(function (window) {
  /*! jQuery v1.7 jquery.com | jquery.org/license */
  (function (a, b) {
    function cA(a) {
      return f.isWindow(a) ? a : a.nodeType === 9 ? a.defaultView || a.parentWindow : !1;
    }
    function cx(a) {
      if (!cm[a]) {
        var b = c.body,
          d = f('<' + a + '>').appendTo(b),
          e = d.css('display');
        d.remove();
        if (e === 'none' || e === '') {
          cn || ((cn = c.createElement('iframe')), (cn.frameBorder = cn.width = cn.height = 0)), b.appendChild(cn);
          if (!co || !cn.createElement)
            (co = (cn.contentWindow || cn.contentDocument).document),
              co.write((c.compatMode === 'CSS1Compat' ? '<!doctype html>' : '') + '<html><body>'),
              co.close();
          (d = co.createElement(a)), co.body.appendChild(d), (e = f.css(d, 'display')), b.removeChild(cn);
        }
        cm[a] = e;
      }
      return cm[a];
    }
    function cw(a, b) {
      var c = {};
      f.each(cs.concat.apply([], cs.slice(0, b)), function () {
        c[this] = a;
      });
      return c;
    }
    function cv() {
      ct = b;
    }
    function cu() {
      setTimeout(cv, 0);
      return (ct = f.now());
    }
    function cl() {
      try {
        return new a.ActiveXObject('Microsoft.XMLHTTP');
      } catch (b) {}
    }
    function ck() {
      try {
        return new a.XMLHttpRequest();
      } catch (b) {}
    }
    function ce(a, c) {
      a.dataFilter && (c = a.dataFilter(c, a.dataType));
      var d = a.dataTypes,
        e = {},
        g,
        h,
        i = d.length,
        j,
        k = d[0],
        l,
        m,
        n,
        o,
        p;
      for (g = 1; g < i; g++) {
        if (g === 1) for (h in a.converters) typeof h == 'string' && (e[h.toLowerCase()] = a.converters[h]);
        (l = k), (k = d[g]);
        if (k === '*') k = l;
        else if (l !== '*' && l !== k) {
          (m = l + ' ' + k), (n = e[m] || e['* ' + k]);
          if (!n) {
            p = b;
            for (o in e) {
              j = o.split(' ');
              if (j[0] === l || j[0] === '*') {
                p = e[j[1] + ' ' + k];
                if (p) {
                  (o = e[o]), o === !0 ? (n = p) : p === !0 && (n = o);
                  break;
                }
              }
            }
          }
          !n && !p && f.error('No conversion from ' + m.replace(' ', ' to ')), n !== !0 && (c = n ? n(c) : p(o(c)));
        }
      }
      return c;
    }
    function cd(a, c, d) {
      var e = a.contents,
        f = a.dataTypes,
        g = a.responseFields,
        h,
        i,
        j,
        k;
      for (i in g) i in d && (c[g[i]] = d[i]);
      while (f[0] === '*') f.shift(), h === b && (h = a.mimeType || c.getResponseHeader('content-type'));
      if (h)
        for (i in e)
          if (e[i] && e[i].test(h)) {
            f.unshift(i);
            break;
          }
      if (f[0] in d) j = f[0];
      else {
        for (i in d) {
          if (!f[0] || a.converters[i + ' ' + f[0]]) {
            j = i;
            break;
          }
          k || (k = i);
        }
        j = j || k;
      }
      if (j) {
        j !== f[0] && f.unshift(j);
        return d[j];
      }
    }
    function cc(a, b, c, d) {
      if (f.isArray(b))
        f.each(b, function (b, e) {
          c || bG.test(a) ? d(a, e) : cc(a + '[' + (typeof e == 'object' || f.isArray(e) ? b : '') + ']', e, c, d);
        });
      else if (!c && b != null && typeof b == 'object') for (var e in b) cc(a + '[' + e + ']', b[e], c, d);
      else d(a, b);
    }
    function cb(a, c) {
      var d,
        e,
        g = f.ajaxSettings.flatOptions || {};
      for (d in c) c[d] !== b && ((g[d] ? a : e || (e = {}))[d] = c[d]);
      e && f.extend(!0, a, e);
    }
    function ca(a, c, d, e, f, g) {
      (f = f || c.dataTypes[0]), (g = g || {}), (g[f] = !0);
      var h = a[f],
        i = 0,
        j = h ? h.length : 0,
        k = a === bV,
        l;
      for (; i < j && (k || !l); i++)
        (l = h[i](c, d, e)),
          typeof l == 'string' && (!k || g[l] ? (l = b) : (c.dataTypes.unshift(l), (l = ca(a, c, d, e, l, g))));
      (k || !l) && !g['*'] && (l = ca(a, c, d, e, '*', g));
      return l;
    }
    function b_(a) {
      return function (b, c) {
        typeof b != 'string' && ((c = b), (b = '*'));
        if (f.isFunction(c)) {
          var d = b.toLowerCase().split(bR),
            e = 0,
            g = d.length,
            h,
            i,
            j;
          for (; e < g; e++)
            (h = d[e]),
              (j = /^\+/.test(h)),
              j && (h = h.substr(1) || '*'),
              (i = a[h] = a[h] || []),
              i[j ? 'unshift' : 'push'](c);
        }
      };
    }
    function bE(a, b, c) {
      var d = b === 'width' ? a.offsetWidth : a.offsetHeight,
        e = b === 'width' ? bz : bA;
      if (d > 0) {
        c !== 'border' &&
          f.each(e, function () {
            c || (d -= parseFloat(f.css(a, 'padding' + this)) || 0),
              c === 'margin'
                ? (d += parseFloat(f.css(a, c + this)) || 0)
                : (d -= parseFloat(f.css(a, 'border' + this + 'Width')) || 0);
          });
        return d + 'px';
      }
      d = bB(a, b, b);
      if (d < 0 || d == null) d = a.style[b] || 0;
      (d = parseFloat(d) || 0),
        c &&
          f.each(e, function () {
            (d += parseFloat(f.css(a, 'padding' + this)) || 0),
              c !== 'padding' && (d += parseFloat(f.css(a, 'border' + this + 'Width')) || 0),
              c === 'margin' && (d += parseFloat(f.css(a, c + this)) || 0);
          });
      return d + 'px';
    }
    function br(a, b) {
      b.src
        ? f.ajax({ url: b.src, async: !1, dataType: 'script' })
        : f.globalEval((b.text || b.textContent || b.innerHTML || '').replace(bi, '/*$0*/')),
        b.parentNode && b.parentNode.removeChild(b);
    }
    function bq(a) {
      var b = (a.nodeName || '').toLowerCase();
      b === 'input'
        ? bp(a)
        : b !== 'script' && typeof a.getElementsByTagName != 'undefined' && f.grep(a.getElementsByTagName('input'), bp);
    }
    function bp(a) {
      if (a.type === 'checkbox' || a.type === 'radio') a.defaultChecked = a.checked;
    }
    function bo(a) {
      return typeof a.getElementsByTagName != 'undefined'
        ? a.getElementsByTagName('*')
        : typeof a.querySelectorAll != 'undefined'
        ? a.querySelectorAll('*')
        : [];
    }
    function bn(a, b) {
      var c;
      if (b.nodeType === 1) {
        b.clearAttributes && b.clearAttributes(),
          b.mergeAttributes && b.mergeAttributes(a),
          (c = b.nodeName.toLowerCase());
        if (c === 'object') b.outerHTML = a.outerHTML;
        else if (c !== 'input' || (a.type !== 'checkbox' && a.type !== 'radio')) {
          if (c === 'option') b.selected = a.defaultSelected;
          else if (c === 'input' || c === 'textarea') b.defaultValue = a.defaultValue;
        } else a.checked && (b.defaultChecked = b.checked = a.checked), b.value !== a.value && (b.value = a.value);
        b.removeAttribute(f.expando);
      }
    }
    function bm(a, b) {
      if (b.nodeType === 1 && !!f.hasData(a)) {
        var c,
          d,
          e,
          g = f._data(a),
          h = f._data(b, g),
          i = g.events;
        if (i) {
          delete h.handle, (h.events = {});
          for (c in i)
            for (d = 0, e = i[c].length; d < e; d++)
              f.event.add(b, c + (i[c][d].namespace ? '.' : '') + i[c][d].namespace, i[c][d], i[c][d].data);
        }
        h.data && (h.data = f.extend({}, h.data));
      }
    }
    function bl(a, b) {
      return f.nodeName(a, 'table')
        ? a.getElementsByTagName('tbody')[0] || a.appendChild(a.ownerDocument.createElement('tbody'))
        : a;
    }
    function X(a) {
      var b = Y.split(' '),
        c = a.createDocumentFragment();
      if (c.createElement) while (b.length) c.createElement(b.pop());
      return c;
    }
    function W(a, b, c) {
      b = b || 0;
      if (f.isFunction(b))
        return f.grep(a, function (a, d) {
          var e = !!b.call(a, d, a);
          return e === c;
        });
      if (b.nodeType)
        return f.grep(a, function (a, d) {
          return (a === b) === c;
        });
      if (typeof b == 'string') {
        var d = f.grep(a, function (a) {
          return a.nodeType === 1;
        });
        if (R.test(b)) return f.filter(b, d, !c);
        b = f.filter(b, d);
      }
      return f.grep(a, function (a, d) {
        return f.inArray(a, b) >= 0 === c;
      });
    }
    function V(a) {
      return !a || !a.parentNode || a.parentNode.nodeType === 11;
    }
    function N() {
      return !0;
    }
    function M() {
      return !1;
    }
    function n(a, b, c) {
      var d = b + 'defer',
        e = b + 'queue',
        g = b + 'mark',
        h = f._data(a, d);
      h &&
        (c === 'queue' || !f._data(a, e)) &&
        (c === 'mark' || !f._data(a, g)) &&
        setTimeout(function () {
          !f._data(a, e) && !f._data(a, g) && (f.removeData(a, d, !0), h.fire());
        }, 0);
    }
    function m(a) {
      for (var b in a) {
        if (b === 'data' && f.isEmptyObject(a[b])) continue;
        if (b !== 'toJSON') return !1;
      }
      return !0;
    }
    function l(a, c, d) {
      if (d === b && a.nodeType === 1) {
        var e = 'data-' + c.replace(k, '-$1').toLowerCase();
        d = a.getAttribute(e);
        if (typeof d == 'string') {
          try {
            d =
              d === 'true'
                ? !0
                : d === 'false'
                ? !1
                : d === 'null'
                ? null
                : f.isNumeric(d)
                ? parseFloat(d)
                : j.test(d)
                ? f.parseJSON(d)
                : d;
          } catch (g) {}
          f.data(a, c, d);
        } else d = b;
      }
      return d;
    }
    function h(a) {
      var b = (g[a] = {}),
        c,
        d;
      a = a.split(/\s+/);
      for (c = 0, d = a.length; c < d; c++) b[a[c]] = !0;
      return b;
    }
    var c = a.document,
      d = a.navigator,
      e = a.location,
      f = (function () {
        function K() {
          if (!e.isReady) {
            try {
              c.documentElement.doScroll('left');
            } catch (a) {
              setTimeout(K, 1);
              return;
            }
            e.ready();
          }
        }
        var e = function (a, b) {
            return new e.fn.init(a, b, h);
          },
          f = a.jQuery,
          g = a.$,
          h,
          i = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,
          j = /\S/,
          k = /^\s+/,
          l = /\s+$/,
          m = /\d/,
          n = /^<(\w+)\s*\/?>(?:<\/\1>)?$/,
          o = /^[\],:{}\s]*$/,
          p = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
          q = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
          r = /(?:^|:|,)(?:\s*\[)+/g,
          s = /(webkit)[ \/]([\w.]+)/,
          t = /(opera)(?:.*version)?[ \/]([\w.]+)/,
          u = /(msie) ([\w.]+)/,
          v = /(mozilla)(?:.*? rv:([\w.]+))?/,
          w = /-([a-z]|[0-9])/gi,
          x = /^-ms-/,
          y = function (a, b) {
            return (b + '').toUpperCase();
          },
          z = d.userAgent,
          A,
          B,
          C,
          D = Object.prototype.toString,
          E = Object.prototype.hasOwnProperty,
          F = Array.prototype.push,
          G = Array.prototype.slice,
          H = String.prototype.trim,
          I = Array.prototype.indexOf,
          J = {};
        (e.fn = e.prototype =
          {
            constructor: e,
            init: function (a, d, f) {
              var g, h, j, k;
              if (!a) return this;
              if (a.nodeType) {
                (this.context = this[0] = a), (this.length = 1);
                return this;
              }
              if (a === 'body' && !d && c.body) {
                (this.context = c), (this[0] = c.body), (this.selector = a), (this.length = 1);
                return this;
              }
              if (typeof a == 'string') {
                a.charAt(0) !== '<' || a.charAt(a.length - 1) !== '>' || a.length < 3
                  ? (g = i.exec(a))
                  : (g = [null, a, null]);
                if (g && (g[1] || !d)) {
                  if (g[1]) {
                    (d = d instanceof e ? d[0] : d),
                      (k = d ? d.ownerDocument || d : c),
                      (j = n.exec(a)),
                      j
                        ? e.isPlainObject(d)
                          ? ((a = [c.createElement(j[1])]), e.fn.attr.call(a, d, !0))
                          : (a = [k.createElement(j[1])])
                        : ((j = e.buildFragment([g[1]], [k])),
                          (a = (j.cacheable ? e.clone(j.fragment) : j.fragment).childNodes));
                    return e.merge(this, a);
                  }
                  h = c.getElementById(g[2]);
                  if (h && h.parentNode) {
                    if (h.id !== g[2]) return f.find(a);
                    (this.length = 1), (this[0] = h);
                  }
                  (this.context = c), (this.selector = a);
                  return this;
                }
                return !d || d.jquery ? (d || f).find(a) : this.constructor(d).find(a);
              }
              if (e.isFunction(a)) return f.ready(a);
              a.selector !== b && ((this.selector = a.selector), (this.context = a.context));
              return e.makeArray(a, this);
            },
            selector: '',
            jquery: '1.7',
            length: 0,
            size: function () {
              return this.length;
            },
            toArray: function () {
              return G.call(this, 0);
            },
            get: function (a) {
              return a == null ? this.toArray() : a < 0 ? this[this.length + a] : this[a];
            },
            pushStack: function (a, b, c) {
              var d = this.constructor();
              e.isArray(a) ? F.apply(d, a) : e.merge(d, a),
                (d.prevObject = this),
                (d.context = this.context),
                b === 'find'
                  ? (d.selector = this.selector + (this.selector ? ' ' : '') + c)
                  : b && (d.selector = this.selector + '.' + b + '(' + c + ')');
              return d;
            },
            each: function (a, b) {
              return e.each(this, a, b);
            },
            ready: function (a) {
              e.bindReady(), B.add(a);
              return this;
            },
            eq: function (a) {
              return a === -1 ? this.slice(a) : this.slice(a, +a + 1);
            },
            first: function () {
              return this.eq(0);
            },
            last: function () {
              return this.eq(-1);
            },
            slice: function () {
              return this.pushStack(G.apply(this, arguments), 'slice', G.call(arguments).join(','));
            },
            map: function (a) {
              return this.pushStack(
                e.map(this, function (b, c) {
                  return a.call(b, c, b);
                }),
              );
            },
            end: function () {
              return this.prevObject || this.constructor(null);
            },
            push: F,
            sort: [].sort,
            splice: [].splice,
          }),
          (e.fn.init.prototype = e.fn),
          (e.extend = e.fn.extend =
            function () {
              var a,
                c,
                d,
                f,
                g,
                h,
                i = arguments[0] || {},
                j = 1,
                k = arguments.length,
                l = !1;
              typeof i == 'boolean' && ((l = i), (i = arguments[1] || {}), (j = 2)),
                typeof i != 'object' && !e.isFunction(i) && (i = {}),
                k === j && ((i = this), --j);
              for (; j < k; j++)
                if ((a = arguments[j]) != null)
                  for (c in a) {
                    (d = i[c]), (f = a[c]);
                    if (i === f) continue;
                    l && f && (e.isPlainObject(f) || (g = e.isArray(f)))
                      ? (g ? ((g = !1), (h = d && e.isArray(d) ? d : [])) : (h = d && e.isPlainObject(d) ? d : {}),
                        (i[c] = e.extend(l, h, f)))
                      : f !== b && (i[c] = f);
                  }
              return i;
            }),
          e.extend({
            noConflict: function (b) {
              a.$ === e && (a.$ = g), b && a.jQuery === e && (a.jQuery = f);
              return e;
            },
            isReady: !1,
            readyWait: 1,
            holdReady: function (a) {
              a ? e.readyWait++ : e.ready(!0);
            },
            ready: function (a) {
              if ((a === !0 && !--e.readyWait) || (a !== !0 && !e.isReady)) {
                if (!c.body) return setTimeout(e.ready, 1);
                e.isReady = !0;
                if (a !== !0 && --e.readyWait > 0) return;
                B.fireWith(c, [e]), e.fn.trigger && e(c).trigger('ready').unbind('ready');
              }
            },
            bindReady: function () {
              if (!B) {
                B = e.Callbacks('once memory');
                if (c.readyState === 'complete') return setTimeout(e.ready, 1);
                if (c.addEventListener)
                  c.addEventListener('DOMContentLoaded', C, !1), a.addEventListener('load', e.ready, !1);
                else if (c.attachEvent) {
                  c.attachEvent('onreadystatechange', C), a.attachEvent('onload', e.ready);
                  var b = !1;
                  try {
                    b = a.frameElement == null;
                  } catch (d) {}
                  c.documentElement.doScroll && b && K();
                }
              }
            },
            isFunction: function (a) {
              return e.type(a) === 'function';
            },
            isArray:
              Array.isArray ||
              function (a) {
                return e.type(a) === 'array';
              },
            isWindow: function (a) {
              return a && typeof a == 'object' && 'setInterval' in a;
            },
            isNumeric: function (a) {
              return a != null && m.test(a) && !isNaN(a);
            },
            type: function (a) {
              return a == null ? String(a) : J[D.call(a)] || 'object';
            },
            isPlainObject: function (a) {
              if (!a || e.type(a) !== 'object' || a.nodeType || e.isWindow(a)) return !1;
              try {
                if (a.constructor && !E.call(a, 'constructor') && !E.call(a.constructor.prototype, 'isPrototypeOf'))
                  return !1;
              } catch (c) {
                return !1;
              }
              var d;
              for (d in a);
              return d === b || E.call(a, d);
            },
            isEmptyObject: function (a) {
              for (var b in a) return !1;
              return !0;
            },
            error: function (a) {
              throw a;
            },
            parseJSON: function (b) {
              if (typeof b != 'string' || !b) return null;
              b = e.trim(b);
              if (a.JSON && a.JSON.parse) return a.JSON.parse(b);
              if (o.test(b.replace(p, '@').replace(q, ']').replace(r, ''))) return new Function('return ' + b)();
              e.error('Invalid JSON: ' + b);
            },
            parseXML: function (c) {
              var d, f;
              try {
                a.DOMParser
                  ? ((f = new DOMParser()), (d = f.parseFromString(c, 'text/xml')))
                  : ((d = new ActiveXObject('Microsoft.XMLDOM')), (d.async = 'false'), d.loadXML(c));
              } catch (g) {
                d = b;
              }
              (!d || !d.documentElement || d.getElementsByTagName('parsererror').length) &&
                e.error('Invalid XML: ' + c);
              return d;
            },
            noop: function () {},
            globalEval: function (b) {
              b &&
                j.test(b) &&
                (
                  a.execScript ||
                  function (b) {
                    a.eval.call(a, b);
                  }
                )(b);
            },
            camelCase: function (a) {
              return a.replace(x, 'ms-').replace(w, y);
            },
            nodeName: function (a, b) {
              return a.nodeName && a.nodeName.toUpperCase() === b.toUpperCase();
            },
            each: function (a, c, d) {
              var f,
                g = 0,
                h = a.length,
                i = h === b || e.isFunction(a);
              if (d) {
                if (i) {
                  for (f in a) if (c.apply(a[f], d) === !1) break;
                } else for (; g < h; ) if (c.apply(a[g++], d) === !1) break;
              } else if (i) {
                for (f in a) if (c.call(a[f], f, a[f]) === !1) break;
              } else for (; g < h; ) if (c.call(a[g], g, a[g++]) === !1) break;
              return a;
            },
            trim: H
              ? function (a) {
                  return a == null ? '' : H.call(a);
                }
              : function (a) {
                  return a == null ? '' : (a + '').replace(k, '').replace(l, '');
                },
            makeArray: function (a, b) {
              var c = b || [];
              if (a != null) {
                var d = e.type(a);
                a.length == null || d === 'string' || d === 'function' || d === 'regexp' || e.isWindow(a)
                  ? F.call(c, a)
                  : e.merge(c, a);
              }
              return c;
            },
            inArray: function (a, b, c) {
              var d;
              if (b) {
                if (I) return I.call(b, a, c);
                (d = b.length), (c = c ? (c < 0 ? Math.max(0, d + c) : c) : 0);
                for (; c < d; c++) if (c in b && b[c] === a) return c;
              }
              return -1;
            },
            merge: function (a, c) {
              var d = a.length,
                e = 0;
              if (typeof c.length == 'number') for (var f = c.length; e < f; e++) a[d++] = c[e];
              else while (c[e] !== b) a[d++] = c[e++];
              a.length = d;
              return a;
            },
            grep: function (a, b, c) {
              var d = [],
                e;
              c = !!c;
              for (var f = 0, g = a.length; f < g; f++) (e = !!b(a[f], f)), c !== e && d.push(a[f]);
              return d;
            },
            map: function (a, c, d) {
              var f,
                g,
                h = [],
                i = 0,
                j = a.length,
                k =
                  a instanceof e ||
                  (j !== b && typeof j == 'number' && ((j > 0 && a[0] && a[j - 1]) || j === 0 || e.isArray(a)));
              if (k) for (; i < j; i++) (f = c(a[i], i, d)), f != null && (h[h.length] = f);
              else for (g in a) (f = c(a[g], g, d)), f != null && (h[h.length] = f);
              return h.concat.apply([], h);
            },
            guid: 1,
            proxy: function (a, c) {
              if (typeof c == 'string') {
                var d = a[c];
                (c = a), (a = d);
              }
              if (!e.isFunction(a)) return b;
              var f = G.call(arguments, 2),
                g = function () {
                  return a.apply(c, f.concat(G.call(arguments)));
                };
              g.guid = a.guid = a.guid || g.guid || e.guid++;
              return g;
            },
            access: function (a, c, d, f, g, h) {
              var i = a.length;
              if (typeof c == 'object') {
                for (var j in c) e.access(a, j, c[j], f, g, d);
                return a;
              }
              if (d !== b) {
                f = !h && f && e.isFunction(d);
                for (var k = 0; k < i; k++) g(a[k], c, f ? d.call(a[k], k, g(a[k], c)) : d, h);
                return a;
              }
              return i ? g(a[0], c) : b;
            },
            now: function () {
              return new Date().getTime();
            },
            uaMatch: function (a) {
              a = a.toLowerCase();
              var b = s.exec(a) || t.exec(a) || u.exec(a) || (a.indexOf('compatible') < 0 && v.exec(a)) || [];
              return { browser: b[1] || '', version: b[2] || '0' };
            },
            sub: function () {
              function a(b, c) {
                return new a.fn.init(b, c);
              }
              e.extend(!0, a, this),
                (a.superclass = this),
                (a.fn = a.prototype = this()),
                (a.fn.constructor = a),
                (a.sub = this.sub),
                (a.fn.init = function (d, f) {
                  f && f instanceof e && !(f instanceof a) && (f = a(f));
                  return e.fn.init.call(this, d, f, b);
                }),
                (a.fn.init.prototype = a.fn);
              var b = a(c);
              return a;
            },
            browser: {},
          }),
          e.each('Boolean Number String Function Array Date RegExp Object'.split(' '), function (a, b) {
            J['[object ' + b + ']'] = b.toLowerCase();
          }),
          (A = e.uaMatch(z)),
          A.browser && ((e.browser[A.browser] = !0), (e.browser.version = A.version)),
          e.browser.webkit && (e.browser.safari = !0),
          j.test(' ') && ((k = /^[\s\xA0]+/), (l = /[\s\xA0]+$/)),
          (h = e(c)),
          c.addEventListener
            ? (C = function () {
                c.removeEventListener('DOMContentLoaded', C, !1), e.ready();
              })
            : c.attachEvent &&
              (C = function () {
                c.readyState === 'complete' && (c.detachEvent('onreadystatechange', C), e.ready());
              }),
          typeof define == 'function' &&
            define.amd &&
            define.amd.jQuery &&
            define('jquery', [], function () {
              return e;
            });
        return e;
      })(),
      g = {};
    f.Callbacks = function (a) {
      a = a ? g[a] || h(a) : {};
      var c = [],
        d = [],
        e,
        i,
        j,
        k,
        l,
        m = function (b) {
          var d, e, g, h, i;
          for (d = 0, e = b.length; d < e; d++)
            (g = b[d]),
              (h = f.type(g)),
              h === 'array' ? m(g) : h === 'function' && (!a.unique || !o.has(g)) && c.push(g);
        },
        n = function (b, f) {
          (f = f || []), (e = !a.memory || [b, f]), (i = !0), (l = j || 0), (j = 0), (k = c.length);
          for (; c && l < k; l++)
            if (c[l].apply(b, f) === !1 && a.stopOnFalse) {
              e = !0;
              break;
            }
          (i = !1),
            c &&
              (a.once
                ? e === !0
                  ? o.disable()
                  : (c = [])
                : d && d.length && ((e = d.shift()), o.fireWith(e[0], e[1])));
        },
        o = {
          add: function () {
            if (c) {
              var a = c.length;
              m(arguments), i ? (k = c.length) : e && e !== !0 && ((j = a), n(e[0], e[1]));
            }
            return this;
          },
          remove: function () {
            if (c) {
              var b = arguments,
                d = 0,
                e = b.length;
              for (; d < e; d++)
                for (var f = 0; f < c.length; f++)
                  if (b[d] === c[f]) {
                    i && f <= k && (k--, f <= l && l--), c.splice(f--, 1);
                    if (a.unique) break;
                  }
            }
            return this;
          },
          has: function (a) {
            if (c) {
              var b = 0,
                d = c.length;
              for (; b < d; b++) if (a === c[b]) return !0;
            }
            return !1;
          },
          empty: function () {
            c = [];
            return this;
          },
          disable: function () {
            c = d = e = b;
            return this;
          },
          disabled: function () {
            return !c;
          },
          lock: function () {
            (d = b), (!e || e === !0) && o.disable();
            return this;
          },
          locked: function () {
            return !d;
          },
          fireWith: function (b, c) {
            d && (i ? a.once || d.push([b, c]) : (!a.once || !e) && n(b, c));
            return this;
          },
          fire: function () {
            o.fireWith(this, arguments);
            return this;
          },
          fired: function () {
            return !!e;
          },
        };
      return o;
    };
    var i = [].slice;
    f.extend({
      Deferred: function (a) {
        var b = f.Callbacks('once memory'),
          c = f.Callbacks('once memory'),
          d = f.Callbacks('memory'),
          e = 'pending',
          g = { resolve: b, reject: c, notify: d },
          h = {
            done: b.add,
            fail: c.add,
            progress: d.add,
            state: function () {
              return e;
            },
            isResolved: b.fired,
            isRejected: c.fired,
            then: function (a, b, c) {
              i.done(a).fail(b).progress(c);
              return this;
            },
            always: function () {
              return i.done.apply(i, arguments).fail.apply(i, arguments);
            },
            pipe: function (a, b, c) {
              return f
                .Deferred(function (d) {
                  f.each({ done: [a, 'resolve'], fail: [b, 'reject'], progress: [c, 'notify'] }, function (a, b) {
                    var c = b[0],
                      e = b[1],
                      g;
                    f.isFunction(c)
                      ? i[a](function () {
                          (g = c.apply(this, arguments)),
                            g && f.isFunction(g.promise)
                              ? g.promise().then(d.resolve, d.reject, d.notify)
                              : d[e + 'With'](this === i ? d : this, [g]);
                        })
                      : i[a](d[e]);
                  });
                })
                .promise();
            },
            promise: function (a) {
              if (a == null) a = h;
              else for (var b in h) a[b] = h[b];
              return a;
            },
          },
          i = h.promise({}),
          j;
        for (j in g) (i[j] = g[j].fire), (i[j + 'With'] = g[j].fireWith);
        i
          .done(
            function () {
              e = 'resolved';
            },
            c.disable,
            d.lock,
          )
          .fail(
            function () {
              e = 'rejected';
            },
            b.disable,
            d.lock,
          ),
          a && a.call(i, i);
        return i;
      },
      when: function (a) {
        function m(a) {
          return function (b) {
            (e[a] = arguments.length > 1 ? i.call(arguments, 0) : b), j.notifyWith(k, e);
          };
        }
        function l(a) {
          return function (c) {
            (b[a] = arguments.length > 1 ? i.call(arguments, 0) : c), --g || j.resolveWith(j, b);
          };
        }
        var b = i.call(arguments, 0),
          c = 0,
          d = b.length,
          e = Array(d),
          g = d,
          h = d,
          j = d <= 1 && a && f.isFunction(a.promise) ? a : f.Deferred(),
          k = j.promise();
        if (d > 1) {
          for (; c < d; c++)
            b[c] && b[c].promise && f.isFunction(b[c].promise) ? b[c].promise().then(l(c), j.reject, m(c)) : --g;
          g || j.resolveWith(j, b);
        } else j !== a && j.resolveWith(j, d ? [a] : []);
        return k;
      },
    }),
      (f.support = (function () {
        var a = c.createElement('div'),
          b = c.documentElement,
          d,
          e,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u;
        a.setAttribute('className', 't'),
          (a.innerHTML =
            "   <link/><table></table><a href='/a' style='top:1px;float:left;opacity:.55;'>a</a><input type='checkbox'/><nav></nav>"),
          (d = a.getElementsByTagName('*')),
          (e = a.getElementsByTagName('a')[0]);
        if (!d || !d.length || !e) return {};
        (g = c.createElement('select')),
          (h = g.appendChild(c.createElement('option'))),
          (i = a.getElementsByTagName('input')[0]),
          (k = {
            leadingWhitespace: a.firstChild.nodeType === 3,
            tbody: !a.getElementsByTagName('tbody').length,
            htmlSerialize: !!a.getElementsByTagName('link').length,
            style: /top/.test(e.getAttribute('style')),
            hrefNormalized: e.getAttribute('href') === '/a',
            opacity: /^0.55/.test(e.style.opacity),
            cssFloat: !!e.style.cssFloat,
            unknownElems: !!a.getElementsByTagName('nav').length,
            checkOn: i.value === 'on',
            optSelected: h.selected,
            getSetAttribute: a.className !== 't',
            enctype: !!c.createElement('form').enctype,
            submitBubbles: !0,
            changeBubbles: !0,
            focusinBubbles: !1,
            deleteExpando: !0,
            noCloneEvent: !0,
            inlineBlockNeedsLayout: !1,
            shrinkWrapBlocks: !1,
            reliableMarginRight: !0,
          }),
          (i.checked = !0),
          (k.noCloneChecked = i.cloneNode(!0).checked),
          (g.disabled = !0),
          (k.optDisabled = !h.disabled);
        try {
          delete a.test;
        } catch (v) {
          k.deleteExpando = !1;
        }
        !a.addEventListener &&
          a.attachEvent &&
          a.fireEvent &&
          (a.attachEvent('onclick', function () {
            k.noCloneEvent = !1;
          }),
          a.cloneNode(!0).fireEvent('onclick')),
          (i = c.createElement('input')),
          (i.value = 't'),
          i.setAttribute('type', 'radio'),
          (k.radioValue = i.value === 't'),
          i.setAttribute('checked', 'checked'),
          a.appendChild(i),
          (l = c.createDocumentFragment()),
          l.appendChild(a.lastChild),
          (k.checkClone = l.cloneNode(!0).cloneNode(!0).lastChild.checked),
          (a.innerHTML = ''),
          (a.style.width = a.style.paddingLeft = '1px'),
          (m = c.getElementsByTagName('body')[0]),
          (o = c.createElement(m ? 'div' : 'body')),
          (p = { visibility: 'hidden', width: 0, height: 0, border: 0, margin: 0, background: 'none' }),
          m && f.extend(p, { position: 'absolute', left: '-999px', top: '-999px' });
        for (t in p) o.style[t] = p[t];
        o.appendChild(a),
          (n = m || b),
          n.insertBefore(o, n.firstChild),
          (k.appendChecked = i.checked),
          (k.boxModel = a.offsetWidth === 2),
          'zoom' in a.style &&
            ((a.style.display = 'inline'),
            (a.style.zoom = 1),
            (k.inlineBlockNeedsLayout = a.offsetWidth === 2),
            (a.style.display = ''),
            (a.innerHTML = "<div style='width:4px;'></div>"),
            (k.shrinkWrapBlocks = a.offsetWidth !== 2)),
          (a.innerHTML = "<table><tr><td style='padding:0;border:0;display:none'></td><td>t</td></tr></table>"),
          (q = a.getElementsByTagName('td')),
          (u = q[0].offsetHeight === 0),
          (q[0].style.display = ''),
          (q[1].style.display = 'none'),
          (k.reliableHiddenOffsets = u && q[0].offsetHeight === 0),
          (a.innerHTML = ''),
          c.defaultView &&
            c.defaultView.getComputedStyle &&
            ((j = c.createElement('div')),
            (j.style.width = '0'),
            (j.style.marginRight = '0'),
            a.appendChild(j),
            (k.reliableMarginRight =
              (parseInt((c.defaultView.getComputedStyle(j, null) || { marginRight: 0 }).marginRight, 10) || 0) === 0));
        if (a.attachEvent)
          for (t in { submit: 1, change: 1, focusin: 1 })
            (s = 'on' + t),
              (u = s in a),
              u || (a.setAttribute(s, 'return;'), (u = typeof a[s] == 'function')),
              (k[t + 'Bubbles'] = u);
        f(function () {
          var a,
            b,
            d,
            e,
            g,
            h,
            i = 1,
            j = 'position:absolute;top:0;left:0;width:1px;height:1px;margin:0;',
            l = 'visibility:hidden;border:0;',
            n = "style='" + j + "border:5px solid #000;padding:0;'",
            p =
              '<div ' +
              n +
              '><div></div></div>' +
              '<table ' +
              n +
              " cellpadding='0' cellspacing='0'>" +
              '<tr><td></td></tr></table>';
          m = c.getElementsByTagName('body')[0];
          !m ||
            ((a = c.createElement('div')),
            (a.style.cssText = l + 'width:0;height:0;position:static;top:0;margin-top:' + i + 'px'),
            m.insertBefore(a, m.firstChild),
            (o = c.createElement('div')),
            (o.style.cssText = j + l),
            (o.innerHTML = p),
            a.appendChild(o),
            (b = o.firstChild),
            (d = b.firstChild),
            (g = b.nextSibling.firstChild.firstChild),
            (h = { doesNotAddBorder: d.offsetTop !== 5, doesAddBorderForTableAndCells: g.offsetTop === 5 }),
            (d.style.position = 'fixed'),
            (d.style.top = '20px'),
            (h.fixedPosition = d.offsetTop === 20 || d.offsetTop === 15),
            (d.style.position = d.style.top = ''),
            (b.style.overflow = 'hidden'),
            (b.style.position = 'relative'),
            (h.subtractsBorderForOverflowNotVisible = d.offsetTop === -5),
            (h.doesNotIncludeMarginInBodyOffset = m.offsetTop !== i),
            m.removeChild(a),
            (o = a = null),
            f.extend(k, h));
        }),
          (o.innerHTML = ''),
          n.removeChild(o),
          (o = l = g = h = m = j = a = i = null);
        return k;
      })()),
      (f.boxModel = f.support.boxModel);
    var j = /^(?:\{.*\}|\[.*\])$/,
      k = /([A-Z])/g;
    f.extend({
      cache: {},
      uuid: 0,
      expando: 'jQuery' + (f.fn.jquery + Math.random()).replace(/\D/g, ''),
      noData: { embed: !0, object: 'clsid:D27CDB6E-AE6D-11cf-96B8-444553540000', applet: !0 },
      hasData: function (a) {
        a = a.nodeType ? f.cache[a[f.expando]] : a[f.expando];
        return !!a && !m(a);
      },
      data: function (a, c, d, e) {
        if (!!f.acceptData(a)) {
          var g,
            h,
            i,
            j = f.expando,
            k = typeof c == 'string',
            l = a.nodeType,
            m = l ? f.cache : a,
            n = l ? a[f.expando] : a[f.expando] && f.expando,
            o = c === 'events';
          if ((!n || !m[n] || (!o && !e && !m[n].data)) && k && d === b) return;
          n || (l ? (a[f.expando] = n = ++f.uuid) : (n = f.expando)),
            m[n] || ((m[n] = {}), l || (m[n].toJSON = f.noop));
          if (typeof c == 'object' || typeof c == 'function')
            e ? (m[n] = f.extend(m[n], c)) : (m[n].data = f.extend(m[n].data, c));
          (g = h = m[n]), e || (h.data || (h.data = {}), (h = h.data)), d !== b && (h[f.camelCase(c)] = d);
          if (o && !h[c]) return g.events;
          k ? ((i = h[c]), i == null && (i = h[f.camelCase(c)])) : (i = h);
          return i;
        }
      },
      removeData: function (a, b, c) {
        if (!!f.acceptData(a)) {
          var d,
            e,
            g,
            h = f.expando,
            i = a.nodeType,
            j = i ? f.cache : a,
            k = i ? a[f.expando] : f.expando;
          if (!j[k]) return;
          if (b) {
            d = c ? j[k] : j[k].data;
            if (d) {
              f.isArray(b)
                ? (b = b)
                : b in d
                ? (b = [b])
                : ((b = f.camelCase(b)), b in d ? (b = [b]) : (b = b.split(' ')));
              for (e = 0, g = b.length; e < g; e++) delete d[b[e]];
              if (!(c ? m : f.isEmptyObject)(d)) return;
            }
          }
          if (!c) {
            delete j[k].data;
            if (!m(j[k])) return;
          }
          f.support.deleteExpando || !j.setInterval ? delete j[k] : (j[k] = null),
            i &&
              (f.support.deleteExpando
                ? delete a[f.expando]
                : a.removeAttribute
                ? a.removeAttribute(f.expando)
                : (a[f.expando] = null));
        }
      },
      _data: function (a, b, c) {
        return f.data(a, b, c, !0);
      },
      acceptData: function (a) {
        if (a.nodeName) {
          var b = f.noData[a.nodeName.toLowerCase()];
          if (b) return b !== !0 && a.getAttribute('classid') === b;
        }
        return !0;
      },
    }),
      f.fn.extend({
        data: function (a, c) {
          var d,
            e,
            g,
            h = null;
          if (typeof a == 'undefined') {
            if (this.length) {
              h = f.data(this[0]);
              if (this[0].nodeType === 1 && !f._data(this[0], 'parsedAttrs')) {
                e = this[0].attributes;
                for (var i = 0, j = e.length; i < j; i++)
                  (g = e[i].name), g.indexOf('data-') === 0 && ((g = f.camelCase(g.substring(5))), l(this[0], g, h[g]));
                f._data(this[0], 'parsedAttrs', !0);
              }
            }
            return h;
          }
          if (typeof a == 'object')
            return this.each(function () {
              f.data(this, a);
            });
          (d = a.split('.')), (d[1] = d[1] ? '.' + d[1] : '');
          if (c === b) {
            (h = this.triggerHandler('getData' + d[1] + '!', [d[0]])),
              h === b && this.length && ((h = f.data(this[0], a)), (h = l(this[0], a, h)));
            return h === b && d[1] ? this.data(d[0]) : h;
          }
          return this.each(function () {
            var b = f(this),
              e = [d[0], c];
            b.triggerHandler('setData' + d[1] + '!', e),
              f.data(this, a, c),
              b.triggerHandler('changeData' + d[1] + '!', e);
          });
        },
        removeData: function (a) {
          return this.each(function () {
            f.removeData(this, a);
          });
        },
      }),
      f.extend({
        _mark: function (a, b) {
          a && ((b = (b || 'fx') + 'mark'), f._data(a, b, (f._data(a, b) || 0) + 1));
        },
        _unmark: function (a, b, c) {
          a !== !0 && ((c = b), (b = a), (a = !1));
          if (b) {
            c = c || 'fx';
            var d = c + 'mark',
              e = a ? 0 : (f._data(b, d) || 1) - 1;
            e ? f._data(b, d, e) : (f.removeData(b, d, !0), n(b, c, 'mark'));
          }
        },
        queue: function (a, b, c) {
          var d;
          if (a) {
            (b = (b || 'fx') + 'queue'),
              (d = f._data(a, b)),
              c && (!d || f.isArray(c) ? (d = f._data(a, b, f.makeArray(c))) : d.push(c));
            return d || [];
          }
        },
        dequeue: function (a, b) {
          b = b || 'fx';
          var c = f.queue(a, b),
            d = c.shift(),
            e = {};
          d === 'inprogress' && (d = c.shift()),
            d &&
              (b === 'fx' && c.unshift('inprogress'),
              f._data(a, b + '.run', e),
              d.call(
                a,
                function () {
                  f.dequeue(a, b);
                },
                e,
              )),
            c.length || (f.removeData(a, b + 'queue ' + b + '.run', !0), n(a, b, 'queue'));
        },
      }),
      f.fn.extend({
        queue: function (a, c) {
          typeof a != 'string' && ((c = a), (a = 'fx'));
          if (c === b) return f.queue(this[0], a);
          return this.each(function () {
            var b = f.queue(this, a, c);
            a === 'fx' && b[0] !== 'inprogress' && f.dequeue(this, a);
          });
        },
        dequeue: function (a) {
          return this.each(function () {
            f.dequeue(this, a);
          });
        },
        delay: function (a, b) {
          (a = f.fx ? f.fx.speeds[a] || a : a), (b = b || 'fx');
          return this.queue(b, function (b, c) {
            var d = setTimeout(b, a);
            c.stop = function () {
              clearTimeout(d);
            };
          });
        },
        clearQueue: function (a) {
          return this.queue(a || 'fx', []);
        },
        promise: function (a, c) {
          function m() {
            --h || d.resolveWith(e, [e]);
          }
          typeof a != 'string' && ((c = a), (a = b)), (a = a || 'fx');
          var d = f.Deferred(),
            e = this,
            g = e.length,
            h = 1,
            i = a + 'defer',
            j = a + 'queue',
            k = a + 'mark',
            l;
          while (g--)
            if (
              (l =
                f.data(e[g], i, b, !0) ||
                ((f.data(e[g], j, b, !0) || f.data(e[g], k, b, !0)) && f.data(e[g], i, f.Callbacks('once memory'), !0)))
            )
              h++, l.add(m);
          m();
          return d.promise();
        },
      });
    var o = /[\n\t\r]/g,
      p = /\s+/,
      q = /\r/g,
      r = /^(?:button|input)$/i,
      s = /^(?:button|input|object|select|textarea)$/i,
      t = /^a(?:rea)?$/i,
      u =
        /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
      v = f.support.getSetAttribute,
      w,
      x,
      y;
    f.fn.extend({
      attr: function (a, b) {
        return f.access(this, a, b, !0, f.attr);
      },
      removeAttr: function (a) {
        return this.each(function () {
          f.removeAttr(this, a);
        });
      },
      prop: function (a, b) {
        return f.access(this, a, b, !0, f.prop);
      },
      removeProp: function (a) {
        a = f.propFix[a] || a;
        return this.each(function () {
          try {
            (this[a] = b), delete this[a];
          } catch (c) {}
        });
      },
      addClass: function (a) {
        var b, c, d, e, g, h, i;
        if (f.isFunction(a))
          return this.each(function (b) {
            f(this).addClass(a.call(this, b, this.className));
          });
        if (a && typeof a == 'string') {
          b = a.split(p);
          for (c = 0, d = this.length; c < d; c++) {
            e = this[c];
            if (e.nodeType === 1)
              if (!e.className && b.length === 1) e.className = a;
              else {
                g = ' ' + e.className + ' ';
                for (h = 0, i = b.length; h < i; h++) ~g.indexOf(' ' + b[h] + ' ') || (g += b[h] + ' ');
                e.className = f.trim(g);
              }
          }
        }
        return this;
      },
      removeClass: function (a) {
        var c, d, e, g, h, i, j;
        if (f.isFunction(a))
          return this.each(function (b) {
            f(this).removeClass(a.call(this, b, this.className));
          });
        if ((a && typeof a == 'string') || a === b) {
          c = (a || '').split(p);
          for (d = 0, e = this.length; d < e; d++) {
            g = this[d];
            if (g.nodeType === 1 && g.className)
              if (a) {
                h = (' ' + g.className + ' ').replace(o, ' ');
                for (i = 0, j = c.length; i < j; i++) h = h.replace(' ' + c[i] + ' ', ' ');
                g.className = f.trim(h);
              } else g.className = '';
          }
        }
        return this;
      },
      toggleClass: function (a, b) {
        var c = typeof a,
          d = typeof b == 'boolean';
        if (f.isFunction(a))
          return this.each(function (c) {
            f(this).toggleClass(a.call(this, c, this.className, b), b);
          });
        return this.each(function () {
          if (c === 'string') {
            var e,
              g = 0,
              h = f(this),
              i = b,
              j = a.split(p);
            while ((e = j[g++])) (i = d ? i : !h.hasClass(e)), h[i ? 'addClass' : 'removeClass'](e);
          } else if (c === 'undefined' || c === 'boolean') this.className && f._data(this, '__className__', this.className), (this.className = this.className || a === !1 ? '' : f._data(this, '__className__') || '');
        });
      },
      hasClass: function (a) {
        var b = ' ' + a + ' ',
          c = 0,
          d = this.length;
        for (; c < d; c++)
          if (this[c].nodeType === 1 && (' ' + this[c].className + ' ').replace(o, ' ').indexOf(b) > -1) return !0;
        return !1;
      },
      val: function (a) {
        var c,
          d,
          e,
          g = this[0];
        if (!arguments.length) {
          if (g) {
            c = f.valHooks[g.nodeName.toLowerCase()] || f.valHooks[g.type];
            if (c && 'get' in c && (d = c.get(g, 'value')) !== b) return d;
            d = g.value;
            return typeof d == 'string' ? d.replace(q, '') : d == null ? '' : d;
          }
          return b;
        }
        e = f.isFunction(a);
        return this.each(function (d) {
          var g = f(this),
            h;
          if (this.nodeType === 1) {
            e ? (h = a.call(this, d, g.val())) : (h = a),
              h == null
                ? (h = '')
                : typeof h == 'number'
                ? (h += '')
                : f.isArray(h) &&
                  (h = f.map(h, function (a) {
                    return a == null ? '' : a + '';
                  })),
              (c = f.valHooks[this.nodeName.toLowerCase()] || f.valHooks[this.type]);
            if (!c || !('set' in c) || c.set(this, h, 'value') === b) this.value = h;
          }
        });
      },
    }),
      f.extend({
        valHooks: {
          option: {
            get: function (a) {
              var b = a.attributes.value;
              return !b || b.specified ? a.value : a.text;
            },
          },
          select: {
            get: function (a) {
              var b,
                c,
                d,
                e,
                g = a.selectedIndex,
                h = [],
                i = a.options,
                j = a.type === 'select-one';
              if (g < 0) return null;
              (c = j ? g : 0), (d = j ? g + 1 : i.length);
              for (; c < d; c++) {
                e = i[c];
                if (
                  e.selected &&
                  (f.support.optDisabled ? !e.disabled : e.getAttribute('disabled') === null) &&
                  (!e.parentNode.disabled || !f.nodeName(e.parentNode, 'optgroup'))
                ) {
                  b = f(e).val();
                  if (j) return b;
                  h.push(b);
                }
              }
              if (j && !h.length && i.length) return f(i[g]).val();
              return h;
            },
            set: function (a, b) {
              var c = f.makeArray(b);
              f(a)
                .find('option')
                .each(function () {
                  this.selected = f.inArray(f(this).val(), c) >= 0;
                }),
                c.length || (a.selectedIndex = -1);
              return c;
            },
          },
        },
        attrFn: { val: !0, css: !0, html: !0, text: !0, data: !0, width: !0, height: !0, offset: !0 },
        attr: function (a, c, d, e) {
          var g,
            h,
            i,
            j = a.nodeType;
          if (!a || j === 3 || j === 8 || j === 2) return b;
          if (e && c in f.attrFn) return f(a)[c](d);
          if (!('getAttribute' in a)) return f.prop(a, c, d);
          (i = j !== 1 || !f.isXMLDoc(a)), i && ((c = c.toLowerCase()), (h = f.attrHooks[c] || (u.test(c) ? x : w)));
          if (d !== b) {
            if (d === null) {
              f.removeAttr(a, c);
              return b;
            }
            if (h && 'set' in h && i && (g = h.set(a, d, c)) !== b) return g;
            a.setAttribute(c, '' + d);
            return d;
          }
          if (h && 'get' in h && i && (g = h.get(a, c)) !== null) return g;
          g = a.getAttribute(c);
          return g === null ? b : g;
        },
        removeAttr: function (a, b) {
          var c,
            d,
            e,
            g,
            h = 0;
          if (a.nodeType === 1) {
            (d = (b || '').split(p)), (g = d.length);
            for (; h < g; h++)
              (e = d[h].toLowerCase()),
                (c = f.propFix[e] || e),
                f.attr(a, e, ''),
                a.removeAttribute(v ? e : c),
                u.test(e) && c in a && (a[c] = !1);
          }
        },
        attrHooks: {
          type: {
            set: function (a, b) {
              if (r.test(a.nodeName) && a.parentNode) f.error("type property can't be changed");
              else if (!f.support.radioValue && b === 'radio' && f.nodeName(a, 'input')) {
                var c = a.value;
                a.setAttribute('type', b), c && (a.value = c);
                return b;
              }
            },
          },
          value: {
            get: function (a, b) {
              if (w && f.nodeName(a, 'button')) return w.get(a, b);
              return b in a ? a.value : null;
            },
            set: function (a, b, c) {
              if (w && f.nodeName(a, 'button')) return w.set(a, b, c);
              a.value = b;
            },
          },
        },
        propFix: {
          tabindex: 'tabIndex',
          readonly: 'readOnly',
          for: 'htmlFor',
          class: 'className',
          maxlength: 'maxLength',
          cellspacing: 'cellSpacing',
          cellpadding: 'cellPadding',
          rowspan: 'rowSpan',
          colspan: 'colSpan',
          usemap: 'useMap',
          frameborder: 'frameBorder',
          contenteditable: 'contentEditable',
        },
        prop: function (a, c, d) {
          var e,
            g,
            h,
            i = a.nodeType;
          if (!a || i === 3 || i === 8 || i === 2) return b;
          (h = i !== 1 || !f.isXMLDoc(a)), h && ((c = f.propFix[c] || c), (g = f.propHooks[c]));
          return d !== b
            ? g && 'set' in g && (e = g.set(a, d, c)) !== b
              ? e
              : (a[c] = d)
            : g && 'get' in g && (e = g.get(a, c)) !== null
            ? e
            : a[c];
        },
        propHooks: {
          tabIndex: {
            get: function (a) {
              var c = a.getAttributeNode('tabindex');
              return c && c.specified
                ? parseInt(c.value, 10)
                : s.test(a.nodeName) || (t.test(a.nodeName) && a.href)
                ? 0
                : b;
            },
          },
        },
      }),
      (f.attrHooks.tabindex = f.propHooks.tabIndex),
      (x = {
        get: function (a, c) {
          var d,
            e = f.prop(a, c);
          return e === !0 || (typeof e != 'boolean' && (d = a.getAttributeNode(c)) && d.nodeValue !== !1)
            ? c.toLowerCase()
            : b;
        },
        set: function (a, b, c) {
          var d;
          b === !1
            ? f.removeAttr(a, c)
            : ((d = f.propFix[c] || c), d in a && (a[d] = !0), a.setAttribute(c, c.toLowerCase()));
          return c;
        },
      }),
      v ||
        ((y = { name: !0, id: !0 }),
        (w = f.valHooks.button =
          {
            get: function (a, c) {
              var d;
              d = a.getAttributeNode(c);
              return d && (y[c] ? d.nodeValue !== '' : d.specified) ? d.nodeValue : b;
            },
            set: function (a, b, d) {
              var e = a.getAttributeNode(d);
              e || ((e = c.createAttribute(d)), a.setAttributeNode(e));
              return (e.nodeValue = b + '');
            },
          }),
        (f.attrHooks.tabindex.set = w.set),
        f.each(['width', 'height'], function (a, b) {
          f.attrHooks[b] = f.extend(f.attrHooks[b], {
            set: function (a, c) {
              if (c === '') {
                a.setAttribute(b, 'auto');
                return c;
              }
            },
          });
        }),
        (f.attrHooks.contenteditable = {
          get: w.get,
          set: function (a, b, c) {
            b === '' && (b = 'false'), w.set(a, b, c);
          },
        })),
      f.support.hrefNormalized ||
        f.each(['href', 'src', 'width', 'height'], function (a, c) {
          f.attrHooks[c] = f.extend(f.attrHooks[c], {
            get: function (a) {
              var d = a.getAttribute(c, 2);
              return d === null ? b : d;
            },
          });
        }),
      f.support.style ||
        (f.attrHooks.style = {
          get: function (a) {
            return a.style.cssText.toLowerCase() || b;
          },
          set: function (a, b) {
            return (a.style.cssText = '' + b);
          },
        }),
      f.support.optSelected ||
        (f.propHooks.selected = f.extend(f.propHooks.selected, {
          get: function (a) {
            var b = a.parentNode;
            b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
            return null;
          },
        })),
      f.support.enctype || (f.propFix.enctype = 'encoding'),
      f.support.checkOn ||
        f.each(['radio', 'checkbox'], function () {
          f.valHooks[this] = {
            get: function (a) {
              return a.getAttribute('value') === null ? 'on' : a.value;
            },
          };
        }),
      f.each(['radio', 'checkbox'], function () {
        f.valHooks[this] = f.extend(f.valHooks[this], {
          set: function (a, b) {
            if (f.isArray(b)) return (a.checked = f.inArray(f(a).val(), b) >= 0);
          },
        });
      });
    var z = /\.(.*)$/,
      A = /^(?:textarea|input|select)$/i,
      B = /\./g,
      C = / /g,
      D = /[^\w\s.|`]/g,
      E = /^([^\.]*)?(?:\.(.+))?$/,
      F = /\bhover(\.\S+)?/,
      G = /^key/,
      H = /^(?:mouse|contextmenu)|click/,
      I = /^(\w*)(?:#([\w\-]+))?(?:\.([\w\-]+))?$/,
      J = function (a) {
        var b = I.exec(a);
        b && ((b[1] = (b[1] || '').toLowerCase()), (b[3] = b[3] && new RegExp('(?:^|\\s)' + b[3] + '(?:\\s|$)')));
        return b;
      },
      K = function (a, b) {
        return (
          (!b[1] || a.nodeName.toLowerCase() === b[1]) && (!b[2] || a.id === b[2]) && (!b[3] || b[3].test(a.className))
        );
      },
      L = function (a) {
        return f.event.special.hover ? a : a.replace(F, 'mouseenter$1 mouseleave$1');
      };
    (f.event = {
      add: function (a, c, d, e, g) {
        var h, i, j, k, l, m, n, o, p, q, r, s;
        if (!(a.nodeType === 3 || a.nodeType === 8 || !c || !d || !(h = f._data(a)))) {
          d.handler && ((p = d), (d = p.handler)),
            d.guid || (d.guid = f.guid++),
            (j = h.events),
            j || (h.events = j = {}),
            (i = h.handle),
            i ||
              ((h.handle = i =
                function (a) {
                  return typeof f != 'undefined' && (!a || f.event.triggered !== a.type)
                    ? f.event.dispatch.apply(i.elem, arguments)
                    : b;
                }),
              (i.elem = a)),
            (c = L(c).split(' '));
          for (k = 0; k < c.length; k++) {
            (l = E.exec(c[k]) || []),
              (m = l[1]),
              (n = (l[2] || '').split('.').sort()),
              (s = f.event.special[m] || {}),
              (m = (g ? s.delegateType : s.bindType) || m),
              (s = f.event.special[m] || {}),
              (o = f.extend(
                { type: m, origType: l[1], data: e, handler: d, guid: d.guid, selector: g, namespace: n.join('.') },
                p,
              )),
              g && ((o.quick = J(g)), !o.quick && f.expr.match.POS.test(g) && (o.isPositional = !0)),
              (r = j[m]);
            if (!r) {
              (r = j[m] = []), (r.delegateCount = 0);
              if (!s.setup || s.setup.call(a, e, n, i) === !1)
                a.addEventListener ? a.addEventListener(m, i, !1) : a.attachEvent && a.attachEvent('on' + m, i);
            }
            s.add && (s.add.call(a, o), o.handler.guid || (o.handler.guid = d.guid)),
              g ? r.splice(r.delegateCount++, 0, o) : r.push(o),
              (f.event.global[m] = !0);
          }
          a = null;
        }
      },
      global: {},
      remove: function (a, b, c, d) {
        var e = f.hasData(a) && f._data(a),
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q;
        if (!!e && !!(m = e.events)) {
          b = L(b || '').split(' ');
          for (g = 0; g < b.length; g++) {
            (h = E.exec(b[g]) || []), (i = h[1]), (j = h[2]);
            if (!i) {
              j = j ? '.' + j : '';
              for (l in m) f.event.remove(a, l + j, c, d);
              return;
            }
            (n = f.event.special[i] || {}),
              (i = (d ? n.delegateType : n.bindType) || i),
              (p = m[i] || []),
              (k = p.length),
              (j = j ? new RegExp('(^|\\.)' + j.split('.').sort().join('\\.(?:.*\\.)?') + '(\\.|$)') : null);
            if (c || j || d || n.remove)
              for (l = 0; l < p.length; l++) {
                q = p[l];
                if (!c || c.guid === q.guid)
                  if (!j || j.test(q.namespace))
                    if (!d || d === q.selector || (d === '**' && q.selector))
                      p.splice(l--, 1), q.selector && p.delegateCount--, n.remove && n.remove.call(a, q);
              }
            else p.length = 0;
            p.length === 0 &&
              k !== p.length &&
              ((!n.teardown || n.teardown.call(a, j) === !1) && f.removeEvent(a, i, e.handle), delete m[i]);
          }
          f.isEmptyObject(m) && ((o = e.handle), o && (o.elem = null), f.removeData(a, ['events', 'handle'], !0));
        }
      },
      customEvent: { getData: !0, setData: !0, changeData: !0 },
      trigger: function (c, d, e, g) {
        if (!e || (e.nodeType !== 3 && e.nodeType !== 8)) {
          var h = c.type || c,
            i = [],
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q,
            r,
            s;
          h.indexOf('!') >= 0 && ((h = h.slice(0, -1)), (k = !0)),
            h.indexOf('.') >= 0 && ((i = h.split('.')), (h = i.shift()), i.sort());
          if ((!e || f.event.customEvent[h]) && !f.event.global[h]) return;
          (c = typeof c == 'object' ? (c[f.expando] ? c : new f.Event(h, c)) : new f.Event(h)),
            (c.type = h),
            (c.isTrigger = !0),
            (c.exclusive = k),
            (c.namespace = i.join('.')),
            (c.namespace_re = c.namespace ? new RegExp('(^|\\.)' + i.join('\\.(?:.*\\.)?') + '(\\.|$)') : null),
            (o = h.indexOf(':') < 0 ? 'on' + h : ''),
            (g || !e) && c.preventDefault();
          if (!e) {
            j = f.cache;
            for (l in j) j[l].events && j[l].events[h] && f.event.trigger(c, d, j[l].handle.elem, !0);
            return;
          }
          (c.result = b),
            c.target || (c.target = e),
            (d = d != null ? f.makeArray(d) : []),
            d.unshift(c),
            (p = f.event.special[h] || {});
          if (p.trigger && p.trigger.apply(e, d) === !1) return;
          r = [[e, p.bindType || h]];
          if (!g && !p.noBubble && !f.isWindow(e)) {
            (s = p.delegateType || h), (n = null);
            for (m = e.parentNode; m; m = m.parentNode) r.push([m, s]), (n = m);
            n && n === e.ownerDocument && r.push([n.defaultView || n.parentWindow || a, s]);
          }
          for (l = 0; l < r.length; l++) {
            (m = r[l][0]),
              (c.type = r[l][1]),
              (q = (f._data(m, 'events') || {})[c.type] && f._data(m, 'handle')),
              q && q.apply(m, d),
              (q = o && m[o]),
              q && f.acceptData(m) && q.apply(m, d);
            if (c.isPropagationStopped()) break;
          }
          (c.type = h),
            c.isDefaultPrevented() ||
              ((!p._default || p._default.apply(e.ownerDocument, d) === !1) &&
                (h !== 'click' || !f.nodeName(e, 'a')) &&
                f.acceptData(e) &&
                o &&
                e[h] &&
                ((h !== 'focus' && h !== 'blur') || c.target.offsetWidth !== 0) &&
                !f.isWindow(e) &&
                ((n = e[o]),
                n && (e[o] = null),
                (f.event.triggered = h),
                e[h](),
                (f.event.triggered = b),
                n && (e[o] = n)));
          return c.result;
        }
      },
      dispatch: function (c) {
        c = f.event.fix(c || a.event);
        var d = (f._data(this, 'events') || {})[c.type] || [],
          e = d.delegateCount,
          g = [].slice.call(arguments, 0),
          h = !c.exclusive && !c.namespace,
          i = (f.event.special[c.type] || {}).handle,
          j = [],
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u;
        (g[0] = c), (c.delegateTarget = this);
        if (e && !c.target.disabled && (!c.button || c.type !== 'click'))
          for (m = c.target; m != this; m = m.parentNode || this) {
            (o = {}), (q = []);
            for (k = 0; k < e; k++)
              (r = d[k]),
                (s = r.selector),
                (t = o[s]),
                r.isPositional
                  ? (t = (t || (o[s] = f(s))).index(m) >= 0)
                  : t === b && (t = o[s] = r.quick ? K(m, r.quick) : f(m).is(s)),
                t && q.push(r);
            q.length && j.push({ elem: m, matches: q });
          }
        d.length > e && j.push({ elem: this, matches: d.slice(e) });
        for (k = 0; k < j.length && !c.isPropagationStopped(); k++) {
          (p = j[k]), (c.currentTarget = p.elem);
          for (l = 0; l < p.matches.length && !c.isImmediatePropagationStopped(); l++) {
            r = p.matches[l];
            if (h || (!c.namespace && !r.namespace) || (c.namespace_re && c.namespace_re.test(r.namespace)))
              (c.data = r.data),
                (c.handleObj = r),
                (n = (i || r.handler).apply(p.elem, g)),
                n !== b && ((c.result = n), n === !1 && (c.preventDefault(), c.stopPropagation()));
          }
        }
        return c.result;
      },
      props:
        'attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which'.split(
          ' ',
        ),
      fixHooks: {},
      keyHooks: {
        props: 'char charCode key keyCode'.split(' '),
        filter: function (a, b) {
          a.which == null && (a.which = b.charCode != null ? b.charCode : b.keyCode);
          return a;
        },
      },
      mouseHooks: {
        props:
          'button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement wheelDelta'.split(
            ' ',
          ),
        filter: function (a, d) {
          var e,
            f,
            g,
            h = d.button,
            i = d.fromElement;
          a.pageX == null &&
            d.clientX != null &&
            ((e = a.target.ownerDocument || c),
            (f = e.documentElement),
            (g = e.body),
            (a.pageX =
              d.clientX +
              ((f && f.scrollLeft) || (g && g.scrollLeft) || 0) -
              ((f && f.clientLeft) || (g && g.clientLeft) || 0)),
            (a.pageY =
              d.clientY +
              ((f && f.scrollTop) || (g && g.scrollTop) || 0) -
              ((f && f.clientTop) || (g && g.clientTop) || 0))),
            !a.relatedTarget && i && (a.relatedTarget = i === a.target ? d.toElement : i),
            !a.which && h !== b && (a.which = h & 1 ? 1 : h & 2 ? 3 : h & 4 ? 2 : 0);
          return a;
        },
      },
      fix: function (a) {
        if (a[f.expando]) return a;
        var d,
          e,
          g = a,
          h = f.event.fixHooks[a.type] || {},
          i = h.props ? this.props.concat(h.props) : this.props;
        a = f.Event(g);
        for (d = i.length; d; ) (e = i[--d]), (a[e] = g[e]);
        a.target || (a.target = g.srcElement || c),
          a.target.nodeType === 3 && (a.target = a.target.parentNode),
          a.metaKey === b && (a.metaKey = a.ctrlKey);
        return h.filter ? h.filter(a, g) : a;
      },
      special: {
        ready: { setup: f.bindReady },
        focus: { delegateType: 'focusin', noBubble: !0 },
        blur: { delegateType: 'focusout', noBubble: !0 },
        beforeunload: {
          setup: function (a, b, c) {
            f.isWindow(this) && (this.onbeforeunload = c);
          },
          teardown: function (a, b) {
            this.onbeforeunload === b && (this.onbeforeunload = null);
          },
        },
      },
      simulate: function (a, b, c, d) {
        var e = f.extend(new f.Event(), c, { type: a, isSimulated: !0, originalEvent: {} });
        d ? f.event.trigger(e, null, b) : f.event.dispatch.call(b, e), e.isDefaultPrevented() && c.preventDefault();
      },
    }),
      (f.event.handle = f.event.dispatch),
      (f.removeEvent = c.removeEventListener
        ? function (a, b, c) {
            a.removeEventListener && a.removeEventListener(b, c, !1);
          }
        : function (a, b, c) {
            a.detachEvent && a.detachEvent('on' + b, c);
          }),
      (f.Event = function (a, b) {
        if (!(this instanceof f.Event)) return new f.Event(a, b);
        a && a.type
          ? ((this.originalEvent = a),
            (this.type = a.type),
            (this.isDefaultPrevented =
              a.defaultPrevented || a.returnValue === !1 || (a.getPreventDefault && a.getPreventDefault()) ? N : M))
          : (this.type = a),
          b && f.extend(this, b),
          (this.timeStamp = (a && a.timeStamp) || f.now()),
          (this[f.expando] = !0);
      }),
      (f.Event.prototype = {
        preventDefault: function () {
          this.isDefaultPrevented = N;
          var a = this.originalEvent;
          !a || (a.preventDefault ? a.preventDefault() : (a.returnValue = !1));
        },
        stopPropagation: function () {
          this.isPropagationStopped = N;
          var a = this.originalEvent;
          !a || (a.stopPropagation && a.stopPropagation(), (a.cancelBubble = !0));
        },
        stopImmediatePropagation: function () {
          (this.isImmediatePropagationStopped = N), this.stopPropagation();
        },
        isDefaultPrevented: M,
        isPropagationStopped: M,
        isImmediatePropagationStopped: M,
      }),
      f.each({ mouseenter: 'mouseover', mouseleave: 'mouseout' }, function (a, b) {
        f.event.special[a] = f.event.special[b] = {
          delegateType: b,
          bindType: b,
          handle: function (a) {
            var b = this,
              c = a.relatedTarget,
              d = a.handleObj,
              e = d.selector,
              g,
              h;
            if (!c || d.origType === a.type || (c !== b && !f.contains(b, c)))
              (g = a.type), (a.type = d.origType), (h = d.handler.apply(this, arguments)), (a.type = g);
            return h;
          },
        };
      }),
      f.support.submitBubbles ||
        (f.event.special.submit = {
          setup: function () {
            if (f.nodeName(this, 'form')) return !1;
            f.event.add(this, 'click._submit keypress._submit', function (a) {
              var c = a.target,
                d = f.nodeName(c, 'input') || f.nodeName(c, 'button') ? c.form : b;
              d &&
                !d._submit_attached &&
                (f.event.add(d, 'submit._submit', function (a) {
                  this.parentNode && f.event.simulate('submit', this.parentNode, a, !0);
                }),
                (d._submit_attached = !0));
            });
          },
          teardown: function () {
            if (f.nodeName(this, 'form')) return !1;
            f.event.remove(this, '._submit');
          },
        }),
      f.support.changeBubbles ||
        (f.event.special.change = {
          setup: function () {
            if (A.test(this.nodeName)) {
              if (this.type === 'checkbox' || this.type === 'radio')
                f.event.add(this, 'propertychange._change', function (a) {
                  a.originalEvent.propertyName === 'checked' && (this._just_changed = !0);
                }),
                  f.event.add(this, 'click._change', function (a) {
                    this._just_changed && ((this._just_changed = !1), f.event.simulate('change', this, a, !0));
                  });
              return !1;
            }
            f.event.add(this, 'beforeactivate._change', function (a) {
              var b = a.target;
              A.test(b.nodeName) &&
                !b._change_attached &&
                (f.event.add(b, 'change._change', function (a) {
                  this.parentNode && !a.isSimulated && f.event.simulate('change', this.parentNode, a, !0);
                }),
                (b._change_attached = !0));
            });
          },
          handle: function (a) {
            var b = a.target;
            if (this !== b || a.isSimulated || a.isTrigger || (b.type !== 'radio' && b.type !== 'checkbox'))
              return a.handleObj.handler.apply(this, arguments);
          },
          teardown: function () {
            f.event.remove(this, '._change');
            return A.test(this.nodeName);
          },
        }),
      f.support.focusinBubbles ||
        f.each({ focus: 'focusin', blur: 'focusout' }, function (a, b) {
          var d = 0,
            e = function (a) {
              f.event.simulate(b, a.target, f.event.fix(a), !0);
            };
          f.event.special[b] = {
            setup: function () {
              d++ === 0 && c.addEventListener(a, e, !0);
            },
            teardown: function () {
              --d === 0 && c.removeEventListener(a, e, !0);
            },
          };
        }),
      f.fn.extend({
        on: function (a, c, d, e, g) {
          var h, i;
          if (typeof a == 'object') {
            typeof c != 'string' && ((d = c), (c = b));
            for (i in a) this.on(i, c, d, a[i], g);
            return this;
          }
          d == null && e == null
            ? ((e = c), (d = c = b))
            : e == null && (typeof c == 'string' ? ((e = d), (d = b)) : ((e = d), (d = c), (c = b)));
          if (e === !1) e = M;
          else if (!e) return this;
          g === 1 &&
            ((h = e),
            (e = function (a) {
              f().off(a);
              return h.apply(this, arguments);
            }),
            (e.guid = h.guid || (h.guid = f.guid++)));
          return this.each(function () {
            f.event.add(this, a, e, d, c);
          });
        },
        one: function (a, b, c, d) {
          return this.on.call(this, a, b, c, d, 1);
        },
        off: function (a, c, d) {
          if (a && a.preventDefault && a.handleObj) {
            var e = a.handleObj;
            f(a.delegateTarget).off(e.namespace ? e.type + '.' + e.namespace : e.type, e.selector, e.handler);
            return this;
          }
          if (typeof a == 'object') {
            for (var g in a) this.off(g, c, a[g]);
            return this;
          }
          if (c === !1 || typeof c == 'function') (d = c), (c = b);
          d === !1 && (d = M);
          return this.each(function () {
            f.event.remove(this, a, d, c);
          });
        },
        bind: function (a, b, c) {
          return this.on(a, null, b, c);
        },
        unbind: function (a, b) {
          return this.off(a, null, b);
        },
        live: function (a, b, c) {
          f(this.context).on(a, this.selector, b, c);
          return this;
        },
        die: function (a, b) {
          f(this.context).off(a, this.selector || '**', b);
          return this;
        },
        delegate: function (a, b, c, d) {
          return this.on(b, a, c, d);
        },
        undelegate: function (a, b, c) {
          return arguments.length == 1 ? this.off(a, '**') : this.off(b, a, c);
        },
        trigger: function (a, b) {
          return this.each(function () {
            f.event.trigger(a, b, this);
          });
        },
        triggerHandler: function (a, b) {
          if (this[0]) return f.event.trigger(a, b, this[0], !0);
        },
        toggle: function (a) {
          var b = arguments,
            c = a.guid || f.guid++,
            d = 0,
            e = function (c) {
              var e = (f._data(this, 'lastToggle' + a.guid) || 0) % d;
              f._data(this, 'lastToggle' + a.guid, e + 1), c.preventDefault();
              return b[e].apply(this, arguments) || !1;
            };
          e.guid = c;
          while (d < b.length) b[d++].guid = c;
          return this.click(e);
        },
        hover: function (a, b) {
          return this.mouseenter(a).mouseleave(b || a);
        },
      }),
      f.each(
        'blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu'.split(
          ' ',
        ),
        function (a, b) {
          (f.fn[b] = function (a, c) {
            c == null && ((c = a), (a = null));
            return arguments.length > 0 ? this.bind(b, a, c) : this.trigger(b);
          }),
            f.attrFn && (f.attrFn[b] = !0),
            G.test(b) && (f.event.fixHooks[b] = f.event.keyHooks),
            H.test(b) && (f.event.fixHooks[b] = f.event.mouseHooks);
        },
      ),
      (function () {
        function x(a, b, c, e, f, g) {
          for (var h = 0, i = e.length; h < i; h++) {
            var j = e[h];
            if (j) {
              var k = !1;
              j = j[a];
              while (j) {
                if (j[d] === c) {
                  k = e[j.sizset];
                  break;
                }
                if (j.nodeType === 1) {
                  g || ((j[d] = c), (j.sizset = h));
                  if (typeof b != 'string') {
                    if (j === b) {
                      k = !0;
                      break;
                    }
                  } else if (m.filter(b, [j]).length > 0) {
                    k = j;
                    break;
                  }
                }
                j = j[a];
              }
              e[h] = k;
            }
          }
        }
        function w(a, b, c, e, f, g) {
          for (var h = 0, i = e.length; h < i; h++) {
            var j = e[h];
            if (j) {
              var k = !1;
              j = j[a];
              while (j) {
                if (j[d] === c) {
                  k = e[j.sizset];
                  break;
                }
                j.nodeType === 1 && !g && ((j[d] = c), (j.sizset = h));
                if (j.nodeName.toLowerCase() === b) {
                  k = j;
                  break;
                }
                j = j[a];
              }
              e[h] = k;
            }
          }
        }
        var a =
            /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
          d = 'sizcache' + (Math.random() + '').replace('.', ''),
          e = 0,
          g = Object.prototype.toString,
          h = !1,
          i = !0,
          j = /\\/g,
          k = /\r\n/g,
          l = /\W/;
        [0, 0].sort(function () {
          i = !1;
          return 0;
        });
        var m = function (b, d, e, f) {
          (e = e || []), (d = d || c);
          var h = d;
          if (d.nodeType !== 1 && d.nodeType !== 9) return [];
          if (!b || typeof b != 'string') return e;
          var i,
            j,
            k,
            l,
            n,
            q,
            r,
            t,
            u = !0,
            v = m.isXML(d),
            w = [],
            x = b;
          do {
            a.exec(''), (i = a.exec(x));
            if (i) {
              (x = i[3]), w.push(i[1]);
              if (i[2]) {
                l = i[3];
                break;
              }
            }
          } while (i);
          if (w.length > 1 && p.exec(b))
            if (w.length === 2 && o.relative[w[0]]) j = y(w[0] + w[1], d, f);
            else {
              j = o.relative[w[0]] ? [d] : m(w.shift(), d);
              while (w.length) (b = w.shift()), o.relative[b] && (b += w.shift()), (j = y(b, j, f));
            }
          else {
            !f &&
              w.length > 1 &&
              d.nodeType === 9 &&
              !v &&
              o.match.ID.test(w[0]) &&
              !o.match.ID.test(w[w.length - 1]) &&
              ((n = m.find(w.shift(), d, v)), (d = n.expr ? m.filter(n.expr, n.set)[0] : n.set[0]));
            if (d) {
              (n = f
                ? { expr: w.pop(), set: s(f) }
                : m.find(
                    w.pop(),
                    w.length === 1 && (w[0] === '~' || w[0] === '+') && d.parentNode ? d.parentNode : d,
                    v,
                  )),
                (j = n.expr ? m.filter(n.expr, n.set) : n.set),
                w.length > 0 ? (k = s(j)) : (u = !1);
              while (w.length)
                (q = w.pop()),
                  (r = q),
                  o.relative[q] ? (r = w.pop()) : (q = ''),
                  r == null && (r = d),
                  o.relative[q](k, r, v);
            } else k = w = [];
          }
          k || (k = j), k || m.error(q || b);
          if (g.call(k) === '[object Array]')
            if (!u) e.push.apply(e, k);
            else if (d && d.nodeType === 1)
              for (t = 0; k[t] != null; t++)
                k[t] && (k[t] === !0 || (k[t].nodeType === 1 && m.contains(d, k[t]))) && e.push(j[t]);
            else for (t = 0; k[t] != null; t++) k[t] && k[t].nodeType === 1 && e.push(j[t]);
          else s(k, e);
          l && (m(l, h, e, f), m.uniqueSort(e));
          return e;
        };
        (m.uniqueSort = function (a) {
          if (u) {
            (h = i), a.sort(u);
            if (h) for (var b = 1; b < a.length; b++) a[b] === a[b - 1] && a.splice(b--, 1);
          }
          return a;
        }),
          (m.matches = function (a, b) {
            return m(a, null, null, b);
          }),
          (m.matchesSelector = function (a, b) {
            return m(b, null, null, [a]).length > 0;
          }),
          (m.find = function (a, b, c) {
            var d, e, f, g, h, i;
            if (!a) return [];
            for (e = 0, f = o.order.length; e < f; e++) {
              h = o.order[e];
              if ((g = o.leftMatch[h].exec(a))) {
                (i = g[1]), g.splice(1, 1);
                if (i.substr(i.length - 1) !== '\\') {
                  (g[1] = (g[1] || '').replace(j, '')), (d = o.find[h](g, b, c));
                  if (d != null) {
                    a = a.replace(o.match[h], '');
                    break;
                  }
                }
              }
            }
            d || (d = typeof b.getElementsByTagName != 'undefined' ? b.getElementsByTagName('*') : []);
            return { set: d, expr: a };
          }),
          (m.filter = function (a, c, d, e) {
            var f,
              g,
              h,
              i,
              j,
              k,
              l,
              n,
              p,
              q = a,
              r = [],
              s = c,
              t = c && c[0] && m.isXML(c[0]);
            while (a && c.length) {
              for (h in o.filter)
                if ((f = o.leftMatch[h].exec(a)) != null && f[2]) {
                  (k = o.filter[h]), (l = f[1]), (g = !1), f.splice(1, 1);
                  if (l.substr(l.length - 1) === '\\') continue;
                  s === r && (r = []);
                  if (o.preFilter[h]) {
                    f = o.preFilter[h](f, s, d, r, e, t);
                    if (!f) g = i = !0;
                    else if (f === !0) continue;
                  }
                  if (f)
                    for (n = 0; (j = s[n]) != null; n++)
                      j &&
                        ((i = k(j, f, n, s)),
                        (p = e ^ i),
                        d && i != null ? (p ? (g = !0) : (s[n] = !1)) : p && (r.push(j), (g = !0)));
                  if (i !== b) {
                    d || (s = r), (a = a.replace(o.match[h], ''));
                    if (!g) return [];
                    break;
                  }
                }
              if (a === q)
                if (g == null) m.error(a);
                else break;
              q = a;
            }
            return s;
          }),
          (m.error = function (a) {
            throw 'Syntax error, unrecognized expression: ' + a;
          });
        var n = (m.getText = function (a) {
            var b,
              c,
              d = a.nodeType,
              e = '';
            if (d) {
              if (d === 1) {
                if (typeof a.textContent == 'string') return a.textContent;
                if (typeof a.innerText == 'string') return a.innerText.replace(k, '');
                for (a = a.firstChild; a; a = a.nextSibling) e += n(a);
              } else if (d === 3 || d === 4) return a.nodeValue;
            } else for (b = 0; (c = a[b]); b++) c.nodeType !== 8 && (e += n(c));
            return e;
          }),
          o = (m.selectors = {
            order: ['ID', 'NAME', 'TAG'],
            match: {
              ID: /#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
              CLASS: /\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,
              NAME: /\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/,
              ATTR: /\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/,
              TAG: /^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/,
              CHILD:
                /:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/,
              POS: /:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/,
              PSEUDO: /:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/,
            },
            leftMatch: {},
            attrMap: { class: 'className', for: 'htmlFor' },
            attrHandle: {
              href: function (a) {
                return a.getAttribute('href');
              },
              type: function (a) {
                return a.getAttribute('type');
              },
            },
            relative: {
              '+': function (a, b) {
                var c = typeof b == 'string',
                  d = c && !l.test(b),
                  e = c && !d;
                d && (b = b.toLowerCase());
                for (var f = 0, g = a.length, h; f < g; f++)
                  if ((h = a[f])) {
                    while ((h = h.previousSibling) && h.nodeType !== 1);
                    a[f] = e || (h && h.nodeName.toLowerCase() === b) ? h || !1 : h === b;
                  }
                e && m.filter(b, a, !0);
              },
              '>': function (a, b) {
                var c,
                  d = typeof b == 'string',
                  e = 0,
                  f = a.length;
                if (d && !l.test(b)) {
                  b = b.toLowerCase();
                  for (; e < f; e++) {
                    c = a[e];
                    if (c) {
                      var g = c.parentNode;
                      a[e] = g.nodeName.toLowerCase() === b ? g : !1;
                    }
                  }
                } else {
                  for (; e < f; e++) (c = a[e]), c && (a[e] = d ? c.parentNode : c.parentNode === b);
                  d && m.filter(b, a, !0);
                }
              },
              '': function (a, b, c) {
                var d,
                  f = e++,
                  g = x;
                typeof b == 'string' && !l.test(b) && ((b = b.toLowerCase()), (d = b), (g = w)),
                  g('parentNode', b, f, a, d, c);
              },
              '~': function (a, b, c) {
                var d,
                  f = e++,
                  g = x;
                typeof b == 'string' && !l.test(b) && ((b = b.toLowerCase()), (d = b), (g = w)),
                  g('previousSibling', b, f, a, d, c);
              },
            },
            find: {
              ID: function (a, b, c) {
                if (typeof b.getElementById != 'undefined' && !c) {
                  var d = b.getElementById(a[1]);
                  return d && d.parentNode ? [d] : [];
                }
              },
              NAME: function (a, b) {
                if (typeof b.getElementsByName != 'undefined') {
                  var c = [],
                    d = b.getElementsByName(a[1]);
                  for (var e = 0, f = d.length; e < f; e++) d[e].getAttribute('name') === a[1] && c.push(d[e]);
                  return c.length === 0 ? null : c;
                }
              },
              TAG: function (a, b) {
                if (typeof b.getElementsByTagName != 'undefined') return b.getElementsByTagName(a[1]);
              },
            },
            preFilter: {
              CLASS: function (a, b, c, d, e, f) {
                a = ' ' + a[1].replace(j, '') + ' ';
                if (f) return a;
                for (var g = 0, h; (h = b[g]) != null; g++)
                  h &&
                    (e ^ (h.className && (' ' + h.className + ' ').replace(/[\t\n\r]/g, ' ').indexOf(a) >= 0)
                      ? c || d.push(h)
                      : c && (b[g] = !1));
                return !1;
              },
              ID: function (a) {
                return a[1].replace(j, '');
              },
              TAG: function (a, b) {
                return a[1].replace(j, '').toLowerCase();
              },
              CHILD: function (a) {
                if (a[1] === 'nth') {
                  a[2] || m.error(a[0]), (a[2] = a[2].replace(/^\+|\s*/g, ''));
                  var b = /(-?)(\d*)(?:n([+\-]?\d*))?/.exec(
                    (a[2] === 'even' && '2n') ||
                      (a[2] === 'odd' && '2n+1') ||
                      (!/\D/.test(a[2]) && '0n+' + a[2]) ||
                      a[2],
                  );
                  (a[2] = b[1] + (b[2] || 1) - 0), (a[3] = b[3] - 0);
                } else a[2] && m.error(a[0]);
                a[0] = e++;
                return a;
              },
              ATTR: function (a, b, c, d, e, f) {
                var g = (a[1] = a[1].replace(j, ''));
                !f && o.attrMap[g] && (a[1] = o.attrMap[g]),
                  (a[4] = (a[4] || a[5] || '').replace(j, '')),
                  a[2] === '~=' && (a[4] = ' ' + a[4] + ' ');
                return a;
              },
              PSEUDO: function (b, c, d, e, f) {
                if (b[1] === 'not')
                  if ((a.exec(b[3]) || '').length > 1 || /^\w/.test(b[3])) b[3] = m(b[3], null, null, c);
                  else {
                    var g = m.filter(b[3], c, d, !0 ^ f);
                    d || e.push.apply(e, g);
                    return !1;
                  }
                else if (o.match.POS.test(b[0]) || o.match.CHILD.test(b[0])) return !0;
                return b;
              },
              POS: function (a) {
                a.unshift(!0);
                return a;
              },
            },
            filters: {
              enabled: function (a) {
                return a.disabled === !1 && a.type !== 'hidden';
              },
              disabled: function (a) {
                return a.disabled === !0;
              },
              checked: function (a) {
                return a.checked === !0;
              },
              selected: function (a) {
                a.parentNode && a.parentNode.selectedIndex;
                return a.selected === !0;
              },
              parent: function (a) {
                return !!a.firstChild;
              },
              empty: function (a) {
                return !a.firstChild;
              },
              has: function (a, b, c) {
                return !!m(c[3], a).length;
              },
              header: function (a) {
                return /h\d/i.test(a.nodeName);
              },
              text: function (a) {
                var b = a.getAttribute('type'),
                  c = a.type;
                return a.nodeName.toLowerCase() === 'input' && 'text' === c && (b === c || b === null);
              },
              radio: function (a) {
                return a.nodeName.toLowerCase() === 'input' && 'radio' === a.type;
              },
              checkbox: function (a) {
                return a.nodeName.toLowerCase() === 'input' && 'checkbox' === a.type;
              },
              file: function (a) {
                return a.nodeName.toLowerCase() === 'input' && 'file' === a.type;
              },
              password: function (a) {
                return a.nodeName.toLowerCase() === 'input' && 'password' === a.type;
              },
              submit: function (a) {
                var b = a.nodeName.toLowerCase();
                return (b === 'input' || b === 'button') && 'submit' === a.type;
              },
              image: function (a) {
                return a.nodeName.toLowerCase() === 'input' && 'image' === a.type;
              },
              reset: function (a) {
                var b = a.nodeName.toLowerCase();
                return (b === 'input' || b === 'button') && 'reset' === a.type;
              },
              button: function (a) {
                var b = a.nodeName.toLowerCase();
                return (b === 'input' && 'button' === a.type) || b === 'button';
              },
              input: function (a) {
                return /input|select|textarea|button/i.test(a.nodeName);
              },
              focus: function (a) {
                return a === a.ownerDocument.activeElement;
              },
            },
            setFilters: {
              first: function (a, b) {
                return b === 0;
              },
              last: function (a, b, c, d) {
                return b === d.length - 1;
              },
              even: function (a, b) {
                return b % 2 === 0;
              },
              odd: function (a, b) {
                return b % 2 === 1;
              },
              lt: function (a, b, c) {
                return b < c[3] - 0;
              },
              gt: function (a, b, c) {
                return b > c[3] - 0;
              },
              nth: function (a, b, c) {
                return c[3] - 0 === b;
              },
              eq: function (a, b, c) {
                return c[3] - 0 === b;
              },
            },
            filter: {
              PSEUDO: function (a, b, c, d) {
                var e = b[1],
                  f = o.filters[e];
                if (f) return f(a, c, b, d);
                if (e === 'contains') return (a.textContent || a.innerText || n([a]) || '').indexOf(b[3]) >= 0;
                if (e === 'not') {
                  var g = b[3];
                  for (var h = 0, i = g.length; h < i; h++) if (g[h] === a) return !1;
                  return !0;
                }
                m.error(e);
              },
              CHILD: function (a, b) {
                var c,
                  e,
                  f,
                  g,
                  h,
                  i,
                  j,
                  k = b[1],
                  l = a;
                switch (k) {
                  case 'only':
                  case 'first':
                    while ((l = l.previousSibling)) if (l.nodeType === 1) return !1;
                    if (k === 'first') return !0;
                    l = a;
                  case 'last':
                    while ((l = l.nextSibling)) if (l.nodeType === 1) return !1;
                    return !0;
                  case 'nth':
                    (c = b[2]), (e = b[3]);
                    if (c === 1 && e === 0) return !0;
                    (f = b[0]), (g = a.parentNode);
                    if (g && (g[d] !== f || !a.nodeIndex)) {
                      i = 0;
                      for (l = g.firstChild; l; l = l.nextSibling) l.nodeType === 1 && (l.nodeIndex = ++i);
                      g[d] = f;
                    }
                    j = a.nodeIndex - e;
                    return c === 0 ? j === 0 : j % c === 0 && j / c >= 0;
                }
              },
              ID: function (a, b) {
                return a.nodeType === 1 && a.getAttribute('id') === b;
              },
              TAG: function (a, b) {
                return (b === '*' && a.nodeType === 1) || (!!a.nodeName && a.nodeName.toLowerCase() === b);
              },
              CLASS: function (a, b) {
                return (' ' + (a.className || a.getAttribute('class')) + ' ').indexOf(b) > -1;
              },
              ATTR: function (a, b) {
                var c = b[1],
                  d = m.attr
                    ? m.attr(a, c)
                    : o.attrHandle[c]
                    ? o.attrHandle[c](a)
                    : a[c] != null
                    ? a[c]
                    : a.getAttribute(c),
                  e = d + '',
                  f = b[2],
                  g = b[4];
                return d == null
                  ? f === '!='
                  : !f && m.attr
                  ? d != null
                  : f === '='
                  ? e === g
                  : f === '*='
                  ? e.indexOf(g) >= 0
                  : f === '~='
                  ? (' ' + e + ' ').indexOf(g) >= 0
                  : g
                  ? f === '!='
                    ? e !== g
                    : f === '^='
                    ? e.indexOf(g) === 0
                    : f === '$='
                    ? e.substr(e.length - g.length) === g
                    : f === '|='
                    ? e === g || e.substr(0, g.length + 1) === g + '-'
                    : !1
                  : e && d !== !1;
              },
              POS: function (a, b, c, d) {
                var e = b[2],
                  f = o.setFilters[e];
                if (f) return f(a, c, b, d);
              },
            },
          }),
          p = o.match.POS,
          q = function (a, b) {
            return '\\' + (b - 0 + 1);
          };
        for (var r in o.match)
          (o.match[r] = new RegExp(o.match[r].source + /(?![^\[]*\])(?![^\(]*\))/.source)),
            (o.leftMatch[r] = new RegExp(/(^(?:.|\r|\n)*?)/.source + o.match[r].source.replace(/\\(\d+)/g, q)));
        var s = function (a, b) {
          a = Array.prototype.slice.call(a, 0);
          if (b) {
            b.push.apply(b, a);
            return b;
          }
          return a;
        };
        try {
          Array.prototype.slice.call(c.documentElement.childNodes, 0)[0].nodeType;
        } catch (t) {
          s = function (a, b) {
            var c = 0,
              d = b || [];
            if (g.call(a) === '[object Array]') Array.prototype.push.apply(d, a);
            else if (typeof a.length == 'number') for (var e = a.length; c < e; c++) d.push(a[c]);
            else for (; a[c]; c++) d.push(a[c]);
            return d;
          };
        }
        var u, v;
        c.documentElement.compareDocumentPosition
          ? (u = function (a, b) {
              if (a === b) {
                h = !0;
                return 0;
              }
              if (!a.compareDocumentPosition || !b.compareDocumentPosition) return a.compareDocumentPosition ? -1 : 1;
              return a.compareDocumentPosition(b) & 4 ? -1 : 1;
            })
          : ((u = function (a, b) {
              if (a === b) {
                h = !0;
                return 0;
              }
              if (a.sourceIndex && b.sourceIndex) return a.sourceIndex - b.sourceIndex;
              var c,
                d,
                e = [],
                f = [],
                g = a.parentNode,
                i = b.parentNode,
                j = g;
              if (g === i) return v(a, b);
              if (!g) return -1;
              if (!i) return 1;
              while (j) e.unshift(j), (j = j.parentNode);
              j = i;
              while (j) f.unshift(j), (j = j.parentNode);
              (c = e.length), (d = f.length);
              for (var k = 0; k < c && k < d; k++) if (e[k] !== f[k]) return v(e[k], f[k]);
              return k === c ? v(a, f[k], -1) : v(e[k], b, 1);
            }),
            (v = function (a, b, c) {
              if (a === b) return c;
              var d = a.nextSibling;
              while (d) {
                if (d === b) return -1;
                d = d.nextSibling;
              }
              return 1;
            })),
          (function () {
            var a = c.createElement('div'),
              d = 'script' + new Date().getTime(),
              e = c.documentElement;
            (a.innerHTML = "<a name='" + d + "'/>"),
              e.insertBefore(a, e.firstChild),
              c.getElementById(d) &&
                ((o.find.ID = function (a, c, d) {
                  if (typeof c.getElementById != 'undefined' && !d) {
                    var e = c.getElementById(a[1]);
                    return e
                      ? e.id === a[1] ||
                        (typeof e.getAttributeNode != 'undefined' && e.getAttributeNode('id').nodeValue === a[1])
                        ? [e]
                        : b
                      : [];
                  }
                }),
                (o.filter.ID = function (a, b) {
                  var c = typeof a.getAttributeNode != 'undefined' && a.getAttributeNode('id');
                  return a.nodeType === 1 && c && c.nodeValue === b;
                })),
              e.removeChild(a),
              (e = a = null);
          })(),
          (function () {
            var a = c.createElement('div');
            a.appendChild(c.createComment('')),
              a.getElementsByTagName('*').length > 0 &&
                (o.find.TAG = function (a, b) {
                  var c = b.getElementsByTagName(a[1]);
                  if (a[1] === '*') {
                    var d = [];
                    for (var e = 0; c[e]; e++) c[e].nodeType === 1 && d.push(c[e]);
                    c = d;
                  }
                  return c;
                }),
              (a.innerHTML = "<a href='#'></a>"),
              a.firstChild &&
                typeof a.firstChild.getAttribute != 'undefined' &&
                a.firstChild.getAttribute('href') !== '#' &&
                (o.attrHandle.href = function (a) {
                  return a.getAttribute('href', 2);
                }),
              (a = null);
          })(),
          c.querySelectorAll &&
            (function () {
              var a = m,
                b = c.createElement('div'),
                d = '__sizzle__';
              b.innerHTML = "<p class='TEST'></p>";
              if (!b.querySelectorAll || b.querySelectorAll('.TEST').length !== 0) {
                m = function (b, e, f, g) {
                  e = e || c;
                  if (!g && !m.isXML(e)) {
                    var h = /^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec(b);
                    if (h && (e.nodeType === 1 || e.nodeType === 9)) {
                      if (h[1]) return s(e.getElementsByTagName(b), f);
                      if (h[2] && o.find.CLASS && e.getElementsByClassName) return s(e.getElementsByClassName(h[2]), f);
                    }
                    if (e.nodeType === 9) {
                      if (b === 'body' && e.body) return s([e.body], f);
                      if (h && h[3]) {
                        var i = e.getElementById(h[3]);
                        if (!i || !i.parentNode) return s([], f);
                        if (i.id === h[3]) return s([i], f);
                      }
                      try {
                        return s(e.querySelectorAll(b), f);
                      } catch (j) {}
                    } else if (e.nodeType === 1 && e.nodeName.toLowerCase() !== 'object') {
                      var k = e,
                        l = e.getAttribute('id'),
                        n = l || d,
                        p = e.parentNode,
                        q = /^\s*[+~]/.test(b);
                      l ? (n = n.replace(/'/g, '\\$&')) : e.setAttribute('id', n), q && p && (e = e.parentNode);
                      try {
                        if (!q || p) return s(e.querySelectorAll("[id='" + n + "'] " + b), f);
                      } catch (r) {
                      } finally {
                        l || k.removeAttribute('id');
                      }
                    }
                  }
                  return a(b, e, f, g);
                };
                for (var e in a) m[e] = a[e];
                b = null;
              }
            })(),
          (function () {
            var a = c.documentElement,
              b = a.matchesSelector || a.mozMatchesSelector || a.webkitMatchesSelector || a.msMatchesSelector;
            if (b) {
              var d = !b.call(c.createElement('div'), 'div'),
                e = !1;
              try {
                b.call(c.documentElement, "[test!='']:sizzle");
              } catch (f) {
                e = !0;
              }
              m.matchesSelector = function (a, c) {
                c = c.replace(/\=\s*([^'"\]]*)\s*\]/g, "='$1']");
                if (!m.isXML(a))
                  try {
                    if (e || (!o.match.PSEUDO.test(c) && !/!=/.test(c))) {
                      var f = b.call(a, c);
                      if (f || !d || (a.document && a.document.nodeType !== 11)) return f;
                    }
                  } catch (g) {}
                return m(c, null, null, [a]).length > 0;
              };
            }
          })(),
          (function () {
            var a = c.createElement('div');
            a.innerHTML = "<div class='test e'></div><div class='test'></div>";
            if (!!a.getElementsByClassName && a.getElementsByClassName('e').length !== 0) {
              a.lastChild.className = 'e';
              if (a.getElementsByClassName('e').length === 1) return;
              o.order.splice(1, 0, 'CLASS'),
                (o.find.CLASS = function (a, b, c) {
                  if (typeof b.getElementsByClassName != 'undefined' && !c) return b.getElementsByClassName(a[1]);
                }),
                (a = null);
            }
          })(),
          c.documentElement.contains
            ? (m.contains = function (a, b) {
                return a !== b && (a.contains ? a.contains(b) : !0);
              })
            : c.documentElement.compareDocumentPosition
            ? (m.contains = function (a, b) {
                return !!(a.compareDocumentPosition(b) & 16);
              })
            : (m.contains = function () {
                return !1;
              }),
          (m.isXML = function (a) {
            var b = (a ? a.ownerDocument || a : 0).documentElement;
            return b ? b.nodeName !== 'HTML' : !1;
          });
        var y = function (a, b, c) {
          var d,
            e = [],
            f = '',
            g = b.nodeType ? [b] : b;
          while ((d = o.match.PSEUDO.exec(a))) (f += d[0]), (a = a.replace(o.match.PSEUDO, ''));
          a = o.relative[a] ? a + '*' : a;
          for (var h = 0, i = g.length; h < i; h++) m(a, g[h], e, c);
          return m.filter(f, e);
        };
        (m.attr = f.attr),
          (m.selectors.attrMap = {}),
          (f.find = m),
          (f.expr = m.selectors),
          (f.expr[':'] = f.expr.filters),
          (f.unique = m.uniqueSort),
          (f.text = m.getText),
          (f.isXMLDoc = m.isXML),
          (f.contains = m.contains);
      })();
    var O = /Until$/,
      P = /^(?:parents|prevUntil|prevAll)/,
      Q = /,/,
      R = /^.[^:#\[\.,]*$/,
      S = Array.prototype.slice,
      T = f.expr.match.POS,
      U = { children: !0, contents: !0, next: !0, prev: !0 };
    f.fn.extend({
      find: function (a) {
        var b = this,
          c,
          d;
        if (typeof a != 'string')
          return f(a).filter(function () {
            for (c = 0, d = b.length; c < d; c++) if (f.contains(b[c], this)) return !0;
          });
        var e = this.pushStack('', 'find', a),
          g,
          h,
          i;
        for (c = 0, d = this.length; c < d; c++) {
          (g = e.length), f.find(a, this[c], e);
          if (c > 0)
            for (h = g; h < e.length; h++)
              for (i = 0; i < g; i++)
                if (e[i] === e[h]) {
                  e.splice(h--, 1);
                  break;
                }
        }
        return e;
      },
      has: function (a) {
        var b = f(a);
        return this.filter(function () {
          for (var a = 0, c = b.length; a < c; a++) if (f.contains(this, b[a])) return !0;
        });
      },
      not: function (a) {
        return this.pushStack(W(this, a, !1), 'not', a);
      },
      filter: function (a) {
        return this.pushStack(W(this, a, !0), 'filter', a);
      },
      is: function (a) {
        return (
          !!a &&
          (typeof a == 'string'
            ? T.test(a)
              ? f(a, this.context).index(this[0]) >= 0
              : f.filter(a, this).length > 0
            : this.filter(a).length > 0)
        );
      },
      closest: function (a, b) {
        var c = [],
          d,
          e,
          g = this[0];
        if (f.isArray(a)) {
          var h = 1;
          while (g && g.ownerDocument && g !== b) {
            for (d = 0; d < a.length; d++) f(g).is(a[d]) && c.push({ selector: a[d], elem: g, level: h });
            (g = g.parentNode), h++;
          }
          return c;
        }
        var i = T.test(a) || typeof a != 'string' ? f(a, b || this.context) : 0;
        for (d = 0, e = this.length; d < e; d++) {
          g = this[d];
          while (g) {
            if (i ? i.index(g) > -1 : f.find.matchesSelector(g, a)) {
              c.push(g);
              break;
            }
            g = g.parentNode;
            if (!g || !g.ownerDocument || g === b || g.nodeType === 11) break;
          }
        }
        c = c.length > 1 ? f.unique(c) : c;
        return this.pushStack(c, 'closest', a);
      },
      index: function (a) {
        if (!a) return this[0] && this[0].parentNode ? this.prevAll().length : -1;
        if (typeof a == 'string') return f.inArray(this[0], f(a));
        return f.inArray(a.jquery ? a[0] : a, this);
      },
      add: function (a, b) {
        var c = typeof a == 'string' ? f(a, b) : f.makeArray(a && a.nodeType ? [a] : a),
          d = f.merge(this.get(), c);
        return this.pushStack(V(c[0]) || V(d[0]) ? d : f.unique(d));
      },
      andSelf: function () {
        return this.add(this.prevObject);
      },
    }),
      f.each(
        {
          parent: function (a) {
            var b = a.parentNode;
            return b && b.nodeType !== 11 ? b : null;
          },
          parents: function (a) {
            return f.dir(a, 'parentNode');
          },
          parentsUntil: function (a, b, c) {
            return f.dir(a, 'parentNode', c);
          },
          next: function (a) {
            return f.nth(a, 2, 'nextSibling');
          },
          prev: function (a) {
            return f.nth(a, 2, 'previousSibling');
          },
          nextAll: function (a) {
            return f.dir(a, 'nextSibling');
          },
          prevAll: function (a) {
            return f.dir(a, 'previousSibling');
          },
          nextUntil: function (a, b, c) {
            return f.dir(a, 'nextSibling', c);
          },
          prevUntil: function (a, b, c) {
            return f.dir(a, 'previousSibling', c);
          },
          siblings: function (a) {
            return f.sibling(a.parentNode.firstChild, a);
          },
          children: function (a) {
            return f.sibling(a.firstChild);
          },
          contents: function (a) {
            return f.nodeName(a, 'iframe') ? a.contentDocument || a.contentWindow.document : f.makeArray(a.childNodes);
          },
        },
        function (a, b) {
          f.fn[a] = function (c, d) {
            var e = f.map(this, b, c),
              g = S.call(arguments);
            O.test(a) || (d = c),
              d && typeof d == 'string' && (e = f.filter(d, e)),
              (e = this.length > 1 && !U[a] ? f.unique(e) : e),
              (this.length > 1 || Q.test(d)) && P.test(a) && (e = e.reverse());
            return this.pushStack(e, a, g.join(','));
          };
        },
      ),
      f.extend({
        filter: function (a, b, c) {
          c && (a = ':not(' + a + ')');
          return b.length === 1 ? (f.find.matchesSelector(b[0], a) ? [b[0]] : []) : f.find.matches(a, b);
        },
        dir: function (a, c, d) {
          var e = [],
            g = a[c];
          while (g && g.nodeType !== 9 && (d === b || g.nodeType !== 1 || !f(g).is(d)))
            g.nodeType === 1 && e.push(g), (g = g[c]);
          return e;
        },
        nth: function (a, b, c, d) {
          b = b || 1;
          var e = 0;
          for (; a; a = a[c]) if (a.nodeType === 1 && ++e === b) break;
          return a;
        },
        sibling: function (a, b) {
          var c = [];
          for (; a; a = a.nextSibling) a.nodeType === 1 && a !== b && c.push(a);
          return c;
        },
      });
    var Y =
        'abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video',
      Z = / jQuery\d+="(?:\d+|null)"/g,
      $ = /^\s+/,
      _ = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      ba = /<([\w:]+)/,
      bb = /<tbody/i,
      bc = /<|&#?\w+;/,
      bd = /<(?:script|style)/i,
      be = /<(?:script|object|embed|option|style)/i,
      bf = new RegExp('<(?:' + Y.replace(' ', '|') + ')', 'i'),
      bg = /checked\s*(?:[^=]|=\s*.checked.)/i,
      bh = /\/(java|ecma)script/i,
      bi = /^\s*<!(?:\[CDATA\[|\-\-)/,
      bj = {
        option: [1, "<select multiple='multiple'>", '</select>'],
        legend: [1, '<fieldset>', '</fieldset>'],
        thead: [1, '<table>', '</table>'],
        tr: [2, '<table><tbody>', '</tbody></table>'],
        td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
        col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
        area: [1, '<map>', '</map>'],
        _default: [0, '', ''],
      },
      bk = X(c);
    (bj.optgroup = bj.option),
      (bj.tbody = bj.tfoot = bj.colgroup = bj.caption = bj.thead),
      (bj.th = bj.td),
      f.support.htmlSerialize || (bj._default = [1, 'div<div>', '</div>']),
      f.fn.extend({
        text: function (a) {
          if (f.isFunction(a))
            return this.each(function (b) {
              var c = f(this);
              c.text(a.call(this, b, c.text()));
            });
          if (typeof a != 'object' && a !== b)
            return this.empty().append(((this[0] && this[0].ownerDocument) || c).createTextNode(a));
          return f.text(this);
        },
        wrapAll: function (a) {
          if (f.isFunction(a))
            return this.each(function (b) {
              f(this).wrapAll(a.call(this, b));
            });
          if (this[0]) {
            var b = f(a, this[0].ownerDocument).eq(0).clone(!0);
            this[0].parentNode && b.insertBefore(this[0]),
              b
                .map(function () {
                  var a = this;
                  while (a.firstChild && a.firstChild.nodeType === 1) a = a.firstChild;
                  return a;
                })
                .append(this);
          }
          return this;
        },
        wrapInner: function (a) {
          if (f.isFunction(a))
            return this.each(function (b) {
              f(this).wrapInner(a.call(this, b));
            });
          return this.each(function () {
            var b = f(this),
              c = b.contents();
            c.length ? c.wrapAll(a) : b.append(a);
          });
        },
        wrap: function (a) {
          return this.each(function () {
            f(this).wrapAll(a);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              f.nodeName(this, 'body') || f(this).replaceWith(this.childNodes);
            })
            .end();
        },
        append: function () {
          return this.domManip(arguments, !0, function (a) {
            this.nodeType === 1 && this.appendChild(a);
          });
        },
        prepend: function () {
          return this.domManip(arguments, !0, function (a) {
            this.nodeType === 1 && this.insertBefore(a, this.firstChild);
          });
        },
        before: function () {
          if (this[0] && this[0].parentNode)
            return this.domManip(arguments, !1, function (a) {
              this.parentNode.insertBefore(a, this);
            });
          if (arguments.length) {
            var a = f(arguments[0]);
            a.push.apply(a, this.toArray());
            return this.pushStack(a, 'before', arguments);
          }
        },
        after: function () {
          if (this[0] && this[0].parentNode)
            return this.domManip(arguments, !1, function (a) {
              this.parentNode.insertBefore(a, this.nextSibling);
            });
          if (arguments.length) {
            var a = this.pushStack(this, 'after', arguments);
            a.push.apply(a, f(arguments[0]).toArray());
            return a;
          }
        },
        remove: function (a, b) {
          for (var c = 0, d; (d = this[c]) != null; c++)
            if (!a || f.filter(a, [d]).length)
              !b && d.nodeType === 1 && (f.cleanData(d.getElementsByTagName('*')), f.cleanData([d])),
                d.parentNode && d.parentNode.removeChild(d);
          return this;
        },
        empty: function () {
          for (var a = 0, b; (b = this[a]) != null; a++) {
            b.nodeType === 1 && f.cleanData(b.getElementsByTagName('*'));
            while (b.firstChild) b.removeChild(b.firstChild);
          }
          return this;
        },
        clone: function (a, b) {
          (a = a == null ? !1 : a), (b = b == null ? a : b);
          return this.map(function () {
            return f.clone(this, a, b);
          });
        },
        html: function (a) {
          if (a === b) return this[0] && this[0].nodeType === 1 ? this[0].innerHTML.replace(Z, '') : null;
          if (
            typeof a == 'string' &&
            !bd.test(a) &&
            (f.support.leadingWhitespace || !$.test(a)) &&
            !bj[(ba.exec(a) || ['', ''])[1].toLowerCase()]
          ) {
            a = a.replace(_, '<$1></$2>');
            try {
              for (var c = 0, d = this.length; c < d; c++)
                this[c].nodeType === 1 && (f.cleanData(this[c].getElementsByTagName('*')), (this[c].innerHTML = a));
            } catch (e) {
              this.empty().append(a);
            }
          } else
            f.isFunction(a)
              ? this.each(function (b) {
                  var c = f(this);
                  c.html(a.call(this, b, c.html()));
                })
              : this.empty().append(a);
          return this;
        },
        replaceWith: function (a) {
          if (this[0] && this[0].parentNode) {
            if (f.isFunction(a))
              return this.each(function (b) {
                var c = f(this),
                  d = c.html();
                c.replaceWith(a.call(this, b, d));
              });
            typeof a != 'string' && (a = f(a).detach());
            return this.each(function () {
              var b = this.nextSibling,
                c = this.parentNode;
              f(this).remove(), b ? f(b).before(a) : f(c).append(a);
            });
          }
          return this.length ? this.pushStack(f(f.isFunction(a) ? a() : a), 'replaceWith', a) : this;
        },
        detach: function (a) {
          return this.remove(a, !0);
        },
        domManip: function (a, c, d) {
          var e,
            g,
            h,
            i,
            j = a[0],
            k = [];
          if (!f.support.checkClone && arguments.length === 3 && typeof j == 'string' && bg.test(j))
            return this.each(function () {
              f(this).domManip(a, c, d, !0);
            });
          if (f.isFunction(j))
            return this.each(function (e) {
              var g = f(this);
              (a[0] = j.call(this, e, c ? g.html() : b)), g.domManip(a, c, d);
            });
          if (this[0]) {
            (i = j && j.parentNode),
              f.support.parentNode && i && i.nodeType === 11 && i.childNodes.length === this.length
                ? (e = { fragment: i })
                : (e = f.buildFragment(a, this, k)),
              (h = e.fragment),
              h.childNodes.length === 1 ? (g = h = h.firstChild) : (g = h.firstChild);
            if (g) {
              c = c && f.nodeName(g, 'tr');
              for (var l = 0, m = this.length, n = m - 1; l < m; l++)
                d.call(c ? bl(this[l], g) : this[l], e.cacheable || (m > 1 && l < n) ? f.clone(h, !0, !0) : h);
            }
            k.length && f.each(k, br);
          }
          return this;
        },
      }),
      (f.buildFragment = function (a, b, d) {
        var e,
          g,
          h,
          i,
          j = a[0];
        b && b[0] && (i = b[0].ownerDocument || b[0]),
          i.createDocumentFragment || (i = c),
          a.length === 1 &&
            typeof j == 'string' &&
            j.length < 512 &&
            i === c &&
            j.charAt(0) === '<' &&
            !be.test(j) &&
            (f.support.checkClone || !bg.test(j)) &&
            !f.support.unknownElems &&
            bf.test(j) &&
            ((g = !0), (h = f.fragments[j]), h && h !== 1 && (e = h)),
          e || ((e = i.createDocumentFragment()), f.clean(a, i, e, d)),
          g && (f.fragments[j] = h ? e : 1);
        return { fragment: e, cacheable: g };
      }),
      (f.fragments = {}),
      f.each(
        {
          appendTo: 'append',
          prependTo: 'prepend',
          insertBefore: 'before',
          insertAfter: 'after',
          replaceAll: 'replaceWith',
        },
        function (a, b) {
          f.fn[a] = function (c) {
            var d = [],
              e = f(c),
              g = this.length === 1 && this[0].parentNode;
            if (g && g.nodeType === 11 && g.childNodes.length === 1 && e.length === 1) {
              e[b](this[0]);
              return this;
            }
            for (var h = 0, i = e.length; h < i; h++) {
              var j = (h > 0 ? this.clone(!0) : this).get();
              f(e[h])[b](j), (d = d.concat(j));
            }
            return this.pushStack(d, a, e.selector);
          };
        },
      ),
      f.extend({
        clone: function (a, b, c) {
          var d = a.cloneNode(!0),
            e,
            g,
            h;
          if (
            (!f.support.noCloneEvent || !f.support.noCloneChecked) &&
            (a.nodeType === 1 || a.nodeType === 11) &&
            !f.isXMLDoc(a)
          ) {
            bn(a, d), (e = bo(a)), (g = bo(d));
            for (h = 0; e[h]; ++h) g[h] && bn(e[h], g[h]);
          }
          if (b) {
            bm(a, d);
            if (c) {
              (e = bo(a)), (g = bo(d));
              for (h = 0; e[h]; ++h) bm(e[h], g[h]);
            }
          }
          e = g = null;
          return d;
        },
        clean: function (a, b, d, e) {
          var g;
          (b = b || c),
            typeof b.createElement == 'undefined' && (b = b.ownerDocument || (b[0] && b[0].ownerDocument) || c);
          var h = [],
            i;
          for (var j = 0, k; (k = a[j]) != null; j++) {
            typeof k == 'number' && (k += '');
            if (!k) continue;
            if (typeof k == 'string')
              if (!bc.test(k)) k = b.createTextNode(k);
              else {
                k = k.replace(_, '<$1></$2>');
                var l = (ba.exec(k) || ['', ''])[1].toLowerCase(),
                  m = bj[l] || bj._default,
                  n = m[0],
                  o = b.createElement('div');
                b === c ? bk.appendChild(o) : X(b).appendChild(o), (o.innerHTML = m[1] + k + m[2]);
                while (n--) o = o.lastChild;
                if (!f.support.tbody) {
                  var p = bb.test(k),
                    q =
                      l === 'table' && !p
                        ? o.firstChild && o.firstChild.childNodes
                        : m[1] === '<table>' && !p
                        ? o.childNodes
                        : [];
                  for (i = q.length - 1; i >= 0; --i)
                    f.nodeName(q[i], 'tbody') && !q[i].childNodes.length && q[i].parentNode.removeChild(q[i]);
                }
                !f.support.leadingWhitespace &&
                  $.test(k) &&
                  o.insertBefore(b.createTextNode($.exec(k)[0]), o.firstChild),
                  (k = o.childNodes);
              }
            var r;
            if (!f.support.appendChecked)
              if (k[0] && typeof (r = k.length) == 'number') for (i = 0; i < r; i++) bq(k[i]);
              else bq(k);
            k.nodeType ? h.push(k) : (h = f.merge(h, k));
          }
          if (d) {
            g = function (a) {
              return !a.type || bh.test(a.type);
            };
            for (j = 0; h[j]; j++)
              if (e && f.nodeName(h[j], 'script') && (!h[j].type || h[j].type.toLowerCase() === 'text/javascript'))
                e.push(h[j].parentNode ? h[j].parentNode.removeChild(h[j]) : h[j]);
              else {
                if (h[j].nodeType === 1) {
                  var s = f.grep(h[j].getElementsByTagName('script'), g);
                  h.splice.apply(h, [j + 1, 0].concat(s));
                }
                d.appendChild(h[j]);
              }
          }
          return h;
        },
        cleanData: function (a) {
          var b,
            c,
            d = f.cache,
            e = f.event.special,
            g = f.support.deleteExpando;
          for (var h = 0, i; (i = a[h]) != null; h++) {
            if (i.nodeName && f.noData[i.nodeName.toLowerCase()]) continue;
            c = i[f.expando];
            if (c) {
              b = d[c];
              if (b && b.events) {
                for (var j in b.events) e[j] ? f.event.remove(i, j) : f.removeEvent(i, j, b.handle);
                b.handle && (b.handle.elem = null);
              }
              g ? delete i[f.expando] : i.removeAttribute && i.removeAttribute(f.expando), delete d[c];
            }
          }
        },
      });
    var bs = /alpha\([^)]*\)/i,
      bt = /opacity=([^)]*)/,
      bu = /([A-Z]|^ms)/g,
      bv = /^-?\d+(?:px)?$/i,
      bw = /^-?\d/,
      bx = /^([\-+])=([\-+.\de]+)/,
      by = { position: 'absolute', visibility: 'hidden', display: 'block' },
      bz = ['Left', 'Right'],
      bA = ['Top', 'Bottom'],
      bB,
      bC,
      bD;
    (f.fn.css = function (a, c) {
      if (arguments.length === 2 && c === b) return this;
      return f.access(this, a, c, !0, function (a, c, d) {
        return d !== b ? f.style(a, c, d) : f.css(a, c);
      });
    }),
      f.extend({
        cssHooks: {
          opacity: {
            get: function (a, b) {
              if (b) {
                var c = bB(a, 'opacity', 'opacity');
                return c === '' ? '1' : c;
              }
              return a.style.opacity;
            },
          },
        },
        cssNumber: {
          fillOpacity: !0,
          fontWeight: !0,
          lineHeight: !0,
          opacity: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
        },
        cssProps: { float: f.support.cssFloat ? 'cssFloat' : 'styleFloat' },
        style: function (a, c, d, e) {
          if (!!a && a.nodeType !== 3 && a.nodeType !== 8 && !!a.style) {
            var g,
              h,
              i = f.camelCase(c),
              j = a.style,
              k = f.cssHooks[i];
            c = f.cssProps[i] || i;
            if (d === b) {
              if (k && 'get' in k && (g = k.get(a, !1, e)) !== b) return g;
              return j[c];
            }
            (h = typeof d),
              h === 'string' &&
                (g = bx.exec(d)) &&
                ((d = +(g[1] + 1) * +g[2] + parseFloat(f.css(a, c))), (h = 'number'));
            if (d == null || (h === 'number' && isNaN(d))) return;
            h === 'number' && !f.cssNumber[i] && (d += 'px');
            if (!k || !('set' in k) || (d = k.set(a, d)) !== b)
              try {
                j[c] = d;
              } catch (l) {}
          }
        },
        css: function (a, c, d) {
          var e, g;
          (c = f.camelCase(c)), (g = f.cssHooks[c]), (c = f.cssProps[c] || c), c === 'cssFloat' && (c = 'float');
          if (g && 'get' in g && (e = g.get(a, !0, d)) !== b) return e;
          if (bB) return bB(a, c);
        },
        swap: function (a, b, c) {
          var d = {};
          for (var e in b) (d[e] = a.style[e]), (a.style[e] = b[e]);
          c.call(a);
          for (e in b) a.style[e] = d[e];
        },
      }),
      (f.curCSS = f.css),
      f.each(['height', 'width'], function (a, b) {
        f.cssHooks[b] = {
          get: function (a, c, d) {
            var e;
            if (c) {
              if (a.offsetWidth !== 0) return bE(a, b, d);
              f.swap(a, by, function () {
                e = bE(a, b, d);
              });
              return e;
            }
          },
          set: function (a, b) {
            if (!bv.test(b)) return b;
            b = parseFloat(b);
            if (b >= 0) return b + 'px';
          },
        };
      }),
      f.support.opacity ||
        (f.cssHooks.opacity = {
          get: function (a, b) {
            return bt.test((b && a.currentStyle ? a.currentStyle.filter : a.style.filter) || '')
              ? parseFloat(RegExp.$1) / 100 + ''
              : b
              ? '1'
              : '';
          },
          set: function (a, b) {
            var c = a.style,
              d = a.currentStyle,
              e = f.isNumeric(b) ? 'alpha(opacity=' + b * 100 + ')' : '',
              g = (d && d.filter) || c.filter || '';
            c.zoom = 1;
            if (b >= 1 && f.trim(g.replace(bs, '')) === '') {
              c.removeAttribute('filter');
              if (d && !d.filter) return;
            }
            c.filter = bs.test(g) ? g.replace(bs, e) : g + ' ' + e;
          },
        }),
      f(function () {
        f.support.reliableMarginRight ||
          (f.cssHooks.marginRight = {
            get: function (a, b) {
              var c;
              f.swap(a, { display: 'inline-block' }, function () {
                b ? (c = bB(a, 'margin-right', 'marginRight')) : (c = a.style.marginRight);
              });
              return c;
            },
          });
      }),
      c.defaultView &&
        c.defaultView.getComputedStyle &&
        (bC = function (a, c) {
          var d, e, g;
          c = c.replace(bu, '-$1').toLowerCase();
          if (!(e = a.ownerDocument.defaultView)) return b;
          if ((g = e.getComputedStyle(a, null)))
            (d = g.getPropertyValue(c)),
              d === '' && !f.contains(a.ownerDocument.documentElement, a) && (d = f.style(a, c));
          return d;
        }),
      c.documentElement.currentStyle &&
        (bD = function (a, b) {
          var c,
            d,
            e,
            f = a.currentStyle && a.currentStyle[b],
            g = a.style;
          f === null && g && (e = g[b]) && (f = e),
            !bv.test(f) &&
              bw.test(f) &&
              ((c = g.left),
              (d = a.runtimeStyle && a.runtimeStyle.left),
              d && (a.runtimeStyle.left = a.currentStyle.left),
              (g.left = b === 'fontSize' ? '1em' : f || 0),
              (f = g.pixelLeft + 'px'),
              (g.left = c),
              d && (a.runtimeStyle.left = d));
          return f === '' ? 'auto' : f;
        }),
      (bB = bC || bD),
      f.expr &&
        f.expr.filters &&
        ((f.expr.filters.hidden = function (a) {
          var b = a.offsetWidth,
            c = a.offsetHeight;
          return (
            (b === 0 && c === 0) ||
            (!f.support.reliableHiddenOffsets && ((a.style && a.style.display) || f.css(a, 'display')) === 'none')
          );
        }),
        (f.expr.filters.visible = function (a) {
          return !f.expr.filters.hidden(a);
        }));
    var bF = /%20/g,
      bG = /\[\]$/,
      bH = /\r?\n/g,
      bI = /#.*$/,
      bJ = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      bK =
        /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,
      bL = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,
      bM = /^(?:GET|HEAD)$/,
      bN = /^\/\//,
      bO = /\?/,
      bP = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
      bQ = /^(?:select|textarea)/i,
      bR = /\s+/,
      bS = /([?&])_=[^&]*/,
      bT = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/,
      bU = f.fn.load,
      bV = {},
      bW = {},
      bX,
      bY,
      bZ = ['*/'] + ['*'];
    try {
      bX = e.href;
    } catch (b$) {
      (bX = c.createElement('a')), (bX.href = ''), (bX = bX.href);
    }
    (bY = bT.exec(bX.toLowerCase()) || []),
      f.fn.extend({
        load: function (a, c, d) {
          if (typeof a != 'string' && bU) return bU.apply(this, arguments);
          if (!this.length) return this;
          var e = a.indexOf(' ');
          if (e >= 0) {
            var g = a.slice(e, a.length);
            a = a.slice(0, e);
          }
          var h = 'GET';
          c &&
            (f.isFunction(c)
              ? ((d = c), (c = b))
              : typeof c == 'object' && ((c = f.param(c, f.ajaxSettings.traditional)), (h = 'POST')));
          var i = this;
          f.ajax({
            url: a,
            type: h,
            dataType: 'html',
            data: c,
            complete: function (a, b, c) {
              (c = a.responseText),
                a.isResolved() &&
                  (a.done(function (a) {
                    c = a;
                  }),
                  i.html(g ? f('<div>').append(c.replace(bP, '')).find(g) : c)),
                d && i.each(d, [c, b, a]);
            },
          });
          return this;
        },
        serialize: function () {
          return f.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            return this.elements ? f.makeArray(this.elements) : this;
          })
            .filter(function () {
              return this.name && !this.disabled && (this.checked || bQ.test(this.nodeName) || bK.test(this.type));
            })
            .map(function (a, b) {
              var c = f(this).val();
              return c == null
                ? null
                : f.isArray(c)
                ? f.map(c, function (a, c) {
                    return { name: b.name, value: a.replace(bH, '\r\n') };
                  })
                : { name: b.name, value: c.replace(bH, '\r\n') };
            })
            .get();
        },
      }),
      f.each('ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend'.split(' '), function (a, b) {
        f.fn[b] = function (a) {
          return this.bind(b, a);
        };
      }),
      f.each(['get', 'post'], function (a, c) {
        f[c] = function (a, d, e, g) {
          f.isFunction(d) && ((g = g || e), (e = d), (d = b));
          return f.ajax({ type: c, url: a, data: d, success: e, dataType: g });
        };
      }),
      f.extend({
        getScript: function (a, c) {
          return f.get(a, b, c, 'script');
        },
        getJSON: function (a, b, c) {
          return f.get(a, b, c, 'json');
        },
        ajaxSetup: function (a, b) {
          b ? cb(a, f.ajaxSettings) : ((b = a), (a = f.ajaxSettings)), cb(a, b);
          return a;
        },
        ajaxSettings: {
          url: bX,
          isLocal: bL.test(bY[1]),
          global: !0,
          type: 'GET',
          contentType: 'application/x-www-form-urlencoded',
          processData: !0,
          async: !0,
          accepts: {
            xml: 'application/xml, text/xml',
            html: 'text/html',
            text: 'text/plain',
            json: 'application/json, text/javascript',
            '*': bZ,
          },
          contents: { xml: /xml/, html: /html/, json: /json/ },
          responseFields: { xml: 'responseXML', text: 'responseText' },
          converters: { '* text': a.String, 'text html': !0, 'text json': f.parseJSON, 'text xml': f.parseXML },
          flatOptions: { context: !0, url: !0 },
        },
        ajaxPrefilter: b_(bV),
        ajaxTransport: b_(bW),
        ajax: function (a, c) {
          function w(a, c, l, m) {
            if (s !== 2) {
              (s = 2), q && clearTimeout(q), (p = b), (n = m || ''), (v.readyState = a > 0 ? 4 : 0);
              var o,
                r,
                u,
                w = c,
                x = l ? cd(d, v, l) : b,
                y,
                z;
              if ((a >= 200 && a < 300) || a === 304) {
                if (d.ifModified) {
                  if ((y = v.getResponseHeader('Last-Modified'))) f.lastModified[k] = y;
                  if ((z = v.getResponseHeader('Etag'))) f.etag[k] = z;
                }
                if (a === 304) (w = 'notmodified'), (o = !0);
                else
                  try {
                    (r = ce(d, x)), (w = 'success'), (o = !0);
                  } catch (A) {
                    (w = 'parsererror'), (u = A);
                  }
              } else {
                u = w;
                if (!w || a) (w = 'error'), a < 0 && (a = 0);
              }
              (v.status = a),
                (v.statusText = '' + (c || w)),
                o ? h.resolveWith(e, [r, w, v]) : h.rejectWith(e, [v, w, u]),
                v.statusCode(j),
                (j = b),
                t && g.trigger('ajax' + (o ? 'Success' : 'Error'), [v, d, o ? r : u]),
                i.fireWith(e, [v, w]),
                t && (g.trigger('ajaxComplete', [v, d]), --f.active || f.event.trigger('ajaxStop'));
            }
          }
          typeof a == 'object' && ((c = a), (a = b)), (c = c || {});
          var d = f.ajaxSetup({}, c),
            e = d.context || d,
            g = e !== d && (e.nodeType || e instanceof f) ? f(e) : f.event,
            h = f.Deferred(),
            i = f.Callbacks('once memory'),
            j = d.statusCode || {},
            k,
            l = {},
            m = {},
            n,
            o,
            p,
            q,
            r,
            s = 0,
            t,
            u,
            v = {
              readyState: 0,
              setRequestHeader: function (a, b) {
                if (!s) {
                  var c = a.toLowerCase();
                  (a = m[c] = m[c] || a), (l[a] = b);
                }
                return this;
              },
              getAllResponseHeaders: function () {
                return s === 2 ? n : null;
              },
              getResponseHeader: function (a) {
                var c;
                if (s === 2) {
                  if (!o) {
                    o = {};
                    while ((c = bJ.exec(n))) o[c[1].toLowerCase()] = c[2];
                  }
                  c = o[a.toLowerCase()];
                }
                return c === b ? null : c;
              },
              overrideMimeType: function (a) {
                s || (d.mimeType = a);
                return this;
              },
              abort: function (a) {
                (a = a || 'abort'), p && p.abort(a), w(0, a);
                return this;
              },
            };
          h.promise(v),
            (v.success = v.done),
            (v.error = v.fail),
            (v.complete = i.add),
            (v.statusCode = function (a) {
              if (a) {
                var b;
                if (s < 2) for (b in a) j[b] = [j[b], a[b]];
                else (b = a[v.status]), v.then(b, b);
              }
              return this;
            }),
            (d.url = ((a || d.url) + '').replace(bI, '').replace(bN, bY[1] + '//')),
            (d.dataTypes = f
              .trim(d.dataType || '*')
              .toLowerCase()
              .split(bR)),
            d.crossDomain == null &&
              ((r = bT.exec(d.url.toLowerCase())),
              (d.crossDomain = !(
                !r ||
                (r[1] == bY[1] &&
                  r[2] == bY[2] &&
                  (r[3] || (r[1] === 'http:' ? 80 : 443)) == (bY[3] || (bY[1] === 'http:' ? 80 : 443)))
              ))),
            d.data && d.processData && typeof d.data != 'string' && (d.data = f.param(d.data, d.traditional)),
            ca(bV, d, c, v);
          if (s === 2) return !1;
          (t = d.global),
            (d.type = d.type.toUpperCase()),
            (d.hasContent = !bM.test(d.type)),
            t && f.active++ === 0 && f.event.trigger('ajaxStart');
          if (!d.hasContent) {
            d.data && ((d.url += (bO.test(d.url) ? '&' : '?') + d.data), delete d.data), (k = d.url);
            if (d.cache === !1) {
              var x = f.now(),
                y = d.url.replace(bS, '$1_=' + x);
              d.url = y + (y === d.url ? (bO.test(d.url) ? '&' : '?') + '_=' + x : '');
            }
          }
          ((d.data && d.hasContent && d.contentType !== !1) || c.contentType) &&
            v.setRequestHeader('Content-Type', d.contentType),
            d.ifModified &&
              ((k = k || d.url),
              f.lastModified[k] && v.setRequestHeader('If-Modified-Since', f.lastModified[k]),
              f.etag[k] && v.setRequestHeader('If-None-Match', f.etag[k])),
            v.setRequestHeader(
              'Accept',
              d.dataTypes[0] && d.accepts[d.dataTypes[0]]
                ? d.accepts[d.dataTypes[0]] + (d.dataTypes[0] !== '*' ? ', ' + bZ + '; q=0.01' : '')
                : d.accepts['*'],
            );
          for (u in d.headers) v.setRequestHeader(u, d.headers[u]);
          if (d.beforeSend && (d.beforeSend.call(e, v, d) === !1 || s === 2)) {
            v.abort();
            return !1;
          }
          for (u in { success: 1, error: 1, complete: 1 }) v[u](d[u]);
          p = ca(bW, d, c, v);
          if (!p) w(-1, 'No Transport');
          else {
            (v.readyState = 1),
              t && g.trigger('ajaxSend', [v, d]),
              d.async &&
                d.timeout > 0 &&
                (q = setTimeout(function () {
                  v.abort('timeout');
                }, d.timeout));
            try {
              (s = 1), p.send(l, w);
            } catch (z) {
              s < 2 ? w(-1, z) : f.error(z);
            }
          }
          return v;
        },
        param: function (a, c) {
          var d = [],
            e = function (a, b) {
              (b = f.isFunction(b) ? b() : b), (d[d.length] = encodeURIComponent(a) + '=' + encodeURIComponent(b));
            };
          c === b && (c = f.ajaxSettings.traditional);
          if (f.isArray(a) || (a.jquery && !f.isPlainObject(a)))
            f.each(a, function () {
              e(this.name, this.value);
            });
          else for (var g in a) cc(g, a[g], c, e);
          return d.join('&').replace(bF, '+');
        },
      }),
      f.extend({ active: 0, lastModified: {}, etag: {} });
    var cf = f.now(),
      cg = /(\=)\?(&|$)|\?\?/i;
    f.ajaxSetup({
      jsonp: 'callback',
      jsonpCallback: function () {
        return f.expando + '_' + cf++;
      },
    }),
      f.ajaxPrefilter('json jsonp', function (b, c, d) {
        var e = b.contentType === 'application/x-www-form-urlencoded' && typeof b.data == 'string';
        if (b.dataTypes[0] === 'jsonp' || (b.jsonp !== !1 && (cg.test(b.url) || (e && cg.test(b.data))))) {
          var g,
            h = (b.jsonpCallback = f.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback),
            i = a[h],
            j = b.url,
            k = b.data,
            l = '$1' + h + '$2';
          b.jsonp !== !1 &&
            ((j = j.replace(cg, l)),
            b.url === j &&
              (e && (k = k.replace(cg, l)), b.data === k && (j += (/\?/.test(j) ? '&' : '?') + b.jsonp + '=' + h))),
            (b.url = j),
            (b.data = k),
            (a[h] = function (a) {
              g = [a];
            }),
            d.always(function () {
              (a[h] = i), g && f.isFunction(i) && a[h](g[0]);
            }),
            (b.converters['script json'] = function () {
              g || f.error(h + ' was not called');
              return g[0];
            }),
            (b.dataTypes[0] = 'json');
          return 'script';
        }
      }),
      f.ajaxSetup({
        accepts: {
          script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
        },
        contents: { script: /javascript|ecmascript/ },
        converters: {
          'text script': function (a) {
            f.globalEval(a);
            return a;
          },
        },
      }),
      f.ajaxPrefilter('script', function (a) {
        a.cache === b && (a.cache = !1), a.crossDomain && ((a.type = 'GET'), (a.global = !1));
      }),
      f.ajaxTransport('script', function (a) {
        if (a.crossDomain) {
          var d,
            e = c.head || c.getElementsByTagName('head')[0] || c.documentElement;
          return {
            send: function (f, g) {
              (d = c.createElement('script')),
                (d.async = 'async'),
                a.scriptCharset && (d.charset = a.scriptCharset),
                (d.src = a.url),
                (d.onload = d.onreadystatechange =
                  function (a, c) {
                    if (c || !d.readyState || /loaded|complete/.test(d.readyState))
                      (d.onload = d.onreadystatechange = null),
                        e && d.parentNode && e.removeChild(d),
                        (d = b),
                        c || g(200, 'success');
                  }),
                e.insertBefore(d, e.firstChild);
            },
            abort: function () {
              d && d.onload(0, 1);
            },
          };
        }
      });
    var ch = a.ActiveXObject
        ? function () {
            for (var a in cj) cj[a](0, 1);
          }
        : !1,
      ci = 0,
      cj;
    (f.ajaxSettings.xhr = a.ActiveXObject
      ? function () {
          return (!this.isLocal && ck()) || cl();
        }
      : ck),
      (function (a) {
        f.extend(f.support, { ajax: !!a, cors: !!a && 'withCredentials' in a });
      })(f.ajaxSettings.xhr()),
      f.support.ajax &&
        f.ajaxTransport(function (c) {
          if (!c.crossDomain || f.support.cors) {
            var d;
            return {
              send: function (e, g) {
                var h = c.xhr(),
                  i,
                  j;
                c.username ? h.open(c.type, c.url, c.async, c.username, c.password) : h.open(c.type, c.url, c.async);
                if (c.xhrFields) for (j in c.xhrFields) h[j] = c.xhrFields[j];
                c.mimeType && h.overrideMimeType && h.overrideMimeType(c.mimeType),
                  !c.crossDomain && !e['X-Requested-With'] && (e['X-Requested-With'] = 'XMLHttpRequest');
                try {
                  for (j in e) h.setRequestHeader(j, e[j]);
                } catch (k) {}
                h.send((c.hasContent && c.data) || null),
                  (d = function (a, e) {
                    var j, k, l, m, n;
                    try {
                      if (d && (e || h.readyState === 4)) {
                        (d = b), i && ((h.onreadystatechange = f.noop), ch && delete cj[i]);
                        if (e) h.readyState !== 4 && h.abort();
                        else {
                          (j = h.status),
                            (l = h.getAllResponseHeaders()),
                            (m = {}),
                            (n = h.responseXML),
                            n && n.documentElement && (m.xml = n),
                            (m.text = h.responseText);
                          try {
                            k = h.statusText;
                          } catch (o) {
                            k = '';
                          }
                          !j && c.isLocal && !c.crossDomain ? (j = m.text ? 200 : 404) : j === 1223 && (j = 204);
                        }
                      }
                    } catch (p) {
                      e || g(-1, p);
                    }
                    m && g(j, k, m, l);
                  }),
                  !c.async || h.readyState === 4
                    ? d()
                    : ((i = ++ci), ch && (cj || ((cj = {}), f(a).unload(ch)), (cj[i] = d)), (h.onreadystatechange = d));
              },
              abort: function () {
                d && d(0, 1);
              },
            };
          }
        });
    var cm = {},
      cn,
      co,
      cp = /^(?:toggle|show|hide)$/,
      cq = /^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i,
      cr,
      cs = [
        ['height', 'marginTop', 'marginBottom', 'paddingTop', 'paddingBottom'],
        ['width', 'marginLeft', 'marginRight', 'paddingLeft', 'paddingRight'],
        ['opacity'],
      ],
      ct;
    f.fn.extend({
      show: function (a, b, c) {
        var d, e;
        if (a || a === 0) return this.animate(cw('show', 3), a, b, c);
        for (var g = 0, h = this.length; g < h; g++)
          (d = this[g]),
            d.style &&
              ((e = d.style.display),
              !f._data(d, 'olddisplay') && e === 'none' && (e = d.style.display = ''),
              e === '' && f.css(d, 'display') === 'none' && f._data(d, 'olddisplay', cx(d.nodeName)));
        for (g = 0; g < h; g++) {
          d = this[g];
          if (d.style) {
            e = d.style.display;
            if (e === '' || e === 'none') d.style.display = f._data(d, 'olddisplay') || '';
          }
        }
        return this;
      },
      hide: function (a, b, c) {
        if (a || a === 0) return this.animate(cw('hide', 3), a, b, c);
        var d,
          e,
          g = 0,
          h = this.length;
        for (; g < h; g++)
          (d = this[g]),
            d.style &&
              ((e = f.css(d, 'display')), e !== 'none' && !f._data(d, 'olddisplay') && f._data(d, 'olddisplay', e));
        for (g = 0; g < h; g++) this[g].style && (this[g].style.display = 'none');
        return this;
      },
      _toggle: f.fn.toggle,
      toggle: function (a, b, c) {
        var d = typeof a == 'boolean';
        f.isFunction(a) && f.isFunction(b)
          ? this._toggle.apply(this, arguments)
          : a == null || d
          ? this.each(function () {
              var b = d ? a : f(this).is(':hidden');
              f(this)[b ? 'show' : 'hide']();
            })
          : this.animate(cw('toggle', 3), a, b, c);
        return this;
      },
      fadeTo: function (a, b, c, d) {
        return this.filter(':hidden').css('opacity', 0).show().end().animate({ opacity: b }, a, c, d);
      },
      animate: function (a, b, c, d) {
        function g() {
          e.queue === !1 && f._mark(this);
          var b = f.extend({}, e),
            c = this.nodeType === 1,
            d = c && f(this).is(':hidden'),
            g,
            h,
            i,
            j,
            k,
            l,
            m,
            n,
            o;
          b.animatedProperties = {};
          for (i in a) {
            (g = f.camelCase(i)),
              i !== g && ((a[g] = a[i]), delete a[i]),
              (h = a[g]),
              f.isArray(h)
                ? ((b.animatedProperties[g] = h[1]), (h = a[g] = h[0]))
                : (b.animatedProperties[g] = (b.specialEasing && b.specialEasing[g]) || b.easing || 'swing');
            if ((h === 'hide' && d) || (h === 'show' && !d)) return b.complete.call(this);
            c &&
              (g === 'height' || g === 'width') &&
              ((b.overflow = [this.style.overflow, this.style.overflowX, this.style.overflowY]),
              f.css(this, 'display') === 'inline' &&
                f.css(this, 'float') === 'none' &&
                (!f.support.inlineBlockNeedsLayout || cx(this.nodeName) === 'inline'
                  ? (this.style.display = 'inline-block')
                  : (this.style.zoom = 1)));
          }
          b.overflow != null && (this.style.overflow = 'hidden');
          for (i in a)
            (j = new f.fx(this, b, i)),
              (h = a[i]),
              cp.test(h)
                ? ((o = f._data(this, 'toggle' + i) || (h === 'toggle' ? (d ? 'show' : 'hide') : 0)),
                  o ? (f._data(this, 'toggle' + i, o === 'show' ? 'hide' : 'show'), j[o]()) : j[h]())
                : ((k = cq.exec(h)),
                  (l = j.cur()),
                  k
                    ? ((m = parseFloat(k[2])),
                      (n = k[3] || (f.cssNumber[i] ? '' : 'px')),
                      n !== 'px' &&
                        (f.style(this, i, (m || 1) + n), (l = ((m || 1) / j.cur()) * l), f.style(this, i, l + n)),
                      k[1] && (m = (k[1] === '-=' ? -1 : 1) * m + l),
                      j.custom(l, m, n))
                    : j.custom(l, h, ''));
          return !0;
        }
        var e = f.speed(b, c, d);
        if (f.isEmptyObject(a)) return this.each(e.complete, [!1]);
        a = f.extend({}, a);
        return e.queue === !1 ? this.each(g) : this.queue(e.queue, g);
      },
      stop: function (a, c, d) {
        typeof a != 'string' && ((d = c), (c = a), (a = b)), c && a !== !1 && this.queue(a || 'fx', []);
        return this.each(function () {
          function h(a, b, c) {
            var e = b[c];
            f.removeData(a, c, !0), e.stop(d);
          }
          var b,
            c = !1,
            e = f.timers,
            g = f._data(this);
          d || f._unmark(!0, this);
          if (a == null) for (b in g) g[b].stop && b.indexOf('.run') === b.length - 4 && h(this, g, b);
          else g[(b = a + '.run')] && g[b].stop && h(this, g, b);
          for (b = e.length; b--; )
            e[b].elem === this &&
              (a == null || e[b].queue === a) &&
              (d ? e[b](!0) : e[b].saveState(), (c = !0), e.splice(b, 1));
          (!d || !c) && f.dequeue(this, a);
        });
      },
    }),
      f.each(
        {
          slideDown: cw('show', 1),
          slideUp: cw('hide', 1),
          slideToggle: cw('toggle', 1),
          fadeIn: { opacity: 'show' },
          fadeOut: { opacity: 'hide' },
          fadeToggle: { opacity: 'toggle' },
        },
        function (a, b) {
          f.fn[a] = function (a, c, d) {
            return this.animate(b, a, c, d);
          };
        },
      ),
      f.extend({
        speed: function (a, b, c) {
          var d =
            a && typeof a == 'object'
              ? f.extend({}, a)
              : {
                  complete: c || (!c && b) || (f.isFunction(a) && a),
                  duration: a,
                  easing: (c && b) || (b && !f.isFunction(b) && b),
                };
          d.duration = f.fx.off
            ? 0
            : typeof d.duration == 'number'
            ? d.duration
            : d.duration in f.fx.speeds
            ? f.fx.speeds[d.duration]
            : f.fx.speeds._default;
          if (d.queue == null || d.queue === !0) d.queue = 'fx';
          (d.old = d.complete),
            (d.complete = function (a) {
              f.isFunction(d.old) && d.old.call(this), d.queue ? f.dequeue(this, d.queue) : a !== !1 && f._unmark(this);
            });
          return d;
        },
        easing: {
          linear: function (a, b, c, d) {
            return c + d * a;
          },
          swing: function (a, b, c, d) {
            return (-Math.cos(a * Math.PI) / 2 + 0.5) * d + c;
          },
        },
        timers: [],
        fx: function (a, b, c) {
          (this.options = b), (this.elem = a), (this.prop = c), (b.orig = b.orig || {});
        },
      }),
      (f.fx.prototype = {
        update: function () {
          this.options.step && this.options.step.call(this.elem, this.now, this),
            (f.fx.step[this.prop] || f.fx.step._default)(this);
        },
        cur: function () {
          if (this.elem[this.prop] != null && (!this.elem.style || this.elem.style[this.prop] == null))
            return this.elem[this.prop];
          var a,
            b = f.css(this.elem, this.prop);
          return isNaN((a = parseFloat(b))) ? (!b || b === 'auto' ? 0 : b) : a;
        },
        custom: function (a, c, d) {
          function h(a) {
            return e.step(a);
          }
          var e = this,
            g = f.fx;
          (this.startTime = ct || cu()),
            (this.end = c),
            (this.now = this.start = a),
            (this.pos = this.state = 0),
            (this.unit = d || this.unit || (f.cssNumber[this.prop] ? '' : 'px')),
            (h.queue = this.options.queue),
            (h.elem = this.elem),
            (h.saveState = function () {
              e.options.hide && f._data(e.elem, 'fxshow' + e.prop) === b && f._data(e.elem, 'fxshow' + e.prop, e.start);
            }),
            h() && f.timers.push(h) && !cr && (cr = setInterval(g.tick, g.interval));
        },
        show: function () {
          var a = f._data(this.elem, 'fxshow' + this.prop);
          (this.options.orig[this.prop] = a || f.style(this.elem, this.prop)),
            (this.options.show = !0),
            a !== b
              ? this.custom(this.cur(), a)
              : this.custom(this.prop === 'width' || this.prop === 'height' ? 1 : 0, this.cur()),
            f(this.elem).show();
        },
        hide: function () {
          (this.options.orig[this.prop] = f._data(this.elem, 'fxshow' + this.prop) || f.style(this.elem, this.prop)),
            (this.options.hide = !0),
            this.custom(this.cur(), 0);
        },
        step: function (a) {
          var b,
            c,
            d,
            e = ct || cu(),
            g = !0,
            h = this.elem,
            i = this.options;
          if (a || e >= i.duration + this.startTime) {
            (this.now = this.end), (this.pos = this.state = 1), this.update(), (i.animatedProperties[this.prop] = !0);
            for (b in i.animatedProperties) i.animatedProperties[b] !== !0 && (g = !1);
            if (g) {
              i.overflow != null &&
                !f.support.shrinkWrapBlocks &&
                f.each(['', 'X', 'Y'], function (a, b) {
                  h.style['overflow' + b] = i.overflow[a];
                }),
                i.hide && f(h).hide();
              if (i.hide || i.show)
                for (b in i.animatedProperties)
                  f.style(h, b, i.orig[b]), f.removeData(h, 'fxshow' + b, !0), f.removeData(h, 'toggle' + b, !0);
              (d = i.complete), d && ((i.complete = !1), d.call(h));
            }
            return !1;
          }
          i.duration == Infinity
            ? (this.now = e)
            : ((c = e - this.startTime),
              (this.state = c / i.duration),
              (this.pos = f.easing[i.animatedProperties[this.prop]](this.state, c, 0, 1, i.duration)),
              (this.now = this.start + (this.end - this.start) * this.pos)),
            this.update();
          return !0;
        },
      }),
      f.extend(f.fx, {
        tick: function () {
          var a,
            b = f.timers,
            c = 0;
          for (; c < b.length; c++) (a = b[c]), !a() && b[c] === a && b.splice(c--, 1);
          b.length || f.fx.stop();
        },
        interval: 13,
        stop: function () {
          clearInterval(cr), (cr = null);
        },
        speeds: { slow: 600, fast: 200, _default: 400 },
        step: {
          opacity: function (a) {
            f.style(a.elem, 'opacity', a.now);
          },
          _default: function (a) {
            a.elem.style && a.elem.style[a.prop] != null
              ? (a.elem.style[a.prop] = a.now + a.unit)
              : (a.elem[a.prop] = a.now);
          },
        },
      }),
      f.each(['width', 'height'], function (a, b) {
        f.fx.step[b] = function (a) {
          f.style(a.elem, b, Math.max(0, a.now));
        };
      }),
      f.expr &&
        f.expr.filters &&
        (f.expr.filters.animated = function (a) {
          return f.grep(f.timers, function (b) {
            return a === b.elem;
          }).length;
        });
    var cy = /^t(?:able|d|h)$/i,
      cz = /^(?:body|html)$/i;
    'getBoundingClientRect' in c.documentElement
      ? (f.fn.offset = function (a) {
          var b = this[0],
            c;
          if (a)
            return this.each(function (b) {
              f.offset.setOffset(this, a, b);
            });
          if (!b || !b.ownerDocument) return null;
          if (b === b.ownerDocument.body) return f.offset.bodyOffset(b);
          try {
            c = b.getBoundingClientRect();
          } catch (d) {}
          var e = b.ownerDocument,
            g = e.documentElement;
          if (!c || !f.contains(g, b)) return c ? { top: c.top, left: c.left } : { top: 0, left: 0 };
          var h = e.body,
            i = cA(e),
            j = g.clientTop || h.clientTop || 0,
            k = g.clientLeft || h.clientLeft || 0,
            l = i.pageYOffset || (f.support.boxModel && g.scrollTop) || h.scrollTop,
            m = i.pageXOffset || (f.support.boxModel && g.scrollLeft) || h.scrollLeft,
            n = c.top + l - j,
            o = c.left + m - k;
          return { top: n, left: o };
        })
      : (f.fn.offset = function (a) {
          var b = this[0];
          if (a)
            return this.each(function (b) {
              f.offset.setOffset(this, a, b);
            });
          if (!b || !b.ownerDocument) return null;
          if (b === b.ownerDocument.body) return f.offset.bodyOffset(b);
          var c,
            d = b.offsetParent,
            e = b,
            g = b.ownerDocument,
            h = g.documentElement,
            i = g.body,
            j = g.defaultView,
            k = j ? j.getComputedStyle(b, null) : b.currentStyle,
            l = b.offsetTop,
            m = b.offsetLeft;
          while ((b = b.parentNode) && b !== i && b !== h) {
            if (f.support.fixedPosition && k.position === 'fixed') break;
            (c = j ? j.getComputedStyle(b, null) : b.currentStyle),
              (l -= b.scrollTop),
              (m -= b.scrollLeft),
              b === d &&
                ((l += b.offsetTop),
                (m += b.offsetLeft),
                f.support.doesNotAddBorder &&
                  (!f.support.doesAddBorderForTableAndCells || !cy.test(b.nodeName)) &&
                  ((l += parseFloat(c.borderTopWidth) || 0), (m += parseFloat(c.borderLeftWidth) || 0)),
                (e = d),
                (d = b.offsetParent)),
              f.support.subtractsBorderForOverflowNotVisible &&
                c.overflow !== 'visible' &&
                ((l += parseFloat(c.borderTopWidth) || 0), (m += parseFloat(c.borderLeftWidth) || 0)),
              (k = c);
          }
          if (k.position === 'relative' || k.position === 'static') (l += i.offsetTop), (m += i.offsetLeft);
          f.support.fixedPosition &&
            k.position === 'fixed' &&
            ((l += Math.max(h.scrollTop, i.scrollTop)), (m += Math.max(h.scrollLeft, i.scrollLeft)));
          return { top: l, left: m };
        }),
      (f.offset = {
        bodyOffset: function (a) {
          var b = a.offsetTop,
            c = a.offsetLeft;
          f.support.doesNotIncludeMarginInBodyOffset &&
            ((b += parseFloat(f.css(a, 'marginTop')) || 0), (c += parseFloat(f.css(a, 'marginLeft')) || 0));
          return { top: b, left: c };
        },
        setOffset: function (a, b, c) {
          var d = f.css(a, 'position');
          d === 'static' && (a.style.position = 'relative');
          var e = f(a),
            g = e.offset(),
            h = f.css(a, 'top'),
            i = f.css(a, 'left'),
            j = (d === 'absolute' || d === 'fixed') && f.inArray('auto', [h, i]) > -1,
            k = {},
            l = {},
            m,
            n;
          j ? ((l = e.position()), (m = l.top), (n = l.left)) : ((m = parseFloat(h) || 0), (n = parseFloat(i) || 0)),
            f.isFunction(b) && (b = b.call(a, c, g)),
            b.top != null && (k.top = b.top - g.top + m),
            b.left != null && (k.left = b.left - g.left + n),
            'using' in b ? b.using.call(a, k) : e.css(k);
        },
      }),
      f.fn.extend({
        position: function () {
          if (!this[0]) return null;
          var a = this[0],
            b = this.offsetParent(),
            c = this.offset(),
            d = cz.test(b[0].nodeName) ? { top: 0, left: 0 } : b.offset();
          (c.top -= parseFloat(f.css(a, 'marginTop')) || 0),
            (c.left -= parseFloat(f.css(a, 'marginLeft')) || 0),
            (d.top += parseFloat(f.css(b[0], 'borderTopWidth')) || 0),
            (d.left += parseFloat(f.css(b[0], 'borderLeftWidth')) || 0);
          return { top: c.top - d.top, left: c.left - d.left };
        },
        offsetParent: function () {
          return this.map(function () {
            var a = this.offsetParent || c.body;
            while (a && !cz.test(a.nodeName) && f.css(a, 'position') === 'static') a = a.offsetParent;
            return a;
          });
        },
      }),
      f.each(['Left', 'Top'], function (a, c) {
        var d = 'scroll' + c;
        f.fn[d] = function (c) {
          var e, g;
          if (c === b) {
            e = this[0];
            if (!e) return null;
            g = cA(e);
            return g
              ? 'pageXOffset' in g
                ? g[a ? 'pageYOffset' : 'pageXOffset']
                : (f.support.boxModel && g.document.documentElement[d]) || g.document.body[d]
              : e[d];
          }
          return this.each(function () {
            (g = cA(this)), g ? g.scrollTo(a ? f(g).scrollLeft() : c, a ? c : f(g).scrollTop()) : (this[d] = c);
          });
        };
      }),
      f.each(['Height', 'Width'], function (a, c) {
        var d = c.toLowerCase();
        (f.fn['inner' + c] = function () {
          var a = this[0];
          return a ? (a.style ? parseFloat(f.css(a, d, 'padding')) : this[d]()) : null;
        }),
          (f.fn['outer' + c] = function (a) {
            var b = this[0];
            return b ? (b.style ? parseFloat(f.css(b, d, a ? 'margin' : 'border')) : this[d]()) : null;
          }),
          (f.fn[d] = function (a) {
            var e = this[0];
            if (!e) return a == null ? null : this;
            if (f.isFunction(a))
              return this.each(function (b) {
                var c = f(this);
                c[d](a.call(this, b, c[d]()));
              });
            if (f.isWindow(e)) {
              var g = e.document.documentElement['client' + c],
                h = e.document.body;
              return (e.document.compatMode === 'CSS1Compat' && g) || (h && h['client' + c]) || g;
            }
            if (e.nodeType === 9)
              return Math.max(
                e.documentElement['client' + c],
                e.body['scroll' + c],
                e.documentElement['scroll' + c],
                e.body['offset' + c],
                e.documentElement['offset' + c],
              );
            if (a === b) {
              var i = f.css(e, d),
                j = parseFloat(i);
              return f.isNumeric(j) ? j : i;
            }
            return this.css(d, typeof a == 'string' ? a : a + 'px');
          });
      }),
      (a.jQuery = a.$ = f);
  })(window);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.core.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    function c(b, c) {
      var e = b.nodeName.toLowerCase();
      if ('area' === e) {
        var f = b.parentNode,
          g = f.name,
          h;
        return !b.href || !g || f.nodeName.toLowerCase() !== 'map'
          ? !1
          : ((h = a('img[usemap=#' + g + ']')[0]), !!h && d(h));
      }
      return (/input|select|textarea|button|object/.test(e) ? !b.disabled : 'a' == e ? b.href || c : c) && d(b);
    }
    function d(b) {
      return !a(b)
        .parents()
        .andSelf()
        .filter(function () {
          return a.curCSS(this, 'visibility') === 'hidden' || a.expr.filters.hidden(this);
        }).length;
    }
    a.ui = a.ui || {};
    if (a.ui.version) return;
    a.extend(a.ui, {
      version: '1.8.24',
      keyCode: {
        ALT: 18,
        BACKSPACE: 8,
        CAPS_LOCK: 20,
        COMMA: 188,
        COMMAND: 91,
        COMMAND_LEFT: 91,
        COMMAND_RIGHT: 93,
        CONTROL: 17,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        INSERT: 45,
        LEFT: 37,
        MENU: 93,
        NUMPAD_ADD: 107,
        NUMPAD_DECIMAL: 110,
        NUMPAD_DIVIDE: 111,
        NUMPAD_ENTER: 108,
        NUMPAD_MULTIPLY: 106,
        NUMPAD_SUBTRACT: 109,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SHIFT: 16,
        SPACE: 32,
        TAB: 9,
        UP: 38,
        WINDOWS: 91,
      },
    }),
      a.fn.extend({
        propAttr: a.fn.prop || a.fn.attr,
        _focus: a.fn.focus,
        focus: function (b, c) {
          return typeof b == 'number'
            ? this.each(function () {
                var d = this;
                setTimeout(function () {
                  a(d).focus(), c && c.call(d);
                }, b);
              })
            : this._focus.apply(this, arguments);
        },
        scrollParent: function () {
          var b;
          return (
            (a.browser.msie && /(static|relative)/.test(this.css('position'))) || /absolute/.test(this.css('position'))
              ? (b = this.parents()
                  .filter(function () {
                    return (
                      /(relative|absolute|fixed)/.test(a.curCSS(this, 'position', 1)) &&
                      /(auto|scroll)/.test(
                        a.curCSS(this, 'overflow', 1) +
                          a.curCSS(this, 'overflow-y', 1) +
                          a.curCSS(this, 'overflow-x', 1),
                      )
                    );
                  })
                  .eq(0))
              : (b = this.parents()
                  .filter(function () {
                    return /(auto|scroll)/.test(
                      a.curCSS(this, 'overflow', 1) + a.curCSS(this, 'overflow-y', 1) + a.curCSS(this, 'overflow-x', 1),
                    );
                  })
                  .eq(0)),
            /fixed/.test(this.css('position')) || !b.length ? a(document) : b
          );
        },
        zIndex: function (c) {
          if (c !== b) return this.css('zIndex', c);
          if (this.length) {
            var d = a(this[0]),
              e,
              f;
            while (d.length && d[0] !== document) {
              e = d.css('position');
              if (e === 'absolute' || e === 'relative' || e === 'fixed') {
                f = parseInt(d.css('zIndex'), 10);
                if (!isNaN(f) && f !== 0) return f;
              }
              d = d.parent();
            }
          }
          return 0;
        },
        disableSelection: function () {
          return this.bind(
            (a.support.selectstart ? 'selectstart' : 'mousedown') + '.ui-disableSelection',
            function (a) {
              a.preventDefault();
            },
          );
        },
        enableSelection: function () {
          return this.unbind('.ui-disableSelection');
        },
      }),
      a('<a>').outerWidth(1).jquery ||
        a.each(['Width', 'Height'], function (c, d) {
          function h(b, c, d, f) {
            return (
              a.each(e, function () {
                (c -= parseFloat(a.curCSS(b, 'padding' + this, !0)) || 0),
                  d && (c -= parseFloat(a.curCSS(b, 'border' + this + 'Width', !0)) || 0),
                  f && (c -= parseFloat(a.curCSS(b, 'margin' + this, !0)) || 0);
              }),
              c
            );
          }
          var e = d === 'Width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
            f = d.toLowerCase(),
            g = {
              innerWidth: a.fn.innerWidth,
              innerHeight: a.fn.innerHeight,
              outerWidth: a.fn.outerWidth,
              outerHeight: a.fn.outerHeight,
            };
          (a.fn['inner' + d] = function (c) {
            return c === b
              ? g['inner' + d].call(this)
              : this.each(function () {
                  a(this).css(f, h(this, c) + 'px');
                });
          }),
            (a.fn['outer' + d] = function (b, c) {
              return typeof b != 'number'
                ? g['outer' + d].call(this, b)
                : this.each(function () {
                    a(this).css(f, h(this, b, !0, c) + 'px');
                  });
            });
        }),
      a.extend(a.expr[':'], {
        data: a.expr.createPseudo
          ? a.expr.createPseudo(function (b) {
              return function (c) {
                return !!a.data(c, b);
              };
            })
          : function (b, c, d) {
              return !!a.data(b, d[3]);
            },
        focusable: function (b) {
          return c(b, !isNaN(a.attr(b, 'tabindex')));
        },
        tabbable: function (b) {
          var d = a.attr(b, 'tabindex'),
            e = isNaN(d);
          return (e || d >= 0) && c(b, !e);
        },
      }),
      a(function () {
        var b = document.body,
          c = b.appendChild((c = document.createElement('div')));
        c.offsetHeight,
          a.extend(c.style, { minHeight: '100px', height: 'auto', padding: 0, borderWidth: 0 }),
          (a.support.minHeight = c.offsetHeight === 100),
          (a.support.selectstart = 'onselectstart' in c),
          (b.removeChild(c).style.display = 'none');
      }),
      a.curCSS || (a.curCSS = a.css),
      a.extend(a.ui, {
        plugin: {
          add: function (b, c, d) {
            var e = a.ui[b].prototype;
            for (var f in d) (e.plugins[f] = e.plugins[f] || []), e.plugins[f].push([c, d[f]]);
          },
          call: function (a, b, c) {
            var d = a.plugins[b];
            if (!d || !a.element[0].parentNode) return;
            for (var e = 0; e < d.length; e++) a.options[d[e][0]] && d[e][1].apply(a.element, c);
          },
        },
        contains: function (a, b) {
          return document.compareDocumentPosition ? a.compareDocumentPosition(b) & 16 : a !== b && a.contains(b);
        },
        hasScroll: function (b, c) {
          if (a(b).css('overflow') === 'hidden') return !1;
          var d = c && c === 'left' ? 'scrollLeft' : 'scrollTop',
            e = !1;
          return b[d] > 0 ? !0 : ((b[d] = 1), (e = b[d] > 0), (b[d] = 0), e);
        },
        isOverAxis: function (a, b, c) {
          return a > b && a < b + c;
        },
        isOver: function (b, c, d, e, f, g) {
          return a.ui.isOverAxis(b, d, f) && a.ui.isOverAxis(c, e, g);
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.widget.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    if (a.cleanData) {
      var c = a.cleanData;
      a.cleanData = function (b) {
        for (var d = 0, e; (e = b[d]) != null; d++)
          try {
            a(e).triggerHandler('remove');
          } catch (f) {}
        c(b);
      };
    } else {
      var d = a.fn.remove;
      a.fn.remove = function (b, c) {
        return this.each(function () {
          return (
            c ||
              ((!b || a.filter(b, [this]).length) &&
                a('*', this)
                  .add([this])
                  .each(function () {
                    try {
                      a(this).triggerHandler('remove');
                    } catch (b) {}
                  })),
            d.call(a(this), b, c)
          );
        });
      };
    }
    (a.widget = function (b, c, d) {
      var e = b.split('.')[0],
        f;
      (b = b.split('.')[1]),
        (f = e + '-' + b),
        d || ((d = c), (c = a.Widget)),
        (a.expr[':'][f] = function (c) {
          return !!a.data(c, b);
        }),
        (a[e] = a[e] || {}),
        (a[e][b] = function (a, b) {
          arguments.length && this._createWidget(a, b);
        });
      var g = new c();
      (g.options = a.extend(!0, {}, g.options)),
        (a[e][b].prototype = a.extend(
          !0,
          g,
          {
            namespace: e,
            widgetName: b,
            widgetEventPrefix: a[e][b].prototype.widgetEventPrefix || b,
            widgetBaseClass: f,
          },
          d,
        )),
        a.widget.bridge(b, a[e][b]);
    }),
      (a.widget.bridge = function (c, d) {
        a.fn[c] = function (e) {
          var f = typeof e == 'string',
            g = Array.prototype.slice.call(arguments, 1),
            h = this;
          return (
            (e = !f && g.length ? a.extend.apply(null, [!0, e].concat(g)) : e),
            f && e.charAt(0) === '_'
              ? h
              : (f
                  ? this.each(function () {
                      var d = a.data(this, c),
                        f = d && a.isFunction(d[e]) ? d[e].apply(d, g) : d;
                      if (f !== d && f !== b) return (h = f), !1;
                    })
                  : this.each(function () {
                      var b = a.data(this, c);
                      b ? b.option(e || {})._init() : a.data(this, c, new d(e, this));
                    }),
                h)
          );
        };
      }),
      (a.Widget = function (a, b) {
        arguments.length && this._createWidget(a, b);
      }),
      (a.Widget.prototype = {
        widgetName: 'widget',
        widgetEventPrefix: '',
        options: { disabled: !1 },
        _createWidget: function (b, c) {
          a.data(c, this.widgetName, this),
            (this.element = a(c)),
            (this.options = a.extend(!0, {}, this.options, this._getCreateOptions(), b));
          var d = this;
          this.element.bind('remove.' + this.widgetName, function () {
            d.destroy();
          }),
            this._create(),
            this._trigger('create'),
            this._init();
        },
        _getCreateOptions: function () {
          return a.metadata && a.metadata.get(this.element[0])[this.widgetName];
        },
        _create: function () {},
        _init: function () {},
        destroy: function () {
          this.element.unbind('.' + this.widgetName).removeData(this.widgetName),
            this.widget()
              .unbind('.' + this.widgetName)
              .removeAttr('aria-disabled')
              .removeClass(this.widgetBaseClass + '-disabled ' + 'ui-state-disabled');
        },
        widget: function () {
          return this.element;
        },
        option: function (c, d) {
          var e = c;
          if (arguments.length === 0) return a.extend({}, this.options);
          if (typeof c == 'string') {
            if (d === b) return this.options[c];
            (e = {}), (e[c] = d);
          }
          return this._setOptions(e), this;
        },
        _setOptions: function (b) {
          var c = this;
          return (
            a.each(b, function (a, b) {
              c._setOption(a, b);
            }),
            this
          );
        },
        _setOption: function (a, b) {
          return (
            (this.options[a] = b),
            a === 'disabled' &&
              this.widget()
                [b ? 'addClass' : 'removeClass'](this.widgetBaseClass + '-disabled' + ' ' + 'ui-state-disabled')
                .attr('aria-disabled', b),
            this
          );
        },
        enable: function () {
          return this._setOption('disabled', !1);
        },
        disable: function () {
          return this._setOption('disabled', !0);
        },
        _trigger: function (b, c, d) {
          var e,
            f,
            g = this.options[b];
          (d = d || {}),
            (c = a.Event(c)),
            (c.type = (b === this.widgetEventPrefix ? b : this.widgetEventPrefix + b).toLowerCase()),
            (c.target = this.element[0]),
            (f = c.originalEvent);
          if (f) for (e in f) e in c || (c[e] = f[e]);
          return (
            this.element.trigger(c, d),
            !((a.isFunction(g) && g.call(this.element[0], c, d) === !1) || c.isDefaultPrevented())
          );
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.mouse.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    var c = !1;
    a(document).mouseup(function (a) {
      c = !1;
    }),
      a.widget('ui.mouse', {
        options: { cancel: ':input,option', distance: 1, delay: 0 },
        _mouseInit: function () {
          var b = this;
          this.element
            .bind('mousedown.' + this.widgetName, function (a) {
              return b._mouseDown(a);
            })
            .bind('click.' + this.widgetName, function (c) {
              if (!0 === a.data(c.target, b.widgetName + '.preventClickEvent'))
                return a.removeData(c.target, b.widgetName + '.preventClickEvent'), c.stopImmediatePropagation(), !1;
            }),
            (this.started = !1);
        },
        _mouseDestroy: function () {
          this.element.unbind('.' + this.widgetName),
            this._mouseMoveDelegate &&
              a(document)
                .unbind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
                .unbind('mouseup.' + this.widgetName, this._mouseUpDelegate);
        },
        _mouseDown: function (b) {
          if (c) return;
          this._mouseStarted && this._mouseUp(b), (this._mouseDownEvent = b);
          var d = this,
            e = b.which == 1,
            f =
              typeof this.options.cancel == 'string' && b.target.nodeName
                ? a(b.target).closest(this.options.cancel).length
                : !1;
          if (!e || f || !this._mouseCapture(b)) return !0;
          (this.mouseDelayMet = !this.options.delay),
            this.mouseDelayMet ||
              (this._mouseDelayTimer = setTimeout(function () {
                d.mouseDelayMet = !0;
              }, this.options.delay));
          if (this._mouseDistanceMet(b) && this._mouseDelayMet(b)) {
            this._mouseStarted = this._mouseStart(b) !== !1;
            if (!this._mouseStarted) return b.preventDefault(), !0;
          }
          return (
            !0 === a.data(b.target, this.widgetName + '.preventClickEvent') &&
              a.removeData(b.target, this.widgetName + '.preventClickEvent'),
            (this._mouseMoveDelegate = function (a) {
              return d._mouseMove(a);
            }),
            (this._mouseUpDelegate = function (a) {
              return d._mouseUp(a);
            }),
            a(document)
              .bind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
              .bind('mouseup.' + this.widgetName, this._mouseUpDelegate),
            b.preventDefault(),
            (c = !0),
            !0
          );
        },
        _mouseMove: function (b) {
          return !a.browser.msie || document.documentMode >= 9 || !!b.button
            ? this._mouseStarted
              ? (this._mouseDrag(b), b.preventDefault())
              : (this._mouseDistanceMet(b) &&
                  this._mouseDelayMet(b) &&
                  ((this._mouseStarted = this._mouseStart(this._mouseDownEvent, b) !== !1),
                  this._mouseStarted ? this._mouseDrag(b) : this._mouseUp(b)),
                !this._mouseStarted)
            : this._mouseUp(b);
        },
        _mouseUp: function (b) {
          return (
            a(document)
              .unbind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
              .unbind('mouseup.' + this.widgetName, this._mouseUpDelegate),
            this._mouseStarted &&
              ((this._mouseStarted = !1),
              b.target == this._mouseDownEvent.target && a.data(b.target, this.widgetName + '.preventClickEvent', !0),
              this._mouseStop(b)),
            !1
          );
        },
        _mouseDistanceMet: function (a) {
          return (
            Math.max(Math.abs(this._mouseDownEvent.pageX - a.pageX), Math.abs(this._mouseDownEvent.pageY - a.pageY)) >=
            this.options.distance
          );
        },
        _mouseDelayMet: function (a) {
          return this.mouseDelayMet;
        },
        _mouseStart: function (a) {},
        _mouseDrag: function (a) {},
        _mouseStop: function (a) {},
        _mouseCapture: function (a) {
          return !0;
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.position.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.ui = a.ui || {};
    var c = /left|center|right/,
      d = /top|center|bottom/,
      e = 'center',
      f = {},
      g = a.fn.position,
      h = a.fn.offset;
    (a.fn.position = function (b) {
      if (!b || !b.of) return g.apply(this, arguments);
      b = a.extend({}, b);
      var h = a(b.of),
        i = h[0],
        j = (b.collision || 'flip').split(' '),
        k = b.offset ? b.offset.split(' ') : [0, 0],
        l,
        m,
        n;
      return (
        i.nodeType === 9
          ? ((l = h.width()), (m = h.height()), (n = { top: 0, left: 0 }))
          : i.setTimeout
          ? ((l = h.width()), (m = h.height()), (n = { top: h.scrollTop(), left: h.scrollLeft() }))
          : i.preventDefault
          ? ((b.at = 'left top'), (l = m = 0), (n = { top: b.of.pageY, left: b.of.pageX }))
          : ((l = h.outerWidth()), (m = h.outerHeight()), (n = h.offset())),
        a.each(['my', 'at'], function () {
          var a = (b[this] || '').split(' ');
          a.length === 1 && (a = c.test(a[0]) ? a.concat([e]) : d.test(a[0]) ? [e].concat(a) : [e, e]),
            (a[0] = c.test(a[0]) ? a[0] : e),
            (a[1] = d.test(a[1]) ? a[1] : e),
            (b[this] = a);
        }),
        j.length === 1 && (j[1] = j[0]),
        (k[0] = parseInt(k[0], 10) || 0),
        k.length === 1 && (k[1] = k[0]),
        (k[1] = parseInt(k[1], 10) || 0),
        b.at[0] === 'right' ? (n.left += l) : b.at[0] === e && (n.left += l / 2),
        b.at[1] === 'bottom' ? (n.top += m) : b.at[1] === e && (n.top += m / 2),
        (n.left += k[0]),
        (n.top += k[1]),
        this.each(function () {
          var c = a(this),
            d = c.outerWidth(),
            g = c.outerHeight(),
            h = parseInt(a.curCSS(this, 'marginLeft', !0)) || 0,
            i = parseInt(a.curCSS(this, 'marginTop', !0)) || 0,
            o = d + h + (parseInt(a.curCSS(this, 'marginRight', !0)) || 0),
            p = g + i + (parseInt(a.curCSS(this, 'marginBottom', !0)) || 0),
            q = a.extend({}, n),
            r;
          b.my[0] === 'right' ? (q.left -= d) : b.my[0] === e && (q.left -= d / 2),
            b.my[1] === 'bottom' ? (q.top -= g) : b.my[1] === e && (q.top -= g / 2),
            f.fractions || ((q.left = Math.round(q.left)), (q.top = Math.round(q.top))),
            (r = { left: q.left - h, top: q.top - i }),
            a.each(['left', 'top'], function (c, e) {
              a.ui.position[j[c]] &&
                a.ui.position[j[c]][e](q, {
                  targetWidth: l,
                  targetHeight: m,
                  elemWidth: d,
                  elemHeight: g,
                  collisionPosition: r,
                  collisionWidth: o,
                  collisionHeight: p,
                  offset: k,
                  my: b.my,
                  at: b.at,
                });
            }),
            a.fn.bgiframe && c.bgiframe(),
            c.offset(a.extend(q, { using: b.using }));
        })
      );
    }),
      (a.ui.position = {
        fit: {
          left: function (b, c) {
            var d = a(window),
              e = c.collisionPosition.left + c.collisionWidth - d.width() - d.scrollLeft();
            b.left = e > 0 ? b.left - e : Math.max(b.left - c.collisionPosition.left, b.left);
          },
          top: function (b, c) {
            var d = a(window),
              e = c.collisionPosition.top + c.collisionHeight - d.height() - d.scrollTop();
            b.top = e > 0 ? b.top - e : Math.max(b.top - c.collisionPosition.top, b.top);
          },
        },
        flip: {
          left: function (b, c) {
            if (c.at[0] === e) return;
            var d = a(window),
              f = c.collisionPosition.left + c.collisionWidth - d.width() - d.scrollLeft(),
              g = c.my[0] === 'left' ? -c.elemWidth : c.my[0] === 'right' ? c.elemWidth : 0,
              h = c.at[0] === 'left' ? c.targetWidth : -c.targetWidth,
              i = -2 * c.offset[0];
            b.left += c.collisionPosition.left < 0 ? g + h + i : f > 0 ? g + h + i : 0;
          },
          top: function (b, c) {
            if (c.at[1] === e) return;
            var d = a(window),
              f = c.collisionPosition.top + c.collisionHeight - d.height() - d.scrollTop(),
              g = c.my[1] === 'top' ? -c.elemHeight : c.my[1] === 'bottom' ? c.elemHeight : 0,
              h = c.at[1] === 'top' ? c.targetHeight : -c.targetHeight,
              i = -2 * c.offset[1];
            b.top += c.collisionPosition.top < 0 ? g + h + i : f > 0 ? g + h + i : 0;
          },
        },
      }),
      a.offset.setOffset ||
        ((a.offset.setOffset = function (b, c) {
          /static/.test(a.curCSS(b, 'position')) && (b.style.position = 'relative');
          var d = a(b),
            e = d.offset(),
            f = parseInt(a.curCSS(b, 'top', !0), 10) || 0,
            g = parseInt(a.curCSS(b, 'left', !0), 10) || 0,
            h = { top: c.top - e.top + f, left: c.left - e.left + g };
          'using' in c ? c.using.call(b, h) : d.css(h);
        }),
        (a.fn.offset = function (b) {
          var c = this[0];
          return !c || !c.ownerDocument
            ? null
            : b
            ? a.isFunction(b)
              ? this.each(function (c) {
                  a(this).offset(b.call(this, c, a(this).offset()));
                })
              : this.each(function () {
                  a.offset.setOffset(this, b);
                })
            : h.call(this);
        })),
      a.curCSS || (a.curCSS = a.css),
      (function () {
        var b = document.getElementsByTagName('body')[0],
          c = document.createElement('div'),
          d,
          e,
          g,
          h,
          i;
        (d = document.createElement(b ? 'div' : 'body')),
          (g = { visibility: 'hidden', width: 0, height: 0, border: 0, margin: 0, background: 'none' }),
          b && a.extend(g, { position: 'absolute', left: '-1000px', top: '-1000px' });
        for (var j in g) d.style[j] = g[j];
        d.appendChild(c),
          (e = b || document.documentElement),
          e.insertBefore(d, e.firstChild),
          (c.style.cssText = 'position: absolute; left: 10.7432222px; top: 10.432325px; height: 30px; width: 201px;'),
          (h = a(c)
            .offset(function (a, b) {
              return b;
            })
            .offset()),
          (d.innerHTML = ''),
          e.removeChild(d),
          (i = h.top + h.left + (b ? 2e3 : 0)),
          (f.fractions = i > 21 && i < 22);
      })();
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.draggable.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.draggable', a.ui.mouse, {
      widgetEventPrefix: 'drag',
      options: {
        addClasses: !0,
        appendTo: 'parent',
        axis: !1,
        connectToSortable: !1,
        containment: !1,
        cursor: 'auto',
        cursorAt: !1,
        grid: !1,
        handle: !1,
        helper: 'original',
        iframeFix: !1,
        opacity: !1,
        refreshPositions: !1,
        revert: !1,
        revertDuration: 500,
        scope: 'default',
        scroll: !0,
        scrollSensitivity: 20,
        scrollSpeed: 20,
        snap: !1,
        snapMode: 'both',
        snapTolerance: 20,
        stack: !1,
        zIndex: !1,
      },
      _create: function () {
        this.options.helper == 'original' &&
          !/^(?:r|a|f)/.test(this.element.css('position')) &&
          (this.element[0].style.position = 'relative'),
          this.options.addClasses && this.element.addClass('ui-draggable'),
          this.options.disabled && this.element.addClass('ui-draggable-disabled'),
          this._mouseInit();
      },
      destroy: function () {
        if (!this.element.data('draggable')) return;
        return (
          this.element
            .removeData('draggable')
            .unbind('.draggable')
            .removeClass('ui-draggable ui-draggable-dragging ui-draggable-disabled'),
          this._mouseDestroy(),
          this
        );
      },
      _mouseCapture: function (b) {
        var c = this.options;
        return this.helper || c.disabled || a(b.target).is('.ui-resizable-handle')
          ? !1
          : ((this.handle = this._getHandle(b)),
            this.handle
              ? (c.iframeFix &&
                  a(c.iframeFix === !0 ? 'iframe' : c.iframeFix).each(function () {
                    a('<div class="ui-draggable-iframeFix" style="background: #fff;"></div>')
                      .css({
                        width: this.offsetWidth + 'px',
                        height: this.offsetHeight + 'px',
                        position: 'absolute',
                        opacity: '0.001',
                        zIndex: 1e3,
                      })
                      .css(a(this).offset())
                      .appendTo('body');
                  }),
                !0)
              : !1);
      },
      _mouseStart: function (b) {
        var c = this.options;
        return (
          (this.helper = this._createHelper(b)),
          this.helper.addClass('ui-draggable-dragging'),
          this._cacheHelperProportions(),
          a.ui.ddmanager && (a.ui.ddmanager.current = this),
          this._cacheMargins(),
          (this.cssPosition = this.helper.css('position')),
          (this.scrollParent = this.helper.scrollParent()),
          (this.offset = this.positionAbs = this.element.offset()),
          (this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left }),
          a.extend(this.offset, {
            click: { left: b.pageX - this.offset.left, top: b.pageY - this.offset.top },
            parent: this._getParentOffset(),
            relative: this._getRelativeOffset(),
          }),
          (this.originalPosition = this.position = this._generatePosition(b)),
          (this.originalPageX = b.pageX),
          (this.originalPageY = b.pageY),
          c.cursorAt && this._adjustOffsetFromHelper(c.cursorAt),
          c.containment && this._setContainment(),
          this._trigger('start', b) === !1
            ? (this._clear(), !1)
            : (this._cacheHelperProportions(),
              a.ui.ddmanager && !c.dropBehaviour && a.ui.ddmanager.prepareOffsets(this, b),
              this._mouseDrag(b, !0),
              a.ui.ddmanager && a.ui.ddmanager.dragStart(this, b),
              !0)
        );
      },
      _mouseDrag: function (b, c) {
        (this.position = this._generatePosition(b)), (this.positionAbs = this._convertPositionTo('absolute'));
        if (!c) {
          var d = this._uiHash();
          if (this._trigger('drag', b, d) === !1) return this._mouseUp({}), !1;
          this.position = d.position;
        }
        if (!this.options.axis || this.options.axis != 'y') this.helper[0].style.left = this.position.left + 'px';
        if (!this.options.axis || this.options.axis != 'x') this.helper[0].style.top = this.position.top + 'px';
        return a.ui.ddmanager && a.ui.ddmanager.drag(this, b), !1;
      },
      _mouseStop: function (b) {
        var c = !1;
        a.ui.ddmanager && !this.options.dropBehaviour && (c = a.ui.ddmanager.drop(this, b)),
          this.dropped && ((c = this.dropped), (this.dropped = !1));
        var d = this.element[0],
          e = !1;
        while (d && (d = d.parentNode)) d == document && (e = !0);
        if (!e && this.options.helper === 'original') return !1;
        if (
          (this.options.revert == 'invalid' && !c) ||
          (this.options.revert == 'valid' && c) ||
          this.options.revert === !0 ||
          (a.isFunction(this.options.revert) && this.options.revert.call(this.element, c))
        ) {
          var f = this;
          a(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
            f._trigger('stop', b) !== !1 && f._clear();
          });
        } else this._trigger('stop', b) !== !1 && this._clear();
        return !1;
      },
      _mouseUp: function (b) {
        return (
          a('div.ui-draggable-iframeFix').each(function () {
            this.parentNode.removeChild(this);
          }),
          a.ui.ddmanager && a.ui.ddmanager.dragStop(this, b),
          a.ui.mouse.prototype._mouseUp.call(this, b)
        );
      },
      cancel: function () {
        return this.helper.is('.ui-draggable-dragging') ? this._mouseUp({}) : this._clear(), this;
      },
      _getHandle: function (b) {
        var c = !this.options.handle || !a(this.options.handle, this.element).length ? !0 : !1;
        return (
          a(this.options.handle, this.element)
            .find('*')
            .andSelf()
            .each(function () {
              this == b.target && (c = !0);
            }),
          c
        );
      },
      _createHelper: function (b) {
        var c = this.options,
          d = a.isFunction(c.helper)
            ? a(c.helper.apply(this.element[0], [b]))
            : c.helper == 'clone'
            ? this.element.clone().removeAttr('id')
            : this.element;
        return (
          d.parents('body').length || d.appendTo(c.appendTo == 'parent' ? this.element[0].parentNode : c.appendTo),
          d[0] != this.element[0] && !/(fixed|absolute)/.test(d.css('position')) && d.css('position', 'absolute'),
          d
        );
      },
      _adjustOffsetFromHelper: function (b) {
        typeof b == 'string' && (b = b.split(' ')),
          a.isArray(b) && (b = { left: +b[0], top: +b[1] || 0 }),
          'left' in b && (this.offset.click.left = b.left + this.margins.left),
          'right' in b && (this.offset.click.left = this.helperProportions.width - b.right + this.margins.left),
          'top' in b && (this.offset.click.top = b.top + this.margins.top),
          'bottom' in b && (this.offset.click.top = this.helperProportions.height - b.bottom + this.margins.top);
      },
      _getParentOffset: function () {
        this.offsetParent = this.helper.offsetParent();
        var b = this.offsetParent.offset();
        this.cssPosition == 'absolute' &&
          this.scrollParent[0] != document &&
          a.ui.contains(this.scrollParent[0], this.offsetParent[0]) &&
          ((b.left += this.scrollParent.scrollLeft()), (b.top += this.scrollParent.scrollTop()));
        if (
          this.offsetParent[0] == document.body ||
          (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() == 'html' && a.browser.msie)
        )
          b = { top: 0, left: 0 };
        return {
          top: b.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
          left: b.left + (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
        };
      },
      _getRelativeOffset: function () {
        if (this.cssPosition == 'relative') {
          var a = this.element.position();
          return {
            top: a.top - (parseInt(this.helper.css('top'), 10) || 0) + this.scrollParent.scrollTop(),
            left: a.left - (parseInt(this.helper.css('left'), 10) || 0) + this.scrollParent.scrollLeft(),
          };
        }
        return { top: 0, left: 0 };
      },
      _cacheMargins: function () {
        this.margins = {
          left: parseInt(this.element.css('marginLeft'), 10) || 0,
          top: parseInt(this.element.css('marginTop'), 10) || 0,
          right: parseInt(this.element.css('marginRight'), 10) || 0,
          bottom: parseInt(this.element.css('marginBottom'), 10) || 0,
        };
      },
      _cacheHelperProportions: function () {
        this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
      },
      _setContainment: function () {
        var b = this.options;
        b.containment == 'parent' && (b.containment = this.helper[0].parentNode);
        if (b.containment == 'document' || b.containment == 'window')
          this.containment = [
            b.containment == 'document'
              ? 0
              : a(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
            b.containment == 'document' ? 0 : a(window).scrollTop() - this.offset.relative.top - this.offset.parent.top,
            (b.containment == 'document' ? 0 : a(window).scrollLeft()) +
              a(b.containment == 'document' ? document : window).width() -
              this.helperProportions.width -
              this.margins.left,
            (b.containment == 'document' ? 0 : a(window).scrollTop()) +
              (a(b.containment == 'document' ? document : window).height() || document.body.parentNode.scrollHeight) -
              this.helperProportions.height -
              this.margins.top,
          ];
        if (!/^(document|window|parent)$/.test(b.containment) && b.containment.constructor != Array) {
          var c = a(b.containment),
            d = c[0];
          if (!d) return;
          var e = c.offset(),
            f = a(d).css('overflow') != 'hidden';
          (this.containment = [
            (parseInt(a(d).css('borderLeftWidth'), 10) || 0) + (parseInt(a(d).css('paddingLeft'), 10) || 0),
            (parseInt(a(d).css('borderTopWidth'), 10) || 0) + (parseInt(a(d).css('paddingTop'), 10) || 0),
            (f ? Math.max(d.scrollWidth, d.offsetWidth) : d.offsetWidth) -
              (parseInt(a(d).css('borderLeftWidth'), 10) || 0) -
              (parseInt(a(d).css('paddingRight'), 10) || 0) -
              this.helperProportions.width -
              this.margins.left -
              this.margins.right,
            (f ? Math.max(d.scrollHeight, d.offsetHeight) : d.offsetHeight) -
              (parseInt(a(d).css('borderTopWidth'), 10) || 0) -
              (parseInt(a(d).css('paddingBottom'), 10) || 0) -
              this.helperProportions.height -
              this.margins.top -
              this.margins.bottom,
          ]),
            (this.relative_container = c);
        } else b.containment.constructor == Array && (this.containment = b.containment);
      },
      _convertPositionTo: function (b, c) {
        c || (c = this.position);
        var d = b == 'absolute' ? 1 : -1,
          e = this.options,
          f =
            this.cssPosition == 'absolute' &&
            (this.scrollParent[0] == document || !a.ui.contains(this.scrollParent[0], this.offsetParent[0]))
              ? this.offsetParent
              : this.scrollParent,
          g = /(html|body)/i.test(f[0].tagName);
        return {
          top:
            c.top +
            this.offset.relative.top * d +
            this.offset.parent.top * d -
            (a.browser.safari && a.browser.version < 526 && this.cssPosition == 'fixed'
              ? 0
              : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : g ? 0 : f.scrollTop()) * d),
          left:
            c.left +
            this.offset.relative.left * d +
            this.offset.parent.left * d -
            (a.browser.safari && a.browser.version < 526 && this.cssPosition == 'fixed'
              ? 0
              : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : g ? 0 : f.scrollLeft()) * d),
        };
      },
      _generatePosition: function (b) {
        var c = this.options,
          d =
            this.cssPosition == 'absolute' &&
            (this.scrollParent[0] == document || !a.ui.contains(this.scrollParent[0], this.offsetParent[0]))
              ? this.offsetParent
              : this.scrollParent,
          e = /(html|body)/i.test(d[0].tagName),
          f = b.pageX,
          g = b.pageY;
        if (this.originalPosition) {
          var h;
          if (this.containment) {
            if (this.relative_container) {
              var i = this.relative_container.offset();
              h = [
                this.containment[0] + i.left,
                this.containment[1] + i.top,
                this.containment[2] + i.left,
                this.containment[3] + i.top,
              ];
            } else h = this.containment;
            b.pageX - this.offset.click.left < h[0] && (f = h[0] + this.offset.click.left),
              b.pageY - this.offset.click.top < h[1] && (g = h[1] + this.offset.click.top),
              b.pageX - this.offset.click.left > h[2] && (f = h[2] + this.offset.click.left),
              b.pageY - this.offset.click.top > h[3] && (g = h[3] + this.offset.click.top);
          }
          if (c.grid) {
            var j = c.grid[1]
              ? this.originalPageY + Math.round((g - this.originalPageY) / c.grid[1]) * c.grid[1]
              : this.originalPageY;
            g = h
              ? j - this.offset.click.top < h[1] || j - this.offset.click.top > h[3]
                ? j - this.offset.click.top < h[1]
                  ? j + c.grid[1]
                  : j - c.grid[1]
                : j
              : j;
            var k = c.grid[0]
              ? this.originalPageX + Math.round((f - this.originalPageX) / c.grid[0]) * c.grid[0]
              : this.originalPageX;
            f = h
              ? k - this.offset.click.left < h[0] || k - this.offset.click.left > h[2]
                ? k - this.offset.click.left < h[0]
                  ? k + c.grid[0]
                  : k - c.grid[0]
                : k
              : k;
          }
        }
        return {
          top:
            g -
            this.offset.click.top -
            this.offset.relative.top -
            this.offset.parent.top +
            (a.browser.safari && a.browser.version < 526 && this.cssPosition == 'fixed'
              ? 0
              : this.cssPosition == 'fixed'
              ? -this.scrollParent.scrollTop()
              : e
              ? 0
              : d.scrollTop()),
          left:
            f -
            this.offset.click.left -
            this.offset.relative.left -
            this.offset.parent.left +
            (a.browser.safari && a.browser.version < 526 && this.cssPosition == 'fixed'
              ? 0
              : this.cssPosition == 'fixed'
              ? -this.scrollParent.scrollLeft()
              : e
              ? 0
              : d.scrollLeft()),
        };
      },
      _clear: function () {
        this.helper.removeClass('ui-draggable-dragging'),
          this.helper[0] != this.element[0] && !this.cancelHelperRemoval && this.helper.remove(),
          (this.helper = null),
          (this.cancelHelperRemoval = !1);
      },
      _trigger: function (b, c, d) {
        return (
          (d = d || this._uiHash()),
          a.ui.plugin.call(this, b, [c, d]),
          b == 'drag' && (this.positionAbs = this._convertPositionTo('absolute')),
          a.Widget.prototype._trigger.call(this, b, c, d)
        );
      },
      plugins: {},
      _uiHash: function (a) {
        return {
          helper: this.helper,
          position: this.position,
          originalPosition: this.originalPosition,
          offset: this.positionAbs,
        };
      },
    }),
      a.extend(a.ui.draggable, { version: '1.8.24' }),
      a.ui.plugin.add('draggable', 'connectToSortable', {
        start: function (b, c) {
          var d = a(this).data('draggable'),
            e = d.options,
            f = a.extend({}, c, { item: d.element });
          (d.sortables = []),
            a(e.connectToSortable).each(function () {
              var c = a.data(this, 'sortable');
              c &&
                !c.options.disabled &&
                (d.sortables.push({ instance: c, shouldRevert: c.options.revert }),
                c.refreshPositions(),
                c._trigger('activate', b, f));
            });
        },
        stop: function (b, c) {
          var d = a(this).data('draggable'),
            e = a.extend({}, c, { item: d.element });
          a.each(d.sortables, function () {
            this.instance.isOver
              ? ((this.instance.isOver = 0),
                (d.cancelHelperRemoval = !0),
                (this.instance.cancelHelperRemoval = !1),
                this.shouldRevert && (this.instance.options.revert = !0),
                this.instance._mouseStop(b),
                (this.instance.options.helper = this.instance.options._helper),
                d.options.helper == 'original' && this.instance.currentItem.css({ top: 'auto', left: 'auto' }))
              : ((this.instance.cancelHelperRemoval = !1), this.instance._trigger('deactivate', b, e));
          });
        },
        drag: function (b, c) {
          var d = a(this).data('draggable'),
            e = this,
            f = function (b) {
              var c = this.offset.click.top,
                d = this.offset.click.left,
                e = this.positionAbs.top,
                f = this.positionAbs.left,
                g = b.height,
                h = b.width,
                i = b.top,
                j = b.left;
              return a.ui.isOver(e + c, f + d, i, j, g, h);
            };
          a.each(d.sortables, function (f) {
            (this.instance.positionAbs = d.positionAbs),
              (this.instance.helperProportions = d.helperProportions),
              (this.instance.offset.click = d.offset.click),
              this.instance._intersectsWith(this.instance.containerCache)
                ? (this.instance.isOver ||
                    ((this.instance.isOver = 1),
                    (this.instance.currentItem = a(e)
                      .clone()
                      .removeAttr('id')
                      .appendTo(this.instance.element)
                      .data('sortable-item', !0)),
                    (this.instance.options._helper = this.instance.options.helper),
                    (this.instance.options.helper = function () {
                      return c.helper[0];
                    }),
                    (b.target = this.instance.currentItem[0]),
                    this.instance._mouseCapture(b, !0),
                    this.instance._mouseStart(b, !0, !0),
                    (this.instance.offset.click.top = d.offset.click.top),
                    (this.instance.offset.click.left = d.offset.click.left),
                    (this.instance.offset.parent.left -= d.offset.parent.left - this.instance.offset.parent.left),
                    (this.instance.offset.parent.top -= d.offset.parent.top - this.instance.offset.parent.top),
                    d._trigger('toSortable', b),
                    (d.dropped = this.instance.element),
                    (d.currentItem = d.element),
                    (this.instance.fromOutside = d)),
                  this.instance.currentItem && this.instance._mouseDrag(b))
                : this.instance.isOver &&
                  ((this.instance.isOver = 0),
                  (this.instance.cancelHelperRemoval = !0),
                  (this.instance.options.revert = !1),
                  this.instance._trigger('out', b, this.instance._uiHash(this.instance)),
                  this.instance._mouseStop(b, !0),
                  (this.instance.options.helper = this.instance.options._helper),
                  this.instance.currentItem.remove(),
                  this.instance.placeholder && this.instance.placeholder.remove(),
                  d._trigger('fromSortable', b),
                  (d.dropped = !1));
          });
        },
      }),
      a.ui.plugin.add('draggable', 'cursor', {
        start: function (b, c) {
          var d = a('body'),
            e = a(this).data('draggable').options;
          d.css('cursor') && (e._cursor = d.css('cursor')), d.css('cursor', e.cursor);
        },
        stop: function (b, c) {
          var d = a(this).data('draggable').options;
          d._cursor && a('body').css('cursor', d._cursor);
        },
      }),
      a.ui.plugin.add('draggable', 'opacity', {
        start: function (b, c) {
          var d = a(c.helper),
            e = a(this).data('draggable').options;
          d.css('opacity') && (e._opacity = d.css('opacity')), d.css('opacity', e.opacity);
        },
        stop: function (b, c) {
          var d = a(this).data('draggable').options;
          d._opacity && a(c.helper).css('opacity', d._opacity);
        },
      }),
      a.ui.plugin.add('draggable', 'scroll', {
        start: function (b, c) {
          var d = a(this).data('draggable');
          d.scrollParent[0] != document &&
            d.scrollParent[0].tagName != 'HTML' &&
            (d.overflowOffset = d.scrollParent.offset());
        },
        drag: function (b, c) {
          var d = a(this).data('draggable'),
            e = d.options,
            f = !1;
          if (d.scrollParent[0] != document && d.scrollParent[0].tagName != 'HTML') {
            if (!e.axis || e.axis != 'x')
              d.overflowOffset.top + d.scrollParent[0].offsetHeight - b.pageY < e.scrollSensitivity
                ? (d.scrollParent[0].scrollTop = f = d.scrollParent[0].scrollTop + e.scrollSpeed)
                : b.pageY - d.overflowOffset.top < e.scrollSensitivity &&
                  (d.scrollParent[0].scrollTop = f = d.scrollParent[0].scrollTop - e.scrollSpeed);
            if (!e.axis || e.axis != 'y')
              d.overflowOffset.left + d.scrollParent[0].offsetWidth - b.pageX < e.scrollSensitivity
                ? (d.scrollParent[0].scrollLeft = f = d.scrollParent[0].scrollLeft + e.scrollSpeed)
                : b.pageX - d.overflowOffset.left < e.scrollSensitivity &&
                  (d.scrollParent[0].scrollLeft = f = d.scrollParent[0].scrollLeft - e.scrollSpeed);
          } else {
            if (!e.axis || e.axis != 'x')
              b.pageY - a(document).scrollTop() < e.scrollSensitivity
                ? (f = a(document).scrollTop(a(document).scrollTop() - e.scrollSpeed))
                : a(window).height() - (b.pageY - a(document).scrollTop()) < e.scrollSensitivity &&
                  (f = a(document).scrollTop(a(document).scrollTop() + e.scrollSpeed));
            if (!e.axis || e.axis != 'y')
              b.pageX - a(document).scrollLeft() < e.scrollSensitivity
                ? (f = a(document).scrollLeft(a(document).scrollLeft() - e.scrollSpeed))
                : a(window).width() - (b.pageX - a(document).scrollLeft()) < e.scrollSensitivity &&
                  (f = a(document).scrollLeft(a(document).scrollLeft() + e.scrollSpeed));
          }
          f !== !1 && a.ui.ddmanager && !e.dropBehaviour && a.ui.ddmanager.prepareOffsets(d, b);
        },
      }),
      a.ui.plugin.add('draggable', 'snap', {
        start: function (b, c) {
          var d = a(this).data('draggable'),
            e = d.options;
          (d.snapElements = []),
            a(e.snap.constructor != String ? e.snap.items || ':data(draggable)' : e.snap).each(function () {
              var b = a(this),
                c = b.offset();
              this != d.element[0] &&
                d.snapElements.push({
                  item: this,
                  width: b.outerWidth(),
                  height: b.outerHeight(),
                  top: c.top,
                  left: c.left,
                });
            });
        },
        drag: function (b, c) {
          var d = a(this).data('draggable'),
            e = d.options,
            f = e.snapTolerance,
            g = c.offset.left,
            h = g + d.helperProportions.width,
            i = c.offset.top,
            j = i + d.helperProportions.height;
          for (var k = d.snapElements.length - 1; k >= 0; k--) {
            var l = d.snapElements[k].left,
              m = l + d.snapElements[k].width,
              n = d.snapElements[k].top,
              o = n + d.snapElements[k].height;
            if (
              !(
                (l - f < g && g < m + f && n - f < i && i < o + f) ||
                (l - f < g && g < m + f && n - f < j && j < o + f) ||
                (l - f < h && h < m + f && n - f < i && i < o + f) ||
                (l - f < h && h < m + f && n - f < j && j < o + f)
              )
            ) {
              d.snapElements[k].snapping &&
                d.options.snap.release &&
                d.options.snap.release.call(d.element, b, a.extend(d._uiHash(), { snapItem: d.snapElements[k].item })),
                (d.snapElements[k].snapping = !1);
              continue;
            }
            if (e.snapMode != 'inner') {
              var p = Math.abs(n - j) <= f,
                q = Math.abs(o - i) <= f,
                r = Math.abs(l - h) <= f,
                s = Math.abs(m - g) <= f;
              p &&
                (c.position.top =
                  d._convertPositionTo('relative', { top: n - d.helperProportions.height, left: 0 }).top -
                  d.margins.top),
                q && (c.position.top = d._convertPositionTo('relative', { top: o, left: 0 }).top - d.margins.top),
                r &&
                  (c.position.left =
                    d._convertPositionTo('relative', { top: 0, left: l - d.helperProportions.width }).left -
                    d.margins.left),
                s && (c.position.left = d._convertPositionTo('relative', { top: 0, left: m }).left - d.margins.left);
            }
            var t = p || q || r || s;
            if (e.snapMode != 'outer') {
              var p = Math.abs(n - i) <= f,
                q = Math.abs(o - j) <= f,
                r = Math.abs(l - g) <= f,
                s = Math.abs(m - h) <= f;
              p && (c.position.top = d._convertPositionTo('relative', { top: n, left: 0 }).top - d.margins.top),
                q &&
                  (c.position.top =
                    d._convertPositionTo('relative', { top: o - d.helperProportions.height, left: 0 }).top -
                    d.margins.top),
                r && (c.position.left = d._convertPositionTo('relative', { top: 0, left: l }).left - d.margins.left),
                s &&
                  (c.position.left =
                    d._convertPositionTo('relative', { top: 0, left: m - d.helperProportions.width }).left -
                    d.margins.left);
            }
            !d.snapElements[k].snapping &&
              (p || q || r || s || t) &&
              d.options.snap.snap &&
              d.options.snap.snap.call(d.element, b, a.extend(d._uiHash(), { snapItem: d.snapElements[k].item })),
              (d.snapElements[k].snapping = p || q || r || s || t);
          }
        },
      }),
      a.ui.plugin.add('draggable', 'stack', {
        start: function (b, c) {
          var d = a(this).data('draggable').options,
            e = a.makeArray(a(d.stack)).sort(function (b, c) {
              return (parseInt(a(b).css('zIndex'), 10) || 0) - (parseInt(a(c).css('zIndex'), 10) || 0);
            });
          if (!e.length) return;
          var f = parseInt(e[0].style.zIndex) || 0;
          a(e).each(function (a) {
            this.style.zIndex = f + a;
          }),
            (this[0].style.zIndex = f + e.length);
        },
      }),
      a.ui.plugin.add('draggable', 'zIndex', {
        start: function (b, c) {
          var d = a(c.helper),
            e = a(this).data('draggable').options;
          d.css('zIndex') && (e._zIndex = d.css('zIndex')), d.css('zIndex', e.zIndex);
        },
        stop: function (b, c) {
          var d = a(this).data('draggable').options;
          d._zIndex && a(c.helper).css('zIndex', d._zIndex);
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.droppable.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.droppable', {
      widgetEventPrefix: 'drop',
      options: {
        accept: '*',
        activeClass: !1,
        addClasses: !0,
        greedy: !1,
        hoverClass: !1,
        scope: 'default',
        tolerance: 'intersect',
      },
      _create: function () {
        var b = this.options,
          c = b.accept;
        (this.isover = 0),
          (this.isout = 1),
          (this.accept = a.isFunction(c)
            ? c
            : function (a) {
                return a.is(c);
              }),
          (this.proportions = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight }),
          (a.ui.ddmanager.droppables[b.scope] = a.ui.ddmanager.droppables[b.scope] || []),
          a.ui.ddmanager.droppables[b.scope].push(this),
          b.addClasses && this.element.addClass('ui-droppable');
      },
      destroy: function () {
        var b = a.ui.ddmanager.droppables[this.options.scope];
        for (var c = 0; c < b.length; c++) b[c] == this && b.splice(c, 1);
        return (
          this.element.removeClass('ui-droppable ui-droppable-disabled').removeData('droppable').unbind('.droppable'),
          this
        );
      },
      _setOption: function (b, c) {
        b == 'accept' &&
          (this.accept = a.isFunction(c)
            ? c
            : function (a) {
                return a.is(c);
              }),
          a.Widget.prototype._setOption.apply(this, arguments);
      },
      _activate: function (b) {
        var c = a.ui.ddmanager.current;
        this.options.activeClass && this.element.addClass(this.options.activeClass),
          c && this._trigger('activate', b, this.ui(c));
      },
      _deactivate: function (b) {
        var c = a.ui.ddmanager.current;
        this.options.activeClass && this.element.removeClass(this.options.activeClass),
          c && this._trigger('deactivate', b, this.ui(c));
      },
      _over: function (b) {
        var c = a.ui.ddmanager.current;
        if (!c || (c.currentItem || c.element)[0] == this.element[0]) return;
        this.accept.call(this.element[0], c.currentItem || c.element) &&
          (this.options.hoverClass && this.element.addClass(this.options.hoverClass),
          this._trigger('over', b, this.ui(c)));
      },
      _out: function (b) {
        var c = a.ui.ddmanager.current;
        if (!c || (c.currentItem || c.element)[0] == this.element[0]) return;
        this.accept.call(this.element[0], c.currentItem || c.element) &&
          (this.options.hoverClass && this.element.removeClass(this.options.hoverClass),
          this._trigger('out', b, this.ui(c)));
      },
      _drop: function (b, c) {
        var d = c || a.ui.ddmanager.current;
        if (!d || (d.currentItem || d.element)[0] == this.element[0]) return !1;
        var e = !1;
        return (
          this.element
            .find(':data(droppable)')
            .not('.ui-draggable-dragging')
            .each(function () {
              var b = a.data(this, 'droppable');
              if (
                b.options.greedy &&
                !b.options.disabled &&
                b.options.scope == d.options.scope &&
                b.accept.call(b.element[0], d.currentItem || d.element) &&
                a.ui.intersect(d, a.extend(b, { offset: b.element.offset() }), b.options.tolerance)
              )
                return (e = !0), !1;
            }),
          e
            ? !1
            : this.accept.call(this.element[0], d.currentItem || d.element)
            ? (this.options.activeClass && this.element.removeClass(this.options.activeClass),
              this.options.hoverClass && this.element.removeClass(this.options.hoverClass),
              this._trigger('drop', b, this.ui(d)),
              this.element)
            : !1
        );
      },
      ui: function (a) {
        return { draggable: a.currentItem || a.element, helper: a.helper, position: a.position, offset: a.positionAbs };
      },
    }),
      a.extend(a.ui.droppable, { version: '1.8.24' }),
      (a.ui.intersect = function (b, c, d) {
        if (!c.offset) return !1;
        var e = (b.positionAbs || b.position.absolute).left,
          f = e + b.helperProportions.width,
          g = (b.positionAbs || b.position.absolute).top,
          h = g + b.helperProportions.height,
          i = c.offset.left,
          j = i + c.proportions.width,
          k = c.offset.top,
          l = k + c.proportions.height;
        switch (d) {
          case 'fit':
            return i <= e && f <= j && k <= g && h <= l;
          case 'intersect':
            return (
              i < e + b.helperProportions.width / 2 &&
              f - b.helperProportions.width / 2 < j &&
              k < g + b.helperProportions.height / 2 &&
              h - b.helperProportions.height / 2 < l
            );
          case 'pointer':
            var m = (b.positionAbs || b.position.absolute).left + (b.clickOffset || b.offset.click).left,
              n = (b.positionAbs || b.position.absolute).top + (b.clickOffset || b.offset.click).top,
              o = a.ui.isOver(n, m, k, i, c.proportions.height, c.proportions.width);
            return o;
          case 'touch':
            return (
              ((g >= k && g <= l) || (h >= k && h <= l) || (g < k && h > l)) &&
              ((e >= i && e <= j) || (f >= i && f <= j) || (e < i && f > j))
            );
          default:
            return !1;
        }
      }),
      (a.ui.ddmanager = {
        current: null,
        droppables: { default: [] },
        prepareOffsets: function (b, c) {
          var d = a.ui.ddmanager.droppables[b.options.scope] || [],
            e = c ? c.type : null,
            f = (b.currentItem || b.element).find(':data(droppable)').andSelf();
          g: for (var h = 0; h < d.length; h++) {
            if (d[h].options.disabled || (b && !d[h].accept.call(d[h].element[0], b.currentItem || b.element)))
              continue;
            for (var i = 0; i < f.length; i++)
              if (f[i] == d[h].element[0]) {
                d[h].proportions.height = 0;
                continue g;
              }
            d[h].visible = d[h].element.css('display') != 'none';
            if (!d[h].visible) continue;
            e == 'mousedown' && d[h]._activate.call(d[h], c),
              (d[h].offset = d[h].element.offset()),
              (d[h].proportions = { width: d[h].element[0].offsetWidth, height: d[h].element[0].offsetHeight });
          }
        },
        drop: function (b, c) {
          var d = !1;
          return (
            a.each(a.ui.ddmanager.droppables[b.options.scope] || [], function () {
              if (!this.options) return;
              !this.options.disabled &&
                this.visible &&
                a.ui.intersect(b, this, this.options.tolerance) &&
                (d = this._drop.call(this, c) || d),
                !this.options.disabled &&
                  this.visible &&
                  this.accept.call(this.element[0], b.currentItem || b.element) &&
                  ((this.isout = 1), (this.isover = 0), this._deactivate.call(this, c));
            }),
            d
          );
        },
        dragStart: function (b, c) {
          b.element.parents(':not(body,html)').bind('scroll.droppable', function () {
            b.options.refreshPositions || a.ui.ddmanager.prepareOffsets(b, c);
          });
        },
        drag: function (b, c) {
          b.options.refreshPositions && a.ui.ddmanager.prepareOffsets(b, c),
            a.each(a.ui.ddmanager.droppables[b.options.scope] || [], function () {
              if (this.options.disabled || this.greedyChild || !this.visible) return;
              var d = a.ui.intersect(b, this, this.options.tolerance),
                e = !d && this.isover == 1 ? 'isout' : d && this.isover == 0 ? 'isover' : null;
              if (!e) return;
              var f;
              if (this.options.greedy) {
                var g = this.options.scope,
                  h = this.element.parents(':data(droppable)').filter(function () {
                    return a.data(this, 'droppable').options.scope === g;
                  });
                h.length && ((f = a.data(h[0], 'droppable')), (f.greedyChild = e == 'isover' ? 1 : 0));
              }
              f && e == 'isover' && ((f.isover = 0), (f.isout = 1), f._out.call(f, c)),
                (this[e] = 1),
                (this[e == 'isout' ? 'isover' : 'isout'] = 0),
                this[e == 'isover' ? '_over' : '_out'].call(this, c),
                f && e == 'isout' && ((f.isout = 0), (f.isover = 1), f._over.call(f, c));
            });
        },
        dragStop: function (b, c) {
          b.element.parents(':not(body,html)').unbind('scroll.droppable'),
            b.options.refreshPositions || a.ui.ddmanager.prepareOffsets(b, c);
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.resizable.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.resizable', a.ui.mouse, {
      widgetEventPrefix: 'resize',
      options: {
        alsoResize: !1,
        animate: !1,
        animateDuration: 'slow',
        animateEasing: 'swing',
        aspectRatio: !1,
        autoHide: !1,
        containment: !1,
        ghost: !1,
        grid: !1,
        handles: 'e,s,se',
        helper: !1,
        maxHeight: null,
        maxWidth: null,
        minHeight: 10,
        minWidth: 10,
        zIndex: 1e3,
      },
      _create: function () {
        var b = this,
          c = this.options;
        this.element.addClass('ui-resizable'),
          a.extend(this, {
            _aspectRatio: !!c.aspectRatio,
            aspectRatio: c.aspectRatio,
            originalElement: this.element,
            _proportionallyResizeElements: [],
            _helper: c.helper || c.ghost || c.animate ? c.helper || 'ui-resizable-helper' : null,
          }),
          this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i) &&
            (this.element.wrap(
              a('<div class="ui-wrapper" style="overflow: hidden;"></div>').css({
                position: this.element.css('position'),
                width: this.element.outerWidth(),
                height: this.element.outerHeight(),
                top: this.element.css('top'),
                left: this.element.css('left'),
              }),
            ),
            (this.element = this.element.parent().data('resizable', this.element.data('resizable'))),
            (this.elementIsWrapper = !0),
            this.element.css({
              marginLeft: this.originalElement.css('marginLeft'),
              marginTop: this.originalElement.css('marginTop'),
              marginRight: this.originalElement.css('marginRight'),
              marginBottom: this.originalElement.css('marginBottom'),
            }),
            this.originalElement.css({ marginLeft: 0, marginTop: 0, marginRight: 0, marginBottom: 0 }),
            (this.originalResizeStyle = this.originalElement.css('resize')),
            this.originalElement.css('resize', 'none'),
            this._proportionallyResizeElements.push(
              this.originalElement.css({ position: 'static', zoom: 1, display: 'block' }),
            ),
            this.originalElement.css({ margin: this.originalElement.css('margin') }),
            this._proportionallyResize()),
          (this.handles =
            c.handles ||
            (a('.ui-resizable-handle', this.element).length
              ? {
                  n: '.ui-resizable-n',
                  e: '.ui-resizable-e',
                  s: '.ui-resizable-s',
                  w: '.ui-resizable-w',
                  se: '.ui-resizable-se',
                  sw: '.ui-resizable-sw',
                  ne: '.ui-resizable-ne',
                  nw: '.ui-resizable-nw',
                }
              : 'e,s,se'));
        if (this.handles.constructor == String) {
          this.handles == 'all' && (this.handles = 'n,e,s,w,se,sw,ne,nw');
          var d = this.handles.split(',');
          this.handles = {};
          for (var e = 0; e < d.length; e++) {
            var f = a.trim(d[e]),
              g = 'ui-resizable-' + f,
              h = a('<div class="ui-resizable-handle ' + g + '"></div>');
            h.css({ zIndex: c.zIndex }),
              'se' == f && h.addClass('ui-icon ui-icon-gripsmall-diagonal-se'),
              (this.handles[f] = '.ui-resizable-' + f),
              this.element.append(h);
          }
        }
        (this._renderAxis = function (b) {
          b = b || this.element;
          for (var c in this.handles) {
            this.handles[c].constructor == String && (this.handles[c] = a(this.handles[c], this.element).show());
            if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/textarea|input|select|button/i)) {
              var d = a(this.handles[c], this.element),
                e = 0;
              e = /sw|ne|nw|se|n|s/.test(c) ? d.outerHeight() : d.outerWidth();
              var f = [
                'padding',
                /ne|nw|n/.test(c) ? 'Top' : /se|sw|s/.test(c) ? 'Bottom' : /^e$/.test(c) ? 'Right' : 'Left',
              ].join('');
              b.css(f, e), this._proportionallyResize();
            }
            if (!a(this.handles[c]).length) continue;
          }
        }),
          this._renderAxis(this.element),
          (this._handles = a('.ui-resizable-handle', this.element).disableSelection()),
          this._handles.mouseover(function () {
            if (!b.resizing) {
              if (this.className) var a = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
              b.axis = a && a[1] ? a[1] : 'se';
            }
          }),
          c.autoHide &&
            (this._handles.hide(),
            a(this.element)
              .addClass('ui-resizable-autohide')
              .hover(
                function () {
                  if (c.disabled) return;
                  a(this).removeClass('ui-resizable-autohide'), b._handles.show();
                },
                function () {
                  if (c.disabled) return;
                  b.resizing || (a(this).addClass('ui-resizable-autohide'), b._handles.hide());
                },
              )),
          this._mouseInit();
      },
      destroy: function () {
        this._mouseDestroy();
        var b = function (b) {
          a(b)
            .removeClass('ui-resizable ui-resizable-disabled ui-resizable-resizing')
            .removeData('resizable')
            .unbind('.resizable')
            .find('.ui-resizable-handle')
            .remove();
        };
        if (this.elementIsWrapper) {
          b(this.element);
          var c = this.element;
          c.after(
            this.originalElement.css({
              position: c.css('position'),
              width: c.outerWidth(),
              height: c.outerHeight(),
              top: c.css('top'),
              left: c.css('left'),
            }),
          ).remove();
        }
        return this.originalElement.css('resize', this.originalResizeStyle), b(this.originalElement), this;
      },
      _mouseCapture: function (b) {
        var c = !1;
        for (var d in this.handles) a(this.handles[d])[0] == b.target && (c = !0);
        return !this.options.disabled && c;
      },
      _mouseStart: function (b) {
        var d = this.options,
          e = this.element.position(),
          f = this.element;
        (this.resizing = !0),
          (this.documentScroll = { top: a(document).scrollTop(), left: a(document).scrollLeft() }),
          (f.is('.ui-draggable') || /absolute/.test(f.css('position'))) &&
            f.css({ position: 'absolute', top: e.top, left: e.left }),
          this._renderProxy();
        var g = c(this.helper.css('left')),
          h = c(this.helper.css('top'));
        d.containment && ((g += a(d.containment).scrollLeft() || 0), (h += a(d.containment).scrollTop() || 0)),
          (this.offset = this.helper.offset()),
          (this.position = { left: g, top: h }),
          (this.size = this._helper
            ? { width: f.outerWidth(), height: f.outerHeight() }
            : { width: f.width(), height: f.height() }),
          (this.originalSize = this._helper
            ? { width: f.outerWidth(), height: f.outerHeight() }
            : { width: f.width(), height: f.height() }),
          (this.originalPosition = { left: g, top: h }),
          (this.sizeDiff = { width: f.outerWidth() - f.width(), height: f.outerHeight() - f.height() }),
          (this.originalMousePosition = { left: b.pageX, top: b.pageY }),
          (this.aspectRatio =
            typeof d.aspectRatio == 'number' ? d.aspectRatio : this.originalSize.width / this.originalSize.height || 1);
        var i = a('.ui-resizable-' + this.axis).css('cursor');
        return (
          a('body').css('cursor', i == 'auto' ? this.axis + '-resize' : i),
          f.addClass('ui-resizable-resizing'),
          this._propagate('start', b),
          !0
        );
      },
      _mouseDrag: function (b) {
        var c = this.helper,
          d = this.options,
          e = {},
          f = this,
          g = this.originalMousePosition,
          h = this.axis,
          i = b.pageX - g.left || 0,
          j = b.pageY - g.top || 0,
          k = this._change[h];
        if (!k) return !1;
        var l = k.apply(this, [b, i, j]),
          m = a.browser.msie && a.browser.version < 7,
          n = this.sizeDiff;
        this._updateVirtualBoundaries(b.shiftKey);
        if (this._aspectRatio || b.shiftKey) l = this._updateRatio(l, b);
        return (
          (l = this._respectSize(l, b)),
          this._propagate('resize', b),
          c.css({
            top: this.position.top + 'px',
            left: this.position.left + 'px',
            width: this.size.width + 'px',
            height: this.size.height + 'px',
          }),
          !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(),
          this._updateCache(l),
          this._trigger('resize', b, this.ui()),
          !1
        );
      },
      _mouseStop: function (b) {
        this.resizing = !1;
        var c = this.options,
          d = this;
        if (this._helper) {
          var e = this._proportionallyResizeElements,
            f = e.length && /textarea/i.test(e[0].nodeName),
            g = f && a.ui.hasScroll(e[0], 'left') ? 0 : d.sizeDiff.height,
            h = f ? 0 : d.sizeDiff.width,
            i = { width: d.helper.width() - h, height: d.helper.height() - g },
            j = parseInt(d.element.css('left'), 10) + (d.position.left - d.originalPosition.left) || null,
            k = parseInt(d.element.css('top'), 10) + (d.position.top - d.originalPosition.top) || null;
          c.animate || this.element.css(a.extend(i, { top: k, left: j })),
            d.helper.height(d.size.height),
            d.helper.width(d.size.width),
            this._helper && !c.animate && this._proportionallyResize();
        }
        return (
          a('body').css('cursor', 'auto'),
          this.element.removeClass('ui-resizable-resizing'),
          this._propagate('stop', b),
          this._helper && this.helper.remove(),
          !1
        );
      },
      _updateVirtualBoundaries: function (a) {
        var b = this.options,
          c,
          e,
          f,
          g,
          h;
        h = {
          minWidth: d(b.minWidth) ? b.minWidth : 0,
          maxWidth: d(b.maxWidth) ? b.maxWidth : Infinity,
          minHeight: d(b.minHeight) ? b.minHeight : 0,
          maxHeight: d(b.maxHeight) ? b.maxHeight : Infinity,
        };
        if (this._aspectRatio || a)
          (c = h.minHeight * this.aspectRatio),
            (f = h.minWidth / this.aspectRatio),
            (e = h.maxHeight * this.aspectRatio),
            (g = h.maxWidth / this.aspectRatio),
            c > h.minWidth && (h.minWidth = c),
            f > h.minHeight && (h.minHeight = f),
            e < h.maxWidth && (h.maxWidth = e),
            g < h.maxHeight && (h.maxHeight = g);
        this._vBoundaries = h;
      },
      _updateCache: function (a) {
        var b = this.options;
        (this.offset = this.helper.offset()),
          d(a.left) && (this.position.left = a.left),
          d(a.top) && (this.position.top = a.top),
          d(a.height) && (this.size.height = a.height),
          d(a.width) && (this.size.width = a.width);
      },
      _updateRatio: function (a, b) {
        var c = this.options,
          e = this.position,
          f = this.size,
          g = this.axis;
        return (
          d(a.height) ? (a.width = a.height * this.aspectRatio) : d(a.width) && (a.height = a.width / this.aspectRatio),
          g == 'sw' && ((a.left = e.left + (f.width - a.width)), (a.top = null)),
          g == 'nw' && ((a.top = e.top + (f.height - a.height)), (a.left = e.left + (f.width - a.width))),
          a
        );
      },
      _respectSize: function (a, b) {
        var c = this.helper,
          e = this._vBoundaries,
          f = this._aspectRatio || b.shiftKey,
          g = this.axis,
          h = d(a.width) && e.maxWidth && e.maxWidth < a.width,
          i = d(a.height) && e.maxHeight && e.maxHeight < a.height,
          j = d(a.width) && e.minWidth && e.minWidth > a.width,
          k = d(a.height) && e.minHeight && e.minHeight > a.height;
        j && (a.width = e.minWidth),
          k && (a.height = e.minHeight),
          h && (a.width = e.maxWidth),
          i && (a.height = e.maxHeight);
        var l = this.originalPosition.left + this.originalSize.width,
          m = this.position.top + this.size.height,
          n = /sw|nw|w/.test(g),
          o = /nw|ne|n/.test(g);
        j && n && (a.left = l - e.minWidth),
          h && n && (a.left = l - e.maxWidth),
          k && o && (a.top = m - e.minHeight),
          i && o && (a.top = m - e.maxHeight);
        var p = !a.width && !a.height;
        return p && !a.left && a.top ? (a.top = null) : p && !a.top && a.left && (a.left = null), a;
      },
      _proportionallyResize: function () {
        var b = this.options;
        if (!this._proportionallyResizeElements.length) return;
        var c = this.helper || this.element;
        for (var d = 0; d < this._proportionallyResizeElements.length; d++) {
          var e = this._proportionallyResizeElements[d];
          if (!this.borderDif) {
            var f = [
                e.css('borderTopWidth'),
                e.css('borderRightWidth'),
                e.css('borderBottomWidth'),
                e.css('borderLeftWidth'),
              ],
              g = [e.css('paddingTop'), e.css('paddingRight'), e.css('paddingBottom'), e.css('paddingLeft')];
            this.borderDif = a.map(f, function (a, b) {
              var c = parseInt(a, 10) || 0,
                d = parseInt(g[b], 10) || 0;
              return c + d;
            });
          }
          if (!a.browser.msie || (!a(c).is(':hidden') && !a(c).parents(':hidden').length))
            e.css({
              height: c.height() - this.borderDif[0] - this.borderDif[2] || 0,
              width: c.width() - this.borderDif[1] - this.borderDif[3] || 0,
            });
          else continue;
        }
      },
      _renderProxy: function () {
        var b = this.element,
          c = this.options;
        this.elementOffset = b.offset();
        if (this._helper) {
          this.helper = this.helper || a('<div style="overflow:hidden;"></div>');
          var d = a.browser.msie && a.browser.version < 7,
            e = d ? 1 : 0,
            f = d ? 2 : -1;
          this.helper.addClass(this._helper).css({
            width: this.element.outerWidth() + f,
            height: this.element.outerHeight() + f,
            position: 'absolute',
            left: this.elementOffset.left - e + 'px',
            top: this.elementOffset.top - e + 'px',
            zIndex: ++c.zIndex,
          }),
            this.helper.appendTo('body').disableSelection();
        } else this.helper = this.element;
      },
      _change: {
        e: function (a, b, c) {
          return { width: this.originalSize.width + b };
        },
        w: function (a, b, c) {
          var d = this.options,
            e = this.originalSize,
            f = this.originalPosition;
          return { left: f.left + b, width: e.width - b };
        },
        n: function (a, b, c) {
          var d = this.options,
            e = this.originalSize,
            f = this.originalPosition;
          return { top: f.top + c, height: e.height - c };
        },
        s: function (a, b, c) {
          return { height: this.originalSize.height + c };
        },
        se: function (b, c, d) {
          return a.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [b, c, d]));
        },
        sw: function (b, c, d) {
          return a.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [b, c, d]));
        },
        ne: function (b, c, d) {
          return a.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [b, c, d]));
        },
        nw: function (b, c, d) {
          return a.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [b, c, d]));
        },
      },
      _propagate: function (b, c) {
        a.ui.plugin.call(this, b, [c, this.ui()]), b != 'resize' && this._trigger(b, c, this.ui());
      },
      plugins: {},
      ui: function () {
        return {
          originalElement: this.originalElement,
          element: this.element,
          helper: this.helper,
          position: this.position,
          size: this.size,
          originalSize: this.originalSize,
          originalPosition: this.originalPosition,
        };
      },
    }),
      a.extend(a.ui.resizable, { version: '1.8.24' }),
      a.ui.plugin.add('resizable', 'alsoResize', {
        start: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = function (b) {
              a(b).each(function () {
                var b = a(this);
                b.data('resizable-alsoresize', {
                  width: parseInt(b.width(), 10),
                  height: parseInt(b.height(), 10),
                  left: parseInt(b.css('left'), 10),
                  top: parseInt(b.css('top'), 10),
                });
              });
            };
          typeof e.alsoResize == 'object' && !e.alsoResize.parentNode
            ? e.alsoResize.length
              ? ((e.alsoResize = e.alsoResize[0]), f(e.alsoResize))
              : a.each(e.alsoResize, function (a) {
                  f(a);
                })
            : f(e.alsoResize);
        },
        resize: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = d.originalSize,
            g = d.originalPosition,
            h = {
              height: d.size.height - f.height || 0,
              width: d.size.width - f.width || 0,
              top: d.position.top - g.top || 0,
              left: d.position.left - g.left || 0,
            },
            i = function (b, d) {
              a(b).each(function () {
                var b = a(this),
                  e = a(this).data('resizable-alsoresize'),
                  f = {},
                  g =
                    d && d.length
                      ? d
                      : b.parents(c.originalElement[0]).length
                      ? ['width', 'height']
                      : ['width', 'height', 'top', 'left'];
                a.each(g, function (a, b) {
                  var c = (e[b] || 0) + (h[b] || 0);
                  c && c >= 0 && (f[b] = c || null);
                }),
                  b.css(f);
              });
            };
          typeof e.alsoResize == 'object' && !e.alsoResize.nodeType
            ? a.each(e.alsoResize, function (a, b) {
                i(a, b);
              })
            : i(e.alsoResize);
        },
        stop: function (b, c) {
          a(this).removeData('resizable-alsoresize');
        },
      }),
      a.ui.plugin.add('resizable', 'animate', {
        stop: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = d._proportionallyResizeElements,
            g = f.length && /textarea/i.test(f[0].nodeName),
            h = g && a.ui.hasScroll(f[0], 'left') ? 0 : d.sizeDiff.height,
            i = g ? 0 : d.sizeDiff.width,
            j = { width: d.size.width - i, height: d.size.height - h },
            k = parseInt(d.element.css('left'), 10) + (d.position.left - d.originalPosition.left) || null,
            l = parseInt(d.element.css('top'), 10) + (d.position.top - d.originalPosition.top) || null;
          d.element.animate(a.extend(j, l && k ? { top: l, left: k } : {}), {
            duration: e.animateDuration,
            easing: e.animateEasing,
            step: function () {
              var c = {
                width: parseInt(d.element.css('width'), 10),
                height: parseInt(d.element.css('height'), 10),
                top: parseInt(d.element.css('top'), 10),
                left: parseInt(d.element.css('left'), 10),
              };
              f && f.length && a(f[0]).css({ width: c.width, height: c.height }),
                d._updateCache(c),
                d._propagate('resize', b);
            },
          });
        },
      }),
      a.ui.plugin.add('resizable', 'containment', {
        start: function (b, d) {
          var e = a(this).data('resizable'),
            f = e.options,
            g = e.element,
            h = f.containment,
            i = h instanceof a ? h.get(0) : /parent/.test(h) ? g.parent().get(0) : h;
          if (!i) return;
          e.containerElement = a(i);
          if (/document/.test(h) || h == document)
            (e.containerOffset = { left: 0, top: 0 }),
              (e.containerPosition = { left: 0, top: 0 }),
              (e.parentData = {
                element: a(document),
                left: 0,
                top: 0,
                width: a(document).width(),
                height: a(document).height() || document.body.parentNode.scrollHeight,
              });
          else {
            var j = a(i),
              k = [];
            a(['Top', 'Right', 'Left', 'Bottom']).each(function (a, b) {
              k[a] = c(j.css('padding' + b));
            }),
              (e.containerOffset = j.offset()),
              (e.containerPosition = j.position()),
              (e.containerSize = { height: j.innerHeight() - k[3], width: j.innerWidth() - k[1] });
            var l = e.containerOffset,
              m = e.containerSize.height,
              n = e.containerSize.width,
              o = a.ui.hasScroll(i, 'left') ? i.scrollWidth : n,
              p = a.ui.hasScroll(i) ? i.scrollHeight : m;
            e.parentData = { element: i, left: l.left, top: l.top, width: o, height: p };
          }
        },
        resize: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = d.containerSize,
            g = d.containerOffset,
            h = d.size,
            i = d.position,
            j = d._aspectRatio || b.shiftKey,
            k = { top: 0, left: 0 },
            l = d.containerElement;
          l[0] != document && /static/.test(l.css('position')) && (k = g),
            i.left < (d._helper ? g.left : 0) &&
              ((d.size.width = d.size.width + (d._helper ? d.position.left - g.left : d.position.left - k.left)),
              j && (d.size.height = d.size.width / d.aspectRatio),
              (d.position.left = e.helper ? g.left : 0)),
            i.top < (d._helper ? g.top : 0) &&
              ((d.size.height = d.size.height + (d._helper ? d.position.top - g.top : d.position.top)),
              j && (d.size.width = d.size.height * d.aspectRatio),
              (d.position.top = d._helper ? g.top : 0)),
            (d.offset.left = d.parentData.left + d.position.left),
            (d.offset.top = d.parentData.top + d.position.top);
          var m = Math.abs((d._helper ? d.offset.left - k.left : d.offset.left - k.left) + d.sizeDiff.width),
            n = Math.abs((d._helper ? d.offset.top - k.top : d.offset.top - g.top) + d.sizeDiff.height),
            o = d.containerElement.get(0) == d.element.parent().get(0),
            p = /relative|absolute/.test(d.containerElement.css('position'));
          o && p && (m -= d.parentData.left),
            m + d.size.width >= d.parentData.width &&
              ((d.size.width = d.parentData.width - m), j && (d.size.height = d.size.width / d.aspectRatio)),
            n + d.size.height >= d.parentData.height &&
              ((d.size.height = d.parentData.height - n), j && (d.size.width = d.size.height * d.aspectRatio));
        },
        stop: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = d.position,
            g = d.containerOffset,
            h = d.containerPosition,
            i = d.containerElement,
            j = a(d.helper),
            k = j.offset(),
            l = j.outerWidth() - d.sizeDiff.width,
            m = j.outerHeight() - d.sizeDiff.height;
          d._helper &&
            !e.animate &&
            /relative/.test(i.css('position')) &&
            a(this).css({ left: k.left - h.left - g.left, width: l, height: m }),
            d._helper &&
              !e.animate &&
              /static/.test(i.css('position')) &&
              a(this).css({ left: k.left - h.left - g.left, width: l, height: m });
        },
      }),
      a.ui.plugin.add('resizable', 'ghost', {
        start: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = d.size;
          (d.ghost = d.originalElement.clone()),
            d.ghost
              .css({
                opacity: 0.25,
                display: 'block',
                position: 'relative',
                height: f.height,
                width: f.width,
                margin: 0,
                left: 0,
                top: 0,
              })
              .addClass('ui-resizable-ghost')
              .addClass(typeof e.ghost == 'string' ? e.ghost : ''),
            d.ghost.appendTo(d.helper);
        },
        resize: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options;
          d.ghost && d.ghost.css({ position: 'relative', height: d.size.height, width: d.size.width });
        },
        stop: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options;
          d.ghost && d.helper && d.helper.get(0).removeChild(d.ghost.get(0));
        },
      }),
      a.ui.plugin.add('resizable', 'grid', {
        resize: function (b, c) {
          var d = a(this).data('resizable'),
            e = d.options,
            f = d.size,
            g = d.originalSize,
            h = d.originalPosition,
            i = d.axis,
            j = e._aspectRatio || b.shiftKey;
          e.grid = typeof e.grid == 'number' ? [e.grid, e.grid] : e.grid;
          var k = Math.round((f.width - g.width) / (e.grid[0] || 1)) * (e.grid[0] || 1),
            l = Math.round((f.height - g.height) / (e.grid[1] || 1)) * (e.grid[1] || 1);
          /^(se|s|e)$/.test(i)
            ? ((d.size.width = g.width + k), (d.size.height = g.height + l))
            : /^(ne)$/.test(i)
            ? ((d.size.width = g.width + k), (d.size.height = g.height + l), (d.position.top = h.top - l))
            : /^(sw)$/.test(i)
            ? ((d.size.width = g.width + k), (d.size.height = g.height + l), (d.position.left = h.left - k))
            : ((d.size.width = g.width + k),
              (d.size.height = g.height + l),
              (d.position.top = h.top - l),
              (d.position.left = h.left - k));
        },
      });
    var c = function (a) {
        return parseInt(a, 10) || 0;
      },
      d = function (a) {
        return !isNaN(parseInt(a, 10));
      };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.selectable.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.selectable', a.ui.mouse, {
      options: { appendTo: 'body', autoRefresh: !0, distance: 0, filter: '*', tolerance: 'touch' },
      _create: function () {
        var b = this;
        this.element.addClass('ui-selectable'), (this.dragged = !1);
        var c;
        (this.refresh = function () {
          (c = a(b.options.filter, b.element[0])),
            c.addClass('ui-selectee'),
            c.each(function () {
              var b = a(this),
                c = b.offset();
              a.data(this, 'selectable-item', {
                element: this,
                $element: b,
                left: c.left,
                top: c.top,
                right: c.left + b.outerWidth(),
                bottom: c.top + b.outerHeight(),
                startselected: !1,
                selected: b.hasClass('ui-selected'),
                selecting: b.hasClass('ui-selecting'),
                unselecting: b.hasClass('ui-unselecting'),
              });
            });
        }),
          this.refresh(),
          (this.selectees = c.addClass('ui-selectee')),
          this._mouseInit(),
          (this.helper = a("<div class='ui-selectable-helper'></div>"));
      },
      destroy: function () {
        return (
          this.selectees.removeClass('ui-selectee').removeData('selectable-item'),
          this.element
            .removeClass('ui-selectable ui-selectable-disabled')
            .removeData('selectable')
            .unbind('.selectable'),
          this._mouseDestroy(),
          this
        );
      },
      _mouseStart: function (b) {
        var c = this;
        this.opos = [b.pageX, b.pageY];
        if (this.options.disabled) return;
        var d = this.options;
        (this.selectees = a(d.filter, this.element[0])),
          this._trigger('start', b),
          a(d.appendTo).append(this.helper),
          this.helper.css({ left: b.clientX, top: b.clientY, width: 0, height: 0 }),
          d.autoRefresh && this.refresh(),
          this.selectees.filter('.ui-selected').each(function () {
            var d = a.data(this, 'selectable-item');
            (d.startselected = !0),
              !b.metaKey &&
                !b.ctrlKey &&
                (d.$element.removeClass('ui-selected'),
                (d.selected = !1),
                d.$element.addClass('ui-unselecting'),
                (d.unselecting = !0),
                c._trigger('unselecting', b, { unselecting: d.element }));
          }),
          a(b.target)
            .parents()
            .andSelf()
            .each(function () {
              var d = a.data(this, 'selectable-item');
              if (d) {
                var e = (!b.metaKey && !b.ctrlKey) || !d.$element.hasClass('ui-selected');
                return (
                  d.$element
                    .removeClass(e ? 'ui-unselecting' : 'ui-selected')
                    .addClass(e ? 'ui-selecting' : 'ui-unselecting'),
                  (d.unselecting = !e),
                  (d.selecting = e),
                  (d.selected = e),
                  e
                    ? c._trigger('selecting', b, { selecting: d.element })
                    : c._trigger('unselecting', b, { unselecting: d.element }),
                  !1
                );
              }
            });
      },
      _mouseDrag: function (b) {
        var c = this;
        this.dragged = !0;
        if (this.options.disabled) return;
        var d = this.options,
          e = this.opos[0],
          f = this.opos[1],
          g = b.pageX,
          h = b.pageY;
        if (e > g) {
          var i = g;
          (g = e), (e = i);
        }
        if (f > h) {
          var i = h;
          (h = f), (f = i);
        }
        return (
          this.helper.css({ left: e, top: f, width: g - e, height: h - f }),
          this.selectees.each(function () {
            var i = a.data(this, 'selectable-item');
            if (!i || i.element == c.element[0]) return;
            var j = !1;
            d.tolerance == 'touch'
              ? (j = !(i.left > g || i.right < e || i.top > h || i.bottom < f))
              : d.tolerance == 'fit' && (j = i.left > e && i.right < g && i.top > f && i.bottom < h),
              j
                ? (i.selected && (i.$element.removeClass('ui-selected'), (i.selected = !1)),
                  i.unselecting && (i.$element.removeClass('ui-unselecting'), (i.unselecting = !1)),
                  i.selecting ||
                    (i.$element.addClass('ui-selecting'),
                    (i.selecting = !0),
                    c._trigger('selecting', b, { selecting: i.element })))
                : (i.selecting &&
                    ((b.metaKey || b.ctrlKey) && i.startselected
                      ? (i.$element.removeClass('ui-selecting'),
                        (i.selecting = !1),
                        i.$element.addClass('ui-selected'),
                        (i.selected = !0))
                      : (i.$element.removeClass('ui-selecting'),
                        (i.selecting = !1),
                        i.startselected && (i.$element.addClass('ui-unselecting'), (i.unselecting = !0)),
                        c._trigger('unselecting', b, { unselecting: i.element }))),
                  i.selected &&
                    !b.metaKey &&
                    !b.ctrlKey &&
                    !i.startselected &&
                    (i.$element.removeClass('ui-selected'),
                    (i.selected = !1),
                    i.$element.addClass('ui-unselecting'),
                    (i.unselecting = !0),
                    c._trigger('unselecting', b, { unselecting: i.element })));
          }),
          !1
        );
      },
      _mouseStop: function (b) {
        var c = this;
        this.dragged = !1;
        var d = this.options;
        return (
          a('.ui-unselecting', this.element[0]).each(function () {
            var d = a.data(this, 'selectable-item');
            d.$element.removeClass('ui-unselecting'),
              (d.unselecting = !1),
              (d.startselected = !1),
              c._trigger('unselected', b, { unselected: d.element });
          }),
          a('.ui-selecting', this.element[0]).each(function () {
            var d = a.data(this, 'selectable-item');
            d.$element.removeClass('ui-selecting').addClass('ui-selected'),
              (d.selecting = !1),
              (d.selected = !0),
              (d.startselected = !0),
              c._trigger('selected', b, { selected: d.element });
          }),
          this._trigger('stop', b),
          this.helper.remove(),
          !1
        );
      },
    }),
      a.extend(a.ui.selectable, { version: '1.8.24' });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.sortable.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.sortable', a.ui.mouse, {
      widgetEventPrefix: 'sort',
      ready: !1,
      options: {
        appendTo: 'parent',
        axis: !1,
        connectWith: !1,
        containment: !1,
        cursor: 'auto',
        cursorAt: !1,
        dropOnEmpty: !0,
        forcePlaceholderSize: !1,
        forceHelperSize: !1,
        grid: !1,
        handle: !1,
        helper: 'original',
        items: '> *',
        opacity: !1,
        placeholder: !1,
        revert: !1,
        scroll: !0,
        scrollSensitivity: 20,
        scrollSpeed: 20,
        scope: 'default',
        tolerance: 'intersect',
        zIndex: 1e3,
      },
      _create: function () {
        var a = this.options;
        (this.containerCache = {}),
          this.element.addClass('ui-sortable'),
          this.refresh(),
          (this.floating = this.items.length
            ? a.axis === 'x' ||
              /left|right/.test(this.items[0].item.css('float')) ||
              /inline|table-cell/.test(this.items[0].item.css('display'))
            : !1),
          (this.offset = this.element.offset()),
          this._mouseInit(),
          (this.ready = !0);
      },
      destroy: function () {
        a.Widget.prototype.destroy.call(this),
          this.element.removeClass('ui-sortable ui-sortable-disabled'),
          this._mouseDestroy();
        for (var b = this.items.length - 1; b >= 0; b--) this.items[b].item.removeData(this.widgetName + '-item');
        return this;
      },
      _setOption: function (b, c) {
        b === 'disabled'
          ? ((this.options[b] = c), this.widget()[c ? 'addClass' : 'removeClass']('ui-sortable-disabled'))
          : a.Widget.prototype._setOption.apply(this, arguments);
      },
      _mouseCapture: function (b, c) {
        var d = this;
        if (this.reverting) return !1;
        if (this.options.disabled || this.options.type == 'static') return !1;
        this._refreshItems(b);
        var e = null,
          f = this,
          g = a(b.target)
            .parents()
            .each(function () {
              if (a.data(this, d.widgetName + '-item') == f) return (e = a(this)), !1;
            });
        a.data(b.target, d.widgetName + '-item') == f && (e = a(b.target));
        if (!e) return !1;
        if (this.options.handle && !c) {
          var h = !1;
          a(this.options.handle, e)
            .find('*')
            .andSelf()
            .each(function () {
              this == b.target && (h = !0);
            });
          if (!h) return !1;
        }
        return (this.currentItem = e), this._removeCurrentsFromItems(), !0;
      },
      _mouseStart: function (b, c, d) {
        var e = this.options,
          f = this;
        (this.currentContainer = this),
          this.refreshPositions(),
          (this.helper = this._createHelper(b)),
          this._cacheHelperProportions(),
          this._cacheMargins(),
          (this.scrollParent = this.helper.scrollParent()),
          (this.offset = this.currentItem.offset()),
          (this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left }),
          a.extend(this.offset, {
            click: { left: b.pageX - this.offset.left, top: b.pageY - this.offset.top },
            parent: this._getParentOffset(),
            relative: this._getRelativeOffset(),
          }),
          this.helper.css('position', 'absolute'),
          (this.cssPosition = this.helper.css('position')),
          (this.originalPosition = this._generatePosition(b)),
          (this.originalPageX = b.pageX),
          (this.originalPageY = b.pageY),
          e.cursorAt && this._adjustOffsetFromHelper(e.cursorAt),
          (this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] }),
          this.helper[0] != this.currentItem[0] && this.currentItem.hide(),
          this._createPlaceholder(),
          e.containment && this._setContainment(),
          e.cursor &&
            (a('body').css('cursor') && (this._storedCursor = a('body').css('cursor')),
            a('body').css('cursor', e.cursor)),
          e.opacity &&
            (this.helper.css('opacity') && (this._storedOpacity = this.helper.css('opacity')),
            this.helper.css('opacity', e.opacity)),
          e.zIndex &&
            (this.helper.css('zIndex') && (this._storedZIndex = this.helper.css('zIndex')),
            this.helper.css('zIndex', e.zIndex)),
          this.scrollParent[0] != document &&
            this.scrollParent[0].tagName != 'HTML' &&
            (this.overflowOffset = this.scrollParent.offset()),
          this._trigger('start', b, this._uiHash()),
          this._preserveHelperProportions || this._cacheHelperProportions();
        if (!d)
          for (var g = this.containers.length - 1; g >= 0; g--)
            this.containers[g]._trigger('activate', b, f._uiHash(this));
        return (
          a.ui.ddmanager && (a.ui.ddmanager.current = this),
          a.ui.ddmanager && !e.dropBehaviour && a.ui.ddmanager.prepareOffsets(this, b),
          (this.dragging = !0),
          this.helper.addClass('ui-sortable-helper'),
          this._mouseDrag(b),
          !0
        );
      },
      _mouseDrag: function (b) {
        (this.position = this._generatePosition(b)),
          (this.positionAbs = this._convertPositionTo('absolute')),
          this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs);
        if (this.options.scroll) {
          var c = this.options,
            d = !1;
          this.scrollParent[0] != document && this.scrollParent[0].tagName != 'HTML'
            ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - b.pageY < c.scrollSensitivity
                ? (this.scrollParent[0].scrollTop = d = this.scrollParent[0].scrollTop + c.scrollSpeed)
                : b.pageY - this.overflowOffset.top < c.scrollSensitivity &&
                  (this.scrollParent[0].scrollTop = d = this.scrollParent[0].scrollTop - c.scrollSpeed),
              this.overflowOffset.left + this.scrollParent[0].offsetWidth - b.pageX < c.scrollSensitivity
                ? (this.scrollParent[0].scrollLeft = d = this.scrollParent[0].scrollLeft + c.scrollSpeed)
                : b.pageX - this.overflowOffset.left < c.scrollSensitivity &&
                  (this.scrollParent[0].scrollLeft = d = this.scrollParent[0].scrollLeft - c.scrollSpeed))
            : (b.pageY - a(document).scrollTop() < c.scrollSensitivity
                ? (d = a(document).scrollTop(a(document).scrollTop() - c.scrollSpeed))
                : a(window).height() - (b.pageY - a(document).scrollTop()) < c.scrollSensitivity &&
                  (d = a(document).scrollTop(a(document).scrollTop() + c.scrollSpeed)),
              b.pageX - a(document).scrollLeft() < c.scrollSensitivity
                ? (d = a(document).scrollLeft(a(document).scrollLeft() - c.scrollSpeed))
                : a(window).width() - (b.pageX - a(document).scrollLeft()) < c.scrollSensitivity &&
                  (d = a(document).scrollLeft(a(document).scrollLeft() + c.scrollSpeed))),
            d !== !1 && a.ui.ddmanager && !c.dropBehaviour && a.ui.ddmanager.prepareOffsets(this, b);
        }
        this.positionAbs = this._convertPositionTo('absolute');
        if (!this.options.axis || this.options.axis != 'y') this.helper[0].style.left = this.position.left + 'px';
        if (!this.options.axis || this.options.axis != 'x') this.helper[0].style.top = this.position.top + 'px';
        for (var e = this.items.length - 1; e >= 0; e--) {
          var f = this.items[e],
            g = f.item[0],
            h = this._intersectsWithPointer(f);
          if (!h) continue;
          if (f.instance !== this.currentContainer) continue;
          if (
            g != this.currentItem[0] &&
            this.placeholder[h == 1 ? 'next' : 'prev']()[0] != g &&
            !a.ui.contains(this.placeholder[0], g) &&
            (this.options.type == 'semi-dynamic' ? !a.ui.contains(this.element[0], g) : !0)
          ) {
            this.direction = h == 1 ? 'down' : 'up';
            if (this.options.tolerance == 'pointer' || this._intersectsWithSides(f)) this._rearrange(b, f);
            else break;
            this._trigger('change', b, this._uiHash());
            break;
          }
        }
        return (
          this._contactContainers(b),
          a.ui.ddmanager && a.ui.ddmanager.drag(this, b),
          this._trigger('sort', b, this._uiHash()),
          (this.lastPositionAbs = this.positionAbs),
          !1
        );
      },
      _mouseStop: function (b, c) {
        if (!b) return;
        a.ui.ddmanager && !this.options.dropBehaviour && a.ui.ddmanager.drop(this, b);
        if (this.options.revert) {
          var d = this,
            e = d.placeholder.offset();
          (d.reverting = !0),
            a(this.helper).animate(
              {
                left:
                  e.left -
                  this.offset.parent.left -
                  d.margins.left +
                  (this.offsetParent[0] == document.body ? 0 : this.offsetParent[0].scrollLeft),
                top:
                  e.top -
                  this.offset.parent.top -
                  d.margins.top +
                  (this.offsetParent[0] == document.body ? 0 : this.offsetParent[0].scrollTop),
              },
              parseInt(this.options.revert, 10) || 500,
              function () {
                d._clear(b);
              },
            );
        } else this._clear(b, c);
        return !1;
      },
      cancel: function () {
        var b = this;
        if (this.dragging) {
          this._mouseUp({ target: null }),
            this.options.helper == 'original'
              ? this.currentItem.css(this._storedCSS).removeClass('ui-sortable-helper')
              : this.currentItem.show();
          for (var c = this.containers.length - 1; c >= 0; c--)
            this.containers[c]._trigger('deactivate', null, b._uiHash(this)),
              this.containers[c].containerCache.over &&
                (this.containers[c]._trigger('out', null, b._uiHash(this)),
                (this.containers[c].containerCache.over = 0));
        }
        return (
          this.placeholder &&
            (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]),
            this.options.helper != 'original' && this.helper && this.helper[0].parentNode && this.helper.remove(),
            a.extend(this, { helper: null, dragging: !1, reverting: !1, _noFinalSort: null }),
            this.domPosition.prev
              ? a(this.domPosition.prev).after(this.currentItem)
              : a(this.domPosition.parent).prepend(this.currentItem)),
          this
        );
      },
      serialize: function (b) {
        var c = this._getItemsAsjQuery(b && b.connected),
          d = [];
        return (
          (b = b || {}),
          a(c).each(function () {
            var c = (a(b.item || this).attr(b.attribute || 'id') || '').match(b.expression || /(.+)[-=_](.+)/);
            c && d.push((b.key || c[1] + '[]') + '=' + (b.key && b.expression ? c[1] : c[2]));
          }),
          !d.length && b.key && d.push(b.key + '='),
          d.join('&')
        );
      },
      toArray: function (b) {
        var c = this._getItemsAsjQuery(b && b.connected),
          d = [];
        return (
          (b = b || {}),
          c.each(function () {
            d.push(a(b.item || this).attr(b.attribute || 'id') || '');
          }),
          d
        );
      },
      _intersectsWith: function (a) {
        var b = this.positionAbs.left,
          c = b + this.helperProportions.width,
          d = this.positionAbs.top,
          e = d + this.helperProportions.height,
          f = a.left,
          g = f + a.width,
          h = a.top,
          i = h + a.height,
          j = this.offset.click.top,
          k = this.offset.click.left,
          l = d + j > h && d + j < i && b + k > f && b + k < g;
        return this.options.tolerance == 'pointer' ||
          this.options.forcePointerForContainers ||
          (this.options.tolerance != 'pointer' &&
            this.helperProportions[this.floating ? 'width' : 'height'] > a[this.floating ? 'width' : 'height'])
          ? l
          : f < b + this.helperProportions.width / 2 &&
              c - this.helperProportions.width / 2 < g &&
              h < d + this.helperProportions.height / 2 &&
              e - this.helperProportions.height / 2 < i;
      },
      _intersectsWithPointer: function (b) {
        var c =
            this.options.axis === 'x' || a.ui.isOverAxis(this.positionAbs.top + this.offset.click.top, b.top, b.height),
          d =
            this.options.axis === 'y' ||
            a.ui.isOverAxis(this.positionAbs.left + this.offset.click.left, b.left, b.width),
          e = c && d,
          f = this._getDragVerticalDirection(),
          g = this._getDragHorizontalDirection();
        return e ? (this.floating ? ((g && g == 'right') || f == 'down' ? 2 : 1) : f && (f == 'down' ? 2 : 1)) : !1;
      },
      _intersectsWithSides: function (b) {
        var c = a.ui.isOverAxis(this.positionAbs.top + this.offset.click.top, b.top + b.height / 2, b.height),
          d = a.ui.isOverAxis(this.positionAbs.left + this.offset.click.left, b.left + b.width / 2, b.width),
          e = this._getDragVerticalDirection(),
          f = this._getDragHorizontalDirection();
        return this.floating && f
          ? (f == 'right' && d) || (f == 'left' && !d)
          : e && ((e == 'down' && c) || (e == 'up' && !c));
      },
      _getDragVerticalDirection: function () {
        var a = this.positionAbs.top - this.lastPositionAbs.top;
        return a != 0 && (a > 0 ? 'down' : 'up');
      },
      _getDragHorizontalDirection: function () {
        var a = this.positionAbs.left - this.lastPositionAbs.left;
        return a != 0 && (a > 0 ? 'right' : 'left');
      },
      refresh: function (a) {
        return this._refreshItems(a), this.refreshPositions(), this;
      },
      _connectWith: function () {
        var a = this.options;
        return a.connectWith.constructor == String ? [a.connectWith] : a.connectWith;
      },
      _getItemsAsjQuery: function (b) {
        var c = this,
          d = [],
          e = [],
          f = this._connectWith();
        if (f && b)
          for (var g = f.length - 1; g >= 0; g--) {
            var h = a(f[g]);
            for (var i = h.length - 1; i >= 0; i--) {
              var j = a.data(h[i], this.widgetName);
              j &&
                j != this &&
                !j.options.disabled &&
                e.push([
                  a.isFunction(j.options.items)
                    ? j.options.items.call(j.element)
                    : a(j.options.items, j.element).not('.ui-sortable-helper').not('.ui-sortable-placeholder'),
                  j,
                ]);
            }
          }
        e.push([
          a.isFunction(this.options.items)
            ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem })
            : a(this.options.items, this.element).not('.ui-sortable-helper').not('.ui-sortable-placeholder'),
          this,
        ]);
        for (var g = e.length - 1; g >= 0; g--)
          e[g][0].each(function () {
            d.push(this);
          });
        return a(d);
      },
      _removeCurrentsFromItems: function () {
        var a = this.currentItem.find(':data(' + this.widgetName + '-item)');
        for (var b = 0; b < this.items.length; b++)
          for (var c = 0; c < a.length; c++) a[c] == this.items[b].item[0] && this.items.splice(b, 1);
      },
      _refreshItems: function (b) {
        (this.items = []), (this.containers = [this]);
        var c = this.items,
          d = this,
          e = [
            [
              a.isFunction(this.options.items)
                ? this.options.items.call(this.element[0], b, { item: this.currentItem })
                : a(this.options.items, this.element),
              this,
            ],
          ],
          f = this._connectWith();
        if (f && this.ready)
          for (var g = f.length - 1; g >= 0; g--) {
            var h = a(f[g]);
            for (var i = h.length - 1; i >= 0; i--) {
              var j = a.data(h[i], this.widgetName);
              j &&
                j != this &&
                !j.options.disabled &&
                (e.push([
                  a.isFunction(j.options.items)
                    ? j.options.items.call(j.element[0], b, { item: this.currentItem })
                    : a(j.options.items, j.element),
                  j,
                ]),
                this.containers.push(j));
            }
          }
        for (var g = e.length - 1; g >= 0; g--) {
          var k = e[g][1],
            l = e[g][0];
          for (var i = 0, m = l.length; i < m; i++) {
            var n = a(l[i]);
            n.data(this.widgetName + '-item', k),
              c.push({ item: n, instance: k, width: 0, height: 0, left: 0, top: 0 });
          }
        }
      },
      refreshPositions: function (b) {
        this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset());
        for (var c = this.items.length - 1; c >= 0; c--) {
          var d = this.items[c];
          if (d.instance != this.currentContainer && this.currentContainer && d.item[0] != this.currentItem[0])
            continue;
          var e = this.options.toleranceElement ? a(this.options.toleranceElement, d.item) : d.item;
          b || ((d.width = e.outerWidth()), (d.height = e.outerHeight()));
          var f = e.offset();
          (d.left = f.left), (d.top = f.top);
        }
        if (this.options.custom && this.options.custom.refreshContainers)
          this.options.custom.refreshContainers.call(this);
        else
          for (var c = this.containers.length - 1; c >= 0; c--) {
            var f = this.containers[c].element.offset();
            (this.containers[c].containerCache.left = f.left),
              (this.containers[c].containerCache.top = f.top),
              (this.containers[c].containerCache.width = this.containers[c].element.outerWidth()),
              (this.containers[c].containerCache.height = this.containers[c].element.outerHeight());
          }
        return this;
      },
      _createPlaceholder: function (b) {
        var c = b || this,
          d = c.options;
        if (!d.placeholder || d.placeholder.constructor == String) {
          var e = d.placeholder;
          d.placeholder = {
            element: function () {
              var b = a(document.createElement(c.currentItem[0].nodeName))
                .addClass(e || c.currentItem[0].className + ' ui-sortable-placeholder')
                .removeClass('ui-sortable-helper')[0];
              return e || (b.style.visibility = 'hidden'), b;
            },
            update: function (a, b) {
              if (e && !d.forcePlaceholderSize) return;
              b.height() ||
                b.height(
                  c.currentItem.innerHeight() -
                    parseInt(c.currentItem.css('paddingTop') || 0, 10) -
                    parseInt(c.currentItem.css('paddingBottom') || 0, 10),
                ),
                b.width() ||
                  b.width(
                    c.currentItem.innerWidth() -
                      parseInt(c.currentItem.css('paddingLeft') || 0, 10) -
                      parseInt(c.currentItem.css('paddingRight') || 0, 10),
                  );
            },
          };
        }
        (c.placeholder = a(d.placeholder.element.call(c.element, c.currentItem))),
          c.currentItem.after(c.placeholder),
          d.placeholder.update(c, c.placeholder);
      },
      _contactContainers: function (b) {
        var c = null,
          d = null;
        for (var e = this.containers.length - 1; e >= 0; e--) {
          if (a.ui.contains(this.currentItem[0], this.containers[e].element[0])) continue;
          if (this._intersectsWith(this.containers[e].containerCache)) {
            if (c && a.ui.contains(this.containers[e].element[0], c.element[0])) continue;
            (c = this.containers[e]), (d = e);
          } else
            this.containers[e].containerCache.over &&
              (this.containers[e]._trigger('out', b, this._uiHash(this)), (this.containers[e].containerCache.over = 0));
        }
        if (!c) return;
        if (this.containers.length === 1)
          this.containers[d]._trigger('over', b, this._uiHash(this)), (this.containers[d].containerCache.over = 1);
        else if (this.currentContainer != this.containers[d]) {
          var f = 1e4,
            g = null,
            h = this.positionAbs[this.containers[d].floating ? 'left' : 'top'];
          for (var i = this.items.length - 1; i >= 0; i--) {
            if (!a.ui.contains(this.containers[d].element[0], this.items[i].item[0])) continue;
            var j = this.containers[d].floating ? this.items[i].item.offset().left : this.items[i].item.offset().top;
            Math.abs(j - h) < f &&
              ((f = Math.abs(j - h)), (g = this.items[i]), (this.direction = j - h > 0 ? 'down' : 'up'));
          }
          if (!g && !this.options.dropOnEmpty) return;
          (this.currentContainer = this.containers[d]),
            g ? this._rearrange(b, g, null, !0) : this._rearrange(b, null, this.containers[d].element, !0),
            this._trigger('change', b, this._uiHash()),
            this.containers[d]._trigger('change', b, this._uiHash(this)),
            this.options.placeholder.update(this.currentContainer, this.placeholder),
            this.containers[d]._trigger('over', b, this._uiHash(this)),
            (this.containers[d].containerCache.over = 1);
        }
      },
      _createHelper: function (b) {
        var c = this.options,
          d = a.isFunction(c.helper)
            ? a(c.helper.apply(this.element[0], [b, this.currentItem]))
            : c.helper == 'clone'
            ? this.currentItem.clone()
            : this.currentItem;
        return (
          d.parents('body').length ||
            a(c.appendTo != 'parent' ? c.appendTo : this.currentItem[0].parentNode)[0].appendChild(d[0]),
          d[0] == this.currentItem[0] &&
            (this._storedCSS = {
              width: this.currentItem[0].style.width,
              height: this.currentItem[0].style.height,
              position: this.currentItem.css('position'),
              top: this.currentItem.css('top'),
              left: this.currentItem.css('left'),
            }),
          (d[0].style.width == '' || c.forceHelperSize) && d.width(this.currentItem.width()),
          (d[0].style.height == '' || c.forceHelperSize) && d.height(this.currentItem.height()),
          d
        );
      },
      _adjustOffsetFromHelper: function (b) {
        typeof b == 'string' && (b = b.split(' ')),
          a.isArray(b) && (b = { left: +b[0], top: +b[1] || 0 }),
          'left' in b && (this.offset.click.left = b.left + this.margins.left),
          'right' in b && (this.offset.click.left = this.helperProportions.width - b.right + this.margins.left),
          'top' in b && (this.offset.click.top = b.top + this.margins.top),
          'bottom' in b && (this.offset.click.top = this.helperProportions.height - b.bottom + this.margins.top);
      },
      _getParentOffset: function () {
        this.offsetParent = this.helper.offsetParent();
        var b = this.offsetParent.offset();
        this.cssPosition == 'absolute' &&
          this.scrollParent[0] != document &&
          a.ui.contains(this.scrollParent[0], this.offsetParent[0]) &&
          ((b.left += this.scrollParent.scrollLeft()), (b.top += this.scrollParent.scrollTop()));
        if (
          this.offsetParent[0] == document.body ||
          (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() == 'html' && a.browser.msie)
        )
          b = { top: 0, left: 0 };
        return {
          top: b.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
          left: b.left + (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
        };
      },
      _getRelativeOffset: function () {
        if (this.cssPosition == 'relative') {
          var a = this.currentItem.position();
          return {
            top: a.top - (parseInt(this.helper.css('top'), 10) || 0) + this.scrollParent.scrollTop(),
            left: a.left - (parseInt(this.helper.css('left'), 10) || 0) + this.scrollParent.scrollLeft(),
          };
        }
        return { top: 0, left: 0 };
      },
      _cacheMargins: function () {
        this.margins = {
          left: parseInt(this.currentItem.css('marginLeft'), 10) || 0,
          top: parseInt(this.currentItem.css('marginTop'), 10) || 0,
        };
      },
      _cacheHelperProportions: function () {
        this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
      },
      _setContainment: function () {
        var b = this.options;
        b.containment == 'parent' && (b.containment = this.helper[0].parentNode);
        if (b.containment == 'document' || b.containment == 'window')
          this.containment = [
            0 - this.offset.relative.left - this.offset.parent.left,
            0 - this.offset.relative.top - this.offset.parent.top,
            a(b.containment == 'document' ? document : window).width() -
              this.helperProportions.width -
              this.margins.left,
            (a(b.containment == 'document' ? document : window).height() || document.body.parentNode.scrollHeight) -
              this.helperProportions.height -
              this.margins.top,
          ];
        if (!/^(document|window|parent)$/.test(b.containment)) {
          var c = a(b.containment)[0],
            d = a(b.containment).offset(),
            e = a(c).css('overflow') != 'hidden';
          this.containment = [
            d.left +
              (parseInt(a(c).css('borderLeftWidth'), 10) || 0) +
              (parseInt(a(c).css('paddingLeft'), 10) || 0) -
              this.margins.left,
            d.top +
              (parseInt(a(c).css('borderTopWidth'), 10) || 0) +
              (parseInt(a(c).css('paddingTop'), 10) || 0) -
              this.margins.top,
            d.left +
              (e ? Math.max(c.scrollWidth, c.offsetWidth) : c.offsetWidth) -
              (parseInt(a(c).css('borderLeftWidth'), 10) || 0) -
              (parseInt(a(c).css('paddingRight'), 10) || 0) -
              this.helperProportions.width -
              this.margins.left,
            d.top +
              (e ? Math.max(c.scrollHeight, c.offsetHeight) : c.offsetHeight) -
              (parseInt(a(c).css('borderTopWidth'), 10) || 0) -
              (parseInt(a(c).css('paddingBottom'), 10) || 0) -
              this.helperProportions.height -
              this.margins.top,
          ];
        }
      },
      _convertPositionTo: function (b, c) {
        c || (c = this.position);
        var d = b == 'absolute' ? 1 : -1,
          e = this.options,
          f =
            this.cssPosition == 'absolute' &&
            (this.scrollParent[0] == document || !a.ui.contains(this.scrollParent[0], this.offsetParent[0]))
              ? this.offsetParent
              : this.scrollParent,
          g = /(html|body)/i.test(f[0].tagName);
        return {
          top:
            c.top +
            this.offset.relative.top * d +
            this.offset.parent.top * d -
            (a.browser.safari && this.cssPosition == 'fixed'
              ? 0
              : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : g ? 0 : f.scrollTop()) * d),
          left:
            c.left +
            this.offset.relative.left * d +
            this.offset.parent.left * d -
            (a.browser.safari && this.cssPosition == 'fixed'
              ? 0
              : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : g ? 0 : f.scrollLeft()) * d),
        };
      },
      _generatePosition: function (b) {
        var c = this.options,
          d =
            this.cssPosition == 'absolute' &&
            (this.scrollParent[0] == document || !a.ui.contains(this.scrollParent[0], this.offsetParent[0]))
              ? this.offsetParent
              : this.scrollParent,
          e = /(html|body)/i.test(d[0].tagName);
        this.cssPosition == 'relative' &&
          (this.scrollParent[0] == document || this.scrollParent[0] == this.offsetParent[0]) &&
          (this.offset.relative = this._getRelativeOffset());
        var f = b.pageX,
          g = b.pageY;
        if (this.originalPosition) {
          this.containment &&
            (b.pageX - this.offset.click.left < this.containment[0] &&
              (f = this.containment[0] + this.offset.click.left),
            b.pageY - this.offset.click.top < this.containment[1] && (g = this.containment[1] + this.offset.click.top),
            b.pageX - this.offset.click.left > this.containment[2] &&
              (f = this.containment[2] + this.offset.click.left),
            b.pageY - this.offset.click.top > this.containment[3] && (g = this.containment[3] + this.offset.click.top));
          if (c.grid) {
            var h = this.originalPageY + Math.round((g - this.originalPageY) / c.grid[1]) * c.grid[1];
            g = this.containment
              ? h - this.offset.click.top < this.containment[1] || h - this.offset.click.top > this.containment[3]
                ? h - this.offset.click.top < this.containment[1]
                  ? h + c.grid[1]
                  : h - c.grid[1]
                : h
              : h;
            var i = this.originalPageX + Math.round((f - this.originalPageX) / c.grid[0]) * c.grid[0];
            f = this.containment
              ? i - this.offset.click.left < this.containment[0] || i - this.offset.click.left > this.containment[2]
                ? i - this.offset.click.left < this.containment[0]
                  ? i + c.grid[0]
                  : i - c.grid[0]
                : i
              : i;
          }
        }
        return {
          top:
            g -
            this.offset.click.top -
            this.offset.relative.top -
            this.offset.parent.top +
            (a.browser.safari && this.cssPosition == 'fixed'
              ? 0
              : this.cssPosition == 'fixed'
              ? -this.scrollParent.scrollTop()
              : e
              ? 0
              : d.scrollTop()),
          left:
            f -
            this.offset.click.left -
            this.offset.relative.left -
            this.offset.parent.left +
            (a.browser.safari && this.cssPosition == 'fixed'
              ? 0
              : this.cssPosition == 'fixed'
              ? -this.scrollParent.scrollLeft()
              : e
              ? 0
              : d.scrollLeft()),
        };
      },
      _rearrange: function (a, b, c, d) {
        c
          ? c[0].appendChild(this.placeholder[0])
          : b.item[0].parentNode.insertBefore(
              this.placeholder[0],
              this.direction == 'down' ? b.item[0] : b.item[0].nextSibling,
            ),
          (this.counter = this.counter ? ++this.counter : 1);
        var e = this,
          f = this.counter;
        window.setTimeout(function () {
          f == e.counter && e.refreshPositions(!d);
        }, 0);
      },
      _clear: function (b, c) {
        this.reverting = !1;
        var d = [],
          e = this;
        !this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem),
          (this._noFinalSort = null);
        if (this.helper[0] == this.currentItem[0]) {
          for (var f in this._storedCSS)
            if (this._storedCSS[f] == 'auto' || this._storedCSS[f] == 'static') this._storedCSS[f] = '';
          this.currentItem.css(this._storedCSS).removeClass('ui-sortable-helper');
        } else this.currentItem.show();
        this.fromOutside &&
          !c &&
          d.push(function (a) {
            this._trigger('receive', a, this._uiHash(this.fromOutside));
          }),
          (this.fromOutside ||
            this.domPosition.prev != this.currentItem.prev().not('.ui-sortable-helper')[0] ||
            this.domPosition.parent != this.currentItem.parent()[0]) &&
            !c &&
            d.push(function (a) {
              this._trigger('update', a, this._uiHash());
            }),
          this !== this.currentContainer &&
            (c ||
              (d.push(function (a) {
                this._trigger('remove', a, this._uiHash());
              }),
              d.push(
                function (a) {
                  return function (b) {
                    a._trigger('receive', b, this._uiHash(this));
                  };
                }.call(this, this.currentContainer),
              ),
              d.push(
                function (a) {
                  return function (b) {
                    a._trigger('update', b, this._uiHash(this));
                  };
                }.call(this, this.currentContainer),
              )));
        for (var f = this.containers.length - 1; f >= 0; f--)
          c ||
            d.push(
              function (a) {
                return function (b) {
                  a._trigger('deactivate', b, this._uiHash(this));
                };
              }.call(this, this.containers[f]),
            ),
            this.containers[f].containerCache.over &&
              (d.push(
                function (a) {
                  return function (b) {
                    a._trigger('out', b, this._uiHash(this));
                  };
                }.call(this, this.containers[f]),
              ),
              (this.containers[f].containerCache.over = 0));
        this._storedCursor && a('body').css('cursor', this._storedCursor),
          this._storedOpacity && this.helper.css('opacity', this._storedOpacity),
          this._storedZIndex && this.helper.css('zIndex', this._storedZIndex == 'auto' ? '' : this._storedZIndex),
          (this.dragging = !1);
        if (this.cancelHelperRemoval) {
          if (!c) {
            this._trigger('beforeStop', b, this._uiHash());
            for (var f = 0; f < d.length; f++) d[f].call(this, b);
            this._trigger('stop', b, this._uiHash());
          }
          return (this.fromOutside = !1), !1;
        }
        c || this._trigger('beforeStop', b, this._uiHash()),
          this.placeholder[0].parentNode.removeChild(this.placeholder[0]),
          this.helper[0] != this.currentItem[0] && this.helper.remove(),
          (this.helper = null);
        if (!c) {
          for (var f = 0; f < d.length; f++) d[f].call(this, b);
          this._trigger('stop', b, this._uiHash());
        }
        return (this.fromOutside = !1), !0;
      },
      _trigger: function () {
        a.Widget.prototype._trigger.apply(this, arguments) === !1 && this.cancel();
      },
      _uiHash: function (b) {
        var c = b || this;
        return {
          helper: c.helper,
          placeholder: c.placeholder || a([]),
          position: c.position,
          originalPosition: c.originalPosition,
          offset: c.positionAbs,
          item: c.currentItem,
          sender: b ? b.element : null,
        };
      },
    }),
      a.extend(a.ui.sortable, { version: '1.8.24' });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.accordion.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.accordion', {
      options: {
        active: 0,
        animated: 'slide',
        autoHeight: !0,
        clearStyle: !1,
        collapsible: !1,
        event: 'click',
        fillSpace: !1,
        header: '> li > :first-child,> :not(li):even',
        icons: { header: 'ui-icon-triangle-1-e', headerSelected: 'ui-icon-triangle-1-s' },
        navigation: !1,
        navigationFilter: function () {
          return this.href.toLowerCase() === location.href.toLowerCase();
        },
      },
      _create: function () {
        var b = this,
          c = b.options;
        (b.running = 0),
          b.element.addClass('ui-accordion ui-widget ui-helper-reset').children('li').addClass('ui-accordion-li-fix'),
          (b.headers = b.element
            .find(c.header)
            .addClass('ui-accordion-header ui-helper-reset ui-state-default ui-corner-all')
            .bind('mouseenter.accordion', function () {
              if (c.disabled) return;
              a(this).addClass('ui-state-hover');
            })
            .bind('mouseleave.accordion', function () {
              if (c.disabled) return;
              a(this).removeClass('ui-state-hover');
            })
            .bind('focus.accordion', function () {
              if (c.disabled) return;
              a(this).addClass('ui-state-focus');
            })
            .bind('blur.accordion', function () {
              if (c.disabled) return;
              a(this).removeClass('ui-state-focus');
            })),
          b.headers.next().addClass('ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom');
        if (c.navigation) {
          var d = b.element.find('a').filter(c.navigationFilter).eq(0);
          if (d.length) {
            var e = d.closest('.ui-accordion-header');
            e.length ? (b.active = e) : (b.active = d.closest('.ui-accordion-content').prev());
          }
        }
        (b.active = b
          ._findActive(b.active || c.active)
          .addClass('ui-state-default ui-state-active')
          .toggleClass('ui-corner-all')
          .toggleClass('ui-corner-top')),
          b.active.next().addClass('ui-accordion-content-active'),
          b._createIcons(),
          b.resize(),
          b.element.attr('role', 'tablist'),
          b.headers
            .attr('role', 'tab')
            .bind('keydown.accordion', function (a) {
              return b._keydown(a);
            })
            .next()
            .attr('role', 'tabpanel'),
          b.headers
            .not(b.active || '')
            .attr({ 'aria-expanded': 'false', 'aria-selected': 'false', tabIndex: -1 })
            .next()
            .hide(),
          b.active.length
            ? b.active.attr({ 'aria-expanded': 'true', 'aria-selected': 'true', tabIndex: 0 })
            : b.headers.eq(0).attr('tabIndex', 0),
          a.browser.safari || b.headers.find('a').attr('tabIndex', -1),
          c.event &&
            b.headers.bind(c.event.split(' ').join('.accordion ') + '.accordion', function (a) {
              b._clickHandler.call(b, a, this), a.preventDefault();
            });
      },
      _createIcons: function () {
        var b = this.options;
        b.icons &&
          (a('<span></span>')
            .addClass('ui-icon ' + b.icons.header)
            .prependTo(this.headers),
          this.active.children('.ui-icon').toggleClass(b.icons.header).toggleClass(b.icons.headerSelected),
          this.element.addClass('ui-accordion-icons'));
      },
      _destroyIcons: function () {
        this.headers.children('.ui-icon').remove(), this.element.removeClass('ui-accordion-icons');
      },
      destroy: function () {
        var b = this.options;
        this.element.removeClass('ui-accordion ui-widget ui-helper-reset').removeAttr('role'),
          this.headers
            .unbind('.accordion')
            .removeClass(
              'ui-accordion-header ui-accordion-disabled ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top',
            )
            .removeAttr('role')
            .removeAttr('aria-expanded')
            .removeAttr('aria-selected')
            .removeAttr('tabIndex'),
          this.headers.find('a').removeAttr('tabIndex'),
          this._destroyIcons();
        var c = this.headers
          .next()
          .css('display', '')
          .removeAttr('role')
          .removeClass(
            'ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-accordion-disabled ui-state-disabled',
          );
        return (b.autoHeight || b.fillHeight) && c.css('height', ''), a.Widget.prototype.destroy.call(this);
      },
      _setOption: function (b, c) {
        a.Widget.prototype._setOption.apply(this, arguments),
          b == 'active' && this.activate(c),
          b == 'icons' && (this._destroyIcons(), c && this._createIcons()),
          b == 'disabled' &&
            this.headers
              .add(this.headers.next())
              [c ? 'addClass' : 'removeClass']('ui-accordion-disabled ui-state-disabled');
      },
      _keydown: function (b) {
        if (this.options.disabled || b.altKey || b.ctrlKey) return;
        var c = a.ui.keyCode,
          d = this.headers.length,
          e = this.headers.index(b.target),
          f = !1;
        switch (b.keyCode) {
          case c.RIGHT:
          case c.DOWN:
            f = this.headers[(e + 1) % d];
            break;
          case c.LEFT:
          case c.UP:
            f = this.headers[(e - 1 + d) % d];
            break;
          case c.SPACE:
          case c.ENTER:
            this._clickHandler({ target: b.target }, b.target), b.preventDefault();
        }
        return f ? (a(b.target).attr('tabIndex', -1), a(f).attr('tabIndex', 0), f.focus(), !1) : !0;
      },
      resize: function () {
        var b = this.options,
          c;
        if (b.fillSpace) {
          if (a.browser.msie) {
            var d = this.element.parent().css('overflow');
            this.element.parent().css('overflow', 'hidden');
          }
          (c = this.element.parent().height()),
            a.browser.msie && this.element.parent().css('overflow', d),
            this.headers.each(function () {
              c -= a(this).outerHeight(!0);
            }),
            this.headers
              .next()
              .each(function () {
                a(this).height(Math.max(0, c - a(this).innerHeight() + a(this).height()));
              })
              .css('overflow', 'auto');
        } else
          b.autoHeight &&
            ((c = 0),
            this.headers
              .next()
              .each(function () {
                c = Math.max(c, a(this).height('').height());
              })
              .height(c));
        return this;
      },
      activate: function (a) {
        this.options.active = a;
        var b = this._findActive(a)[0];
        return this._clickHandler({ target: b }, b), this;
      },
      _findActive: function (b) {
        return b
          ? typeof b == 'number'
            ? this.headers.filter(':eq(' + b + ')')
            : this.headers.not(this.headers.not(b))
          : b === !1
          ? a([])
          : this.headers.filter(':eq(0)');
      },
      _clickHandler: function (b, c) {
        var d = this.options;
        if (d.disabled) return;
        if (!b.target) {
          if (!d.collapsible) return;
          this.active
            .removeClass('ui-state-active ui-corner-top')
            .addClass('ui-state-default ui-corner-all')
            .children('.ui-icon')
            .removeClass(d.icons.headerSelected)
            .addClass(d.icons.header),
            this.active.next().addClass('ui-accordion-content-active');
          var e = this.active.next(),
            f = { options: d, newHeader: a([]), oldHeader: d.active, newContent: a([]), oldContent: e },
            g = (this.active = a([]));
          this._toggle(g, e, f);
          return;
        }
        var h = a(b.currentTarget || c),
          i = h[0] === this.active[0];
        d.active = d.collapsible && i ? !1 : this.headers.index(h);
        if (this.running || (!d.collapsible && i)) return;
        var j = this.active,
          g = h.next(),
          e = this.active.next(),
          f = {
            options: d,
            newHeader: i && d.collapsible ? a([]) : h,
            oldHeader: this.active,
            newContent: i && d.collapsible ? a([]) : g,
            oldContent: e,
          },
          k = this.headers.index(this.active[0]) > this.headers.index(h[0]);
        (this.active = i ? a([]) : h),
          this._toggle(g, e, f, i, k),
          j
            .removeClass('ui-state-active ui-corner-top')
            .addClass('ui-state-default ui-corner-all')
            .children('.ui-icon')
            .removeClass(d.icons.headerSelected)
            .addClass(d.icons.header),
          i ||
            (h
              .removeClass('ui-state-default ui-corner-all')
              .addClass('ui-state-active ui-corner-top')
              .children('.ui-icon')
              .removeClass(d.icons.header)
              .addClass(d.icons.headerSelected),
            h.next().addClass('ui-accordion-content-active'));
        return;
      },
      _toggle: function (b, c, d, e, f) {
        var g = this,
          h = g.options;
        (g.toShow = b), (g.toHide = c), (g.data = d);
        var i = function () {
          if (!g) return;
          return g._completed.apply(g, arguments);
        };
        g._trigger('changestart', null, g.data), (g.running = c.size() === 0 ? b.size() : c.size());
        if (h.animated) {
          var j = {};
          h.collapsible && e
            ? (j = { toShow: a([]), toHide: c, complete: i, down: f, autoHeight: h.autoHeight || h.fillSpace })
            : (j = { toShow: b, toHide: c, complete: i, down: f, autoHeight: h.autoHeight || h.fillSpace }),
            h.proxied || (h.proxied = h.animated),
            h.proxiedDuration || (h.proxiedDuration = h.duration),
            (h.animated = a.isFunction(h.proxied) ? h.proxied(j) : h.proxied),
            (h.duration = a.isFunction(h.proxiedDuration) ? h.proxiedDuration(j) : h.proxiedDuration);
          var k = a.ui.accordion.animations,
            l = h.duration,
            m = h.animated;
          m && !k[m] && !a.easing[m] && (m = 'slide'),
            k[m] ||
              (k[m] = function (a) {
                this.slide(a, { easing: m, duration: l || 700 });
              }),
            k[m](j);
        } else h.collapsible && e ? b.toggle() : (c.hide(), b.show()), i(!0);
        c.prev().attr({ 'aria-expanded': 'false', 'aria-selected': 'false', tabIndex: -1 }).blur(),
          b.prev().attr({ 'aria-expanded': 'true', 'aria-selected': 'true', tabIndex: 0 }).focus();
      },
      _completed: function (a) {
        this.running = a ? 0 : --this.running;
        if (this.running) return;
        this.options.clearStyle && this.toShow.add(this.toHide).css({ height: '', overflow: '' }),
          this.toHide.removeClass('ui-accordion-content-active'),
          this.toHide.length && (this.toHide.parent()[0].className = this.toHide.parent()[0].className),
          this._trigger('change', null, this.data);
      },
    }),
      a.extend(a.ui.accordion, {
        version: '1.8.24',
        animations: {
          slide: function (b, c) {
            b = a.extend({ easing: 'swing', duration: 300 }, b, c);
            if (!b.toHide.size()) {
              b.toShow.animate({ height: 'show', paddingTop: 'show', paddingBottom: 'show' }, b);
              return;
            }
            if (!b.toShow.size()) {
              b.toHide.animate({ height: 'hide', paddingTop: 'hide', paddingBottom: 'hide' }, b);
              return;
            }
            var d = b.toShow.css('overflow'),
              e = 0,
              f = {},
              g = {},
              h = ['height', 'paddingTop', 'paddingBottom'],
              i,
              j = b.toShow;
            (i = j[0].style.width),
              j.width(
                j.parent().width() -
                  parseFloat(j.css('paddingLeft')) -
                  parseFloat(j.css('paddingRight')) -
                  (parseFloat(j.css('borderLeftWidth')) || 0) -
                  (parseFloat(j.css('borderRightWidth')) || 0),
              ),
              a.each(h, function (c, d) {
                g[d] = 'hide';
                var e = ('' + a.css(b.toShow[0], d)).match(/^([\d+-.]+)(.*)$/);
                f[d] = { value: e[1], unit: e[2] || 'px' };
              }),
              b.toShow.css({ height: 0, overflow: 'hidden' }).show(),
              b.toHide
                .filter(':hidden')
                .each(b.complete)
                .end()
                .filter(':visible')
                .animate(g, {
                  step: function (a, c) {
                    c.prop == 'height' && (e = c.end - c.start === 0 ? 0 : (c.now - c.start) / (c.end - c.start)),
                      (b.toShow[0].style[c.prop] = e * f[c.prop].value + f[c.prop].unit);
                  },
                  duration: b.duration,
                  easing: b.easing,
                  complete: function () {
                    b.autoHeight || b.toShow.css('height', ''), b.toShow.css({ width: i, overflow: d }), b.complete();
                  },
                });
          },
          bounceslide: function (a) {
            this.slide(a, { easing: a.down ? 'easeOutBounce' : 'swing', duration: a.down ? 1e3 : 200 });
          },
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.autocomplete.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    var c = 0;
    a.widget('ui.autocomplete', {
      options: {
        appendTo: 'body',
        autoFocus: !1,
        delay: 300,
        minLength: 1,
        position: { my: 'left top', at: 'left bottom', collision: 'none' },
        source: null,
      },
      pending: 0,
      _create: function () {
        var b = this,
          c = this.element[0].ownerDocument,
          d;
        (this.isMultiLine = this.element.is('textarea')),
          this.element
            .addClass('ui-autocomplete-input')
            .attr('autocomplete', 'off')
            .attr({ role: 'textbox', 'aria-autocomplete': 'list', 'aria-haspopup': 'true' })
            .bind('keydown.autocomplete', function (c) {
              if (b.options.disabled || b.element.propAttr('readOnly')) return;
              d = !1;
              var e = a.ui.keyCode;
              switch (c.keyCode) {
                case e.PAGE_UP:
                  b._move('previousPage', c);
                  break;
                case e.PAGE_DOWN:
                  b._move('nextPage', c);
                  break;
                case e.UP:
                  b._keyEvent('previous', c);
                  break;
                case e.DOWN:
                  b._keyEvent('next', c);
                  break;
                case e.ENTER:
                case e.NUMPAD_ENTER:
                  b.menu.active && ((d = !0), c.preventDefault());
                case e.TAB:
                  if (!b.menu.active) return;
                  b.menu.select(c);
                  break;
                case e.ESCAPE:
                  b.element.val(b.term), b.close(c);
                  break;
                default:
                  clearTimeout(b.searching),
                    (b.searching = setTimeout(function () {
                      b.term != b.element.val() && ((b.selectedItem = null), b.search(null, c));
                    }, b.options.delay));
              }
            })
            .bind('keypress.autocomplete', function (a) {
              d && ((d = !1), a.preventDefault());
            })
            .bind('focus.autocomplete', function () {
              if (b.options.disabled) return;
              (b.selectedItem = null), (b.previous = b.element.val());
            })
            .bind('blur.autocomplete', function (a) {
              if (b.options.disabled) return;
              clearTimeout(b.searching),
                (b.closing = setTimeout(function () {
                  b.close(a), b._change(a);
                }, 150));
            }),
          this._initSource(),
          (this.menu = a('<ul></ul>')
            .addClass('ui-autocomplete')
            .appendTo(a(this.options.appendTo || 'body', c)[0])
            .mousedown(function (c) {
              var d = b.menu.element[0];
              a(c.target).closest('.ui-menu-item').length ||
                setTimeout(function () {
                  a(document).one('mousedown', function (c) {
                    c.target !== b.element[0] && c.target !== d && !a.ui.contains(d, c.target) && b.close();
                  });
                }, 1),
                setTimeout(function () {
                  clearTimeout(b.closing);
                }, 13);
            })
            .menu({
              focus: function (a, c) {
                var d = c.item.data('item.autocomplete');
                !1 !== b._trigger('focus', a, { item: d }) &&
                  /^key/.test(a.originalEvent.type) &&
                  b.element.val(d.value);
              },
              selected: function (a, d) {
                var e = d.item.data('item.autocomplete'),
                  f = b.previous;
                b.element[0] !== c.activeElement &&
                  (b.element.focus(),
                  (b.previous = f),
                  setTimeout(function () {
                    (b.previous = f), (b.selectedItem = e);
                  }, 1)),
                  !1 !== b._trigger('select', a, { item: e }) && b.element.val(e.value),
                  (b.term = b.element.val()),
                  b.close(a),
                  (b.selectedItem = e);
              },
              blur: function (a, c) {
                b.menu.element.is(':visible') && b.element.val() !== b.term && b.element.val(b.term);
              },
            })
            .zIndex(this.element.zIndex() + 1)
            .css({ top: 0, left: 0 })
            .hide()
            .data('menu')),
          a.fn.bgiframe && this.menu.element.bgiframe(),
          (b.beforeunloadHandler = function () {
            b.element.removeAttr('autocomplete');
          }),
          a(window).bind('beforeunload', b.beforeunloadHandler);
      },
      destroy: function () {
        this.element
          .removeClass('ui-autocomplete-input')
          .removeAttr('autocomplete')
          .removeAttr('role')
          .removeAttr('aria-autocomplete')
          .removeAttr('aria-haspopup'),
          this.menu.element.remove(),
          a(window).unbind('beforeunload', this.beforeunloadHandler),
          a.Widget.prototype.destroy.call(this);
      },
      _setOption: function (b, c) {
        a.Widget.prototype._setOption.apply(this, arguments),
          b === 'source' && this._initSource(),
          b === 'appendTo' && this.menu.element.appendTo(a(c || 'body', this.element[0].ownerDocument)[0]),
          b === 'disabled' && c && this.xhr && this.xhr.abort();
      },
      _initSource: function () {
        var b = this,
          c,
          d;
        a.isArray(this.options.source)
          ? ((c = this.options.source),
            (this.source = function (b, d) {
              d(a.ui.autocomplete.filter(c, b.term));
            }))
          : typeof this.options.source == 'string'
          ? ((d = this.options.source),
            (this.source = function (c, e) {
              b.xhr && b.xhr.abort(),
                (b.xhr = a.ajax({
                  url: d,
                  data: c,
                  dataType: 'json',
                  success: function (a, b) {
                    e(a);
                  },
                  error: function () {
                    e([]);
                  },
                }));
            }))
          : (this.source = this.options.source);
      },
      search: function (a, b) {
        (a = a != null ? a : this.element.val()), (this.term = this.element.val());
        if (a.length < this.options.minLength) return this.close(b);
        clearTimeout(this.closing);
        if (this._trigger('search', b) === !1) return;
        return this._search(a);
      },
      _search: function (a) {
        this.pending++, this.element.addClass('ui-autocomplete-loading'), this.source({ term: a }, this._response());
      },
      _response: function () {
        var a = this,
          b = ++c;
        return function (d) {
          b === c && a.__response(d), a.pending--, a.pending || a.element.removeClass('ui-autocomplete-loading');
        };
      },
      __response: function (a) {
        !this.options.disabled && a && a.length
          ? ((a = this._normalize(a)), this._suggest(a), this._trigger('open'))
          : this.close();
      },
      close: function (a) {
        clearTimeout(this.closing),
          this.menu.element.is(':visible') &&
            (this.menu.element.hide(), this.menu.deactivate(), this._trigger('close', a));
      },
      _change: function (a) {
        this.previous !== this.element.val() && this._trigger('change', a, { item: this.selectedItem });
      },
      _normalize: function (b) {
        return b.length && b[0].label && b[0].value
          ? b
          : a.map(b, function (b) {
              return typeof b == 'string'
                ? { label: b, value: b }
                : a.extend({ label: b.label || b.value, value: b.value || b.label }, b);
            });
      },
      _suggest: function (b) {
        var c = this.menu.element.empty().zIndex(this.element.zIndex() + 1);
        this._renderMenu(c, b),
          this.menu.deactivate(),
          this.menu.refresh(),
          c.show(),
          this._resizeMenu(),
          c.position(a.extend({ of: this.element }, this.options.position)),
          this.options.autoFocus && this.menu.next(new a.Event('mouseover'));
      },
      _resizeMenu: function () {
        var a = this.menu.element;
        a.outerWidth(Math.max(a.width('').outerWidth() + 1, this.element.outerWidth()));
      },
      _renderMenu: function (b, c) {
        var d = this;
        a.each(c, function (a, c) {
          d._renderItem(b, c);
        });
      },
      _renderItem: function (b, c) {
        return a('<li></li>').data('item.autocomplete', c).append(a('<a></a>').text(c.label)).appendTo(b);
      },
      _move: function (a, b) {
        if (!this.menu.element.is(':visible')) {
          this.search(null, b);
          return;
        }
        if ((this.menu.first() && /^previous/.test(a)) || (this.menu.last() && /^next/.test(a))) {
          this.element.val(this.term), this.menu.deactivate();
          return;
        }
        this.menu[a](b);
      },
      widget: function () {
        return this.menu.element;
      },
      _keyEvent: function (a, b) {
        if (!this.isMultiLine || this.menu.element.is(':visible')) this._move(a, b), b.preventDefault();
      },
    }),
      a.extend(a.ui.autocomplete, {
        escapeRegex: function (a) {
          return a.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        },
        filter: function (b, c) {
          var d = new RegExp(a.ui.autocomplete.escapeRegex(c), 'i');
          return a.grep(b, function (a) {
            return d.test(a.label || a.value || a);
          });
        },
      });
  })(jQuery),
    (function (a) {
      a.widget('ui.menu', {
        _create: function () {
          var b = this;
          this.element
            .addClass('ui-menu ui-widget ui-widget-content ui-corner-all')
            .attr({ role: 'listbox', 'aria-activedescendant': 'ui-active-menuitem' })
            .click(function (c) {
              if (!a(c.target).closest('.ui-menu-item a').length) return;
              c.preventDefault(), b.select(c);
            }),
            this.refresh();
        },
        refresh: function () {
          var b = this,
            c = this.element.children('li:not(.ui-menu-item):has(a)').addClass('ui-menu-item').attr('role', 'menuitem');
          c.children('a')
            .addClass('ui-corner-all')
            .attr('tabindex', -1)
            .mouseenter(function (c) {
              b.activate(c, a(this).parent());
            })
            .mouseleave(function () {
              b.deactivate();
            });
        },
        activate: function (a, b) {
          this.deactivate();
          if (this.hasScroll()) {
            var c = b.offset().top - this.element.offset().top,
              d = this.element.scrollTop(),
              e = this.element.height();
            c < 0 ? this.element.scrollTop(d + c) : c >= e && this.element.scrollTop(d + c - e + b.height());
          }
          (this.active = b.eq(0).children('a').addClass('ui-state-hover').attr('id', 'ui-active-menuitem').end()),
            this._trigger('focus', a, { item: b });
        },
        deactivate: function () {
          if (!this.active) return;
          this.active.children('a').removeClass('ui-state-hover').removeAttr('id'),
            this._trigger('blur'),
            (this.active = null);
        },
        next: function (a) {
          this.move('next', '.ui-menu-item:first', a);
        },
        previous: function (a) {
          this.move('prev', '.ui-menu-item:last', a);
        },
        first: function () {
          return this.active && !this.active.prevAll('.ui-menu-item').length;
        },
        last: function () {
          return this.active && !this.active.nextAll('.ui-menu-item').length;
        },
        move: function (a, b, c) {
          if (!this.active) {
            this.activate(c, this.element.children(b));
            return;
          }
          var d = this.active[a + 'All']('.ui-menu-item').eq(0);
          d.length ? this.activate(c, d) : this.activate(c, this.element.children(b));
        },
        nextPage: function (b) {
          if (this.hasScroll()) {
            if (!this.active || this.last()) {
              this.activate(b, this.element.children('.ui-menu-item:first'));
              return;
            }
            var c = this.active.offset().top,
              d = this.element.height(),
              e = this.element.children('.ui-menu-item').filter(function () {
                var b = a(this).offset().top - c - d + a(this).height();
                return b < 10 && b > -10;
              });
            e.length || (e = this.element.children('.ui-menu-item:last')), this.activate(b, e);
          } else
            this.activate(
              b,
              this.element.children('.ui-menu-item').filter(!this.active || this.last() ? ':first' : ':last'),
            );
        },
        previousPage: function (b) {
          if (this.hasScroll()) {
            if (!this.active || this.first()) {
              this.activate(b, this.element.children('.ui-menu-item:last'));
              return;
            }
            var c = this.active.offset().top,
              d = this.element.height(),
              e = this.element.children('.ui-menu-item').filter(function () {
                var b = a(this).offset().top - c + d - a(this).height();
                return b < 10 && b > -10;
              });
            e.length || (e = this.element.children('.ui-menu-item:first')), this.activate(b, e);
          } else
            this.activate(
              b,
              this.element.children('.ui-menu-item').filter(!this.active || this.first() ? ':last' : ':first'),
            );
        },
        hasScroll: function () {
          return this.element.height() < this.element[a.fn.prop ? 'prop' : 'attr']('scrollHeight');
        },
        select: function (a) {
          this._trigger('selected', a, { item: this.active });
        },
      });
    })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.button.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    var c,
      d,
      e,
      f,
      g = 'ui-button ui-widget ui-state-default ui-corner-all',
      h = 'ui-state-hover ui-state-active ',
      i =
        'ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only',
      j = function () {
        var b = a(this).find(':ui-button');
        setTimeout(function () {
          b.button('refresh');
        }, 1);
      },
      k = function (b) {
        var c = b.name,
          d = b.form,
          e = a([]);
        return (
          c &&
            (d
              ? (e = a(d).find("[name='" + c + "']"))
              : (e = a("[name='" + c + "']", b.ownerDocument).filter(function () {
                  return !this.form;
                }))),
          e
        );
      };
    a.widget('ui.button', {
      options: { disabled: null, text: !0, label: null, icons: { primary: null, secondary: null } },
      _create: function () {
        this.element.closest('form').unbind('reset.button').bind('reset.button', j),
          typeof this.options.disabled != 'boolean'
            ? (this.options.disabled = !!this.element.propAttr('disabled'))
            : this.element.propAttr('disabled', this.options.disabled),
          this._determineButtonType(),
          (this.hasTitle = !!this.buttonElement.attr('title'));
        var b = this,
          h = this.options,
          i = this.type === 'checkbox' || this.type === 'radio',
          l = 'ui-state-hover' + (i ? '' : ' ui-state-active'),
          m = 'ui-state-focus';
        h.label === null && (h.label = this.buttonElement.html()),
          this.buttonElement
            .addClass(g)
            .attr('role', 'button')
            .bind('mouseenter.button', function () {
              if (h.disabled) return;
              a(this).addClass('ui-state-hover'), this === c && a(this).addClass('ui-state-active');
            })
            .bind('mouseleave.button', function () {
              if (h.disabled) return;
              a(this).removeClass(l);
            })
            .bind('click.button', function (a) {
              h.disabled && (a.preventDefault(), a.stopImmediatePropagation());
            }),
          this.element
            .bind('focus.button', function () {
              b.buttonElement.addClass(m);
            })
            .bind('blur.button', function () {
              b.buttonElement.removeClass(m);
            }),
          i &&
            (this.element.bind('change.button', function () {
              if (f) return;
              b.refresh();
            }),
            this.buttonElement
              .bind('mousedown.button', function (a) {
                if (h.disabled) return;
                (f = !1), (d = a.pageX), (e = a.pageY);
              })
              .bind('mouseup.button', function (a) {
                if (h.disabled) return;
                if (d !== a.pageX || e !== a.pageY) f = !0;
              })),
          this.type === 'checkbox'
            ? this.buttonElement.bind('click.button', function () {
                if (h.disabled || f) return !1;
                a(this).toggleClass('ui-state-active'), b.buttonElement.attr('aria-pressed', b.element[0].checked);
              })
            : this.type === 'radio'
            ? this.buttonElement.bind('click.button', function () {
                if (h.disabled || f) return !1;
                a(this).addClass('ui-state-active'), b.buttonElement.attr('aria-pressed', 'true');
                var c = b.element[0];
                k(c)
                  .not(c)
                  .map(function () {
                    return a(this).button('widget')[0];
                  })
                  .removeClass('ui-state-active')
                  .attr('aria-pressed', 'false');
              })
            : (this.buttonElement
                .bind('mousedown.button', function () {
                  if (h.disabled) return !1;
                  a(this).addClass('ui-state-active'),
                    (c = this),
                    a(document).one('mouseup', function () {
                      c = null;
                    });
                })
                .bind('mouseup.button', function () {
                  if (h.disabled) return !1;
                  a(this).removeClass('ui-state-active');
                })
                .bind('keydown.button', function (b) {
                  if (h.disabled) return !1;
                  (b.keyCode == a.ui.keyCode.SPACE || b.keyCode == a.ui.keyCode.ENTER) &&
                    a(this).addClass('ui-state-active');
                })
                .bind('keyup.button', function () {
                  a(this).removeClass('ui-state-active');
                }),
              this.buttonElement.is('a') &&
                this.buttonElement.keyup(function (b) {
                  b.keyCode === a.ui.keyCode.SPACE && a(this).click();
                })),
          this._setOption('disabled', h.disabled),
          this._resetButton();
      },
      _determineButtonType: function () {
        this.element.is(':checkbox')
          ? (this.type = 'checkbox')
          : this.element.is(':radio')
          ? (this.type = 'radio')
          : this.element.is('input')
          ? (this.type = 'input')
          : (this.type = 'button');
        if (this.type === 'checkbox' || this.type === 'radio') {
          var a = this.element.parents().filter(':last'),
            b = "label[for='" + this.element.attr('id') + "']";
          (this.buttonElement = a.find(b)),
            this.buttonElement.length ||
              ((a = a.length ? a.siblings() : this.element.siblings()),
              (this.buttonElement = a.filter(b)),
              this.buttonElement.length || (this.buttonElement = a.find(b))),
            this.element.addClass('ui-helper-hidden-accessible');
          var c = this.element.is(':checked');
          c && this.buttonElement.addClass('ui-state-active'), this.buttonElement.attr('aria-pressed', c);
        } else this.buttonElement = this.element;
      },
      widget: function () {
        return this.buttonElement;
      },
      destroy: function () {
        this.element.removeClass('ui-helper-hidden-accessible'),
          this.buttonElement
            .removeClass(g + ' ' + h + ' ' + i)
            .removeAttr('role')
            .removeAttr('aria-pressed')
            .html(this.buttonElement.find('.ui-button-text').html()),
          this.hasTitle || this.buttonElement.removeAttr('title'),
          a.Widget.prototype.destroy.call(this);
      },
      _setOption: function (b, c) {
        a.Widget.prototype._setOption.apply(this, arguments);
        if (b === 'disabled') {
          c ? this.element.propAttr('disabled', !0) : this.element.propAttr('disabled', !1);
          return;
        }
        this._resetButton();
      },
      refresh: function () {
        var b = this.element.is(':disabled');
        b !== this.options.disabled && this._setOption('disabled', b),
          this.type === 'radio'
            ? k(this.element[0]).each(function () {
                a(this).is(':checked')
                  ? a(this).button('widget').addClass('ui-state-active').attr('aria-pressed', 'true')
                  : a(this).button('widget').removeClass('ui-state-active').attr('aria-pressed', 'false');
              })
            : this.type === 'checkbox' &&
              (this.element.is(':checked')
                ? this.buttonElement.addClass('ui-state-active').attr('aria-pressed', 'true')
                : this.buttonElement.removeClass('ui-state-active').attr('aria-pressed', 'false'));
      },
      _resetButton: function () {
        if (this.type === 'input') {
          this.options.label && this.element.val(this.options.label);
          return;
        }
        var b = this.buttonElement.removeClass(i),
          c = a('<span></span>', this.element[0].ownerDocument)
            .addClass('ui-button-text')
            .html(this.options.label)
            .appendTo(b.empty())
            .text(),
          d = this.options.icons,
          e = d.primary && d.secondary,
          f = [];
        d.primary || d.secondary
          ? (this.options.text && f.push('ui-button-text-icon' + (e ? 's' : d.primary ? '-primary' : '-secondary')),
            d.primary && b.prepend("<span class='ui-button-icon-primary ui-icon " + d.primary + "'></span>"),
            d.secondary && b.append("<span class='ui-button-icon-secondary ui-icon " + d.secondary + "'></span>"),
            this.options.text ||
              (f.push(e ? 'ui-button-icons-only' : 'ui-button-icon-only'), this.hasTitle || b.attr('title', c)))
          : f.push('ui-button-text-only'),
          b.addClass(f.join(' '));
      },
    }),
      a.widget('ui.buttonset', {
        options: { items: ':button, :submit, :reset, :checkbox, :radio, a, :data(button)' },
        _create: function () {
          this.element.addClass('ui-buttonset');
        },
        _init: function () {
          this.refresh();
        },
        _setOption: function (b, c) {
          b === 'disabled' && this.buttons.button('option', b, c), a.Widget.prototype._setOption.apply(this, arguments);
        },
        refresh: function () {
          var b = this.element.css('direction') === 'rtl';
          this.buttons = this.element
            .find(this.options.items)
            .filter(':ui-button')
            .button('refresh')
            .end()
            .not(':ui-button')
            .button()
            .end()
            .map(function () {
              return a(this).button('widget')[0];
            })
            .removeClass('ui-corner-all ui-corner-left ui-corner-right')
            .filter(':first')
            .addClass(b ? 'ui-corner-right' : 'ui-corner-left')
            .end()
            .filter(':last')
            .addClass(b ? 'ui-corner-left' : 'ui-corner-right')
            .end()
            .end();
        },
        destroy: function () {
          this.element.removeClass('ui-buttonset'),
            this.buttons
              .map(function () {
                return a(this).button('widget')[0];
              })
              .removeClass('ui-corner-left ui-corner-right')
              .end()
              .button('destroy'),
            a.Widget.prototype.destroy.call(this);
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.dialog.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    var c = 'ui-dialog ui-widget ui-widget-content ui-corner-all ',
      d = { buttons: !0, height: !0, maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0, width: !0 },
      e = { maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0 };
    a.widget('ui.dialog', {
      options: {
        autoOpen: !0,
        buttons: {},
        closeOnEscape: !0,
        closeText: 'close',
        dialogClass: '',
        draggable: !0,
        hide: null,
        height: 'auto',
        maxHeight: !1,
        maxWidth: !1,
        minHeight: 150,
        minWidth: 150,
        modal: !1,
        position: {
          my: 'center',
          at: 'center',
          collision: 'fit',
          using: function (b) {
            var c = a(this).css(b).offset().top;
            c < 0 && a(this).css('top', b.top - c);
          },
        },
        resizable: !0,
        show: null,
        stack: !0,
        title: '',
        width: 300,
        zIndex: 1e3,
      },
      _create: function () {
        (this.originalTitle = this.element.attr('title')),
          typeof this.originalTitle != 'string' && (this.originalTitle = ''),
          (this.options.title = this.options.title || this.originalTitle);
        var b = this,
          d = b.options,
          e = d.title || '&#160;',
          f = a.ui.dialog.getTitleId(b.element),
          g = (b.uiDialog = a('<div></div>'))
            .appendTo(document.body)
            .hide()
            .addClass(c + d.dialogClass)
            .css({ zIndex: d.zIndex })
            .attr('tabIndex', -1)
            .css('outline', 0)
            .keydown(function (c) {
              d.closeOnEscape &&
                !c.isDefaultPrevented() &&
                c.keyCode &&
                c.keyCode === a.ui.keyCode.ESCAPE &&
                (b.close(c), c.preventDefault());
            })
            .attr({ role: 'dialog', 'aria-labelledby': f })
            .mousedown(function (a) {
              b.moveToTop(!1, a);
            }),
          h = b.element.show().removeAttr('title').addClass('ui-dialog-content ui-widget-content').appendTo(g),
          i = (b.uiDialogTitlebar = a('<div></div>'))
            .addClass('ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix')
            .prependTo(g),
          j = a('<a href="#"></a>')
            .addClass('ui-dialog-titlebar-close ui-corner-all')
            .attr('role', 'button')
            .hover(
              function () {
                j.addClass('ui-state-hover');
              },
              function () {
                j.removeClass('ui-state-hover');
              },
            )
            .focus(function () {
              j.addClass('ui-state-focus');
            })
            .blur(function () {
              j.removeClass('ui-state-focus');
            })
            .click(function (a) {
              return b.close(a), !1;
            })
            .appendTo(i),
          k = (b.uiDialogTitlebarCloseText = a('<span></span>'))
            .addClass('ui-icon ui-icon-closethick')
            .text(d.closeText)
            .appendTo(j),
          l = a('<span></span>').addClass('ui-dialog-title').attr('id', f).html(e).prependTo(i);
        a.isFunction(d.beforeclose) && !a.isFunction(d.beforeClose) && (d.beforeClose = d.beforeclose),
          i.find('*').add(i).disableSelection(),
          d.draggable && a.fn.draggable && b._makeDraggable(),
          d.resizable && a.fn.resizable && b._makeResizable(),
          b._createButtons(d.buttons),
          (b._isOpen = !1),
          a.fn.bgiframe && g.bgiframe();
      },
      _init: function () {
        this.options.autoOpen && this.open();
      },
      destroy: function () {
        var a = this;
        return (
          a.overlay && a.overlay.destroy(),
          a.uiDialog.hide(),
          a.element
            .unbind('.dialog')
            .removeData('dialog')
            .removeClass('ui-dialog-content ui-widget-content')
            .hide()
            .appendTo('body'),
          a.uiDialog.remove(),
          a.originalTitle && a.element.attr('title', a.originalTitle),
          a
        );
      },
      widget: function () {
        return this.uiDialog;
      },
      close: function (b) {
        var c = this,
          d,
          e;
        if (!1 === c._trigger('beforeClose', b)) return;
        return (
          c.overlay && c.overlay.destroy(),
          c.uiDialog.unbind('keypress.ui-dialog'),
          (c._isOpen = !1),
          c.options.hide
            ? c.uiDialog.hide(c.options.hide, function () {
                c._trigger('close', b);
              })
            : (c.uiDialog.hide(), c._trigger('close', b)),
          a.ui.dialog.overlay.resize(),
          c.options.modal &&
            ((d = 0),
            a('.ui-dialog').each(function () {
              this !== c.uiDialog[0] && ((e = a(this).css('z-index')), isNaN(e) || (d = Math.max(d, e)));
            }),
            (a.ui.dialog.maxZ = d)),
          c
        );
      },
      isOpen: function () {
        return this._isOpen;
      },
      moveToTop: function (b, c) {
        var d = this,
          e = d.options,
          f;
        return (e.modal && !b) || (!e.stack && !e.modal)
          ? d._trigger('focus', c)
          : (e.zIndex > a.ui.dialog.maxZ && (a.ui.dialog.maxZ = e.zIndex),
            d.overlay &&
              ((a.ui.dialog.maxZ += 1), d.overlay.$el.css('z-index', (a.ui.dialog.overlay.maxZ = a.ui.dialog.maxZ))),
            (f = { scrollTop: d.element.scrollTop(), scrollLeft: d.element.scrollLeft() }),
            (a.ui.dialog.maxZ += 1),
            d.uiDialog.css('z-index', a.ui.dialog.maxZ),
            d.element.attr(f),
            d._trigger('focus', c),
            d);
      },
      open: function () {
        if (this._isOpen) return;
        var b = this,
          c = b.options,
          d = b.uiDialog;
        return (
          (b.overlay = c.modal ? new a.ui.dialog.overlay(b) : null),
          b._size(),
          b._position(c.position),
          d.show(c.show),
          b.moveToTop(!0),
          c.modal &&
            d.bind('keydown.ui-dialog', function (b) {
              if (b.keyCode !== a.ui.keyCode.TAB) return;
              var c = a(':tabbable', this),
                d = c.filter(':first'),
                e = c.filter(':last');
              if (b.target === e[0] && !b.shiftKey) return d.focus(1), !1;
              if (b.target === d[0] && b.shiftKey) return e.focus(1), !1;
            }),
          a(b.element.find(':tabbable').get().concat(d.find('.ui-dialog-buttonpane :tabbable').get().concat(d.get())))
            .eq(0)
            .focus(),
          (b._isOpen = !0),
          b._trigger('open'),
          b
        );
      },
      _createButtons: function (b) {
        var c = this,
          d = !1,
          e = a('<div></div>').addClass('ui-dialog-buttonpane ui-widget-content ui-helper-clearfix'),
          f = a('<div></div>').addClass('ui-dialog-buttonset').appendTo(e);
        c.uiDialog.find('.ui-dialog-buttonpane').remove(),
          typeof b == 'object' &&
            b !== null &&
            a.each(b, function () {
              return !(d = !0);
            }),
          d &&
            (a.each(b, function (b, d) {
              d = a.isFunction(d) ? { click: d, text: b } : d;
              var e = a('<button type="button"></button>')
                .click(function () {
                  d.click.apply(c.element[0], arguments);
                })
                .appendTo(f);
              a.each(d, function (a, b) {
                if (a === 'click') return;
                a in e ? e[a](b) : e.attr(a, b);
              }),
                a.fn.button && e.button();
            }),
            e.appendTo(c.uiDialog));
      },
      _makeDraggable: function () {
        function f(a) {
          return { position: a.position, offset: a.offset };
        }
        var b = this,
          c = b.options,
          d = a(document),
          e;
        b.uiDialog.draggable({
          cancel: '.ui-dialog-content, .ui-dialog-titlebar-close',
          handle: '.ui-dialog-titlebar',
          containment: 'document',
          start: function (d, g) {
            (e = c.height === 'auto' ? 'auto' : a(this).height()),
              a(this).height(a(this).height()).addClass('ui-dialog-dragging'),
              b._trigger('dragStart', d, f(g));
          },
          drag: function (a, c) {
            b._trigger('drag', a, f(c));
          },
          stop: function (g, h) {
            (c.position = [h.position.left - d.scrollLeft(), h.position.top - d.scrollTop()]),
              a(this).removeClass('ui-dialog-dragging').height(e),
              b._trigger('dragStop', g, f(h)),
              a.ui.dialog.overlay.resize();
          },
        });
      },
      _makeResizable: function (c) {
        function h(a) {
          return {
            originalPosition: a.originalPosition,
            originalSize: a.originalSize,
            position: a.position,
            size: a.size,
          };
        }
        c = c === b ? this.options.resizable : c;
        var d = this,
          e = d.options,
          f = d.uiDialog.css('position'),
          g = typeof c == 'string' ? c : 'n,e,s,w,se,sw,ne,nw';
        d.uiDialog
          .resizable({
            cancel: '.ui-dialog-content',
            containment: 'document',
            alsoResize: d.element,
            maxWidth: e.maxWidth,
            maxHeight: e.maxHeight,
            minWidth: e.minWidth,
            minHeight: d._minHeight(),
            handles: g,
            start: function (b, c) {
              a(this).addClass('ui-dialog-resizing'), d._trigger('resizeStart', b, h(c));
            },
            resize: function (a, b) {
              d._trigger('resize', a, h(b));
            },
            stop: function (b, c) {
              a(this).removeClass('ui-dialog-resizing'),
                (e.height = a(this).height()),
                (e.width = a(this).width()),
                d._trigger('resizeStop', b, h(c)),
                a.ui.dialog.overlay.resize();
            },
          })
          .css('position', f)
          .find('.ui-resizable-se')
          .addClass('ui-icon ui-icon-grip-diagonal-se');
      },
      _minHeight: function () {
        var a = this.options;
        return a.height === 'auto' ? a.minHeight : Math.min(a.minHeight, a.height);
      },
      _position: function (b) {
        var c = [],
          d = [0, 0],
          e;
        if (b) {
          if (typeof b == 'string' || (typeof b == 'object' && '0' in b))
            (c = b.split ? b.split(' ') : [b[0], b[1]]),
              c.length === 1 && (c[1] = c[0]),
              a.each(['left', 'top'], function (a, b) {
                +c[a] === c[a] && ((d[a] = c[a]), (c[a] = b));
              }),
              (b = { my: c.join(' '), at: c.join(' '), offset: d.join(' ') });
          b = a.extend({}, a.ui.dialog.prototype.options.position, b);
        } else b = a.ui.dialog.prototype.options.position;
        (e = this.uiDialog.is(':visible')),
          e || this.uiDialog.show(),
          this.uiDialog.css({ top: 0, left: 0 }).position(a.extend({ of: window }, b)),
          e || this.uiDialog.hide();
      },
      _setOptions: function (b) {
        var c = this,
          f = {},
          g = !1;
        a.each(b, function (a, b) {
          c._setOption(a, b), a in d && (g = !0), a in e && (f[a] = b);
        }),
          g && this._size(),
          this.uiDialog.is(':data(resizable)') && this.uiDialog.resizable('option', f);
      },
      _setOption: function (b, d) {
        var e = this,
          f = e.uiDialog;
        switch (b) {
          case 'beforeclose':
            b = 'beforeClose';
            break;
          case 'buttons':
            e._createButtons(d);
            break;
          case 'closeText':
            e.uiDialogTitlebarCloseText.text('' + d);
            break;
          case 'dialogClass':
            f.removeClass(e.options.dialogClass).addClass(c + d);
            break;
          case 'disabled':
            d ? f.addClass('ui-dialog-disabled') : f.removeClass('ui-dialog-disabled');
            break;
          case 'draggable':
            var g = f.is(':data(draggable)');
            g && !d && f.draggable('destroy'), !g && d && e._makeDraggable();
            break;
          case 'position':
            e._position(d);
            break;
          case 'resizable':
            var h = f.is(':data(resizable)');
            h && !d && f.resizable('destroy'),
              h && typeof d == 'string' && f.resizable('option', 'handles', d),
              !h && d !== !1 && e._makeResizable(d);
            break;
          case 'title':
            a('.ui-dialog-title', e.uiDialogTitlebar).html('' + (d || '&#160;'));
        }
        a.Widget.prototype._setOption.apply(e, arguments);
      },
      _size: function () {
        var b = this.options,
          c,
          d,
          e = this.uiDialog.is(':visible');
        this.element.show().css({ width: 'auto', minHeight: 0, height: 0 }),
          b.minWidth > b.width && (b.width = b.minWidth),
          (c = this.uiDialog.css({ height: 'auto', width: b.width }).height()),
          (d = Math.max(0, b.minHeight - c));
        if (b.height === 'auto')
          if (a.support.minHeight) this.element.css({ minHeight: d, height: 'auto' });
          else {
            this.uiDialog.show();
            var f = this.element.css('height', 'auto').height();
            e || this.uiDialog.hide(), this.element.height(Math.max(f, d));
          }
        else this.element.height(Math.max(b.height - c, 0));
        this.uiDialog.is(':data(resizable)') && this.uiDialog.resizable('option', 'minHeight', this._minHeight());
      },
    }),
      a.extend(a.ui.dialog, {
        version: '1.8.24',
        uuid: 0,
        maxZ: 0,
        getTitleId: function (a) {
          var b = a.attr('id');
          return b || ((this.uuid += 1), (b = this.uuid)), 'ui-dialog-title-' + b;
        },
        overlay: function (b) {
          this.$el = a.ui.dialog.overlay.create(b);
        },
      }),
      a.extend(a.ui.dialog.overlay, {
        instances: [],
        oldInstances: [],
        maxZ: 0,
        events: a
          .map('focus,mousedown,mouseup,keydown,keypress,click'.split(','), function (a) {
            return a + '.dialog-overlay';
          })
          .join(' '),
        create: function (b) {
          this.instances.length === 0 &&
            (setTimeout(function () {
              a.ui.dialog.overlay.instances.length &&
                a(document).bind(a.ui.dialog.overlay.events, function (b) {
                  if (a(b.target).zIndex() < a.ui.dialog.overlay.maxZ) return !1;
                });
            }, 1),
            a(document).bind('keydown.dialog-overlay', function (c) {
              b.options.closeOnEscape &&
                !c.isDefaultPrevented() &&
                c.keyCode &&
                c.keyCode === a.ui.keyCode.ESCAPE &&
                (b.close(c), c.preventDefault());
            }),
            a(window).bind('resize.dialog-overlay', a.ui.dialog.overlay.resize));
          var c = (this.oldInstances.pop() || a('<div></div>').addClass('ui-widget-overlay'))
            .appendTo(document.body)
            .css({ width: this.width(), height: this.height() });
          return a.fn.bgiframe && c.bgiframe(), this.instances.push(c), c;
        },
        destroy: function (b) {
          var c = a.inArray(b, this.instances);
          c != -1 && this.oldInstances.push(this.instances.splice(c, 1)[0]),
            this.instances.length === 0 && a([document, window]).unbind('.dialog-overlay'),
            b.remove();
          var d = 0;
          a.each(this.instances, function () {
            d = Math.max(d, this.css('z-index'));
          }),
            (this.maxZ = d);
        },
        height: function () {
          var b, c;
          return a.browser.msie && a.browser.version < 7
            ? ((b = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight)),
              (c = Math.max(document.documentElement.offsetHeight, document.body.offsetHeight)),
              b < c ? a(window).height() + 'px' : b + 'px')
            : a(document).height() + 'px';
        },
        width: function () {
          var b, c;
          return a.browser.msie
            ? ((b = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth)),
              (c = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth)),
              b < c ? a(window).width() + 'px' : b + 'px')
            : a(document).width() + 'px';
        },
        resize: function () {
          var b = a([]);
          a.each(a.ui.dialog.overlay.instances, function () {
            b = b.add(this);
          }),
            b
              .css({ width: 0, height: 0 })
              .css({ width: a.ui.dialog.overlay.width(), height: a.ui.dialog.overlay.height() });
        },
      }),
      a.extend(a.ui.dialog.overlay.prototype, {
        destroy: function () {
          a.ui.dialog.overlay.destroy(this.$el);
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.slider.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    var c = 5;
    a.widget('ui.slider', a.ui.mouse, {
      widgetEventPrefix: 'slide',
      options: {
        animate: !1,
        distance: 0,
        max: 100,
        min: 0,
        orientation: 'horizontal',
        range: !1,
        step: 1,
        value: 0,
        values: null,
      },
      _create: function () {
        var b = this,
          d = this.options,
          e = this.element.find('.ui-slider-handle').addClass('ui-state-default ui-corner-all'),
          f = "<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",
          g = (d.values && d.values.length) || 1,
          h = [];
        (this._keySliding = !1),
          (this._mouseSliding = !1),
          (this._animateOff = !0),
          (this._handleIndex = null),
          this._detectOrientation(),
          this._mouseInit(),
          this.element.addClass(
            'ui-slider ui-slider-' +
              this.orientation +
              ' ui-widget' +
              ' ui-widget-content' +
              ' ui-corner-all' +
              (d.disabled ? ' ui-slider-disabled ui-disabled' : ''),
          ),
          (this.range = a([])),
          d.range &&
            (d.range === !0 &&
              (d.values || (d.values = [this._valueMin(), this._valueMin()]),
              d.values.length && d.values.length !== 2 && (d.values = [d.values[0], d.values[0]])),
            (this.range = a('<div></div>')
              .appendTo(this.element)
              .addClass(
                'ui-slider-range ui-widget-header' +
                  (d.range === 'min' || d.range === 'max' ? ' ui-slider-range-' + d.range : ''),
              )));
        for (var i = e.length; i < g; i += 1) h.push(f);
        (this.handles = e.add(a(h.join('')).appendTo(b.element))),
          (this.handle = this.handles.eq(0)),
          this.handles
            .add(this.range)
            .filter('a')
            .click(function (a) {
              a.preventDefault();
            })
            .hover(
              function () {
                d.disabled || a(this).addClass('ui-state-hover');
              },
              function () {
                a(this).removeClass('ui-state-hover');
              },
            )
            .focus(function () {
              d.disabled
                ? a(this).blur()
                : (a('.ui-slider .ui-state-focus').removeClass('ui-state-focus'), a(this).addClass('ui-state-focus'));
            })
            .blur(function () {
              a(this).removeClass('ui-state-focus');
            }),
          this.handles.each(function (b) {
            a(this).data('index.ui-slider-handle', b);
          }),
          this.handles
            .keydown(function (d) {
              var e = a(this).data('index.ui-slider-handle'),
                f,
                g,
                h,
                i;
              if (b.options.disabled) return;
              switch (d.keyCode) {
                case a.ui.keyCode.HOME:
                case a.ui.keyCode.END:
                case a.ui.keyCode.PAGE_UP:
                case a.ui.keyCode.PAGE_DOWN:
                case a.ui.keyCode.UP:
                case a.ui.keyCode.RIGHT:
                case a.ui.keyCode.DOWN:
                case a.ui.keyCode.LEFT:
                  d.preventDefault();
                  if (!b._keySliding) {
                    (b._keySliding = !0), a(this).addClass('ui-state-active'), (f = b._start(d, e));
                    if (f === !1) return;
                  }
              }
              (i = b.options.step),
                b.options.values && b.options.values.length ? (g = h = b.values(e)) : (g = h = b.value());
              switch (d.keyCode) {
                case a.ui.keyCode.HOME:
                  h = b._valueMin();
                  break;
                case a.ui.keyCode.END:
                  h = b._valueMax();
                  break;
                case a.ui.keyCode.PAGE_UP:
                  h = b._trimAlignValue(g + (b._valueMax() - b._valueMin()) / c);
                  break;
                case a.ui.keyCode.PAGE_DOWN:
                  h = b._trimAlignValue(g - (b._valueMax() - b._valueMin()) / c);
                  break;
                case a.ui.keyCode.UP:
                case a.ui.keyCode.RIGHT:
                  if (g === b._valueMax()) return;
                  h = b._trimAlignValue(g + i);
                  break;
                case a.ui.keyCode.DOWN:
                case a.ui.keyCode.LEFT:
                  if (g === b._valueMin()) return;
                  h = b._trimAlignValue(g - i);
              }
              b._slide(d, e, h);
            })
            .keyup(function (c) {
              var d = a(this).data('index.ui-slider-handle');
              b._keySliding &&
                ((b._keySliding = !1), b._stop(c, d), b._change(c, d), a(this).removeClass('ui-state-active'));
            }),
          this._refreshValue(),
          (this._animateOff = !1);
      },
      destroy: function () {
        return (
          this.handles.remove(),
          this.range.remove(),
          this.element
            .removeClass(
              'ui-slider ui-slider-horizontal ui-slider-vertical ui-slider-disabled ui-widget ui-widget-content ui-corner-all',
            )
            .removeData('slider')
            .unbind('.slider'),
          this._mouseDestroy(),
          this
        );
      },
      _mouseCapture: function (b) {
        var c = this.options,
          d,
          e,
          f,
          g,
          h,
          i,
          j,
          k,
          l;
        return c.disabled
          ? !1
          : ((this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() }),
            (this.elementOffset = this.element.offset()),
            (d = { x: b.pageX, y: b.pageY }),
            (e = this._normValueFromMouse(d)),
            (f = this._valueMax() - this._valueMin() + 1),
            (h = this),
            this.handles.each(function (b) {
              var c = Math.abs(e - h.values(b));
              f > c && ((f = c), (g = a(this)), (i = b));
            }),
            c.range === !0 && this.values(1) === c.min && ((i += 1), (g = a(this.handles[i]))),
            (j = this._start(b, i)),
            j === !1
              ? !1
              : ((this._mouseSliding = !0),
                (h._handleIndex = i),
                g.addClass('ui-state-active').focus(),
                (k = g.offset()),
                (l = !a(b.target).parents().andSelf().is('.ui-slider-handle')),
                (this._clickOffset = l
                  ? { left: 0, top: 0 }
                  : {
                      left: b.pageX - k.left - g.width() / 2,
                      top:
                        b.pageY -
                        k.top -
                        g.height() / 2 -
                        (parseInt(g.css('borderTopWidth'), 10) || 0) -
                        (parseInt(g.css('borderBottomWidth'), 10) || 0) +
                        (parseInt(g.css('marginTop'), 10) || 0),
                    }),
                this.handles.hasClass('ui-state-hover') || this._slide(b, i, e),
                (this._animateOff = !0),
                !0));
      },
      _mouseStart: function (a) {
        return !0;
      },
      _mouseDrag: function (a) {
        var b = { x: a.pageX, y: a.pageY },
          c = this._normValueFromMouse(b);
        return this._slide(a, this._handleIndex, c), !1;
      },
      _mouseStop: function (a) {
        return (
          this.handles.removeClass('ui-state-active'),
          (this._mouseSliding = !1),
          this._stop(a, this._handleIndex),
          this._change(a, this._handleIndex),
          (this._handleIndex = null),
          (this._clickOffset = null),
          (this._animateOff = !1),
          !1
        );
      },
      _detectOrientation: function () {
        this.orientation = this.options.orientation === 'vertical' ? 'vertical' : 'horizontal';
      },
      _normValueFromMouse: function (a) {
        var b, c, d, e, f;
        return (
          this.orientation === 'horizontal'
            ? ((b = this.elementSize.width),
              (c = a.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)))
            : ((b = this.elementSize.height),
              (c = a.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0))),
          (d = c / b),
          d > 1 && (d = 1),
          d < 0 && (d = 0),
          this.orientation === 'vertical' && (d = 1 - d),
          (e = this._valueMax() - this._valueMin()),
          (f = this._valueMin() + d * e),
          this._trimAlignValue(f)
        );
      },
      _start: function (a, b) {
        var c = { handle: this.handles[b], value: this.value() };
        return (
          this.options.values && this.options.values.length && ((c.value = this.values(b)), (c.values = this.values())),
          this._trigger('start', a, c)
        );
      },
      _slide: function (a, b, c) {
        var d, e, f;
        this.options.values && this.options.values.length
          ? ((d = this.values(b ? 0 : 1)),
            this.options.values.length === 2 &&
              this.options.range === !0 &&
              ((b === 0 && c > d) || (b === 1 && c < d)) &&
              (c = d),
            c !== this.values(b) &&
              ((e = this.values()),
              (e[b] = c),
              (f = this._trigger('slide', a, { handle: this.handles[b], value: c, values: e })),
              (d = this.values(b ? 0 : 1)),
              f !== !1 && this.values(b, c, !0)))
          : c !== this.value() &&
            ((f = this._trigger('slide', a, { handle: this.handles[b], value: c })), f !== !1 && this.value(c));
      },
      _stop: function (a, b) {
        var c = { handle: this.handles[b], value: this.value() };
        this.options.values && this.options.values.length && ((c.value = this.values(b)), (c.values = this.values())),
          this._trigger('stop', a, c);
      },
      _change: function (a, b) {
        if (!this._keySliding && !this._mouseSliding) {
          var c = { handle: this.handles[b], value: this.value() };
          this.options.values && this.options.values.length && ((c.value = this.values(b)), (c.values = this.values())),
            this._trigger('change', a, c);
        }
      },
      value: function (a) {
        if (arguments.length) {
          (this.options.value = this._trimAlignValue(a)), this._refreshValue(), this._change(null, 0);
          return;
        }
        return this._value();
      },
      values: function (b, c) {
        var d, e, f;
        if (arguments.length > 1) {
          (this.options.values[b] = this._trimAlignValue(c)), this._refreshValue(), this._change(null, b);
          return;
        }
        if (!arguments.length) return this._values();
        if (!a.isArray(arguments[0]))
          return this.options.values && this.options.values.length ? this._values(b) : this.value();
        (d = this.options.values), (e = arguments[0]);
        for (f = 0; f < d.length; f += 1) (d[f] = this._trimAlignValue(e[f])), this._change(null, f);
        this._refreshValue();
      },
      _setOption: function (b, c) {
        var d,
          e = 0;
        a.isArray(this.options.values) && (e = this.options.values.length),
          a.Widget.prototype._setOption.apply(this, arguments);
        switch (b) {
          case 'disabled':
            c
              ? (this.handles.filter('.ui-state-focus').blur(),
                this.handles.removeClass('ui-state-hover'),
                this.handles.propAttr('disabled', !0),
                this.element.addClass('ui-disabled'))
              : (this.handles.propAttr('disabled', !1), this.element.removeClass('ui-disabled'));
            break;
          case 'orientation':
            this._detectOrientation(),
              this.element
                .removeClass('ui-slider-horizontal ui-slider-vertical')
                .addClass('ui-slider-' + this.orientation),
              this._refreshValue();
            break;
          case 'value':
            (this._animateOff = !0), this._refreshValue(), this._change(null, 0), (this._animateOff = !1);
            break;
          case 'values':
            (this._animateOff = !0), this._refreshValue();
            for (d = 0; d < e; d += 1) this._change(null, d);
            this._animateOff = !1;
        }
      },
      _value: function () {
        var a = this.options.value;
        return (a = this._trimAlignValue(a)), a;
      },
      _values: function (a) {
        var b, c, d;
        if (arguments.length) return (b = this.options.values[a]), (b = this._trimAlignValue(b)), b;
        c = this.options.values.slice();
        for (d = 0; d < c.length; d += 1) c[d] = this._trimAlignValue(c[d]);
        return c;
      },
      _trimAlignValue: function (a) {
        if (a <= this._valueMin()) return this._valueMin();
        if (a >= this._valueMax()) return this._valueMax();
        var b = this.options.step > 0 ? this.options.step : 1,
          c = (a - this._valueMin()) % b,
          d = a - c;
        return Math.abs(c) * 2 >= b && (d += c > 0 ? b : -b), parseFloat(d.toFixed(5));
      },
      _valueMin: function () {
        return this.options.min;
      },
      _valueMax: function () {
        return this.options.max;
      },
      _refreshValue: function () {
        var b = this.options.range,
          c = this.options,
          d = this,
          e = this._animateOff ? !1 : c.animate,
          f,
          g = {},
          h,
          i,
          j,
          k;
        this.options.values && this.options.values.length
          ? this.handles.each(function (b, i) {
              (f = ((d.values(b) - d._valueMin()) / (d._valueMax() - d._valueMin())) * 100),
                (g[d.orientation === 'horizontal' ? 'left' : 'bottom'] = f + '%'),
                a(this).stop(1, 1)[e ? 'animate' : 'css'](g, c.animate),
                d.options.range === !0 &&
                  (d.orientation === 'horizontal'
                    ? (b === 0 && d.range.stop(1, 1)[e ? 'animate' : 'css']({ left: f + '%' }, c.animate),
                      b === 1 &&
                        d.range[e ? 'animate' : 'css']({ width: f - h + '%' }, { queue: !1, duration: c.animate }))
                    : (b === 0 && d.range.stop(1, 1)[e ? 'animate' : 'css']({ bottom: f + '%' }, c.animate),
                      b === 1 &&
                        d.range[e ? 'animate' : 'css']({ height: f - h + '%' }, { queue: !1, duration: c.animate }))),
                (h = f);
            })
          : ((i = this.value()),
            (j = this._valueMin()),
            (k = this._valueMax()),
            (f = k !== j ? ((i - j) / (k - j)) * 100 : 0),
            (g[d.orientation === 'horizontal' ? 'left' : 'bottom'] = f + '%'),
            this.handle.stop(1, 1)[e ? 'animate' : 'css'](g, c.animate),
            b === 'min' &&
              this.orientation === 'horizontal' &&
              this.range.stop(1, 1)[e ? 'animate' : 'css']({ width: f + '%' }, c.animate),
            b === 'max' &&
              this.orientation === 'horizontal' &&
              this.range[e ? 'animate' : 'css']({ width: 100 - f + '%' }, { queue: !1, duration: c.animate }),
            b === 'min' &&
              this.orientation === 'vertical' &&
              this.range.stop(1, 1)[e ? 'animate' : 'css']({ height: f + '%' }, c.animate),
            b === 'max' &&
              this.orientation === 'vertical' &&
              this.range[e ? 'animate' : 'css']({ height: 100 - f + '%' }, { queue: !1, duration: c.animate }));
      },
    }),
      a.extend(a.ui.slider, { version: '1.8.24' });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.tabs.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    function e() {
      return ++c;
    }
    function f() {
      return ++d;
    }
    var c = 0,
      d = 0;
    a.widget('ui.tabs', {
      options: {
        add: null,
        ajaxOptions: null,
        cache: !1,
        cookie: null,
        collapsible: !1,
        disable: null,
        disabled: [],
        enable: null,
        event: 'click',
        fx: null,
        idPrefix: 'ui-tabs-',
        load: null,
        panelTemplate: '<div></div>',
        remove: null,
        select: null,
        show: null,
        spinner: '<em>Loading&#8230;</em>',
        tabTemplate: "<li><a href='#{href}'><span>#{label}</span></a></li>",
      },
      _create: function () {
        this._tabify(!0);
      },
      _setOption: function (a, b) {
        if (a == 'selected') {
          if (this.options.collapsible && b == this.options.selected) return;
          this.select(b);
        } else (this.options[a] = b), this._tabify();
      },
      _tabId: function (a) {
        return (
          (a.title && a.title.replace(/\s/g, '_').replace(/[^\w\u00c0-\uFFFF-]/g, '')) || this.options.idPrefix + e()
        );
      },
      _sanitizeSelector: function (a) {
        return a.replace(/:/g, '\\:');
      },
      _cookie: function () {
        var b = this.cookie || (this.cookie = this.options.cookie.name || 'ui-tabs-' + f());
        return a.cookie.apply(null, [b].concat(a.makeArray(arguments)));
      },
      _ui: function (a, b) {
        return { tab: a, panel: b, index: this.anchors.index(a) };
      },
      _cleanup: function () {
        this.lis
          .filter('.ui-state-processing')
          .removeClass('ui-state-processing')
          .find('span:data(label.tabs)')
          .each(function () {
            var b = a(this);
            b.html(b.data('label.tabs')).removeData('label.tabs');
          });
      },
      _tabify: function (c) {
        function m(b, c) {
          b.css('display', ''), !a.support.opacity && c.opacity && b[0].style.removeAttribute('filter');
        }
        var d = this,
          e = this.options,
          f = /^#.+/;
        (this.list = this.element.find('ol,ul').eq(0)),
          (this.lis = a(' > li:has(a[href])', this.list)),
          (this.anchors = this.lis.map(function () {
            return a('a', this)[0];
          })),
          (this.panels = a([])),
          this.anchors.each(function (b, c) {
            var g = a(c).attr('href'),
              h = g.split('#')[0],
              i;
            h &&
              (h === location.toString().split('#')[0] || ((i = a('base')[0]) && h === i.href)) &&
              ((g = c.hash), (c.href = g));
            if (f.test(g)) d.panels = d.panels.add(d.element.find(d._sanitizeSelector(g)));
            else if (g && g !== '#') {
              a.data(c, 'href.tabs', g), a.data(c, 'load.tabs', g.replace(/#.*$/, ''));
              var j = d._tabId(c);
              c.href = '#' + j;
              var k = d.element.find('#' + j);
              k.length ||
                ((k = a(e.panelTemplate)
                  .attr('id', j)
                  .addClass('ui-tabs-panel ui-widget-content ui-corner-bottom')
                  .insertAfter(d.panels[b - 1] || d.list)),
                k.data('destroy.tabs', !0)),
                (d.panels = d.panels.add(k));
            } else e.disabled.push(b);
          }),
          c
            ? (this.element.addClass('ui-tabs ui-widget ui-widget-content ui-corner-all'),
              this.list.addClass('ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all'),
              this.lis.addClass('ui-state-default ui-corner-top'),
              this.panels.addClass('ui-tabs-panel ui-widget-content ui-corner-bottom'),
              e.selected === b
                ? (location.hash &&
                    this.anchors.each(function (a, b) {
                      if (b.hash == location.hash) return (e.selected = a), !1;
                    }),
                  typeof e.selected != 'number' && e.cookie && (e.selected = parseInt(d._cookie(), 10)),
                  typeof e.selected != 'number' &&
                    this.lis.filter('.ui-tabs-selected').length &&
                    (e.selected = this.lis.index(this.lis.filter('.ui-tabs-selected'))),
                  (e.selected = e.selected || (this.lis.length ? 0 : -1)))
                : e.selected === null && (e.selected = -1),
              (e.selected = (e.selected >= 0 && this.anchors[e.selected]) || e.selected < 0 ? e.selected : 0),
              (e.disabled = a
                .unique(
                  e.disabled.concat(
                    a.map(this.lis.filter('.ui-state-disabled'), function (a, b) {
                      return d.lis.index(a);
                    }),
                  ),
                )
                .sort()),
              a.inArray(e.selected, e.disabled) != -1 && e.disabled.splice(a.inArray(e.selected, e.disabled), 1),
              this.panels.addClass('ui-tabs-hide'),
              this.lis.removeClass('ui-tabs-selected ui-state-active'),
              e.selected >= 0 &&
                this.anchors.length &&
                (d.element.find(d._sanitizeSelector(d.anchors[e.selected].hash)).removeClass('ui-tabs-hide'),
                this.lis.eq(e.selected).addClass('ui-tabs-selected ui-state-active'),
                d.element.queue('tabs', function () {
                  d._trigger(
                    'show',
                    null,
                    d._ui(d.anchors[e.selected], d.element.find(d._sanitizeSelector(d.anchors[e.selected].hash))[0]),
                  );
                }),
                this.load(e.selected)),
              a(window).bind('unload', function () {
                d.lis.add(d.anchors).unbind('.tabs'), (d.lis = d.anchors = d.panels = null);
              }))
            : (e.selected = this.lis.index(this.lis.filter('.ui-tabs-selected'))),
          this.element[e.collapsible ? 'addClass' : 'removeClass']('ui-tabs-collapsible'),
          e.cookie && this._cookie(e.selected, e.cookie);
        for (var g = 0, h; (h = this.lis[g]); g++)
          a(h)[a.inArray(g, e.disabled) != -1 && !a(h).hasClass('ui-tabs-selected') ? 'addClass' : 'removeClass'](
            'ui-state-disabled',
          );
        e.cache === !1 && this.anchors.removeData('cache.tabs'), this.lis.add(this.anchors).unbind('.tabs');
        if (e.event !== 'mouseover') {
          var i = function (a, b) {
              b.is(':not(.ui-state-disabled)') && b.addClass('ui-state-' + a);
            },
            j = function (a, b) {
              b.removeClass('ui-state-' + a);
            };
          this.lis.bind('mouseover.tabs', function () {
            i('hover', a(this));
          }),
            this.lis.bind('mouseout.tabs', function () {
              j('hover', a(this));
            }),
            this.anchors.bind('focus.tabs', function () {
              i('focus', a(this).closest('li'));
            }),
            this.anchors.bind('blur.tabs', function () {
              j('focus', a(this).closest('li'));
            });
        }
        var k, l;
        e.fx && (a.isArray(e.fx) ? ((k = e.fx[0]), (l = e.fx[1])) : (k = l = e.fx));
        var n = l
            ? function (b, c) {
                a(b).closest('li').addClass('ui-tabs-selected ui-state-active'),
                  c
                    .hide()
                    .removeClass('ui-tabs-hide')
                    .animate(l, l.duration || 'normal', function () {
                      m(c, l), d._trigger('show', null, d._ui(b, c[0]));
                    });
              }
            : function (b, c) {
                a(b).closest('li').addClass('ui-tabs-selected ui-state-active'),
                  c.removeClass('ui-tabs-hide'),
                  d._trigger('show', null, d._ui(b, c[0]));
              },
          o = k
            ? function (a, b) {
                b.animate(k, k.duration || 'normal', function () {
                  d.lis.removeClass('ui-tabs-selected ui-state-active'),
                    b.addClass('ui-tabs-hide'),
                    m(b, k),
                    d.element.dequeue('tabs');
                });
              }
            : function (a, b, c) {
                d.lis.removeClass('ui-tabs-selected ui-state-active'),
                  b.addClass('ui-tabs-hide'),
                  d.element.dequeue('tabs');
              };
        this.anchors.bind(e.event + '.tabs', function () {
          var b = this,
            c = a(b).closest('li'),
            f = d.panels.filter(':not(.ui-tabs-hide)'),
            g = d.element.find(d._sanitizeSelector(b.hash));
          if (
            (c.hasClass('ui-tabs-selected') && !e.collapsible) ||
            c.hasClass('ui-state-disabled') ||
            c.hasClass('ui-state-processing') ||
            d.panels.filter(':animated').length ||
            d._trigger('select', null, d._ui(this, g[0])) === !1
          )
            return this.blur(), !1;
          (e.selected = d.anchors.index(this)), d.abort();
          if (e.collapsible) {
            if (c.hasClass('ui-tabs-selected'))
              return (
                (e.selected = -1),
                e.cookie && d._cookie(e.selected, e.cookie),
                d.element
                  .queue('tabs', function () {
                    o(b, f);
                  })
                  .dequeue('tabs'),
                this.blur(),
                !1
              );
            if (!f.length)
              return (
                e.cookie && d._cookie(e.selected, e.cookie),
                d.element.queue('tabs', function () {
                  n(b, g);
                }),
                d.load(d.anchors.index(this)),
                this.blur(),
                !1
              );
          }
          e.cookie && d._cookie(e.selected, e.cookie);
          if (g.length)
            f.length &&
              d.element.queue('tabs', function () {
                o(b, f);
              }),
              d.element.queue('tabs', function () {
                n(b, g);
              }),
              d.load(d.anchors.index(this));
          else throw 'jQuery UI Tabs: Mismatching fragment identifier.';
          a.browser.msie && this.blur();
        }),
          this.anchors.bind('click.tabs', function () {
            return !1;
          });
      },
      _getIndex: function (a) {
        return typeof a == 'string' && (a = this.anchors.index(this.anchors.filter("[href$='" + a + "']"))), a;
      },
      destroy: function () {
        var b = this.options;
        return (
          this.abort(),
          this.element
            .unbind('.tabs')
            .removeClass('ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible')
            .removeData('tabs'),
          this.list.removeClass('ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all'),
          this.anchors.each(function () {
            var b = a.data(this, 'href.tabs');
            b && (this.href = b);
            var c = a(this).unbind('.tabs');
            a.each(['href', 'load', 'cache'], function (a, b) {
              c.removeData(b + '.tabs');
            });
          }),
          this.lis
            .unbind('.tabs')
            .add(this.panels)
            .each(function () {
              a.data(this, 'destroy.tabs')
                ? a(this).remove()
                : a(this).removeClass(
                    [
                      'ui-state-default',
                      'ui-corner-top',
                      'ui-tabs-selected',
                      'ui-state-active',
                      'ui-state-hover',
                      'ui-state-focus',
                      'ui-state-disabled',
                      'ui-tabs-panel',
                      'ui-widget-content',
                      'ui-corner-bottom',
                      'ui-tabs-hide',
                    ].join(' '),
                  );
            }),
          b.cookie && this._cookie(null, b.cookie),
          this
        );
      },
      add: function (c, d, e) {
        e === b && (e = this.anchors.length);
        var f = this,
          g = this.options,
          h = a(g.tabTemplate.replace(/#\{href\}/g, c).replace(/#\{label\}/g, d)),
          i = c.indexOf('#') ? this._tabId(a('a', h)[0]) : c.replace('#', '');
        h.addClass('ui-state-default ui-corner-top').data('destroy.tabs', !0);
        var j = f.element.find('#' + i);
        return (
          j.length || (j = a(g.panelTemplate).attr('id', i).data('destroy.tabs', !0)),
          j.addClass('ui-tabs-panel ui-widget-content ui-corner-bottom ui-tabs-hide'),
          e >= this.lis.length
            ? (h.appendTo(this.list), j.appendTo(this.list[0].parentNode))
            : (h.insertBefore(this.lis[e]), j.insertBefore(this.panels[e])),
          (g.disabled = a.map(g.disabled, function (a, b) {
            return a >= e ? ++a : a;
          })),
          this._tabify(),
          this.anchors.length == 1 &&
            ((g.selected = 0),
            h.addClass('ui-tabs-selected ui-state-active'),
            j.removeClass('ui-tabs-hide'),
            this.element.queue('tabs', function () {
              f._trigger('show', null, f._ui(f.anchors[0], f.panels[0]));
            }),
            this.load(0)),
          this._trigger('add', null, this._ui(this.anchors[e], this.panels[e])),
          this
        );
      },
      remove: function (b) {
        b = this._getIndex(b);
        var c = this.options,
          d = this.lis.eq(b).remove(),
          e = this.panels.eq(b).remove();
        return (
          d.hasClass('ui-tabs-selected') &&
            this.anchors.length > 1 &&
            this.select(b + (b + 1 < this.anchors.length ? 1 : -1)),
          (c.disabled = a.map(
            a.grep(c.disabled, function (a, c) {
              return a != b;
            }),
            function (a, c) {
              return a >= b ? --a : a;
            },
          )),
          this._tabify(),
          this._trigger('remove', null, this._ui(d.find('a')[0], e[0])),
          this
        );
      },
      enable: function (b) {
        b = this._getIndex(b);
        var c = this.options;
        if (a.inArray(b, c.disabled) == -1) return;
        return (
          this.lis.eq(b).removeClass('ui-state-disabled'),
          (c.disabled = a.grep(c.disabled, function (a, c) {
            return a != b;
          })),
          this._trigger('enable', null, this._ui(this.anchors[b], this.panels[b])),
          this
        );
      },
      disable: function (a) {
        a = this._getIndex(a);
        var b = this,
          c = this.options;
        return (
          a != c.selected &&
            (this.lis.eq(a).addClass('ui-state-disabled'),
            c.disabled.push(a),
            c.disabled.sort(),
            this._trigger('disable', null, this._ui(this.anchors[a], this.panels[a]))),
          this
        );
      },
      select: function (a) {
        a = this._getIndex(a);
        if (a == -1)
          if (this.options.collapsible && this.options.selected != -1) a = this.options.selected;
          else return this;
        return this.anchors.eq(a).trigger(this.options.event + '.tabs'), this;
      },
      load: function (b) {
        b = this._getIndex(b);
        var c = this,
          d = this.options,
          e = this.anchors.eq(b)[0],
          f = a.data(e, 'load.tabs');
        this.abort();
        if (!f || (this.element.queue('tabs').length !== 0 && a.data(e, 'cache.tabs'))) {
          this.element.dequeue('tabs');
          return;
        }
        this.lis.eq(b).addClass('ui-state-processing');
        if (d.spinner) {
          var g = a('span', e);
          g.data('label.tabs', g.html()).html(d.spinner);
        }
        return (
          (this.xhr = a.ajax(
            a.extend({}, d.ajaxOptions, {
              url: f,
              success: function (f, g) {
                c.element.find(c._sanitizeSelector(e.hash)).html(f),
                  c._cleanup(),
                  d.cache && a.data(e, 'cache.tabs', !0),
                  c._trigger('load', null, c._ui(c.anchors[b], c.panels[b]));
                try {
                  d.ajaxOptions.success(f, g);
                } catch (h) {}
              },
              error: function (a, f, g) {
                c._cleanup(), c._trigger('load', null, c._ui(c.anchors[b], c.panels[b]));
                try {
                  d.ajaxOptions.error(a, f, b, e);
                } catch (g) {}
              },
            }),
          )),
          c.element.dequeue('tabs'),
          this
        );
      },
      abort: function () {
        return (
          this.element.queue([]),
          this.panels.stop(!1, !0),
          this.element.queue('tabs', this.element.queue('tabs').splice(-2, 2)),
          this.xhr && (this.xhr.abort(), delete this.xhr),
          this._cleanup(),
          this
        );
      },
      url: function (a, b) {
        return this.anchors.eq(a).removeData('cache.tabs').data('load.tabs', b), this;
      },
      length: function () {
        return this.anchors.length;
      },
    }),
      a.extend(a.ui.tabs, { version: '1.8.24' }),
      a.extend(a.ui.tabs.prototype, {
        rotation: null,
        rotate: function (a, b) {
          var c = this,
            d = this.options,
            e =
              c._rotate ||
              (c._rotate = function (b) {
                clearTimeout(c.rotation),
                  (c.rotation = setTimeout(function () {
                    var a = d.selected;
                    c.select(++a < c.anchors.length ? a : 0);
                  }, a)),
                  b && b.stopPropagation();
              }),
            f =
              c._unrotate ||
              (c._unrotate = b
                ? function (a) {
                    e();
                  }
                : function (a) {
                    a.clientX && c.rotate(null);
                  });
          return (
            a
              ? (this.element.bind('tabsshow', e), this.anchors.bind(d.event + '.tabs', f), e())
              : (clearTimeout(c.rotation),
                this.element.unbind('tabsshow', e),
                this.anchors.unbind(d.event + '.tabs', f),
                delete this._rotate,
                delete this._unrotate),
            this
          );
        },
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.datepicker.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function ($, undefined) {
    function Datepicker() {
      (this.debug = !1),
        (this._curInst = null),
        (this._keyEvent = !1),
        (this._disabledInputs = []),
        (this._datepickerShowing = !1),
        (this._inDialog = !1),
        (this._mainDivId = 'ui-datepicker-div'),
        (this._inlineClass = 'ui-datepicker-inline'),
        (this._appendClass = 'ui-datepicker-append'),
        (this._triggerClass = 'ui-datepicker-trigger'),
        (this._dialogClass = 'ui-datepicker-dialog'),
        (this._disableClass = 'ui-datepicker-disabled'),
        (this._unselectableClass = 'ui-datepicker-unselectable'),
        (this._currentClass = 'ui-datepicker-current-day'),
        (this._dayOverClass = 'ui-datepicker-days-cell-over'),
        (this.regional = []),
        (this.regional[''] = {
          closeText: 'Done',
          prevText: 'Prev',
          nextText: 'Next',
          currentText: 'Today',
          monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
          monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          weekHeader: 'Wk',
          dateFormat: 'mm/dd/yy',
          firstDay: 0,
          isRTL: !1,
          showMonthAfterYear: !1,
          yearSuffix: '',
        }),
        (this._defaults = {
          showOn: 'focus',
          showAnim: 'fadeIn',
          showOptions: {},
          defaultDate: null,
          appendText: '',
          buttonText: '...',
          buttonImage: '',
          buttonImageOnly: !1,
          hideIfNoPrevNext: !1,
          navigationAsDateFormat: !1,
          gotoCurrent: !1,
          changeMonth: !1,
          changeYear: !1,
          yearRange: 'c-10:c+10',
          showOtherMonths: !1,
          selectOtherMonths: !1,
          showWeek: !1,
          calculateWeek: this.iso8601Week,
          shortYearCutoff: '+10',
          minDate: null,
          maxDate: null,
          duration: 'fast',
          beforeShowDay: null,
          beforeShow: null,
          onSelect: null,
          onChangeMonthYear: null,
          onClose: null,
          numberOfMonths: 1,
          showCurrentAtPos: 0,
          stepMonths: 1,
          stepBigMonths: 12,
          altField: '',
          altFormat: '',
          constrainInput: !0,
          showButtonPanel: !1,
          autoSize: !1,
          disabled: !1,
        }),
        $.extend(this._defaults, this.regional['']),
        (this.dpDiv = bindHover(
          $(
            '<div id="' +
              this._mainDivId +
              '" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>',
          ),
        ));
    }
    function bindHover(a) {
      var b = 'button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a';
      return a
        .bind('mouseout', function (a) {
          var c = $(a.target).closest(b);
          if (!c.length) return;
          c.removeClass('ui-state-hover ui-datepicker-prev-hover ui-datepicker-next-hover');
        })
        .bind('mouseover', function (c) {
          var d = $(c.target).closest(b);
          if ($.datepicker._isDisabledDatepicker(instActive.inline ? a.parent()[0] : instActive.input[0]) || !d.length)
            return;
          d.parents('.ui-datepicker-calendar').find('a').removeClass('ui-state-hover'),
            d.addClass('ui-state-hover'),
            d.hasClass('ui-datepicker-prev') && d.addClass('ui-datepicker-prev-hover'),
            d.hasClass('ui-datepicker-next') && d.addClass('ui-datepicker-next-hover');
        });
    }
    function extendRemove(a, b) {
      $.extend(a, b);
      for (var c in b) if (b[c] == null || b[c] == undefined) a[c] = b[c];
      return a;
    }
    function isArray(a) {
      return (
        a &&
        (($.browser.safari && typeof a == 'object' && a.length) ||
          (a.constructor && a.constructor.toString().match(/\Array\(\)/)))
      );
    }
    $.extend($.ui, { datepicker: { version: '1.8.24' } });
    var PROP_NAME = 'datepicker',
      dpuuid = new Date().getTime(),
      instActive;
    $.extend(Datepicker.prototype, {
      markerClassName: 'hasDatepicker',
      maxRows: 4,
      log: function () {
        this.debug && console.log.apply('', arguments);
      },
      _widgetDatepicker: function () {
        return this.dpDiv;
      },
      setDefaults: function (a) {
        return extendRemove(this._defaults, a || {}), this;
      },
      _attachDatepicker: function (target, settings) {
        var inlineSettings = null;
        for (var attrName in this._defaults) {
          var attrValue = target.getAttribute('date:' + attrName);
          if (attrValue) {
            inlineSettings = inlineSettings || {};
            try {
              inlineSettings[attrName] = eval(attrValue);
            } catch (err) {
              inlineSettings[attrName] = attrValue;
            }
          }
        }
        var nodeName = target.nodeName.toLowerCase(),
          inline = nodeName == 'div' || nodeName == 'span';
        target.id || ((this.uuid += 1), (target.id = 'dp' + this.uuid));
        var inst = this._newInst($(target), inline);
        (inst.settings = $.extend({}, settings || {}, inlineSettings || {})),
          nodeName == 'input' ? this._connectDatepicker(target, inst) : inline && this._inlineDatepicker(target, inst);
      },
      _newInst: function (a, b) {
        var c = a[0].id.replace(/([^A-Za-z0-9_-])/g, '\\\\$1');
        return {
          id: c,
          input: a,
          selectedDay: 0,
          selectedMonth: 0,
          selectedYear: 0,
          drawMonth: 0,
          drawYear: 0,
          inline: b,
          dpDiv: b
            ? bindHover(
                $(
                  '<div class="' +
                    this._inlineClass +
                    ' ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>',
                ),
              )
            : this.dpDiv,
        };
      },
      _connectDatepicker: function (a, b) {
        var c = $(a);
        (b.append = $([])), (b.trigger = $([]));
        if (c.hasClass(this.markerClassName)) return;
        this._attachments(c, b),
          c
            .addClass(this.markerClassName)
            .keydown(this._doKeyDown)
            .keypress(this._doKeyPress)
            .keyup(this._doKeyUp)
            .bind('setData.datepicker', function (a, c, d) {
              b.settings[c] = d;
            })
            .bind('getData.datepicker', function (a, c) {
              return this._get(b, c);
            }),
          this._autoSize(b),
          $.data(a, PROP_NAME, b),
          b.settings.disabled && this._disableDatepicker(a);
      },
      _attachments: function (a, b) {
        var c = this._get(b, 'appendText'),
          d = this._get(b, 'isRTL');
        b.append && b.append.remove(),
          c &&
            ((b.append = $('<span class="' + this._appendClass + '">' + c + '</span>')),
            a[d ? 'before' : 'after'](b.append)),
          a.unbind('focus', this._showDatepicker),
          b.trigger && b.trigger.remove();
        var e = this._get(b, 'showOn');
        (e == 'focus' || e == 'both') && a.focus(this._showDatepicker);
        if (e == 'button' || e == 'both') {
          var f = this._get(b, 'buttonText'),
            g = this._get(b, 'buttonImage');
          (b.trigger = $(
            this._get(b, 'buttonImageOnly')
              ? $('<img/>').addClass(this._triggerClass).attr({ src: g, alt: f, title: f })
              : $('<button type="button"></button>')
                  .addClass(this._triggerClass)
                  .html(g == '' ? f : $('<img/>').attr({ src: g, alt: f, title: f })),
          )),
            a[d ? 'before' : 'after'](b.trigger),
            b.trigger.click(function () {
              return (
                $.datepicker._datepickerShowing && $.datepicker._lastInput == a[0]
                  ? $.datepicker._hideDatepicker()
                  : $.datepicker._datepickerShowing && $.datepicker._lastInput != a[0]
                  ? ($.datepicker._hideDatepicker(), $.datepicker._showDatepicker(a[0]))
                  : $.datepicker._showDatepicker(a[0]),
                !1
              );
            });
        }
      },
      _autoSize: function (a) {
        if (this._get(a, 'autoSize') && !a.inline) {
          var b = new Date(2009, 11, 20),
            c = this._get(a, 'dateFormat');
          if (c.match(/[DM]/)) {
            var d = function (a) {
              var b = 0,
                c = 0;
              for (var d = 0; d < a.length; d++) a[d].length > b && ((b = a[d].length), (c = d));
              return c;
            };
            b.setMonth(d(this._get(a, c.match(/MM/) ? 'monthNames' : 'monthNamesShort'))),
              b.setDate(d(this._get(a, c.match(/DD/) ? 'dayNames' : 'dayNamesShort')) + 20 - b.getDay());
          }
          a.input.attr('size', this._formatDate(a, b).length);
        }
      },
      _inlineDatepicker: function (a, b) {
        var c = $(a);
        if (c.hasClass(this.markerClassName)) return;
        c
          .addClass(this.markerClassName)
          .append(b.dpDiv)
          .bind('setData.datepicker', function (a, c, d) {
            b.settings[c] = d;
          })
          .bind('getData.datepicker', function (a, c) {
            return this._get(b, c);
          }),
          $.data(a, PROP_NAME, b),
          this._setDate(b, this._getDefaultDate(b), !0),
          this._updateDatepicker(b),
          this._updateAlternate(b),
          b.settings.disabled && this._disableDatepicker(a),
          b.dpDiv.css('display', 'block');
      },
      _dialogDatepicker: function (a, b, c, d, e) {
        var f = this._dialogInst;
        if (!f) {
          this.uuid += 1;
          var g = 'dp' + this.uuid;
          (this._dialogInput = $(
            '<input type="text" id="' + g + '" style="position: absolute; top: -100px; width: 0px;"/>',
          )),
            this._dialogInput.keydown(this._doKeyDown),
            $('body').append(this._dialogInput),
            (f = this._dialogInst = this._newInst(this._dialogInput, !1)),
            (f.settings = {}),
            $.data(this._dialogInput[0], PROP_NAME, f);
        }
        extendRemove(f.settings, d || {}),
          (b = b && b.constructor == Date ? this._formatDate(f, b) : b),
          this._dialogInput.val(b),
          (this._pos = e ? (e.length ? e : [e.pageX, e.pageY]) : null);
        if (!this._pos) {
          var h = document.documentElement.clientWidth,
            i = document.documentElement.clientHeight,
            j = document.documentElement.scrollLeft || document.body.scrollLeft,
            k = document.documentElement.scrollTop || document.body.scrollTop;
          this._pos = [h / 2 - 100 + j, i / 2 - 150 + k];
        }
        return (
          this._dialogInput.css('left', this._pos[0] + 20 + 'px').css('top', this._pos[1] + 'px'),
          (f.settings.onSelect = c),
          (this._inDialog = !0),
          this.dpDiv.addClass(this._dialogClass),
          this._showDatepicker(this._dialogInput[0]),
          $.blockUI && $.blockUI(this.dpDiv),
          $.data(this._dialogInput[0], PROP_NAME, f),
          this
        );
      },
      _destroyDatepicker: function (a) {
        var b = $(a),
          c = $.data(a, PROP_NAME);
        if (!b.hasClass(this.markerClassName)) return;
        var d = a.nodeName.toLowerCase();
        $.removeData(a, PROP_NAME),
          d == 'input'
            ? (c.append.remove(),
              c.trigger.remove(),
              b
                .removeClass(this.markerClassName)
                .unbind('focus', this._showDatepicker)
                .unbind('keydown', this._doKeyDown)
                .unbind('keypress', this._doKeyPress)
                .unbind('keyup', this._doKeyUp))
            : (d == 'div' || d == 'span') && b.removeClass(this.markerClassName).empty();
      },
      _enableDatepicker: function (a) {
        var b = $(a),
          c = $.data(a, PROP_NAME);
        if (!b.hasClass(this.markerClassName)) return;
        var d = a.nodeName.toLowerCase();
        if (d == 'input')
          (a.disabled = !1),
            c.trigger
              .filter('button')
              .each(function () {
                this.disabled = !1;
              })
              .end()
              .filter('img')
              .css({ opacity: '1.0', cursor: '' });
        else if (d == 'div' || d == 'span') {
          var e = b.children('.' + this._inlineClass);
          e.children().removeClass('ui-state-disabled'),
            e.find('select.ui-datepicker-month, select.ui-datepicker-year').removeAttr('disabled');
        }
        this._disabledInputs = $.map(this._disabledInputs, function (b) {
          return b == a ? null : b;
        });
      },
      _disableDatepicker: function (a) {
        var b = $(a),
          c = $.data(a, PROP_NAME);
        if (!b.hasClass(this.markerClassName)) return;
        var d = a.nodeName.toLowerCase();
        if (d == 'input')
          (a.disabled = !0),
            c.trigger
              .filter('button')
              .each(function () {
                this.disabled = !0;
              })
              .end()
              .filter('img')
              .css({ opacity: '0.5', cursor: 'default' });
        else if (d == 'div' || d == 'span') {
          var e = b.children('.' + this._inlineClass);
          e.children().addClass('ui-state-disabled'),
            e.find('select.ui-datepicker-month, select.ui-datepicker-year').attr('disabled', 'disabled');
        }
        (this._disabledInputs = $.map(this._disabledInputs, function (b) {
          return b == a ? null : b;
        })),
          (this._disabledInputs[this._disabledInputs.length] = a);
      },
      _isDisabledDatepicker: function (a) {
        if (!a) return !1;
        for (var b = 0; b < this._disabledInputs.length; b++) if (this._disabledInputs[b] == a) return !0;
        return !1;
      },
      _getInst: function (a) {
        try {
          return $.data(a, PROP_NAME);
        } catch (b) {
          throw 'Missing instance data for this datepicker';
        }
      },
      _optionDatepicker: function (a, b, c) {
        var d = this._getInst(a);
        if (arguments.length == 2 && typeof b == 'string')
          return b == 'defaults'
            ? $.extend({}, $.datepicker._defaults)
            : d
            ? b == 'all'
              ? $.extend({}, d.settings)
              : this._get(d, b)
            : null;
        var e = b || {};
        typeof b == 'string' && ((e = {}), (e[b] = c));
        if (d) {
          this._curInst == d && this._hideDatepicker();
          var f = this._getDateDatepicker(a, !0),
            g = this._getMinMaxDate(d, 'min'),
            h = this._getMinMaxDate(d, 'max');
          extendRemove(d.settings, e),
            g !== null &&
              e.dateFormat !== undefined &&
              e.minDate === undefined &&
              (d.settings.minDate = this._formatDate(d, g)),
            h !== null &&
              e.dateFormat !== undefined &&
              e.maxDate === undefined &&
              (d.settings.maxDate = this._formatDate(d, h)),
            this._attachments($(a), d),
            this._autoSize(d),
            this._setDate(d, f),
            this._updateAlternate(d),
            this._updateDatepicker(d);
        }
      },
      _changeDatepicker: function (a, b, c) {
        this._optionDatepicker(a, b, c);
      },
      _refreshDatepicker: function (a) {
        var b = this._getInst(a);
        b && this._updateDatepicker(b);
      },
      _setDateDatepicker: function (a, b) {
        var c = this._getInst(a);
        c && (this._setDate(c, b), this._updateDatepicker(c), this._updateAlternate(c));
      },
      _getDateDatepicker: function (a, b) {
        var c = this._getInst(a);
        return c && !c.inline && this._setDateFromField(c, b), c ? this._getDate(c) : null;
      },
      _doKeyDown: function (a) {
        var b = $.datepicker._getInst(a.target),
          c = !0,
          d = b.dpDiv.is('.ui-datepicker-rtl');
        b._keyEvent = !0;
        if ($.datepicker._datepickerShowing)
          switch (a.keyCode) {
            case 9:
              $.datepicker._hideDatepicker(), (c = !1);
              break;
            case 13:
              var e = $('td.' + $.datepicker._dayOverClass + ':not(.' + $.datepicker._currentClass + ')', b.dpDiv);
              e[0] && $.datepicker._selectDay(a.target, b.selectedMonth, b.selectedYear, e[0]);
              var f = $.datepicker._get(b, 'onSelect');
              if (f) {
                var g = $.datepicker._formatDate(b);
                f.apply(b.input ? b.input[0] : null, [g, b]);
              } else $.datepicker._hideDatepicker();
              return !1;
            case 27:
              $.datepicker._hideDatepicker();
              break;
            case 33:
              $.datepicker._adjustDate(
                a.target,
                a.ctrlKey ? -$.datepicker._get(b, 'stepBigMonths') : -$.datepicker._get(b, 'stepMonths'),
                'M',
              );
              break;
            case 34:
              $.datepicker._adjustDate(
                a.target,
                a.ctrlKey ? +$.datepicker._get(b, 'stepBigMonths') : +$.datepicker._get(b, 'stepMonths'),
                'M',
              );
              break;
            case 35:
              (a.ctrlKey || a.metaKey) && $.datepicker._clearDate(a.target), (c = a.ctrlKey || a.metaKey);
              break;
            case 36:
              (a.ctrlKey || a.metaKey) && $.datepicker._gotoToday(a.target), (c = a.ctrlKey || a.metaKey);
              break;
            case 37:
              (a.ctrlKey || a.metaKey) && $.datepicker._adjustDate(a.target, d ? 1 : -1, 'D'),
                (c = a.ctrlKey || a.metaKey),
                a.originalEvent.altKey &&
                  $.datepicker._adjustDate(
                    a.target,
                    a.ctrlKey ? -$.datepicker._get(b, 'stepBigMonths') : -$.datepicker._get(b, 'stepMonths'),
                    'M',
                  );
              break;
            case 38:
              (a.ctrlKey || a.metaKey) && $.datepicker._adjustDate(a.target, -7, 'D'), (c = a.ctrlKey || a.metaKey);
              break;
            case 39:
              (a.ctrlKey || a.metaKey) && $.datepicker._adjustDate(a.target, d ? -1 : 1, 'D'),
                (c = a.ctrlKey || a.metaKey),
                a.originalEvent.altKey &&
                  $.datepicker._adjustDate(
                    a.target,
                    a.ctrlKey ? +$.datepicker._get(b, 'stepBigMonths') : +$.datepicker._get(b, 'stepMonths'),
                    'M',
                  );
              break;
            case 40:
              (a.ctrlKey || a.metaKey) && $.datepicker._adjustDate(a.target, 7, 'D'), (c = a.ctrlKey || a.metaKey);
              break;
            default:
              c = !1;
          }
        else a.keyCode == 36 && a.ctrlKey ? $.datepicker._showDatepicker(this) : (c = !1);
        c && (a.preventDefault(), a.stopPropagation());
      },
      _doKeyPress: function (a) {
        var b = $.datepicker._getInst(a.target);
        if ($.datepicker._get(b, 'constrainInput')) {
          var c = $.datepicker._possibleChars($.datepicker._get(b, 'dateFormat')),
            d = String.fromCharCode(a.charCode == undefined ? a.keyCode : a.charCode);
          return a.ctrlKey || a.metaKey || d < ' ' || !c || c.indexOf(d) > -1;
        }
      },
      _doKeyUp: function (a) {
        var b = $.datepicker._getInst(a.target);
        if (b.input.val() != b.lastVal)
          try {
            var c = $.datepicker.parseDate(
              $.datepicker._get(b, 'dateFormat'),
              b.input ? b.input.val() : null,
              $.datepicker._getFormatConfig(b),
            );
            c &&
              ($.datepicker._setDateFromField(b), $.datepicker._updateAlternate(b), $.datepicker._updateDatepicker(b));
          } catch (d) {
            $.datepicker.log(d);
          }
        return !0;
      },
      _showDatepicker: function (a) {
        (a = a.target || a), a.nodeName.toLowerCase() != 'input' && (a = $('input', a.parentNode)[0]);
        if ($.datepicker._isDisabledDatepicker(a) || $.datepicker._lastInput == a) return;
        var b = $.datepicker._getInst(a);
        $.datepicker._curInst &&
          $.datepicker._curInst != b &&
          ($.datepicker._curInst.dpDiv.stop(!0, !0),
          b && $.datepicker._datepickerShowing && $.datepicker._hideDatepicker($.datepicker._curInst.input[0]));
        var c = $.datepicker._get(b, 'beforeShow'),
          d = c ? c.apply(a, [a, b]) : {};
        if (d === !1) return;
        extendRemove(b.settings, d),
          (b.lastVal = null),
          ($.datepicker._lastInput = a),
          $.datepicker._setDateFromField(b),
          $.datepicker._inDialog && (a.value = ''),
          $.datepicker._pos ||
            (($.datepicker._pos = $.datepicker._findPos(a)), ($.datepicker._pos[1] += a.offsetHeight));
        var e = !1;
        $(a)
          .parents()
          .each(function () {
            return (e |= $(this).css('position') == 'fixed'), !e;
          }),
          e &&
            $.browser.opera &&
            (($.datepicker._pos[0] -= document.documentElement.scrollLeft),
            ($.datepicker._pos[1] -= document.documentElement.scrollTop));
        var f = { left: $.datepicker._pos[0], top: $.datepicker._pos[1] };
        ($.datepicker._pos = null),
          b.dpDiv.empty(),
          b.dpDiv.css({ position: 'absolute', display: 'block', top: '-1000px' }),
          $.datepicker._updateDatepicker(b),
          (f = $.datepicker._checkOffset(b, f, e)),
          b.dpDiv.css({
            position: $.datepicker._inDialog && $.blockUI ? 'static' : e ? 'fixed' : 'absolute',
            display: 'none',
            left: f.left + 'px',
            top: f.top + 'px',
          });
        if (!b.inline) {
          var g = $.datepicker._get(b, 'showAnim'),
            h = $.datepicker._get(b, 'duration'),
            i = function () {
              var a = b.dpDiv.find('iframe.ui-datepicker-cover');
              if (!!a.length) {
                var c = $.datepicker._getBorders(b.dpDiv);
                a.css({ left: -c[0], top: -c[1], width: b.dpDiv.outerWidth(), height: b.dpDiv.outerHeight() });
              }
            };
          b.dpDiv.zIndex($(a).zIndex() + 1),
            ($.datepicker._datepickerShowing = !0),
            $.effects && $.effects[g]
              ? b.dpDiv.show(g, $.datepicker._get(b, 'showOptions'), h, i)
              : b.dpDiv[g || 'show'](g ? h : null, i),
            (!g || !h) && i(),
            b.input.is(':visible') && !b.input.is(':disabled') && b.input.focus(),
            ($.datepicker._curInst = b);
        }
      },
      _updateDatepicker: function (a) {
        var b = this;
        b.maxRows = 4;
        var c = $.datepicker._getBorders(a.dpDiv);
        (instActive = a), a.dpDiv.empty().append(this._generateHTML(a)), this._attachHandlers(a);
        var d = a.dpDiv.find('iframe.ui-datepicker-cover');
        !d.length || d.css({ left: -c[0], top: -c[1], width: a.dpDiv.outerWidth(), height: a.dpDiv.outerHeight() }),
          a.dpDiv.find('.' + this._dayOverClass + ' a').mouseover();
        var e = this._getNumberOfMonths(a),
          f = e[1],
          g = 17;
        a.dpDiv.removeClass('ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4').width(''),
          f > 1 && a.dpDiv.addClass('ui-datepicker-multi-' + f).css('width', g * f + 'em'),
          a.dpDiv[(e[0] != 1 || e[1] != 1 ? 'add' : 'remove') + 'Class']('ui-datepicker-multi'),
          a.dpDiv[(this._get(a, 'isRTL') ? 'add' : 'remove') + 'Class']('ui-datepicker-rtl'),
          a == $.datepicker._curInst &&
            $.datepicker._datepickerShowing &&
            a.input &&
            a.input.is(':visible') &&
            !a.input.is(':disabled') &&
            a.input[0] != document.activeElement &&
            a.input.focus();
        if (a.yearshtml) {
          var h = a.yearshtml;
          setTimeout(function () {
            h === a.yearshtml &&
              a.yearshtml &&
              a.dpDiv.find('select.ui-datepicker-year:first').replaceWith(a.yearshtml),
              (h = a.yearshtml = null);
          }, 0);
        }
      },
      _getBorders: function (a) {
        var b = function (a) {
          return { thin: 1, medium: 2, thick: 3 }[a] || a;
        };
        return [parseFloat(b(a.css('border-left-width'))), parseFloat(b(a.css('border-top-width')))];
      },
      _checkOffset: function (a, b, c) {
        var d = a.dpDiv.outerWidth(),
          e = a.dpDiv.outerHeight(),
          f = a.input ? a.input.outerWidth() : 0,
          g = a.input ? a.input.outerHeight() : 0,
          h = document.documentElement.clientWidth + (c ? 0 : $(document).scrollLeft()),
          i = document.documentElement.clientHeight + (c ? 0 : $(document).scrollTop());
        return (
          (b.left -= this._get(a, 'isRTL') ? d - f : 0),
          (b.left -= c && b.left == a.input.offset().left ? $(document).scrollLeft() : 0),
          (b.top -= c && b.top == a.input.offset().top + g ? $(document).scrollTop() : 0),
          (b.left -= Math.min(b.left, b.left + d > h && h > d ? Math.abs(b.left + d - h) : 0)),
          (b.top -= Math.min(b.top, b.top + e > i && i > e ? Math.abs(e + g) : 0)),
          b
        );
      },
      _findPos: function (a) {
        var b = this._getInst(a),
          c = this._get(b, 'isRTL');
        while (a && (a.type == 'hidden' || a.nodeType != 1 || $.expr.filters.hidden(a)))
          a = a[c ? 'previousSibling' : 'nextSibling'];
        var d = $(a).offset();
        return [d.left, d.top];
      },
      _hideDatepicker: function (a) {
        var b = this._curInst;
        if (!b || (a && b != $.data(a, PROP_NAME))) return;
        if (this._datepickerShowing) {
          var c = this._get(b, 'showAnim'),
            d = this._get(b, 'duration'),
            e = function () {
              $.datepicker._tidyDialog(b);
            };
          $.effects && $.effects[c]
            ? b.dpDiv.hide(c, $.datepicker._get(b, 'showOptions'), d, e)
            : b.dpDiv[c == 'slideDown' ? 'slideUp' : c == 'fadeIn' ? 'fadeOut' : 'hide'](c ? d : null, e),
            c || e(),
            (this._datepickerShowing = !1);
          var f = this._get(b, 'onClose');
          f && f.apply(b.input ? b.input[0] : null, [b.input ? b.input.val() : '', b]),
            (this._lastInput = null),
            this._inDialog &&
              (this._dialogInput.css({ position: 'absolute', left: '0', top: '-100px' }),
              $.blockUI && ($.unblockUI(), $('body').append(this.dpDiv))),
            (this._inDialog = !1);
        }
      },
      _tidyDialog: function (a) {
        a.dpDiv.removeClass(this._dialogClass).unbind('.ui-datepicker-calendar');
      },
      _checkExternalClick: function (a) {
        if (!$.datepicker._curInst) return;
        var b = $(a.target),
          c = $.datepicker._getInst(b[0]);
        ((b[0].id != $.datepicker._mainDivId &&
          b.parents('#' + $.datepicker._mainDivId).length == 0 &&
          !b.hasClass($.datepicker.markerClassName) &&
          !b.closest('.' + $.datepicker._triggerClass).length &&
          $.datepicker._datepickerShowing &&
          (!$.datepicker._inDialog || !$.blockUI)) ||
          (b.hasClass($.datepicker.markerClassName) && $.datepicker._curInst != c)) &&
          $.datepicker._hideDatepicker();
      },
      _adjustDate: function (a, b, c) {
        var d = $(a),
          e = this._getInst(d[0]);
        if (this._isDisabledDatepicker(d[0])) return;
        this._adjustInstDate(e, b + (c == 'M' ? this._get(e, 'showCurrentAtPos') : 0), c), this._updateDatepicker(e);
      },
      _gotoToday: function (a) {
        var b = $(a),
          c = this._getInst(b[0]);
        if (this._get(c, 'gotoCurrent') && c.currentDay)
          (c.selectedDay = c.currentDay),
            (c.drawMonth = c.selectedMonth = c.currentMonth),
            (c.drawYear = c.selectedYear = c.currentYear);
        else {
          var d = new Date();
          (c.selectedDay = d.getDate()),
            (c.drawMonth = c.selectedMonth = d.getMonth()),
            (c.drawYear = c.selectedYear = d.getFullYear());
        }
        this._notifyChange(c), this._adjustDate(b);
      },
      _selectMonthYear: function (a, b, c) {
        var d = $(a),
          e = this._getInst(d[0]);
        (e['selected' + (c == 'M' ? 'Month' : 'Year')] = e['draw' + (c == 'M' ? 'Month' : 'Year')] =
          parseInt(b.options[b.selectedIndex].value, 10)),
          this._notifyChange(e),
          this._adjustDate(d);
      },
      _selectDay: function (a, b, c, d) {
        var e = $(a);
        if ($(d).hasClass(this._unselectableClass) || this._isDisabledDatepicker(e[0])) return;
        var f = this._getInst(e[0]);
        (f.selectedDay = f.currentDay = $('a', d).html()),
          (f.selectedMonth = f.currentMonth = b),
          (f.selectedYear = f.currentYear = c),
          this._selectDate(a, this._formatDate(f, f.currentDay, f.currentMonth, f.currentYear));
      },
      _clearDate: function (a) {
        var b = $(a),
          c = this._getInst(b[0]);
        this._selectDate(b, '');
      },
      _selectDate: function (a, b) {
        var c = $(a),
          d = this._getInst(c[0]);
        (b = b != null ? b : this._formatDate(d)), d.input && d.input.val(b), this._updateAlternate(d);
        var e = this._get(d, 'onSelect');
        e ? e.apply(d.input ? d.input[0] : null, [b, d]) : d.input && d.input.trigger('change'),
          d.inline
            ? this._updateDatepicker(d)
            : (this._hideDatepicker(),
              (this._lastInput = d.input[0]),
              typeof d.input[0] != 'object' && d.input.focus(),
              (this._lastInput = null));
      },
      _updateAlternate: function (a) {
        var b = this._get(a, 'altField');
        if (b) {
          var c = this._get(a, 'altFormat') || this._get(a, 'dateFormat'),
            d = this._getDate(a),
            e = this.formatDate(c, d, this._getFormatConfig(a));
          $(b).each(function () {
            $(this).val(e);
          });
        }
      },
      noWeekends: function (a) {
        var b = a.getDay();
        return [b > 0 && b < 6, ''];
      },
      iso8601Week: function (a) {
        var b = new Date(a.getTime());
        b.setDate(b.getDate() + 4 - (b.getDay() || 7));
        var c = b.getTime();
        return b.setMonth(0), b.setDate(1), Math.floor(Math.round((c - b) / 864e5) / 7) + 1;
      },
      parseDate: function (a, b, c) {
        if (a == null || b == null) throw 'Invalid arguments';
        b = typeof b == 'object' ? b.toString() : b + '';
        if (b == '') return null;
        var d = (c ? c.shortYearCutoff : null) || this._defaults.shortYearCutoff;
        d = typeof d != 'string' ? d : (new Date().getFullYear() % 100) + parseInt(d, 10);
        var e = (c ? c.dayNamesShort : null) || this._defaults.dayNamesShort,
          f = (c ? c.dayNames : null) || this._defaults.dayNames,
          g = (c ? c.monthNamesShort : null) || this._defaults.monthNamesShort,
          h = (c ? c.monthNames : null) || this._defaults.monthNames,
          i = -1,
          j = -1,
          k = -1,
          l = -1,
          m = !1,
          n = function (b) {
            var c = s + 1 < a.length && a.charAt(s + 1) == b;
            return c && s++, c;
          },
          o = function (a) {
            var c = n(a),
              d = a == '@' ? 14 : a == '!' ? 20 : a == 'y' && c ? 4 : a == 'o' ? 3 : 2,
              e = new RegExp('^\\d{1,' + d + '}'),
              f = b.substring(r).match(e);
            if (!f) throw 'Missing number at position ' + r;
            return (r += f[0].length), parseInt(f[0], 10);
          },
          p = function (a, c, d) {
            var e = $.map(n(a) ? d : c, function (a, b) {
                return [[b, a]];
              }).sort(function (a, b) {
                return -(a[1].length - b[1].length);
              }),
              f = -1;
            $.each(e, function (a, c) {
              var d = c[1];
              if (b.substr(r, d.length).toLowerCase() == d.toLowerCase()) return (f = c[0]), (r += d.length), !1;
            });
            if (f != -1) return f + 1;
            throw 'Unknown name at position ' + r;
          },
          q = function () {
            if (b.charAt(r) != a.charAt(s)) throw 'Unexpected literal at position ' + r;
            r++;
          },
          r = 0;
        for (var s = 0; s < a.length; s++)
          if (m) a.charAt(s) == "'" && !n("'") ? (m = !1) : q();
          else
            switch (a.charAt(s)) {
              case 'd':
                k = o('d');
                break;
              case 'D':
                p('D', e, f);
                break;
              case 'o':
                l = o('o');
                break;
              case 'm':
                j = o('m');
                break;
              case 'M':
                j = p('M', g, h);
                break;
              case 'y':
                i = o('y');
                break;
              case '@':
                var t = new Date(o('@'));
                (i = t.getFullYear()), (j = t.getMonth() + 1), (k = t.getDate());
                break;
              case '!':
                var t = new Date((o('!') - this._ticksTo1970) / 1e4);
                (i = t.getFullYear()), (j = t.getMonth() + 1), (k = t.getDate());
                break;
              case "'":
                n("'") ? q() : (m = !0);
                break;
              default:
                q();
            }
        if (r < b.length) throw 'Extra/unparsed characters found in date: ' + b.substring(r);
        i == -1
          ? (i = new Date().getFullYear())
          : i < 100 && (i += new Date().getFullYear() - (new Date().getFullYear() % 100) + (i <= d ? 0 : -100));
        if (l > -1) {
          (j = 1), (k = l);
          do {
            var u = this._getDaysInMonth(i, j - 1);
            if (k <= u) break;
            j++, (k -= u);
          } while (!0);
        }
        var t = this._daylightSavingAdjust(new Date(i, j - 1, k));
        if (t.getFullYear() != i || t.getMonth() + 1 != j || t.getDate() != k) throw 'Invalid date';
        return t;
      },
      ATOM: 'yy-mm-dd',
      COOKIE: 'D, dd M yy',
      ISO_8601: 'yy-mm-dd',
      RFC_822: 'D, d M y',
      RFC_850: 'DD, dd-M-y',
      RFC_1036: 'D, d M y',
      RFC_1123: 'D, d M yy',
      RFC_2822: 'D, d M yy',
      RSS: 'D, d M y',
      TICKS: '!',
      TIMESTAMP: '@',
      W3C: 'yy-mm-dd',
      _ticksTo1970: (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 24 * 60 * 60 * 1e7,
      formatDate: function (a, b, c) {
        if (!b) return '';
        var d = (c ? c.dayNamesShort : null) || this._defaults.dayNamesShort,
          e = (c ? c.dayNames : null) || this._defaults.dayNames,
          f = (c ? c.monthNamesShort : null) || this._defaults.monthNamesShort,
          g = (c ? c.monthNames : null) || this._defaults.monthNames,
          h = function (b) {
            var c = m + 1 < a.length && a.charAt(m + 1) == b;
            return c && m++, c;
          },
          i = function (a, b, c) {
            var d = '' + b;
            if (h(a)) while (d.length < c) d = '0' + d;
            return d;
          },
          j = function (a, b, c, d) {
            return h(a) ? d[b] : c[b];
          },
          k = '',
          l = !1;
        if (b)
          for (var m = 0; m < a.length; m++)
            if (l) a.charAt(m) == "'" && !h("'") ? (l = !1) : (k += a.charAt(m));
            else
              switch (a.charAt(m)) {
                case 'd':
                  k += i('d', b.getDate(), 2);
                  break;
                case 'D':
                  k += j('D', b.getDay(), d, e);
                  break;
                case 'o':
                  k += i(
                    'o',
                    Math.round(
                      (new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime() -
                        new Date(b.getFullYear(), 0, 0).getTime()) /
                        864e5,
                    ),
                    3,
                  );
                  break;
                case 'm':
                  k += i('m', b.getMonth() + 1, 2);
                  break;
                case 'M':
                  k += j('M', b.getMonth(), f, g);
                  break;
                case 'y':
                  k += h('y') ? b.getFullYear() : (b.getYear() % 100 < 10 ? '0' : '') + (b.getYear() % 100);
                  break;
                case '@':
                  k += b.getTime();
                  break;
                case '!':
                  k += b.getTime() * 1e4 + this._ticksTo1970;
                  break;
                case "'":
                  h("'") ? (k += "'") : (l = !0);
                  break;
                default:
                  k += a.charAt(m);
              }
        return k;
      },
      _possibleChars: function (a) {
        var b = '',
          c = !1,
          d = function (b) {
            var c = e + 1 < a.length && a.charAt(e + 1) == b;
            return c && e++, c;
          };
        for (var e = 0; e < a.length; e++)
          if (c) a.charAt(e) == "'" && !d("'") ? (c = !1) : (b += a.charAt(e));
          else
            switch (a.charAt(e)) {
              case 'd':
              case 'm':
              case 'y':
              case '@':
                b += '0123456789';
                break;
              case 'D':
              case 'M':
                return null;
              case "'":
                d("'") ? (b += "'") : (c = !0);
                break;
              default:
                b += a.charAt(e);
            }
        return b;
      },
      _get: function (a, b) {
        return a.settings[b] !== undefined ? a.settings[b] : this._defaults[b];
      },
      _setDateFromField: function (a, b) {
        if (a.input.val() == a.lastVal) return;
        var c = this._get(a, 'dateFormat'),
          d = (a.lastVal = a.input ? a.input.val() : null),
          e,
          f;
        e = f = this._getDefaultDate(a);
        var g = this._getFormatConfig(a);
        try {
          e = this.parseDate(c, d, g) || f;
        } catch (h) {
          this.log(h), (d = b ? '' : d);
        }
        (a.selectedDay = e.getDate()),
          (a.drawMonth = a.selectedMonth = e.getMonth()),
          (a.drawYear = a.selectedYear = e.getFullYear()),
          (a.currentDay = d ? e.getDate() : 0),
          (a.currentMonth = d ? e.getMonth() : 0),
          (a.currentYear = d ? e.getFullYear() : 0),
          this._adjustInstDate(a);
      },
      _getDefaultDate: function (a) {
        return this._restrictMinMax(a, this._determineDate(a, this._get(a, 'defaultDate'), new Date()));
      },
      _determineDate: function (a, b, c) {
        var d = function (a) {
            var b = new Date();
            return b.setDate(b.getDate() + a), b;
          },
          e = function (b) {
            try {
              return $.datepicker.parseDate($.datepicker._get(a, 'dateFormat'), b, $.datepicker._getFormatConfig(a));
            } catch (c) {}
            var d = (b.toLowerCase().match(/^c/) ? $.datepicker._getDate(a) : null) || new Date(),
              e = d.getFullYear(),
              f = d.getMonth(),
              g = d.getDate(),
              h = /([+-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
              i = h.exec(b);
            while (i) {
              switch (i[2] || 'd') {
                case 'd':
                case 'D':
                  g += parseInt(i[1], 10);
                  break;
                case 'w':
                case 'W':
                  g += parseInt(i[1], 10) * 7;
                  break;
                case 'm':
                case 'M':
                  (f += parseInt(i[1], 10)), (g = Math.min(g, $.datepicker._getDaysInMonth(e, f)));
                  break;
                case 'y':
                case 'Y':
                  (e += parseInt(i[1], 10)), (g = Math.min(g, $.datepicker._getDaysInMonth(e, f)));
              }
              i = h.exec(b);
            }
            return new Date(e, f, g);
          },
          f =
            b == null || b === ''
              ? c
              : typeof b == 'string'
              ? e(b)
              : typeof b == 'number'
              ? isNaN(b)
                ? c
                : d(b)
              : new Date(b.getTime());
        return (
          (f = f && f.toString() == 'Invalid Date' ? c : f),
          f && (f.setHours(0), f.setMinutes(0), f.setSeconds(0), f.setMilliseconds(0)),
          this._daylightSavingAdjust(f)
        );
      },
      _daylightSavingAdjust: function (a) {
        return a ? (a.setHours(a.getHours() > 12 ? a.getHours() + 2 : 0), a) : null;
      },
      _setDate: function (a, b, c) {
        var d = !b,
          e = a.selectedMonth,
          f = a.selectedYear,
          g = this._restrictMinMax(a, this._determineDate(a, b, new Date()));
        (a.selectedDay = a.currentDay = g.getDate()),
          (a.drawMonth = a.selectedMonth = a.currentMonth = g.getMonth()),
          (a.drawYear = a.selectedYear = a.currentYear = g.getFullYear()),
          (e != a.selectedMonth || f != a.selectedYear) && !c && this._notifyChange(a),
          this._adjustInstDate(a),
          a.input && a.input.val(d ? '' : this._formatDate(a));
      },
      _getDate: function (a) {
        var b =
          !a.currentYear || (a.input && a.input.val() == '')
            ? null
            : this._daylightSavingAdjust(new Date(a.currentYear, a.currentMonth, a.currentDay));
        return b;
      },
      _attachHandlers: function (a) {
        var b = this._get(a, 'stepMonths'),
          c = '#' + a.id.replace(/\\\\/g, '\\');
        a.dpDiv.find('[data-handler]').map(function () {
          var a = {
            prev: function () {
              window['DP_jQuery_' + dpuuid].datepicker._adjustDate(c, -b, 'M');
            },
            next: function () {
              window['DP_jQuery_' + dpuuid].datepicker._adjustDate(c, +b, 'M');
            },
            hide: function () {
              window['DP_jQuery_' + dpuuid].datepicker._hideDatepicker();
            },
            today: function () {
              window['DP_jQuery_' + dpuuid].datepicker._gotoToday(c);
            },
            selectDay: function () {
              return (
                window['DP_jQuery_' + dpuuid].datepicker._selectDay(
                  c,
                  +this.getAttribute('data-month'),
                  +this.getAttribute('data-year'),
                  this,
                ),
                !1
              );
            },
            selectMonth: function () {
              return window['DP_jQuery_' + dpuuid].datepicker._selectMonthYear(c, this, 'M'), !1;
            },
            selectYear: function () {
              return window['DP_jQuery_' + dpuuid].datepicker._selectMonthYear(c, this, 'Y'), !1;
            },
          };
          $(this).bind(this.getAttribute('data-event'), a[this.getAttribute('data-handler')]);
        });
      },
      _generateHTML: function (a) {
        var b = new Date();
        b = this._daylightSavingAdjust(new Date(b.getFullYear(), b.getMonth(), b.getDate()));
        var c = this._get(a, 'isRTL'),
          d = this._get(a, 'showButtonPanel'),
          e = this._get(a, 'hideIfNoPrevNext'),
          f = this._get(a, 'navigationAsDateFormat'),
          g = this._getNumberOfMonths(a),
          h = this._get(a, 'showCurrentAtPos'),
          i = this._get(a, 'stepMonths'),
          j = g[0] != 1 || g[1] != 1,
          k = this._daylightSavingAdjust(
            a.currentDay ? new Date(a.currentYear, a.currentMonth, a.currentDay) : new Date(9999, 9, 9),
          ),
          l = this._getMinMaxDate(a, 'min'),
          m = this._getMinMaxDate(a, 'max'),
          n = a.drawMonth - h,
          o = a.drawYear;
        n < 0 && ((n += 12), o--);
        if (m) {
          var p = this._daylightSavingAdjust(new Date(m.getFullYear(), m.getMonth() - g[0] * g[1] + 1, m.getDate()));
          p = l && p < l ? l : p;
          while (this._daylightSavingAdjust(new Date(o, n, 1)) > p) n--, n < 0 && ((n = 11), o--);
        }
        (a.drawMonth = n), (a.drawYear = o);
        var q = this._get(a, 'prevText');
        q = f ? this.formatDate(q, this._daylightSavingAdjust(new Date(o, n - i, 1)), this._getFormatConfig(a)) : q;
        var r = this._canAdjustMonth(a, -1, o, n)
            ? '<a class="ui-datepicker-prev ui-corner-all" data-handler="prev" data-event="click" title="' +
              q +
              '"><span class="ui-icon ui-icon-circle-triangle-' +
              (c ? 'e' : 'w') +
              '">' +
              q +
              '</span></a>'
            : e
            ? ''
            : '<a class="ui-datepicker-prev ui-corner-all ui-state-disabled" title="' +
              q +
              '"><span class="ui-icon ui-icon-circle-triangle-' +
              (c ? 'e' : 'w') +
              '">' +
              q +
              '</span></a>',
          s = this._get(a, 'nextText');
        s = f ? this.formatDate(s, this._daylightSavingAdjust(new Date(o, n + i, 1)), this._getFormatConfig(a)) : s;
        var t = this._canAdjustMonth(a, 1, o, n)
            ? '<a class="ui-datepicker-next ui-corner-all" data-handler="next" data-event="click" title="' +
              s +
              '"><span class="ui-icon ui-icon-circle-triangle-' +
              (c ? 'w' : 'e') +
              '">' +
              s +
              '</span></a>'
            : e
            ? ''
            : '<a class="ui-datepicker-next ui-corner-all ui-state-disabled" title="' +
              s +
              '"><span class="ui-icon ui-icon-circle-triangle-' +
              (c ? 'w' : 'e') +
              '">' +
              s +
              '</span></a>',
          u = this._get(a, 'currentText'),
          v = this._get(a, 'gotoCurrent') && a.currentDay ? k : b;
        u = f ? this.formatDate(u, v, this._getFormatConfig(a)) : u;
        var w = a.inline
            ? ''
            : '<button type="button" class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all" data-handler="hide" data-event="click">' +
              this._get(a, 'closeText') +
              '</button>',
          x = d
            ? '<div class="ui-datepicker-buttonpane ui-widget-content">' +
              (c ? w : '') +
              (this._isInRange(a, v)
                ? '<button type="button" class="ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all" data-handler="today" data-event="click">' +
                  u +
                  '</button>'
                : '') +
              (c ? '' : w) +
              '</div>'
            : '',
          y = parseInt(this._get(a, 'firstDay'), 10);
        y = isNaN(y) ? 0 : y;
        var z = this._get(a, 'showWeek'),
          A = this._get(a, 'dayNames'),
          B = this._get(a, 'dayNamesShort'),
          C = this._get(a, 'dayNamesMin'),
          D = this._get(a, 'monthNames'),
          E = this._get(a, 'monthNamesShort'),
          F = this._get(a, 'beforeShowDay'),
          G = this._get(a, 'showOtherMonths'),
          H = this._get(a, 'selectOtherMonths'),
          I = this._get(a, 'calculateWeek') || this.iso8601Week,
          J = this._getDefaultDate(a),
          K = '';
        for (var L = 0; L < g[0]; L++) {
          var M = '';
          this.maxRows = 4;
          for (var N = 0; N < g[1]; N++) {
            var O = this._daylightSavingAdjust(new Date(o, n, a.selectedDay)),
              P = ' ui-corner-all',
              Q = '';
            if (j) {
              Q += '<div class="ui-datepicker-group';
              if (g[1] > 1)
                switch (N) {
                  case 0:
                    (Q += ' ui-datepicker-group-first'), (P = ' ui-corner-' + (c ? 'right' : 'left'));
                    break;
                  case g[1] - 1:
                    (Q += ' ui-datepicker-group-last'), (P = ' ui-corner-' + (c ? 'left' : 'right'));
                    break;
                  default:
                    (Q += ' ui-datepicker-group-middle'), (P = '');
                }
              Q += '">';
            }
            Q +=
              '<div class="ui-datepicker-header ui-widget-header ui-helper-clearfix' +
              P +
              '">' +
              (/all|left/.test(P) && L == 0 ? (c ? t : r) : '') +
              (/all|right/.test(P) && L == 0 ? (c ? r : t) : '') +
              this._generateMonthYearHeader(a, n, o, l, m, L > 0 || N > 0, D, E) +
              '</div><table class="ui-datepicker-calendar"><thead>' +
              '<tr>';
            var R = z ? '<th class="ui-datepicker-week-col">' + this._get(a, 'weekHeader') + '</th>' : '';
            for (var S = 0; S < 7; S++) {
              var T = (S + y) % 7;
              R +=
                '<th' +
                ((S + y + 6) % 7 >= 5 ? ' class="ui-datepicker-week-end"' : '') +
                '>' +
                '<span title="' +
                A[T] +
                '">' +
                C[T] +
                '</span></th>';
            }
            Q += R + '</tr></thead><tbody>';
            var U = this._getDaysInMonth(o, n);
            o == a.selectedYear && n == a.selectedMonth && (a.selectedDay = Math.min(a.selectedDay, U));
            var V = (this._getFirstDayOfMonth(o, n) - y + 7) % 7,
              W = Math.ceil((V + U) / 7),
              X = j ? (this.maxRows > W ? this.maxRows : W) : W;
            this.maxRows = X;
            var Y = this._daylightSavingAdjust(new Date(o, n, 1 - V));
            for (var Z = 0; Z < X; Z++) {
              Q += '<tr>';
              var _ = z ? '<td class="ui-datepicker-week-col">' + this._get(a, 'calculateWeek')(Y) + '</td>' : '';
              for (var S = 0; S < 7; S++) {
                var ba = F ? F.apply(a.input ? a.input[0] : null, [Y]) : [!0, ''],
                  bb = Y.getMonth() != n,
                  bc = (bb && !H) || !ba[0] || (l && Y < l) || (m && Y > m);
                (_ +=
                  '<td class="' +
                  ((S + y + 6) % 7 >= 5 ? ' ui-datepicker-week-end' : '') +
                  (bb ? ' ui-datepicker-other-month' : '') +
                  ((Y.getTime() == O.getTime() && n == a.selectedMonth && a._keyEvent) ||
                  (J.getTime() == Y.getTime() && J.getTime() == O.getTime())
                    ? ' ' + this._dayOverClass
                    : '') +
                  (bc ? ' ' + this._unselectableClass + ' ui-state-disabled' : '') +
                  (bb && !G
                    ? ''
                    : ' ' +
                      ba[1] +
                      (Y.getTime() == k.getTime() ? ' ' + this._currentClass : '') +
                      (Y.getTime() == b.getTime() ? ' ui-datepicker-today' : '')) +
                  '"' +
                  ((!bb || G) && ba[2] ? ' title="' + ba[2] + '"' : '') +
                  (bc
                    ? ''
                    : ' data-handler="selectDay" data-event="click" data-month="' +
                      Y.getMonth() +
                      '" data-year="' +
                      Y.getFullYear() +
                      '"') +
                  '>' +
                  (bb && !G
                    ? '&#xa0;'
                    : bc
                    ? '<span class="ui-state-default">' + Y.getDate() + '</span>'
                    : '<a class="ui-state-default' +
                      (Y.getTime() == b.getTime() ? ' ui-state-highlight' : '') +
                      (Y.getTime() == k.getTime() ? ' ui-state-active' : '') +
                      (bb ? ' ui-priority-secondary' : '') +
                      '" href="#">' +
                      Y.getDate() +
                      '</a>') +
                  '</td>'),
                  Y.setDate(Y.getDate() + 1),
                  (Y = this._daylightSavingAdjust(Y));
              }
              Q += _ + '</tr>';
            }
            n++,
              n > 11 && ((n = 0), o++),
              (Q +=
                '</tbody></table>' +
                (j ? '</div>' + (g[0] > 0 && N == g[1] - 1 ? '<div class="ui-datepicker-row-break"></div>' : '') : '')),
              (M += Q);
          }
          K += M;
        }
        return (
          (K +=
            x +
            ($.browser.msie && parseInt($.browser.version, 10) < 7 && !a.inline
              ? '<iframe src="javascript:false;" class="ui-datepicker-cover" frameborder="0"></iframe>'
              : '')),
          (a._keyEvent = !1),
          K
        );
      },
      _generateMonthYearHeader: function (a, b, c, d, e, f, g, h) {
        var i = this._get(a, 'changeMonth'),
          j = this._get(a, 'changeYear'),
          k = this._get(a, 'showMonthAfterYear'),
          l = '<div class="ui-datepicker-title">',
          m = '';
        if (f || !i) m += '<span class="ui-datepicker-month">' + g[b] + '</span>';
        else {
          var n = d && d.getFullYear() == c,
            o = e && e.getFullYear() == c;
          m += '<select class="ui-datepicker-month" data-handler="selectMonth" data-event="change">';
          for (var p = 0; p < 12; p++)
            (!n || p >= d.getMonth()) &&
              (!o || p <= e.getMonth()) &&
              (m += '<option value="' + p + '"' + (p == b ? ' selected="selected"' : '') + '>' + h[p] + '</option>');
          m += '</select>';
        }
        k || (l += m + (f || !i || !j ? '&#xa0;' : ''));
        if (!a.yearshtml) {
          a.yearshtml = '';
          if (f || !j) l += '<span class="ui-datepicker-year">' + c + '</span>';
          else {
            var q = this._get(a, 'yearRange').split(':'),
              r = new Date().getFullYear(),
              s = function (a) {
                var b = a.match(/c[+-].*/)
                  ? c + parseInt(a.substring(1), 10)
                  : a.match(/[+-].*/)
                  ? r + parseInt(a, 10)
                  : parseInt(a, 10);
                return isNaN(b) ? r : b;
              },
              t = s(q[0]),
              u = Math.max(t, s(q[1] || ''));
            (t = d ? Math.max(t, d.getFullYear()) : t),
              (u = e ? Math.min(u, e.getFullYear()) : u),
              (a.yearshtml += '<select class="ui-datepicker-year" data-handler="selectYear" data-event="change">');
            for (; t <= u; t++)
              a.yearshtml +=
                '<option value="' + t + '"' + (t == c ? ' selected="selected"' : '') + '>' + t + '</option>';
            (a.yearshtml += '</select>'), (l += a.yearshtml), (a.yearshtml = null);
          }
        }
        return (l += this._get(a, 'yearSuffix')), k && (l += (f || !i || !j ? '&#xa0;' : '') + m), (l += '</div>'), l;
      },
      _adjustInstDate: function (a, b, c) {
        var d = a.drawYear + (c == 'Y' ? b : 0),
          e = a.drawMonth + (c == 'M' ? b : 0),
          f = Math.min(a.selectedDay, this._getDaysInMonth(d, e)) + (c == 'D' ? b : 0),
          g = this._restrictMinMax(a, this._daylightSavingAdjust(new Date(d, e, f)));
        (a.selectedDay = g.getDate()),
          (a.drawMonth = a.selectedMonth = g.getMonth()),
          (a.drawYear = a.selectedYear = g.getFullYear()),
          (c == 'M' || c == 'Y') && this._notifyChange(a);
      },
      _restrictMinMax: function (a, b) {
        var c = this._getMinMaxDate(a, 'min'),
          d = this._getMinMaxDate(a, 'max'),
          e = c && b < c ? c : b;
        return (e = d && e > d ? d : e), e;
      },
      _notifyChange: function (a) {
        var b = this._get(a, 'onChangeMonthYear');
        b && b.apply(a.input ? a.input[0] : null, [a.selectedYear, a.selectedMonth + 1, a]);
      },
      _getNumberOfMonths: function (a) {
        var b = this._get(a, 'numberOfMonths');
        return b == null ? [1, 1] : typeof b == 'number' ? [1, b] : b;
      },
      _getMinMaxDate: function (a, b) {
        return this._determineDate(a, this._get(a, b + 'Date'), null);
      },
      _getDaysInMonth: function (a, b) {
        return 32 - this._daylightSavingAdjust(new Date(a, b, 32)).getDate();
      },
      _getFirstDayOfMonth: function (a, b) {
        return new Date(a, b, 1).getDay();
      },
      _canAdjustMonth: function (a, b, c, d) {
        var e = this._getNumberOfMonths(a),
          f = this._daylightSavingAdjust(new Date(c, d + (b < 0 ? b : e[0] * e[1]), 1));
        return b < 0 && f.setDate(this._getDaysInMonth(f.getFullYear(), f.getMonth())), this._isInRange(a, f);
      },
      _isInRange: function (a, b) {
        var c = this._getMinMaxDate(a, 'min'),
          d = this._getMinMaxDate(a, 'max');
        return (!c || b.getTime() >= c.getTime()) && (!d || b.getTime() <= d.getTime());
      },
      _getFormatConfig: function (a) {
        var b = this._get(a, 'shortYearCutoff');
        return (
          (b = typeof b != 'string' ? b : (new Date().getFullYear() % 100) + parseInt(b, 10)),
          {
            shortYearCutoff: b,
            dayNamesShort: this._get(a, 'dayNamesShort'),
            dayNames: this._get(a, 'dayNames'),
            monthNamesShort: this._get(a, 'monthNamesShort'),
            monthNames: this._get(a, 'monthNames'),
          }
        );
      },
      _formatDate: function (a, b, c, d) {
        b || ((a.currentDay = a.selectedDay), (a.currentMonth = a.selectedMonth), (a.currentYear = a.selectedYear));
        var e = b
          ? typeof b == 'object'
            ? b
            : this._daylightSavingAdjust(new Date(d, c, b))
          : this._daylightSavingAdjust(new Date(a.currentYear, a.currentMonth, a.currentDay));
        return this.formatDate(this._get(a, 'dateFormat'), e, this._getFormatConfig(a));
      },
    }),
      ($.fn.datepicker = function (a) {
        if (!this.length) return this;
        $.datepicker.initialized ||
          ($(document).mousedown($.datepicker._checkExternalClick).find('body').append($.datepicker.dpDiv),
          ($.datepicker.initialized = !0));
        var b = Array.prototype.slice.call(arguments, 1);
        return typeof a != 'string' || (a != 'isDisabled' && a != 'getDate' && a != 'widget')
          ? a == 'option' && arguments.length == 2 && typeof arguments[1] == 'string'
            ? $.datepicker['_' + a + 'Datepicker'].apply($.datepicker, [this[0]].concat(b))
            : this.each(function () {
                typeof a == 'string'
                  ? $.datepicker['_' + a + 'Datepicker'].apply($.datepicker, [this].concat(b))
                  : $.datepicker._attachDatepicker(this, a);
              })
          : $.datepicker['_' + a + 'Datepicker'].apply($.datepicker, [this[0]].concat(b));
      }),
      ($.datepicker = new Datepicker()),
      ($.datepicker.initialized = !1),
      ($.datepicker.uuid = new Date().getTime()),
      ($.datepicker.version = '1.8.24'),
      (window['DP_jQuery_' + dpuuid] = $);
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.ui.progressbar.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.widget('ui.progressbar', {
      options: { value: 0, max: 100 },
      min: 0,
      _create: function () {
        this.element.addClass('ui-progressbar ui-widget ui-widget-content ui-corner-all').attr({
          role: 'progressbar',
          'aria-valuemin': this.min,
          'aria-valuemax': this.options.max,
          'aria-valuenow': this._value(),
        }),
          (this.valueDiv = a("<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>").appendTo(
            this.element,
          )),
          (this.oldValue = this._value()),
          this._refreshValue();
      },
      destroy: function () {
        this.element
          .removeClass('ui-progressbar ui-widget ui-widget-content ui-corner-all')
          .removeAttr('role')
          .removeAttr('aria-valuemin')
          .removeAttr('aria-valuemax')
          .removeAttr('aria-valuenow'),
          this.valueDiv.remove(),
          a.Widget.prototype.destroy.apply(this, arguments);
      },
      value: function (a) {
        return a === b ? this._value() : (this._setOption('value', a), this);
      },
      _setOption: function (b, c) {
        b === 'value' &&
          ((this.options.value = c),
          this._refreshValue(),
          this._value() === this.options.max && this._trigger('complete')),
          a.Widget.prototype._setOption.apply(this, arguments);
      },
      _value: function () {
        var a = this.options.value;
        return typeof a != 'number' && (a = 0), Math.min(this.options.max, Math.max(this.min, a));
      },
      _percentage: function () {
        return (100 * this._value()) / this.options.max;
      },
      _refreshValue: function () {
        var a = this.value(),
          b = this._percentage();
        this.oldValue !== a && ((this.oldValue = a), this._trigger('change')),
          this.valueDiv
            .toggle(a > this.min)
            .toggleClass('ui-corner-right', a === this.options.max)
            .width(b.toFixed(0) + '%'),
          this.element.attr('aria-valuenow', a);
      },
    }),
      a.extend(a.ui.progressbar, { version: '1.8.24' });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.core.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  jQuery.effects ||
    (function (a, b) {
      function c(b) {
        var c;
        return b && b.constructor == Array && b.length == 3
          ? b
          : (c = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(b))
          ? [parseInt(c[1], 10), parseInt(c[2], 10), parseInt(c[3], 10)]
          : (c =
              /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(
                b,
              ))
          ? [parseFloat(c[1]) * 2.55, parseFloat(c[2]) * 2.55, parseFloat(c[3]) * 2.55]
          : (c = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(b))
          ? [parseInt(c[1], 16), parseInt(c[2], 16), parseInt(c[3], 16)]
          : (c = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(b))
          ? [parseInt(c[1] + c[1], 16), parseInt(c[2] + c[2], 16), parseInt(c[3] + c[3], 16)]
          : (c = /rgba\(0, 0, 0, 0\)/.exec(b))
          ? e.transparent
          : e[a.trim(b).toLowerCase()];
      }
      function d(b, d) {
        var e;
        do {
          e = (a.curCSS || a.css)(b, d);
          if ((e != '' && e != 'transparent') || a.nodeName(b, 'body')) break;
          d = 'backgroundColor';
        } while ((b = b.parentNode));
        return c(e);
      }
      function h() {
        var a = document.defaultView ? document.defaultView.getComputedStyle(this, null) : this.currentStyle,
          b = {},
          c,
          d;
        if (a && a.length && a[0] && a[a[0]]) {
          var e = a.length;
          while (e--)
            (c = a[e]),
              typeof a[c] == 'string' &&
                ((d = c.replace(/\-(\w)/g, function (a, b) {
                  return b.toUpperCase();
                })),
                (b[d] = a[c]));
        } else for (c in a) typeof a[c] == 'string' && (b[c] = a[c]);
        return b;
      }
      function i(b) {
        var c, d;
        for (c in b)
          (d = b[c]),
            (d == null ||
              a.isFunction(d) ||
              c in g ||
              /scrollbar/.test(c) ||
              (!/color/i.test(c) && isNaN(parseFloat(d)))) &&
              delete b[c];
        return b;
      }
      function j(a, b) {
        var c = { _: 0 },
          d;
        for (d in b) a[d] != b[d] && (c[d] = b[d]);
        return c;
      }
      function k(b, c, d, e) {
        typeof b == 'object' && ((e = c), (d = null), (c = b), (b = c.effect)),
          a.isFunction(c) && ((e = c), (d = null), (c = {}));
        if (typeof c == 'number' || a.fx.speeds[c]) (e = d), (d = c), (c = {});
        return (
          a.isFunction(d) && ((e = d), (d = null)),
          (c = c || {}),
          (d = d || c.duration),
          (d = a.fx.off ? 0 : typeof d == 'number' ? d : d in a.fx.speeds ? a.fx.speeds[d] : a.fx.speeds._default),
          (e = e || c.complete),
          [b, c, d, e]
        );
      }
      function l(b) {
        return !b || typeof b == 'number' || a.fx.speeds[b] ? !0 : typeof b == 'string' && !a.effects[b] ? !0 : !1;
      }
      (a.effects = {}),
        a.each(
          [
            'backgroundColor',
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor',
            'borderColor',
            'color',
            'outlineColor',
          ],
          function (b, e) {
            a.fx.step[e] = function (a) {
              a.colorInit || ((a.start = d(a.elem, e)), (a.end = c(a.end)), (a.colorInit = !0)),
                (a.elem.style[e] =
                  'rgb(' +
                  Math.max(Math.min(parseInt(a.pos * (a.end[0] - a.start[0]) + a.start[0], 10), 255), 0) +
                  ',' +
                  Math.max(Math.min(parseInt(a.pos * (a.end[1] - a.start[1]) + a.start[1], 10), 255), 0) +
                  ',' +
                  Math.max(Math.min(parseInt(a.pos * (a.end[2] - a.start[2]) + a.start[2], 10), 255), 0) +
                  ')');
            };
          },
        );
      var e = {
          aqua: [0, 255, 255],
          azure: [240, 255, 255],
          beige: [245, 245, 220],
          black: [0, 0, 0],
          blue: [0, 0, 255],
          brown: [165, 42, 42],
          cyan: [0, 255, 255],
          darkblue: [0, 0, 139],
          darkcyan: [0, 139, 139],
          darkgrey: [169, 169, 169],
          darkgreen: [0, 100, 0],
          darkkhaki: [189, 183, 107],
          darkmagenta: [139, 0, 139],
          darkolivegreen: [85, 107, 47],
          darkorange: [255, 140, 0],
          darkorchid: [153, 50, 204],
          darkred: [139, 0, 0],
          darksalmon: [233, 150, 122],
          darkviolet: [148, 0, 211],
          fuchsia: [255, 0, 255],
          gold: [255, 215, 0],
          green: [0, 128, 0],
          indigo: [75, 0, 130],
          khaki: [240, 230, 140],
          lightblue: [173, 216, 230],
          lightcyan: [224, 255, 255],
          lightgreen: [144, 238, 144],
          lightgrey: [211, 211, 211],
          lightpink: [255, 182, 193],
          lightyellow: [255, 255, 224],
          lime: [0, 255, 0],
          magenta: [255, 0, 255],
          maroon: [128, 0, 0],
          navy: [0, 0, 128],
          olive: [128, 128, 0],
          orange: [255, 165, 0],
          pink: [255, 192, 203],
          purple: [128, 0, 128],
          violet: [128, 0, 128],
          red: [255, 0, 0],
          silver: [192, 192, 192],
          white: [255, 255, 255],
          yellow: [255, 255, 0],
          transparent: [255, 255, 255],
        },
        f = ['add', 'remove', 'toggle'],
        g = {
          border: 1,
          borderBottom: 1,
          borderColor: 1,
          borderLeft: 1,
          borderRight: 1,
          borderTop: 1,
          borderWidth: 1,
          margin: 1,
          padding: 1,
        };
      (a.effects.animateClass = function (b, c, d, e) {
        return (
          a.isFunction(d) && ((e = d), (d = null)),
          this.queue(function () {
            var g = a(this),
              k = g.attr('style') || ' ',
              l = i(h.call(this)),
              m,
              n = g.attr('class') || '';
            a.each(f, function (a, c) {
              b[c] && g[c + 'Class'](b[c]);
            }),
              (m = i(h.call(this))),
              g.attr('class', n),
              g.animate(j(l, m), {
                queue: !1,
                duration: c,
                easing: d,
                complete: function () {
                  a.each(f, function (a, c) {
                    b[c] && g[c + 'Class'](b[c]);
                  }),
                    typeof g.attr('style') == 'object'
                      ? ((g.attr('style').cssText = ''), (g.attr('style').cssText = k))
                      : g.attr('style', k),
                    e && e.apply(this, arguments),
                    a.dequeue(this);
                },
              });
          })
        );
      }),
        a.fn.extend({
          _addClass: a.fn.addClass,
          addClass: function (b, c, d, e) {
            return c ? a.effects.animateClass.apply(this, [{ add: b }, c, d, e]) : this._addClass(b);
          },
          _removeClass: a.fn.removeClass,
          removeClass: function (b, c, d, e) {
            return c ? a.effects.animateClass.apply(this, [{ remove: b }, c, d, e]) : this._removeClass(b);
          },
          _toggleClass: a.fn.toggleClass,
          toggleClass: function (c, d, e, f, g) {
            return typeof d == 'boolean' || d === b
              ? e
                ? a.effects.animateClass.apply(this, [d ? { add: c } : { remove: c }, e, f, g])
                : this._toggleClass(c, d)
              : a.effects.animateClass.apply(this, [{ toggle: c }, d, e, f]);
          },
          switchClass: function (b, c, d, e, f) {
            return a.effects.animateClass.apply(this, [{ add: c, remove: b }, d, e, f]);
          },
        }),
        a.extend(a.effects, {
          version: '1.8.24',
          save: function (a, b) {
            for (var c = 0; c < b.length; c++) b[c] !== null && a.data('ec.storage.' + b[c], a[0].style[b[c]]);
          },
          restore: function (a, b) {
            for (var c = 0; c < b.length; c++) b[c] !== null && a.css(b[c], a.data('ec.storage.' + b[c]));
          },
          setMode: function (a, b) {
            return b == 'toggle' && (b = a.is(':hidden') ? 'show' : 'hide'), b;
          },
          getBaseline: function (a, b) {
            var c, d;
            switch (a[0]) {
              case 'top':
                c = 0;
                break;
              case 'middle':
                c = 0.5;
                break;
              case 'bottom':
                c = 1;
                break;
              default:
                c = a[0] / b.height;
            }
            switch (a[1]) {
              case 'left':
                d = 0;
                break;
              case 'center':
                d = 0.5;
                break;
              case 'right':
                d = 1;
                break;
              default:
                d = a[1] / b.width;
            }
            return { x: d, y: c };
          },
          createWrapper: function (b) {
            if (b.parent().is('.ui-effects-wrapper')) return b.parent();
            var c = { width: b.outerWidth(!0), height: b.outerHeight(!0), float: b.css('float') },
              d = a('<div></div>')
                .addClass('ui-effects-wrapper')
                .css({ fontSize: '100%', background: 'transparent', border: 'none', margin: 0, padding: 0 }),
              e = document.activeElement;
            try {
              e.id;
            } catch (f) {
              e = document.body;
            }
            return (
              b.wrap(d),
              (b[0] === e || a.contains(b[0], e)) && a(e).focus(),
              (d = b.parent()),
              b.css('position') == 'static'
                ? (d.css({ position: 'relative' }), b.css({ position: 'relative' }))
                : (a.extend(c, { position: b.css('position'), zIndex: b.css('z-index') }),
                  a.each(['top', 'left', 'bottom', 'right'], function (a, d) {
                    (c[d] = b.css(d)), isNaN(parseInt(c[d], 10)) && (c[d] = 'auto');
                  }),
                  b.css({ position: 'relative', top: 0, left: 0, right: 'auto', bottom: 'auto' })),
              d.css(c).show()
            );
          },
          removeWrapper: function (b) {
            var c,
              d = document.activeElement;
            return b.parent().is('.ui-effects-wrapper')
              ? ((c = b.parent().replaceWith(b)), (b[0] === d || a.contains(b[0], d)) && a(d).focus(), c)
              : b;
          },
          setTransition: function (b, c, d, e) {
            return (
              (e = e || {}),
              a.each(c, function (a, c) {
                var f = b.cssUnit(c);
                f[0] > 0 && (e[c] = f[0] * d + f[1]);
              }),
              e
            );
          },
        }),
        a.fn.extend({
          effect: function (b, c, d, e) {
            var f = k.apply(this, arguments),
              g = { options: f[1], duration: f[2], callback: f[3] },
              h = g.options.mode,
              i = a.effects[b];
            return a.fx.off || !i
              ? h
                ? this[h](g.duration, g.callback)
                : this.each(function () {
                    g.callback && g.callback.call(this);
                  })
              : i.call(this, g);
          },
          _show: a.fn.show,
          show: function (a) {
            if (l(a)) return this._show.apply(this, arguments);
            var b = k.apply(this, arguments);
            return (b[1].mode = 'show'), this.effect.apply(this, b);
          },
          _hide: a.fn.hide,
          hide: function (a) {
            if (l(a)) return this._hide.apply(this, arguments);
            var b = k.apply(this, arguments);
            return (b[1].mode = 'hide'), this.effect.apply(this, b);
          },
          __toggle: a.fn.toggle,
          toggle: function (b) {
            if (l(b) || typeof b == 'boolean' || a.isFunction(b)) return this.__toggle.apply(this, arguments);
            var c = k.apply(this, arguments);
            return (c[1].mode = 'toggle'), this.effect.apply(this, c);
          },
          cssUnit: function (b) {
            var c = this.css(b),
              d = [];
            return (
              a.each(['em', 'px', '%', 'pt'], function (a, b) {
                c.indexOf(b) > 0 && (d = [parseFloat(c), b]);
              }),
              d
            );
          },
        });
      var m = {};
      a.each(['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'], function (a, b) {
        m[b] = function (b) {
          return Math.pow(b, a + 2);
        };
      }),
        a.extend(m, {
          Sine: function (a) {
            return 1 - Math.cos((a * Math.PI) / 2);
          },
          Circ: function (a) {
            return 1 - Math.sqrt(1 - a * a);
          },
          Elastic: function (a) {
            return a === 0 || a === 1 ? a : -Math.pow(2, 8 * (a - 1)) * Math.sin((((a - 1) * 80 - 7.5) * Math.PI) / 15);
          },
          Back: function (a) {
            return a * a * (3 * a - 2);
          },
          Bounce: function (a) {
            var b,
              c = 4;
            while (a < ((b = Math.pow(2, --c)) - 1) / 11);
            return 1 / Math.pow(4, 3 - c) - 7.5625 * Math.pow((b * 3 - 2) / 22 - a, 2);
          },
        }),
        a.each(m, function (b, c) {
          (a.easing['easeIn' + b] = c),
            (a.easing['easeOut' + b] = function (a) {
              return 1 - c(1 - a);
            }),
            (a.easing['easeInOut' + b] = function (a) {
              return a < 0.5 ? c(a * 2) / 2 : c(a * -2 + 2) / -2 + 1;
            });
        });
    })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.blind.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.blind = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right'],
          e = a.effects.setMode(c, b.options.mode || 'hide'),
          f = b.options.direction || 'vertical';
        a.effects.save(c, d), c.show();
        var g = a.effects.createWrapper(c).css({ overflow: 'hidden' }),
          h = f == 'vertical' ? 'height' : 'width',
          i = f == 'vertical' ? g.height() : g.width();
        e == 'show' && g.css(h, 0);
        var j = {};
        (j[h] = e == 'show' ? i : 0),
          g.animate(j, b.duration, b.options.easing, function () {
            e == 'hide' && c.hide(),
              a.effects.restore(c, d),
              a.effects.removeWrapper(c),
              b.callback && b.callback.apply(c[0], arguments),
              c.dequeue();
          });
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.bounce.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.bounce = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right'],
          e = a.effects.setMode(c, b.options.mode || 'effect'),
          f = b.options.direction || 'up',
          g = b.options.distance || 20,
          h = b.options.times || 5,
          i = b.duration || 250;
        /show|hide/.test(e) && d.push('opacity'), a.effects.save(c, d), c.show(), a.effects.createWrapper(c);
        var j = f == 'up' || f == 'down' ? 'top' : 'left',
          k = f == 'up' || f == 'left' ? 'pos' : 'neg',
          g = b.options.distance || (j == 'top' ? c.outerHeight(!0) / 3 : c.outerWidth(!0) / 3);
        e == 'show' && c.css('opacity', 0).css(j, k == 'pos' ? -g : g),
          e == 'hide' && (g = g / (h * 2)),
          e != 'hide' && h--;
        if (e == 'show') {
          var l = { opacity: 1 };
          (l[j] = (k == 'pos' ? '+=' : '-=') + g), c.animate(l, i / 2, b.options.easing), (g = g / 2), h--;
        }
        for (var m = 0; m < h; m++) {
          var n = {},
            p = {};
          (n[j] = (k == 'pos' ? '-=' : '+=') + g),
            (p[j] = (k == 'pos' ? '+=' : '-=') + g),
            c.animate(n, i / 2, b.options.easing).animate(p, i / 2, b.options.easing),
            (g = e == 'hide' ? g * 2 : g / 2);
        }
        if (e == 'hide') {
          var l = { opacity: 0 };
          (l[j] = (k == 'pos' ? '-=' : '+=') + g),
            c.animate(l, i / 2, b.options.easing, function () {
              c.hide(),
                a.effects.restore(c, d),
                a.effects.removeWrapper(c),
                b.callback && b.callback.apply(this, arguments);
            });
        } else {
          var n = {},
            p = {};
          (n[j] = (k == 'pos' ? '-=' : '+=') + g),
            (p[j] = (k == 'pos' ? '+=' : '-=') + g),
            c.animate(n, i / 2, b.options.easing).animate(p, i / 2, b.options.easing, function () {
              a.effects.restore(c, d), a.effects.removeWrapper(c), b.callback && b.callback.apply(this, arguments);
            });
        }
        c.queue('fx', function () {
          c.dequeue();
        }),
          c.dequeue();
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.clip.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.clip = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right', 'height', 'width'],
          e = a.effects.setMode(c, b.options.mode || 'hide'),
          f = b.options.direction || 'vertical';
        a.effects.save(c, d), c.show();
        var g = a.effects.createWrapper(c).css({ overflow: 'hidden' }),
          h = c[0].tagName == 'IMG' ? g : c,
          i = { size: f == 'vertical' ? 'height' : 'width', position: f == 'vertical' ? 'top' : 'left' },
          j = f == 'vertical' ? h.height() : h.width();
        e == 'show' && (h.css(i.size, 0), h.css(i.position, j / 2));
        var k = {};
        (k[i.size] = e == 'show' ? j : 0),
          (k[i.position] = e == 'show' ? 0 : j / 2),
          h.animate(k, {
            queue: !1,
            duration: b.duration,
            easing: b.options.easing,
            complete: function () {
              e == 'hide' && c.hide(),
                a.effects.restore(c, d),
                a.effects.removeWrapper(c),
                b.callback && b.callback.apply(c[0], arguments),
                c.dequeue();
            },
          });
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.drop.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.drop = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right', 'opacity'],
          e = a.effects.setMode(c, b.options.mode || 'hide'),
          f = b.options.direction || 'left';
        a.effects.save(c, d), c.show(), a.effects.createWrapper(c);
        var g = f == 'up' || f == 'down' ? 'top' : 'left',
          h = f == 'up' || f == 'left' ? 'pos' : 'neg',
          i = b.options.distance || (g == 'top' ? c.outerHeight(!0) / 2 : c.outerWidth(!0) / 2);
        e == 'show' && c.css('opacity', 0).css(g, h == 'pos' ? -i : i);
        var j = { opacity: e == 'show' ? 1 : 0 };
        (j[g] = (e == 'show' ? (h == 'pos' ? '+=' : '-=') : h == 'pos' ? '-=' : '+=') + i),
          c.animate(j, {
            queue: !1,
            duration: b.duration,
            easing: b.options.easing,
            complete: function () {
              e == 'hide' && c.hide(),
                a.effects.restore(c, d),
                a.effects.removeWrapper(c),
                b.callback && b.callback.apply(this, arguments),
                c.dequeue();
            },
          });
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.explode.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.explode = function (b) {
      return this.queue(function () {
        var c = b.options.pieces ? Math.round(Math.sqrt(b.options.pieces)) : 3,
          d = b.options.pieces ? Math.round(Math.sqrt(b.options.pieces)) : 3;
        b.options.mode = b.options.mode == 'toggle' ? (a(this).is(':visible') ? 'hide' : 'show') : b.options.mode;
        var e = a(this).show().css('visibility', 'hidden'),
          f = e.offset();
        (f.top -= parseInt(e.css('marginTop'), 10) || 0), (f.left -= parseInt(e.css('marginLeft'), 10) || 0);
        var g = e.outerWidth(!0),
          h = e.outerHeight(!0);
        for (var i = 0; i < c; i++)
          for (var j = 0; j < d; j++)
            e.clone()
              .appendTo('body')
              .wrap('<div></div>')
              .css({ position: 'absolute', visibility: 'visible', left: -j * (g / d), top: -i * (h / c) })
              .parent()
              .addClass('ui-effects-explode')
              .css({
                position: 'absolute',
                overflow: 'hidden',
                width: g / d,
                height: h / c,
                left: f.left + j * (g / d) + (b.options.mode == 'show' ? (j - Math.floor(d / 2)) * (g / d) : 0),
                top: f.top + i * (h / c) + (b.options.mode == 'show' ? (i - Math.floor(c / 2)) * (h / c) : 0),
                opacity: b.options.mode == 'show' ? 0 : 1,
              })
              .animate(
                {
                  left: f.left + j * (g / d) + (b.options.mode == 'show' ? 0 : (j - Math.floor(d / 2)) * (g / d)),
                  top: f.top + i * (h / c) + (b.options.mode == 'show' ? 0 : (i - Math.floor(c / 2)) * (h / c)),
                  opacity: b.options.mode == 'show' ? 1 : 0,
                },
                b.duration || 500,
              );
        setTimeout(function () {
          b.options.mode == 'show' ? e.css({ visibility: 'visible' }) : e.css({ visibility: 'visible' }).hide(),
            b.callback && b.callback.apply(e[0]),
            e.dequeue(),
            a('div.ui-effects-explode').remove();
        }, b.duration || 500);
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.fade.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.fade = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = a.effects.setMode(c, b.options.mode || 'hide');
        c.animate(
          { opacity: d },
          {
            queue: !1,
            duration: b.duration,
            easing: b.options.easing,
            complete: function () {
              b.callback && b.callback.apply(this, arguments), c.dequeue();
            },
          },
        );
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.fold.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.fold = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right'],
          e = a.effects.setMode(c, b.options.mode || 'hide'),
          f = b.options.size || 15,
          g = !!b.options.horizFirst,
          h = b.duration ? b.duration / 2 : a.fx.speeds._default / 2;
        a.effects.save(c, d), c.show();
        var i = a.effects.createWrapper(c).css({ overflow: 'hidden' }),
          j = (e == 'show') != g,
          k = j ? ['width', 'height'] : ['height', 'width'],
          l = j ? [i.width(), i.height()] : [i.height(), i.width()],
          m = /([0-9]+)%/.exec(f);
        m && (f = (parseInt(m[1], 10) / 100) * l[e == 'hide' ? 0 : 1]),
          e == 'show' && i.css(g ? { height: 0, width: f } : { height: f, width: 0 });
        var n = {},
          p = {};
        (n[k[0]] = e == 'show' ? l[0] : f),
          (p[k[1]] = e == 'show' ? l[1] : 0),
          i.animate(n, h, b.options.easing).animate(p, h, b.options.easing, function () {
            e == 'hide' && c.hide(),
              a.effects.restore(c, d),
              a.effects.removeWrapper(c),
              b.callback && b.callback.apply(c[0], arguments),
              c.dequeue();
          });
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.highlight.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.highlight = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['backgroundImage', 'backgroundColor', 'opacity'],
          e = a.effects.setMode(c, b.options.mode || 'show'),
          f = { backgroundColor: c.css('backgroundColor') };
        e == 'hide' && (f.opacity = 0),
          a.effects.save(c, d),
          c
            .show()
            .css({ backgroundImage: 'none', backgroundColor: b.options.color || '#ffff99' })
            .animate(f, {
              queue: !1,
              duration: b.duration,
              easing: b.options.easing,
              complete: function () {
                e == 'hide' && c.hide(),
                  a.effects.restore(c, d),
                  e == 'show' && !a.support.opacity && this.style.removeAttribute('filter'),
                  b.callback && b.callback.apply(this, arguments),
                  c.dequeue();
              },
            });
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.pulsate.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.pulsate = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = a.effects.setMode(c, b.options.mode || 'show'),
          e = (b.options.times || 5) * 2 - 1,
          f = b.duration ? b.duration / 2 : a.fx.speeds._default / 2,
          g = c.is(':visible'),
          h = 0;
        g || (c.css('opacity', 0).show(), (h = 1)), ((d == 'hide' && g) || (d == 'show' && !g)) && e--;
        for (var i = 0; i < e; i++) c.animate({ opacity: h }, f, b.options.easing), (h = (h + 1) % 2);
        c.animate({ opacity: h }, f, b.options.easing, function () {
          h == 0 && c.hide(), b.callback && b.callback.apply(this, arguments);
        }),
          c
            .queue('fx', function () {
              c.dequeue();
            })
            .dequeue();
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.scale.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    (a.effects.puff = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = a.effects.setMode(c, b.options.mode || 'hide'),
          e = parseInt(b.options.percent, 10) || 150,
          f = e / 100,
          g = { height: c.height(), width: c.width() };
        a.extend(b.options, {
          fade: !0,
          mode: d,
          percent: d == 'hide' ? e : 100,
          from: d == 'hide' ? g : { height: g.height * f, width: g.width * f },
        }),
          c.effect('scale', b.options, b.duration, b.callback),
          c.dequeue();
      });
    }),
      (a.effects.scale = function (b) {
        return this.queue(function () {
          var c = a(this),
            d = a.extend(!0, {}, b.options),
            e = a.effects.setMode(c, b.options.mode || 'effect'),
            f = parseInt(b.options.percent, 10) || (parseInt(b.options.percent, 10) == 0 ? 0 : e == 'hide' ? 0 : 100),
            g = b.options.direction || 'both',
            h = b.options.origin;
          e != 'effect' && ((d.origin = h || ['middle', 'center']), (d.restore = !0));
          var i = { height: c.height(), width: c.width() };
          c.from = b.options.from || (e == 'show' ? { height: 0, width: 0 } : i);
          var j = { y: g != 'horizontal' ? f / 100 : 1, x: g != 'vertical' ? f / 100 : 1 };
          (c.to = { height: i.height * j.y, width: i.width * j.x }),
            b.options.fade &&
              (e == 'show' && ((c.from.opacity = 0), (c.to.opacity = 1)),
              e == 'hide' && ((c.from.opacity = 1), (c.to.opacity = 0))),
            (d.from = c.from),
            (d.to = c.to),
            (d.mode = e),
            c.effect('size', d, b.duration, b.callback),
            c.dequeue();
        });
      }),
      (a.effects.size = function (b) {
        return this.queue(function () {
          var c = a(this),
            d = ['position', 'top', 'bottom', 'left', 'right', 'width', 'height', 'overflow', 'opacity'],
            e = ['position', 'top', 'bottom', 'left', 'right', 'overflow', 'opacity'],
            f = ['width', 'height', 'overflow'],
            g = ['fontSize'],
            h = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'],
            i = ['borderLeftWidth', 'borderRightWidth', 'paddingLeft', 'paddingRight'],
            j = a.effects.setMode(c, b.options.mode || 'effect'),
            k = b.options.restore || !1,
            l = b.options.scale || 'both',
            m = b.options.origin,
            n = { height: c.height(), width: c.width() };
          (c.from = b.options.from || n), (c.to = b.options.to || n);
          if (m) {
            var p = a.effects.getBaseline(m, n);
            (c.from.top = (n.height - c.from.height) * p.y),
              (c.from.left = (n.width - c.from.width) * p.x),
              (c.to.top = (n.height - c.to.height) * p.y),
              (c.to.left = (n.width - c.to.width) * p.x);
          }
          var q = {
            from: { y: c.from.height / n.height, x: c.from.width / n.width },
            to: { y: c.to.height / n.height, x: c.to.width / n.width },
          };
          if (l == 'box' || l == 'both')
            q.from.y != q.to.y &&
              ((d = d.concat(h)),
              (c.from = a.effects.setTransition(c, h, q.from.y, c.from)),
              (c.to = a.effects.setTransition(c, h, q.to.y, c.to))),
              q.from.x != q.to.x &&
                ((d = d.concat(i)),
                (c.from = a.effects.setTransition(c, i, q.from.x, c.from)),
                (c.to = a.effects.setTransition(c, i, q.to.x, c.to)));
          (l == 'content' || l == 'both') &&
            q.from.y != q.to.y &&
            ((d = d.concat(g)),
            (c.from = a.effects.setTransition(c, g, q.from.y, c.from)),
            (c.to = a.effects.setTransition(c, g, q.to.y, c.to))),
            a.effects.save(c, k ? d : e),
            c.show(),
            a.effects.createWrapper(c),
            c.css('overflow', 'hidden').css(c.from);
          if (l == 'content' || l == 'both')
            (h = h.concat(['marginTop', 'marginBottom']).concat(g)),
              (i = i.concat(['marginLeft', 'marginRight'])),
              (f = d.concat(h).concat(i)),
              c.find('*[width]').each(function () {
                var c = a(this);
                k && a.effects.save(c, f);
                var d = { height: c.height(), width: c.width() };
                (c.from = { height: d.height * q.from.y, width: d.width * q.from.x }),
                  (c.to = { height: d.height * q.to.y, width: d.width * q.to.x }),
                  q.from.y != q.to.y &&
                    ((c.from = a.effects.setTransition(c, h, q.from.y, c.from)),
                    (c.to = a.effects.setTransition(c, h, q.to.y, c.to))),
                  q.from.x != q.to.x &&
                    ((c.from = a.effects.setTransition(c, i, q.from.x, c.from)),
                    (c.to = a.effects.setTransition(c, i, q.to.x, c.to))),
                  c.css(c.from),
                  c.animate(c.to, b.duration, b.options.easing, function () {
                    k && a.effects.restore(c, f);
                  });
              });
          c.animate(c.to, {
            queue: !1,
            duration: b.duration,
            easing: b.options.easing,
            complete: function () {
              c.to.opacity === 0 && c.css('opacity', c.from.opacity),
                j == 'hide' && c.hide(),
                a.effects.restore(c, k ? d : e),
                a.effects.removeWrapper(c),
                b.callback && b.callback.apply(this, arguments),
                c.dequeue();
            },
          });
        });
      });
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.shake.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.shake = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right'],
          e = a.effects.setMode(c, b.options.mode || 'effect'),
          f = b.options.direction || 'left',
          g = b.options.distance || 20,
          h = b.options.times || 3,
          i = b.duration || b.options.duration || 140;
        a.effects.save(c, d), c.show(), a.effects.createWrapper(c);
        var j = f == 'up' || f == 'down' ? 'top' : 'left',
          k = f == 'up' || f == 'left' ? 'pos' : 'neg',
          l = {},
          m = {},
          n = {};
        (l[j] = (k == 'pos' ? '-=' : '+=') + g),
          (m[j] = (k == 'pos' ? '+=' : '-=') + g * 2),
          (n[j] = (k == 'pos' ? '-=' : '+=') + g * 2),
          c.animate(l, i, b.options.easing);
        for (var p = 1; p < h; p++) c.animate(m, i, b.options.easing).animate(n, i, b.options.easing);
        c.animate(m, i, b.options.easing).animate(l, i / 2, b.options.easing, function () {
          a.effects.restore(c, d), a.effects.removeWrapper(c), b.callback && b.callback.apply(this, arguments);
        }),
          c.queue('fx', function () {
            c.dequeue();
          }),
          c.dequeue();
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.slide.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.slide = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = ['position', 'top', 'bottom', 'left', 'right'],
          e = a.effects.setMode(c, b.options.mode || 'show'),
          f = b.options.direction || 'left';
        a.effects.save(c, d), c.show(), a.effects.createWrapper(c).css({ overflow: 'hidden' });
        var g = f == 'up' || f == 'down' ? 'top' : 'left',
          h = f == 'up' || f == 'left' ? 'pos' : 'neg',
          i = b.options.distance || (g == 'top' ? c.outerHeight(!0) : c.outerWidth(!0));
        e == 'show' && c.css(g, h == 'pos' ? (isNaN(i) ? '-' + i : -i) : i);
        var j = {};
        (j[g] = (e == 'show' ? (h == 'pos' ? '+=' : '-=') : h == 'pos' ? '-=' : '+=') + i),
          c.animate(j, {
            queue: !1,
            duration: b.duration,
            easing: b.options.easing,
            complete: function () {
              e == 'hide' && c.hide(),
                a.effects.restore(c, d),
                a.effects.removeWrapper(c),
                b.callback && b.callback.apply(this, arguments),
                c.dequeue();
            },
          });
      });
    };
  })(jQuery);
  /*! jQuery UI - v1.8.24 - 2012-09-28
   * https://github.com/jquery/jquery-ui
   * Includes: jquery.effects.transfer.js
   * Copyright (c) 2012 AUTHORS.txt; Licensed MIT, GPL */
  (function (a, b) {
    a.effects.transfer = function (b) {
      return this.queue(function () {
        var c = a(this),
          d = a(b.options.to),
          e = d.offset(),
          f = { top: e.top, left: e.left, height: d.innerHeight(), width: d.innerWidth() },
          g = c.offset(),
          h = a('<div class="ui-effects-transfer"></div>')
            .appendTo(document.body)
            .addClass(b.options.className)
            .css({ top: g.top, left: g.left, height: c.innerHeight(), width: c.innerWidth(), position: 'absolute' })
            .animate(f, b.duration, b.options.easing, function () {
              h.remove(), b.callback && b.callback.apply(c[0], arguments), c.dequeue();
            });
      });
    };
  })(jQuery);
  /*!
   * jquery.event.drag - v 2.2
   * Copyright (c) 2010 Three Dub Media - http://threedubmedia.com
   * Open Source MIT License - http://threedubmedia.com/code/license
   */
  // Created: 2008-06-04
  // Updated: 2012-05-21
  // REQUIRES: jquery 1.7.x

  (function ($) {
    // add the jquery instance method
    $.fn.drag = function (str, arg, opts) {
      // figure out the event type
      var type = typeof str == 'string' ? str : '',
        // figure out the event handler...
        fn = $.isFunction(str) ? str : $.isFunction(arg) ? arg : null;
      // fix the event type
      if (type.indexOf('drag') !== 0) type = 'drag' + type;
      // were options passed
      opts = (str == fn ? arg : opts) || {};
      // trigger or bind event handler
      return fn ? this.bind(type, opts, fn) : this.trigger(type);
    };

    // local refs (increase compression)
    var $event = $.event,
      $special = $event.special,
      // configure the drag special event
      drag = ($special.drag = {
        // these are the default settings
        defaults: {
          which: 1, // mouse button pressed to start drag sequence
          distance: 0, // distance dragged before dragstart
          not: ':input', // selector to suppress dragging on target elements
          handle: null, // selector to match handle target elements
          relative: false, // true to use "position", false to use "offset"
          drop: true, // false to suppress drop events, true or selector to allow
          click: false, // false to suppress click events after dragend (no proxy)
        },

        // the key name for stored drag data
        datakey: 'dragdata',

        // prevent bubbling for better performance
        noBubble: true,

        // count bound related events
        add: function (obj) {
          // read the interaction data
          var data = $.data(this, drag.datakey),
            // read any passed options
            opts = obj.data || {};
          // count another realted event
          data.related += 1;
          // extend data options bound with this event
          // don't iterate "opts" in case it is a node
          $.each(drag.defaults, function (key, def) {
            if (opts[key] !== undefined) data[key] = opts[key];
          });
        },

        // forget unbound related events
        remove: function () {
          $.data(this, drag.datakey).related -= 1;
        },

        // configure interaction, capture settings
        setup: function () {
          // check for related events
          if ($.data(this, drag.datakey)) return;
          // initialize the drag data with copied defaults
          var data = $.extend({ related: 0 }, drag.defaults);
          // store the interaction data
          $.data(this, drag.datakey, data);
          // bind the mousedown event, which starts drag interactions
          $event.add(this, 'touchstart mousedown', drag.init, data);
          // prevent image dragging in IE...
          if (this.attachEvent) this.attachEvent('ondragstart', drag.dontstart);
        },

        // destroy configured interaction
        teardown: function () {
          var data = $.data(this, drag.datakey) || {};
          // check for related events
          if (data.related) return;
          // remove the stored data
          $.removeData(this, drag.datakey);
          // remove the mousedown event
          $event.remove(this, 'touchstart mousedown', drag.init);
          // enable text selection
          drag.textselect(true);
          // un-prevent image dragging in IE...
          if (this.detachEvent) this.detachEvent('ondragstart', drag.dontstart);
        },

        // initialize the interaction
        init: function (event) {
          // sorry, only one touch at a time
          if (drag.touched) return;
          // the drag/drop interaction data
          var dd = event.data,
            results;
          // check the which directive
          if (event.which != 0 && dd.which > 0 && event.which != dd.which) return;
          // check for suppressed selector
          if ($(event.target).is(dd.not)) return;
          // check for handle selector
          if (dd.handle && !$(event.target).closest(dd.handle, event.currentTarget).length) return;

          drag.touched = event.type == 'touchstart' ? this : null;
          dd.propagates = 1;
          dd.mousedown = this;
          dd.interactions = [drag.interaction(this, dd)];
          dd.target = event.target;
          dd.pageX = event.pageX;
          dd.pageY = event.pageY;
          dd.dragging = null;
          // handle draginit event...
          results = drag.hijack(event, 'draginit', dd);
          // early cancel
          if (!dd.propagates) return;
          // flatten the result set
          results = drag.flatten(results);
          // insert new interaction elements
          if (results && results.length) {
            dd.interactions = [];
            $.each(results, function () {
              dd.interactions.push(drag.interaction(this, dd));
            });
          }
          // remember how many interactions are propagating
          dd.propagates = dd.interactions.length;
          // locate and init the drop targets
          if (dd.drop !== false && $special.drop) $special.drop.handler(event, dd);
          // disable text selection
          drag.textselect(false);
          // bind additional events...
          if (drag.touched) $event.add(drag.touched, 'touchmove touchend', drag.handler, dd);
          else $event.add(document, 'mousemove mouseup', drag.handler, dd);
          // helps prevent text selection or scrolling
          if (!drag.touched || dd.live) return false;
        },

        // returns an interaction object
        interaction: function (elem, dd) {
          var offset = $(elem)[dd.relative ? 'position' : 'offset']() || { top: 0, left: 0 };
          return {
            drag: elem,
            callback: new drag.callback(),
            droppable: [],
            offset: offset,
          };
        },

        // handle drag-releatd DOM events
        handler: function (event) {
          // read the data before hijacking anything
          var dd = event.data;
          // handle various events
          switch (event.type) {
            // mousemove, check distance, start dragging
            case !dd.dragging && 'touchmove':
              event.preventDefault();
            case !dd.dragging && 'mousemove':
              //  drag tolerance, x≤ + y≤ = distance≤
              if (Math.pow(event.pageX - dd.pageX, 2) + Math.pow(event.pageY - dd.pageY, 2) < Math.pow(dd.distance, 2))
                break; // distance tolerance not reached
              event.target = dd.target; // force target from "mousedown" event (fix distance issue)
              drag.hijack(event, 'dragstart', dd); // trigger "dragstart"
              if (dd.propagates)
                // "dragstart" not rejected
                dd.dragging = true; // activate interaction
            // mousemove, dragging
            case 'touchmove':
              event.preventDefault();
            case 'mousemove':
              if (dd.dragging) {
                // trigger "drag"
                drag.hijack(event, 'drag', dd);
                if (dd.propagates) {
                  // manage drop events
                  if (dd.drop !== false && $special.drop) $special.drop.handler(event, dd); // "dropstart", "dropend"
                  break; // "drag" not rejected, stop
                }
                event.type = 'mouseup'; // helps "drop" handler behave
              }
            // mouseup, stop dragging
            case 'touchend':
            case 'mouseup':
            default: // remove page events
              // enable text selection
              // deactivate element
              if (drag.touched) $event.remove(drag.touched, 'touchmove touchend', drag.handler); // remove touch events
              else $event.remove(document, 'mousemove mouseup', drag.handler);
              if (dd.dragging) {
                if (dd.drop !== false && $special.drop) $special.drop.handler(event, dd); // "drop"
                drag.hijack(event, 'dragend', dd); // trigger "dragend"
              }
              drag.textselect(true);
              // if suppressing click events...
              if (dd.click === false && dd.dragging) $.data(dd.mousedown, 'suppress.click', new Date().getTime() + 5);
              dd.dragging = drag.touched = false;
              break;
          }
        },

        // re-use event object for custom events
        hijack: function (event, type, dd, x, elem) {
          // not configured
          if (!dd) return;
          // remember the original event and type
          var orig = { event: event.originalEvent, type: event.type },
            // is the event drag related or drog related?
            mode = type.indexOf('drop') ? 'drag' : 'drop',
            // iteration vars
            result,
            i = x || 0,
            ia,
            $elems,
            callback,
            len = !isNaN(x) ? x : dd.interactions.length;
          // modify the event type
          event.type = type;
          // remove the original event
          event.originalEvent = null;
          // initialize the results
          dd.results = [];
          // handle each interacted element
          do
            if ((ia = dd.interactions[i])) {
              // validate the interaction
              if (type !== 'dragend' && ia.cancelled) continue;
              // set the dragdrop properties on the event object
              callback = drag.properties(event, dd, ia);
              // prepare for more results
              ia.results = [];
              // handle each element
              $(elem || ia[mode] || dd.droppable).each(function (p, subject) {
                // identify drag or drop targets individually
                callback.target = subject;
                // force propagtion of the custom event
                event.isPropagationStopped = function () {
                  return false;
                };
                // handle the event
                result = subject ? $event.dispatch.call(subject, event, callback) : null;
                // stop the drag interaction for this element
                if (result === false) {
                  if (mode == 'drag') {
                    ia.cancelled = true;
                    dd.propagates -= 1;
                  }
                  if (type == 'drop') {
                    ia[mode][p] = null;
                  }
                }
                // assign any dropinit elements
                else if (type == 'dropinit') ia.droppable.push(drag.element(result) || subject);
                // accept a returned proxy element
                if (type == 'dragstart') ia.proxy = $(drag.element(result) || ia.drag)[0];
                // remember this result
                ia.results.push(result);
                // forget the event result, for recycling
                delete event.result;
                // break on cancelled handler
                if (type !== 'dropinit') return result;
              });
              // flatten the results
              dd.results[i] = drag.flatten(ia.results);
              // accept a set of valid drop targets
              if (type == 'dropinit') ia.droppable = drag.flatten(ia.droppable);
              // locate drop targets
              if (type == 'dragstart' && !ia.cancelled) callback.update();
            }
          while (++i < len);
          // restore the original event & type
          event.type = orig.type;
          event.originalEvent = orig.event;
          // return all handler results
          return drag.flatten(dd.results);
        },

        // extend the callback object with drag/drop properties...
        properties: function (event, dd, ia) {
          var obj = ia.callback;
          // elements
          obj.drag = ia.drag;
          obj.proxy = ia.proxy || ia.drag;
          // starting mouse position
          obj.startX = dd.pageX;
          obj.startY = dd.pageY;
          // current distance dragged
          obj.deltaX = event.pageX - dd.pageX;
          obj.deltaY = event.pageY - dd.pageY;
          // original element position
          obj.originalX = ia.offset.left;
          obj.originalY = ia.offset.top;
          // adjusted element position
          obj.offsetX = obj.originalX + obj.deltaX;
          obj.offsetY = obj.originalY + obj.deltaY;
          // assign the drop targets information
          obj.drop = drag.flatten((ia.drop || []).slice());
          obj.available = drag.flatten((ia.droppable || []).slice());
          return obj;
        },

        // determine is the argument is an element or jquery instance
        element: function (arg) {
          if (arg && (arg.jquery || arg.nodeType == 1)) return arg;
        },

        // flatten nested jquery objects and arrays into a single dimension array
        flatten: function (arr) {
          return $.map(arr, function (member) {
            return member && member.jquery
              ? $.makeArray(member)
              : member && member.length
              ? drag.flatten(member)
              : member;
          });
        },

        // toggles text selection attributes ON (true) or OFF (false)
        textselect: function (bool) {
          $(document)
            [bool ? 'unbind' : 'bind']('selectstart', drag.dontstart)
            .css('MozUserSelect', bool ? '' : 'none');
          // .attr("unselectable", bool ? "off" : "on" )
          document.unselectable = bool ? 'off' : 'on';
        },

        // suppress "selectstart" and "ondragstart" events
        dontstart: function () {
          return false;
        },

        // a callback instance contructor
        callback: function () {},
      });

    // callback methods
    drag.callback.prototype = {
      update: function () {
        if ($special.drop && this.available.length)
          $.each(this.available, function (i) {
            $special.drop.locate(this, i);
          });
      },
    };

    // patch $.event.$dispatch to allow suppressing clicks
    var $dispatch = $event.dispatch;
    $event.dispatch = function (event) {
      if ($.data(this, 'suppress.' + event.type) - new Date().getTime() > 0) {
        $.removeData(this, 'suppress.' + event.type);
        return;
      }
      return $dispatch.apply(this, arguments);
    };

    // event fix hooks for touch events...
    var touchHooks =
      ($event.fixHooks.touchstart =
      $event.fixHooks.touchmove =
      $event.fixHooks.touchend =
      $event.fixHooks.touchcancel =
        {
          props: 'clientX clientY pageX pageY screenX screenY'.split(' '),
          filter: function (event, orig) {
            if (orig) {
              var touched =
                (orig.touches && orig.touches[0]) || (orig.changedTouches && orig.changedTouches[0]) || null;
              // iOS webkit: touchstart, touchmove, touchend
              if (touched)
                $.each(touchHooks.props, function (i, prop) {
                  event[prop] = touched[prop];
                });
            }
            return event;
          },
        });

    // share the same special event configuration with related events...
    $special.draginit = $special.dragstart = $special.dragend = drag;
  })(jQuery);

  /*!
   * jquery.event.drop - v 2.2
   * Copyright (c) 2010 Three Dub Media - http://threedubmedia.com
   * Open Source MIT License - http://threedubmedia.com/code/license
   */
  // Created: 2008-06-04
  // Updated: 2012-05-21
  // REQUIRES: jquery 1.7.x, event.drag 2.2

  (function ($) {
    // secure $ jQuery alias

    // Events: drop, dropstart, dropend

    // add the jquery instance method
    $.fn.drop = function (str, arg, opts) {
      // figure out the event type
      var type = typeof str == 'string' ? str : '',
        // figure out the event handler...
        fn = $.isFunction(str) ? str : $.isFunction(arg) ? arg : null;
      // fix the event type
      if (type.indexOf('drop') !== 0) type = 'drop' + type;
      // were options passed
      opts = (str == fn ? arg : opts) || {};
      // trigger or bind event handler
      return fn ? this.bind(type, opts, fn) : this.trigger(type);
    };

    // DROP MANAGEMENT UTILITY
    // returns filtered drop target elements, caches their positions
    $.drop = function (opts) {
      opts = opts || {};
      // safely set new options...
      drop.multi =
        opts.multi === true ? Infinity : opts.multi === false ? 1 : !isNaN(opts.multi) ? opts.multi : drop.multi;
      drop.delay = opts.delay || drop.delay;
      drop.tolerance = $.isFunction(opts.tolerance) ? opts.tolerance : opts.tolerance === null ? null : drop.tolerance;
      drop.mode = opts.mode || drop.mode || 'intersect';
    };

    // local refs (increase compression)
    var $event = $.event,
      $special = $event.special,
      // configure the drop special event
      drop = ($.event.special.drop = {
        // these are the default settings
        multi: 1, // allow multiple drop winners per dragged element
        delay: 20, // async timeout delay
        mode: 'overlap', // drop tolerance mode

        // internal cache
        targets: [],

        // the key name for stored drop data
        datakey: 'dropdata',

        // prevent bubbling for better performance
        noBubble: true,

        // count bound related events
        add: function (obj) {
          // read the interaction data
          var data = $.data(this, drop.datakey);
          // count another realted event
          data.related += 1;
        },

        // forget unbound related events
        remove: function () {
          $.data(this, drop.datakey).related -= 1;
        },

        // configure the interactions
        setup: function () {
          // check for related events
          if ($.data(this, drop.datakey)) return;
          // initialize the drop element data
          var data = {
            related: 0,
            active: [],
            anyactive: 0,
            winner: 0,
            location: {},
          };
          // store the drop data on the element
          $.data(this, drop.datakey, data);
          // store the drop target in internal cache
          drop.targets.push(this);
        },

        // destroy the configure interaction
        teardown: function () {
          var data = $.data(this, drop.datakey) || {};
          // check for related events
          if (data.related) return;
          // remove the stored data
          $.removeData(this, drop.datakey);
          // reference the targeted element
          var element = this;
          // remove from the internal cache
          drop.targets = $.grep(drop.targets, function (target) {
            return target !== element;
          });
        },

        // shared event handler
        handler: function (event, dd) {
          // local vars
          var results, $targets;
          // make sure the right data is available
          if (!dd) return;
          // handle various events
          switch (event.type) {
            // draginit, from $.event.special.drag
            case 'mousedown': // DROPINIT >>
            case 'touchstart': // DROPINIT >>
              // collect and assign the drop targets
              $targets = $(drop.targets);
              if (typeof dd.drop == 'string') $targets = $targets.filter(dd.drop);
              // reset drop data winner properties
              $targets.each(function () {
                var data = $.data(this, drop.datakey);
                data.active = [];
                data.anyactive = 0;
                data.winner = 0;
              });
              // set available target elements
              dd.droppable = $targets;
              // activate drop targets for the initial element being dragged
              $special.drag.hijack(event, 'dropinit', dd);
              break;
            // drag, from $.event.special.drag
            case 'mousemove': // TOLERATE >>
            case 'touchmove': // TOLERATE >>
              drop.event = event; // store the mousemove event
              if (!drop.timer)
                // monitor drop targets
                drop.tolerate(dd);
              break;
            // dragend, from $.event.special.drag
            case 'mouseup': // DROP >> DROPEND >>
            case 'touchend': // DROP >> DROPEND >>
              drop.timer = clearTimeout(drop.timer); // delete timer
              if (dd.propagates) {
                $special.drag.hijack(event, 'drop', dd);
                $special.drag.hijack(event, 'dropend', dd);
              }
              break;
          }
        },

        // returns the location positions of an element
        locate: function (elem, index) {
          var data = $.data(elem, drop.datakey),
            $elem = $(elem),
            posi = $elem.offset() || {},
            height = $elem.outerHeight(),
            width = $elem.outerWidth(),
            location = {
              elem: elem,
              width: width,
              height: height,
              top: posi.top,
              left: posi.left,
              right: posi.left + width,
              bottom: posi.top + height,
            };
          // drag elements might not have dropdata
          if (data) {
            data.location = location;
            data.index = index;
            data.elem = elem;
          }
          return location;
        },

        // test the location positions of an element against another OR an X,Y coord
        contains: function (target, test) {
          // target { location } contains test [x,y] or { location }
          return (
            (test[0] || test.left) >= target.left &&
            (test[0] || test.right) <= target.right &&
            (test[1] || test.top) >= target.top &&
            (test[1] || test.bottom) <= target.bottom
          );
        },

        // stored tolerance modes
        modes: {
          // fn scope: "$.event.special.drop" object
          // target with mouse wins, else target with most overlap wins
          intersect: function (event, proxy, target) {
            return this.contains(target, [event.pageX, event.pageY]) // check cursor
              ? 1e9
              : this.modes.overlap.apply(this, arguments); // check overlap
          },
          // target with most overlap wins
          overlap: function (event, proxy, target) {
            // calculate the area of overlap...
            return (
              Math.max(0, Math.min(target.bottom, proxy.bottom) - Math.max(target.top, proxy.top)) *
              Math.max(0, Math.min(target.right, proxy.right) - Math.max(target.left, proxy.left))
            );
          },
          // proxy is completely contained within target bounds
          fit: function (event, proxy, target) {
            return this.contains(target, proxy) ? 1 : 0;
          },
          // center of the proxy is contained within target bounds
          middle: function (event, proxy, target) {
            return this.contains(target, [proxy.left + proxy.width * 0.5, proxy.top + proxy.height * 0.5]) ? 1 : 0;
          },
        },

        // sort drop target cache by by winner (dsc), then index (asc)
        sort: function (a, b) {
          return b.winner - a.winner || a.index - b.index;
        },

        // async, recursive tolerance execution
        tolerate: function (dd) {
          // declare local refs
          var i,
            drp,
            drg,
            data,
            arr,
            len,
            elem,
            // interaction iteration variables
            x = 0,
            ia,
            end = dd.interactions.length,
            // determine the mouse coords
            xy = [drop.event.pageX, drop.event.pageY],
            // custom or stored tolerance fn
            tolerance = drop.tolerance || drop.modes[drop.mode];
          // go through each passed interaction...
          do
            if ((ia = dd.interactions[x])) {
              // check valid interaction
              if (!ia) return;
              // initialize or clear the drop data
              ia.drop = [];
              // holds the drop elements
              arr = [];
              len = ia.droppable.length;
              // determine the proxy location, if needed
              if (tolerance) drg = drop.locate(ia.proxy);
              // reset the loop
              i = 0;
              // loop each stored drop target
              do
                if ((elem = ia.droppable[i])) {
                  data = $.data(elem, drop.datakey);
                  drp = data.location;
                  if (!drp) continue;
                  // find a winner: tolerance function is defined, call it
                  data.winner = tolerance
                    ? tolerance.call(drop, drop.event, drg, drp)
                    : // mouse position is always the fallback
                    drop.contains(drp, xy)
                    ? 1
                    : 0;
                  arr.push(data);
                }
              while (++i < len); // loop
              // sort the drop targets
              arr.sort(drop.sort);
              // reset the loop
              i = 0;
              // loop through all of the targets again
              do
                if ((data = arr[i])) {
                  // winners...
                  if (data.winner && ia.drop.length < drop.multi) {
                    // new winner... dropstart
                    if (!data.active[x] && !data.anyactive) {
                      // check to make sure that this is not prevented
                      if ($special.drag.hijack(drop.event, 'dropstart', dd, x, data.elem)[0] !== false) {
                        data.active[x] = 1;
                        data.anyactive += 1;
                      }
                      // if false, it is not a winner
                      else data.winner = 0;
                    }
                    // if it is still a winner
                    if (data.winner) ia.drop.push(data.elem);
                  }
                  // losers...
                  else if (data.active[x] && data.anyactive == 1) {
                    // former winner... dropend
                    $special.drag.hijack(drop.event, 'dropend', dd, x, data.elem);
                    data.active[x] = 0;
                    data.anyactive -= 1;
                  }
                }
              while (++i < len); // loop
            }
          while (++x < end); // loop
          // check if the mouse is still moving or is idle
          if (drop.last && xy[0] == drop.last.pageX && xy[1] == drop.last.pageY)
            delete drop.timer; // idle, don't recurse
          // recurse
          else
            drop.timer = setTimeout(function () {
              drop.tolerate(dd);
            }, drop.delay);
          // remember event, to compare idleness
          drop.last = drop.event;
        },
      });

    // share the same special event configuration with related events...
    $special.dropinit = $special.dropstart = $special.dropend = drop;
  })(jQuery); // confine scope
  // jquery.jsonp 2.4.0 (c)2012 Julian Aubourg | MIT License
  // https://github.com/jaubourg/jquery-jsonp
  (function (e) {
    function t() {}
    function n(e) {
      C = [e];
    }
    function r(e, t, n) {
      return e && e.apply && e.apply(t.context || t, n);
    }
    function i(e) {
      return /\?/.test(e) ? '&' : '?';
    }
    function O(c) {
      function Y(e) {
        z++ || (W(), j && (T[I] = { s: [e] }), D && (e = D.apply(c, [e])), r(O, c, [e, b, c]), r(_, c, [c, b]));
      }
      function Z(e) {
        z++ || (W(), j && e != w && (T[I] = e), r(M, c, [c, e]), r(_, c, [c, e]));
      }
      c = e.extend({}, k, c);
      var O = c.success,
        M = c.error,
        _ = c.complete,
        D = c.dataFilter,
        P = c.callbackParameter,
        H = c.callback,
        B = c.cache,
        j = c.pageCache,
        F = c.charset,
        I = c.url,
        q = c.data,
        R = c.timeout,
        U,
        z = 0,
        W = t,
        X,
        V,
        J,
        K,
        Q,
        G;
      return (
        S &&
          S(function (e) {
            e.done(O).fail(M), (O = e.resolve), (M = e.reject);
          }).promise(c),
        (c.abort = function () {
          !z++ && W();
        }),
        r(c.beforeSend, c, [c]) === !1 || z
          ? c
          : ((I = I || u),
            (q = q ? (typeof q == 'string' ? q : e.param(q, c.traditional)) : u),
            (I += q ? i(I) + q : u),
            P && (I += i(I) + encodeURIComponent(P) + '=?'),
            !B && !j && (I += i(I) + '_' + new Date().getTime() + '='),
            (I = I.replace(/=\?(&|$)/, '=' + H + '$1')),
            j && (U = T[I])
              ? U.s
                ? Y(U.s[0])
                : Z(U)
              : ((E[H] = n),
                (K = e(y)[0]),
                (K.id = l + N++),
                F && (K[o] = F),
                L && L.version() < 11.6
                  ? ((Q = e(y)[0]).text = "document.getElementById('" + K.id + "')." + p + '()')
                  : (K[s] = s),
                A && ((K.htmlFor = K.id), (K.event = h)),
                (K[d] =
                  K[p] =
                  K[v] =
                    function (e) {
                      if (!K[m] || !/i/.test(K[m])) {
                        try {
                          K[h] && K[h]();
                        } catch (t) {}
                        (e = C), (C = 0), e ? Y(e[0]) : Z(a);
                      }
                    }),
                (K.src = I),
                (W = function (e) {
                  G && clearTimeout(G), (K[v] = K[d] = K[p] = null), x[g](K), Q && x[g](Q);
                }),
                x[f](K, (J = x.firstChild)),
                Q && x[f](Q, J),
                (G =
                  R > 0 &&
                  setTimeout(function () {
                    Z(w);
                  }, R))),
            c)
      );
    }
    var s = 'async',
      o = 'charset',
      u = '',
      a = 'error',
      f = 'insertBefore',
      l = '_jqjsp',
      c = 'on',
      h = c + 'click',
      p = c + a,
      d = c + 'load',
      v = c + 'readystatechange',
      m = 'readyState',
      g = 'removeChild',
      y = '<script>',
      b = 'success',
      w = 'timeout',
      E = window,
      S = e.Deferred,
      x = e('head')[0] || document.documentElement,
      T = {},
      N = 0,
      C,
      k = { callback: l, url: location.href },
      L = E.opera,
      A = !!e('<div>').html('<!--[if IE]><i><![endif]-->').find('i').length;
    (O.setup = function (t) {
      e.extend(k, t);
    }),
      (e.jsonp = O);
  })(jQuery);
  /*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
   * Licensed under the MIT License (LICENSE.txt).
   *
   * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
   * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
   * Thanks to: Seamus Leahy for adding deltaX and deltaY
   *
   * Version: 3.0.6
   *
   * Requires: 1.2.2+
   */

  (function ($) {
    var types = ['DOMMouseScroll', 'mousewheel'];

    if ($.event.fixHooks) {
      for (var i = types.length; i; ) {
        $.event.fixHooks[types[--i]] = $.event.mouseHooks;
      }
    }

    $.event.special.mousewheel = {
      setup: function () {
        if (this.addEventListener) {
          for (var i = types.length; i; ) {
            this.addEventListener(types[--i], handler, false);
          }
        } else {
          this.onmousewheel = handler;
        }
      },

      teardown: function () {
        if (this.removeEventListener) {
          for (var i = types.length; i; ) {
            this.removeEventListener(types[--i], handler, false);
          }
        } else {
          this.onmousewheel = null;
        }
      },
    };

    $.fn.extend({
      mousewheel: function (fn) {
        return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
      },

      unmousewheel: function (fn) {
        return this.unbind('mousewheel', fn);
      },
    });

    function handler(event) {
      var orgEvent = event || window.event,
        args = [].slice.call(arguments, 1),
        delta = 0,
        returnValue = true,
        deltaX = 0,
        deltaY = 0;
      event = $.event.fix(orgEvent);
      event.type = 'mousewheel';

      // Old school scrollwheel delta
      if (orgEvent.wheelDelta) {
        delta = orgEvent.wheelDelta / 120;
      }
      if (orgEvent.detail) {
        delta = -orgEvent.detail / 3;
      }

      // New school multidimensional scroll (touchpads) deltas
      deltaY = delta;

      // Gecko
      if (orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = -1 * delta;
      }

      // Webkit
      if (orgEvent.wheelDeltaY !== undefined) {
        deltaY = orgEvent.wheelDeltaY / 120;
      }
      if (orgEvent.wheelDeltaX !== undefined) {
        deltaX = (-1 * orgEvent.wheelDeltaX) / 120;
      }

      // Add event and delta to the front of the arguments
      args.unshift(event, delta, deltaX, deltaY);

      return ($.event.dispatch || $.event.handle).apply(this, args);
    }
  })(jQuery);

  /*
   * jquery.simulate - simulate browser mouse and keyboard events
   *
   * Copyright (c) 2010 AUTHORS.txt (http://jqueryui.com/about)
   * Dual licensed under the MIT (MIT-LICENSE.txt)
   * and GPL (GPL-LICENSE.txt) licenses.
   *
   */

  (function ($) {
    $.fn.extend({
      simulate: function (type, options) {
        return this.each(function () {
          var opt = $.extend({}, $.simulate.defaults, options || {});
          new $.simulate(this, type, opt);
        });
      },
    });

    $.simulate = function (el, type, options) {
      this.target = el;
      this.options = options;

      if (/^drag$/.test(type)) {
        this[type].apply(this, [this.target, options]);
      } else {
        this.simulateEvent(el, type, options);
      }
    };

    $.extend($.simulate.prototype, {
      simulateEvent: function (el, type, options) {
        var evt = this.createEvent(type, options);
        this.dispatchEvent(el, type, evt, options);
        return evt;
      },
      createEvent: function (type, options) {
        if (/^mouse(over|out|down|up|move)|(dbl)?click$/.test(type)) {
          return this.mouseEvent(type, options);
        } else if (/^key(up|down|press)$/.test(type)) {
          return this.keyboardEvent(type, options);
        }
      },
      mouseEvent: function (type, options) {
        var evt;
        var e = $.extend(
          {
            bubbles: true,
            cancelable: type != 'mousemove',
            view: window,
            detail: 0,
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            button: 0,
            relatedTarget: undefined,
          },
          options,
        );

        var relatedTarget = $(e.relatedTarget)[0];

        if ($.isFunction(document.createEvent)) {
          evt = document.createEvent('MouseEvents');
          evt.initMouseEvent(
            type,
            e.bubbles,
            e.cancelable,
            e.view,
            e.detail,
            e.screenX,
            e.screenY,
            e.clientX,
            e.clientY,
            e.ctrlKey,
            e.altKey,
            e.shiftKey,
            e.metaKey,
            e.button,
            e.relatedTarget || document.body.parentNode,
          );
        } else if (document.createEventObject) {
          evt = document.createEventObject();
          $.extend(evt, e);
          evt.button = { 0: 1, 1: 4, 2: 2 }[evt.button] || evt.button;
        }
        return evt;
      },
      keyboardEvent: function (type, options) {
        var evt;

        var e = $.extend(
          {
            bubbles: true,
            cancelable: true,
            view: window,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            keyCode: 0,
            charCode: 0,
          },
          options,
        );

        if ($.isFunction(document.createEvent)) {
          try {
            evt = document.createEvent('KeyEvents');
            evt.initKeyEvent(
              type,
              e.bubbles,
              e.cancelable,
              e.view,
              e.ctrlKey,
              e.altKey,
              e.shiftKey,
              e.metaKey,
              e.keyCode,
              e.charCode,
            );
          } catch (err) {
            evt = document.createEvent('Events');
            evt.initEvent(type, e.bubbles, e.cancelable);
            $.extend(evt, {
              view: e.view,
              ctrlKey: e.ctrlKey,
              altKey: e.altKey,
              shiftKey: e.shiftKey,
              metaKey: e.metaKey,
              keyCode: e.keyCode,
              charCode: e.charCode,
            });
          }
        } else if (document.createEventObject) {
          evt = document.createEventObject();
          $.extend(evt, e);
        }
        if ($.browser.msie || $.browser.opera) {
          evt.keyCode = e.charCode > 0 ? e.charCode : e.keyCode;
          evt.charCode = undefined;
        }
        return evt;
      },

      dispatchEvent: function (el, type, evt) {
        if (el.dispatchEvent) {
          el.dispatchEvent(evt);
        } else if (el.fireEvent) {
          el.fireEvent('on' + type, evt);
        }
        return evt;
      },

      drag: function (el) {
        var self = this,
          center = this.findCenter(this.target),
          options = this.options,
          x = Math.floor(center.x),
          y = Math.floor(center.y),
          dx = options.dx || 0,
          dy = options.dy || 0,
          target = this.target;
        var coord = { clientX: x, clientY: y };
        this.simulateEvent(target, 'mousedown', coord);
        coord = { clientX: x + 1, clientY: y + 1 };
        this.simulateEvent(document, 'mousemove', coord);
        coord = { clientX: x + dx, clientY: y + dy };
        this.simulateEvent(document, 'mousemove', coord);
        this.simulateEvent(document, 'mousemove', coord);
        this.simulateEvent(target, 'mouseup', coord);
      },
      findCenter: function (el) {
        var el = $(this.target),
          o = el.offset();
        return {
          x: o.left + el.outerWidth() / 2,
          y: o.top + el.outerHeight() / 2,
        };
      },
    });

    $.extend($.simulate, {
      defaults: {
        speed: 'sync',
      },
      VK_TAB: 9,
      VK_ENTER: 13,
      VK_ESC: 27,
      VK_PGUP: 33,
      VK_PGDN: 34,
      VK_END: 35,
      VK_HOME: 36,
      VK_LEFT: 37,
      VK_UP: 38,
      VK_RIGHT: 39,
      VK_DOWN: 40,
    });
  })(jQuery);

  /* jquery.sparkline 1.4.3 - http://omnipotent.net/jquery.sparkline/ */

  (function ($) {
    $.fn.simpledraw = function (width, height, use_existing) {
      if (use_existing && this[0].vcanvas) return this[0].vcanvas;
      if (width == undefined) width = $(this).innerWidth();
      if (height == undefined) height = $(this).innerHeight();
      if ($.browser.hasCanvas) {
        return new vcanvas_canvas(width, height, this);
      } else if ($.browser.msie) {
        return new vcanvas_vml(width, height, this);
      } else {
        return false;
      }
    };
    var pending = [];
    $.fn.sparkline = function (uservalues, options) {
      var options = $.extend(
        {
          type: 'line',
          lineColor: '#00f',
          fillColor: '#cdf',
          defaultPixelsPerValue: 3,
          width: 'auto',
          height: 'auto',
          composite: false,
        },
        options ? options : {},
      );
      return this.each(function () {
        var render = function () {
          var values = uservalues == 'html' || uservalues == undefined ? $(this).text().split(',') : uservalues;
          var width = options.width == 'auto' ? values.length * options.defaultPixelsPerValue : options.width;
          if (options.height == 'auto') {
            if (!options.composite || !this.vcanvas) {
              var tmp = document.createElement('span');
              tmp.innerHTML = 'a';
              $(this).html(tmp);
              height = $(tmp).innerHeight();
              $(tmp).remove();
            }
          } else {
            height = options.height;
          }
          $.fn.sparkline[options.type].call(this, values, options, width, height);
        };
        if (($(this).html() && $(this).is(':hidden')) || ($.fn.jquery < '1.3.0' && $(this).parents().is(':hidden'))) {
          pending.push([this, render]);
        } else {
          render.call(this);
        }
      });
    };
    $.sparkline_display_visible = function () {
      for (var i = pending.length - 1; i >= 0; i--) {
        var el = pending[i][0];
        if ($(el).is(':visible') && !$(el).parents().is(':hidden')) {
          pending[i][1].call(el);
          pending.splice(i, 1);
        }
      }
    };
    $.fn.sparkline.line = function (values, options, width, height) {
      var options = $.extend(
        {
          spotColor: '#f80',
          spotRadius: 1.5,
          minSpotColor: '#f80',
          maxSpotColor: '#f80',
          lineWidth: 1,
          normalRangeMin: undefined,
          normalRangeMax: undefined,
          normalRangeColor: '#ccc',
          chartRangeMin: undefined,
          chartRangeMax: undefined,
        },
        options ? options : {},
      );
      var xvalues = [],
        yvalues = [],
        yminmax = [];
      for (i = 0; i < values.length; i++) {
        var v = values[i];
        var isstr = typeof values[i] == 'string';
        var isarray = typeof values[i] == 'object' && values[i] instanceof Array;
        var sp = isstr && values[i].split(':');
        if (isstr && sp.length == 2) {
          xvalues.push(Number(sp[0]));
          yvalues.push(Number(sp[1]));
          yminmax.push(Number(sp[1]));
        } else if (isarray) {
          xvalues.push(values[i][0]);
          yvalues.push(values[i][1]);
          yminmax.push(values[i][1]);
        } else {
          xvalues.push(i);
          if (values[i] === null || values[i] == 'null') {
            yvalues.push(null);
          } else {
            yvalues.push(Number(values[i]));
            yminmax.push(Number(values[i]));
          }
        }
      }
      if (options.xvalues) {
        xvalues = options.xvalues;
      }
      var maxy = Math.max.apply(Math, yminmax);
      var maxyval = maxy;
      var miny = Math.min.apply(Math, yminmax);
      var minyval = miny;
      var maxx = Math.max.apply(Math, xvalues);
      var maxxval = maxx;
      var minx = Math.min.apply(Math, xvalues);
      var minxval = minx;
      if (options.normalRangeMin != undefined) {
        if (options.normalRangeMin < miny) miny = options.normalRangeMin;
        if (options.normalRangeMax > maxy) maxy = options.normalRangeMax;
      }
      if (options.chartRangeMin != undefined && options.chartRangeMin < miny) {
        miny = options.chartRangeMin;
      }
      if (options.chartRangeMax != undefined && options.chartRangeMax > maxy) {
        maxy = options.chartRangeMax;
      }
      var rangex = maxx - minx == 0 ? 1 : maxx - minx;
      var rangey = maxy - miny == 0 ? 1 : maxy - miny;
      var vl = yvalues.length - 1;
      if (vl < 1) {
        this.innerHTML = '';
        return;
      }
      var target = $(this).simpledraw(width, height, options.composite);
      if (target) {
        var canvas_width = target.pixel_width;
        var canvas_height = target.pixel_height;
        var canvas_top = 0;
        var canvas_left = 0;
        if (options.spotRadius && (canvas_width < options.spotRadius * 4 || canvas_height < options.spotRadius * 4)) {
          options.spotRadius = 0;
        }
        if (options.spotRadius) {
          if (options.minSpotColor || (options.spotColor && yvalues[vl] == miny))
            canvas_height -= Math.ceil(options.spotRadius);
          if (options.maxSpotColor || (options.spotColor && yvalues[vl] == maxy)) {
            canvas_height -= Math.ceil(options.spotRadius);
            canvas_top += Math.ceil(options.spotRadius);
          }
          if (options.minSpotColor || (options.maxSpotColor && (yvalues[0] == miny || yvalues[0] == maxy))) {
            canvas_left += Math.ceil(options.spotRadius);
            canvas_width -= Math.ceil(options.spotRadius);
          }
          if (
            options.spotColor ||
            options.minSpotColor ||
            (options.maxSpotColor && (yvalues[vl] == miny || yvalues[vl] == maxy))
          )
            canvas_width -= Math.ceil(options.spotRadius);
        }
        canvas_height--;
        if (options.normalRangeMin != undefined) {
          var ytop =
            canvas_top + Math.round(canvas_height - canvas_height * ((options.normalRangeMax - miny) / rangey));
          var height = Math.round((canvas_height * (options.normalRangeMax - options.normalRangeMin)) / rangey);
          target.drawRect(canvas_left, ytop, canvas_width, height, undefined, options.normalRangeColor);
        }
        var path = [];
        var paths = [path];
        for (var i = 0; i < yvalues.length; i++) {
          var x = xvalues[i],
            y = yvalues[i];
          if (y === null) {
            if (i) {
              if (yvalues[i - 1] !== null) {
                path = [];
                paths.push(path);
              }
            }
          } else {
            if (!path.length) {
              path.push([canvas_left + Math.round((x - minx) * (canvas_width / rangex)), canvas_top + canvas_height]);
            }
            path.push([
              canvas_left + Math.round((x - minx) * (canvas_width / rangex)),
              canvas_top + Math.round(canvas_height - canvas_height * ((y - miny) / rangey)),
            ]);
          }
        }
        for (var i = 0; i < paths.length; i++) {
          path = paths[i];
          if (!path.length) continue;
          if (options.fillColor) {
            path.push([path[path.length - 1][0], canvas_top + canvas_height - 1]);
            target.drawShape(path, undefined, options.fillColor);
            path.pop();
          }
          if (path.length > 2) {
            path[0] = [path[0][0], path[1][1]];
          }
          target.drawShape(path, options.lineColor, undefined, options.lineWidth);
        }
        if (options.spotRadius && options.spotColor) {
          target.drawCircle(
            canvas_left + canvas_width,
            canvas_top + Math.round(canvas_height - canvas_height * ((yvalues[vl] - miny) / rangey)),
            options.spotRadius,
            undefined,
            options.spotColor,
          );
        }
        if (maxy != minyval) {
          if (options.spotRadius && options.minSpotColor) {
            var x = xvalues[yvalues.indexOf(minyval)];
            target.drawCircle(
              canvas_left + Math.round((x - minx) * (canvas_width / rangex)),
              canvas_top + Math.round(canvas_height - canvas_height * ((minyval - miny) / rangey)),
              options.spotRadius,
              undefined,
              options.minSpotColor,
            );
          }
          if (options.spotRadius && options.maxSpotColor) {
            var x = xvalues[yvalues.indexOf(maxyval)];
            target.drawCircle(
              canvas_left + Math.round((x - minx) * (canvas_width / rangex)),
              canvas_top + Math.round(canvas_height - canvas_height * ((maxyval - miny) / rangey)),
              options.spotRadius,
              undefined,
              options.maxSpotColor,
            );
          }
        }
      } else {
        this.innerHTML = '';
      }
    };
    $.fn.sparkline.bar = function (values, options, width, height) {
      var options = $.extend(
        {
          type: 'bar',
          barColor: '#00f',
          negBarColor: '#f44',
          zeroColor: undefined,
          zeroAxis: undefined,
          barWidth: 4,
          barSpacing: 1,
          chartRangeMax: undefined,
          chartRangeMin: undefined,
          colorMap: {},
        },
        options ? options : {},
      );
      var width = values.length * options.barWidth + (values.length - 1) * options.barSpacing;
      var num_values = [];
      for (var i = 0; i < values.length; i++) {
        if (values[i] == 'null' || values[i] === null) {
          values[i] = null;
        } else {
          values[i] = Number(values[i]);
          num_values.push(Number(values[i]));
        }
      }
      var max = Math.max.apply(Math, num_values);
      var min = Math.min.apply(Math, num_values);
      if (options.chartRangeMin != undefined && options.chartRangeMin < min) {
        min = options.chartRangeMin;
      }
      if (options.chartRangeMax != undefined && options.chartRangeMax > max) {
        max = options.chartRangeMax;
      }
      if (options.zeroAxis == undefined) options.zeroAxis = min < 0;
      var range = max - min == 0 ? 1 : max - min;
      var target = $(this).simpledraw(width, height);
      if (target) {
        var canvas_width = target.pixel_width;
        var canvas_height = target.pixel_height;
        var yzero =
          min < 0 && options.zeroAxis
            ? canvas_height - Math.round(canvas_height * (Math.abs(min) / range)) - 1
            : canvas_height - 1;
        for (var i = 0; i < values.length; i++) {
          var x = i * (options.barWidth + options.barSpacing);
          var val = values[i];
          if (val === null) {
            continue;
          }
          var color = val < 0 ? options.negBarColor : options.barColor;
          if (options.zeroAxis && min < 0) {
            var height = Math.round(canvas_height * (Math.abs(val) / range)) + 1;
            var y = val < 0 ? yzero : yzero - height;
          } else {
            var height = Math.round(canvas_height * ((val - min) / range)) + 1;
            var y = canvas_height - height;
          }
          if (val == 0 && options.zeroColor != undefined) {
            color = options.zeroColor;
          }
          if (options.colorMap[val]) {
            color = options.colorMap[val];
          }
          target.drawRect(x, y, options.barWidth - 1, height - 1, color, color);
        }
      } else {
        this.innerHTML = '';
      }
    };
    $.fn.sparkline.tristate = function (values, options, width, height) {
      values = $.map(values, Number);
      var options = $.extend(
        { barWidth: 4, barSpacing: 1, posBarColor: '#6f6', negBarColor: '#f44', zeroBarColor: '#999', colorMap: {} },
        options,
      );
      var width = values.length * options.barWidth + (values.length - 1) * options.barSpacing;
      var target = $(this).simpledraw(width, height);
      if (target) {
        var canvas_width = target.pixel_width;
        var canvas_height = target.pixel_height;
        var half_height = Math.round(canvas_height / 2);
        for (var i = 0; i < values.length; i++) {
          var x = i * (options.barWidth + options.barSpacing);
          if (values[i] < 0) {
            var y = half_height;
            var height = half_height - 1;
            var color = options.negBarColor;
          } else if (values[i] > 0) {
            var y = 0;
            var height = half_height - 1;
            var color = options.posBarColor;
          } else {
            var y = half_height - 1;
            var height = 2;
            var color = options.zeroBarColor;
          }
          if (options.colorMap[values[i]]) {
            color = options.colorMap[values[i]];
          }
          target.drawRect(x, y, options.barWidth - 1, height - 1, color, color);
        }
      } else {
        this.innerHTML = '';
      }
    };
    $.fn.sparkline.discrete = function (values, options, width, height) {
      values = $.map(values, Number);
      var options = $.extend(
        {
          lineHeight: 'auto',
          thresholdColor: undefined,
          thresholdValue: 0,
          chartRangeMax: undefined,
          chartRangeMin: undefined,
        },
        options,
      );
      width = options.width == 'auto' ? values.length * 2 : width;
      var interval = Math.floor(width / values.length);
      var target = $(this).simpledraw(width, height);
      if (target) {
        var canvas_width = target.pixel_width;
        var canvas_height = target.pixel_height;
        var line_height = options.lineHeight == 'auto' ? Math.round(canvas_height * 0.3) : options.lineHeight;
        var pheight = canvas_height - line_height;
        var min = Math.min.apply(Math, values);
        var max = Math.max.apply(Math, values);
        if (options.chartRangeMin != undefined && options.chartRangeMin < min) {
          min = options.chartRangeMin;
        }
        if (options.chartRangeMax != undefined && options.chartRangeMax > max) {
          max = options.chartRangeMax;
        }
        var range = max - min;
        for (var i = 0; i < values.length; i++) {
          var val = values[i];
          var x = i * interval;
          var ytop = Math.round(pheight - pheight * ((val - min) / range));
          target.drawLine(
            x,
            ytop,
            x,
            ytop + line_height,
            options.thresholdColor && val < options.thresholdValue ? options.thresholdColor : options.lineColor,
          );
        }
      } else {
        this.innerHTML = '';
      }
    };
    $.fn.sparkline.bullet = function (values, options, width, height) {
      values = $.map(values, Number);
      var options = $.extend(
        {
          targetColor: 'red',
          targetWidth: 3,
          performanceColor: 'blue',
          rangeColors: ['#D3DAFE', '#A8B6FF', '#7F94FF'],
          base: undefined,
        },
        options,
      );
      width = options.width == 'auto' ? '4.0em' : width;
      var target = $(this).simpledraw(width, height);
      if (target && values.length > 1) {
        var canvas_width = target.pixel_width - Math.ceil(options.targetWidth / 2);
        var canvas_height = target.pixel_height;
        var min = Math.min.apply(Math, values);
        var max = Math.max.apply(Math, values);
        if (options.base == undefined) {
          var min = min < 0 ? min : 0;
        } else {
          min = options.base;
        }
        var range = max - min;
        for (i = 2; i < values.length; i++) {
          var rangeval = parseInt(values[i]);
          var rangewidth = Math.round(canvas_width * ((rangeval - min) / range));
          target.drawRect(
            0,
            0,
            rangewidth - 1,
            canvas_height - 1,
            options.rangeColors[i - 2],
            options.rangeColors[i - 2],
          );
        }
        var perfval = parseInt(values[1]);
        var perfwidth = Math.round(canvas_width * ((perfval - min) / range));
        target.drawRect(
          0,
          Math.round(canvas_height * 0.3),
          perfwidth - 1,
          Math.round(canvas_height * 0.4) - 1,
          options.performanceColor,
          options.performanceColor,
        );
        var targetval = parseInt(values[0]);
        var x = Math.round(canvas_width * ((targetval - min) / range) - options.targetWidth / 2);
        var targettop = Math.round(canvas_height * 0.1);
        var targetheight = canvas_height - targettop * 2;
        target.drawRect(
          x,
          targettop,
          options.targetWidth - 1,
          targetheight - 1,
          options.targetColor,
          options.targetColor,
        );
      } else {
        this.innerHTML = '';
      }
    };
    $.fn.sparkline.pie = function (values, options, width, height) {
      values = $.map(values, Number);
      var options = $.extend({ sliceColors: ['#f00', '#0f0', '#00f'] }, options);
      width = options.width == 'auto' ? height : width;
      var target = $(this).simpledraw(width, height);
      if (target && values.length > 1) {
        var canvas_width = target.pixel_width;
        var canvas_height = target.pixel_height;
        var radius = Math.floor(Math.min(canvas_width, canvas_height) / 2);
        var total = 0;
        for (var i = 0; i < values.length; i++) total += values[i];
        var next = 0;
        if (options.offset) {
          next += 2 * Math.PI * (options.offset / 360);
        }
        var circle = 2 * Math.PI;
        for (var i = 0; i < values.length; i++) {
          var start = next;
          var end = next;
          if (total > 0) {
            end = next + circle * (values[i] / total);
          }
          target.drawPieSlice(
            radius,
            radius,
            radius,
            start,
            end,
            undefined,
            options.sliceColors[i % options.sliceColors.length],
          );
          next = end;
        }
      }
    };
    function quartile(values, q) {
      if (q == 2) {
        var vl2 = Math.floor(values.length / 2);
        return values.length % 2 ? values[vl2] : (values[vl2] + values[vl2 + 1]) / 2;
      } else {
        var vl4 = Math.floor(values.length / 4);
        return values.length % 2 ? (values[vl4 * q] + values[vl4 * q + 1]) / 2 : values[vl4 * q];
      }
    }
    $.fn.sparkline.box = function (values, options, width, height) {
      values = $.map(values, Number);
      var options = $.extend(
        {
          raw: false,
          boxLineColor: 'black',
          boxFillColor: '#cdf',
          whiskerColor: 'black',
          outlierLineColor: '#333',
          outlierFillColor: 'white',
          medianColor: 'red',
          showOutliers: true,
          outlierIQR: 1.5,
          spotRadius: 1.5,
          target: undefined,
          targetColor: '#4a2',
          chartRangeMax: undefined,
          chartRangeMin: undefined,
        },
        options,
      );
      width = options.width == 'auto' ? '4.0em' : width;
      minvalue = options.chartRangeMin == undefined ? Math.min.apply(Math, values) : options.chartRangeMin;
      maxvalue = options.chartRangeMax == undefined ? Math.max.apply(Math, values) : options.chartRangeMax;
      var target = $(this).simpledraw(width, height);
      if (target && values.length > 1) {
        var canvas_width = target.pixel_width;
        var canvas_height = target.pixel_height;
        if (options.raw) {
          if (options.showOutliers && values.length > 5) {
            var loutlier = values[0],
              lwhisker = values[1],
              q1 = values[2],
              q2 = values[3],
              q3 = values[4],
              rwhisker = values[5],
              routlier = values[6];
          } else {
            var lwhisker = values[0],
              q1 = values[1],
              q2 = values[2],
              q3 = values[3],
              rwhisker = values[4];
          }
        } else {
          values.sort(function (a, b) {
            return a - b;
          });
          var q1 = quartile(values, 1);
          var q2 = quartile(values, 2);
          var q3 = quartile(values, 3);
          var iqr = q3 - q1;
          if (options.showOutliers) {
            var lwhisker = undefined,
              rwhisker = undefined;
            for (var i = 0; i < values.length; i++) {
              if (lwhisker == undefined && values[i] > q1 - iqr * options.outlierIQR) lwhisker = values[i];
              if (values[i] < q3 + iqr * options.outlierIQR) rwhisker = values[i];
            }
            var loutlier = values[0];
            var routlier = values[values.length - 1];
          } else {
            var lwhisker = values[0];
            var rwhisker = values[values.length - 1];
          }
        }
        var unitsize = canvas_width / (maxvalue - minvalue + 1);
        var canvas_left = 0;
        if (options.showOutliers) {
          canvas_left = Math.ceil(options.spotRadius);
          canvas_width -= 2 * Math.ceil(options.spotRadius);
          var unitsize = canvas_width / (maxvalue - minvalue + 1);
          if (loutlier < lwhisker)
            target.drawCircle(
              (loutlier - minvalue) * unitsize + canvas_left,
              canvas_height / 2,
              options.spotRadius,
              options.outlierLineColor,
              options.outlierFillColor,
            );
          if (routlier > rwhisker)
            target.drawCircle(
              (routlier - minvalue) * unitsize + canvas_left,
              canvas_height / 2,
              options.spotRadius,
              options.outlierLineColor,
              options.outlierFillColor,
            );
        }
        target.drawRect(
          Math.round((q1 - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height * 0.1),
          Math.round((q3 - q1) * unitsize),
          Math.round(canvas_height * 0.8),
          options.boxLineColor,
          options.boxFillColor,
        );
        target.drawLine(
          Math.round((lwhisker - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height / 2),
          Math.round((q1 - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height / 2),
          options.lineColor,
        );
        target.drawLine(
          Math.round((lwhisker - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height / 4),
          Math.round((lwhisker - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height - canvas_height / 4),
          options.whiskerColor,
        );
        target.drawLine(
          Math.round((rwhisker - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height / 2),
          Math.round((q3 - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height / 2),
          options.lineColor,
        );
        target.drawLine(
          Math.round((rwhisker - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height / 4),
          Math.round((rwhisker - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height - canvas_height / 4),
          options.whiskerColor,
        );
        target.drawLine(
          Math.round((q2 - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height * 0.1),
          Math.round((q2 - minvalue) * unitsize + canvas_left),
          Math.round(canvas_height * 0.9),
          options.medianColor,
        );
        if (options.target) {
          var size = Math.ceil(options.spotRadius);
          target.drawLine(
            Math.round((options.target - minvalue) * unitsize + canvas_left),
            Math.round(canvas_height / 2 - size),
            Math.round((options.target - minvalue) * unitsize + canvas_left),
            Math.round(canvas_height / 2 + size),
            options.targetColor,
          );
          target.drawLine(
            Math.round((options.target - minvalue) * unitsize + canvas_left - size),
            Math.round(canvas_height / 2),
            Math.round((options.target - minvalue) * unitsize + canvas_left + size),
            Math.round(canvas_height / 2),
            options.targetColor,
          );
        }
      } else {
        this.innerHTML = '';
      }
    };
    if (!Array.prototype.indexOf) {
      Array.prototype.indexOf = function (entry) {
        for (var i = 0; i < this.length; i++) {
          if (this[i] == entry) return i;
        }
        return -1;
      };
    }
    if ($.browser.msie && !document.namespaces['v']) {
      document.namespaces.add('v', 'urn:schemas-microsoft-com:vml', '#default#VML');
    }
    if ($.browser.hasCanvas == undefined) {
      var t = document.createElement('canvas');
      $.browser.hasCanvas = t.getContext != undefined;
    }
    var vcanvas_base = function (width, height, target) {};
    vcanvas_base.prototype = {
      init: function (width, height, target) {
        this.width = width;
        this.height = height;
        this.target = target;
        if (target[0]) target = target[0];
        target.vcanvas = this;
      },
      drawShape: function (path, lineColor, fillColor, lineWidth) {
        alert('drawShape not implemented');
      },
      drawLine: function (x1, y1, x2, y2, lineColor, lineWidth) {
        return this.drawShape(
          [
            [x1, y1],
            [x2, y2],
          ],
          lineColor,
          lineWidth,
        );
      },
      drawCircle: function (x, y, radius, lineColor, fillColor) {
        alert('drawCircle not implemented');
      },
      drawPieSlice: function (x, y, radius, startAngle, endAngle, lineColor, fillColor) {
        alert('drawPieSlice not implemented');
      },
      drawRect: function (x, y, width, height, lineColor, fillColor) {
        alert('drawRect not implemented');
      },
      getElement: function () {
        return this.canvas;
      },
      _insert: function (el, target) {
        $(target).html(el);
      },
    };
    var vcanvas_canvas = function (width, height, target) {
      return this.init(width, height, target);
    };
    vcanvas_canvas.prototype = $.extend(new vcanvas_base(), {
      _super: vcanvas_base.prototype,
      init: function (width, height, target) {
        this._super.init(width, height, target);
        this.canvas = document.createElement('canvas');
        if (target[0]) target = target[0];
        target.vcanvas = this;
        $(this.canvas).css({ display: 'inline-block', width: width, height: height, verticalAlign: 'top' });
        this._insert(this.canvas, target);
        this.pixel_height = $(this.canvas).height();
        this.pixel_width = $(this.canvas).width();
        this.canvas.width = this.pixel_width;
        this.canvas.height = this.pixel_height;
        $(this.canvas).css({ width: this.pixel_width, height: this.pixel_height });
      },
      _getContext: function (lineColor, fillColor, lineWidth) {
        var context = this.canvas.getContext('2d');
        if (lineColor != undefined) context.strokeStyle = lineColor;
        context.lineWidth = lineWidth == undefined ? 1 : lineWidth;
        if (fillColor != undefined) context.fillStyle = fillColor;
        return context;
      },
      drawShape: function (path, lineColor, fillColor, lineWidth) {
        var context = this._getContext(lineColor, fillColor, lineWidth);
        context.beginPath();
        context.moveTo(path[0][0] + 0.5, path[0][1] + 0.5);
        for (var i = 1; i < path.length; i++) {
          context.lineTo(path[i][0] + 0.5, path[i][1] + 0.5);
        }
        if (lineColor != undefined) {
          context.stroke();
        }
        if (fillColor != undefined) {
          context.fill();
        }
      },
      drawCircle: function (x, y, radius, lineColor, fillColor) {
        var context = this._getContext(lineColor, fillColor);
        context.beginPath();
        context.arc(x, y, radius, 0, 2 * Math.PI, false);
        if (lineColor != undefined) {
          context.stroke();
        }
        if (fillColor != undefined) {
          context.fill();
        }
      },
      drawPieSlice: function (x, y, radius, startAngle, endAngle, lineColor, fillColor) {
        var context = this._getContext(lineColor, fillColor);
        context.beginPath();
        context.moveTo(x, y);
        context.arc(x, y, radius, startAngle, endAngle, false);
        context.lineTo(x, y);
        context.closePath();
        if (lineColor != undefined) {
          context.stroke();
        }
        if (fillColor) {
          context.fill();
        }
      },
      drawRect: function (x, y, width, height, lineColor, fillColor) {
        return this.drawShape(
          [
            [x, y],
            [x + width, y],
            [x + width, y + height],
            [x, y + height],
            [x, y],
          ],
          lineColor,
          fillColor,
        );
      },
    });
    var vcanvas_vml = function (width, height, target) {
      return this.init(width, height, target);
    };
    vcanvas_vml.prototype = $.extend(new vcanvas_base(), {
      _super: vcanvas_base.prototype,
      init: function (width, height, target) {
        this._super.init(width, height, target);
        if (target[0]) target = target[0];
        target.vcanvas = this;
        this.canvas = document.createElement('span');
        $(this.canvas).css({
          display: 'inline-block',
          position: 'relative',
          overflow: 'hidden',
          width: width,
          height: height,
          margin: '0px',
          padding: '0px',
          verticalAlign: 'top',
        });
        this._insert(this.canvas, target);
        this.pixel_height = $(this.canvas).height();
        this.pixel_width = $(this.canvas).width();
        this.canvas.width = this.pixel_width;
        this.canvas.height = this.pixel_height;
        var groupel =
          '<v:group coordorigin="0 0" coordsize="' +
          this.pixel_width +
          ' ' +
          this.pixel_height +
          '"' +
          ' style="position:absolute;top:0;left:0;width:' +
          this.pixel_width +
          'px;height=' +
          this.pixel_height +
          'px;"></v:group>';
        this.canvas.insertAdjacentHTML('beforeEnd', groupel);
        this.group = $(this.canvas).children()[0];
      },
      drawShape: function (path, lineColor, fillColor, lineWidth) {
        var vpath = [];
        for (var i = 0; i < path.length; i++) {
          vpath[i] = '' + path[i][0] + ',' + path[i][1];
        }
        var initial = vpath.splice(0, 1);
        lineWidth = lineWidth == undefined ? 1 : lineWidth;
        var stroke =
          lineColor == undefined
            ? ' stroked="false" '
            : ' strokeWeight="' + lineWidth + '" strokeColor="' + lineColor + '" ';
        var fill = fillColor == undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
        var closed = vpath[0] == vpath[vpath.length - 1] ? 'x ' : '';
        var vel =
          '<v:shape coordorigin="0 0" coordsize="' +
          this.pixel_width +
          ' ' +
          this.pixel_height +
          '" ' +
          stroke +
          fill +
          ' style="position:absolute;left:0px;top:0px;height:' +
          this.pixel_height +
          'px;width:' +
          this.pixel_width +
          'px;padding:0px;margin:0px;" ' +
          ' path="m ' +
          initial +
          ' l ' +
          vpath.join(', ') +
          ' ' +
          closed +
          'e">' +
          ' </v:shape>';
        this.group.insertAdjacentHTML('beforeEnd', vel);
      },
      drawCircle: function (x, y, radius, lineColor, fillColor) {
        x -= radius + 1;
        y -= radius + 1;
        var stroke =
          lineColor == undefined ? ' stroked="false" ' : ' strokeWeight="1" strokeColor="' + lineColor + '" ';
        var fill = fillColor == undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
        var vel =
          '<v:oval ' +
          stroke +
          fill +
          ' style="position:absolute;top:' +
          y +
          'px; left:' +
          x +
          'px; width:' +
          radius * 2 +
          'px; height:' +
          radius * 2 +
          'px"></v:oval>';
        this.group.insertAdjacentHTML('beforeEnd', vel);
      },
      drawPieSlice: function (x, y, radius, startAngle, endAngle, lineColor, fillColor) {
        if (startAngle == endAngle) {
          return;
        }
        if (endAngle - startAngle == 2 * Math.PI) {
          startAngle = 0.0;
          endAngle = 2 * Math.PI;
        }
        var startx = x + Math.round(Math.cos(startAngle) * radius);
        var starty = y + Math.round(Math.sin(startAngle) * radius);
        var endx = x + Math.round(Math.cos(endAngle) * radius);
        var endy = y + Math.round(Math.sin(endAngle) * radius);
        var vpath = [x - radius, y - radius, x + radius, y + radius, startx, starty, endx, endy];
        var stroke =
          lineColor == undefined ? ' stroked="false" ' : ' strokeWeight="1" strokeColor="' + lineColor + '" ';
        var fill = fillColor == undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
        var vel =
          '<v:shape coordorigin="0 0" coordsize="' +
          this.pixel_width +
          ' ' +
          this.pixel_height +
          '" ' +
          stroke +
          fill +
          ' style="position:absolute;left:0px;top:0px;height:' +
          this.pixel_height +
          'px;width:' +
          this.pixel_width +
          'px;padding:0px;margin:0px;" ' +
          ' path="m ' +
          x +
          ',' +
          y +
          ' wa ' +
          vpath.join(', ') +
          ' x e">' +
          ' </v:shape>';
        this.group.insertAdjacentHTML('beforeEnd', vel);
      },
      drawRect: function (x, y, width, height, lineColor, fillColor) {
        return this.drawShape(
          [
            [x, y],
            [x, y + height],
            [x + width, y + height],
            [x + width, y],
            [x, y],
          ],
          lineColor,
          fillColor,
        );
      },
    });
  })(jQuery);
  /***
   * Contains core SlickGrid classes.
   * @module Core
   * @namespace Slick
   */

  (function ($) {
    // register namespace
    $.extend(true, window, {
      Slick: {
        Event: Event,
        EventData: EventData,
        EventHandler: EventHandler,
        Range: Range,
        NonDataRow: NonDataItem,
        Group: Group,
        GroupTotals: GroupTotals,
        EditorLock: EditorLock,

        /***
         * A global singleton editor lock.
         * @class GlobalEditorLock
         * @static
         * @constructor
         */
        GlobalEditorLock: new EditorLock(),
      },
    });

    /***
     * An event object for passing data to event handlers and letting them control propagation.
     * <p>This is pretty much identical to how W3C and jQuery implement events.</p>
     * @class EventData
     * @constructor
     */
    function EventData() {
      var isPropagationStopped = false;
      var isImmediatePropagationStopped = false;

      /***
       * Stops event from propagating up the DOM tree.
       * @method stopPropagation
       */
      this.stopPropagation = function () {
        isPropagationStopped = true;
      };

      /***
       * Returns whether stopPropagation was called on this event object.
       * @method isPropagationStopped
       * @return {Boolean}
       */
      this.isPropagationStopped = function () {
        return isPropagationStopped;
      };

      /***
       * Prevents the rest of the handlers from being executed.
       * @method stopImmediatePropagation
       */
      this.stopImmediatePropagation = function () {
        isImmediatePropagationStopped = true;
      };

      /***
       * Returns whether stopImmediatePropagation was called on this event object.\
       * @method isImmediatePropagationStopped
       * @return {Boolean}
       */
      this.isImmediatePropagationStopped = function () {
        return isImmediatePropagationStopped;
      };
    }

    /***
     * A simple publisher-subscriber implementation.
     * @class Event
     * @constructor
     */
    function Event() {
      var handlers = [];

      /***
       * Adds an event handler to be called when the event is fired.
       * <p>Event handler will receive two arguments - an <code>EventData</code> and the <code>data</code>
       * object the event was fired with.<p>
       * @method subscribe
       * @param fn {Function} Event handler.
       */
      this.subscribe = function (fn) {
        handlers.push(fn);
      };

      /***
       * Removes an event handler added with <code>subscribe(fn)</code>.
       * @method unsubscribe
       * @param fn {Function} Event handler to be removed.
       */
      this.unsubscribe = function (fn) {
        for (var i = handlers.length - 1; i >= 0; i--) {
          if (handlers[i] === fn) {
            handlers.splice(i, 1);
          }
        }
      };

      /***
       * Fires an event notifying all subscribers.
       * @method notify
       * @param args {Object} Additional data object to be passed to all handlers.
       * @param e {EventData}
       *      Optional.
       *      An <code>EventData</code> object to be passed to all handlers.
       *      For DOM events, an existing W3C/jQuery event object can be passed in.
       * @param scope {Object}
       *      Optional.
       *      The scope ("this") within which the handler will be executed.
       *      If not specified, the scope will be set to the <code>Event</code> instance.
       */
      this.notify = function (args, e, scope) {
        e = e || new EventData();
        scope = scope || this;

        var returnValue;
        for (var i = 0; i < handlers.length && !(e.isPropagationStopped() || e.isImmediatePropagationStopped()); i++) {
          returnValue = handlers[i].call(scope, e, args);
        }

        return returnValue;
      };
    }

    function EventHandler() {
      var handlers = [];

      this.subscribe = function (event, handler) {
        handlers.push({
          event: event,
          handler: handler,
        });
        event.subscribe(handler);

        return this; // allow chaining
      };

      this.unsubscribe = function (event, handler) {
        var i = handlers.length;
        while (i--) {
          if (handlers[i].event === event && handlers[i].handler === handler) {
            handlers.splice(i, 1);
            event.unsubscribe(handler);
            return;
          }
        }

        return this; // allow chaining
      };

      this.unsubscribeAll = function () {
        var i = handlers.length;
        while (i--) {
          handlers[i].event.unsubscribe(handlers[i].handler);
        }
        handlers = [];

        return this; // allow chaining
      };
    }

    /***
     * A structure containing a range of cells.
     * @class Range
     * @constructor
     * @param fromRow {Integer} Starting row.
     * @param fromCell {Integer} Starting cell.
     * @param toRow {Integer} Optional. Ending row. Defaults to <code>fromRow</code>.
     * @param toCell {Integer} Optional. Ending cell. Defaults to <code>fromCell</code>.
     */
    function Range(fromRow, fromCell, toRow, toCell) {
      if (toRow === undefined && toCell === undefined) {
        toRow = fromRow;
        toCell = fromCell;
      }

      /***
       * @property fromRow
       * @type {Integer}
       */
      this.fromRow = Math.min(fromRow, toRow);

      /***
       * @property fromCell
       * @type {Integer}
       */
      this.fromCell = Math.min(fromCell, toCell);

      /***
       * @property toRow
       * @type {Integer}
       */
      this.toRow = Math.max(fromRow, toRow);

      /***
       * @property toCell
       * @type {Integer}
       */
      this.toCell = Math.max(fromCell, toCell);

      /***
       * Returns whether a range represents a single row.
       * @method isSingleRow
       * @return {Boolean}
       */
      this.isSingleRow = function () {
        return this.fromRow == this.toRow;
      };

      /***
       * Returns whether a range represents a single cell.
       * @method isSingleCell
       * @return {Boolean}
       */
      this.isSingleCell = function () {
        return this.fromRow == this.toRow && this.fromCell == this.toCell;
      };

      /***
       * Returns whether a range contains a given cell.
       * @method contains
       * @param row {Integer}
       * @param cell {Integer}
       * @return {Boolean}
       */
      this.contains = function (row, cell) {
        return row >= this.fromRow && row <= this.toRow && cell >= this.fromCell && cell <= this.toCell;
      };

      /***
       * Returns a readable representation of a range.
       * @method toString
       * @return {String}
       */
      this.toString = function () {
        if (this.isSingleCell()) {
          return '(' + this.fromRow + ':' + this.fromCell + ')';
        } else {
          return '(' + this.fromRow + ':' + this.fromCell + ' - ' + this.toRow + ':' + this.toCell + ')';
        }
      };
    }

    /***
     * A base class that all special / non-data rows (like Group and GroupTotals) derive from.
     * @class NonDataItem
     * @constructor
     */
    function NonDataItem() {
      this.__nonDataRow = true;
    }

    /***
     * Information about a group of rows.
     * @class Group
     * @extends Slick.NonDataItem
     * @constructor
     */
    function Group() {
      this.__group = true;

      /**
       * Grouping level, starting with 0.
       * @property level
       * @type {Number}
       */
      this.level = 0;

      /***
       * Number of rows in the group.
       * @property count
       * @type {Integer}
       */
      this.count = 0;

      /***
       * Grouping value.
       * @property value
       * @type {Object}
       */
      this.value = null;

      /***
       * Formatted display value of the group.
       * @property title
       * @type {String}
       */
      this.title = null;

      /***
       * Whether a group is collapsed.
       * @property collapsed
       * @type {Boolean}
       */
      this.collapsed = false;

      /***
       * GroupTotals, if any.
       * @property totals
       * @type {GroupTotals}
       */
      this.totals = null;

      /**
       * Rows that are part of the group.
       * @property rows
       * @type {Array}
       */
      this.rows = [];

      /**
       * Sub-groups that are part of the group.
       * @property groups
       * @type {Array}
       */
      this.groups = null;

      /**
       * A unique key used to identify the group.  This key can be used in calls to DataView
       * collapseGroup() or expandGroup().
       * @property groupingKey
       * @type {Object}
       */
      this.groupingKey = null;
    }

    Group.prototype = new NonDataItem();

    /***
     * Compares two Group instances.
     * @method equals
     * @return {Boolean}
     * @param group {Group} Group instance to compare to.
     */
    Group.prototype.equals = function (group) {
      return (
        this.value === group.value &&
        this.count === group.count &&
        this.collapsed === group.collapsed &&
        this.title === group.title
      );
    };

    /***
     * Information about group totals.
     * An instance of GroupTotals will be created for each totals row and passed to the aggregators
     * so that they can store arbitrary data in it.  That data can later be accessed by group totals
     * formatters during the display.
     * @class GroupTotals
     * @extends Slick.NonDataItem
     * @constructor
     */
    function GroupTotals() {
      this.__groupTotals = true;

      /***
       * Parent Group.
       * @param group
       * @type {Group}
       */
      this.group = null;

      /***
       * Whether the totals have been fully initialized / calculated.
       * Will be set to false for lazy-calculated group totals.
       * @param initialized
       * @type {Boolean}
       */
      this.initialized = false;
    }

    GroupTotals.prototype = new NonDataItem();

    /***
     * A locking helper to track the active edit controller and ensure that only a single controller
     * can be active at a time.  This prevents a whole class of state and validation synchronization
     * issues.  An edit controller (such as SlickGrid) can query if an active edit is in progress
     * and attempt a commit or cancel before proceeding.
     * @class EditorLock
     * @constructor
     */
    function EditorLock() {
      var activeEditController = null;

      /***
       * Returns true if a specified edit controller is active (has the edit lock).
       * If the parameter is not specified, returns true if any edit controller is active.
       * @method isActive
       * @param editController {EditController}
       * @return {Boolean}
       */
      this.isActive = function (editController) {
        return editController ? activeEditController === editController : activeEditController !== null;
      };

      /***
       * Sets the specified edit controller as the active edit controller (acquire edit lock).
       * If another edit controller is already active, and exception will be thrown.
       * @method activate
       * @param editController {EditController} edit controller acquiring the lock
       */
      this.activate = function (editController) {
        if (editController === activeEditController) {
          // already activated?
          return;
        }
        if (activeEditController !== null) {
          throw "SlickGrid.EditorLock.activate: an editController is still active, can't activate another editController";
        }
        if (!editController.commitCurrentEdit) {
          throw 'SlickGrid.EditorLock.activate: editController must implement .commitCurrentEdit()';
        }
        if (!editController.cancelCurrentEdit) {
          throw 'SlickGrid.EditorLock.activate: editController must implement .cancelCurrentEdit()';
        }
        activeEditController = editController;
      };

      /***
       * Unsets the specified edit controller as the active edit controller (release edit lock).
       * If the specified edit controller is not the active one, an exception will be thrown.
       * @method deactivate
       * @param editController {EditController} edit controller releasing the lock
       */
      this.deactivate = function (editController) {
        if (activeEditController !== editController) {
          throw 'SlickGrid.EditorLock.deactivate: specified editController is not the currently active one';
        }
        activeEditController = null;
      };

      /***
       * Attempts to commit the current edit by calling "commitCurrentEdit" method on the active edit
       * controller and returns whether the commit attempt was successful (commit may fail due to validation
       * errors, etc.).  Edit controller's "commitCurrentEdit" must return true if the commit has succeeded
       * and false otherwise.  If no edit controller is active, returns true.
       * @method commitCurrentEdit
       * @return {Boolean}
       */
      this.commitCurrentEdit = function () {
        return activeEditController ? activeEditController.commitCurrentEdit() : true;
      };

      /***
       * Attempts to cancel the current edit by calling "cancelCurrentEdit" method on the active edit
       * controller and returns whether the edit was successfully cancelled.  If no edit controller is
       * active, returns true.
       * @method cancelCurrentEdit
       * @return {Boolean}
       */
      this.cancelCurrentEdit = function cancelCurrentEdit() {
        return activeEditController ? activeEditController.cancelCurrentEdit() : true;
      };
    }
  })(jQuery);

  /***
   * Contains basic SlickGrid editors.
   * @module Editors
   * @namespace Slick
   */

  (function ($) {
    // register namespace
    $.extend(true, window, {
      Slick: {
        Editors: {
          Text: TextEditor,
          Integer: IntegerEditor,
          Date: DateEditor,
          YesNoSelect: YesNoSelectEditor,
          Checkbox: CheckboxEditor,
          PercentComplete: PercentCompleteEditor,
          LongText: LongTextEditor,
        },
      },
    });

    function TextEditor(args) {
      var $input;
      var defaultValue;
      var scope = this;

      this.init = function () {
        $input = $("<INPUT type=text class='editor-text' />")
          .appendTo(args.container)
          .bind('keydown.nav', function (e) {
            if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT) {
              e.stopImmediatePropagation();
            }
          })
          .focus()
          .select();
      };

      this.destroy = function () {
        $input.remove();
      };

      this.focus = function () {
        $input.focus();
      };

      this.getValue = function () {
        return $input.val();
      };

      this.setValue = function (val) {
        $input.val(val);
      };

      this.loadValue = function (item) {
        defaultValue = item[args.column.field] || '';
        $input.val(defaultValue);
        $input[0].defaultValue = defaultValue;
        $input.select();
      };

      this.serializeValue = function () {
        return $input.val();
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return !($input.val() == '' && defaultValue == null) && $input.val() != defaultValue;
      };

      this.validate = function () {
        if (args.column.validator) {
          var validationResults = args.column.validator($input.val());
          if (!validationResults.valid) {
            return validationResults;
          }
        }

        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }

    function IntegerEditor(args) {
      var $input;
      var defaultValue;
      var scope = this;

      this.init = function () {
        $input = $("<INPUT type=text class='editor-text' />");

        $input.bind('keydown.nav', function (e) {
          if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT) {
            e.stopImmediatePropagation();
          }
        });

        $input.appendTo(args.container);
        $input.focus().select();
      };

      this.destroy = function () {
        $input.remove();
      };

      this.focus = function () {
        $input.focus();
      };

      this.loadValue = function (item) {
        defaultValue = item[args.column.field];
        $input.val(defaultValue);
        $input[0].defaultValue = defaultValue;
        $input.select();
      };

      this.serializeValue = function () {
        return parseInt($input.val(), 10) || 0;
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return !($input.val() == '' && defaultValue == null) && $input.val() != defaultValue;
      };

      this.validate = function () {
        if (isNaN($input.val())) {
          return {
            valid: false,
            msg: 'Please enter a valid integer',
          };
        }

        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }

    function DateEditor(args) {
      var $input;
      var defaultValue;
      var scope = this;
      var calendarOpen = false;

      this.init = function () {
        $input = $("<INPUT type=text class='editor-text' />");
        $input.appendTo(args.container);
        $input.focus().select();
        $input.datepicker({
          showOn: 'button',
          buttonImageOnly: true,
          buttonImage: '../images/calendar.gif',
          beforeShow: function () {
            calendarOpen = true;
          },
          onClose: function () {
            calendarOpen = false;
          },
        });
        $input.width($input.width() - 18);
      };

      this.destroy = function () {
        $.datepicker.dpDiv.stop(true, true);
        $input.datepicker('hide');
        $input.datepicker('destroy');
        $input.remove();
      };

      this.show = function () {
        if (calendarOpen) {
          $.datepicker.dpDiv.stop(true, true).show();
        }
      };

      this.hide = function () {
        if (calendarOpen) {
          $.datepicker.dpDiv.stop(true, true).hide();
        }
      };

      this.position = function (position) {
        if (!calendarOpen) {
          return;
        }
        $.datepicker.dpDiv.css('top', position.top + 30).css('left', position.left);
      };

      this.focus = function () {
        $input.focus();
      };

      this.loadValue = function (item) {
        defaultValue = item[args.column.field];
        $input.val(defaultValue);
        $input[0].defaultValue = defaultValue;
        $input.select();
      };

      this.serializeValue = function () {
        return $input.val();
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return !($input.val() == '' && defaultValue == null) && $input.val() != defaultValue;
      };

      this.validate = function () {
        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }

    function YesNoSelectEditor(args) {
      var $select;
      var defaultValue;
      var scope = this;

      this.init = function () {
        $select = $(
          "<SELECT tabIndex='0' class='editor-yesno'><OPTION value='yes'>Yes</OPTION><OPTION value='no'>No</OPTION></SELECT>",
        );
        $select.appendTo(args.container);
        $select.focus();
      };

      this.destroy = function () {
        $select.remove();
      };

      this.focus = function () {
        $select.focus();
      };

      this.loadValue = function (item) {
        $select.val((defaultValue = item[args.column.field]) ? 'yes' : 'no');
        $select.select();
      };

      this.serializeValue = function () {
        return $select.val() == 'yes';
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return $select.val() != defaultValue;
      };

      this.validate = function () {
        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }

    function CheckboxEditor(args) {
      var $select;
      var defaultValue;
      var scope = this;

      this.init = function () {
        $select = $("<INPUT type=checkbox value='true' class='editor-checkbox' hideFocus>");
        $select.appendTo(args.container);
        $select.focus();
      };

      this.destroy = function () {
        $select.remove();
      };

      this.focus = function () {
        $select.focus();
      };

      this.loadValue = function (item) {
        defaultValue = !!item[args.column.field];
        if (defaultValue) {
          $select.prop('checked', true);
        } else {
          $select.prop('checked', false);
        }
      };

      this.serializeValue = function () {
        return $select.prop('checked');
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return this.serializeValue() !== defaultValue;
      };

      this.validate = function () {
        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }

    function PercentCompleteEditor(args) {
      var $input, $picker;
      var defaultValue;
      var scope = this;

      this.init = function () {
        $input = $("<INPUT type=text class='editor-percentcomplete' />");
        $input.width($(args.container).innerWidth() - 25);
        $input.appendTo(args.container);

        $picker = $("<div class='editor-percentcomplete-picker' />").appendTo(args.container);
        $picker.append(
          "<div class='editor-percentcomplete-helper'><div class='editor-percentcomplete-wrapper'><div class='editor-percentcomplete-slider' /><div class='editor-percentcomplete-buttons' /></div></div>",
        );

        $picker
          .find('.editor-percentcomplete-buttons')
          .append(
            '<button val=0>Not started</button><br/><button val=50>In Progress</button><br/><button val=100>Complete</button>',
          );

        $input.focus().select();

        $picker.find('.editor-percentcomplete-slider').slider({
          orientation: 'vertical',
          range: 'min',
          value: defaultValue,
          slide: function (event, ui) {
            $input.val(ui.value);
          },
        });

        $picker.find('.editor-percentcomplete-buttons button').bind('click', function (e) {
          $input.val($(this).attr('val'));
          $picker.find('.editor-percentcomplete-slider').slider('value', $(this).attr('val'));
        });
      };

      this.destroy = function () {
        $input.remove();
        $picker.remove();
      };

      this.focus = function () {
        $input.focus();
      };

      this.loadValue = function (item) {
        $input.val((defaultValue = item[args.column.field]));
        $input.select();
      };

      this.serializeValue = function () {
        return parseInt($input.val(), 10) || 0;
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return !($input.val() == '' && defaultValue == null) && (parseInt($input.val(), 10) || 0) != defaultValue;
      };

      this.validate = function () {
        if (isNaN(parseInt($input.val(), 10))) {
          return {
            valid: false,
            msg: 'Please enter a valid positive number',
          };
        }

        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }

    /*
     * An example of a "detached" editor.
     * The UI is added onto document BODY and .position(), .show() and .hide() are implemented.
     * KeyDown events are also handled to provide handling for Tab, Shift-Tab, Esc and Ctrl-Enter.
     */
    function LongTextEditor(args) {
      var $input, $wrapper;
      var defaultValue;
      var scope = this;

      this.init = function () {
        var $container = $('body');

        $wrapper = $(
          "<DIV style='z-index:10000;position:absolute;background:white;padding:5px;border:3px solid gray; -moz-border-radius:10px; border-radius:10px;'/>",
        ).appendTo($container);

        $input = $(
          "<TEXTAREA hidefocus rows=5 style='backround:white;width:250px;height:80px;border:0;outline:0'>",
        ).appendTo($wrapper);

        $("<DIV style='text-align:right'><BUTTON>Save</BUTTON><BUTTON>Cancel</BUTTON></DIV>").appendTo($wrapper);

        $wrapper.find('button:first').bind('click', this.save);
        $wrapper.find('button:last').bind('click', this.cancel);
        $input.bind('keydown', this.handleKeyDown);

        scope.position(args.position);
        $input.focus().select();
      };

      this.handleKeyDown = function (e) {
        if (e.which == $.ui.keyCode.ENTER && e.ctrlKey) {
          scope.save();
        } else if (e.which == $.ui.keyCode.ESCAPE) {
          e.preventDefault();
          scope.cancel();
        } else if (e.which == $.ui.keyCode.TAB && e.shiftKey) {
          e.preventDefault();
          args.grid.navigatePrev();
        } else if (e.which == $.ui.keyCode.TAB) {
          e.preventDefault();
          args.grid.navigateNext();
        }
      };

      this.save = function () {
        args.commitChanges();
      };

      this.cancel = function () {
        $input.val(defaultValue);
        args.cancelChanges();
      };

      this.hide = function () {
        $wrapper.hide();
      };

      this.show = function () {
        $wrapper.show();
      };

      this.position = function (position) {
        $wrapper.css('top', position.top - 5).css('left', position.left - 5);
      };

      this.destroy = function () {
        $wrapper.remove();
      };

      this.focus = function () {
        $input.focus();
      };

      this.loadValue = function (item) {
        $input.val((defaultValue = item[args.column.field]));
        $input.select();
      };

      this.serializeValue = function () {
        return $input.val();
      };

      this.applyValue = function (item, state) {
        item[args.column.field] = state;
      };

      this.isValueChanged = function () {
        return !($input.val() == '' && defaultValue == null) && $input.val() != defaultValue;
      };

      this.validate = function () {
        return {
          valid: true,
          msg: null,
        };
      };

      this.init();
    }
  })(jQuery);

  /***
   * Contains basic SlickGrid formatters.
   *
   * NOTE:  These are merely examples.  You will most likely need to implement something more
   *        robust/extensible/localizable/etc. for your use!
   *
   * @module Formatters
   * @namespace Slick
   */

  (function ($) {
    // register namespace
    $.extend(true, window, {
      Slick: {
        Formatters: {
          PercentComplete: PercentCompleteFormatter,
          PercentCompleteBar: PercentCompleteBarFormatter,
          YesNo: YesNoFormatter,
          Checkmark: CheckmarkFormatter,
        },
      },
    });

    function PercentCompleteFormatter(row, cell, value, columnDef, dataContext) {
      if (value == null || value === '') {
        return '-';
      } else if (value < 50) {
        return "<span style='color:red;font-weight:bold;'>" + value + '%</span>';
      } else {
        return "<span style='color:green'>" + value + '%</span>';
      }
    }

    function PercentCompleteBarFormatter(row, cell, value, columnDef, dataContext) {
      if (value == null || value === '') {
        return '';
      }

      var color;

      if (value < 30) {
        color = 'red';
      } else if (value < 70) {
        color = 'silver';
      } else {
        color = 'green';
      }

      return "<span class='percent-complete-bar' style='background:" + color + ';width:' + value + "%'></span>";
    }

    function YesNoFormatter(row, cell, value, columnDef, dataContext) {
      return value ? 'Yes' : 'No';
    }

    function CheckmarkFormatter(row, cell, value, columnDef, dataContext) {
      return value ? "<img src='../images/tick.png'>" : '';
    }
  })(jQuery);

  (function ($) {
    // register namespace
    $.extend(true, window, {
      Slick: {
        RowSelectionModel: RowSelectionModel,
      },
    });

    function RowSelectionModel(options) {
      var _grid;
      var _ranges = [];
      var _self = this;
      var _handler = new Slick.EventHandler();
      var _inHandler;
      var _options;
      var _defaults = {
        selectActiveRow: true,
      };

      function init(grid) {
        _options = $.extend(true, {}, _defaults, options);
        _grid = grid;
        _handler.subscribe(_grid.onActiveCellChanged, wrapHandler(handleActiveCellChange));
        _handler.subscribe(_grid.onKeyDown, wrapHandler(handleKeyDown));
        _handler.subscribe(_grid.onClick, wrapHandler(handleClick));
      }

      function destroy() {
        _handler.unsubscribeAll();
      }

      function wrapHandler(handler) {
        return function () {
          if (!_inHandler) {
            _inHandler = true;
            handler.apply(this, arguments);
            _inHandler = false;
          }
        };
      }

      function rangesToRows(ranges) {
        var rows = [];
        for (var i = 0; i < ranges.length; i++) {
          for (var j = ranges[i].fromRow; j <= ranges[i].toRow; j++) {
            rows.push(j);
          }
        }
        return rows;
      }

      function rowsToRanges(rows) {
        var ranges = [];
        var lastCell = _grid.getColumns().length - 1;
        for (var i = 0; i < rows.length; i++) {
          ranges.push(new Slick.Range(rows[i], 0, rows[i], lastCell));
        }
        return ranges;
      }

      function getRowsRange(from, to) {
        var i,
          rows = [];
        for (i = from; i <= to; i++) {
          rows.push(i);
        }
        for (i = to; i < from; i++) {
          rows.push(i);
        }
        return rows;
      }

      function getSelectedRows() {
        return rangesToRows(_ranges);
      }

      function setSelectedRows(rows) {
        setSelectedRanges(rowsToRanges(rows));
      }

      function setSelectedRanges(ranges) {
        _ranges = ranges;
        _self.onSelectedRangesChanged.notify(_ranges);
      }

      function getSelectedRanges() {
        return _ranges;
      }

      function handleActiveCellChange(e, data) {
        if (_options.selectActiveRow && data.row != null) {
          setSelectedRanges([new Slick.Range(data.row, 0, data.row, _grid.getColumns().length - 1)]);
        }
      }

      function handleKeyDown(e) {
        var activeRow = _grid.getActiveCell();
        if (activeRow && e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey && (e.which == 38 || e.which == 40)) {
          var selectedRows = getSelectedRows();
          selectedRows.sort(function (x, y) {
            return x - y;
          });

          if (!selectedRows.length) {
            selectedRows = [activeRow.row];
          }

          var top = selectedRows[0];
          var bottom = selectedRows[selectedRows.length - 1];
          var active;

          if (e.which == 40) {
            active = activeRow.row < bottom || top == bottom ? ++bottom : ++top;
          } else {
            active = activeRow.row < bottom ? --bottom : --top;
          }

          if (active >= 0 && active < _grid.getDataLength()) {
            _grid.scrollRowIntoView(active);
            _ranges = rowsToRanges(getRowsRange(top, bottom));
            setSelectedRanges(_ranges);
          }

          e.preventDefault();
          e.stopPropagation();
        }
      }

      function handleClick(e) {
        var cell = _grid.getCellFromEvent(e);
        if (!cell || !_grid.canCellBeActive(cell.row, cell.cell)) {
          return false;
        }

        if (!_grid.getOptions().multiSelect || (!e.ctrlKey && !e.shiftKey && !e.metaKey)) {
          return false;
        }

        var selection = rangesToRows(_ranges);
        var idx = $.inArray(cell.row, selection);

        if (idx === -1 && (e.ctrlKey || e.metaKey)) {
          selection.push(cell.row);
          _grid.setActiveCell(cell.row, cell.cell);
        } else if (idx !== -1 && (e.ctrlKey || e.metaKey)) {
          selection = $.grep(selection, function (o, i) {
            return o !== cell.row;
          });
          _grid.setActiveCell(cell.row, cell.cell);
        } else if (selection.length && e.shiftKey) {
          var last = selection.pop();
          var from = Math.min(cell.row, last);
          var to = Math.max(cell.row, last);
          selection = [];
          for (var i = from; i <= to; i++) {
            if (i !== last) {
              selection.push(i);
            }
          }
          selection.push(last);
          _grid.setActiveCell(cell.row, cell.cell);
        }

        _ranges = rowsToRanges(selection);
        setSelectedRanges(_ranges);
        e.stopImmediatePropagation();

        return true;
      }

      $.extend(this, {
        getSelectedRows: getSelectedRows,
        setSelectedRows: setSelectedRows,

        getSelectedRanges: getSelectedRanges,
        setSelectedRanges: setSelectedRanges,

        init: init,
        destroy: destroy,

        onSelectedRangesChanged: new Slick.Event(),
      });
    }
  })(jQuery);

  /**
   * @license
   * (c) 2009-2013 Michael Leibman
   * michael{dot}leibman{at}gmail{dot}com
   * http://github.com/mleibman/slickgrid
   *
   * Distributed under MIT license.
   * All rights reserved.
   *
   * SlickGrid v2.2
   *
   * NOTES:
   *     Cell/row DOM manipulations are done directly bypassing jQuery's DOM manipulation methods.
   *     This increases the speed dramatically, but can only be done safely because there are no event handlers
   *     or data associated with any cell/row DOM nodes.  Cell editors must make sure they implement .destroy()
   *     and do proper cleanup.
   */

  // make sure required JavaScript modules are loaded
  if (typeof jQuery === 'undefined') {
    throw 'SlickGrid requires jquery module to be loaded';
  }
  if (!jQuery.fn.drag) {
    throw 'SlickGrid requires jquery.event.drag module to be loaded';
  }
  if (typeof Slick === 'undefined') {
    throw 'slick.core.js not loaded';
  }

  (function ($) {
    // Slick.Grid
    $.extend(true, window, {
      Slick: {
        Grid: SlickGrid,
      },
    });

    // shared across all grids on the page
    var scrollbarDimensions;
    var maxSupportedCssHeight; // browser's breaking point

    //////////////////////////////////////////////////////////////////////////////////////////////
    // SlickGrid class implementation (available as Slick.Grid)

    /**
     * Creates a new instance of the grid.
     * @class SlickGrid
     * @constructor
     * @param {Node}              container   Container node to create the grid in.
     * @param {Array,Object}      data        An array of objects for databinding.
     * @param {Array}             columns     An array of column definitions.
     * @param {Object}            options     Grid options.
     **/
    function SlickGrid(container, data, columns, options) {
      // settings
      var defaults = {
        explicitInitialization: false,
        rowHeight: 25,
        defaultColumnWidth: 80,
        enableAddRow: false,
        leaveSpaceForNewRows: false,
        editable: false,
        autoEdit: true,
        enableCellNavigation: true,
        enableColumnReorder: true,
        asyncEditorLoading: false,
        asyncEditorLoadDelay: 100,
        forceFitColumns: false,
        enableAsyncPostRender: false,
        asyncPostRenderDelay: 50,
        autoHeight: false,
        editorLock: Slick.GlobalEditorLock,
        showHeaderRow: false,
        headerRowHeight: 25,
        showTopPanel: false,
        topPanelHeight: 25,
        formatterFactory: null,
        editorFactory: null,
        cellFlashingCssClass: 'flashing',
        selectedCellCssClass: 'selected',
        multiSelect: true,
        enableTextSelectionOnCells: false,
        dataItemColumnValueExtractor: null,
        fullWidthRows: false,
        multiColumnSort: false,
        defaultFormatter: defaultFormatter,
        forceSyncScrolling: false,
        addNewRowCssClass: 'new-row',
      };

      var columnDefaults = {
        name: '',
        resizable: true,
        sortable: false,
        minWidth: 30,
        rerenderOnResize: false,
        headerCssClass: null,
        defaultSortAsc: true,
        focusable: true,
        selectable: true,
      };

      // scroller
      var th; // virtual height
      var h; // real scrollable height
      var ph; // page height
      var n; // number of pages
      var cj; // "jumpiness" coefficient

      var page = 0; // current page
      var offset = 0; // current page offset
      var vScrollDir = 1;

      // private
      var initialized = false;
      var $container;
      var uid = 'slickgrid_' + Math.round(1000000 * Math.random());
      var self = this;
      var $focusSink, $focusSink2;
      var $headerScroller;
      var $headers;
      var $headerRow, $headerRowScroller, $headerRowSpacer;
      var $topPanelScroller;
      var $topPanel;
      var $viewport;
      var $canvas;
      var $style;
      var $boundAncestors;
      var stylesheet, columnCssRulesL, columnCssRulesR;
      var viewportH, viewportW;
      var canvasWidth;
      var viewportHasHScroll, viewportHasVScroll;
      var headerColumnWidthDiff = 0,
        headerColumnHeightDiff = 0, // border+padding
        cellWidthDiff = 0,
        cellHeightDiff = 0;
      var absoluteColumnMinWidth;

      var tabbingDirection = 1;
      var activePosX;
      var activeRow, activeCell;
      var activeCellNode = null;
      var currentEditor = null;
      var serializedEditorValue;
      var editController;

      var rowsCache = {};
      var renderedRows = 0;
      var numVisibleRows;
      var prevScrollTop = 0;
      var scrollTop = 0;
      var lastRenderedScrollTop = 0;
      var lastRenderedScrollLeft = 0;
      var prevScrollLeft = 0;
      var scrollLeft = 0;

      var selectionModel;
      var selectedRows = [];

      var plugins = [];
      var cellCssClasses = {};

      var columnsById = {};
      var sortColumns = [];
      var columnPosLeft = [];
      var columnPosRight = [];

      // async call handles
      var h_editorLoader = null;
      var h_render = null;
      var h_postrender = null;
      var postProcessedRows = {};
      var postProcessToRow = null;
      var postProcessFromRow = null;

      // perf counters
      var counter_rows_rendered = 0;
      var counter_rows_removed = 0;

      // These two variables work around a bug with inertial scrolling in Webkit/Blink on Mac.
      // See http://crbug.com/312427.
      var rowNodeFromLastMouseWheelEvent; // this node must not be deleted while inertial scrolling
      var zombieRowNodeFromLastMouseWheelEvent; // node that was hidden instead of getting deleted

      //////////////////////////////////////////////////////////////////////////////////////////////
      // Initialization

      function init() {
        $container = $(container);
        if ($container.length < 1) {
          throw new Error('SlickGrid requires a valid container, ' + container + ' does not exist in the DOM.');
        }

        // calculate these only once and share between grid instances
        maxSupportedCssHeight = maxSupportedCssHeight || getMaxSupportedCssHeight();
        scrollbarDimensions = scrollbarDimensions || measureScrollbar();

        options = $.extend({}, defaults, options);
        validateAndEnforceOptions();
        columnDefaults.width = options.defaultColumnWidth;

        columnsById = {};
        for (var i = 0; i < columns.length; i++) {
          var m = (columns[i] = $.extend({}, columnDefaults, columns[i]));
          columnsById[m.id] = i;
          if (m.minWidth && m.width < m.minWidth) {
            m.width = m.minWidth;
          }
          if (m.maxWidth && m.width > m.maxWidth) {
            m.width = m.maxWidth;
          }
        }

        // validate loaded JavaScript modules against requested options
        if (options.enableColumnReorder && !$.fn.sortable) {
          throw new Error(
            "SlickGrid's 'enableColumnReorder = true' option requires jquery-ui.sortable module to be loaded",
          );
        }

        editController = {
          commitCurrentEdit: commitCurrentEdit,
          cancelCurrentEdit: cancelCurrentEdit,
        };

        $container.empty().css('overflow', 'hidden').css('outline', 0).addClass(uid).addClass('ui-widget');

        // set up a positioning container if needed
        if (!/relative|absolute|fixed/.test($container.css('position'))) {
          $container.css('position', 'relative');
        }

        $focusSink = $(
          "<div tabIndex='0' hideFocus style='position:fixed;width:0;height:0;top:0;left:0;outline:0;'></div>",
        ).appendTo($container);

        $headerScroller = $(
          "<div class='slick-header ui-state-default' style='overflow:hidden;position:relative;' />",
        ).appendTo($container);
        $headers = $("<div class='slick-header-columns' style='left:-1000px' />").appendTo($headerScroller);
        $headers.width(getHeadersWidth());

        $headerRowScroller = $(
          "<div class='slick-headerrow ui-state-default' style='overflow:hidden;position:relative;' />",
        ).appendTo($container);
        $headerRow = $("<div class='slick-headerrow-columns' />").appendTo($headerRowScroller);
        $headerRowSpacer = $("<div style='display:block;height:1px;position:absolute;top:0;left:0;'></div>")
          .css('width', getCanvasWidth() + scrollbarDimensions.width + 'px')
          .appendTo($headerRowScroller);

        $topPanelScroller = $(
          "<div class='slick-top-panel-scroller ui-state-default' style='overflow:hidden;position:relative;' />",
        ).appendTo($container);
        $topPanel = $("<div class='slick-top-panel' style='width:10000px' />").appendTo($topPanelScroller);

        if (!options.showTopPanel) {
          $topPanelScroller.hide();
        }

        if (!options.showHeaderRow) {
          $headerRowScroller.hide();
        }

        $viewport = $(
          "<div class='slick-viewport' style='width:100%;overflow:auto;outline:0;position:relative;;'>",
        ).appendTo($container);
        $viewport.css('overflow-y', options.autoHeight ? 'hidden' : 'auto');

        $canvas = $("<div class='grid-canvas' />").appendTo($viewport);

        $focusSink2 = $focusSink.clone().appendTo($container);

        if (!options.explicitInitialization) {
          finishInitialization();
        }
      }

      function finishInitialization() {
        if (!initialized) {
          initialized = true;

          viewportW = parseFloat($.css($container[0], 'width', true));

          // header columns and cells may have different padding/border skewing width calculations (box-sizing, hello?)
          // calculate the diff so we can set consistent sizes
          measureCellPaddingAndBorder();

          // for usability reasons, all text selection in SlickGrid is disabled
          // with the exception of input and textarea elements (selection must
          // be enabled there so that editors work as expected); note that
          // selection in grid cells (grid body) is already unavailable in
          // all browsers except IE
          disableSelection($headers); // disable all text selection in header (including input and textarea)

          if (!options.enableTextSelectionOnCells) {
            // disable text selection in grid cells except in input and textarea elements
            // (this is IE-specific, because selectstart event will only fire in IE)
            $viewport.bind('selectstart.ui', function (event) {
              return $(event.target).is('input,textarea');
            });
          }

          updateColumnCaches();
          createColumnHeaders();
          setupColumnSort();
          createCssRules();
          resizeCanvas();
          bindAncestorScrollEvents();

          $container.bind('resize.slickgrid', resizeCanvas);
          $viewport
            //.bind("click", handleClick)
            .bind('scroll', handleScroll);
          $headerScroller
            .bind('contextmenu', handleHeaderContextMenu)
            .bind('click', handleHeaderClick)
            .delegate('.slick-header-column', 'mouseenter', handleHeaderMouseEnter)
            .delegate('.slick-header-column', 'mouseleave', handleHeaderMouseLeave);
          $headerRowScroller.bind('scroll', handleHeaderRowScroll);
          $focusSink.add($focusSink2).bind('keydown', handleKeyDown);
          $canvas
            .bind('keydown', handleKeyDown)
            .bind('click', handleClick)
            .bind('dblclick', handleDblClick)
            .bind('contextmenu', handleContextMenu)
            .bind('draginit', handleDragInit)
            .bind('dragstart', { distance: 3 }, handleDragStart)
            .bind('drag', handleDrag)
            .bind('dragend', handleDragEnd)
            .delegate('.slick-cell', 'mouseenter', handleMouseEnter)
            .delegate('.slick-cell', 'mouseleave', handleMouseLeave);

          // Work around http://crbug.com/312427.
          if (
            navigator.userAgent.toLowerCase().match(/webkit/) &&
            navigator.userAgent.toLowerCase().match(/macintosh/)
          ) {
            $canvas.bind('mousewheel', handleMouseWheel);
          }
        }
      }

      function registerPlugin(plugin) {
        plugins.unshift(plugin);
        plugin.init(self);
      }

      function unregisterPlugin(plugin) {
        for (var i = plugins.length; i >= 0; i--) {
          if (plugins[i] === plugin) {
            if (plugins[i].destroy) {
              plugins[i].destroy();
            }
            plugins.splice(i, 1);
            break;
          }
        }
      }

      function setSelectionModel(model) {
        if (selectionModel) {
          selectionModel.onSelectedRangesChanged.unsubscribe(handleSelectedRangesChanged);
          if (selectionModel.destroy) {
            selectionModel.destroy();
          }
        }

        selectionModel = model;
        if (selectionModel) {
          selectionModel.init(self);
          selectionModel.onSelectedRangesChanged.subscribe(handleSelectedRangesChanged);
        }
      }

      function getSelectionModel() {
        return selectionModel;
      }

      function getCanvasNode() {
        return $canvas[0];
      }

      function measureScrollbar() {
        var $c = $(
          "<div style='position:absolute; top:-10000px; left:-10000px; width:100px; height:100px; overflow:scroll;'></div>",
        ).appendTo('body');
        var dim = {
          width: $c.width() - $c[0].clientWidth,
          height: $c.height() - $c[0].clientHeight,
        };
        $c.remove();
        return dim;
      }

      function getHeadersWidth() {
        var headersWidth = 0;
        for (var i = 0, ii = columns.length; i < ii; i++) {
          var width = columns[i].width;
          headersWidth += width;
        }
        headersWidth += scrollbarDimensions.width;
        return Math.max(headersWidth, viewportW) + 1000;
      }

      function getCanvasWidth() {
        var availableWidth = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW;
        var rowWidth = 0;
        var i = columns.length;
        while (i--) {
          rowWidth += columns[i].width;
        }
        return options.fullWidthRows ? Math.max(rowWidth, availableWidth) : rowWidth;
      }

      function updateCanvasWidth(forceColumnWidthsUpdate) {
        var oldCanvasWidth = canvasWidth;
        canvasWidth = getCanvasWidth();

        if (canvasWidth != oldCanvasWidth) {
          $canvas.width(canvasWidth);
          $headerRow.width(canvasWidth);
          $headers.width(getHeadersWidth());
          viewportHasHScroll = canvasWidth > viewportW - scrollbarDimensions.width;
        }

        $headerRowSpacer.width(canvasWidth + (viewportHasVScroll ? scrollbarDimensions.width : 0));

        if (canvasWidth != oldCanvasWidth || forceColumnWidthsUpdate) {
          applyColumnWidths();
        }
      }

      function disableSelection($target) {
        if ($target && $target.jquery) {
          $target
            .attr('unselectable', 'on')
            .css('MozUserSelect', 'none')
            .bind('selectstart.ui', function () {
              return false;
            }); // from jquery:ui.core.js 1.7.2
        }
      }

      function getMaxSupportedCssHeight() {
        var supportedHeight = 1000000;
        // FF reports the height back but still renders blank after ~6M px
        var testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6000000 : 1000000000;
        var div = $("<div style='display:none' />").appendTo(document.body);

        while (true) {
          var test = supportedHeight * 2;
          div.css('height', test);
          if (test > testUpTo || div.height() !== test) {
            break;
          } else {
            supportedHeight = test;
          }
        }

        div.remove();
        return supportedHeight;
      }

      // TODO:  this is static.  need to handle page mutation.
      function bindAncestorScrollEvents() {
        var elem = $canvas[0];
        while ((elem = elem.parentNode) != document.body && elem != null) {
          // bind to scroll containers only
          if (elem == $viewport[0] || elem.scrollWidth != elem.clientWidth || elem.scrollHeight != elem.clientHeight) {
            var $elem = $(elem);
            if (!$boundAncestors) {
              $boundAncestors = $elem;
            } else {
              $boundAncestors = $boundAncestors.add($elem);
            }
            $elem.bind('scroll.' + uid, handleActiveCellPositionChange);
          }
        }
      }

      function unbindAncestorScrollEvents() {
        if (!$boundAncestors) {
          return;
        }
        $boundAncestors.unbind('scroll.' + uid);
        $boundAncestors = null;
      }

      function updateColumnHeader(columnId, title, toolTip) {
        if (!initialized) {
          return;
        }
        var idx = getColumnIndex(columnId);
        if (idx == null) {
          return;
        }

        var columnDef = columns[idx];
        var $header = $headers.children().eq(idx);
        if ($header) {
          if (title !== undefined) {
            columns[idx].name = title;
          }
          if (toolTip !== undefined) {
            columns[idx].toolTip = toolTip;
          }

          trigger(self.onBeforeHeaderCellDestroy, {
            node: $header[0],
            column: columnDef,
          });

          $header
            .attr('title', toolTip || '')
            .children()
            .eq(0)
            .html(title);

          trigger(self.onHeaderCellRendered, {
            node: $header[0],
            column: columnDef,
          });
        }
      }

      function getHeaderRow() {
        return $headerRow[0];
      }

      function getHeaderRowColumn(columnId) {
        var idx = getColumnIndex(columnId);
        var $header = $headerRow.children().eq(idx);
        return $header && $header[0];
      }

      function createColumnHeaders() {
        function onMouseEnter() {
          $(this).addClass('ui-state-hover');
        }

        function onMouseLeave() {
          $(this).removeClass('ui-state-hover');
        }

        $headers.find('.slick-header-column').each(function () {
          var columnDef = $(this).data('column');
          if (columnDef) {
            trigger(self.onBeforeHeaderCellDestroy, {
              node: this,
              column: columnDef,
            });
          }
        });
        $headers.empty();
        $headers.width(getHeadersWidth());

        $headerRow.find('.slick-headerrow-column').each(function () {
          var columnDef = $(this).data('column');
          if (columnDef) {
            trigger(self.onBeforeHeaderRowCellDestroy, {
              node: this,
              column: columnDef,
            });
          }
        });
        $headerRow.empty();

        for (var i = 0; i < columns.length; i++) {
          var m = columns[i];

          var header = $("<div class='ui-state-default slick-header-column' />")
            .html("<span class='slick-column-name'>" + m.name + '</span>')
            .width(m.width - headerColumnWidthDiff)
            .attr('id', '' + uid + m.id)
            .attr('title', m.toolTip || '')
            .data('column', m)
            .addClass(m.headerCssClass || '')
            .appendTo($headers);

          if (options.enableColumnReorder || m.sortable) {
            header.on('mouseenter', onMouseEnter).on('mouseleave', onMouseLeave);
          }

          if (m.sortable) {
            header.addClass('slick-header-sortable');
            header.append("<span class='slick-sort-indicator' />");
          }

          trigger(self.onHeaderCellRendered, {
            node: header[0],
            column: m,
          });

          if (options.showHeaderRow) {
            var headerRowCell = $("<div class='ui-state-default slick-headerrow-column l" + i + ' r' + i + "'></div>")
              .data('column', m)
              .appendTo($headerRow);

            trigger(self.onHeaderRowCellRendered, {
              node: headerRowCell[0],
              column: m,
            });
          }
        }

        setSortColumns(sortColumns);
        setupColumnResize();
        if (options.enableColumnReorder) {
          setupColumnReorder();
        }
      }

      var sortingEnabled = true; // #20181119-01 - delay sort click
      function setupColumnSort() {
        $headers.click(function (e) {
          // #20181119-01 - delay sort click - Start
          if (!sortingEnabled) {
            return;
          }

          setTimeout(function () {
            sortingEnabled = true;
          }, 300);

          sortingEnabled = false;
          // #20181119-01 - delay sort click - End

          // temporary workaround for a bug in jQuery 1.7.1 (http://bugs.jquery.com/ticket/11328)
          e.metaKey = e.metaKey || e.ctrlKey;

          if ($(e.target).hasClass('slick-resizable-handle')) {
            return;
          }

          var $col = $(e.target).closest('.slick-header-column');
          if (!$col.length) {
            return;
          }

          var column = $col.data('column');
          if (column.sortable) {
            if (!getEditorLock().commitCurrentEdit()) {
              return;
            }

            var sortOpts = null;
            var i = 0;
            for (; i < sortColumns.length; i++) {
              if (sortColumns[i].columnId == column.id) {
                sortOpts = sortColumns[i];
                sortOpts.sortAsc = !sortOpts.sortAsc;
                break;
              }
            }

            if (e.metaKey && options.multiColumnSort) {
              if (sortOpts) {
                sortColumns.splice(i, 1);
              }
            } else {
              if ((!e.shiftKey && !e.metaKey) || !options.multiColumnSort) {
                sortColumns = [];
              }

              if (!sortOpts) {
                sortOpts = { columnId: column.id, sortAsc: column.defaultSortAsc };
                sortColumns.push(sortOpts);
              } else if (sortColumns.length == 0) {
                sortColumns.push(sortOpts);
              }
            }

            setSortColumns(sortColumns);

            if (!options.multiColumnSort) {
              trigger(
                self.onSort,
                {
                  multiColumnSort: false,
                  sortCol: column,
                  sortAsc: sortOpts.sortAsc,
                },
                e,
              );
            } else {
              trigger(
                self.onSort,
                {
                  multiColumnSort: true,
                  sortCols: $.map(sortColumns, function (col) {
                    return { sortCol: columns[getColumnIndex(col.columnId)], sortAsc: col.sortAsc };
                  }),
                },
                e,
              );
            }
          }
        });
      }

      function setupColumnReorder() {
        $headers.filter(':ui-sortable').sortable('destroy');
        $headers.sortable({
          containment: 'parent',
          distance: 3,
          axis: 'x',
          cursor: 'default',
          tolerance: 'intersection',
          helper: 'clone',
          placeholder: 'slick-sortable-placeholder ui-state-default slick-header-column',
          start: function (e, ui) {
            ui.placeholder.width(ui.helper.outerWidth() - headerColumnWidthDiff);
            $(ui.helper).addClass('slick-header-column-active');
          },
          beforeStop: function (e, ui) {
            $(ui.helper).removeClass('slick-header-column-active');
          },
          stop: function (e) {
            if (!getEditorLock().commitCurrentEdit()) {
              $(this).sortable('cancel');
              return;
            }

            var reorderedIds = $headers.sortable('toArray');
            var reorderedColumns = [];
            for (var i = 0; i < reorderedIds.length; i++) {
              reorderedColumns.push(columns[getColumnIndex(reorderedIds[i].replace(uid, ''))]);
            }
            setColumns(reorderedColumns);

            trigger(self.onColumnsReordered, {});
            e.stopPropagation();
            setupColumnResize();
          },
        });
      }

      function setupColumnResize() {
        var $col, j, c, pageX, columnElements, minPageX, maxPageX, firstResizable, lastResizable;
        columnElements = $headers.children();
        columnElements.find('.slick-resizable-handle').remove();
        columnElements.each(function (i, e) {
          if (columns[i].resizable) {
            if (firstResizable === undefined) {
              firstResizable = i;
            }
            lastResizable = i;
          }
        });
        if (firstResizable === undefined) {
          return;
        }
        columnElements.each(function (i, e) {
          if (i < firstResizable || (options.forceFitColumns && i >= lastResizable)) {
            return;
          }
          $col = $(e);
          $("<div class='slick-resizable-handle' />")
            .appendTo(e)
            .bind('dragstart', function (e, dd) {
              if (!getEditorLock().commitCurrentEdit()) {
                return false;
              }
              pageX = e.pageX;
              $(this).parent().addClass('slick-header-column-active');
              var shrinkLeewayOnRight = null,
                stretchLeewayOnRight = null;
              // lock each column's width option to current width
              columnElements.each(function (i, e) {
                columns[i].previousWidth = $(e).outerWidth();
              });
              if (options.forceFitColumns) {
                shrinkLeewayOnRight = 0;
                stretchLeewayOnRight = 0;
                // colums on right affect maxPageX/minPageX
                for (j = i + 1; j < columnElements.length; j++) {
                  c = columns[j];
                  if (c.resizable) {
                    if (stretchLeewayOnRight !== null) {
                      if (c.maxWidth) {
                        stretchLeewayOnRight += c.maxWidth - c.previousWidth;
                      } else {
                        stretchLeewayOnRight = null;
                      }
                    }
                    shrinkLeewayOnRight += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                  }
                }
              }
              var shrinkLeewayOnLeft = 0,
                stretchLeewayOnLeft = 0;
              for (j = 0; j <= i; j++) {
                // columns on left only affect minPageX
                c = columns[j];
                if (c.resizable) {
                  if (stretchLeewayOnLeft !== null) {
                    if (c.maxWidth) {
                      stretchLeewayOnLeft += c.maxWidth - c.previousWidth;
                    } else {
                      stretchLeewayOnLeft = null;
                    }
                  }
                  shrinkLeewayOnLeft += c.previousWidth - Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                }
              }
              if (shrinkLeewayOnRight === null) {
                shrinkLeewayOnRight = 100000;
              }
              if (shrinkLeewayOnLeft === null) {
                shrinkLeewayOnLeft = 100000;
              }
              if (stretchLeewayOnRight === null) {
                stretchLeewayOnRight = 100000;
              }
              if (stretchLeewayOnLeft === null) {
                stretchLeewayOnLeft = 100000;
              }
              maxPageX = pageX + Math.min(shrinkLeewayOnRight, stretchLeewayOnLeft);
              minPageX = pageX - Math.min(shrinkLeewayOnLeft, stretchLeewayOnRight);
            })
            .bind('drag', function (e, dd) {
              var actualMinWidth,
                d = Math.min(maxPageX, Math.max(minPageX, e.pageX)) - pageX,
                x;
              if (d < 0) {
                // shrink column
                x = d;
                for (j = i; j >= 0; j--) {
                  c = columns[j];
                  if (c.resizable) {
                    actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                    if (x && c.previousWidth + x < actualMinWidth) {
                      x += c.previousWidth - actualMinWidth;
                      c.width = actualMinWidth;
                    } else {
                      c.width = c.previousWidth + x;
                      x = 0;
                    }
                  }
                }

                if (options.forceFitColumns) {
                  x = -d;
                  for (j = i + 1; j < columnElements.length; j++) {
                    c = columns[j];
                    if (c.resizable) {
                      if (x && c.maxWidth && c.maxWidth - c.previousWidth < x) {
                        x -= c.maxWidth - c.previousWidth;
                        c.width = c.maxWidth;
                      } else {
                        c.width = c.previousWidth + x;
                        x = 0;
                      }
                    }
                  }
                }
              } else {
                // stretch column
                x = d;
                for (j = i; j >= 0; j--) {
                  c = columns[j];
                  if (c.resizable) {
                    if (x && c.maxWidth && c.maxWidth - c.previousWidth < x) {
                      x -= c.maxWidth - c.previousWidth;
                      c.width = c.maxWidth;
                    } else {
                      c.width = c.previousWidth + x;
                      x = 0;
                    }
                  }
                }

                if (options.forceFitColumns) {
                  x = -d;
                  for (j = i + 1; j < columnElements.length; j++) {
                    c = columns[j];
                    if (c.resizable) {
                      actualMinWidth = Math.max(c.minWidth || 0, absoluteColumnMinWidth);
                      if (x && c.previousWidth + x < actualMinWidth) {
                        x += c.previousWidth - actualMinWidth;
                        c.width = actualMinWidth;
                      } else {
                        c.width = c.previousWidth + x;
                        x = 0;
                      }
                    }
                  }
                }
              }
              applyColumnHeaderWidths();
              if (options.syncColumnCellResize) {
                applyColumnWidths();
              }
            })
            .bind('dragend', function (e, dd) {
              var newWidth;
              $(this).parent().removeClass('slick-header-column-active');
              for (j = 0; j < columnElements.length; j++) {
                c = columns[j];
                newWidth = $(columnElements[j]).outerWidth();

                if (c.previousWidth !== newWidth && c.rerenderOnResize) {
                  invalidateAllRows();
                }
              }
              updateCanvasWidth(true);
              render();
              trigger(self.onColumnsResized, {});
            });
        });
      }

      function getVBoxDelta($el) {
        var p = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'];
        var delta = 0;
        $.each(p, function (n, val) {
          delta += parseFloat($el.css(val)) || 0;
        });
        return delta;
      }

      function measureCellPaddingAndBorder() {
        var el;
        var h = ['borderLeftWidth', 'borderRightWidth', 'paddingLeft', 'paddingRight'];
        var v = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'];

        el = $("<div class='ui-state-default slick-header-column' style='visibility:hidden'>-</div>").appendTo(
          $headers,
        );
        headerColumnWidthDiff = headerColumnHeightDiff = 0;
        if (
          el.css('box-sizing') != 'border-box' &&
          el.css('-moz-box-sizing') != 'border-box' &&
          el.css('-webkit-box-sizing') != 'border-box'
        ) {
          $.each(h, function (n, val) {
            headerColumnWidthDiff += parseFloat(el.css(val)) || 0;
          });
          $.each(v, function (n, val) {
            headerColumnHeightDiff += parseFloat(el.css(val)) || 0;
          });
        }
        el.remove();

        var r = $("<div class='slick-row' />").appendTo($canvas);
        el = $("<div class='slick-cell' id='' style='visibility:hidden'>-</div>").appendTo(r);
        cellWidthDiff = cellHeightDiff = 0;
        if (
          el.css('box-sizing') != 'border-box' &&
          el.css('-moz-box-sizing') != 'border-box' &&
          el.css('-webkit-box-sizing') != 'border-box'
        ) {
          $.each(h, function (n, val) {
            cellWidthDiff += parseFloat(el.css(val)) || 0;
          });
          $.each(v, function (n, val) {
            cellHeightDiff += parseFloat(el.css(val)) || 0;
          });
        }
        r.remove();

        absoluteColumnMinWidth = Math.max(headerColumnWidthDiff, cellWidthDiff);
      }

      function createCssRules() {
        $style = $("<style type='text/css' rel='stylesheet' />").appendTo($('head'));
        var rowHeight = options.rowHeight - cellHeightDiff;
        var rules = [
          '.' + uid + ' .slick-header-column { left: 1000px; }',
          '.' + uid + ' .slick-top-panel { height:' + options.topPanelHeight + 'px; }',
          '.' + uid + ' .slick-headerrow-columns { height:' + options.headerRowHeight + 'px; }',
          '.' + uid + ' .slick-cell { height:' + rowHeight + 'px; }',
          '.' + uid + ' .slick-row { height:' + options.rowHeight + 'px; }',
        ];

        for (var i = 0; i < columns.length; i++) {
          rules.push('.' + uid + ' .l' + i + ' { }');
          rules.push('.' + uid + ' .r' + i + ' { }');
        }

        if ($style[0].styleSheet) {
          // IE
          $style[0].styleSheet.cssText = rules.join(' ');
        } else {
          $style[0].appendChild(document.createTextNode(rules.join(' ')));
        }
      }

      function getColumnCssRules(idx) {
        if (!stylesheet) {
          var sheets = document.styleSheets;
          for (var i = 0; i < sheets.length; i++) {
            if ((sheets[i].ownerNode || sheets[i].owningElement) == $style[0]) {
              stylesheet = sheets[i];
              break;
            }
          }

          if (!stylesheet) {
            throw new Error('Cannot find stylesheet.');
          }

          // find and cache column CSS rules
          columnCssRulesL = [];
          columnCssRulesR = [];
          var cssRules = stylesheet.cssRules || stylesheet.rules;
          var matches, columnIdx;
          for (var i = 0; i < cssRules.length; i++) {
            var selector = cssRules[i].selectorText;
            if ((matches = /\.l\d+/.exec(selector))) {
              columnIdx = parseInt(matches[0].substr(2, matches[0].length - 2), 10);
              columnCssRulesL[columnIdx] = cssRules[i];
            } else if ((matches = /\.r\d+/.exec(selector))) {
              columnIdx = parseInt(matches[0].substr(2, matches[0].length - 2), 10);
              columnCssRulesR[columnIdx] = cssRules[i];
            }
          }
        }

        return {
          left: columnCssRulesL[idx],
          right: columnCssRulesR[idx],
        };
      }

      function removeCssRules() {
        $style.remove();
        stylesheet = null;
      }

      function destroy() {
        getEditorLock().cancelCurrentEdit();

        trigger(self.onBeforeDestroy, {});

        var i = plugins.length;
        while (i--) {
          unregisterPlugin(plugins[i]);
        }

        if (options.enableColumnReorder) {
          $headers.filter(':ui-sortable').sortable('destroy');
        }

        unbindAncestorScrollEvents();
        $container.unbind('.slickgrid');
        removeCssRules();

        $canvas.unbind('draginit dragstart dragend drag');
        $container.empty().removeClass(uid);
      }

      //////////////////////////////////////////////////////////////////////////////////////////////
      // General

      function trigger(evt, args, e) {
        e = e || new Slick.EventData();
        args = args || {};
        args.grid = self;
        return evt.notify(args, e, self);
      }

      function getEditorLock() {
        return options.editorLock;
      }

      function getEditController() {
        return editController;
      }

      function getColumnIndex(id) {
        return columnsById[id];
      }

      function autosizeColumns() {
        var i,
          c,
          widths = [],
          shrinkLeeway = 0,
          total = 0,
          prevTotal,
          availWidth = viewportHasVScroll ? viewportW - scrollbarDimensions.width : viewportW;

        for (i = 0; i < columns.length; i++) {
          c = columns[i];
          widths.push(c.width);
          total += c.width;
          if (c.resizable) {
            shrinkLeeway += c.width - Math.max(c.minWidth, absoluteColumnMinWidth);
          }
        }

        // shrink
        prevTotal = total;
        while (total > availWidth && shrinkLeeway) {
          var shrinkProportion = (total - availWidth) / shrinkLeeway;
          for (i = 0; i < columns.length && total > availWidth; i++) {
            c = columns[i];
            var width = widths[i];
            if (!c.resizable || width <= c.minWidth || width <= absoluteColumnMinWidth) {
              continue;
            }
            var absMinWidth = Math.max(c.minWidth, absoluteColumnMinWidth);
            var shrinkSize = Math.floor(shrinkProportion * (width - absMinWidth)) || 1;
            shrinkSize = Math.min(shrinkSize, width - absMinWidth);
            total -= shrinkSize;
            shrinkLeeway -= shrinkSize;
            widths[i] -= shrinkSize;
          }
          if (prevTotal <= total) {
            // avoid infinite loop
            break;
          }
          prevTotal = total;
        }

        // grow
        prevTotal = total;
        while (total < availWidth) {
          var growProportion = availWidth / total;
          for (i = 0; i < columns.length && total < availWidth; i++) {
            c = columns[i];
            var currentWidth = widths[i];
            var growSize;

            if (!c.resizable || c.maxWidth <= currentWidth) {
              growSize = 0;
            } else {
              growSize =
                Math.min(
                  Math.floor(growProportion * currentWidth) - currentWidth,
                  c.maxWidth - currentWidth || 1000000,
                ) || 1;
            }
            total += growSize;
            widths[i] += growSize;
          }
          if (prevTotal >= total) {
            // avoid infinite loop
            break;
          }
          prevTotal = total;
        }

        var reRender = false;
        for (i = 0; i < columns.length; i++) {
          if (columns[i].rerenderOnResize && columns[i].width != widths[i]) {
            reRender = true;
          }
          columns[i].width = widths[i];
        }

        applyColumnHeaderWidths();
        updateCanvasWidth(true);
        if (reRender) {
          invalidateAllRows();
          render();
        }
      }

      function applyColumnHeaderWidths() {
        if (!initialized) {
          return;
        }
        var h;
        for (var i = 0, headers = $headers.children(), ii = headers.length; i < ii; i++) {
          h = $(headers[i]);
          if (h.width() !== columns[i].width - headerColumnWidthDiff) {
            h.width(columns[i].width - headerColumnWidthDiff);
          }
        }

        updateColumnCaches();
      }

      function applyColumnWidths() {
        var x = 0,
          w,
          rule;
        for (var i = 0; i < columns.length; i++) {
          w = columns[i].width;

          rule = getColumnCssRules(i);
          rule.left.style.left = x + 'px';
          rule.right.style.right = canvasWidth - x - w + 'px';

          x += columns[i].width;
        }
      }

      function setSortColumn(columnId, ascending) {
        setSortColumns([{ columnId: columnId, sortAsc: ascending }]);
      }

      function setSortColumns(cols) {
        sortColumns = cols;

        var headerColumnEls = $headers.children();
        headerColumnEls
          .removeClass('slick-header-column-sorted')
          .find('.slick-sort-indicator')
          .removeClass('slick-sort-indicator-asc slick-sort-indicator-desc');

        $.each(sortColumns, function (i, col) {
          if (col.sortAsc == null) {
            col.sortAsc = true;
          }
          var columnIndex = getColumnIndex(col.columnId);
          if (columnIndex != null) {
            headerColumnEls
              .eq(columnIndex)
              .addClass('slick-header-column-sorted')
              .find('.slick-sort-indicator')
              .addClass(col.sortAsc ? 'slick-sort-indicator-asc' : 'slick-sort-indicator-desc');
          }
        });
      }

      function getSortColumns() {
        return sortColumns;
      }

      function handleSelectedRangesChanged(e, ranges) {
        selectedRows = [];
        var hash = {};
        for (var i = 0; i < ranges.length; i++) {
          for (var j = ranges[i].fromRow; j <= ranges[i].toRow; j++) {
            if (!hash[j]) {
              // prevent duplicates
              selectedRows.push(j);
              hash[j] = {};
            }
            for (var k = ranges[i].fromCell; k <= ranges[i].toCell; k++) {
              if (canCellBeSelected(j, k)) {
                hash[j][columns[k].id] = options.selectedCellCssClass;
              }
            }
          }
        }

        setCellCssStyles(options.selectedCellCssClass, hash);

        trigger(self.onSelectedRowsChanged, { rows: getSelectedRows() }, e);
      }

      function getColumns() {
        return columns;
      }

      function updateColumnCaches() {
        // Pre-calculate cell boundaries.
        columnPosLeft = [];
        columnPosRight = [];
        var x = 0;
        for (var i = 0, ii = columns.length; i < ii; i++) {
          columnPosLeft[i] = x;
          columnPosRight[i] = x + columns[i].width;
          x += columns[i].width;
        }
      }

      function setColumns(columnDefinitions) {
        columns = columnDefinitions;

        columnsById = {};
        for (var i = 0; i < columns.length; i++) {
          var m = (columns[i] = $.extend({}, columnDefaults, columns[i]));
          columnsById[m.id] = i;
          if (m.minWidth && m.width < m.minWidth) {
            m.width = m.minWidth;
          }
          if (m.maxWidth && m.width > m.maxWidth) {
            m.width = m.maxWidth;
          }
        }

        updateColumnCaches();

        if (initialized) {
          invalidateAllRows();
          createColumnHeaders();
          removeCssRules();
          createCssRules();
          resizeCanvas();
          applyColumnWidths();
          handleScroll();
        }
      }

      function getOptions() {
        return options;
      }

      function setOptions(args) {
        if (!getEditorLock().commitCurrentEdit()) {
          return;
        }

        makeActiveCellNormal();

        if (options.enableAddRow !== args.enableAddRow) {
          invalidateRow(getDataLength());
        }

        options = $.extend(options, args);
        validateAndEnforceOptions();

        $viewport.css('overflow-y', options.autoHeight ? 'hidden' : 'auto');
        render();
      }

      function validateAndEnforceOptions() {
        if (options.autoHeight) {
          options.leaveSpaceForNewRows = false;
        }
      }

      function setData(newData, scrollToTop) {
        data = newData;
        invalidateAllRows();
        updateRowCount();
        if (scrollToTop) {
          scrollTo(0);
        }
      }

      function getData() {
        return data;
      }

      function getDataLength() {
        if (data.getLength) {
          return data.getLength();
        } else {
          return data.length;
        }
      }

      function getDataLengthIncludingAddNew() {
        return getDataLength() + (options.enableAddRow ? 1 : 0);
      }

      function getDataItem(i) {
        if (data.getItem) {
          return data.getItem(i);
        } else {
          return data[i];
        }
      }

      function getTopPanel() {
        return $topPanel[0];
      }

      function setTopPanelVisibility(visible) {
        if (options.showTopPanel != visible) {
          options.showTopPanel = visible;
          if (visible) {
            $topPanelScroller.slideDown('fast', resizeCanvas);
          } else {
            $topPanelScroller.slideUp('fast', resizeCanvas);
          }
        }
      }

      function setHeaderRowVisibility(visible) {
        if (options.showHeaderRow != visible) {
          options.showHeaderRow = visible;
          if (visible) {
            $headerRowScroller.slideDown('fast', resizeCanvas);
          } else {
            $headerRowScroller.slideUp('fast', resizeCanvas);
          }
        }
      }

      function getContainerNode() {
        return $container.get(0);
      }

      //////////////////////////////////////////////////////////////////////////////////////////////
      // Rendering / Scrolling

      function getRowTop(row) {
        return options.rowHeight * row - offset;
      }

      function getRowFromPosition(y) {
        return Math.floor((y + offset) / options.rowHeight);
      }

      function scrollTo(y) {
        y = Math.max(y, 0);
        y = Math.min(y, th - viewportH + (viewportHasHScroll ? scrollbarDimensions.height : 0));

        var oldOffset = offset;

        page = Math.min(n - 1, Math.floor(y / ph));
        offset = Math.round(page * cj);
        var newScrollTop = y - offset;

        if (offset != oldOffset) {
          var range = getVisibleRange(newScrollTop);
          cleanupRows(range);
          updateRowPositions();
        }

        if (prevScrollTop != newScrollTop) {
          vScrollDir = prevScrollTop + oldOffset < newScrollTop + offset ? 1 : -1;
          $viewport[0].scrollTop = lastRenderedScrollTop = scrollTop = prevScrollTop = newScrollTop;

          trigger(self.onViewportChanged, {});
        }
      }

      function defaultFormatter(row, cell, value, columnDef, dataContext) {
        if (value == null) {
          return '';
        } else {
          return (value + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
      }

      function getFormatter(row, column) {
        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);

        // look up by id, then index
        var columnOverrides =
          rowMetadata &&
          rowMetadata.columns &&
          (rowMetadata.columns[column.id] || rowMetadata.columns[getColumnIndex(column.id)]);

        return (
          (columnOverrides && columnOverrides.formatter) ||
          (rowMetadata && rowMetadata.formatter) ||
          column.formatter ||
          (options.formatterFactory && options.formatterFactory.getFormatter(column)) ||
          options.defaultFormatter
        );
      }

      function getEditor(row, cell) {
        var column = columns[cell];
        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        var columnMetadata = rowMetadata && rowMetadata.columns;

        if (columnMetadata && columnMetadata[column.id] && columnMetadata[column.id].editor !== undefined) {
          return columnMetadata[column.id].editor;
        }
        if (columnMetadata && columnMetadata[cell] && columnMetadata[cell].editor !== undefined) {
          return columnMetadata[cell].editor;
        }

        return column.editor || (options.editorFactory && options.editorFactory.getEditor(column));
      }

      function getDataItemValueForColumn(item, columnDef) {
        if (options.dataItemColumnValueExtractor) {
          return options.dataItemColumnValueExtractor(item, columnDef);
        }
        return item[columnDef.field];
      }

      function appendRowHtml(stringArray, row, range, dataLength) {
        var d = getDataItem(row);
        var dataLoading = row < dataLength && !d;
        var rowCss =
          'slick-row' +
          (dataLoading ? ' loading' : '') +
          (row === activeRow ? ' active' : '') +
          (row % 2 == 1 ? ' odd' : ' even') +
          (row === dataLength - 1 ? ' last' : ''); // #20181119-02 : 마지막 줄 클래스 추가

        if (!d) {
          rowCss += ' ' + options.addNewRowCssClass;
        }

        var metadata = data.getItemMetadata && data.getItemMetadata(row);

        if (metadata && metadata.cssClasses) {
          rowCss += ' ' + metadata.cssClasses;
        }

        stringArray.push("<div class='ui-widget-content " + rowCss + "' style='top:" + getRowTop(row) + "px'>");

        var colspan, m;
        for (var i = 0, ii = columns.length; i < ii; i++) {
          m = columns[i];
          colspan = 1;
          if (metadata && metadata.columns) {
            var columnData = metadata.columns[m.id] || metadata.columns[i];
            colspan = (columnData && columnData.colspan) || 1;
            if (colspan === '*') {
              colspan = ii - i;
            }
          }

          // Do not render cells outside of the viewport.
          if (columnPosRight[Math.min(ii - 1, i + colspan - 1)] > range.leftPx) {
            if (columnPosLeft[i] > range.rightPx) {
              // All columns to the right are outside the range.
              break;
            }

            appendCellHtml(stringArray, row, i, colspan, d);
          }

          if (colspan > 1) {
            i += colspan - 1;
          }
        }

        stringArray.push('</div>');
      }

      function appendCellHtml(stringArray, row, cell, colspan, item) {
        var m = columns[cell];
        var cellCss =
          'slick-cell l' +
          cell +
          ' r' +
          Math.min(columns.length - 1, cell + colspan - 1) +
          (m.cssClass ? ' ' + m.cssClass : '');
        if (row === activeRow && cell === activeCell) {
          cellCss += ' active';
        }

        // TODO:  merge them together in the setter
        for (var key in cellCssClasses) {
          if (cellCssClasses[key][row] && cellCssClasses[key][row][m.id]) {
            cellCss += ' ' + cellCssClasses[key][row][m.id];
          }
        }

        stringArray.push("<div class='" + cellCss + "'>");

        // if there is a corresponding row (if not, this is the Add New row or this data hasn't been loaded yet)
        if (item) {
          var value = getDataItemValueForColumn(item, m);
          stringArray.push(getFormatter(row, m)(row, cell, value, m, item));
        }

        stringArray.push('</div>');

        rowsCache[row].cellRenderQueue.push(cell);
        rowsCache[row].cellColSpans[cell] = colspan;
      }

      function cleanupRows(rangeToKeep) {
        for (var i in rowsCache) {
          if ((i = parseInt(i, 10)) !== activeRow && (i < rangeToKeep.top || i > rangeToKeep.bottom)) {
            removeRowFromCache(i);
          }
        }
      }

      function invalidate() {
        updateRowCount();
        invalidateAllRows();
        render();
      }

      function invalidateAllRows() {
        if (currentEditor) {
          makeActiveCellNormal();
        }
        for (var row in rowsCache) {
          removeRowFromCache(row);
        }
      }

      function removeRowFromCache(row) {
        var cacheEntry = rowsCache[row];
        if (!cacheEntry) {
          return;
        }

        if (rowNodeFromLastMouseWheelEvent == cacheEntry.rowNode) {
          cacheEntry.rowNode.style.display = 'none';
          zombieRowNodeFromLastMouseWheelEvent = rowNodeFromLastMouseWheelEvent;
        } else {
          $canvas[0].removeChild(cacheEntry.rowNode);
        }

        delete rowsCache[row];
        delete postProcessedRows[row];
        renderedRows--;
        counter_rows_removed++;
      }

      function invalidateRows(rows) {
        var i, rl;
        if (!rows || !rows.length) {
          return;
        }
        vScrollDir = 0;
        for (i = 0, rl = rows.length; i < rl; i++) {
          if (currentEditor && activeRow === rows[i]) {
            makeActiveCellNormal();
          }
          if (rowsCache[rows[i]]) {
            removeRowFromCache(rows[i]);
          }
        }
      }

      function invalidateRow(row) {
        invalidateRows([row]);
      }

      function updateCell(row, cell) {
        var cellNode = getCellNode(row, cell);
        if (!cellNode) {
          return;
        }

        var m = columns[cell],
          d = getDataItem(row);
        if (currentEditor && activeRow === row && activeCell === cell) {
          currentEditor.loadValue(d);
        } else {
          cellNode.innerHTML = d ? getFormatter(row, m)(row, cell, getDataItemValueForColumn(d, m), m, d) : '';
          invalidatePostProcessingResults(row);
        }
      }

      function updateRow(row) {
        var cacheEntry = rowsCache[row];
        if (!cacheEntry) {
          return;
        }

        ensureCellNodesInRowsCache(row);

        var d = getDataItem(row);

        for (var columnIdx in cacheEntry.cellNodesByColumnIdx) {
          if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(columnIdx)) {
            continue;
          }

          columnIdx = columnIdx | 0;
          var m = columns[columnIdx],
            node = cacheEntry.cellNodesByColumnIdx[columnIdx];

          if (row === activeRow && columnIdx === activeCell && currentEditor) {
            currentEditor.loadValue(d);
          } else if (d) {
            node.innerHTML = getFormatter(row, m)(row, columnIdx, getDataItemValueForColumn(d, m), m, d);
          } else {
            node.innerHTML = '';
          }
        }

        invalidatePostProcessingResults(row);
      }

      function getViewportHeight() {
        return (
          parseFloat($.css($container[0], 'height', true)) -
          parseFloat($.css($container[0], 'paddingTop', true)) -
          parseFloat($.css($container[0], 'paddingBottom', true)) -
          parseFloat($.css($headerScroller[0], 'height')) -
          getVBoxDelta($headerScroller) -
          (options.showTopPanel ? options.topPanelHeight + getVBoxDelta($topPanelScroller) : 0) -
          (options.showHeaderRow ? options.headerRowHeight + getVBoxDelta($headerRowScroller) : 0)
        );
      }

      function resizeCanvas() {
        if (!initialized) {
          return;
        }
        if (options.autoHeight) {
          viewportH = options.rowHeight * getDataLengthIncludingAddNew();
        } else {
          viewportH = getViewportHeight();
        }

        numVisibleRows = Math.ceil(viewportH / options.rowHeight);
        viewportW = parseFloat($.css($container[0], 'width', true));
        if (!options.autoHeight) {
          $viewport.height(viewportH);
        }

        if (options.forceFitColumns) {
          autosizeColumns();
        }

        updateRowCount();
        handleScroll();
        // Since the width has changed, force the render() to reevaluate virtually rendered cells.
        lastRenderedScrollLeft = -1;
        render();
      }

      function updateRowCount() {
        if (!initialized) {
          return;
        }

        var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
        var numberOfRows = dataLengthIncludingAddNew + (options.leaveSpaceForNewRows ? numVisibleRows - 1 : 0);

        var oldViewportHasVScroll = viewportHasVScroll;
        // with autoHeight, we do not need to accommodate the vertical scroll bar
        viewportHasVScroll = !options.autoHeight && numberOfRows * options.rowHeight > viewportH;

        makeActiveCellNormal();

        // remove the rows that are now outside of the data range
        // this helps avoid redundant calls to .removeRow() when the size of the data decreased by thousands of rows
        var l = dataLengthIncludingAddNew - 1;
        for (var i in rowsCache) {
          if (i >= l) {
            removeRowFromCache(i);
          }
        }

        if (activeCellNode && activeRow > l) {
          resetActiveCell();
        }

        var oldH = h;
        th = Math.max(options.rowHeight * numberOfRows, viewportH - scrollbarDimensions.height);
        if (th < maxSupportedCssHeight) {
          // just one page
          h = ph = th;
          n = 1;
          cj = 0;
        } else {
          // break into pages
          h = maxSupportedCssHeight;
          ph = h / 100;
          n = Math.floor(th / ph);
          cj = (th - h) / (n - 1);
        }

        if (h !== oldH) {
          $canvas.css('height', h);
          scrollTop = $viewport[0].scrollTop;
        }

        var oldScrollTopInRange = scrollTop + offset <= th - viewportH;

        if (th == 0 || scrollTop == 0) {
          page = offset = 0;
        } else if (oldScrollTopInRange) {
          // maintain virtual position
          scrollTo(scrollTop + offset);
        } else {
          // scroll to bottom
          scrollTo(th - viewportH);
        }

        if (h != oldH && options.autoHeight) {
          resizeCanvas();
        }

        if (options.forceFitColumns && oldViewportHasVScroll != viewportHasVScroll) {
          autosizeColumns();
        }
        updateCanvasWidth(false);
      }

      function getVisibleRange(viewportTop, viewportLeft) {
        if (viewportTop == null) {
          viewportTop = scrollTop;
        }
        if (viewportLeft == null) {
          viewportLeft = scrollLeft;
        }

        return {
          top: getRowFromPosition(viewportTop),
          bottom: getRowFromPosition(viewportTop + viewportH) + 1,
          leftPx: viewportLeft,
          rightPx: viewportLeft + viewportW,
        };
      }

      function getRenderedRange(viewportTop, viewportLeft) {
        var range = getVisibleRange(viewportTop, viewportLeft);
        var buffer = Math.round(viewportH / options.rowHeight);
        var minBuffer = 3;

        if (vScrollDir == -1) {
          range.top -= buffer;
          range.bottom += minBuffer;
        } else if (vScrollDir == 1) {
          range.top -= minBuffer;
          range.bottom += buffer;
        } else {
          range.top -= minBuffer;
          range.bottom += minBuffer;
        }

        range.top = Math.max(0, range.top);
        range.bottom = Math.min(getDataLengthIncludingAddNew() - 1, range.bottom);

        range.leftPx -= viewportW;
        range.rightPx += viewportW;

        range.leftPx = Math.max(0, range.leftPx);
        range.rightPx = Math.min(canvasWidth, range.rightPx);

        return range;
      }

      function ensureCellNodesInRowsCache(row) {
        var cacheEntry = rowsCache[row];
        if (cacheEntry) {
          if (cacheEntry.cellRenderQueue.length) {
            var lastChild = cacheEntry.rowNode.lastChild;
            while (cacheEntry.cellRenderQueue.length) {
              var columnIdx = cacheEntry.cellRenderQueue.pop();
              cacheEntry.cellNodesByColumnIdx[columnIdx] = lastChild;
              lastChild = lastChild.previousSibling;
            }
          }
        }
      }

      function cleanUpCells(range, row) {
        var totalCellsRemoved = 0;
        var cacheEntry = rowsCache[row];

        // Remove cells outside the range.
        var cellsToRemove = [];
        for (var i in cacheEntry.cellNodesByColumnIdx) {
          // I really hate it when people mess with Array.prototype.
          if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(i)) {
            continue;
          }

          // This is a string, so it needs to be cast back to a number.
          i = i | 0;

          var colspan = cacheEntry.cellColSpans[i];
          if (
            columnPosLeft[i] > range.rightPx ||
            columnPosRight[Math.min(columns.length - 1, i + colspan - 1)] < range.leftPx
          ) {
            if (!(row == activeRow && i == activeCell)) {
              cellsToRemove.push(i);
            }
          }
        }

        var cellToRemove;
        while ((cellToRemove = cellsToRemove.pop()) != null) {
          cacheEntry.rowNode.removeChild(cacheEntry.cellNodesByColumnIdx[cellToRemove]);
          delete cacheEntry.cellColSpans[cellToRemove];
          delete cacheEntry.cellNodesByColumnIdx[cellToRemove];
          if (postProcessedRows[row]) {
            delete postProcessedRows[row][cellToRemove];
          }
          totalCellsRemoved++;
        }
      }

      function cleanUpAndRenderCells(range) {
        var cacheEntry;
        var stringArray = [];
        var processedRows = [];
        var cellsAdded;
        var totalCellsAdded = 0;
        var colspan;

        for (var row = range.top, btm = range.bottom; row <= btm; row++) {
          cacheEntry = rowsCache[row];
          if (!cacheEntry) {
            continue;
          }

          // cellRenderQueue populated in renderRows() needs to be cleared first
          ensureCellNodesInRowsCache(row);

          cleanUpCells(range, row);

          // Render missing cells.
          cellsAdded = 0;

          var metadata = data.getItemMetadata && data.getItemMetadata(row);
          metadata = metadata && metadata.columns;

          var d = getDataItem(row);

          // TODO:  shorten this loop (index? heuristics? binary search?)
          for (var i = 0, ii = columns.length; i < ii; i++) {
            // Cells to the right are outside the range.
            if (columnPosLeft[i] > range.rightPx) {
              break;
            }

            // Already rendered.
            if ((colspan = cacheEntry.cellColSpans[i]) != null) {
              i += colspan > 1 ? colspan - 1 : 0;
              continue;
            }

            colspan = 1;
            if (metadata) {
              var columnData = metadata[columns[i].id] || metadata[i];
              colspan = (columnData && columnData.colspan) || 1;
              if (colspan === '*') {
                colspan = ii - i;
              }
            }

            if (columnPosRight[Math.min(ii - 1, i + colspan - 1)] > range.leftPx) {
              appendCellHtml(stringArray, row, i, colspan, d);
              cellsAdded++;
            }

            i += colspan > 1 ? colspan - 1 : 0;
          }

          if (cellsAdded) {
            totalCellsAdded += cellsAdded;
            processedRows.push(row);
          }
        }

        if (!stringArray.length) {
          return;
        }

        var x = document.createElement('div');
        x.innerHTML = stringArray.join('');

        var processedRow;
        var node;
        while ((processedRow = processedRows.pop()) != null) {
          cacheEntry = rowsCache[processedRow];
          var columnIdx;
          while ((columnIdx = cacheEntry.cellRenderQueue.pop()) != null) {
            node = x.lastChild;
            cacheEntry.rowNode.appendChild(node);
            cacheEntry.cellNodesByColumnIdx[columnIdx] = node;
          }
        }
      }

      function renderRows(range) {
        var parentNode = $canvas[0],
          stringArray = [],
          rows = [],
          needToReselectCell = false,
          dataLength = getDataLength();

        for (var i = range.top, ii = range.bottom; i <= ii; i++) {
          if (rowsCache[i]) {
            continue;
          }
          renderedRows++;
          rows.push(i);

          // Create an entry right away so that appendRowHtml() can
          // start populatating it.
          rowsCache[i] = {
            rowNode: null,

            // ColSpans of rendered cells (by column idx).
            // Can also be used for checking whether a cell has been rendered.
            cellColSpans: [],

            // Cell nodes (by column idx).  Lazy-populated by ensureCellNodesInRowsCache().
            cellNodesByColumnIdx: [],

            // Column indices of cell nodes that have been rendered, but not yet indexed in
            // cellNodesByColumnIdx.  These are in the same order as cell nodes added at the
            // end of the row.
            cellRenderQueue: [],
          };

          appendRowHtml(stringArray, i, range, dataLength);
          if (activeCellNode && activeRow === i) {
            needToReselectCell = true;
          }
          counter_rows_rendered++;
        }

        if (!rows.length) {
          return;
        }

        var x = document.createElement('div');
        x.innerHTML = stringArray.join('');

        for (var i = 0, ii = rows.length; i < ii; i++) {
          rowsCache[rows[i]].rowNode = parentNode.appendChild(x.firstChild);
        }

        if (needToReselectCell) {
          activeCellNode = getCellNode(activeRow, activeCell);
        }
      }

      function startPostProcessing() {
        if (!options.enableAsyncPostRender) {
          return;
        }
        clearTimeout(h_postrender);
        h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay);
      }

      function invalidatePostProcessingResults(row) {
        delete postProcessedRows[row];
        postProcessFromRow = Math.min(postProcessFromRow, row);
        postProcessToRow = Math.max(postProcessToRow, row);
        startPostProcessing();
      }

      function updateRowPositions() {
        for (var row in rowsCache) {
          rowsCache[row].rowNode.style.top = getRowTop(row) + 'px';
        }
      }

      function render() {
        if (!initialized) {
          return;
        }
        var visible = getVisibleRange();
        var rendered = getRenderedRange();

        // remove rows no longer in the viewport
        cleanupRows(rendered);

        // add new rows & missing cells in existing rows
        if (lastRenderedScrollLeft != scrollLeft) {
          cleanUpAndRenderCells(rendered);
        }

        // render missing rows
        renderRows(rendered);

        postProcessFromRow = visible.top;
        postProcessToRow = Math.min(getDataLengthIncludingAddNew() - 1, visible.bottom);
        startPostProcessing();

        lastRenderedScrollTop = scrollTop;
        lastRenderedScrollLeft = scrollLeft;
        h_render = null;
      }

      function handleHeaderRowScroll() {
        var scrollLeft = $headerRowScroller[0].scrollLeft;
        if (scrollLeft != $viewport[0].scrollLeft) {
          $viewport[0].scrollLeft = scrollLeft;
        }
      }

      function handleScroll() {
        scrollTop = $viewport[0].scrollTop;
        scrollLeft = $viewport[0].scrollLeft;
        var vScrollDist = Math.abs(scrollTop - prevScrollTop);
        var hScrollDist = Math.abs(scrollLeft - prevScrollLeft);

        if (hScrollDist) {
          prevScrollLeft = scrollLeft;
          $headerScroller[0].scrollLeft = scrollLeft;
          $topPanelScroller[0].scrollLeft = scrollLeft;
          $headerRowScroller[0].scrollLeft = scrollLeft;
        }

        if (vScrollDist) {
          vScrollDir = prevScrollTop < scrollTop ? 1 : -1;
          prevScrollTop = scrollTop;

          // switch virtual pages if needed
          if (vScrollDist < viewportH) {
            scrollTo(scrollTop + offset);
          } else {
            var oldOffset = offset;
            if (h == viewportH) {
              page = 0;
            } else {
              page = Math.min(n - 1, Math.floor(scrollTop * ((th - viewportH) / (h - viewportH)) * (1 / ph)));
            }
            offset = Math.round(page * cj);
            if (oldOffset != offset) {
              invalidateAllRows();
            }
          }
        }

        if (hScrollDist || vScrollDist) {
          if (h_render) {
            clearTimeout(h_render);
          }

          if (Math.abs(lastRenderedScrollTop - scrollTop) > 20 || Math.abs(lastRenderedScrollLeft - scrollLeft) > 20) {
            if (
              options.forceSyncScrolling ||
              (Math.abs(lastRenderedScrollTop - scrollTop) < viewportH &&
                Math.abs(lastRenderedScrollLeft - scrollLeft) < viewportW)
            ) {
              render();
            } else {
              render();
            }

            trigger(self.onViewportChanged, {});
          }
        }

        trigger(self.onScroll, { scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      function asyncPostProcessRows() {
        var dataLength = getDataLength();
        while (postProcessFromRow <= postProcessToRow) {
          var row = vScrollDir >= 0 ? postProcessFromRow++ : postProcessToRow--;
          var cacheEntry = rowsCache[row];
          if (!cacheEntry || row >= dataLength) {
            continue;
          }

          if (!postProcessedRows[row]) {
            postProcessedRows[row] = {};
          }

          ensureCellNodesInRowsCache(row);
          for (var columnIdx in cacheEntry.cellNodesByColumnIdx) {
            if (!cacheEntry.cellNodesByColumnIdx.hasOwnProperty(columnIdx)) {
              continue;
            }

            columnIdx = columnIdx | 0;

            var m = columns[columnIdx];
            if (m.asyncPostRender && !postProcessedRows[row][columnIdx]) {
              var node = cacheEntry.cellNodesByColumnIdx[columnIdx];
              if (node) {
                m.asyncPostRender(node, row, getDataItem(row), m);
              }
              postProcessedRows[row][columnIdx] = true;
            }
          }

          h_postrender = setTimeout(asyncPostProcessRows, options.asyncPostRenderDelay);
          return;
        }
      }

      function updateCellCssStylesOnRenderedRows(addedHash, removedHash) {
        var node, columnId, addedRowHash, removedRowHash;
        for (var row in rowsCache) {
          removedRowHash = removedHash && removedHash[row];
          addedRowHash = addedHash && addedHash[row];

          if (removedRowHash) {
            for (columnId in removedRowHash) {
              if (!addedRowHash || removedRowHash[columnId] != addedRowHash[columnId]) {
                node = getCellNode(row, getColumnIndex(columnId));
                if (node) {
                  $(node).removeClass(removedRowHash[columnId]);
                }
              }
            }
          }

          if (addedRowHash) {
            for (columnId in addedRowHash) {
              if (!removedRowHash || removedRowHash[columnId] != addedRowHash[columnId]) {
                node = getCellNode(row, getColumnIndex(columnId));
                if (node) {
                  $(node).addClass(addedRowHash[columnId]);
                }
              }
            }
          }
        }
      }

      function addCellCssStyles(key, hash) {
        if (cellCssClasses[key]) {
          throw "addCellCssStyles: cell CSS hash with key '" + key + "' already exists.";
        }

        cellCssClasses[key] = hash;
        updateCellCssStylesOnRenderedRows(hash, null);

        trigger(self.onCellCssStylesChanged, { key: key, hash: hash });
      }

      function removeCellCssStyles(key) {
        if (!cellCssClasses[key]) {
          return;
        }

        updateCellCssStylesOnRenderedRows(null, cellCssClasses[key]);
        delete cellCssClasses[key];

        trigger(self.onCellCssStylesChanged, { key: key, hash: null });
      }

      function setCellCssStyles(key, hash) {
        var prevHash = cellCssClasses[key];

        cellCssClasses[key] = hash;
        updateCellCssStylesOnRenderedRows(hash, prevHash);

        trigger(self.onCellCssStylesChanged, { key: key, hash: hash });
      }

      function getCellCssStyles(key) {
        return cellCssClasses[key];
      }

      function flashCell(row, cell, speed) {
        speed = speed || 100;
        if (rowsCache[row]) {
          var $cell = $(getCellNode(row, cell));

          function toggleCellClass(times) {
            if (!times) {
              return;
            }
            setTimeout(function () {
              $cell.queue(function () {
                $cell.toggleClass(options.cellFlashingCssClass).dequeue();
                toggleCellClass(times - 1);
              });
            }, speed);
          }

          toggleCellClass(4);
        }
      }

      //////////////////////////////////////////////////////////////////////////////////////////////
      // Interactivity

      function handleMouseWheel(e) {
        var rowNode = $(e.target).closest('.slick-row')[0];
        if (rowNode != rowNodeFromLastMouseWheelEvent) {
          if (zombieRowNodeFromLastMouseWheelEvent && zombieRowNodeFromLastMouseWheelEvent != rowNode) {
            $canvas[0].removeChild(zombieRowNodeFromLastMouseWheelEvent);
            zombieRowNodeFromLastMouseWheelEvent = null;
          }
          rowNodeFromLastMouseWheelEvent = rowNode;
        }
      }

      function handleDragInit(e, dd) {
        var cell = getCellFromEvent(e);
        if (!cell || !cellExists(cell.row, cell.cell)) {
          return false;
        }

        var retval = trigger(self.onDragInit, dd, e);
        if (e.isImmediatePropagationStopped()) {
          return retval;
        }

        // if nobody claims to be handling drag'n'drop by stopping immediate propagation,
        // cancel out of it
        return false;
      }

      function handleDragStart(e, dd) {
        var cell = getCellFromEvent(e);
        if (!cell || !cellExists(cell.row, cell.cell)) {
          return false;
        }

        var retval = trigger(self.onDragStart, dd, e);
        if (e.isImmediatePropagationStopped()) {
          return retval;
        }

        return false;
      }

      function handleDrag(e, dd) {
        return trigger(self.onDrag, dd, e);
      }

      function handleDragEnd(e, dd) {
        trigger(self.onDragEnd, dd, e);
      }

      function handleKeyDown(e) {
        trigger(self.onKeyDown, { row: activeRow, cell: activeCell }, e);
        var handled = e.isImmediatePropagationStopped();

        if (!handled) {
          if (!e.shiftKey && !e.altKey && !e.ctrlKey) {
            if (e.which == 27) {
              if (!getEditorLock().isActive()) {
                return; // no editing mode to cancel, allow bubbling and default processing (exit without cancelling the event)
              }
              cancelEditAndSetFocus();
            } else if (e.which == 34) {
              navigatePageDown();
              handled = true;
            } else if (e.which == 33) {
              navigatePageUp();
              handled = true;
            } else if (e.which == 37) {
              handled = navigateLeft();
            } else if (e.which == 39) {
              handled = navigateRight();
            } else if (e.which == 38) {
              handled = navigateUp();
            } else if (e.which == 40) {
              handled = navigateDown();
            } else if (e.which == 9) {
              handled = navigateNext();
            } else if (e.which == 13) {
              if (options.editable) {
                if (currentEditor) {
                  // adding new row
                  if (activeRow === getDataLength()) {
                    navigateDown();
                  } else {
                    commitEditAndSetFocus();
                  }
                } else {
                  if (getEditorLock().commitCurrentEdit()) {
                    makeActiveCellEditable();
                  }
                }
              }
              handled = true;
            }
          } else if (e.which == 9 && e.shiftKey && !e.ctrlKey && !e.altKey) {
            handled = navigatePrev();
          }
        }

        if (handled) {
          // the event has been handled so don't let parent element (bubbling/propagation) or browser (default) handle it
          e.stopPropagation();
          e.preventDefault();
          try {
            e.originalEvent.keyCode = 0; // prevent default behaviour for special keys in IE browsers (F3, F5, etc.)
          } catch (error) {
            // ignore exceptions - setting the original event's keycode throws access denied exception for "Ctrl"
            // (hitting control key only, nothing else), "Shift" (maybe others)
          }
        }
      }

      function handleClick(e) {
        if (!currentEditor) {
          // if this click resulted in some cell child node getting focus,
          // don't steal it back - keyboard events will still bubble up
          // IE9+ seems to default DIVs to tabIndex=0 instead of -1, so check for cell clicks directly.
          if (e.target != document.activeElement || $(e.target).hasClass('slick-cell')) {
            setFocus();
          }
        }

        var cell = getCellFromEvent(e);
        if (!cell || (currentEditor !== null && activeRow == cell.row && activeCell == cell.cell)) {
          return;
        }

        trigger(self.onClick, { row: cell.row, cell: cell.cell }, e);
        if (e.isImmediatePropagationStopped()) {
          return;
        }

        if ((activeCell != cell.cell || activeRow != cell.row) && canCellBeActive(cell.row, cell.cell)) {
          if (!getEditorLock().isActive() || getEditorLock().commitCurrentEdit()) {
            scrollRowIntoView(cell.row, false);
            setActiveCellInternal(getCellNode(cell.row, cell.cell));
          }
        }
      }

      function handleContextMenu(e) {
        var $cell = $(e.target).closest('.slick-cell', $canvas);
        if ($cell.length === 0) {
          return;
        }

        // are we editing this cell?
        if (activeCellNode === $cell[0] && currentEditor !== null) {
          return;
        }

        trigger(self.onContextMenu, {}, e);
      }

      function handleDblClick(e) {
        var cell = getCellFromEvent(e);
        if (!cell || (currentEditor !== null && activeRow == cell.row && activeCell == cell.cell)) {
          return;
        }

        trigger(self.onDblClick, { row: cell.row, cell: cell.cell }, e);
        if (e.isImmediatePropagationStopped()) {
          return;
        }

        if (options.editable) {
          gotoCell(cell.row, cell.cell, true);
        }
      }

      function handleHeaderMouseEnter(e) {
        trigger(
          self.onHeaderMouseEnter,
          {
            column: $(this).data('column'),
          },
          e,
        );
      }

      function handleHeaderMouseLeave(e) {
        trigger(
          self.onHeaderMouseLeave,
          {
            column: $(this).data('column'),
          },
          e,
        );
      }

      function handleHeaderContextMenu(e) {
        var $header = $(e.target).closest('.slick-header-column', '.slick-header-columns');
        var column = $header && $header.data('column');
        trigger(self.onHeaderContextMenu, { column: column }, e);
      }

      function handleHeaderClick(e) {
        var $header = $(e.target).closest('.slick-header-column', '.slick-header-columns');
        var column = $header && $header.data('column');
        if (column) {
          trigger(self.onHeaderClick, { column: column }, e);
        }
      }

      function handleMouseEnter(e) {
        trigger(self.onMouseEnter, {}, e);
      }

      function handleMouseLeave(e) {
        trigger(self.onMouseLeave, {}, e);
      }

      function cellExists(row, cell) {
        return !(row < 0 || row >= getDataLength() || cell < 0 || cell >= columns.length);
      }

      function getCellFromPoint(x, y) {
        var row = getRowFromPosition(y);
        var cell = 0;

        var w = 0;
        for (var i = 0; i < columns.length && w < x; i++) {
          w += columns[i].width;
          cell++;
        }

        if (cell < 0) {
          cell = 0;
        }

        return { row: row, cell: cell - 1 };
      }

      function getCellFromNode(cellNode) {
        // read column number from .l<columnNumber> CSS class
        var cls = /l\d+/.exec(cellNode.className);
        if (!cls) {
          throw 'getCellFromNode: cannot get cell - ' + cellNode.className;
        }
        return parseInt(cls[0].substr(1, cls[0].length - 1), 10);
      }

      function getRowFromNode(rowNode) {
        for (var row in rowsCache) {
          if (rowsCache[row].rowNode === rowNode) {
            return row | 0;
          }
        }

        return null;
      }

      function getCellFromEvent(e) {
        var $cell = $(e.target).closest('.slick-cell', $canvas);
        if (!$cell.length) {
          return null;
        }

        var row = getRowFromNode($cell[0].parentNode);
        var cell = getCellFromNode($cell[0]);

        if (row == null || cell == null) {
          return null;
        } else {
          return {
            row: row,
            cell: cell,
          };
        }
      }

      function getCellNodeBox(row, cell) {
        if (!cellExists(row, cell)) {
          return null;
        }

        var y1 = getRowTop(row);
        var y2 = y1 + options.rowHeight - 1;
        var x1 = 0;
        for (var i = 0; i < cell; i++) {
          x1 += columns[i].width;
        }
        var x2 = x1 + columns[cell].width;

        return {
          top: y1,
          left: x1,
          bottom: y2,
          right: x2,
        };
      }

      //////////////////////////////////////////////////////////////////////////////////////////////
      // Cell switching

      function resetActiveCell() {
        setActiveCellInternal(null, false);
      }

      function setFocus() {
        if (tabbingDirection == -1) {
          $focusSink[0].focus();
        } else {
          $focusSink2[0].focus();
        }
      }

      function scrollCellIntoView(row, cell, doPaging) {
        scrollRowIntoView(row, doPaging);

        var colspan = getColspan(row, cell);
        var left = columnPosLeft[cell],
          right = columnPosRight[cell + (colspan > 1 ? colspan - 1 : 0)],
          scrollRight = scrollLeft + viewportW;

        if (left < scrollLeft) {
          $viewport.scrollLeft(left);
          handleScroll();
          render();
        } else if (right > scrollRight) {
          $viewport.scrollLeft(Math.min(left, right - $viewport[0].clientWidth));
          handleScroll();
          render();
        }
      }

      function setActiveCellInternal(newCell, opt_editMode) {
        if (activeCellNode !== null) {
          makeActiveCellNormal();
          $(activeCellNode).removeClass('active');
          if (rowsCache[activeRow]) {
            $(rowsCache[activeRow].rowNode).removeClass('active');
          }
        }

        var activeCellChanged = activeCellNode !== newCell;
        activeCellNode = newCell;

        if (activeCellNode != null) {
          activeRow = getRowFromNode(activeCellNode.parentNode);
          activeCell = activePosX = getCellFromNode(activeCellNode);

          if (opt_editMode == null) {
            opt_editMode = activeRow == getDataLength() || options.autoEdit;
          }

          $(activeCellNode).addClass('active');
          $(rowsCache[activeRow].rowNode).addClass('active');

          if (options.editable && opt_editMode && isCellPotentiallyEditable(activeRow, activeCell)) {
            clearTimeout(h_editorLoader);

            if (options.asyncEditorLoading) {
              h_editorLoader = setTimeout(function () {
                makeActiveCellEditable();
              }, options.asyncEditorLoadDelay);
            } else {
              makeActiveCellEditable();
            }
          }
        } else {
          activeRow = activeCell = null;
        }

        if (activeCellChanged) {
          trigger(self.onActiveCellChanged, getActiveCell());
        }
      }

      function clearTextSelection() {
        if (document.selection && document.selection.empty) {
          try {
            //IE fails here if selected element is not in dom
            document.selection.empty();
          } catch (e) {}
        } else if (window.getSelection) {
          var sel = window.getSelection();
          if (sel && sel.removeAllRanges) {
            sel.removeAllRanges();
          }
        }
      }

      function isCellPotentiallyEditable(row, cell) {
        var dataLength = getDataLength();
        // is the data for this row loaded?
        if (row < dataLength && !getDataItem(row)) {
          return false;
        }

        // are we in the Add New row?  can we create new from this cell?
        if (columns[cell].cannotTriggerInsert && row >= dataLength) {
          return false;
        }

        // does this cell have an editor?
        if (!getEditor(row, cell)) {
          return false;
        }

        return true;
      }

      function makeActiveCellNormal() {
        if (!currentEditor) {
          return;
        }
        trigger(self.onBeforeCellEditorDestroy, { editor: currentEditor });
        currentEditor.destroy();
        currentEditor = null;

        if (activeCellNode) {
          var d = getDataItem(activeRow);
          $(activeCellNode).removeClass('editable invalid');
          if (d) {
            var column = columns[activeCell];
            var formatter = getFormatter(activeRow, column);
            activeCellNode.innerHTML = formatter(
              activeRow,
              activeCell,
              getDataItemValueForColumn(d, column),
              column,
              d,
            );
            invalidatePostProcessingResults(activeRow);
          }
        }

        // if there previously was text selected on a page (such as selected text in the edit cell just removed),
        // IE can't set focus to anything else correctly
        if (navigator.userAgent.toLowerCase().match(/msie/)) {
          clearTextSelection();
        }

        getEditorLock().deactivate(editController);
      }

      function makeActiveCellEditable(editor) {
        if (!activeCellNode) {
          return;
        }
        if (!options.editable) {
          throw 'Grid : makeActiveCellEditable : should never get called when options.editable is false';
        }

        // cancel pending async call if there is one
        clearTimeout(h_editorLoader);

        if (!isCellPotentiallyEditable(activeRow, activeCell)) {
          return;
        }

        var columnDef = columns[activeCell];
        var item = getDataItem(activeRow);

        if (
          trigger(self.onBeforeEditCell, { row: activeRow, cell: activeCell, item: item, column: columnDef }) === false
        ) {
          setFocus();
          return;
        }

        getEditorLock().activate(editController);
        $(activeCellNode).addClass('editable');

        // don't clear the cell if a custom editor is passed through
        if (!editor) {
          activeCellNode.innerHTML = '';
        }

        currentEditor = new (editor || getEditor(activeRow, activeCell))({
          grid: self,
          gridPosition: absBox($container[0]),
          position: absBox(activeCellNode),
          container: activeCellNode,
          column: columnDef,
          item: item || {},
          commitChanges: commitEditAndSetFocus,
          cancelChanges: cancelEditAndSetFocus,
        });

        if (item) {
          currentEditor.loadValue(item);
        }

        serializedEditorValue = currentEditor.serializeValue();

        if (currentEditor.position) {
          handleActiveCellPositionChange();
        }
      }

      function commitEditAndSetFocus() {
        // if the commit fails, it would do so due to a validation error
        // if so, do not steal the focus from the editor
        if (getEditorLock().commitCurrentEdit()) {
          setFocus();
          if (options.autoEdit) {
            navigateDown();
          }
        }
      }

      function cancelEditAndSetFocus() {
        if (getEditorLock().cancelCurrentEdit()) {
          setFocus();
        }
      }

      function absBox(elem) {
        var box = {
          top: elem.offsetTop,
          left: elem.offsetLeft,
          bottom: 0,
          right: 0,
          width: $(elem).outerWidth(),
          height: $(elem).outerHeight(),
          visible: true,
        };
        box.bottom = box.top + box.height;
        box.right = box.left + box.width;

        // walk up the tree
        var offsetParent = elem.offsetParent;
        while ((elem = elem.parentNode) != document.body) {
          if (box.visible && elem.scrollHeight != elem.offsetHeight && $(elem).css('overflowY') != 'visible') {
            box.visible = box.bottom > elem.scrollTop && box.top < elem.scrollTop + elem.clientHeight;
          }

          if (box.visible && elem.scrollWidth != elem.offsetWidth && $(elem).css('overflowX') != 'visible') {
            box.visible = box.right > elem.scrollLeft && box.left < elem.scrollLeft + elem.clientWidth;
          }

          box.left -= elem.scrollLeft;
          box.top -= elem.scrollTop;

          if (elem === offsetParent) {
            box.left += elem.offsetLeft;
            box.top += elem.offsetTop;
            offsetParent = elem.offsetParent;
          }

          box.bottom = box.top + box.height;
          box.right = box.left + box.width;
        }

        return box;
      }

      function getActiveCellPosition() {
        return absBox(activeCellNode);
      }

      function getGridPosition() {
        return absBox($container[0]);
      }

      function handleActiveCellPositionChange() {
        if (!activeCellNode) {
          return;
        }

        trigger(self.onActiveCellPositionChanged, {});

        if (currentEditor) {
          var cellBox = getActiveCellPosition();
          if (currentEditor.show && currentEditor.hide) {
            if (!cellBox.visible) {
              currentEditor.hide();
            } else {
              currentEditor.show();
            }
          }

          if (currentEditor.position) {
            currentEditor.position(cellBox);
          }
        }
      }

      function getCellEditor() {
        return currentEditor;
      }

      function getActiveCell() {
        if (!activeCellNode) {
          return null;
        } else {
          return { row: activeRow, cell: activeCell };
        }
      }

      function getActiveCellNode() {
        return activeCellNode;
      }

      function scrollRowIntoView(row, doPaging) {
        var rowAtTop = row * options.rowHeight;
        var rowAtBottom =
          (row + 1) * options.rowHeight - viewportH + (viewportHasHScroll ? scrollbarDimensions.height : 0);

        // need to page down?
        if ((row + 1) * options.rowHeight > scrollTop + viewportH + offset) {
          scrollTo(doPaging ? rowAtTop : rowAtBottom);
          render();
        }
        // or page up?
        else if (row * options.rowHeight < scrollTop + offset) {
          scrollTo(doPaging ? rowAtBottom : rowAtTop);
          render();
        }
      }

      function scrollRowToTop(row) {
        scrollTo(row * options.rowHeight);
        render();
      }

      function scrollPage(dir) {
        var deltaRows = dir * numVisibleRows;
        scrollTo((getRowFromPosition(scrollTop) + deltaRows) * options.rowHeight);
        render();

        if (options.enableCellNavigation && activeRow != null) {
          var row = activeRow + deltaRows;
          var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
          if (row >= dataLengthIncludingAddNew) {
            row = dataLengthIncludingAddNew - 1;
          }
          if (row < 0) {
            row = 0;
          }

          var cell = 0,
            prevCell = null;
          var prevActivePosX = activePosX;
          while (cell <= activePosX) {
            if (canCellBeActive(row, cell)) {
              prevCell = cell;
            }
            cell += getColspan(row, cell);
          }

          if (prevCell !== null) {
            setActiveCellInternal(getCellNode(row, prevCell));
            activePosX = prevActivePosX;
          } else {
            resetActiveCell();
          }
        }
      }

      function navigatePageDown() {
        scrollPage(1);
      }

      function navigatePageUp() {
        scrollPage(-1);
      }

      function getColspan(row, cell) {
        var metadata = data.getItemMetadata && data.getItemMetadata(row);
        if (!metadata || !metadata.columns) {
          return 1;
        }

        var columnData = metadata.columns[columns[cell].id] || metadata.columns[cell];
        var colspan = columnData && columnData.colspan;
        if (colspan === '*') {
          colspan = columns.length - cell;
        } else {
          colspan = colspan || 1;
        }

        return colspan;
      }

      function findFirstFocusableCell(row) {
        var cell = 0;
        while (cell < columns.length) {
          if (canCellBeActive(row, cell)) {
            return cell;
          }
          cell += getColspan(row, cell);
        }
        return null;
      }

      function findLastFocusableCell(row) {
        var cell = 0;
        var lastFocusableCell = null;
        while (cell < columns.length) {
          if (canCellBeActive(row, cell)) {
            lastFocusableCell = cell;
          }
          cell += getColspan(row, cell);
        }
        return lastFocusableCell;
      }

      function gotoRight(row, cell, posX) {
        if (cell >= columns.length) {
          return null;
        }

        do {
          cell += getColspan(row, cell);
        } while (cell < columns.length && !canCellBeActive(row, cell));

        if (cell < columns.length) {
          return {
            row: row,
            cell: cell,
            posX: cell,
          };
        }
        return null;
      }

      function gotoLeft(row, cell, posX) {
        if (cell <= 0) {
          return null;
        }

        var firstFocusableCell = findFirstFocusableCell(row);
        if (firstFocusableCell === null || firstFocusableCell >= cell) {
          return null;
        }

        var prev = {
          row: row,
          cell: firstFocusableCell,
          posX: firstFocusableCell,
        };
        var pos;
        while (true) {
          pos = gotoRight(prev.row, prev.cell, prev.posX);
          if (!pos) {
            return null;
          }
          if (pos.cell >= cell) {
            return prev;
          }
          prev = pos;
        }
      }

      function gotoDown(row, cell, posX) {
        var prevCell;
        var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
        while (true) {
          if (++row >= dataLengthIncludingAddNew) {
            return null;
          }

          prevCell = cell = 0;
          while (cell <= posX) {
            prevCell = cell;
            cell += getColspan(row, cell);
          }

          if (canCellBeActive(row, prevCell)) {
            return {
              row: row,
              cell: prevCell,
              posX: posX,
            };
          }
        }
      }

      function gotoUp(row, cell, posX) {
        var prevCell;
        while (true) {
          if (--row < 0) {
            return null;
          }

          prevCell = cell = 0;
          while (cell <= posX) {
            prevCell = cell;
            cell += getColspan(row, cell);
          }

          if (canCellBeActive(row, prevCell)) {
            return {
              row: row,
              cell: prevCell,
              posX: posX,
            };
          }
        }
      }

      function gotoNext(row, cell, posX) {
        if (row == null && cell == null) {
          row = cell = posX = 0;
          if (canCellBeActive(row, cell)) {
            return {
              row: row,
              cell: cell,
              posX: cell,
            };
          }
        }

        var pos = gotoRight(row, cell, posX);
        if (pos) {
          return pos;
        }

        var firstFocusableCell = null;
        var dataLengthIncludingAddNew = getDataLengthIncludingAddNew();
        while (++row < dataLengthIncludingAddNew) {
          firstFocusableCell = findFirstFocusableCell(row);
          if (firstFocusableCell !== null) {
            return {
              row: row,
              cell: firstFocusableCell,
              posX: firstFocusableCell,
            };
          }
        }
        return null;
      }

      function gotoPrev(row, cell, posX) {
        if (row == null && cell == null) {
          row = getDataLengthIncludingAddNew() - 1;
          cell = posX = columns.length - 1;
          if (canCellBeActive(row, cell)) {
            return {
              row: row,
              cell: cell,
              posX: cell,
            };
          }
        }

        var pos;
        var lastSelectableCell;
        while (!pos) {
          pos = gotoLeft(row, cell, posX);
          if (pos) {
            break;
          }
          if (--row < 0) {
            return null;
          }

          cell = 0;
          lastSelectableCell = findLastFocusableCell(row);
          if (lastSelectableCell !== null) {
            pos = {
              row: row,
              cell: lastSelectableCell,
              posX: lastSelectableCell,
            };
          }
        }
        return pos;
      }

      function navigateRight() {
        return navigate('right');
      }

      function navigateLeft() {
        return navigate('left');
      }

      function navigateDown() {
        return navigate('down');
      }

      function navigateUp() {
        return navigate('up');
      }

      function navigateNext() {
        return navigate('next');
      }

      function navigatePrev() {
        return navigate('prev');
      }

      /**
       * @param {string} dir Navigation direction.
       * @return {boolean} Whether navigation resulted in a change of active cell.
       */
      function navigate(dir) {
        if (!options.enableCellNavigation) {
          return false;
        }

        if (!activeCellNode && dir != 'prev' && dir != 'next') {
          return false;
        }

        if (!getEditorLock().commitCurrentEdit()) {
          return true;
        }
        setFocus();

        var tabbingDirections = {
          up: -1,
          down: 1,
          left: -1,
          right: 1,
          prev: -1,
          next: 1,
        };
        tabbingDirection = tabbingDirections[dir];

        var stepFunctions = {
          up: gotoUp,
          down: gotoDown,
          left: gotoLeft,
          right: gotoRight,
          prev: gotoPrev,
          next: gotoNext,
        };
        var stepFn = stepFunctions[dir];
        var pos = stepFn(activeRow, activeCell, activePosX);
        if (pos) {
          var isAddNewRow = pos.row == getDataLength();
          scrollCellIntoView(pos.row, pos.cell, !isAddNewRow);
          setActiveCellInternal(getCellNode(pos.row, pos.cell));
          activePosX = pos.posX;
          return true;
        } else {
          setActiveCellInternal(getCellNode(activeRow, activeCell));
          return false;
        }
      }

      function getCellNode(row, cell) {
        if (rowsCache[row]) {
          ensureCellNodesInRowsCache(row);
          return rowsCache[row].cellNodesByColumnIdx[cell];
        }
        return null;
      }

      function setActiveCell(row, cell) {
        if (!initialized) {
          return;
        }
        if (row > getDataLength() || row < 0 || cell >= columns.length || cell < 0) {
          return;
        }

        if (!options.enableCellNavigation) {
          return;
        }

        scrollCellIntoView(row, cell, false);
        setActiveCellInternal(getCellNode(row, cell), false);
      }

      function canCellBeActive(row, cell) {
        if (
          !options.enableCellNavigation ||
          row >= getDataLengthIncludingAddNew() ||
          row < 0 ||
          cell >= columns.length ||
          cell < 0
        ) {
          return false;
        }

        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        if (rowMetadata && typeof rowMetadata.focusable === 'boolean') {
          return rowMetadata.focusable;
        }

        var columnMetadata = rowMetadata && rowMetadata.columns;
        if (
          columnMetadata &&
          columnMetadata[columns[cell].id] &&
          typeof columnMetadata[columns[cell].id].focusable === 'boolean'
        ) {
          return columnMetadata[columns[cell].id].focusable;
        }
        if (columnMetadata && columnMetadata[cell] && typeof columnMetadata[cell].focusable === 'boolean') {
          return columnMetadata[cell].focusable;
        }

        return columns[cell].focusable;
      }

      function canCellBeSelected(row, cell) {
        if (row >= getDataLength() || row < 0 || cell >= columns.length || cell < 0) {
          return false;
        }

        var rowMetadata = data.getItemMetadata && data.getItemMetadata(row);
        if (rowMetadata && typeof rowMetadata.selectable === 'boolean') {
          return rowMetadata.selectable;
        }

        var columnMetadata =
          rowMetadata && rowMetadata.columns && (rowMetadata.columns[columns[cell].id] || rowMetadata.columns[cell]);
        if (columnMetadata && typeof columnMetadata.selectable === 'boolean') {
          return columnMetadata.selectable;
        }

        return columns[cell].selectable;
      }

      function gotoCell(row, cell, forceEdit) {
        if (!initialized) {
          return;
        }
        if (!canCellBeActive(row, cell)) {
          return;
        }

        if (!getEditorLock().commitCurrentEdit()) {
          return;
        }

        scrollCellIntoView(row, cell, false);

        var newCell = getCellNode(row, cell);

        // if selecting the 'add new' row, start editing right away
        setActiveCellInternal(newCell, forceEdit || row === getDataLength() || options.autoEdit);

        // if no editor was created, set the focus back on the grid
        if (!currentEditor) {
          setFocus();
        }
      }

      //////////////////////////////////////////////////////////////////////////////////////////////
      // IEditor implementation for the editor lock

      function commitCurrentEdit() {
        var item = getDataItem(activeRow);
        var column = columns[activeCell];

        if (currentEditor) {
          if (currentEditor.isValueChanged()) {
            var validationResults = currentEditor.validate();

            if (validationResults.valid) {
              if (activeRow < getDataLength()) {
                var editCommand = {
                  row: activeRow,
                  cell: activeCell,
                  editor: currentEditor,
                  serializedValue: currentEditor.serializeValue(),
                  prevSerializedValue: serializedEditorValue,
                  execute: function () {
                    this.editor.applyValue(item, this.serializedValue);
                    updateRow(this.row);
                    trigger(self.onCellChange, {
                      row: activeRow,
                      cell: activeCell,
                      item: item,
                    });
                  },
                  undo: function () {
                    this.editor.applyValue(item, this.prevSerializedValue);
                    updateRow(this.row);
                    trigger(self.onCellChange, {
                      row: activeRow,
                      cell: activeCell,
                      item: item,
                    });
                  },
                };

                if (options.editCommandHandler) {
                  makeActiveCellNormal();
                  options.editCommandHandler(item, column, editCommand);
                } else {
                  editCommand.execute();
                  makeActiveCellNormal();
                }
              } else {
                var newItem = {};
                currentEditor.applyValue(newItem, currentEditor.serializeValue());
                makeActiveCellNormal();
                trigger(self.onAddNewRow, { item: newItem, column: column });
              }

              // check whether the lock has been re-acquired by event handlers
              return !getEditorLock().isActive();
            } else {
              // Re-add the CSS class to trigger transitions, if any.
              $(activeCellNode).removeClass('invalid');
              $(activeCellNode).width(); // force layout
              $(activeCellNode).addClass('invalid');

              trigger(self.onValidationError, {
                editor: currentEditor,
                cellNode: activeCellNode,
                validationResults: validationResults,
                row: activeRow,
                cell: activeCell,
                column: column,
              });

              currentEditor.focus();
              return false;
            }
          }

          makeActiveCellNormal();
        }
        return true;
      }

      function cancelCurrentEdit() {
        makeActiveCellNormal();
        return true;
      }

      function rowsToRanges(rows) {
        var ranges = [];
        var lastCell = columns.length - 1;
        for (var i = 0; i < rows.length; i++) {
          ranges.push(new Slick.Range(rows[i], 0, rows[i], lastCell));
        }
        return ranges;
      }

      function getSelectedRows() {
        if (!selectionModel) {
          throw 'Selection model is not set';
        }
        return selectedRows;
      }

      function setSelectedRows(rows) {
        if (!selectionModel) {
          throw 'Selection model is not set';
        }
        selectionModel.setSelectedRanges(rowsToRanges(rows));
      }

      //////////////////////////////////////////////////////////////////////////////////////////////
      // Debug

      this.debug = function () {
        var s = '';

        s += '\n' + 'counter_rows_rendered:  ' + counter_rows_rendered;
        s += '\n' + 'counter_rows_removed:  ' + counter_rows_removed;
        s += '\n' + 'renderedRows:  ' + renderedRows;
        s += '\n' + 'numVisibleRows:  ' + numVisibleRows;
        s += '\n' + 'maxSupportedCssHeight:  ' + maxSupportedCssHeight;
        s += '\n' + 'n(umber of pages):  ' + n;
        s += '\n' + '(current) page:  ' + page;
        s += '\n' + 'page height (ph):  ' + ph;
        s += '\n' + 'vScrollDir:  ' + vScrollDir;

        alert(s);
      };

      // a debug helper to be able to access private members
      this.eval = function (expr) {
        return eval(expr);
      };

      //////////////////////////////////////////////////////////////////////////////////////////////
      // Public API

      $.extend(this, {
        slickGridVersion: '2.1',

        // Events
        onScroll: new Slick.Event(),
        onSort: new Slick.Event(),
        onHeaderMouseEnter: new Slick.Event(),
        onHeaderMouseLeave: new Slick.Event(),
        onHeaderContextMenu: new Slick.Event(),
        onHeaderClick: new Slick.Event(),
        onHeaderCellRendered: new Slick.Event(),
        onBeforeHeaderCellDestroy: new Slick.Event(),
        onHeaderRowCellRendered: new Slick.Event(),
        onBeforeHeaderRowCellDestroy: new Slick.Event(),
        onMouseEnter: new Slick.Event(),
        onMouseLeave: new Slick.Event(),
        onClick: new Slick.Event(),
        onDblClick: new Slick.Event(),
        onContextMenu: new Slick.Event(),
        onKeyDown: new Slick.Event(),
        onAddNewRow: new Slick.Event(),
        onValidationError: new Slick.Event(),
        onViewportChanged: new Slick.Event(),
        onColumnsReordered: new Slick.Event(),
        onColumnsResized: new Slick.Event(),
        onCellChange: new Slick.Event(),
        onBeforeEditCell: new Slick.Event(),
        onBeforeCellEditorDestroy: new Slick.Event(),
        onBeforeDestroy: new Slick.Event(),
        onActiveCellChanged: new Slick.Event(),
        onActiveCellPositionChanged: new Slick.Event(),
        onDragInit: new Slick.Event(),
        onDragStart: new Slick.Event(),
        onDrag: new Slick.Event(),
        onDragEnd: new Slick.Event(),
        onSelectedRowsChanged: new Slick.Event(),
        onCellCssStylesChanged: new Slick.Event(),

        // Methods
        registerPlugin: registerPlugin,
        unregisterPlugin: unregisterPlugin,
        getColumns: getColumns,
        setColumns: setColumns,
        getColumnIndex: getColumnIndex,
        updateColumnHeader: updateColumnHeader,
        setSortColumn: setSortColumn,
        setSortColumns: setSortColumns,
        getSortColumns: getSortColumns,
        autosizeColumns: autosizeColumns,
        getOptions: getOptions,
        setOptions: setOptions,
        getData: getData,
        getDataLength: getDataLength,
        getDataItem: getDataItem,
        setData: setData,
        getSelectionModel: getSelectionModel,
        setSelectionModel: setSelectionModel,
        getSelectedRows: getSelectedRows,
        setSelectedRows: setSelectedRows,
        getContainerNode: getContainerNode,

        render: render,
        invalidate: invalidate,
        invalidateRow: invalidateRow,
        invalidateRows: invalidateRows,
        invalidateAllRows: invalidateAllRows,
        updateCell: updateCell,
        updateRow: updateRow,
        getViewport: getVisibleRange,
        getRenderedRange: getRenderedRange,
        resizeCanvas: resizeCanvas,
        updateRowCount: updateRowCount,
        scrollRowIntoView: scrollRowIntoView,
        scrollRowToTop: scrollRowToTop,
        scrollCellIntoView: scrollCellIntoView,
        getCanvasNode: getCanvasNode,
        focus: setFocus,

        getCellFromPoint: getCellFromPoint,
        getCellFromEvent: getCellFromEvent,
        getActiveCell: getActiveCell,
        setActiveCell: setActiveCell,
        getActiveCellNode: getActiveCellNode,
        getActiveCellPosition: getActiveCellPosition,
        resetActiveCell: resetActiveCell,
        editActiveCell: makeActiveCellEditable,
        getCellEditor: getCellEditor,
        getCellNode: getCellNode,
        getCellNodeBox: getCellNodeBox,
        canCellBeSelected: canCellBeSelected,
        canCellBeActive: canCellBeActive,
        navigatePrev: navigatePrev,
        navigateNext: navigateNext,
        navigateUp: navigateUp,
        navigateDown: navigateDown,
        navigateLeft: navigateLeft,
        navigateRight: navigateRight,
        navigatePageUp: navigatePageUp,
        navigatePageDown: navigatePageDown,
        gotoCell: gotoCell,
        getTopPanel: getTopPanel,
        setTopPanelVisibility: setTopPanelVisibility,
        setHeaderRowVisibility: setHeaderRowVisibility,
        getHeaderRow: getHeaderRow,
        getHeaderRowColumn: getHeaderRowColumn,
        getGridPosition: getGridPosition,
        flashCell: flashCell,
        addCellCssStyles: addCellCssStyles,
        setCellCssStyles: setCellCssStyles,
        removeCellCssStyles: removeCellCssStyles,
        getCellCssStyles: getCellCssStyles,

        init: finishInitialization,
        destroy: destroy,

        // IEditor implementation
        getEditorLock: getEditorLock,
        getEditController: getEditController,
      });

      init();
    }
  })(jQuery);

  (function ($) {
    $.extend(true, window, {
      Slick: {
        Data: {
          DataView: DataView,
          Aggregators: {
            Avg: AvgAggregator,
            Min: MinAggregator,
            Max: MaxAggregator,
            Sum: SumAggregator,
          },
        },
      },
    });

    /***
     * A sample Model implementation.
     * Provides a filtered view of the underlying data.
     *
     * Relies on the data item having an "id" property uniquely identifying it.
     */

    function DataView(options) {
      var self = this;

      var defaults = {
        groupItemMetadataProvider: null,
        inlineFilters: false,
      };

      // private
      var idProperty = '_idProperty_'; // property holding a unique row id
      var items = []; // data by index
      var rows = []; // data by row
      var idxById = {}; // indexes by id
      var rowsById = null; // rows by id; lazy-calculated
      var filter = null; // filter function
      var updated = null; // updated item ids
      var suspend = false; // suspends the recalculation
      var sortAsc = true;
      var fastSortField;
      var sortComparer;
      var refreshHints = {};
      var prevRefreshHints = {};
      var filterArgs;
      var filteredItems = [];
      var compiledFilter;
      var compiledFilterWithCaching;
      var filterCache = [];

      // grouping
      var groupingInfoDefaults = {
        getter: null,
        formatter: null,
        comparer: function (a, b) {
          return a.value - b.value;
        },
        predefinedValues: [],
        aggregators: [],
        aggregateEmpty: false,
        aggregateCollapsed: false,
        aggregateChildGroups: false,
        collapsed: false,
        displayTotalsRow: true,
      };
      var groupingInfos = [];
      var groups = [];
      var toggledGroupsByLevel = [];
      var groupingDelimiter = ':|:';

      var pagesize = 0;
      var pagenum = 0;
      var totalRows = 0;

      // events
      var onRowCountChanged = new Slick.Event();
      var onRowsChanged = new Slick.Event();
      var onPagingInfoChanged = new Slick.Event();

      options = $.extend(true, {}, defaults, options);

      function beginUpdate() {
        suspend = true;
      }

      function endUpdate() {
        suspend = false;
        refresh();
      }

      function setRefreshHints(hints) {
        refreshHints = hints;
      }

      function setFilterArgs(args) {
        filterArgs = args;
      }

      function updateIdxById(startingIndex) {
        startingIndex = startingIndex || 0;
        var id;
        for (var i = startingIndex, l = items.length; i < l; i++) {
          id = items[i][idProperty];
          if (id === undefined) {
            throw "Each data element must implement a unique 'id' property";
          }
          idxById[id] = i;
        }
      }

      function ensureIdUniqueness() {
        var id;
        for (var i = 0, l = items.length; i < l; i++) {
          id = items[i][idProperty];
          if (id === undefined || idxById[id] !== i) {
            throw "Each data element must implement a unique 'id' property";
          }
        }
      }

      function getItems() {
        return items;
      }

      function setItems(data, objectIdProperty) {
        if (objectIdProperty !== undefined) {
          idProperty = objectIdProperty;
        }
        items = filteredItems = data;
        idxById = {};
        updateIdxById();
        ensureIdUniqueness();
        refresh();
      }

      function setPagingOptions(args) {
        if (args.pageSize != undefined) {
          pagesize = args.pageSize;
          pagenum = pagesize ? Math.min(pagenum, Math.max(0, Math.ceil(totalRows / pagesize) - 1)) : 0;
        }

        if (args.pageNum != undefined) {
          pagenum = Math.min(args.pageNum, Math.max(0, Math.ceil(totalRows / pagesize) - 1));
        }

        onPagingInfoChanged.notify(getPagingInfo(), null, self);

        refresh();
      }

      function getPagingInfo() {
        var totalPages = pagesize ? Math.max(1, Math.ceil(totalRows / pagesize)) : 1;
        return {
          pageSize: pagesize,
          pageNum: pagenum,
          totalRows: totalRows,
          totalPages: totalPages,
        };
      }

      function sort(comparer, ascending) {
        sortAsc = ascending;
        sortComparer = comparer;
        fastSortField = null;
        if (ascending === false) {
          items.reverse();
        }
        items.sort(comparer);
        if (ascending === false) {
          items.reverse();
        }
        idxById = {};
        updateIdxById();
        refresh();
      }

      /***
       * Provides a workaround for the extremely slow sorting in IE.
       * Does a [lexicographic] sort on a give column by temporarily overriding Object.prototype.toString
       * to return the value of that field and then doing a native Array.sort().
       */

      function fastSort(field, ascending) {
        sortAsc = ascending;
        fastSortField = field;
        sortComparer = null;
        var oldToString = Object.prototype.toString;
        Object.prototype.toString =
          typeof field == 'function'
            ? field
            : function () {
                return this[field];
              };
        // an extra reversal for descending sort keeps the sort stable
        // (assuming a stable native sort implementation, which isn't true in some cases)
        if (ascending === false) {
          items.reverse();
        }
        items.sort();
        Object.prototype.toString = oldToString;
        if (ascending === false) {
          items.reverse();
        }
        idxById = {};
        updateIdxById();
        refresh();
      }

      function reSort() {
        if (sortComparer) {
          sort(sortComparer, sortAsc);
        } else if (fastSortField) {
          fastSort(fastSortField, sortAsc);
        }
      }

      function setFilter(filterFn) {
        filter = filterFn;
        if (options.inlineFilters) {
          compiledFilter = compileFilter();
          compiledFilterWithCaching = compileFilterWithCaching();
        }
        refresh();
      }

      function getGrouping() {
        return groupingInfos;
      }

      function setGrouping(groupingInfo) {
        if (!options.groupItemMetadataProvider) {
          options.groupItemMetadataProvider = new Slick.Data.GroupItemMetadataProvider();
        }

        groups = [];
        toggledGroupsByLevel = [];
        groupingInfo = groupingInfo || [];
        groupingInfos = groupingInfo instanceof Array ? groupingInfo : [groupingInfo];

        for (var i = 0; i < groupingInfos.length; i++) {
          var gi = (groupingInfos[i] = $.extend(true, {}, groupingInfoDefaults, groupingInfos[i]));
          gi.getterIsAFn = typeof gi.getter === 'function';

          // pre-compile accumulator loops
          gi.compiledAccumulators = [];
          var idx = gi.aggregators.length;
          while (idx--) {
            gi.compiledAccumulators[idx] = compileAccumulatorLoop(gi.aggregators[idx]);
          }

          toggledGroupsByLevel[i] = {};
        }

        refresh();
      }

      /**
       * @deprecated Please use {@link setGrouping}.
       */
      function groupBy(valueGetter, valueFormatter, sortComparer) {
        if (valueGetter == null) {
          setGrouping([]);
          return;
        }

        setGrouping({
          getter: valueGetter,
          formatter: valueFormatter,
          comparer: sortComparer,
        });
      }

      /**
       * @deprecated Please use {@link setGrouping}.
       */
      function setAggregators(groupAggregators, includeCollapsed) {
        if (!groupingInfos.length) {
          throw new Error('At least one grouping must be specified before calling setAggregators().');
        }

        groupingInfos[0].aggregators = groupAggregators;
        groupingInfos[0].aggregateCollapsed = includeCollapsed;

        setGrouping(groupingInfos);
      }

      function getItemByIdx(i) {
        return items[i];
      }

      function getIdxById(id) {
        return idxById[id];
      }

      function ensureRowsByIdCache() {
        if (!rowsById) {
          rowsById = {};
          for (var i = 0, l = rows.length; i < l; i++) {
            rowsById[rows[i][idProperty]] = i;
          }
        }
      }

      function getRowById(id) {
        ensureRowsByIdCache();
        return rowsById[id];
      }

      function getItemById(id) {
        return items[idxById[id]];
      }

      function mapIdsToRows(idArray) {
        var rows = [];
        ensureRowsByIdCache();
        for (var i = 0; i < idArray.length; i++) {
          var row = rowsById[idArray[i]];
          if (row != null) {
            rows[rows.length] = row;
          }
        }
        return rows;
      }

      function mapRowsToIds(rowArray) {
        var ids = [];
        for (var i = 0; i < rowArray.length; i++) {
          if (rowArray[i] < rows.length) {
            ids[ids.length] = rows[rowArray[i]][idProperty];
          }
        }
        return ids;
      }

      function updateItem(id, item) {
        if (idxById[id] === undefined || id !== item[idProperty]) {
          throw 'Invalid or non-matching id';
        }
        items[idxById[id]] = item;
        if (!updated) {
          updated = {};
        }
        updated[id] = true;
        refresh();
      }

      function insertItem(insertBefore, item) {
        items.splice(insertBefore, 0, item);
        updateIdxById(insertBefore);
        refresh();
      }

      function addItem(item) {
        items.push(item);
        updateIdxById(items.length - 1);
        refresh();
      }

      function deleteItem(id) {
        var idx = idxById[id];
        if (idx === undefined) {
          throw 'Invalid id';
        }
        delete idxById[id];
        items.splice(idx, 1);
        updateIdxById(idx);
        refresh();
      }

      function getLength() {
        return rows.length;
      }

      function getItem(i) {
        return rows[i];
      }

      function getItemMetadata(i) {
        var item = rows[i];
        if (item === undefined) {
          return null;
        }

        // overrides for grouping rows
        if (item.__group) {
          return options.groupItemMetadataProvider.getGroupRowMetadata(item);
        }

        // overrides for totals rows
        if (item.__groupTotals) {
          return options.groupItemMetadataProvider.getTotalsRowMetadata(item);
        }

        if (options.groupItemMetadataProvider) {
          return options.groupItemMetadataProvider.getRowMetadata(item);
        }

        return null;
      }

      function expandCollapseAllGroups(level, collapse) {
        if (level == null) {
          for (var i = 0; i < groupingInfos.length; i++) {
            toggledGroupsByLevel[i] = {};
            groupingInfos[i].collapsed = collapse;
          }
        } else {
          toggledGroupsByLevel[level] = {};
          groupingInfos[level].collapsed = collapse;
        }
        refresh();
      }

      /**
       * @param level {Number} Optional level to collapse.  If not specified, applies to all levels.
       */
      function collapseAllGroups(level) {
        expandCollapseAllGroups(level, true);
      }

      /**
       * @param level {Number} Optional level to expand.  If not specified, applies to all levels.
       */
      function expandAllGroups(level) {
        expandCollapseAllGroups(level, false);
      }

      function expandCollapseGroup(level, groupingKey, collapse) {
        toggledGroupsByLevel[level][groupingKey] = groupingInfos[level].collapsed ^ collapse;
        refresh();
      }

      /**
       * @param varArgs Either a Slick.Group's "groupingKey" property, or a
       *     variable argument list of grouping values denoting a unique path to the row.  For
       *     example, calling collapseGroup('high', '10%') will collapse the '10%' subgroup of
       *     the 'high' setGrouping.
       */
      function collapseGroup(varArgs) {
        var args = Array.prototype.slice.call(arguments);
        var arg0 = args[0];
        if (args.length == 1 && arg0.indexOf(groupingDelimiter) != -1) {
          expandCollapseGroup(arg0.split(groupingDelimiter).length - 1, arg0, true);
        } else {
          expandCollapseGroup(args.length - 1, args.join(groupingDelimiter), true);
        }
      }

      /**
       * @param varArgs Either a Slick.Group's "groupingKey" property, or a
       *     variable argument list of grouping values denoting a unique path to the row.  For
       *     example, calling expandGroup('high', '10%') will expand the '10%' subgroup of
       *     the 'high' setGrouping.
       */
      function expandGroup(varArgs) {
        var args = Array.prototype.slice.call(arguments);
        var arg0 = args[0];
        if (args.length == 1 && arg0.indexOf(groupingDelimiter) != -1) {
          expandCollapseGroup(arg0.split(groupingDelimiter).length - 1, arg0, false);
        } else {
          expandCollapseGroup(args.length - 1, args.join(groupingDelimiter), false);
        }
      }

      function getGroups() {
        return groups;
      }

      function extractGroups(rows, parentGroup) {
        var group;
        var val;
        var groups = [];
        var groupsByVal = {};
        var r;
        var level = parentGroup ? parentGroup.level + 1 : 0;
        var gi = groupingInfos[level];

        for (var i = 0, l = gi.predefinedValues.length; i < l; i++) {
          val = gi.predefinedValues[i];
          group = groupsByVal[val];
          if (!group) {
            group = new Slick.Group();
            group.value = val;
            group.level = level;
            group.groupingKey = (parentGroup ? parentGroup.groupingKey + groupingDelimiter : '') + val;
            groups[groups.length] = group;
            groupsByVal[val] = group;
          }
        }

        for (var i = 0, l = rows.length; i < l; i++) {
          r = rows[i];
          val = gi.getterIsAFn ? gi.getter(r) : r[gi.getter];
          group = groupsByVal[val];
          if (!group) {
            group = new Slick.Group();
            group.value = val;
            group.level = level;
            group.groupingKey = (parentGroup ? parentGroup.groupingKey + groupingDelimiter : '') + val;
            groups[groups.length] = group;
            groupsByVal[val] = group;
          }

          group.rows[group.count++] = r;
        }

        if (level < groupingInfos.length - 1) {
          for (var i = 0; i < groups.length; i++) {
            group = groups[i];
            group.groups = extractGroups(group.rows, group);
          }
        }

        groups.sort(groupingInfos[level].comparer);

        return groups;
      }

      // TODO:  lazy totals calculation

      function calculateGroupTotals(group) {
        // TODO:  try moving iterating over groups into compiled accumulator
        var gi = groupingInfos[group.level];
        var isLeafLevel = group.level == groupingInfos.length;
        var totals = new Slick.GroupTotals();
        var agg,
          idx = gi.aggregators.length;
        while (idx--) {
          agg = gi.aggregators[idx];
          agg.init();
          gi.compiledAccumulators[idx].call(agg, !isLeafLevel && gi.aggregateChildGroups ? group.groups : group.rows);
          agg.storeResult(totals);
        }
        totals.group = group;
        group.totals = totals;
      }

      function calculateTotals(groups, level) {
        level = level || 0;
        var gi = groupingInfos[level];
        var idx = groups.length,
          g;
        while (idx--) {
          g = groups[idx];

          if (g.collapsed && !gi.aggregateCollapsed) {
            continue;
          }

          // Do a depth-first aggregation so that parent setGrouping aggregators can access subgroup totals.
          if (g.groups) {
            calculateTotals(g.groups, level + 1);
          }

          if (gi.aggregators.length && (gi.aggregateEmpty || g.rows.length || (g.groups && g.groups.length))) {
            calculateGroupTotals(g);
          }
        }
      }

      function finalizeGroups(groups, level) {
        level = level || 0;
        var gi = groupingInfos[level];
        var groupCollapsed = gi.collapsed;
        var toggledGroups = toggledGroupsByLevel[level];
        var idx = groups.length,
          g;
        while (idx--) {
          g = groups[idx];
          g.collapsed = groupCollapsed ^ toggledGroups[g.groupingKey];
          g.title = gi.formatter ? gi.formatter(g) : g.value;

          if (g.groups) {
            finalizeGroups(g.groups, level + 1);
            // Let the non-leaf setGrouping rows get garbage-collected.
            // They may have been used by aggregates that go over all of the descendants,
            // but at this point they are no longer needed.
            g.rows = [];
          }
        }
      }

      function flattenGroupedRows(groups, level) {
        level = level || 0;
        var gi = groupingInfos[level];
        var groupedRows = [],
          rows,
          gl = 0,
          g;
        for (var i = 0, l = groups.length; i < l; i++) {
          g = groups[i];
          groupedRows[gl++] = g;

          if (!g.collapsed) {
            rows = g.groups ? flattenGroupedRows(g.groups, level + 1) : g.rows;
            for (var j = 0, jj = rows.length; j < jj; j++) {
              groupedRows[gl++] = rows[j];
            }
          }

          if (g.totals && gi.displayTotalsRow && (!g.collapsed || gi.aggregateCollapsed)) {
            groupedRows[gl++] = g.totals;
          }
        }
        return groupedRows;
      }

      function getFunctionInfo(fn) {
        var fnRegex = /^function[^(]*\(([^)]*)\)\s*{([\s\S]*)}$/;
        var matches = fn.toString().match(fnRegex);
        return {
          params: matches[1].split(','),
          body: matches[2],
        };
      }

      function compileAccumulatorLoop(aggregator) {
        var accumulatorInfo = getFunctionInfo(aggregator.accumulate);
        var fn = new Function(
          '_items',
          'for (var ' +
            accumulatorInfo.params[0] +
            ', _i=0, _il=_items.length; _i<_il; _i++) {' +
            accumulatorInfo.params[0] +
            ' = _items[_i]; ' +
            accumulatorInfo.body +
            '}',
        );
        fn.displayName = fn.name = 'compiledAccumulatorLoop';
        return fn;
      }

      function compileFilter() {
        var filterInfo = getFunctionInfo(filter);

        var filterBody = filterInfo.body
          .replace(/return false\s*([;}]|$)/gi, '{ continue _coreloop; }$1')
          .replace(/return true\s*([;}]|$)/gi, '{ _retval[_idx++] = $item$; continue _coreloop; }$1')
          .replace(/return ([^;}]+?)\s*([;}]|$)/gi, '{ if ($1) { _retval[_idx++] = $item$; }; continue _coreloop; }$2');

        // This preserves the function template code after JS compression,
        // so that replace() commands still work as expected.
        var tpl = [
          //"function(_items, _args) { ",
          'var _retval = [], _idx = 0; ',
          'var $item$, $args$ = _args; ',
          '_coreloop: ',
          'for (var _i = 0, _il = _items.length; _i < _il; _i++) { ',
          '$item$ = _items[_i]; ',
          '$filter$; ',
          '} ',
          'return _retval; ',
          //"}"
        ].join('');
        tpl = tpl.replace(/\$filter\$/gi, filterBody);
        tpl = tpl.replace(/\$item\$/gi, filterInfo.params[0]);
        tpl = tpl.replace(/\$args\$/gi, filterInfo.params[1]);

        var fn = new Function('_items,_args', tpl);
        fn.displayName = fn.name = 'compiledFilter';
        return fn;
      }

      function compileFilterWithCaching() {
        var filterInfo = getFunctionInfo(filter);

        var filterBody = filterInfo.body
          .replace(/return false\s*([;}]|$)/gi, '{ continue _coreloop; }$1')
          .replace(/return true\s*([;}]|$)/gi, '{ _cache[_i] = true;_retval[_idx++] = $item$; continue _coreloop; }$1')
          .replace(
            /return ([^;}]+?)\s*([;}]|$)/gi,
            '{ if ((_cache[_i] = $1)) { _retval[_idx++] = $item$; }; continue _coreloop; }$2',
          );

        // This preserves the function template code after JS compression,
        // so that replace() commands still work as expected.
        var tpl = [
          //"function(_items, _args, _cache) { ",
          'var _retval = [], _idx = 0; ',
          'var $item$, $args$ = _args; ',
          '_coreloop: ',
          'for (var _i = 0, _il = _items.length; _i < _il; _i++) { ',
          '$item$ = _items[_i]; ',
          'if (_cache[_i]) { ',
          '_retval[_idx++] = $item$; ',
          'continue _coreloop; ',
          '} ',
          '$filter$; ',
          '} ',
          'return _retval; ',
          //"}"
        ].join('');
        tpl = tpl.replace(/\$filter\$/gi, filterBody);
        tpl = tpl.replace(/\$item\$/gi, filterInfo.params[0]);
        tpl = tpl.replace(/\$args\$/gi, filterInfo.params[1]);

        var fn = new Function('_items,_args,_cache', tpl);
        fn.displayName = fn.name = 'compiledFilterWithCaching';
        return fn;
      }

      function uncompiledFilter(items, args) {
        var retval = [],
          idx = 0;

        for (var i = 0, ii = items.length; i < ii; i++) {
          if (filter(items[i], args)) {
            retval[idx++] = items[i];
          }
        }

        return retval;
      }

      function uncompiledFilterWithCaching(items, args, cache) {
        var retval = [],
          idx = 0,
          item;

        for (var i = 0, ii = items.length; i < ii; i++) {
          item = items[i];
          if (cache[i]) {
            retval[idx++] = item;
          } else if (filter(item, args)) {
            retval[idx++] = item;
            cache[i] = true;
          }
        }

        return retval;
      }

      function getFilteredAndPagedItems(items) {
        if (filter) {
          var batchFilter = options.inlineFilters ? compiledFilter : uncompiledFilter;
          var batchFilterWithCaching = options.inlineFilters ? compiledFilterWithCaching : uncompiledFilterWithCaching;

          if (refreshHints.isFilterNarrowing) {
            filteredItems = batchFilter(filteredItems, filterArgs);
          } else if (refreshHints.isFilterExpanding) {
            filteredItems = batchFilterWithCaching(items, filterArgs, filterCache);
          } else if (!refreshHints.isFilterUnchanged) {
            filteredItems = batchFilter(items, filterArgs);
          }
        } else {
          // special case:  if not filtering and not paging, the resulting
          // rows collection needs to be a copy so that changes due to sort
          // can be caught
          filteredItems = pagesize ? items : items.concat();
        }

        // get the current page
        var paged;
        if (pagesize) {
          if (filteredItems.length < pagenum * pagesize) {
            pagenum = Math.floor(filteredItems.length / pagesize);
          }
          paged = filteredItems.slice(pagesize * pagenum, pagesize * pagenum + pagesize);
        } else {
          paged = filteredItems;
        }

        return {
          totalRows: filteredItems.length,
          rows: paged,
        };
      }

      function getRowDiffs(rows, newRows) {
        var item,
          r,
          eitherIsNonData,
          diff = [];
        var from = 0,
          to = newRows.length;

        if (refreshHints && refreshHints.ignoreDiffsBefore) {
          from = Math.max(0, Math.min(newRows.length, refreshHints.ignoreDiffsBefore));
        }

        if (refreshHints && refreshHints.ignoreDiffsAfter) {
          to = Math.min(newRows.length, Math.max(0, refreshHints.ignoreDiffsAfter));
        }

        for (var i = from, rl = rows.length; i < to; i++) {
          if (i >= rl) {
            diff[diff.length] = i;
          } else {
            item = newRows[i];
            r = rows[i];

            if (
              (groupingInfos.length &&
                (eitherIsNonData = item.__nonDataRow || r.__nonDataRow) &&
                item.__group !== r.__group) ||
              (item.__group && !item.equals(r)) ||
              (eitherIsNonData &&
                // no good way to compare totals since they are arbitrary DTOs
                // deep object comparison is pretty expensive
                // always considering them 'dirty' seems easier for the time being
                (item.__groupTotals || r.__groupTotals)) ||
              item[idProperty] != r[idProperty] ||
              (updated && updated[item[idProperty]])
            ) {
              diff[diff.length] = i;
            }
          }
        }
        return diff;
      }

      function recalc(_items) {
        rowsById = null;

        if (
          refreshHints.isFilterNarrowing != prevRefreshHints.isFilterNarrowing ||
          refreshHints.isFilterExpanding != prevRefreshHints.isFilterExpanding
        ) {
          filterCache = [];
        }

        var filteredItems = getFilteredAndPagedItems(_items);
        totalRows = filteredItems.totalRows;
        var newRows = filteredItems.rows;

        groups = [];
        if (groupingInfos.length) {
          groups = extractGroups(newRows);
          if (groups.length) {
            calculateTotals(groups);
            finalizeGroups(groups);
            newRows = flattenGroupedRows(groups);
          }
        }

        var diff = getRowDiffs(rows, newRows);

        rows = newRows;

        return diff;
      }

      function refresh() {
        if (suspend) {
          return;
        }

        var countBefore = rows.length;
        var totalRowsBefore = totalRows;

        var diff = recalc(items, filter); // pass as direct refs to avoid closure perf hit
        // if the current page is no longer valid, go to last page and recalc
        // we suffer a performance penalty here, but the main loop (recalc) remains highly optimized
        if (pagesize && totalRows < pagenum * pagesize) {
          pagenum = Math.max(0, Math.ceil(totalRows / pagesize) - 1);
          diff = recalc(items, filter);
        }

        updated = null;
        prevRefreshHints = refreshHints;
        refreshHints = {};

        if (totalRowsBefore != totalRows) {
          onPagingInfoChanged.notify(getPagingInfo(), null, self);
        }
        if (countBefore != rows.length) {
          onRowCountChanged.notify(
            {
              previous: countBefore,
              current: rows.length,
            },
            null,
            self,
          );
        }
        if (diff.length > 0) {
          onRowsChanged.notify(
            {
              rows: diff,
            },
            null,
            self,
          );
        }
      }

      function syncGridSelection(grid, preserveHidden) {
        var self = this;
        var selectedRowIds = self.mapRowsToIds(grid.getSelectedRows());
        var inHandler;

        function update() {
          if (selectedRowIds.length > 0) {
            inHandler = true;
            var selectedRows = self.mapIdsToRows(selectedRowIds);
            if (!preserveHidden) {
              selectedRowIds = self.mapRowsToIds(selectedRows);
            }
            grid.setSelectedRows(selectedRows);
            inHandler = false;
          }
        }

        grid.onSelectedRowsChanged.subscribe(function (e, args) {
          if (inHandler) {
            return;
          }

          selectedRowIds = self.mapRowsToIds(grid.getSelectedRows());
        });

        this.onRowsChanged.subscribe(update);

        this.onRowCountChanged.subscribe(update);
      }

      function syncGridCellCssStyles(grid, key) {
        var hashById;
        var inHandler;

        // since this method can be called after the cell styles have been set,
        // get the existing ones right away
        storeCellCssStyles(grid.getCellCssStyles(key));

        function storeCellCssStyles(hash) {
          hashById = {};
          for (var row in hash) {
            var id = rows[row][idProperty];
            hashById[id] = hash[row];
          }
        }

        function update() {
          if (hashById) {
            inHandler = true;
            ensureRowsByIdCache();
            var newHash = {};
            for (var id in hashById) {
              var row = rowsById[id];
              if (row != undefined) {
                newHash[row] = hashById[id];
              }
            }
            grid.setCellCssStyles(key, newHash);
            inHandler = false;
          }
        }

        grid.onCellCssStylesChanged.subscribe(function (e, args) {
          if (inHandler) {
            return;
          }
          if (key != args.key) {
            return;
          }
          if (args.hash) {
            storeCellCssStyles(args.hash);
          }
        });

        this.onRowsChanged.subscribe(update);

        this.onRowCountChanged.subscribe(update);
      }

      $.extend(this, {
        // methods
        beginUpdate: beginUpdate,
        endUpdate: endUpdate,
        setPagingOptions: setPagingOptions,
        getPagingInfo: getPagingInfo,
        getItems: getItems,
        setItems: setItems,
        setFilter: setFilter,
        sort: sort,
        fastSort: fastSort,
        reSort: reSort,
        setGrouping: setGrouping,
        getGrouping: getGrouping,
        groupBy: groupBy,
        setAggregators: setAggregators,
        collapseAllGroups: collapseAllGroups,
        expandAllGroups: expandAllGroups,
        collapseGroup: collapseGroup,
        expandGroup: expandGroup,
        getGroups: getGroups,
        getIdxById: getIdxById,
        getRowById: getRowById,
        getItemById: getItemById,
        getItemByIdx: getItemByIdx,
        mapRowsToIds: mapRowsToIds,
        mapIdsToRows: mapIdsToRows,
        setRefreshHints: setRefreshHints,
        setFilterArgs: setFilterArgs,
        refresh: refresh,
        updateItem: updateItem,
        insertItem: insertItem,
        addItem: addItem,
        deleteItem: deleteItem,
        syncGridSelection: syncGridSelection,
        syncGridCellCssStyles: syncGridCellCssStyles,

        // data provider methods
        getLength: getLength,
        getItem: getItem,
        getItemMetadata: getItemMetadata,

        // events
        onRowCountChanged: onRowCountChanged,
        onRowsChanged: onRowsChanged,
        onPagingInfoChanged: onPagingInfoChanged,
      });
    }

    function AvgAggregator(field) {
      this.field_ = field;

      this.init = function () {
        this.count_ = 0;
        this.nonNullCount_ = 0;
        this.sum_ = 0;
      };

      this.accumulate = function (item) {
        var val = item[this.field_];
        this.count_++;
        if (val != null && val !== '' && val !== NaN) {
          this.nonNullCount_++;
          this.sum_ += parseFloat(val);
        }
      };

      this.storeResult = function (groupTotals) {
        if (!groupTotals.avg) {
          groupTotals.avg = {};
        }
        if (this.nonNullCount_ != 0) {
          groupTotals.avg[this.field_] = this.sum_ / this.nonNullCount_;
        }
      };
    }

    function MinAggregator(field) {
      this.field_ = field;

      this.init = function () {
        this.min_ = null;
      };

      this.accumulate = function (item) {
        var val = item[this.field_];
        if (val != null && val !== '' && val !== NaN) {
          if (this.min_ == null || val < this.min_) {
            this.min_ = val;
          }
        }
      };

      this.storeResult = function (groupTotals) {
        if (!groupTotals.min) {
          groupTotals.min = {};
        }
        groupTotals.min[this.field_] = this.min_;
      };
    }

    function MaxAggregator(field) {
      this.field_ = field;

      this.init = function () {
        this.max_ = null;
      };

      this.accumulate = function (item) {
        var val = item[this.field_];
        if (val != null && val !== '' && val !== NaN) {
          if (this.max_ == null || val > this.max_) {
            this.max_ = val;
          }
        }
      };

      this.storeResult = function (groupTotals) {
        if (!groupTotals.max) {
          groupTotals.max = {};
        }
        groupTotals.max[this.field_] = this.max_;
      };
    }

    function SumAggregator(field) {
      this.field_ = field;

      this.init = function () {
        this.sum_ = null;
      };

      this.accumulate = function (item) {
        var val = item[this.field_];
        if (val != null && val !== '' && val !== NaN) {
          this.sum_ += parseFloat(val);
        }
      };

      this.storeResult = function (groupTotals) {
        if (!groupTotals.sum) {
          groupTotals.sum = {};
        }
        groupTotals.sum[this.field_] = this.sum_;
      };
    }

    // TODO:  add more built-in aggregators
    // TODO:  merge common aggregators in one to prevent needles iterating
  })(jQuery);

  (function ($) {
    function SlickGridPager(dataView, grid, $container) {
      var $status;

      function init() {
        dataView.onPagingInfoChanged.subscribe(function (e, pagingInfo) {
          updatePager(pagingInfo);
        });

        constructPagerUI();
        updatePager(dataView.getPagingInfo());
      }

      function getNavState() {
        var cannotLeaveEditMode = !Slick.GlobalEditorLock.commitCurrentEdit();
        var pagingInfo = dataView.getPagingInfo();
        var lastPage = pagingInfo.totalPages - 1;

        return {
          canGotoFirst: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum > 0,
          canGotoLast: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum != lastPage,
          canGotoPrev: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum > 0,
          canGotoNext: !cannotLeaveEditMode && pagingInfo.pageSize != 0 && pagingInfo.pageNum < lastPage,
          pagingInfo: pagingInfo,
        };
      }

      function setPageSize(n) {
        dataView.setRefreshHints({
          isFilterUnchanged: true,
        });
        dataView.setPagingOptions({ pageSize: n });
      }

      function gotoFirst() {
        if (getNavState().canGotoFirst) {
          dataView.setPagingOptions({ pageNum: 0 });
        }
      }

      function gotoLast() {
        var state = getNavState();
        if (state.canGotoLast) {
          dataView.setPagingOptions({ pageNum: state.pagingInfo.totalPages - 1 });
        }
      }

      function gotoPrev() {
        var state = getNavState();
        if (state.canGotoPrev) {
          dataView.setPagingOptions({ pageNum: state.pagingInfo.pageNum - 1 });
        }
      }

      function gotoNext() {
        var state = getNavState();
        if (state.canGotoNext) {
          dataView.setPagingOptions({ pageNum: state.pagingInfo.pageNum + 1 });
        }
      }

      function constructPagerUI() {
        $container.empty();

        var $nav = $("<span class='slick-pager-nav' />").appendTo($container);
        var $settings = $("<span class='slick-pager-settings' />").appendTo($container);
        $status = $("<span class='slick-pager-status' />").appendTo($container);

        $settings.append(
          "<span class='slick-pager-settings-expanded' style='display:none'>Show: <a data=0>All</a><a data='-1'>Auto</a><a data=25>25</a><a data=50>50</a><a data=100>100</a></span>",
        );

        $settings.find('a[data]').click(function (e) {
          var pagesize = $(e.target).attr('data');
          if (pagesize != undefined) {
            if (pagesize == -1) {
              var vp = grid.getViewport();
              setPageSize(vp.bottom - vp.top);
            } else {
              setPageSize(parseInt(pagesize));
            }
          }
        });

        var icon_prefix = "<span class='ui-state-default ui-corner-all ui-icon-container'><span class='ui-icon ";
        var icon_suffix = "' /></span>";

        $(icon_prefix + 'ui-icon-lightbulb' + icon_suffix)
          .click(function () {
            $('.slick-pager-settings-expanded').toggle();
          })
          .appendTo($settings);

        $(icon_prefix + 'ui-icon-seek-first' + icon_suffix)
          .click(gotoFirst)
          .appendTo($nav);

        $(icon_prefix + 'ui-icon-seek-prev' + icon_suffix)
          .click(gotoPrev)
          .appendTo($nav);

        $(icon_prefix + 'ui-icon-seek-next' + icon_suffix)
          .click(gotoNext)
          .appendTo($nav);

        $(icon_prefix + 'ui-icon-seek-end' + icon_suffix)
          .click(gotoLast)
          .appendTo($nav);

        $container.find('.ui-icon-container').hover(function () {
          $(this).toggleClass('ui-state-hover');
        });

        $container.children().wrapAll("<div class='slick-pager' />");
      }

      function updatePager(pagingInfo) {
        var state = getNavState();

        $container.find('.slick-pager-nav span').removeClass('ui-state-disabled');
        if (!state.canGotoFirst) {
          $container.find('.ui-icon-seek-first').addClass('ui-state-disabled');
        }
        if (!state.canGotoLast) {
          $container.find('.ui-icon-seek-end').addClass('ui-state-disabled');
        }
        if (!state.canGotoNext) {
          $container.find('.ui-icon-seek-next').addClass('ui-state-disabled');
        }
        if (!state.canGotoPrev) {
          $container.find('.ui-icon-seek-prev').addClass('ui-state-disabled');
        }

        if (pagingInfo.pageSize == 0) {
          $status.text('Showing all ' + pagingInfo.totalRows + ' rows');
        } else {
          $status.text('Showing page ' + (pagingInfo.pageNum + 1) + ' of ' + pagingInfo.totalPages);
        }
      }

      init();
    }

    // Slick.Controls.Pager
    $.extend(true, window, { Slick: { Controls: { Pager: SlickGridPager } } });
  })(jQuery);

  (function ($) {
    function SlickColumnPicker(columns, grid, options) {
      var $menu;
      var columnCheckboxes;

      var defaults = {
        fadeSpeed: 250,
      };

      function init() {
        grid.onHeaderContextMenu.subscribe(handleHeaderContextMenu);
        grid.onColumnsReordered.subscribe(updateColumnOrder);
        options = $.extend({}, defaults, options);

        $menu = $("<span class='slick-columnpicker' style='display:none;position:absolute;z-index:20;' />").appendTo(
          document.body,
        );

        $menu
          .bind('mouseleave', function (e) {
            $(this).fadeOut(options.fadeSpeed);
          })
          .bind('click', updateColumn);
      }

      function handleHeaderContextMenu(e, args) {
        e.preventDefault();
        $menu.empty();
        updateColumnOrder();
        columnCheckboxes = [];

        var $li, $input;
        for (var i = 0; i < columns.length; i++) {
          $li = $('<li />').appendTo($menu);
          $input = $("<input type='checkbox' />").data('column-id', columns[i]._idProperty_);
          columnCheckboxes.push($input);

          if (grid.getColumnIndex(columns[i]._idProperty_) != null) {
            $input.attr('checked', 'checked');
          }

          $('<label />').text(columns[i].name).prepend($input).appendTo($li);
        }

        $('<hr/>').appendTo($menu);
        $li = $('<li />').appendTo($menu);
        $input = $("<input type='checkbox' />").data('option', 'autoresize');
        $('<label />').text('Force fit columns').prepend($input).appendTo($li);
        if (grid.getOptions().forceFitColumns) {
          $input.attr('checked', 'checked');
        }

        $li = $('<li />').appendTo($menu);
        $input = $("<input type='checkbox' />").data('option', 'syncresize');
        $('<label />').text('Synchronous resize').prepend($input).appendTo($li);
        if (grid.getOptions().syncColumnCellResize) {
          $input.attr('checked', 'checked');
        }

        $menu
          .css('top', e.pageY - 10)
          .css('left', e.pageX - 10)
          .fadeIn(options.fadeSpeed);
      }

      function updateColumnOrder() {
        // Because columns can be reordered, we have to update the `columns`
        // to reflect the new order, however we can't just take `grid.getColumns()`,
        // as it does not include columns currently hidden by the picker.
        // We create a new `columns` structure by leaving currently-hidden
        // columns in their original ordinal position and interleaving the results
        // of the current column sort.
        var current = grid.getColumns().slice(0);
        var ordered = new Array(columns.length);
        for (var i = 0; i < ordered.length; i++) {
          if (grid.getColumnIndex(columns[i]._idProperty_) === undefined) {
            // If the column doesn't return a value from getColumnIndex,
            // it is hidden. Leave it in this position.
            ordered[i] = columns[i];
          } else {
            // Otherwise, grab the next visible column.
            ordered[i] = current.shift();
          }
        }
        columns = ordered;
      }

      function updateColumn(e) {
        if ($(e.target).data('option') == 'autoresize') {
          if (e.target.checked) {
            grid.setOptions({
              forceFitColumns: true,
            });
            grid.autosizeColumns();
          } else {
            grid.setOptions({
              forceFitColumns: false,
            });
          }
          return;
        }

        if ($(e.target).data('option') == 'syncresize') {
          if (e.target.checked) {
            grid.setOptions({
              syncColumnCellResize: true,
            });
          } else {
            grid.setOptions({
              syncColumnCellResize: false,
            });
          }
          return;
        }

        if ($(e.target).is(':checkbox')) {
          var visibleColumns = [];
          $.each(columnCheckboxes, function (i, e) {
            if ($(this).is(':checked')) {
              visibleColumns.push(columns[i]);
            }
          });

          if (!visibleColumns.length) {
            $(e.target).attr('checked', 'checked');
            return;
          }

          grid.setColumns(visibleColumns);
        }
      }

      function getAllColumns() {
        return columns;
      }
      init();

      return {
        getAllColumns: getAllColumns,
      };
    }

    // Slick.Controls.ColumnPicker
    $.extend(true, window, {
      Slick: {
        Controls: {
          ColumnPicker: SlickColumnPicker,
        },
      },
    });
  })(jQuery);

  window.jQuery_1_7 = $.noConflict(true);
  window.Slick = Slick;
})(window);
(function ($) {
  $.extend(true, window, {
    Slick: {
      ColumnGroup: ColumnGroup,
    },
  });

  function ColumnGroup() {
    var grid,
      $container,
      $groupHeaderColumns,
      self = this,
      isColumnGroupEnabled = false;
    var handler = new Slick.EventHandler();

    function init(_grid) {
      grid = _grid;
      $container = $(grid.getContainerNode());
      handler.subscribe(grid.onColumnsResized, onColumnsResized);
      handler.subscribe(grid.onColumnsReordered, onColumnsReordered);
    }

    function enableColumnGrouping() {
      if (isColumnGroupEnabled) {
        return;
      }
      isColumnGroupEnabled = true;
      setGroupedColumns();
    }

    function removeColumnGrouping() {
      if (!isColumnGroupEnabled) {
        return;
      }
      isColumnGroupEnabled = false;
      $groupHeaderColumns.remove();
      grid.resizeCanvas();
    }

    function setGroupedColumns() {
      var headerColumns = $container.find('.slick-header-columns');
      $groupHeaderColumns = $('<div class="slick-group-header-columns ui-state-default"> </div>');
      $groupHeaderColumns.css({
        width: headerColumns.width() + 'px',
        left: headerColumns.position().left + 'px',
      });

      var columns = grid.getColumns();
      var columnGroups = getGroupedColumns(columns);
      setGroupIndex(columns);
      setColumnIndex(columns);

      $groupHeaderColumns.append(getGroupedColumnsTemplate(columnGroups));
      $container.find('.slick-header').prepend($groupHeaderColumns);

      setupGroupColumnReorder();
      columns.sort(groupCompare);
      grid.setColumns(columns);
      grid.resizeCanvas();
    }

    function getGroupedColumnsTemplate(columnGroups) {
      var slickColumns = '',
        borderWidth = 2;
      $.each(columnGroups, function (name, group) {
        var width = group.reduce(function (width, column) {
          return width + column.width;
        }, 0);
        var displayName = name === '-' ? ' ' : name;
        slickColumns +=
          '<div class="ui-state-default slick-header-column" data-group-name="' +
          name +
          '"style="width:' +
          (width - borderWidth) +
          'px"> <div class="slick-column-name">' +
          displayName +
          '</div></div>';
        borderWidth = 1;
      });
      return slickColumns;
    }

    function setColumnIndex(columns) {
      columns.forEach(function (column, index) {
        column._index = index;
      });
    }

    function setGroupIndex(columns) {
      var groupNames = Object.keys(getGroupedColumns(columns));
      columns.forEach(function (column) {
        column._groupIndex = groupNames.indexOf(column.groupName);
        column._groupIndex = column._groupIndex === -1 ? groupNames.length : column._groupIndex;
      });
    }

    function setupGroupColumnReorder() {
      $groupHeaderColumns.sortable({
        containment: 'parent',
        distance: 3,
        axis: 'x',
        cursor: 'default',
        tolerance: 'intersection',
        helper: 'clone',
        update: onColumnsReordered,
      });
    }

    function onColumnsResized() {
      var columns = grid.getColumns(),
        borderWidth = 2;

      if (!isColumnGroupEnabled) {
        self.onColumnsResized.notify(columns);
        return;
      }

      $.each(getGroupedColumns(columns), function (name, group) {
        var width = group.reduce(function (width, column) {
          return width + column.width;
        }, 0);
        $groupHeaderColumns.find("[data-group-name='" + name + "']").css('width', width - borderWidth);
        borderWidth = 1;
      });

      self.onColumnsResized.notify(columns);
    }

    function onColumnsReordered() {
      var columns = grid.getColumns();
      setColumnIndex(columns);

      if (!isColumnGroupEnabled) {
        self.onColumnsReordered.notify(columns);
        return;
      }

      var $columns = $('.slick-group-header-columns .slick-header-column');
      var columnGroups = getGroupedColumns(columns);
      $columns.each(function (index, column) {
        var groupedColumns = columnGroups[$(column).data('group-name')];
        groupedColumns.forEach(function (groupedColumn) {
          groupedColumn._groupIndex = index;
        });
      });
      columns.sort(groupCompare);
      grid.setColumns(columns);
      setColumnIndex(columns);
      self.onColumnsReordered.notify(columns);
    }

    function groupCompare(c1, c2) {
      return c1._groupIndex - c2._groupIndex || c1._index - c2._index;
    }

    function getGroupedColumns(columns) {
      var groupedColumns = {};
      columns.forEach(function (column) {
        var groupName = column.groupName || '-';
        groupedColumns[groupName] = groupedColumns[groupName] || [];
        groupedColumns[groupName].push(column);
      });
      return groupedColumns;
    }

    function destroy() {
      handler.unsubscribeAll();
    }

    this.onColumnsReordered = new Slick.Event();
    this.onColumnsResized = new Slick.Event();

    return {
      init: init,
      destroy: destroy,
      onColumnsReordered: this.onColumnsReordered,
      onColumnsResized: this.onColumnsResized,
      enableColumnGrouping: enableColumnGrouping,
      removeColumnGrouping: removeColumnGrouping,
    };
  }
})(jQuery);
/*!
 * jQuery UI 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI
 */
(function (c, j) {
  function k(a, b) {
    var d = a.nodeName.toLowerCase();
    if ('area' === d) {
      b = a.parentNode;
      d = b.name;
      if (!a.href || !d || b.nodeName.toLowerCase() !== 'map') return false;
      a = c('img[usemap=#' + d + ']')[0];
      return !!a && l(a);
    }
    return (/input|select|textarea|button|object/.test(d) ? !a.disabled : 'a' == d ? a.href || b : b) && l(a);
  }
  function l(a) {
    return !c(a)
      .parents()
      .andSelf()
      .filter(function () {
        return c.curCSS(this, 'visibility') === 'hidden' || c.expr.filters.hidden(this);
      }).length;
  }
  c.ui = c.ui || {};
  if (!c.ui.version) {
    c.extend(c.ui, {
      version: '1.8.16',
      keyCode: {
        ALT: 18,
        BACKSPACE: 8,
        CAPS_LOCK: 20,
        COMMA: 188,
        COMMAND: 91,
        COMMAND_LEFT: 91,
        COMMAND_RIGHT: 93,
        CONTROL: 17,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        INSERT: 45,
        LEFT: 37,
        MENU: 93,
        NUMPAD_ADD: 107,
        NUMPAD_DECIMAL: 110,
        NUMPAD_DIVIDE: 111,
        NUMPAD_ENTER: 108,
        NUMPAD_MULTIPLY: 106,
        NUMPAD_SUBTRACT: 109,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SHIFT: 16,
        SPACE: 32,
        TAB: 9,
        UP: 38,
        WINDOWS: 91,
      },
    });
    c.fn.extend({
      propAttr: c.fn.prop || c.fn.attr,
      _focus: c.fn.focus,
      focus: function (a, b) {
        return typeof a === 'number'
          ? this.each(function () {
              var d = this;
              setTimeout(function () {
                c(d).focus();
                b && b.call(d);
              }, a);
            })
          : this._focus.apply(this, arguments);
      },
      scrollParent: function () {
        var a;
        a =
          (c.browser.msie && /(static|relative)/.test(this.css('position'))) || /absolute/.test(this.css('position'))
            ? this.parents()
                .filter(function () {
                  return (
                    /(relative|absolute|fixed)/.test(c.curCSS(this, 'position', 1)) &&
                    /(auto|scroll)/.test(
                      c.curCSS(this, 'overflow', 1) + c.curCSS(this, 'overflow-y', 1) + c.curCSS(this, 'overflow-x', 1),
                    )
                  );
                })
                .eq(0)
            : this.parents()
                .filter(function () {
                  return /(auto|scroll)/.test(
                    c.curCSS(this, 'overflow', 1) + c.curCSS(this, 'overflow-y', 1) + c.curCSS(this, 'overflow-x', 1),
                  );
                })
                .eq(0);
        return /fixed/.test(this.css('position')) || !a.length ? c(document) : a;
      },
      zIndex: function (a) {
        if (a !== j) return this.css('zIndex', a);
        if (this.length) {
          a = c(this[0]);
          for (var b; a.length && a[0] !== document; ) {
            b = a.css('position');
            if (b === 'absolute' || b === 'relative' || b === 'fixed') {
              b = parseInt(a.css('zIndex'), 10);
              if (!isNaN(b) && b !== 0) return b;
            }
            a = a.parent();
          }
        }
        return 0;
      },
      disableSelection: function () {
        return this.bind((c.support.selectstart ? 'selectstart' : 'mousedown') + '.ui-disableSelection', function (a) {
          a.preventDefault();
        });
      },
      enableSelection: function () {
        return this.unbind('.ui-disableSelection');
      },
    });
    c.each(['Width', 'Height'], function (a, b) {
      function d(f, g, m, n) {
        c.each(e, function () {
          g -= parseFloat(c.curCSS(f, 'padding' + this, true)) || 0;
          if (m) g -= parseFloat(c.curCSS(f, 'border' + this + 'Width', true)) || 0;
          if (n) g -= parseFloat(c.curCSS(f, 'margin' + this, true)) || 0;
        });
        return g;
      }
      var e = b === 'Width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
        h = b.toLowerCase(),
        i = {
          innerWidth: c.fn.innerWidth,
          innerHeight: c.fn.innerHeight,
          outerWidth: c.fn.outerWidth,
          outerHeight: c.fn.outerHeight,
        };
      c.fn['inner' + b] = function (f) {
        if (f === j) return i['inner' + b].call(this);
        return this.each(function () {
          c(this).css(h, d(this, f) + 'px');
        });
      };
      c.fn['outer' + b] = function (f, g) {
        if (typeof f !== 'number') return i['outer' + b].call(this, f);
        return this.each(function () {
          c(this).css(h, d(this, f, true, g) + 'px');
        });
      };
    });
    c.extend(c.expr[':'], {
      data: function (a, b, d) {
        return !!c.data(a, d[3]);
      },
      focusable: function (a) {
        return k(a, !isNaN(c.attr(a, 'tabindex')));
      },
      tabbable: function (a) {
        var b = c.attr(a, 'tabindex'),
          d = isNaN(b);
        return (d || b >= 0) && k(a, !d);
      },
    });
    c(function () {
      var a = document.body,
        b = a.appendChild((b = document.createElement('div')));
      c.extend(b.style, { minHeight: '100px', height: 'auto', padding: 0, borderWidth: 0 });
      c.support.minHeight = b.offsetHeight === 100;
      c.support.selectstart = 'onselectstart' in b;
      a.removeChild(b).style.display = 'none';
    });
    c.extend(c.ui, {
      plugin: {
        add: function (a, b, d) {
          a = c.ui[a].prototype;
          for (var e in d) {
            a.plugins[e] = a.plugins[e] || [];
            a.plugins[e].push([b, d[e]]);
          }
        },
        call: function (a, b, d) {
          if ((b = a.plugins[b]) && a.element[0].parentNode)
            for (var e = 0; e < b.length; e++) a.options[b[e][0]] && b[e][1].apply(a.element, d);
        },
      },
      contains: function (a, b) {
        return document.compareDocumentPosition ? a.compareDocumentPosition(b) & 16 : a !== b && a.contains(b);
      },
      hasScroll: function (a, b) {
        if (c(a).css('overflow') === 'hidden') return false;
        b = b && b === 'left' ? 'scrollLeft' : 'scrollTop';
        var d = false;
        if (a[b] > 0) return true;
        a[b] = 1;
        d = a[b] > 0;
        a[b] = 0;
        return d;
      },
      isOverAxis: function (a, b, d) {
        return a > b && a < b + d;
      },
      isOver: function (a, b, d, e, h, i) {
        return c.ui.isOverAxis(a, d, h) && c.ui.isOverAxis(b, e, i);
      },
    });
  }
})(jQuery);
/*!
 * jQuery UI Widget 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Widget
 */
(function (b, j) {
  if (b.cleanData) {
    var k = b.cleanData;
    b.cleanData = function (a) {
      for (var c = 0, d; (d = a[c]) != null; c++)
        try {
          b(d).triggerHandler('remove');
        } catch (e) {}
      k(a);
    };
  } else {
    var l = b.fn.remove;
    b.fn.remove = function (a, c) {
      return this.each(function () {
        if (!c)
          if (!a || b.filter(a, [this]).length)
            b('*', this)
              .add([this])
              .each(function () {
                try {
                  b(this).triggerHandler('remove');
                } catch (d) {}
              });
        return l.call(b(this), a, c);
      });
    };
  }
  b.widget = function (a, c, d) {
    var e = a.split('.')[0],
      f;
    a = a.split('.')[1];
    f = e + '-' + a;
    if (!d) {
      d = c;
      c = b.Widget;
    }
    b.expr[':'][f] = function (h) {
      return !!b.data(h, a);
    };
    b[e] = b[e] || {};
    b[e][a] = function (h, g) {
      arguments.length && this._createWidget(h, g);
    };
    c = new c();
    c.options = b.extend(true, {}, c.options);
    b[e][a].prototype = b.extend(
      true,
      c,
      { namespace: e, widgetName: a, widgetEventPrefix: b[e][a].prototype.widgetEventPrefix || a, widgetBaseClass: f },
      d,
    );
    b.widget.bridge(a, b[e][a]);
  };
  b.widget.bridge = function (a, c) {
    b.fn[a] = function (d) {
      var e = typeof d === 'string',
        f = Array.prototype.slice.call(arguments, 1),
        h = this;
      d = !e && f.length ? b.extend.apply(null, [true, d].concat(f)) : d;
      if (e && d.charAt(0) === '_') return h;
      e
        ? this.each(function () {
            var g = b.data(this, a),
              i = g && b.isFunction(g[d]) ? g[d].apply(g, f) : g;
            if (i !== g && i !== j) {
              h = i;
              return false;
            }
          })
        : this.each(function () {
            var g = b.data(this, a);
            g ? g.option(d || {})._init() : b.data(this, a, new c(d, this));
          });
      return h;
    };
  };
  b.Widget = function (a, c) {
    arguments.length && this._createWidget(a, c);
  };
  b.Widget.prototype = {
    widgetName: 'widget',
    widgetEventPrefix: '',
    options: { disabled: false },
    _createWidget: function (a, c) {
      b.data(c, this.widgetName, this);
      this.element = b(c);
      this.options = b.extend(true, {}, this.options, this._getCreateOptions(), a);
      var d = this;
      this.element.bind('remove.' + this.widgetName, function () {
        d.destroy();
      });
      this._create();
      this._trigger('create');
      this._init();
    },
    _getCreateOptions: function () {
      return b.metadata && b.metadata.get(this.element[0])[this.widgetName];
    },
    _create: function () {},
    _init: function () {},
    destroy: function () {
      this.element.unbind('.' + this.widgetName).removeData(this.widgetName);
      this.widget()
        .unbind('.' + this.widgetName)
        .removeAttr('aria-disabled')
        .removeClass(this.widgetBaseClass + '-disabled ui-state-disabled');
    },
    widget: function () {
      return this.element;
    },
    option: function (a, c) {
      var d = a;
      if (arguments.length === 0) return b.extend({}, this.options);
      if (typeof a === 'string') {
        if (c === j) return this.options[a];
        d = {};
        d[a] = c;
      }
      this._setOptions(d);
      return this;
    },
    _setOptions: function (a) {
      var c = this;
      b.each(a, function (d, e) {
        c._setOption(d, e);
      });
      return this;
    },
    _setOption: function (a, c) {
      this.options[a] = c;
      if (a === 'disabled')
        this.widget()
          [c ? 'addClass' : 'removeClass'](this.widgetBaseClass + '-disabled ui-state-disabled')
          .attr('aria-disabled', c);
      return this;
    },
    enable: function () {
      return this._setOption('disabled', false);
    },
    disable: function () {
      return this._setOption('disabled', true);
    },
    _trigger: function (a, c, d) {
      var e = this.options[a];
      c = b.Event(c);
      c.type = (a === this.widgetEventPrefix ? a : this.widgetEventPrefix + a).toLowerCase();
      d = d || {};
      if (c.originalEvent) {
        a = b.event.props.length;
        for (var f; a; ) {
          f = b.event.props[--a];
          c[f] = c.originalEvent[f];
        }
      }
      this.element.trigger(c, d);
      return !((b.isFunction(e) && e.call(this.element[0], c, d) === false) || c.isDefaultPrevented());
    },
  };
})(jQuery);
/*!
 * jQuery UI Mouse 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Mouse
 *
 * Depends:
 *	jquery.ui.widget.js
 */
(function (b) {
  var d = false;
  b(document).mouseup(function () {
    d = false;
  });
  b.widget('ui.mouse', {
    options: { cancel: ':input,option', distance: 1, delay: 0 },
    _mouseInit: function () {
      var a = this;
      this.element
        .bind('mousedown.' + this.widgetName, function (c) {
          return a._mouseDown(c);
        })
        .bind('click.' + this.widgetName, function (c) {
          if (true === b.data(c.target, a.widgetName + '.preventClickEvent')) {
            b.removeData(c.target, a.widgetName + '.preventClickEvent');
            c.stopImmediatePropagation();
            return false;
          }
        });
      this.started = false;
    },
    _mouseDestroy: function () {
      this.element.unbind('.' + this.widgetName);
    },
    _mouseDown: function (a) {
      if (!d) {
        this._mouseStarted && this._mouseUp(a);
        this._mouseDownEvent = a;
        var c = this,
          f = a.which == 1,
          g =
            typeof this.options.cancel == 'string' && a.target.nodeName
              ? b(a.target).closest(this.options.cancel).length
              : false;
        if (!f || g || !this._mouseCapture(a)) return true;
        this.mouseDelayMet = !this.options.delay;
        if (!this.mouseDelayMet)
          this._mouseDelayTimer = setTimeout(function () {
            c.mouseDelayMet = true;
          }, this.options.delay);
        if (this._mouseDistanceMet(a) && this._mouseDelayMet(a)) {
          this._mouseStarted = this._mouseStart(a) !== false;
          if (!this._mouseStarted) {
            a.preventDefault();
            return true;
          }
        }
        true === b.data(a.target, this.widgetName + '.preventClickEvent') &&
          b.removeData(a.target, this.widgetName + '.preventClickEvent');
        this._mouseMoveDelegate = function (e) {
          return c._mouseMove(e);
        };
        this._mouseUpDelegate = function (e) {
          return c._mouseUp(e);
        };
        b(document)
          .bind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
          .bind('mouseup.' + this.widgetName, this._mouseUpDelegate);
        a.preventDefault();
        return (d = true);
      }
    },
    _mouseMove: function (a) {
      if (b.browser.msie && !(document.documentMode >= 9) && !a.button) return this._mouseUp(a);
      if (this._mouseStarted) {
        this._mouseDrag(a);
        return a.preventDefault();
      }
      if (this._mouseDistanceMet(a) && this._mouseDelayMet(a))
        (this._mouseStarted = this._mouseStart(this._mouseDownEvent, a) !== false)
          ? this._mouseDrag(a)
          : this._mouseUp(a);
      return !this._mouseStarted;
    },
    _mouseUp: function (a) {
      b(document)
        .unbind('mousemove.' + this.widgetName, this._mouseMoveDelegate)
        .unbind('mouseup.' + this.widgetName, this._mouseUpDelegate);
      if (this._mouseStarted) {
        this._mouseStarted = false;
        a.target == this._mouseDownEvent.target && b.data(a.target, this.widgetName + '.preventClickEvent', true);
        this._mouseStop(a);
      }
      return false;
    },
    _mouseDistanceMet: function (a) {
      return (
        Math.max(Math.abs(this._mouseDownEvent.pageX - a.pageX), Math.abs(this._mouseDownEvent.pageY - a.pageY)) >=
        this.options.distance
      );
    },
    _mouseDelayMet: function () {
      return this.mouseDelayMet;
    },
    _mouseStart: function () {},
    _mouseDrag: function () {},
    _mouseStop: function () {},
    _mouseCapture: function () {
      return true;
    },
  });
})(jQuery);
/*
 * jQuery UI Position 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Position
 */
(function (c) {
  c.ui = c.ui || {};
  var n = /left|center|right/,
    o = /top|center|bottom/,
    t = c.fn.position,
    u = c.fn.offset;
  c.fn.position = function (b) {
    if (!b || !b.of) return t.apply(this, arguments);
    b = c.extend({}, b);
    var a = c(b.of),
      d = a[0],
      g = (b.collision || 'flip').split(' '),
      e = b.offset ? b.offset.split(' ') : [0, 0],
      h,
      k,
      j;
    if (d.nodeType === 9) {
      h = a.width();
      k = a.height();
      j = { top: 0, left: 0 };
    } else if (d.setTimeout) {
      h = a.width();
      k = a.height();
      j = { top: a.scrollTop(), left: a.scrollLeft() };
    } else if (d.preventDefault) {
      b.at = 'left top';
      h = k = 0;
      j = { top: b.of.pageY, left: b.of.pageX };
    } else {
      h = a.outerWidth();
      k = a.outerHeight();
      j = a.offset();
    }
    c.each(['my', 'at'], function () {
      var f = (b[this] || '').split(' ');
      if (f.length === 1)
        f = n.test(f[0]) ? f.concat(['center']) : o.test(f[0]) ? ['center'].concat(f) : ['center', 'center'];
      f[0] = n.test(f[0]) ? f[0] : 'center';
      f[1] = o.test(f[1]) ? f[1] : 'center';
      b[this] = f;
    });
    if (g.length === 1) g[1] = g[0];
    e[0] = parseInt(e[0], 10) || 0;
    if (e.length === 1) e[1] = e[0];
    e[1] = parseInt(e[1], 10) || 0;
    if (b.at[0] === 'right') j.left += h;
    else if (b.at[0] === 'center') j.left += h / 2;
    if (b.at[1] === 'bottom') j.top += k;
    else if (b.at[1] === 'center') j.top += k / 2;
    j.left += e[0];
    j.top += e[1];
    return this.each(function () {
      var f = c(this),
        l = f.outerWidth(),
        m = f.outerHeight(),
        p = parseInt(c.curCSS(this, 'marginLeft', true)) || 0,
        q = parseInt(c.curCSS(this, 'marginTop', true)) || 0,
        v = l + p + (parseInt(c.curCSS(this, 'marginRight', true)) || 0),
        w = m + q + (parseInt(c.curCSS(this, 'marginBottom', true)) || 0),
        i = c.extend({}, j),
        r;
      if (b.my[0] === 'right') i.left -= l;
      else if (b.my[0] === 'center') i.left -= l / 2;
      if (b.my[1] === 'bottom') i.top -= m;
      else if (b.my[1] === 'center') i.top -= m / 2;
      i.left = Math.round(i.left);
      i.top = Math.round(i.top);
      r = { left: i.left - p, top: i.top - q };
      c.each(['left', 'top'], function (s, x) {
        c.ui.position[g[s]] &&
          c.ui.position[g[s]][x](i, {
            targetWidth: h,
            targetHeight: k,
            elemWidth: l,
            elemHeight: m,
            collisionPosition: r,
            collisionWidth: v,
            collisionHeight: w,
            offset: e,
            my: b.my,
            at: b.at,
          });
      });
      c.fn.bgiframe && f.bgiframe();
      f.offset(c.extend(i, { using: b.using }));
    });
  };
  c.ui.position = {
    fit: {
      left: function (b, a) {
        var d = c(window);
        d = a.collisionPosition.left + a.collisionWidth - d.width() - d.scrollLeft();
        b.left = d > 0 ? b.left - d : Math.max(b.left - a.collisionPosition.left, b.left);
      },
      top: function (b, a) {
        var d = c(window);
        d = a.collisionPosition.top + a.collisionHeight - d.height() - d.scrollTop();
        b.top = d > 0 ? b.top - d : Math.max(b.top - a.collisionPosition.top, b.top);
      },
    },
    flip: {
      left: function (b, a) {
        if (a.at[0] !== 'center') {
          var d = c(window);
          d = a.collisionPosition.left + a.collisionWidth - d.width() - d.scrollLeft();
          var g = a.my[0] === 'left' ? -a.elemWidth : a.my[0] === 'right' ? a.elemWidth : 0,
            e = a.at[0] === 'left' ? a.targetWidth : -a.targetWidth,
            h = -2 * a.offset[0];
          b.left += a.collisionPosition.left < 0 ? g + e + h : d > 0 ? g + e + h : 0;
        }
      },
      top: function (b, a) {
        if (a.at[1] !== 'center') {
          var d = c(window);
          d = a.collisionPosition.top + a.collisionHeight - d.height() - d.scrollTop();
          var g = a.my[1] === 'top' ? -a.elemHeight : a.my[1] === 'bottom' ? a.elemHeight : 0,
            e = a.at[1] === 'top' ? a.targetHeight : -a.targetHeight,
            h = -2 * a.offset[1];
          b.top += a.collisionPosition.top < 0 ? g + e + h : d > 0 ? g + e + h : 0;
        }
      },
    },
  };
  if (!c.offset.setOffset) {
    c.offset.setOffset = function (b, a) {
      if (/static/.test(c.curCSS(b, 'position'))) b.style.position = 'relative';
      var d = c(b),
        g = d.offset(),
        e = parseInt(c.curCSS(b, 'top', true), 10) || 0,
        h = parseInt(c.curCSS(b, 'left', true), 10) || 0;
      g = { top: a.top - g.top + e, left: a.left - g.left + h };
      'using' in a ? a.using.call(b, g) : d.css(g);
    };
    c.fn.offset = function (b) {
      var a = this[0];
      if (!a || !a.ownerDocument) return null;
      if (b)
        return this.each(function () {
          c.offset.setOffset(this, b);
        });
      return u.call(this);
    };
  }
})(jQuery);
/*
 * jQuery UI Draggable 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Draggables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function (d) {
  d.widget('ui.draggable', d.ui.mouse, {
    widgetEventPrefix: 'drag',
    options: {
      addClasses: true,
      appendTo: 'parent',
      axis: false,
      connectToSortable: false,
      containment: false,
      cursor: 'auto',
      cursorAt: false,
      grid: false,
      handle: false,
      helper: 'original',
      iframeFix: false,
      opacity: false,
      refreshPositions: false,
      revert: false,
      revertDuration: 500,
      scope: 'default',
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      snap: false,
      snapMode: 'both',
      snapTolerance: 20,
      stack: false,
      zIndex: false,
    },
    _create: function () {
      if (this.options.helper == 'original' && !/^(?:r|a|f)/.test(this.element.css('position')))
        this.element[0].style.position = 'relative';
      this.options.addClasses && this.element.addClass('ui-draggable');
      this.options.disabled && this.element.addClass('ui-draggable-disabled');
      this._mouseInit();
    },
    destroy: function () {
      if (this.element.data('draggable')) {
        this.element
          .removeData('draggable')
          .unbind('.draggable')
          .removeClass('ui-draggable ui-draggable-dragging ui-draggable-disabled');
        this._mouseDestroy();
        return this;
      }
    },
    _mouseCapture: function (a) {
      var b = this.options;
      if (this.helper || b.disabled || d(a.target).is('.ui-resizable-handle')) return false;
      this.handle = this._getHandle(a);
      if (!this.handle) return false;
      if (b.iframeFix)
        d(b.iframeFix === true ? 'iframe' : b.iframeFix).each(function () {
          d('<div class="ui-draggable-iframeFix" style="background: #fff;"></div>')
            .css({
              width: this.offsetWidth + 'px',
              height: this.offsetHeight + 'px',
              position: 'absolute',
              opacity: '0.001',
              zIndex: 1e3,
            })
            .css(d(this).offset())
            .appendTo('body');
        });
      return true;
    },
    _mouseStart: function (a) {
      var b = this.options;
      this.helper = this._createHelper(a);
      this._cacheHelperProportions();
      if (d.ui.ddmanager) d.ui.ddmanager.current = this;
      this._cacheMargins();
      this.cssPosition = this.helper.css('position');
      this.scrollParent = this.helper.scrollParent();
      this.offset = this.positionAbs = this.element.offset();
      this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left };
      d.extend(this.offset, {
        click: { left: a.pageX - this.offset.left, top: a.pageY - this.offset.top },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(),
      });
      this.originalPosition = this.position = this._generatePosition(a);
      this.originalPageX = a.pageX;
      this.originalPageY = a.pageY;
      b.cursorAt && this._adjustOffsetFromHelper(b.cursorAt);
      b.containment && this._setContainment();
      if (this._trigger('start', a) === false) {
        this._clear();
        return false;
      }
      this._cacheHelperProportions();
      d.ui.ddmanager && !b.dropBehaviour && d.ui.ddmanager.prepareOffsets(this, a);
      this.helper.addClass('ui-draggable-dragging');
      this._mouseDrag(a, true);
      d.ui.ddmanager && d.ui.ddmanager.dragStart(this, a);
      return true;
    },
    _mouseDrag: function (a, b) {
      this.position = this._generatePosition(a);
      this.positionAbs = this._convertPositionTo('absolute');
      if (!b) {
        b = this._uiHash();
        if (this._trigger('drag', a, b) === false) {
          this._mouseUp({});
          return false;
        }
        this.position = b.position;
      }
      if (!this.options.axis || this.options.axis != 'y') this.helper[0].style.left = this.position.left + 'px';
      if (!this.options.axis || this.options.axis != 'x') this.helper[0].style.top = this.position.top + 'px';
      d.ui.ddmanager && d.ui.ddmanager.drag(this, a);
      return false;
    },
    _mouseStop: function (a) {
      var b = false;
      if (d.ui.ddmanager && !this.options.dropBehaviour) b = d.ui.ddmanager.drop(this, a);
      if (this.dropped) {
        b = this.dropped;
        this.dropped = false;
      }
      if ((!this.element[0] || !this.element[0].parentNode) && this.options.helper == 'original') return false;
      if (
        (this.options.revert == 'invalid' && !b) ||
        (this.options.revert == 'valid' && b) ||
        this.options.revert === true ||
        (d.isFunction(this.options.revert) && this.options.revert.call(this.element, b))
      ) {
        var c = this;
        d(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
          c._trigger('stop', a) !== false && c._clear();
        });
      } else this._trigger('stop', a) !== false && this._clear();
      return false;
    },
    _mouseUp: function (a) {
      this.options.iframeFix === true &&
        d('div.ui-draggable-iframeFix').each(function () {
          this.parentNode.removeChild(this);
        });
      d.ui.ddmanager && d.ui.ddmanager.dragStop(this, a);
      return d.ui.mouse.prototype._mouseUp.call(this, a);
    },
    cancel: function () {
      this.helper.is('.ui-draggable-dragging') ? this._mouseUp({}) : this._clear();
      return this;
    },
    _getHandle: function (a) {
      var b = !this.options.handle || !d(this.options.handle, this.element).length ? true : false;
      d(this.options.handle, this.element)
        .find('*')
        .andSelf()
        .each(function () {
          if (this == a.target) b = true;
        });
      return b;
    },
    _createHelper: function (a) {
      var b = this.options;
      a = d.isFunction(b.helper)
        ? d(b.helper.apply(this.element[0], [a]))
        : b.helper == 'clone'
        ? this.element.clone().removeAttr('id')
        : this.element;
      a.parents('body').length || a.appendTo(b.appendTo == 'parent' ? this.element[0].parentNode : b.appendTo);
      a[0] != this.element[0] && !/(fixed|absolute)/.test(a.css('position')) && a.css('position', 'absolute');
      return a;
    },
    _adjustOffsetFromHelper: function (a) {
      if (typeof a == 'string') a = a.split(' ');
      if (d.isArray(a)) a = { left: +a[0], top: +a[1] || 0 };
      if ('left' in a) this.offset.click.left = a.left + this.margins.left;
      if ('right' in a) this.offset.click.left = this.helperProportions.width - a.right + this.margins.left;
      if ('top' in a) this.offset.click.top = a.top + this.margins.top;
      if ('bottom' in a) this.offset.click.top = this.helperProportions.height - a.bottom + this.margins.top;
    },
    _getParentOffset: function () {
      this.offsetParent = this.helper.offsetParent();
      var a = this.offsetParent.offset();
      if (
        this.cssPosition == 'absolute' &&
        this.scrollParent[0] != document &&
        d.ui.contains(this.scrollParent[0], this.offsetParent[0])
      ) {
        a.left += this.scrollParent.scrollLeft();
        a.top += this.scrollParent.scrollTop();
      }
      if (
        this.offsetParent[0] == document.body ||
        (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() == 'html' && d.browser.msie)
      )
        a = { top: 0, left: 0 };
      return {
        top: a.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left: a.left + (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
      };
    },
    _getRelativeOffset: function () {
      if (this.cssPosition == 'relative') {
        var a = this.element.position();
        return {
          top: a.top - (parseInt(this.helper.css('top'), 10) || 0) + this.scrollParent.scrollTop(),
          left: a.left - (parseInt(this.helper.css('left'), 10) || 0) + this.scrollParent.scrollLeft(),
        };
      } else return { top: 0, left: 0 };
    },
    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.element.css('marginLeft'), 10) || 0,
        top: parseInt(this.element.css('marginTop'), 10) || 0,
        right: parseInt(this.element.css('marginRight'), 10) || 0,
        bottom: parseInt(this.element.css('marginBottom'), 10) || 0,
      };
    },
    _cacheHelperProportions: function () {
      this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
    },
    _setContainment: function () {
      var a = this.options;
      if (a.containment == 'parent') a.containment = this.helper[0].parentNode;
      if (a.containment == 'document' || a.containment == 'window')
        this.containment = [
          a.containment == 'document'
            ? 0
            : d(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
          a.containment == 'document' ? 0 : d(window).scrollTop() - this.offset.relative.top - this.offset.parent.top,
          (a.containment == 'document' ? 0 : d(window).scrollLeft()) +
            d(a.containment == 'document' ? document : window).width() -
            this.helperProportions.width -
            this.margins.left,
          (a.containment == 'document' ? 0 : d(window).scrollTop()) +
            (d(a.containment == 'document' ? document : window).height() || document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
      if (!/^(document|window|parent)$/.test(a.containment) && a.containment.constructor != Array) {
        a = d(a.containment);
        var b = a[0];
        if (b) {
          a.offset();
          var c = d(b).css('overflow') != 'hidden';
          this.containment = [
            (parseInt(d(b).css('borderLeftWidth'), 10) || 0) + (parseInt(d(b).css('paddingLeft'), 10) || 0),
            (parseInt(d(b).css('borderTopWidth'), 10) || 0) + (parseInt(d(b).css('paddingTop'), 10) || 0),
            (c ? Math.max(b.scrollWidth, b.offsetWidth) : b.offsetWidth) -
              (parseInt(d(b).css('borderLeftWidth'), 10) || 0) -
              (parseInt(d(b).css('paddingRight'), 10) || 0) -
              this.helperProportions.width -
              this.margins.left -
              this.margins.right,
            (c ? Math.max(b.scrollHeight, b.offsetHeight) : b.offsetHeight) -
              (parseInt(d(b).css('borderTopWidth'), 10) || 0) -
              (parseInt(d(b).css('paddingBottom'), 10) || 0) -
              this.helperProportions.height -
              this.margins.top -
              this.margins.bottom,
          ];
          this.relative_container = a;
        }
      } else if (a.containment.constructor == Array) this.containment = a.containment;
    },
    _convertPositionTo: function (a, b) {
      if (!b) b = this.position;
      a = a == 'absolute' ? 1 : -1;
      var c =
          this.cssPosition == 'absolute' &&
          !(this.scrollParent[0] != document && d.ui.contains(this.scrollParent[0], this.offsetParent[0]))
            ? this.offsetParent
            : this.scrollParent,
        f = /(html|body)/i.test(c[0].tagName);
      return {
        top:
          b.top +
          this.offset.relative.top * a +
          this.offset.parent.top * a -
          (d.browser.safari && d.browser.version < 526 && this.cssPosition == 'fixed'
            ? 0
            : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : f ? 0 : c.scrollTop()) * a),
        left:
          b.left +
          this.offset.relative.left * a +
          this.offset.parent.left * a -
          (d.browser.safari && d.browser.version < 526 && this.cssPosition == 'fixed'
            ? 0
            : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : f ? 0 : c.scrollLeft()) * a),
      };
    },
    _generatePosition: function (a) {
      var b = this.options,
        c =
          this.cssPosition == 'absolute' &&
          !(this.scrollParent[0] != document && d.ui.contains(this.scrollParent[0], this.offsetParent[0]))
            ? this.offsetParent
            : this.scrollParent,
        f = /(html|body)/i.test(c[0].tagName),
        e = a.pageX,
        h = a.pageY;
      if (this.originalPosition) {
        var g;
        if (this.containment) {
          if (this.relative_container) {
            g = this.relative_container.offset();
            g = [
              this.containment[0] + g.left,
              this.containment[1] + g.top,
              this.containment[2] + g.left,
              this.containment[3] + g.top,
            ];
          } else g = this.containment;
          if (a.pageX - this.offset.click.left < g[0]) e = g[0] + this.offset.click.left;
          if (a.pageY - this.offset.click.top < g[1]) h = g[1] + this.offset.click.top;
          if (a.pageX - this.offset.click.left > g[2]) e = g[2] + this.offset.click.left;
          if (a.pageY - this.offset.click.top > g[3]) h = g[3] + this.offset.click.top;
        }
        if (b.grid) {
          h = b.grid[1]
            ? this.originalPageY + Math.round((h - this.originalPageY) / b.grid[1]) * b.grid[1]
            : this.originalPageY;
          h = g
            ? !(h - this.offset.click.top < g[1] || h - this.offset.click.top > g[3])
              ? h
              : !(h - this.offset.click.top < g[1])
              ? h - b.grid[1]
              : h + b.grid[1]
            : h;
          e = b.grid[0]
            ? this.originalPageX + Math.round((e - this.originalPageX) / b.grid[0]) * b.grid[0]
            : this.originalPageX;
          e = g
            ? !(e - this.offset.click.left < g[0] || e - this.offset.click.left > g[2])
              ? e
              : !(e - this.offset.click.left < g[0])
              ? e - b.grid[0]
              : e + b.grid[0]
            : e;
        }
      }
      return {
        top:
          h -
          this.offset.click.top -
          this.offset.relative.top -
          this.offset.parent.top +
          (d.browser.safari && d.browser.version < 526 && this.cssPosition == 'fixed'
            ? 0
            : this.cssPosition == 'fixed'
            ? -this.scrollParent.scrollTop()
            : f
            ? 0
            : c.scrollTop()),
        left:
          e -
          this.offset.click.left -
          this.offset.relative.left -
          this.offset.parent.left +
          (d.browser.safari && d.browser.version < 526 && this.cssPosition == 'fixed'
            ? 0
            : this.cssPosition == 'fixed'
            ? -this.scrollParent.scrollLeft()
            : f
            ? 0
            : c.scrollLeft()),
      };
    },
    _clear: function () {
      this.helper.removeClass('ui-draggable-dragging');
      this.helper[0] != this.element[0] && !this.cancelHelperRemoval && this.helper.remove();
      this.helper = null;
      this.cancelHelperRemoval = false;
    },
    _trigger: function (a, b, c) {
      c = c || this._uiHash();
      d.ui.plugin.call(this, a, [b, c]);
      if (a == 'drag') this.positionAbs = this._convertPositionTo('absolute');
      return d.Widget.prototype._trigger.call(this, a, b, c);
    },
    plugins: {},
    _uiHash: function () {
      return {
        helper: this.helper,
        position: this.position,
        originalPosition: this.originalPosition,
        offset: this.positionAbs,
      };
    },
  });
  d.extend(d.ui.draggable, { version: '1.8.16' });
  d.ui.plugin.add('draggable', 'connectToSortable', {
    start: function (a, b) {
      var c = d(this).data('draggable'),
        f = c.options,
        e = d.extend({}, b, { item: c.element });
      c.sortables = [];
      d(f.connectToSortable).each(function () {
        var h = d.data(this, 'sortable');
        if (h && !h.options.disabled) {
          c.sortables.push({ instance: h, shouldRevert: h.options.revert });
          h.refreshPositions();
          h._trigger('activate', a, e);
        }
      });
    },
    stop: function (a, b) {
      var c = d(this).data('draggable'),
        f = d.extend({}, b, { item: c.element });
      d.each(c.sortables, function () {
        if (this.instance.isOver) {
          this.instance.isOver = 0;
          c.cancelHelperRemoval = true;
          this.instance.cancelHelperRemoval = false;
          if (this.shouldRevert) this.instance.options.revert = true;
          this.instance._mouseStop(a);
          this.instance.options.helper = this.instance.options._helper;
          c.options.helper == 'original' && this.instance.currentItem.css({ top: 'auto', left: 'auto' });
        } else {
          this.instance.cancelHelperRemoval = false;
          this.instance._trigger('deactivate', a, f);
        }
      });
    },
    drag: function (a, b) {
      var c = d(this).data('draggable'),
        f = this;
      d.each(c.sortables, function () {
        this.instance.positionAbs = c.positionAbs;
        this.instance.helperProportions = c.helperProportions;
        this.instance.offset.click = c.offset.click;
        if (this.instance._intersectsWith(this.instance.containerCache)) {
          if (!this.instance.isOver) {
            this.instance.isOver = 1;
            this.instance.currentItem = d(f)
              .clone()
              .removeAttr('id')
              .appendTo(this.instance.element)
              .data('sortable-item', true);
            this.instance.options._helper = this.instance.options.helper;
            this.instance.options.helper = function () {
              return b.helper[0];
            };
            a.target = this.instance.currentItem[0];
            this.instance._mouseCapture(a, true);
            this.instance._mouseStart(a, true, true);
            this.instance.offset.click.top = c.offset.click.top;
            this.instance.offset.click.left = c.offset.click.left;
            this.instance.offset.parent.left -= c.offset.parent.left - this.instance.offset.parent.left;
            this.instance.offset.parent.top -= c.offset.parent.top - this.instance.offset.parent.top;
            c._trigger('toSortable', a);
            c.dropped = this.instance.element;
            c.currentItem = c.element;
            this.instance.fromOutside = c;
          }
          this.instance.currentItem && this.instance._mouseDrag(a);
        } else if (this.instance.isOver) {
          this.instance.isOver = 0;
          this.instance.cancelHelperRemoval = true;
          this.instance.options.revert = false;
          this.instance._trigger('out', a, this.instance._uiHash(this.instance));
          this.instance._mouseStop(a, true);
          this.instance.options.helper = this.instance.options._helper;
          this.instance.currentItem.remove();
          this.instance.placeholder && this.instance.placeholder.remove();
          c._trigger('fromSortable', a);
          c.dropped = false;
        }
      });
    },
  });
  d.ui.plugin.add('draggable', 'cursor', {
    start: function () {
      var a = d('body'),
        b = d(this).data('draggable').options;
      if (a.css('cursor')) b._cursor = a.css('cursor');
      a.css('cursor', b.cursor);
    },
    stop: function () {
      var a = d(this).data('draggable').options;
      a._cursor && d('body').css('cursor', a._cursor);
    },
  });
  d.ui.plugin.add('draggable', 'opacity', {
    start: function (a, b) {
      a = d(b.helper);
      b = d(this).data('draggable').options;
      if (a.css('opacity')) b._opacity = a.css('opacity');
      a.css('opacity', b.opacity);
    },
    stop: function (a, b) {
      a = d(this).data('draggable').options;
      a._opacity && d(b.helper).css('opacity', a._opacity);
    },
  });
  d.ui.plugin.add('draggable', 'scroll', {
    start: function () {
      var a = d(this).data('draggable');
      if (a.scrollParent[0] != document && a.scrollParent[0].tagName != 'HTML')
        a.overflowOffset = a.scrollParent.offset();
    },
    drag: function (a) {
      var b = d(this).data('draggable'),
        c = b.options,
        f = false;
      if (b.scrollParent[0] != document && b.scrollParent[0].tagName != 'HTML') {
        if (!c.axis || c.axis != 'x')
          if (b.overflowOffset.top + b.scrollParent[0].offsetHeight - a.pageY < c.scrollSensitivity)
            b.scrollParent[0].scrollTop = f = b.scrollParent[0].scrollTop + c.scrollSpeed;
          else if (a.pageY - b.overflowOffset.top < c.scrollSensitivity)
            b.scrollParent[0].scrollTop = f = b.scrollParent[0].scrollTop - c.scrollSpeed;
        if (!c.axis || c.axis != 'y')
          if (b.overflowOffset.left + b.scrollParent[0].offsetWidth - a.pageX < c.scrollSensitivity)
            b.scrollParent[0].scrollLeft = f = b.scrollParent[0].scrollLeft + c.scrollSpeed;
          else if (a.pageX - b.overflowOffset.left < c.scrollSensitivity)
            b.scrollParent[0].scrollLeft = f = b.scrollParent[0].scrollLeft - c.scrollSpeed;
      } else {
        if (!c.axis || c.axis != 'x')
          if (a.pageY - d(document).scrollTop() < c.scrollSensitivity)
            f = d(document).scrollTop(d(document).scrollTop() - c.scrollSpeed);
          else if (d(window).height() - (a.pageY - d(document).scrollTop()) < c.scrollSensitivity)
            f = d(document).scrollTop(d(document).scrollTop() + c.scrollSpeed);
        if (!c.axis || c.axis != 'y')
          if (a.pageX - d(document).scrollLeft() < c.scrollSensitivity)
            f = d(document).scrollLeft(d(document).scrollLeft() - c.scrollSpeed);
          else if (d(window).width() - (a.pageX - d(document).scrollLeft()) < c.scrollSensitivity)
            f = d(document).scrollLeft(d(document).scrollLeft() + c.scrollSpeed);
      }
      f !== false && d.ui.ddmanager && !c.dropBehaviour && d.ui.ddmanager.prepareOffsets(b, a);
    },
  });
  d.ui.plugin.add('draggable', 'snap', {
    start: function () {
      var a = d(this).data('draggable'),
        b = a.options;
      a.snapElements = [];
      d(b.snap.constructor != String ? b.snap.items || ':data(draggable)' : b.snap).each(function () {
        var c = d(this),
          f = c.offset();
        this != a.element[0] &&
          a.snapElements.push({ item: this, width: c.outerWidth(), height: c.outerHeight(), top: f.top, left: f.left });
      });
    },
    drag: function (a, b) {
      for (
        var c = d(this).data('draggable'),
          f = c.options,
          e = f.snapTolerance,
          h = b.offset.left,
          g = h + c.helperProportions.width,
          n = b.offset.top,
          o = n + c.helperProportions.height,
          i = c.snapElements.length - 1;
        i >= 0;
        i--
      ) {
        var j = c.snapElements[i].left,
          l = j + c.snapElements[i].width,
          k = c.snapElements[i].top,
          m = k + c.snapElements[i].height;
        if (
          (j - e < h && h < l + e && k - e < n && n < m + e) ||
          (j - e < h && h < l + e && k - e < o && o < m + e) ||
          (j - e < g && g < l + e && k - e < n && n < m + e) ||
          (j - e < g && g < l + e && k - e < o && o < m + e)
        ) {
          if (f.snapMode != 'inner') {
            var p = Math.abs(k - o) <= e,
              q = Math.abs(m - n) <= e,
              r = Math.abs(j - g) <= e,
              s = Math.abs(l - h) <= e;
            if (p)
              b.position.top =
                c._convertPositionTo('relative', { top: k - c.helperProportions.height, left: 0 }).top - c.margins.top;
            if (q) b.position.top = c._convertPositionTo('relative', { top: m, left: 0 }).top - c.margins.top;
            if (r)
              b.position.left =
                c._convertPositionTo('relative', { top: 0, left: j - c.helperProportions.width }).left - c.margins.left;
            if (s) b.position.left = c._convertPositionTo('relative', { top: 0, left: l }).left - c.margins.left;
          }
          var t = p || q || r || s;
          if (f.snapMode != 'outer') {
            p = Math.abs(k - n) <= e;
            q = Math.abs(m - o) <= e;
            r = Math.abs(j - h) <= e;
            s = Math.abs(l - g) <= e;
            if (p) b.position.top = c._convertPositionTo('relative', { top: k, left: 0 }).top - c.margins.top;
            if (q)
              b.position.top =
                c._convertPositionTo('relative', { top: m - c.helperProportions.height, left: 0 }).top - c.margins.top;
            if (r) b.position.left = c._convertPositionTo('relative', { top: 0, left: j }).left - c.margins.left;
            if (s)
              b.position.left =
                c._convertPositionTo('relative', { top: 0, left: l - c.helperProportions.width }).left - c.margins.left;
          }
          if (!c.snapElements[i].snapping && (p || q || r || s || t))
            c.options.snap.snap &&
              c.options.snap.snap.call(c.element, a, d.extend(c._uiHash(), { snapItem: c.snapElements[i].item }));
          c.snapElements[i].snapping = p || q || r || s || t;
        } else {
          c.snapElements[i].snapping &&
            c.options.snap.release &&
            c.options.snap.release.call(c.element, a, d.extend(c._uiHash(), { snapItem: c.snapElements[i].item }));
          c.snapElements[i].snapping = false;
        }
      }
    },
  });
  d.ui.plugin.add('draggable', 'stack', {
    start: function () {
      var a = d(this).data('draggable').options;
      a = d.makeArray(d(a.stack)).sort(function (c, f) {
        return (parseInt(d(c).css('zIndex'), 10) || 0) - (parseInt(d(f).css('zIndex'), 10) || 0);
      });
      if (a.length) {
        var b = parseInt(a[0].style.zIndex) || 0;
        d(a).each(function (c) {
          this.style.zIndex = b + c;
        });
        this[0].style.zIndex = b + a.length;
      }
    },
  });
  d.ui.plugin.add('draggable', 'zIndex', {
    start: function (a, b) {
      a = d(b.helper);
      b = d(this).data('draggable').options;
      if (a.css('zIndex')) b._zIndex = a.css('zIndex');
      a.css('zIndex', b.zIndex);
    },
    stop: function (a, b) {
      a = d(this).data('draggable').options;
      a._zIndex && d(b.helper).css('zIndex', a._zIndex);
    },
  });
})(jQuery);
/*
 * jQuery UI Droppable 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Droppables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.widget.js
 *	jquery.ui.mouse.js
 *	jquery.ui.draggable.js
 */
(function (d) {
  d.widget('ui.droppable', {
    widgetEventPrefix: 'drop',
    options: {
      accept: '*',
      activeClass: false,
      addClasses: true,
      greedy: false,
      hoverClass: false,
      scope: 'default',
      tolerance: 'intersect',
    },
    _create: function () {
      var a = this.options,
        b = a.accept;
      this.isover = 0;
      this.isout = 1;
      this.accept = d.isFunction(b)
        ? b
        : function (c) {
            return c.is(b);
          };
      this.proportions = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight };
      d.ui.ddmanager.droppables[a.scope] = d.ui.ddmanager.droppables[a.scope] || [];
      d.ui.ddmanager.droppables[a.scope].push(this);
      a.addClasses && this.element.addClass('ui-droppable');
    },
    destroy: function () {
      for (var a = d.ui.ddmanager.droppables[this.options.scope], b = 0; b < a.length; b++)
        a[b] == this && a.splice(b, 1);
      this.element.removeClass('ui-droppable ui-droppable-disabled').removeData('droppable').unbind('.droppable');
      return this;
    },
    _setOption: function (a, b) {
      if (a == 'accept')
        this.accept = d.isFunction(b)
          ? b
          : function (c) {
              return c.is(b);
            };
      d.Widget.prototype._setOption.apply(this, arguments);
    },
    _activate: function (a) {
      var b = d.ui.ddmanager.current;
      this.options.activeClass && this.element.addClass(this.options.activeClass);
      b && this._trigger('activate', a, this.ui(b));
    },
    _deactivate: function (a) {
      var b = d.ui.ddmanager.current;
      this.options.activeClass && this.element.removeClass(this.options.activeClass);
      b && this._trigger('deactivate', a, this.ui(b));
    },
    _over: function (a) {
      var b = d.ui.ddmanager.current;
      if (!(!b || (b.currentItem || b.element)[0] == this.element[0]))
        if (this.accept.call(this.element[0], b.currentItem || b.element)) {
          this.options.hoverClass && this.element.addClass(this.options.hoverClass);
          this._trigger('over', a, this.ui(b));
        }
    },
    _out: function (a) {
      var b = d.ui.ddmanager.current;
      if (!(!b || (b.currentItem || b.element)[0] == this.element[0]))
        if (this.accept.call(this.element[0], b.currentItem || b.element)) {
          this.options.hoverClass && this.element.removeClass(this.options.hoverClass);
          this._trigger('out', a, this.ui(b));
        }
    },
    _drop: function (a, b) {
      var c = b || d.ui.ddmanager.current;
      if (!c || (c.currentItem || c.element)[0] == this.element[0]) return false;
      var e = false;
      this.element
        .find(':data(droppable)')
        .not('.ui-draggable-dragging')
        .each(function () {
          var g = d.data(this, 'droppable');
          if (
            g.options.greedy &&
            !g.options.disabled &&
            g.options.scope == c.options.scope &&
            g.accept.call(g.element[0], c.currentItem || c.element) &&
            d.ui.intersect(c, d.extend(g, { offset: g.element.offset() }), g.options.tolerance)
          ) {
            e = true;
            return false;
          }
        });
      if (e) return false;
      if (this.accept.call(this.element[0], c.currentItem || c.element)) {
        this.options.activeClass && this.element.removeClass(this.options.activeClass);
        this.options.hoverClass && this.element.removeClass(this.options.hoverClass);
        this._trigger('drop', a, this.ui(c));
        return this.element;
      }
      return false;
    },
    ui: function (a) {
      return { draggable: a.currentItem || a.element, helper: a.helper, position: a.position, offset: a.positionAbs };
    },
  });
  d.extend(d.ui.droppable, { version: '1.8.16' });
  d.ui.intersect = function (a, b, c) {
    if (!b.offset) return false;
    var e = (a.positionAbs || a.position.absolute).left,
      g = e + a.helperProportions.width,
      f = (a.positionAbs || a.position.absolute).top,
      h = f + a.helperProportions.height,
      i = b.offset.left,
      k = i + b.proportions.width,
      j = b.offset.top,
      l = j + b.proportions.height;
    switch (c) {
      case 'fit':
        return i <= e && g <= k && j <= f && h <= l;
      case 'intersect':
        return (
          i < e + a.helperProportions.width / 2 &&
          g - a.helperProportions.width / 2 < k &&
          j < f + a.helperProportions.height / 2 &&
          h - a.helperProportions.height / 2 < l
        );
      case 'pointer':
        return d.ui.isOver(
          (a.positionAbs || a.position.absolute).top + (a.clickOffset || a.offset.click).top,
          (a.positionAbs || a.position.absolute).left + (a.clickOffset || a.offset.click).left,
          j,
          i,
          b.proportions.height,
          b.proportions.width,
        );
      case 'touch':
        return (
          ((f >= j && f <= l) || (h >= j && h <= l) || (f < j && h > l)) &&
          ((e >= i && e <= k) || (g >= i && g <= k) || (e < i && g > k))
        );
      default:
        return false;
    }
  };
  d.ui.ddmanager = {
    current: null,
    droppables: { default: [] },
    prepareOffsets: function (a, b) {
      var c = d.ui.ddmanager.droppables[a.options.scope] || [],
        e = b ? b.type : null,
        g = (a.currentItem || a.element).find(':data(droppable)').andSelf(),
        f = 0;
      a: for (; f < c.length; f++)
        if (!(c[f].options.disabled || (a && !c[f].accept.call(c[f].element[0], a.currentItem || a.element)))) {
          for (var h = 0; h < g.length; h++)
            if (g[h] == c[f].element[0]) {
              c[f].proportions.height = 0;
              continue a;
            }
          c[f].visible = c[f].element.css('display') != 'none';
          if (c[f].visible) {
            e == 'mousedown' && c[f]._activate.call(c[f], b);
            c[f].offset = c[f].element.offset();
            c[f].proportions = { width: c[f].element[0].offsetWidth, height: c[f].element[0].offsetHeight };
          }
        }
    },
    drop: function (a, b) {
      var c = false;
      d.each(d.ui.ddmanager.droppables[a.options.scope] || [], function () {
        if (this.options) {
          if (!this.options.disabled && this.visible && d.ui.intersect(a, this, this.options.tolerance))
            c = c || this._drop.call(this, b);
          if (!this.options.disabled && this.visible && this.accept.call(this.element[0], a.currentItem || a.element)) {
            this.isout = 1;
            this.isover = 0;
            this._deactivate.call(this, b);
          }
        }
      });
      return c;
    },
    dragStart: function (a, b) {
      a.element.parents(':not(body,html)').bind('scroll.droppable', function () {
        a.options.refreshPositions || d.ui.ddmanager.prepareOffsets(a, b);
      });
    },
    drag: function (a, b) {
      a.options.refreshPositions && d.ui.ddmanager.prepareOffsets(a, b);
      d.each(d.ui.ddmanager.droppables[a.options.scope] || [], function () {
        if (!(this.options.disabled || this.greedyChild || !this.visible)) {
          var c = d.ui.intersect(a, this, this.options.tolerance);
          if ((c = !c && this.isover == 1 ? 'isout' : c && this.isover == 0 ? 'isover' : null)) {
            var e;
            if (this.options.greedy) {
              var g = this.element.parents(':data(droppable):eq(0)');
              if (g.length) {
                e = d.data(g[0], 'droppable');
                e.greedyChild = c == 'isover' ? 1 : 0;
              }
            }
            if (e && c == 'isover') {
              e.isover = 0;
              e.isout = 1;
              e._out.call(e, b);
            }
            this[c] = 1;
            this[c == 'isout' ? 'isover' : 'isout'] = 0;
            this[c == 'isover' ? '_over' : '_out'].call(this, b);
            if (e && c == 'isout') {
              e.isout = 0;
              e.isover = 1;
              e._over.call(e, b);
            }
          }
        }
      });
    },
    dragStop: function (a, b) {
      a.element.parents(':not(body,html)').unbind('scroll.droppable');
      a.options.refreshPositions || d.ui.ddmanager.prepareOffsets(a, b);
    },
  };
})(jQuery);
/*
 * jQuery UI Resizable 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Resizables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function (e) {
  e.widget('ui.resizable', e.ui.mouse, {
    widgetEventPrefix: 'resize',
    options: {
      alsoResize: false,
      animate: false,
      animateDuration: 'slow',
      animateEasing: 'swing',
      aspectRatio: false,
      autoHide: false,
      containment: false,
      ghost: false,
      grid: false,
      handles: 'e,s,se',
      helper: false,
      maxHeight: null,
      maxWidth: null,
      minHeight: 10,
      minWidth: 10,
      zIndex: 1e3,
    },
    _create: function () {
      var b = this,
        a = this.options;
      this.element.addClass('ui-resizable');
      e.extend(this, {
        _aspectRatio: !!a.aspectRatio,
        aspectRatio: a.aspectRatio,
        originalElement: this.element,
        _proportionallyResizeElements: [],
        _helper: a.helper || a.ghost || a.animate ? a.helper || 'ui-resizable-helper' : null,
      });
      if (this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)) {
        /relative/.test(this.element.css('position')) &&
          e.browser.opera &&
          this.element.css({ position: 'relative', top: 'auto', left: 'auto' });
        this.element.wrap(
          e('<div class="ui-wrapper" style="overflow: hidden;"></div>').css({
            position: this.element.css('position'),
            width: this.element.outerWidth(),
            height: this.element.outerHeight(),
            top: this.element.css('top'),
            left: this.element.css('left'),
          }),
        );
        this.element = this.element.parent().data('resizable', this.element.data('resizable'));
        this.elementIsWrapper = true;
        this.element.css({
          marginLeft: this.originalElement.css('marginLeft'),
          marginTop: this.originalElement.css('marginTop'),
          marginRight: this.originalElement.css('marginRight'),
          marginBottom: this.originalElement.css('marginBottom'),
        });
        this.originalElement.css({ marginLeft: 0, marginTop: 0, marginRight: 0, marginBottom: 0 });
        this.originalResizeStyle = this.originalElement.css('resize');
        this.originalElement.css('resize', 'none');
        this._proportionallyResizeElements.push(
          this.originalElement.css({ position: 'static', zoom: 1, display: 'block' }),
        );
        this.originalElement.css({ margin: this.originalElement.css('margin') });
        this._proportionallyResize();
      }
      this.handles =
        a.handles ||
        (!e('.ui-resizable-handle', this.element).length
          ? 'e,s,se'
          : {
              n: '.ui-resizable-n',
              e: '.ui-resizable-e',
              s: '.ui-resizable-s',
              w: '.ui-resizable-w',
              se: '.ui-resizable-se',
              sw: '.ui-resizable-sw',
              ne: '.ui-resizable-ne',
              nw: '.ui-resizable-nw',
            });
      if (this.handles.constructor == String) {
        if (this.handles == 'all') this.handles = 'n,e,s,w,se,sw,ne,nw';
        var c = this.handles.split(',');
        this.handles = {};
        for (var d = 0; d < c.length; d++) {
          var f = e.trim(c[d]),
            g = e('<div class="ui-resizable-handle ' + ('ui-resizable-' + f) + '"></div>');
          /sw|se|ne|nw/.test(f) && g.css({ zIndex: ++a.zIndex });
          'se' == f && g.addClass('ui-icon ui-icon-gripsmall-diagonal-se');
          this.handles[f] = '.ui-resizable-' + f;
          this.element.append(g);
        }
      }
      this._renderAxis = function (h) {
        h = h || this.element;
        for (var i in this.handles) {
          if (this.handles[i].constructor == String) this.handles[i] = e(this.handles[i], this.element).show();
          if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/textarea|input|select|button/i)) {
            var j = e(this.handles[i], this.element),
              l = 0;
            l = /sw|ne|nw|se|n|s/.test(i) ? j.outerHeight() : j.outerWidth();
            j = [
              'padding',
              /ne|nw|n/.test(i) ? 'Top' : /se|sw|s/.test(i) ? 'Bottom' : /^e$/.test(i) ? 'Right' : 'Left',
            ].join('');
            h.css(j, l);
            this._proportionallyResize();
          }
          e(this.handles[i]);
        }
      };
      this._renderAxis(this.element);
      this._handles = e('.ui-resizable-handle', this.element).disableSelection();
      this._handles.mouseover(function () {
        if (!b.resizing) {
          if (this.className) var h = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
          b.axis = h && h[1] ? h[1] : 'se';
        }
      });
      if (a.autoHide) {
        this._handles.hide();
        e(this.element)
          .addClass('ui-resizable-autohide')
          .hover(
            function () {
              if (!a.disabled) {
                e(this).removeClass('ui-resizable-autohide');
                b._handles.show();
              }
            },
            function () {
              if (!a.disabled)
                if (!b.resizing) {
                  e(this).addClass('ui-resizable-autohide');
                  b._handles.hide();
                }
            },
          );
      }
      this._mouseInit();
    },
    destroy: function () {
      this._mouseDestroy();
      var b = function (c) {
        e(c)
          .removeClass('ui-resizable ui-resizable-disabled ui-resizable-resizing')
          .removeData('resizable')
          .unbind('.resizable')
          .find('.ui-resizable-handle')
          .remove();
      };
      if (this.elementIsWrapper) {
        b(this.element);
        var a = this.element;
        a.after(
          this.originalElement.css({
            position: a.css('position'),
            width: a.outerWidth(),
            height: a.outerHeight(),
            top: a.css('top'),
            left: a.css('left'),
          }),
        ).remove();
      }
      this.originalElement.css('resize', this.originalResizeStyle);
      b(this.originalElement);
      return this;
    },
    _mouseCapture: function (b) {
      var a = false;
      for (var c in this.handles) if (e(this.handles[c])[0] == b.target) a = true;
      return !this.options.disabled && a;
    },
    _mouseStart: function (b) {
      var a = this.options,
        c = this.element.position(),
        d = this.element;
      this.resizing = true;
      this.documentScroll = { top: e(document).scrollTop(), left: e(document).scrollLeft() };
      if (d.is('.ui-draggable') || /absolute/.test(d.css('position')))
        d.css({ position: 'absolute', top: c.top, left: c.left });
      e.browser.opera &&
        /relative/.test(d.css('position')) &&
        d.css({ position: 'relative', top: 'auto', left: 'auto' });
      this._renderProxy();
      c = m(this.helper.css('left'));
      var f = m(this.helper.css('top'));
      if (a.containment) {
        c += e(a.containment).scrollLeft() || 0;
        f += e(a.containment).scrollTop() || 0;
      }
      this.offset = this.helper.offset();
      this.position = { left: c, top: f };
      this.size = this._helper
        ? { width: d.outerWidth(), height: d.outerHeight() }
        : { width: d.width(), height: d.height() };
      this.originalSize = this._helper
        ? { width: d.outerWidth(), height: d.outerHeight() }
        : { width: d.width(), height: d.height() };
      this.originalPosition = { left: c, top: f };
      this.sizeDiff = { width: d.outerWidth() - d.width(), height: d.outerHeight() - d.height() };
      this.originalMousePosition = { left: b.pageX, top: b.pageY };
      this.aspectRatio =
        typeof a.aspectRatio == 'number' ? a.aspectRatio : this.originalSize.width / this.originalSize.height || 1;
      a = e('.ui-resizable-' + this.axis).css('cursor');
      e('body').css('cursor', a == 'auto' ? this.axis + '-resize' : a);
      d.addClass('ui-resizable-resizing');
      this._propagate('start', b);
      return true;
    },
    _mouseDrag: function (b) {
      var a = this.helper,
        c = this.originalMousePosition,
        d = this._change[this.axis];
      if (!d) return false;
      c = d.apply(this, [b, b.pageX - c.left || 0, b.pageY - c.top || 0]);
      this._updateVirtualBoundaries(b.shiftKey);
      if (this._aspectRatio || b.shiftKey) c = this._updateRatio(c, b);
      c = this._respectSize(c, b);
      this._propagate('resize', b);
      a.css({
        top: this.position.top + 'px',
        left: this.position.left + 'px',
        width: this.size.width + 'px',
        height: this.size.height + 'px',
      });
      !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize();
      this._updateCache(c);
      this._trigger('resize', b, this.ui());
      return false;
    },
    _mouseStop: function (b) {
      this.resizing = false;
      var a = this.options,
        c = this;
      if (this._helper) {
        var d = this._proportionallyResizeElements,
          f = d.length && /textarea/i.test(d[0].nodeName);
        d = f && e.ui.hasScroll(d[0], 'left') ? 0 : c.sizeDiff.height;
        f = f ? 0 : c.sizeDiff.width;
        f = { width: c.helper.width() - f, height: c.helper.height() - d };
        d = parseInt(c.element.css('left'), 10) + (c.position.left - c.originalPosition.left) || null;
        var g = parseInt(c.element.css('top'), 10) + (c.position.top - c.originalPosition.top) || null;
        a.animate || this.element.css(e.extend(f, { top: g, left: d }));
        c.helper.height(c.size.height);
        c.helper.width(c.size.width);
        this._helper && !a.animate && this._proportionallyResize();
      }
      e('body').css('cursor', 'auto');
      this.element.removeClass('ui-resizable-resizing');
      this._propagate('stop', b);
      this._helper && this.helper.remove();
      return false;
    },
    _updateVirtualBoundaries: function (b) {
      var a = this.options,
        c,
        d,
        f;
      a = {
        minWidth: k(a.minWidth) ? a.minWidth : 0,
        maxWidth: k(a.maxWidth) ? a.maxWidth : Infinity,
        minHeight: k(a.minHeight) ? a.minHeight : 0,
        maxHeight: k(a.maxHeight) ? a.maxHeight : Infinity,
      };
      if (this._aspectRatio || b) {
        b = a.minHeight * this.aspectRatio;
        d = a.minWidth / this.aspectRatio;
        c = a.maxHeight * this.aspectRatio;
        f = a.maxWidth / this.aspectRatio;
        if (b > a.minWidth) a.minWidth = b;
        if (d > a.minHeight) a.minHeight = d;
        if (c < a.maxWidth) a.maxWidth = c;
        if (f < a.maxHeight) a.maxHeight = f;
      }
      this._vBoundaries = a;
    },
    _updateCache: function (b) {
      this.offset = this.helper.offset();
      if (k(b.left)) this.position.left = b.left;
      if (k(b.top)) this.position.top = b.top;
      if (k(b.height)) this.size.height = b.height;
      if (k(b.width)) this.size.width = b.width;
    },
    _updateRatio: function (b) {
      var a = this.position,
        c = this.size,
        d = this.axis;
      if (k(b.height)) b.width = b.height * this.aspectRatio;
      else if (k(b.width)) b.height = b.width / this.aspectRatio;
      if (d == 'sw') {
        b.left = a.left + (c.width - b.width);
        b.top = null;
      }
      if (d == 'nw') {
        b.top = a.top + (c.height - b.height);
        b.left = a.left + (c.width - b.width);
      }
      return b;
    },
    _respectSize: function (b) {
      var a = this._vBoundaries,
        c = this.axis,
        d = k(b.width) && a.maxWidth && a.maxWidth < b.width,
        f = k(b.height) && a.maxHeight && a.maxHeight < b.height,
        g = k(b.width) && a.minWidth && a.minWidth > b.width,
        h = k(b.height) && a.minHeight && a.minHeight > b.height;
      if (g) b.width = a.minWidth;
      if (h) b.height = a.minHeight;
      if (d) b.width = a.maxWidth;
      if (f) b.height = a.maxHeight;
      var i = this.originalPosition.left + this.originalSize.width,
        j = this.position.top + this.size.height,
        l = /sw|nw|w/.test(c);
      c = /nw|ne|n/.test(c);
      if (g && l) b.left = i - a.minWidth;
      if (d && l) b.left = i - a.maxWidth;
      if (h && c) b.top = j - a.minHeight;
      if (f && c) b.top = j - a.maxHeight;
      if ((a = !b.width && !b.height) && !b.left && b.top) b.top = null;
      else if (a && !b.top && b.left) b.left = null;
      return b;
    },
    _proportionallyResize: function () {
      if (this._proportionallyResizeElements.length)
        for (var b = this.helper || this.element, a = 0; a < this._proportionallyResizeElements.length; a++) {
          var c = this._proportionallyResizeElements[a];
          if (!this.borderDif) {
            var d = [
                c.css('borderTopWidth'),
                c.css('borderRightWidth'),
                c.css('borderBottomWidth'),
                c.css('borderLeftWidth'),
              ],
              f = [c.css('paddingTop'), c.css('paddingRight'), c.css('paddingBottom'), c.css('paddingLeft')];
            this.borderDif = e.map(d, function (g, h) {
              g = parseInt(g, 10) || 0;
              h = parseInt(f[h], 10) || 0;
              return g + h;
            });
          }
          (e.browser.msie && (e(b).is(':hidden') || e(b).parents(':hidden').length)) ||
            c.css({
              height: b.height() - this.borderDif[0] - this.borderDif[2] || 0,
              width: b.width() - this.borderDif[1] - this.borderDif[3] || 0,
            });
        }
    },
    _renderProxy: function () {
      var b = this.options;
      this.elementOffset = this.element.offset();
      if (this._helper) {
        this.helper = this.helper || e('<div style="overflow:hidden;"></div>');
        var a = e.browser.msie && e.browser.version < 7,
          c = a ? 1 : 0;
        a = a ? 2 : -1;
        this.helper.addClass(this._helper).css({
          width: this.element.outerWidth() + a,
          height: this.element.outerHeight() + a,
          position: 'absolute',
          left: this.elementOffset.left - c + 'px',
          top: this.elementOffset.top - c + 'px',
          zIndex: ++b.zIndex,
        });
        this.helper.appendTo('body').disableSelection();
      } else this.helper = this.element;
    },
    _change: {
      e: function (b, a) {
        return { width: this.originalSize.width + a };
      },
      w: function (b, a) {
        return { left: this.originalPosition.left + a, width: this.originalSize.width - a };
      },
      n: function (b, a, c) {
        return { top: this.originalPosition.top + c, height: this.originalSize.height - c };
      },
      s: function (b, a, c) {
        return { height: this.originalSize.height + c };
      },
      se: function (b, a, c) {
        return e.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [b, a, c]));
      },
      sw: function (b, a, c) {
        return e.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [b, a, c]));
      },
      ne: function (b, a, c) {
        return e.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [b, a, c]));
      },
      nw: function (b, a, c) {
        return e.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [b, a, c]));
      },
    },
    _propagate: function (b, a) {
      e.ui.plugin.call(this, b, [a, this.ui()]);
      b != 'resize' && this._trigger(b, a, this.ui());
    },
    plugins: {},
    ui: function () {
      return {
        originalElement: this.originalElement,
        element: this.element,
        helper: this.helper,
        position: this.position,
        size: this.size,
        originalSize: this.originalSize,
        originalPosition: this.originalPosition,
      };
    },
  });
  e.extend(e.ui.resizable, { version: '1.8.16' });
  e.ui.plugin.add('resizable', 'alsoResize', {
    start: function () {
      var b = e(this).data('resizable').options,
        a = function (c) {
          e(c).each(function () {
            var d = e(this);
            d.data('resizable-alsoresize', {
              width: parseInt(d.width(), 10),
              height: parseInt(d.height(), 10),
              left: parseInt(d.css('left'), 10),
              top: parseInt(d.css('top'), 10),
              position: d.css('position'),
            });
          });
        };
      if (typeof b.alsoResize == 'object' && !b.alsoResize.parentNode)
        if (b.alsoResize.length) {
          b.alsoResize = b.alsoResize[0];
          a(b.alsoResize);
        } else
          e.each(b.alsoResize, function (c) {
            a(c);
          });
      else a(b.alsoResize);
    },
    resize: function (b, a) {
      var c = e(this).data('resizable');
      b = c.options;
      var d = c.originalSize,
        f = c.originalPosition,
        g = {
          height: c.size.height - d.height || 0,
          width: c.size.width - d.width || 0,
          top: c.position.top - f.top || 0,
          left: c.position.left - f.left || 0,
        },
        h = function (i, j) {
          e(i).each(function () {
            var l = e(this),
              q = e(this).data('resizable-alsoresize'),
              p = {},
              r =
                j && j.length
                  ? j
                  : l.parents(a.originalElement[0]).length
                  ? ['width', 'height']
                  : ['width', 'height', 'top', 'left'];
            e.each(r, function (n, o) {
              if ((n = (q[o] || 0) + (g[o] || 0)) && n >= 0) p[o] = n || null;
            });
            if (e.browser.opera && /relative/.test(l.css('position'))) {
              c._revertToRelativePosition = true;
              l.css({ position: 'absolute', top: 'auto', left: 'auto' });
            }
            l.css(p);
          });
        };
      typeof b.alsoResize == 'object' && !b.alsoResize.nodeType
        ? e.each(b.alsoResize, function (i, j) {
            h(i, j);
          })
        : h(b.alsoResize);
    },
    stop: function () {
      var b = e(this).data('resizable'),
        a = b.options,
        c = function (d) {
          e(d).each(function () {
            var f = e(this);
            f.css({ position: f.data('resizable-alsoresize').position });
          });
        };
      if (b._revertToRelativePosition) {
        b._revertToRelativePosition = false;
        typeof a.alsoResize == 'object' && !a.alsoResize.nodeType
          ? e.each(a.alsoResize, function (d) {
              c(d);
            })
          : c(a.alsoResize);
      }
      e(this).removeData('resizable-alsoresize');
    },
  });
  e.ui.plugin.add('resizable', 'animate', {
    stop: function (b) {
      var a = e(this).data('resizable'),
        c = a.options,
        d = a._proportionallyResizeElements,
        f = d.length && /textarea/i.test(d[0].nodeName),
        g = f && e.ui.hasScroll(d[0], 'left') ? 0 : a.sizeDiff.height;
      f = { width: a.size.width - (f ? 0 : a.sizeDiff.width), height: a.size.height - g };
      g = parseInt(a.element.css('left'), 10) + (a.position.left - a.originalPosition.left) || null;
      var h = parseInt(a.element.css('top'), 10) + (a.position.top - a.originalPosition.top) || null;
      a.element.animate(e.extend(f, h && g ? { top: h, left: g } : {}), {
        duration: c.animateDuration,
        easing: c.animateEasing,
        step: function () {
          var i = {
            width: parseInt(a.element.css('width'), 10),
            height: parseInt(a.element.css('height'), 10),
            top: parseInt(a.element.css('top'), 10),
            left: parseInt(a.element.css('left'), 10),
          };
          d && d.length && e(d[0]).css({ width: i.width, height: i.height });
          a._updateCache(i);
          a._propagate('resize', b);
        },
      });
    },
  });
  e.ui.plugin.add('resizable', 'containment', {
    start: function () {
      var b = e(this).data('resizable'),
        a = b.element,
        c = b.options.containment;
      if ((a = c instanceof e ? c.get(0) : /parent/.test(c) ? a.parent().get(0) : c)) {
        b.containerElement = e(a);
        if (/document/.test(c) || c == document) {
          b.containerOffset = { left: 0, top: 0 };
          b.containerPosition = { left: 0, top: 0 };
          b.parentData = {
            element: e(document),
            left: 0,
            top: 0,
            width: e(document).width(),
            height: e(document).height() || document.body.parentNode.scrollHeight,
          };
        } else {
          var d = e(a),
            f = [];
          e(['Top', 'Right', 'Left', 'Bottom']).each(function (i, j) {
            f[i] = m(d.css('padding' + j));
          });
          b.containerOffset = d.offset();
          b.containerPosition = d.position();
          b.containerSize = { height: d.innerHeight() - f[3], width: d.innerWidth() - f[1] };
          c = b.containerOffset;
          var g = b.containerSize.height,
            h = b.containerSize.width;
          h = e.ui.hasScroll(a, 'left') ? a.scrollWidth : h;
          g = e.ui.hasScroll(a) ? a.scrollHeight : g;
          b.parentData = { element: a, left: c.left, top: c.top, width: h, height: g };
        }
      }
    },
    resize: function (b) {
      var a = e(this).data('resizable'),
        c = a.options,
        d = a.containerOffset,
        f = a.position;
      b = a._aspectRatio || b.shiftKey;
      var g = { top: 0, left: 0 },
        h = a.containerElement;
      if (h[0] != document && /static/.test(h.css('position'))) g = d;
      if (f.left < (a._helper ? d.left : 0)) {
        a.size.width += a._helper ? a.position.left - d.left : a.position.left - g.left;
        if (b) a.size.height = a.size.width / c.aspectRatio;
        a.position.left = c.helper ? d.left : 0;
      }
      if (f.top < (a._helper ? d.top : 0)) {
        a.size.height += a._helper ? a.position.top - d.top : a.position.top;
        if (b) a.size.width = a.size.height * c.aspectRatio;
        a.position.top = a._helper ? d.top : 0;
      }
      a.offset.left = a.parentData.left + a.position.left;
      a.offset.top = a.parentData.top + a.position.top;
      c = Math.abs((a._helper ? a.offset.left - g.left : a.offset.left - g.left) + a.sizeDiff.width);
      d = Math.abs((a._helper ? a.offset.top - g.top : a.offset.top - d.top) + a.sizeDiff.height);
      f = a.containerElement.get(0) == a.element.parent().get(0);
      g = /relative|absolute/.test(a.containerElement.css('position'));
      if (f && g) c -= a.parentData.left;
      if (c + a.size.width >= a.parentData.width) {
        a.size.width = a.parentData.width - c;
        if (b) a.size.height = a.size.width / a.aspectRatio;
      }
      if (d + a.size.height >= a.parentData.height) {
        a.size.height = a.parentData.height - d;
        if (b) a.size.width = a.size.height * a.aspectRatio;
      }
    },
    stop: function () {
      var b = e(this).data('resizable'),
        a = b.options,
        c = b.containerOffset,
        d = b.containerPosition,
        f = b.containerElement,
        g = e(b.helper),
        h = g.offset(),
        i = g.outerWidth() - b.sizeDiff.width;
      g = g.outerHeight() - b.sizeDiff.height;
      b._helper &&
        !a.animate &&
        /relative/.test(f.css('position')) &&
        e(this).css({ left: h.left - d.left - c.left, width: i, height: g });
      b._helper &&
        !a.animate &&
        /static/.test(f.css('position')) &&
        e(this).css({ left: h.left - d.left - c.left, width: i, height: g });
    },
  });
  e.ui.plugin.add('resizable', 'ghost', {
    start: function () {
      var b = e(this).data('resizable'),
        a = b.options,
        c = b.size;
      b.ghost = b.originalElement.clone();
      b.ghost
        .css({
          opacity: 0.25,
          display: 'block',
          position: 'relative',
          height: c.height,
          width: c.width,
          margin: 0,
          left: 0,
          top: 0,
        })
        .addClass('ui-resizable-ghost')
        .addClass(typeof a.ghost == 'string' ? a.ghost : '');
      b.ghost.appendTo(b.helper);
    },
    resize: function () {
      var b = e(this).data('resizable');
      b.ghost && b.ghost.css({ position: 'relative', height: b.size.height, width: b.size.width });
    },
    stop: function () {
      var b = e(this).data('resizable');
      b.ghost && b.helper && b.helper.get(0).removeChild(b.ghost.get(0));
    },
  });
  e.ui.plugin.add('resizable', 'grid', {
    resize: function () {
      var b = e(this).data('resizable'),
        a = b.options,
        c = b.size,
        d = b.originalSize,
        f = b.originalPosition,
        g = b.axis;
      a.grid = typeof a.grid == 'number' ? [a.grid, a.grid] : a.grid;
      var h = Math.round((c.width - d.width) / (a.grid[0] || 1)) * (a.grid[0] || 1);
      a = Math.round((c.height - d.height) / (a.grid[1] || 1)) * (a.grid[1] || 1);
      if (/^(se|s|e)$/.test(g)) {
        b.size.width = d.width + h;
        b.size.height = d.height + a;
      } else if (/^(ne)$/.test(g)) {
        b.size.width = d.width + h;
        b.size.height = d.height + a;
        b.position.top = f.top - a;
      } else {
        if (/^(sw)$/.test(g)) {
          b.size.width = d.width + h;
          b.size.height = d.height + a;
        } else {
          b.size.width = d.width + h;
          b.size.height = d.height + a;
          b.position.top = f.top - a;
        }
        b.position.left = f.left - h;
      }
    },
  });
  var m = function (b) {
      return parseInt(b, 10) || 0;
    },
    k = function (b) {
      return !isNaN(parseInt(b, 10));
    };
})(jQuery);
/*
 * jQuery UI Selectable 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Selectables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function (e) {
  e.widget('ui.selectable', e.ui.mouse, {
    options: { appendTo: 'body', autoRefresh: true, distance: 0, filter: '*', tolerance: 'touch' },
    _create: function () {
      var c = this;
      this.element.addClass('ui-selectable');
      this.dragged = false;
      var f;
      this.refresh = function () {
        f = e(c.options.filter, c.element[0]);
        f.each(function () {
          var d = e(this),
            b = d.offset();
          e.data(this, 'selectable-item', {
            element: this,
            $element: d,
            left: b.left,
            top: b.top,
            right: b.left + d.outerWidth(),
            bottom: b.top + d.outerHeight(),
            startselected: false,
            selected: d.hasClass('ui-selected'),
            selecting: d.hasClass('ui-selecting'),
            unselecting: d.hasClass('ui-unselecting'),
          });
        });
      };
      this.refresh();
      this.selectees = f.addClass('ui-selectee');
      this._mouseInit();
      this.helper = e("<div class='ui-selectable-helper'></div>");
    },
    destroy: function () {
      this.selectees.removeClass('ui-selectee').removeData('selectable-item');
      this.element.removeClass('ui-selectable ui-selectable-disabled').removeData('selectable').unbind('.selectable');
      this._mouseDestroy();
      return this;
    },
    _mouseStart: function (c) {
      var f = this;
      this.opos = [c.pageX, c.pageY];
      if (!this.options.disabled) {
        var d = this.options;
        this.selectees = e(d.filter, this.element[0]);
        this._trigger('start', c);
        e(d.appendTo).append(this.helper);
        this.helper.css({ left: c.clientX, top: c.clientY, width: 0, height: 0 });
        d.autoRefresh && this.refresh();
        this.selectees.filter('.ui-selected').each(function () {
          var b = e.data(this, 'selectable-item');
          b.startselected = true;
          if (!c.metaKey) {
            b.$element.removeClass('ui-selected');
            b.selected = false;
            b.$element.addClass('ui-unselecting');
            b.unselecting = true;
            f._trigger('unselecting', c, { unselecting: b.element });
          }
        });
        e(c.target)
          .parents()
          .andSelf()
          .each(function () {
            var b = e.data(this, 'selectable-item');
            if (b) {
              var g = !c.metaKey || !b.$element.hasClass('ui-selected');
              b.$element
                .removeClass(g ? 'ui-unselecting' : 'ui-selected')
                .addClass(g ? 'ui-selecting' : 'ui-unselecting');
              b.unselecting = !g;
              b.selecting = g;
              (b.selected = g)
                ? f._trigger('selecting', c, { selecting: b.element })
                : f._trigger('unselecting', c, { unselecting: b.element });
              return false;
            }
          });
      }
    },
    _mouseDrag: function (c) {
      var f = this;
      this.dragged = true;
      if (!this.options.disabled) {
        var d = this.options,
          b = this.opos[0],
          g = this.opos[1],
          h = c.pageX,
          i = c.pageY;
        if (b > h) {
          var j = h;
          h = b;
          b = j;
        }
        if (g > i) {
          j = i;
          i = g;
          g = j;
        }
        this.helper.css({ left: b, top: g, width: h - b, height: i - g });
        this.selectees.each(function () {
          var a = e.data(this, 'selectable-item');
          if (!(!a || a.element == f.element[0])) {
            var k = false;
            if (d.tolerance == 'touch') k = !(a.left > h || a.right < b || a.top > i || a.bottom < g);
            else if (d.tolerance == 'fit') k = a.left > b && a.right < h && a.top > g && a.bottom < i;
            if (k) {
              if (a.selected) {
                a.$element.removeClass('ui-selected');
                a.selected = false;
              }
              if (a.unselecting) {
                a.$element.removeClass('ui-unselecting');
                a.unselecting = false;
              }
              if (!a.selecting) {
                a.$element.addClass('ui-selecting');
                a.selecting = true;
                f._trigger('selecting', c, { selecting: a.element });
              }
            } else {
              if (a.selecting)
                if (c.metaKey && a.startselected) {
                  a.$element.removeClass('ui-selecting');
                  a.selecting = false;
                  a.$element.addClass('ui-selected');
                  a.selected = true;
                } else {
                  a.$element.removeClass('ui-selecting');
                  a.selecting = false;
                  if (a.startselected) {
                    a.$element.addClass('ui-unselecting');
                    a.unselecting = true;
                  }
                  f._trigger('unselecting', c, { unselecting: a.element });
                }
              if (a.selected)
                if (!c.metaKey && !a.startselected) {
                  a.$element.removeClass('ui-selected');
                  a.selected = false;
                  a.$element.addClass('ui-unselecting');
                  a.unselecting = true;
                  f._trigger('unselecting', c, { unselecting: a.element });
                }
            }
          }
        });
        return false;
      }
    },
    _mouseStop: function (c) {
      var f = this;
      this.dragged = false;
      e('.ui-unselecting', this.element[0]).each(function () {
        var d = e.data(this, 'selectable-item');
        d.$element.removeClass('ui-unselecting');
        d.unselecting = false;
        d.startselected = false;
        f._trigger('unselected', c, { unselected: d.element });
      });
      e('.ui-selecting', this.element[0]).each(function () {
        var d = e.data(this, 'selectable-item');
        d.$element.removeClass('ui-selecting').addClass('ui-selected');
        d.selecting = false;
        d.selected = true;
        d.startselected = true;
        f._trigger('selected', c, { selected: d.element });
      });
      this._trigger('stop', c);
      this.helper.remove();
      return false;
    },
  });
  e.extend(e.ui.selectable, { version: '1.8.16' });
})(jQuery);
/*
 * jQuery UI Sortable 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Sortables
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function (d) {
  d.widget('ui.sortable', d.ui.mouse, {
    widgetEventPrefix: 'sort',
    options: {
      appendTo: 'parent',
      axis: false,
      connectWith: false,
      containment: false,
      cursor: 'auto',
      cursorAt: false,
      dropOnEmpty: true,
      forcePlaceholderSize: false,
      forceHelperSize: false,
      grid: false,
      handle: false,
      helper: 'original',
      items: '> *',
      opacity: false,
      placeholder: false,
      revert: false,
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      scope: 'default',
      tolerance: 'intersect',
      zIndex: 1e3,
    },
    _create: function () {
      var a = this.options;
      this.containerCache = {};
      this.element.addClass('ui-sortable');
      this.refresh();
      this.floating = this.items.length
        ? a.axis === 'x' ||
          /left|right/.test(this.items[0].item.css('float')) ||
          /inline|table-cell/.test(this.items[0].item.css('display'))
        : false;
      this.offset = this.element.offset();
      this._mouseInit();
    },
    destroy: function () {
      this.element.removeClass('ui-sortable ui-sortable-disabled').removeData('sortable').unbind('.sortable');
      this._mouseDestroy();
      for (var a = this.items.length - 1; a >= 0; a--) this.items[a].item.removeData('sortable-item');
      return this;
    },
    _setOption: function (a, b) {
      if (a === 'disabled') {
        this.options[a] = b;
        this.widget()[b ? 'addClass' : 'removeClass']('ui-sortable-disabled');
      } else d.Widget.prototype._setOption.apply(this, arguments);
    },
    _mouseCapture: function (a, b) {
      if (this.reverting) return false;
      if (this.options.disabled || this.options.type == 'static') return false;
      this._refreshItems(a);
      var c = null,
        e = this;
      d(a.target)
        .parents()
        .each(function () {
          if (d.data(this, 'sortable-item') == e) {
            c = d(this);
            return false;
          }
        });
      if (d.data(a.target, 'sortable-item') == e) c = d(a.target);
      if (!c) return false;
      if (this.options.handle && !b) {
        var f = false;
        d(this.options.handle, c)
          .find('*')
          .andSelf()
          .each(function () {
            if (this == a.target) f = true;
          });
        if (!f) return false;
      }
      this.currentItem = c;
      this._removeCurrentsFromItems();
      return true;
    },
    _mouseStart: function (a, b, c) {
      b = this.options;
      var e = this;
      this.currentContainer = this;
      this.refreshPositions();
      this.helper = this._createHelper(a);
      this._cacheHelperProportions();
      this._cacheMargins();
      this.scrollParent = this.helper.scrollParent();
      this.offset = this.currentItem.offset();
      this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left };
      this.helper.css('position', 'absolute');
      this.cssPosition = this.helper.css('position');
      d.extend(this.offset, {
        click: { left: a.pageX - this.offset.left, top: a.pageY - this.offset.top },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(),
      });
      this.originalPosition = this._generatePosition(a);
      this.originalPageX = a.pageX;
      this.originalPageY = a.pageY;
      b.cursorAt && this._adjustOffsetFromHelper(b.cursorAt);
      this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };
      this.helper[0] != this.currentItem[0] && this.currentItem.hide();
      this._createPlaceholder();
      b.containment && this._setContainment();
      if (b.cursor) {
        if (d('body').css('cursor')) this._storedCursor = d('body').css('cursor');
        d('body').css('cursor', b.cursor);
      }
      if (b.opacity) {
        if (this.helper.css('opacity')) this._storedOpacity = this.helper.css('opacity');
        this.helper.css('opacity', b.opacity);
      }
      if (b.zIndex) {
        if (this.helper.css('zIndex')) this._storedZIndex = this.helper.css('zIndex');
        this.helper.css('zIndex', b.zIndex);
      }
      if (this.scrollParent[0] != document && this.scrollParent[0].tagName != 'HTML')
        this.overflowOffset = this.scrollParent.offset();
      this._trigger('start', a, this._uiHash());
      this._preserveHelperProportions || this._cacheHelperProportions();
      if (!c)
        for (c = this.containers.length - 1; c >= 0; c--) this.containers[c]._trigger('activate', a, e._uiHash(this));
      if (d.ui.ddmanager) d.ui.ddmanager.current = this;
      d.ui.ddmanager && !b.dropBehaviour && d.ui.ddmanager.prepareOffsets(this, a);
      this.dragging = true;
      this.helper.addClass('ui-sortable-helper');
      this._mouseDrag(a);
      return true;
    },
    _mouseDrag: function (a) {
      this.position = this._generatePosition(a);
      this.positionAbs = this._convertPositionTo('absolute');
      if (!this.lastPositionAbs) this.lastPositionAbs = this.positionAbs;
      if (this.options.scroll) {
        var b = this.options,
          c = false;
        if (this.scrollParent[0] != document && this.scrollParent[0].tagName != 'HTML') {
          if (this.overflowOffset.top + this.scrollParent[0].offsetHeight - a.pageY < b.scrollSensitivity)
            this.scrollParent[0].scrollTop = c = this.scrollParent[0].scrollTop + b.scrollSpeed;
          else if (a.pageY - this.overflowOffset.top < b.scrollSensitivity)
            this.scrollParent[0].scrollTop = c = this.scrollParent[0].scrollTop - b.scrollSpeed;
          if (this.overflowOffset.left + this.scrollParent[0].offsetWidth - a.pageX < b.scrollSensitivity)
            this.scrollParent[0].scrollLeft = c = this.scrollParent[0].scrollLeft + b.scrollSpeed;
          else if (a.pageX - this.overflowOffset.left < b.scrollSensitivity)
            this.scrollParent[0].scrollLeft = c = this.scrollParent[0].scrollLeft - b.scrollSpeed;
        } else {
          if (a.pageY - d(document).scrollTop() < b.scrollSensitivity)
            c = d(document).scrollTop(d(document).scrollTop() - b.scrollSpeed);
          else if (d(window).height() - (a.pageY - d(document).scrollTop()) < b.scrollSensitivity)
            c = d(document).scrollTop(d(document).scrollTop() + b.scrollSpeed);
          if (a.pageX - d(document).scrollLeft() < b.scrollSensitivity)
            c = d(document).scrollLeft(d(document).scrollLeft() - b.scrollSpeed);
          else if (d(window).width() - (a.pageX - d(document).scrollLeft()) < b.scrollSensitivity)
            c = d(document).scrollLeft(d(document).scrollLeft() + b.scrollSpeed);
        }
        c !== false && d.ui.ddmanager && !b.dropBehaviour && d.ui.ddmanager.prepareOffsets(this, a);
      }
      this.positionAbs = this._convertPositionTo('absolute');
      if (!this.options.axis || this.options.axis != 'y') this.helper[0].style.left = this.position.left + 'px';
      if (!this.options.axis || this.options.axis != 'x') this.helper[0].style.top = this.position.top + 'px';
      for (b = this.items.length - 1; b >= 0; b--) {
        c = this.items[b];
        var e = c.item[0],
          f = this._intersectsWithPointer(c);
        if (f)
          if (
            e != this.currentItem[0] &&
            this.placeholder[f == 1 ? 'next' : 'prev']()[0] != e &&
            !d.ui.contains(this.placeholder[0], e) &&
            (this.options.type == 'semi-dynamic' ? !d.ui.contains(this.element[0], e) : true)
          ) {
            this.direction = f == 1 ? 'down' : 'up';
            if (this.options.tolerance == 'pointer' || this._intersectsWithSides(c)) this._rearrange(a, c);
            else break;
            this._trigger('change', a, this._uiHash());
            break;
          }
      }
      this._contactContainers(a);
      d.ui.ddmanager && d.ui.ddmanager.drag(this, a);
      this._trigger('sort', a, this._uiHash());
      this.lastPositionAbs = this.positionAbs;
      return false;
    },
    _mouseStop: function (a, b) {
      if (a) {
        d.ui.ddmanager && !this.options.dropBehaviour && d.ui.ddmanager.drop(this, a);
        if (this.options.revert) {
          var c = this;
          b = c.placeholder.offset();
          c.reverting = true;
          d(this.helper).animate(
            {
              left:
                b.left -
                this.offset.parent.left -
                c.margins.left +
                (this.offsetParent[0] == document.body ? 0 : this.offsetParent[0].scrollLeft),
              top:
                b.top -
                this.offset.parent.top -
                c.margins.top +
                (this.offsetParent[0] == document.body ? 0 : this.offsetParent[0].scrollTop),
            },
            parseInt(this.options.revert, 10) || 500,
            function () {
              c._clear(a);
            },
          );
        } else this._clear(a, b);
        return false;
      }
    },
    cancel: function () {
      var a = this;
      if (this.dragging) {
        this._mouseUp({ target: null });
        this.options.helper == 'original'
          ? this.currentItem.css(this._storedCSS).removeClass('ui-sortable-helper')
          : this.currentItem.show();
        for (var b = this.containers.length - 1; b >= 0; b--) {
          this.containers[b]._trigger('deactivate', null, a._uiHash(this));
          if (this.containers[b].containerCache.over) {
            this.containers[b]._trigger('out', null, a._uiHash(this));
            this.containers[b].containerCache.over = 0;
          }
        }
      }
      if (this.placeholder) {
        this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
        this.options.helper != 'original' && this.helper && this.helper[0].parentNode && this.helper.remove();
        d.extend(this, { helper: null, dragging: false, reverting: false, _noFinalSort: null });
        this.domPosition.prev
          ? d(this.domPosition.prev).after(this.currentItem)
          : d(this.domPosition.parent).prepend(this.currentItem);
      }
      return this;
    },
    serialize: function (a) {
      var b = this._getItemsAsjQuery(a && a.connected),
        c = [];
      a = a || {};
      d(b).each(function () {
        var e = (d(a.item || this).attr(a.attribute || 'id') || '').match(a.expression || /(.+)[-=_](.+)/);
        if (e) c.push((a.key || e[1] + '[]') + '=' + (a.key && a.expression ? e[1] : e[2]));
      });
      !c.length && a.key && c.push(a.key + '=');
      return c.join('&');
    },
    toArray: function (a) {
      var b = this._getItemsAsjQuery(a && a.connected),
        c = [];
      a = a || {};
      b.each(function () {
        c.push(d(a.item || this).attr(a.attribute || 'id') || '');
      });
      return c;
    },
    _intersectsWith: function (a) {
      var b = this.positionAbs.left,
        c = b + this.helperProportions.width,
        e = this.positionAbs.top,
        f = e + this.helperProportions.height,
        g = a.left,
        h = g + a.width,
        i = a.top,
        k = i + a.height,
        j = this.offset.click.top,
        l = this.offset.click.left;
      j = e + j > i && e + j < k && b + l > g && b + l < h;
      return this.options.tolerance == 'pointer' ||
        this.options.forcePointerForContainers ||
        (this.options.tolerance != 'pointer' &&
          this.helperProportions[this.floating ? 'width' : 'height'] > a[this.floating ? 'width' : 'height'])
        ? j
        : g < b + this.helperProportions.width / 2 &&
            c - this.helperProportions.width / 2 < h &&
            i < e + this.helperProportions.height / 2 &&
            f - this.helperProportions.height / 2 < k;
    },
    _intersectsWithPointer: function (a) {
      var b = d.ui.isOverAxis(this.positionAbs.top + this.offset.click.top, a.top, a.height);
      a = d.ui.isOverAxis(this.positionAbs.left + this.offset.click.left, a.left, a.width);
      b = b && a;
      a = this._getDragVerticalDirection();
      var c = this._getDragHorizontalDirection();
      if (!b) return false;
      return this.floating ? ((c && c == 'right') || a == 'down' ? 2 : 1) : a && (a == 'down' ? 2 : 1);
    },
    _intersectsWithSides: function (a) {
      var b = d.ui.isOverAxis(this.positionAbs.top + this.offset.click.top, a.top + a.height / 2, a.height);
      a = d.ui.isOverAxis(this.positionAbs.left + this.offset.click.left, a.left + a.width / 2, a.width);
      var c = this._getDragVerticalDirection(),
        e = this._getDragHorizontalDirection();
      return this.floating && e
        ? (e == 'right' && a) || (e == 'left' && !a)
        : c && ((c == 'down' && b) || (c == 'up' && !b));
    },
    _getDragVerticalDirection: function () {
      var a = this.positionAbs.top - this.lastPositionAbs.top;
      return a != 0 && (a > 0 ? 'down' : 'up');
    },
    _getDragHorizontalDirection: function () {
      var a = this.positionAbs.left - this.lastPositionAbs.left;
      return a != 0 && (a > 0 ? 'right' : 'left');
    },
    refresh: function (a) {
      this._refreshItems(a);
      this.refreshPositions();
      return this;
    },
    _connectWith: function () {
      var a = this.options;
      return a.connectWith.constructor == String ? [a.connectWith] : a.connectWith;
    },
    _getItemsAsjQuery: function (a) {
      var b = [],
        c = [],
        e = this._connectWith();
      if (e && a)
        for (a = e.length - 1; a >= 0; a--)
          for (var f = d(e[a]), g = f.length - 1; g >= 0; g--) {
            var h = d.data(f[g], 'sortable');
            if (h && h != this && !h.options.disabled)
              c.push([
                d.isFunction(h.options.items)
                  ? h.options.items.call(h.element)
                  : d(h.options.items, h.element).not('.ui-sortable-helper').not('.ui-sortable-placeholder'),
                h,
              ]);
          }
      c.push([
        d.isFunction(this.options.items)
          ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem })
          : d(this.options.items, this.element).not('.ui-sortable-helper').not('.ui-sortable-placeholder'),
        this,
      ]);
      for (a = c.length - 1; a >= 0; a--)
        c[a][0].each(function () {
          b.push(this);
        });
      return d(b);
    },
    _removeCurrentsFromItems: function () {
      for (var a = this.currentItem.find(':data(sortable-item)'), b = 0; b < this.items.length; b++)
        for (var c = 0; c < a.length; c++) a[c] == this.items[b].item[0] && this.items.splice(b, 1);
    },
    _refreshItems: function (a) {
      this.items = [];
      this.containers = [this];
      var b = this.items,
        c = [
          [
            d.isFunction(this.options.items)
              ? this.options.items.call(this.element[0], a, { item: this.currentItem })
              : d(this.options.items, this.element),
            this,
          ],
        ],
        e = this._connectWith();
      if (e)
        for (var f = e.length - 1; f >= 0; f--)
          for (var g = d(e[f]), h = g.length - 1; h >= 0; h--) {
            var i = d.data(g[h], 'sortable');
            if (i && i != this && !i.options.disabled) {
              c.push([
                d.isFunction(i.options.items)
                  ? i.options.items.call(i.element[0], a, { item: this.currentItem })
                  : d(i.options.items, i.element),
                i,
              ]);
              this.containers.push(i);
            }
          }
      for (f = c.length - 1; f >= 0; f--) {
        a = c[f][1];
        e = c[f][0];
        h = 0;
        for (g = e.length; h < g; h++) {
          i = d(e[h]);
          i.data('sortable-item', a);
          b.push({ item: i, instance: a, width: 0, height: 0, left: 0, top: 0 });
        }
      }
    },
    refreshPositions: function (a) {
      if (this.offsetParent && this.helper) this.offset.parent = this._getParentOffset();
      for (var b = this.items.length - 1; b >= 0; b--) {
        var c = this.items[b];
        if (!(c.instance != this.currentContainer && this.currentContainer && c.item[0] != this.currentItem[0])) {
          var e = this.options.toleranceElement ? d(this.options.toleranceElement, c.item) : c.item;
          if (!a) {
            c.width = e.outerWidth();
            c.height = e.outerHeight();
          }
          e = e.offset();
          c.left = e.left;
          c.top = e.top;
        }
      }
      if (this.options.custom && this.options.custom.refreshContainers)
        this.options.custom.refreshContainers.call(this);
      else
        for (b = this.containers.length - 1; b >= 0; b--) {
          e = this.containers[b].element.offset();
          this.containers[b].containerCache.left = e.left;
          this.containers[b].containerCache.top = e.top;
          this.containers[b].containerCache.width = this.containers[b].element.outerWidth();
          this.containers[b].containerCache.height = this.containers[b].element.outerHeight();
        }
      return this;
    },
    _createPlaceholder: function (a) {
      var b = a || this,
        c = b.options;
      if (!c.placeholder || c.placeholder.constructor == String) {
        var e = c.placeholder;
        c.placeholder = {
          element: function () {
            var f = d(document.createElement(b.currentItem[0].nodeName))
              .addClass(e || b.currentItem[0].className + ' ui-sortable-placeholder')
              .removeClass('ui-sortable-helper')[0];
            if (!e) f.style.visibility = 'hidden';
            return f;
          },
          update: function (f, g) {
            if (!(e && !c.forcePlaceholderSize)) {
              g.height() ||
                g.height(
                  b.currentItem.innerHeight() -
                    parseInt(b.currentItem.css('paddingTop') || 0, 10) -
                    parseInt(b.currentItem.css('paddingBottom') || 0, 10),
                );
              g.width() ||
                g.width(
                  b.currentItem.innerWidth() -
                    parseInt(b.currentItem.css('paddingLeft') || 0, 10) -
                    parseInt(b.currentItem.css('paddingRight') || 0, 10),
                );
            }
          },
        };
      }
      b.placeholder = d(c.placeholder.element.call(b.element, b.currentItem));
      b.currentItem.after(b.placeholder);
      c.placeholder.update(b, b.placeholder);
    },
    _contactContainers: function (a) {
      for (var b = null, c = null, e = this.containers.length - 1; e >= 0; e--)
        if (!d.ui.contains(this.currentItem[0], this.containers[e].element[0]))
          if (this._intersectsWith(this.containers[e].containerCache)) {
            if (!(b && d.ui.contains(this.containers[e].element[0], b.element[0]))) {
              b = this.containers[e];
              c = e;
            }
          } else if (this.containers[e].containerCache.over) {
            this.containers[e]._trigger('out', a, this._uiHash(this));
            this.containers[e].containerCache.over = 0;
          }
      if (b)
        if (this.containers.length === 1) {
          this.containers[c]._trigger('over', a, this._uiHash(this));
          this.containers[c].containerCache.over = 1;
        } else if (this.currentContainer != this.containers[c]) {
          b = 1e4;
          e = null;
          for (
            var f = this.positionAbs[this.containers[c].floating ? 'left' : 'top'], g = this.items.length - 1;
            g >= 0;
            g--
          )
            if (d.ui.contains(this.containers[c].element[0], this.items[g].item[0])) {
              var h = this.items[g][this.containers[c].floating ? 'left' : 'top'];
              if (Math.abs(h - f) < b) {
                b = Math.abs(h - f);
                e = this.items[g];
              }
            }
          if (e || this.options.dropOnEmpty) {
            this.currentContainer = this.containers[c];
            e ? this._rearrange(a, e, null, true) : this._rearrange(a, null, this.containers[c].element, true);
            this._trigger('change', a, this._uiHash());
            this.containers[c]._trigger('change', a, this._uiHash(this));
            this.options.placeholder.update(this.currentContainer, this.placeholder);
            this.containers[c]._trigger('over', a, this._uiHash(this));
            this.containers[c].containerCache.over = 1;
          }
        }
    },
    _createHelper: function (a) {
      var b = this.options;
      a = d.isFunction(b.helper)
        ? d(b.helper.apply(this.element[0], [a, this.currentItem]))
        : b.helper == 'clone'
        ? this.currentItem.clone()
        : this.currentItem;
      a.parents('body').length ||
        d(b.appendTo != 'parent' ? b.appendTo : this.currentItem[0].parentNode)[0].appendChild(a[0]);
      if (a[0] == this.currentItem[0])
        this._storedCSS = {
          width: this.currentItem[0].style.width,
          height: this.currentItem[0].style.height,
          position: this.currentItem.css('position'),
          top: this.currentItem.css('top'),
          left: this.currentItem.css('left'),
        };
      if (a[0].style.width == '' || b.forceHelperSize) a.width(this.currentItem.width());
      if (a[0].style.height == '' || b.forceHelperSize) a.height(this.currentItem.height());
      return a;
    },
    _adjustOffsetFromHelper: function (a) {
      if (typeof a == 'string') a = a.split(' ');
      if (d.isArray(a)) a = { left: +a[0], top: +a[1] || 0 };
      if ('left' in a) this.offset.click.left = a.left + this.margins.left;
      if ('right' in a) this.offset.click.left = this.helperProportions.width - a.right + this.margins.left;
      if ('top' in a) this.offset.click.top = a.top + this.margins.top;
      if ('bottom' in a) this.offset.click.top = this.helperProportions.height - a.bottom + this.margins.top;
    },
    _getParentOffset: function () {
      this.offsetParent = this.helper.offsetParent();
      var a = this.offsetParent.offset();
      if (
        this.cssPosition == 'absolute' &&
        this.scrollParent[0] != document &&
        d.ui.contains(this.scrollParent[0], this.offsetParent[0])
      ) {
        a.left += this.scrollParent.scrollLeft();
        a.top += this.scrollParent.scrollTop();
      }
      if (
        this.offsetParent[0] == document.body ||
        (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() == 'html' && d.browser.msie)
      )
        a = { top: 0, left: 0 };
      return {
        top: a.top + (parseInt(this.offsetParent.css('borderTopWidth'), 10) || 0),
        left: a.left + (parseInt(this.offsetParent.css('borderLeftWidth'), 10) || 0),
      };
    },
    _getRelativeOffset: function () {
      if (this.cssPosition == 'relative') {
        var a = this.currentItem.position();
        return {
          top: a.top - (parseInt(this.helper.css('top'), 10) || 0) + this.scrollParent.scrollTop(),
          left: a.left - (parseInt(this.helper.css('left'), 10) || 0) + this.scrollParent.scrollLeft(),
        };
      } else return { top: 0, left: 0 };
    },
    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.currentItem.css('marginLeft'), 10) || 0,
        top: parseInt(this.currentItem.css('marginTop'), 10) || 0,
      };
    },
    _cacheHelperProportions: function () {
      this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
    },
    _setContainment: function () {
      var a = this.options;
      if (a.containment == 'parent') a.containment = this.helper[0].parentNode;
      if (a.containment == 'document' || a.containment == 'window')
        this.containment = [
          0 - this.offset.relative.left - this.offset.parent.left,
          0 - this.offset.relative.top - this.offset.parent.top,
          d(a.containment == 'document' ? document : window).width() - this.helperProportions.width - this.margins.left,
          (d(a.containment == 'document' ? document : window).height() || document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
      if (!/^(document|window|parent)$/.test(a.containment)) {
        var b = d(a.containment)[0];
        a = d(a.containment).offset();
        var c = d(b).css('overflow') != 'hidden';
        this.containment = [
          a.left +
            (parseInt(d(b).css('borderLeftWidth'), 10) || 0) +
            (parseInt(d(b).css('paddingLeft'), 10) || 0) -
            this.margins.left,
          a.top +
            (parseInt(d(b).css('borderTopWidth'), 10) || 0) +
            (parseInt(d(b).css('paddingTop'), 10) || 0) -
            this.margins.top,
          a.left +
            (c ? Math.max(b.scrollWidth, b.offsetWidth) : b.offsetWidth) -
            (parseInt(d(b).css('borderLeftWidth'), 10) || 0) -
            (parseInt(d(b).css('paddingRight'), 10) || 0) -
            this.helperProportions.width -
            this.margins.left,
          a.top +
            (c ? Math.max(b.scrollHeight, b.offsetHeight) : b.offsetHeight) -
            (parseInt(d(b).css('borderTopWidth'), 10) || 0) -
            (parseInt(d(b).css('paddingBottom'), 10) || 0) -
            this.helperProportions.height -
            this.margins.top,
        ];
      }
    },
    _convertPositionTo: function (a, b) {
      if (!b) b = this.position;
      a = a == 'absolute' ? 1 : -1;
      var c =
          this.cssPosition == 'absolute' &&
          !(this.scrollParent[0] != document && d.ui.contains(this.scrollParent[0], this.offsetParent[0]))
            ? this.offsetParent
            : this.scrollParent,
        e = /(html|body)/i.test(c[0].tagName);
      return {
        top:
          b.top +
          this.offset.relative.top * a +
          this.offset.parent.top * a -
          (d.browser.safari && this.cssPosition == 'fixed'
            ? 0
            : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollTop() : e ? 0 : c.scrollTop()) * a),
        left:
          b.left +
          this.offset.relative.left * a +
          this.offset.parent.left * a -
          (d.browser.safari && this.cssPosition == 'fixed'
            ? 0
            : (this.cssPosition == 'fixed' ? -this.scrollParent.scrollLeft() : e ? 0 : c.scrollLeft()) * a),
      };
    },
    _generatePosition: function (a) {
      var b = this.options,
        c =
          this.cssPosition == 'absolute' &&
          !(this.scrollParent[0] != document && d.ui.contains(this.scrollParent[0], this.offsetParent[0]))
            ? this.offsetParent
            : this.scrollParent,
        e = /(html|body)/i.test(c[0].tagName);
      if (
        this.cssPosition == 'relative' &&
        !(this.scrollParent[0] != document && this.scrollParent[0] != this.offsetParent[0])
      )
        this.offset.relative = this._getRelativeOffset();
      var f = a.pageX,
        g = a.pageY;
      if (this.originalPosition) {
        if (this.containment) {
          if (a.pageX - this.offset.click.left < this.containment[0]) f = this.containment[0] + this.offset.click.left;
          if (a.pageY - this.offset.click.top < this.containment[1]) g = this.containment[1] + this.offset.click.top;
          if (a.pageX - this.offset.click.left > this.containment[2]) f = this.containment[2] + this.offset.click.left;
          if (a.pageY - this.offset.click.top > this.containment[3]) g = this.containment[3] + this.offset.click.top;
        }
        if (b.grid) {
          g = this.originalPageY + Math.round((g - this.originalPageY) / b.grid[1]) * b.grid[1];
          g = this.containment
            ? !(g - this.offset.click.top < this.containment[1] || g - this.offset.click.top > this.containment[3])
              ? g
              : !(g - this.offset.click.top < this.containment[1])
              ? g - b.grid[1]
              : g + b.grid[1]
            : g;
          f = this.originalPageX + Math.round((f - this.originalPageX) / b.grid[0]) * b.grid[0];
          f = this.containment
            ? !(f - this.offset.click.left < this.containment[0] || f - this.offset.click.left > this.containment[2])
              ? f
              : !(f - this.offset.click.left < this.containment[0])
              ? f - b.grid[0]
              : f + b.grid[0]
            : f;
        }
      }
      return {
        top:
          g -
          this.offset.click.top -
          this.offset.relative.top -
          this.offset.parent.top +
          (d.browser.safari && this.cssPosition == 'fixed'
            ? 0
            : this.cssPosition == 'fixed'
            ? -this.scrollParent.scrollTop()
            : e
            ? 0
            : c.scrollTop()),
        left:
          f -
          this.offset.click.left -
          this.offset.relative.left -
          this.offset.parent.left +
          (d.browser.safari && this.cssPosition == 'fixed'
            ? 0
            : this.cssPosition == 'fixed'
            ? -this.scrollParent.scrollLeft()
            : e
            ? 0
            : c.scrollLeft()),
      };
    },
    _rearrange: function (a, b, c, e) {
      c
        ? c[0].appendChild(this.placeholder[0])
        : b.item[0].parentNode.insertBefore(
            this.placeholder[0],
            this.direction == 'down' ? b.item[0] : b.item[0].nextSibling,
          );
      this.counter = this.counter ? ++this.counter : 1;
      var f = this,
        g = this.counter;
      window.setTimeout(function () {
        g == f.counter && f.refreshPositions(!e);
      }, 0);
    },
    _clear: function (a, b) {
      this.reverting = false;
      var c = [];
      !this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem);
      this._noFinalSort = null;
      if (this.helper[0] == this.currentItem[0]) {
        for (var e in this._storedCSS)
          if (this._storedCSS[e] == 'auto' || this._storedCSS[e] == 'static') this._storedCSS[e] = '';
        this.currentItem.css(this._storedCSS).removeClass('ui-sortable-helper');
      } else this.currentItem.show();
      this.fromOutside &&
        !b &&
        c.push(function (f) {
          this._trigger('receive', f, this._uiHash(this.fromOutside));
        });
      if (
        (this.fromOutside ||
          this.domPosition.prev != this.currentItem.prev().not('.ui-sortable-helper')[0] ||
          this.domPosition.parent != this.currentItem.parent()[0]) &&
        !b
      )
        c.push(function (f) {
          this._trigger('update', f, this._uiHash());
        });
      if (!d.ui.contains(this.element[0], this.currentItem[0])) {
        b ||
          c.push(function (f) {
            this._trigger('remove', f, this._uiHash());
          });
        for (e = this.containers.length - 1; e >= 0; e--)
          if (d.ui.contains(this.containers[e].element[0], this.currentItem[0]) && !b) {
            c.push(
              function (f) {
                return function (g) {
                  f._trigger('receive', g, this._uiHash(this));
                };
              }.call(this, this.containers[e]),
            );
            c.push(
              function (f) {
                return function (g) {
                  f._trigger('update', g, this._uiHash(this));
                };
              }.call(this, this.containers[e]),
            );
          }
      }
      for (e = this.containers.length - 1; e >= 0; e--) {
        b ||
          c.push(
            function (f) {
              return function (g) {
                f._trigger('deactivate', g, this._uiHash(this));
              };
            }.call(this, this.containers[e]),
          );
        if (this.containers[e].containerCache.over) {
          c.push(
            function (f) {
              return function (g) {
                f._trigger('out', g, this._uiHash(this));
              };
            }.call(this, this.containers[e]),
          );
          this.containers[e].containerCache.over = 0;
        }
      }
      this._storedCursor && d('body').css('cursor', this._storedCursor);
      this._storedOpacity && this.helper.css('opacity', this._storedOpacity);
      if (this._storedZIndex) this.helper.css('zIndex', this._storedZIndex == 'auto' ? '' : this._storedZIndex);
      this.dragging = false;
      if (this.cancelHelperRemoval) {
        if (!b) {
          this._trigger('beforeStop', a, this._uiHash());
          for (e = 0; e < c.length; e++) c[e].call(this, a);
          this._trigger('stop', a, this._uiHash());
        }
        return false;
      }
      b || this._trigger('beforeStop', a, this._uiHash());
      this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
      this.helper[0] != this.currentItem[0] && this.helper.remove();
      this.helper = null;
      if (!b) {
        for (e = 0; e < c.length; e++) c[e].call(this, a);
        this._trigger('stop', a, this._uiHash());
      }
      this.fromOutside = false;
      return true;
    },
    _trigger: function () {
      d.Widget.prototype._trigger.apply(this, arguments) === false && this.cancel();
    },
    _uiHash: function (a) {
      var b = a || this;
      return {
        helper: b.helper,
        placeholder: b.placeholder || d([]),
        position: b.position,
        originalPosition: b.originalPosition,
        offset: b.positionAbs,
        item: b.currentItem,
        sender: a ? a.element : null,
      };
    },
  });
  d.extend(d.ui.sortable, { version: '1.8.16' });
})(jQuery);
/*
 * jQuery UI Slider 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Slider
 *
 * Depends:
 *	jquery.ui.core.js
 *	jquery.ui.mouse.js
 *	jquery.ui.widget.js
 */
(function (d) {
  d.widget('ui.slider', d.ui.mouse, {
    widgetEventPrefix: 'slide',
    options: {
      animate: false,
      distance: 0,
      max: 100,
      min: 0,
      orientation: 'horizontal',
      range: false,
      step: 1,
      value: 0,
      values: null,
    },
    _create: function () {
      var a = this,
        b = this.options,
        c = this.element.find('.ui-slider-handle').addClass('ui-state-default ui-corner-all'),
        f = (b.values && b.values.length) || 1,
        e = [];
      this._mouseSliding = this._keySliding = false;
      this._animateOff = true;
      this._handleIndex = null;
      this._detectOrientation();
      this._mouseInit();
      this.element.addClass(
        'ui-slider ui-slider-' +
          this.orientation +
          ' ui-widget ui-widget-content ui-corner-all' +
          (b.disabled ? ' ui-slider-disabled ui-disabled' : ''),
      );
      this.range = d([]);
      if (b.range) {
        if (b.range === true) {
          if (!b.values) b.values = [this._valueMin(), this._valueMin()];
          if (b.values.length && b.values.length !== 2) b.values = [b.values[0], b.values[0]];
        }
        this.range = d('<div></div>')
          .appendTo(this.element)
          .addClass(
            'ui-slider-range ui-widget-header' +
              (b.range === 'min' || b.range === 'max' ? ' ui-slider-range-' + b.range : ''),
          );
      }
      for (var j = c.length; j < f; j += 1)
        e.push("<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>");
      this.handles = c.add(d(e.join('')).appendTo(a.element));
      this.handle = this.handles.eq(0);
      this.handles
        .add(this.range)
        .filter('a')
        .click(function (g) {
          g.preventDefault();
        })
        .hover(
          function () {
            b.disabled || d(this).addClass('ui-state-hover');
          },
          function () {
            d(this).removeClass('ui-state-hover');
          },
        )
        .focus(function () {
          if (b.disabled) d(this).blur();
          else {
            d('.ui-slider .ui-state-focus').removeClass('ui-state-focus');
            d(this).addClass('ui-state-focus');
          }
        })
        .blur(function () {
          d(this).removeClass('ui-state-focus');
        });
      this.handles.each(function (g) {
        d(this).data('index.ui-slider-handle', g);
      });
      this.handles
        .keydown(function (g) {
          var k = true,
            l = d(this).data('index.ui-slider-handle'),
            i,
            h,
            m;
          if (!a.options.disabled) {
            switch (g.keyCode) {
              case d.ui.keyCode.HOME:
              case d.ui.keyCode.END:
              case d.ui.keyCode.PAGE_UP:
              case d.ui.keyCode.PAGE_DOWN:
              case d.ui.keyCode.UP:
              case d.ui.keyCode.RIGHT:
              case d.ui.keyCode.DOWN:
              case d.ui.keyCode.LEFT:
                k = false;
                if (!a._keySliding) {
                  a._keySliding = true;
                  d(this).addClass('ui-state-active');
                  i = a._start(g, l);
                  if (i === false) return;
                }
                break;
            }
            m = a.options.step;
            i = a.options.values && a.options.values.length ? (h = a.values(l)) : (h = a.value());
            switch (g.keyCode) {
              case d.ui.keyCode.HOME:
                h = a._valueMin();
                break;
              case d.ui.keyCode.END:
                h = a._valueMax();
                break;
              case d.ui.keyCode.PAGE_UP:
                h = a._trimAlignValue(i + (a._valueMax() - a._valueMin()) / 5);
                break;
              case d.ui.keyCode.PAGE_DOWN:
                h = a._trimAlignValue(i - (a._valueMax() - a._valueMin()) / 5);
                break;
              case d.ui.keyCode.UP:
              case d.ui.keyCode.RIGHT:
                if (i === a._valueMax()) return;
                h = a._trimAlignValue(i + m);
                break;
              case d.ui.keyCode.DOWN:
              case d.ui.keyCode.LEFT:
                if (i === a._valueMin()) return;
                h = a._trimAlignValue(i - m);
                break;
            }
            a._slide(g, l, h);
            return k;
          }
        })
        .keyup(function (g) {
          var k = d(this).data('index.ui-slider-handle');
          if (a._keySliding) {
            a._keySliding = false;
            a._stop(g, k);
            a._change(g, k);
            d(this).removeClass('ui-state-active');
          }
        });
      this._refreshValue();
      this._animateOff = false;
    },
    destroy: function () {
      this.handles.remove();
      this.range.remove();
      this.element
        .removeClass(
          'ui-slider ui-slider-horizontal ui-slider-vertical ui-slider-disabled ui-widget ui-widget-content ui-corner-all',
        )
        .removeData('slider')
        .unbind('.slider');
      this._mouseDestroy();
      return this;
    },
    _mouseCapture: function (a) {
      var b = this.options,
        c,
        f,
        e,
        j,
        g;
      if (b.disabled) return false;
      this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() };
      this.elementOffset = this.element.offset();
      c = this._normValueFromMouse({ x: a.pageX, y: a.pageY });
      f = this._valueMax() - this._valueMin() + 1;
      j = this;
      this.handles.each(function (k) {
        var l = Math.abs(c - j.values(k));
        if (f > l) {
          f = l;
          e = d(this);
          g = k;
        }
      });
      if (b.range === true && this.values(1) === b.min) {
        g += 1;
        e = d(this.handles[g]);
      }
      if (this._start(a, g) === false) return false;
      this._mouseSliding = true;
      j._handleIndex = g;
      e.addClass('ui-state-active').focus();
      b = e.offset();
      this._clickOffset = !d(a.target).parents().andSelf().is('.ui-slider-handle')
        ? { left: 0, top: 0 }
        : {
            left: a.pageX - b.left - e.width() / 2,
            top:
              a.pageY -
              b.top -
              e.height() / 2 -
              (parseInt(e.css('borderTopWidth'), 10) || 0) -
              (parseInt(e.css('borderBottomWidth'), 10) || 0) +
              (parseInt(e.css('marginTop'), 10) || 0),
          };
      this.handles.hasClass('ui-state-hover') || this._slide(a, g, c);
      return (this._animateOff = true);
    },
    _mouseStart: function () {
      return true;
    },
    _mouseDrag: function (a) {
      var b = this._normValueFromMouse({ x: a.pageX, y: a.pageY });
      this._slide(a, this._handleIndex, b);
      return false;
    },
    _mouseStop: function (a) {
      this.handles.removeClass('ui-state-active');
      this._mouseSliding = false;
      this._stop(a, this._handleIndex);
      this._change(a, this._handleIndex);
      this._clickOffset = this._handleIndex = null;
      return (this._animateOff = false);
    },
    _detectOrientation: function () {
      this.orientation = this.options.orientation === 'vertical' ? 'vertical' : 'horizontal';
    },
    _normValueFromMouse: function (a) {
      var b;
      if (this.orientation === 'horizontal') {
        b = this.elementSize.width;
        a = a.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0);
      } else {
        b = this.elementSize.height;
        a = a.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0);
      }
      b = a / b;
      if (b > 1) b = 1;
      if (b < 0) b = 0;
      if (this.orientation === 'vertical') b = 1 - b;
      a = this._valueMax() - this._valueMin();
      return this._trimAlignValue(this._valueMin() + b * a);
    },
    _start: function (a, b) {
      var c = { handle: this.handles[b], value: this.value() };
      if (this.options.values && this.options.values.length) {
        c.value = this.values(b);
        c.values = this.values();
      }
      return this._trigger('start', a, c);
    },
    _slide: function (a, b, c) {
      var f;
      if (this.options.values && this.options.values.length) {
        f = this.values(b ? 0 : 1);
        if (
          this.options.values.length === 2 &&
          this.options.range === true &&
          ((b === 0 && c > f) || (b === 1 && c < f))
        )
          c = f;
        if (c !== this.values(b)) {
          f = this.values();
          f[b] = c;
          a = this._trigger('slide', a, { handle: this.handles[b], value: c, values: f });
          this.values(b ? 0 : 1);
          a !== false && this.values(b, c, true);
        }
      } else if (c !== this.value()) {
        a = this._trigger('slide', a, { handle: this.handles[b], value: c });
        a !== false && this.value(c);
      }
    },
    _stop: function (a, b) {
      var c = { handle: this.handles[b], value: this.value() };
      if (this.options.values && this.options.values.length) {
        c.value = this.values(b);
        c.values = this.values();
      }
      this._trigger('stop', a, c);
    },
    _change: function (a, b) {
      if (!this._keySliding && !this._mouseSliding) {
        var c = { handle: this.handles[b], value: this.value() };
        if (this.options.values && this.options.values.length) {
          c.value = this.values(b);
          c.values = this.values();
        }
        this._trigger('change', a, c);
      }
    },
    value: function (a) {
      if (arguments.length) {
        this.options.value = this._trimAlignValue(a);
        this._refreshValue();
        this._change(null, 0);
      } else return this._value();
    },
    values: function (a, b) {
      var c, f, e;
      if (arguments.length > 1) {
        this.options.values[a] = this._trimAlignValue(b);
        this._refreshValue();
        this._change(null, a);
      } else if (arguments.length)
        if (d.isArray(arguments[0])) {
          c = this.options.values;
          f = arguments[0];
          for (e = 0; e < c.length; e += 1) {
            c[e] = this._trimAlignValue(f[e]);
            this._change(null, e);
          }
          this._refreshValue();
        } else return this.options.values && this.options.values.length ? this._values(a) : this.value();
      else return this._values();
    },
    _setOption: function (a, b) {
      var c,
        f = 0;
      if (d.isArray(this.options.values)) f = this.options.values.length;
      d.Widget.prototype._setOption.apply(this, arguments);
      switch (a) {
        case 'disabled':
          if (b) {
            this.handles.filter('.ui-state-focus').blur();
            this.handles.removeClass('ui-state-hover');
            this.handles.propAttr('disabled', true);
            this.element.addClass('ui-disabled');
          } else {
            this.handles.propAttr('disabled', false);
            this.element.removeClass('ui-disabled');
          }
          break;
        case 'orientation':
          this._detectOrientation();
          this.element.removeClass('ui-slider-horizontal ui-slider-vertical').addClass('ui-slider-' + this.orientation);
          this._refreshValue();
          break;
        case 'value':
          this._animateOff = true;
          this._refreshValue();
          this._change(null, 0);
          this._animateOff = false;
          break;
        case 'values':
          this._animateOff = true;
          this._refreshValue();
          for (c = 0; c < f; c += 1) this._change(null, c);
          this._animateOff = false;
          break;
      }
    },
    _value: function () {
      var a = this.options.value;
      return (a = this._trimAlignValue(a));
    },
    _values: function (a) {
      var b, c;
      if (arguments.length) {
        b = this.options.values[a];
        return (b = this._trimAlignValue(b));
      } else {
        b = this.options.values.slice();
        for (c = 0; c < b.length; c += 1) b[c] = this._trimAlignValue(b[c]);
        return b;
      }
    },
    _trimAlignValue: function (a) {
      if (a <= this._valueMin()) return this._valueMin();
      if (a >= this._valueMax()) return this._valueMax();
      var b = this.options.step > 0 ? this.options.step : 1,
        c = (a - this._valueMin()) % b;
      a = a - c;
      if (Math.abs(c) * 2 >= b) a += c > 0 ? b : -b;
      return parseFloat(a.toFixed(5));
    },
    _valueMin: function () {
      return this.options.min;
    },
    _valueMax: function () {
      return this.options.max;
    },
    _refreshValue: function () {
      var a = this.options.range,
        b = this.options,
        c = this,
        f = !this._animateOff ? b.animate : false,
        e,
        j = {},
        g,
        k,
        l,
        i;
      if (this.options.values && this.options.values.length)
        this.handles.each(function (h) {
          e = ((c.values(h) - c._valueMin()) / (c._valueMax() - c._valueMin())) * 100;
          j[c.orientation === 'horizontal' ? 'left' : 'bottom'] = e + '%';
          d(this).stop(1, 1)[f ? 'animate' : 'css'](j, b.animate);
          if (c.options.range === true)
            if (c.orientation === 'horizontal') {
              if (h === 0) c.range.stop(1, 1)[f ? 'animate' : 'css']({ left: e + '%' }, b.animate);
              if (h === 1)
                c.range[f ? 'animate' : 'css']({ width: e - g + '%' }, { queue: false, duration: b.animate });
            } else {
              if (h === 0) c.range.stop(1, 1)[f ? 'animate' : 'css']({ bottom: e + '%' }, b.animate);
              if (h === 1)
                c.range[f ? 'animate' : 'css']({ height: e - g + '%' }, { queue: false, duration: b.animate });
            }
          g = e;
        });
      else {
        k = this.value();
        l = this._valueMin();
        i = this._valueMax();
        e = i !== l ? ((k - l) / (i - l)) * 100 : 0;
        j[c.orientation === 'horizontal' ? 'left' : 'bottom'] = e + '%';
        this.handle.stop(1, 1)[f ? 'animate' : 'css'](j, b.animate);
        if (a === 'min' && this.orientation === 'horizontal')
          this.range.stop(1, 1)[f ? 'animate' : 'css']({ width: e + '%' }, b.animate);
        if (a === 'max' && this.orientation === 'horizontal')
          this.range[f ? 'animate' : 'css']({ width: 100 - e + '%' }, { queue: false, duration: b.animate });
        if (a === 'min' && this.orientation === 'vertical')
          this.range.stop(1, 1)[f ? 'animate' : 'css']({ height: e + '%' }, b.animate);
        if (a === 'max' && this.orientation === 'vertical')
          this.range[f ? 'animate' : 'css']({ height: 100 - e + '%' }, { queue: false, duration: b.animate });
      }
    },
  });
  d.extend(d.ui.slider, { version: '1.8.16' });
})(jQuery);
/*
 * jQuery UI Datepicker 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Datepicker
 *
 * Depends:
 *	jquery.ui.core.js
 */
(function (d, C) {
  function M() {
    this.debug = false;
    this._curInst = null;
    this._keyEvent = false;
    this._disabledInputs = [];
    this._inDialog = this._datepickerShowing = false;
    this._mainDivId = 'ui-datepicker-div';
    this._inlineClass = 'ui-datepicker-inline';
    this._appendClass = 'ui-datepicker-append';
    this._triggerClass = 'ui-datepicker-trigger';
    this._dialogClass = 'ui-datepicker-dialog';
    this._disableClass = 'ui-datepicker-disabled';
    this._unselectableClass = 'ui-datepicker-unselectable';
    this._currentClass = 'ui-datepicker-current-day';
    this._dayOverClass = 'ui-datepicker-days-cell-over';
    this.regional = [];
    this.regional[''] = {
      closeText: 'Done',
      prevText: 'Prev',
      nextText: 'Next',
      currentText: 'Today',
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      weekHeader: 'Wk',
      dateFormat: 'mm/dd/yy',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: '',
    };
    this._defaults = {
      showOn: 'focus',
      showAnim: 'fadeIn',
      showOptions: {},
      defaultDate: null,
      appendText: '',
      buttonText: '...',
      buttonImage: '',
      buttonImageOnly: false,
      hideIfNoPrevNext: false,
      navigationAsDateFormat: false,
      gotoCurrent: false,
      changeMonth: false,
      changeYear: false,
      yearRange: 'c-10:c+10',
      showOtherMonths: false,
      selectOtherMonths: false,
      showWeek: false,
      calculateWeek: this.iso8601Week,
      shortYearCutoff: '+10',
      minDate: null,
      maxDate: null,
      duration: 'fast',
      beforeShowDay: null,
      beforeShow: null,
      onSelect: null,
      onChangeMonthYear: null,
      onClose: null,
      numberOfMonths: 1,
      showCurrentAtPos: 0,
      stepMonths: 1,
      stepBigMonths: 12,
      altField: '',
      altFormat: '',
      constrainInput: true,
      showButtonPanel: false,
      autoSize: false,
      disabled: false,
    };
    d.extend(this._defaults, this.regional['']);
    this.dpDiv = N(
      d(
        '<div id="' +
          this._mainDivId +
          '" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>',
      ),
    );
  }
  function N(a) {
    return a
      .bind('mouseout', function (b) {
        b = d(b.target).closest('button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a');
        b.length && b.removeClass('ui-state-hover ui-datepicker-prev-hover ui-datepicker-next-hover');
      })
      .bind('mouseover', function (b) {
        b = d(b.target).closest('button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a');
        if (!(d.datepicker._isDisabledDatepicker(J.inline ? a.parent()[0] : J.input[0]) || !b.length)) {
          b.parents('.ui-datepicker-calendar').find('a').removeClass('ui-state-hover');
          b.addClass('ui-state-hover');
          b.hasClass('ui-datepicker-prev') && b.addClass('ui-datepicker-prev-hover');
          b.hasClass('ui-datepicker-next') && b.addClass('ui-datepicker-next-hover');
        }
      });
  }
  function H(a, b) {
    d.extend(a, b);
    for (var c in b) if (b[c] == null || b[c] == C) a[c] = b[c];
    return a;
  }
  d.extend(d.ui, { datepicker: { version: '1.8.16' } });
  var B = new Date().getTime(),
    J;
  d.extend(M.prototype, {
    markerClassName: 'hasDatepicker',
    maxRows: 4,
    log: function () {
      this.debug && console.log.apply('', arguments);
    },
    _widgetDatepicker: function () {
      return this.dpDiv;
    },
    setDefaults: function (a) {
      H(this._defaults, a || {});
      return this;
    },
    _attachDatepicker: function (a, b) {
      var c = null;
      for (var e in this._defaults) {
        var f = a.getAttribute('date:' + e);
        if (f) {
          c = c || {};
          try {
            c[e] = eval(f);
          } catch (h) {
            c[e] = f;
          }
        }
      }
      e = a.nodeName.toLowerCase();
      f = e == 'div' || e == 'span';
      if (!a.id) {
        this.uuid += 1;
        a.id = 'dp' + this.uuid;
      }
      var i = this._newInst(d(a), f);
      i.settings = d.extend({}, b || {}, c || {});
      if (e == 'input') this._connectDatepicker(a, i);
      else f && this._inlineDatepicker(a, i);
    },
    _newInst: function (a, b) {
      return {
        id: a[0].id.replace(/([^A-Za-z0-9_-])/g, '\\\\$1'),
        input: a,
        selectedDay: 0,
        selectedMonth: 0,
        selectedYear: 0,
        drawMonth: 0,
        drawYear: 0,
        inline: b,
        dpDiv: !b
          ? this.dpDiv
          : N(
              d(
                '<div class="' +
                  this._inlineClass +
                  ' ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>',
              ),
            ),
      };
    },
    _connectDatepicker: function (a, b) {
      var c = d(a);
      b.append = d([]);
      b.trigger = d([]);
      if (!c.hasClass(this.markerClassName)) {
        this._attachments(c, b);
        c.addClass(this.markerClassName)
          .keydown(this._doKeyDown)
          .keypress(this._doKeyPress)
          .keyup(this._doKeyUp)
          .bind('setData.datepicker', function (e, f, h) {
            b.settings[f] = h;
          })
          .bind('getData.datepicker', function (e, f) {
            return this._get(b, f);
          });
        this._autoSize(b);
        d.data(a, 'datepicker', b);
        b.settings.disabled && this._disableDatepicker(a);
      }
    },
    _attachments: function (a, b) {
      var c = this._get(b, 'appendText'),
        e = this._get(b, 'isRTL');
      b.append && b.append.remove();
      if (c) {
        b.append = d('<span class="' + this._appendClass + '">' + c + '</span>');
        a[e ? 'before' : 'after'](b.append);
      }
      a.unbind('focus', this._showDatepicker);
      b.trigger && b.trigger.remove();
      c = this._get(b, 'showOn');
      if (c == 'focus' || c == 'both') a.focus(this._showDatepicker);
      if (c == 'button' || c == 'both') {
        c = this._get(b, 'buttonText');
        var f = this._get(b, 'buttonImage');
        b.trigger = d(
          this._get(b, 'buttonImageOnly')
            ? d('<img/>').addClass(this._triggerClass).attr({ src: f, alt: c, title: c })
            : d('<button type="button"></button>')
                .addClass(this._triggerClass)
                .html(f == '' ? c : d('<img/>').attr({ src: f, alt: c, title: c })),
        );
        a[e ? 'before' : 'after'](b.trigger);
        b.trigger.click(function () {
          d.datepicker._datepickerShowing && d.datepicker._lastInput == a[0]
            ? d.datepicker._hideDatepicker()
            : d.datepicker._showDatepicker(a[0]);
          return false;
        });
      }
    },
    _autoSize: function (a) {
      if (this._get(a, 'autoSize') && !a.inline) {
        var b = new Date(2009, 11, 20),
          c = this._get(a, 'dateFormat');
        if (c.match(/[DM]/)) {
          var e = function (f) {
            for (var h = 0, i = 0, g = 0; g < f.length; g++)
              if (f[g].length > h) {
                h = f[g].length;
                i = g;
              }
            return i;
          };
          b.setMonth(e(this._get(a, c.match(/MM/) ? 'monthNames' : 'monthNamesShort')));
          b.setDate(e(this._get(a, c.match(/DD/) ? 'dayNames' : 'dayNamesShort')) + 20 - b.getDay());
        }
        a.input.attr('size', this._formatDate(a, b).length);
      }
    },
    _inlineDatepicker: function (a, b) {
      var c = d(a);
      if (!c.hasClass(this.markerClassName)) {
        c.addClass(this.markerClassName)
          .append(b.dpDiv)
          .bind('setData.datepicker', function (e, f, h) {
            b.settings[f] = h;
          })
          .bind('getData.datepicker', function (e, f) {
            return this._get(b, f);
          });
        d.data(a, 'datepicker', b);
        this._setDate(b, this._getDefaultDate(b), true);
        this._updateDatepicker(b);
        this._updateAlternate(b);
        b.settings.disabled && this._disableDatepicker(a);
        b.dpDiv.css('display', 'block');
      }
    },
    _dialogDatepicker: function (a, b, c, e, f) {
      a = this._dialogInst;
      if (!a) {
        this.uuid += 1;
        this._dialogInput = d(
          '<input type="text" id="' +
            ('dp' + this.uuid) +
            '" style="position: absolute; top: -100px; width: 0px; z-index: -10;"/>',
        );
        this._dialogInput.keydown(this._doKeyDown);
        d('body').append(this._dialogInput);
        a = this._dialogInst = this._newInst(this._dialogInput, false);
        a.settings = {};
        d.data(this._dialogInput[0], 'datepicker', a);
      }
      H(a.settings, e || {});
      b = b && b.constructor == Date ? this._formatDate(a, b) : b;
      this._dialogInput.val(b);
      this._pos = f ? (f.length ? f : [f.pageX, f.pageY]) : null;
      if (!this._pos)
        this._pos = [
          document.documentElement.clientWidth / 2 -
            100 +
            (document.documentElement.scrollLeft || document.body.scrollLeft),
          document.documentElement.clientHeight / 2 -
            150 +
            (document.documentElement.scrollTop || document.body.scrollTop),
        ];
      this._dialogInput.css('left', this._pos[0] + 20 + 'px').css('top', this._pos[1] + 'px');
      a.settings.onSelect = c;
      this._inDialog = true;
      this.dpDiv.addClass(this._dialogClass);
      this._showDatepicker(this._dialogInput[0]);
      d.blockUI && d.blockUI(this.dpDiv);
      d.data(this._dialogInput[0], 'datepicker', a);
      return this;
    },
    _destroyDatepicker: function (a) {
      var b = d(a),
        c = d.data(a, 'datepicker');
      if (b.hasClass(this.markerClassName)) {
        var e = a.nodeName.toLowerCase();
        d.removeData(a, 'datepicker');
        if (e == 'input') {
          c.append.remove();
          c.trigger.remove();
          b.removeClass(this.markerClassName)
            .unbind('focus', this._showDatepicker)
            .unbind('keydown', this._doKeyDown)
            .unbind('keypress', this._doKeyPress)
            .unbind('keyup', this._doKeyUp);
        } else if (e == 'div' || e == 'span') b.removeClass(this.markerClassName).empty();
      }
    },
    _enableDatepicker: function (a) {
      var b = d(a),
        c = d.data(a, 'datepicker');
      if (b.hasClass(this.markerClassName)) {
        var e = a.nodeName.toLowerCase();
        if (e == 'input') {
          a.disabled = false;
          c.trigger
            .filter('button')
            .each(function () {
              this.disabled = false;
            })
            .end()
            .filter('img')
            .css({ opacity: '1.0', cursor: '' });
        } else if (e == 'div' || e == 'span') {
          b = b.children('.' + this._inlineClass);
          b.children().removeClass('ui-state-disabled');
          b.find('select.ui-datepicker-month, select.ui-datepicker-year').removeAttr('disabled');
        }
        this._disabledInputs = d.map(this._disabledInputs, function (f) {
          return f == a ? null : f;
        });
      }
    },
    _disableDatepicker: function (a) {
      var b = d(a),
        c = d.data(a, 'datepicker');
      if (b.hasClass(this.markerClassName)) {
        var e = a.nodeName.toLowerCase();
        if (e == 'input') {
          a.disabled = true;
          c.trigger
            .filter('button')
            .each(function () {
              this.disabled = true;
            })
            .end()
            .filter('img')
            .css({ opacity: '0.5', cursor: 'default' });
        } else if (e == 'div' || e == 'span') {
          b = b.children('.' + this._inlineClass);
          b.children().addClass('ui-state-disabled');
          b.find('select.ui-datepicker-month, select.ui-datepicker-year').attr('disabled', 'disabled');
        }
        this._disabledInputs = d.map(this._disabledInputs, function (f) {
          return f == a ? null : f;
        });
        this._disabledInputs[this._disabledInputs.length] = a;
      }
    },
    _isDisabledDatepicker: function (a) {
      if (!a) return false;
      for (var b = 0; b < this._disabledInputs.length; b++) if (this._disabledInputs[b] == a) return true;
      return false;
    },
    _getInst: function (a) {
      try {
        return d.data(a, 'datepicker');
      } catch (b) {
        throw 'Missing instance data for this datepicker';
      }
    },
    _optionDatepicker: function (a, b, c) {
      var e = this._getInst(a);
      if (arguments.length == 2 && typeof b == 'string')
        return b == 'defaults'
          ? d.extend({}, d.datepicker._defaults)
          : e
          ? b == 'all'
            ? d.extend({}, e.settings)
            : this._get(e, b)
          : null;
      var f = b || {};
      if (typeof b == 'string') {
        f = {};
        f[b] = c;
      }
      if (e) {
        this._curInst == e && this._hideDatepicker();
        var h = this._getDateDatepicker(a, true),
          i = this._getMinMaxDate(e, 'min'),
          g = this._getMinMaxDate(e, 'max');
        H(e.settings, f);
        if (i !== null && f.dateFormat !== C && f.minDate === C) e.settings.minDate = this._formatDate(e, i);
        if (g !== null && f.dateFormat !== C && f.maxDate === C) e.settings.maxDate = this._formatDate(e, g);
        this._attachments(d(a), e);
        this._autoSize(e);
        this._setDate(e, h);
        this._updateAlternate(e);
        this._updateDatepicker(e);
      }
    },
    _changeDatepicker: function (a, b, c) {
      this._optionDatepicker(a, b, c);
    },
    _refreshDatepicker: function (a) {
      (a = this._getInst(a)) && this._updateDatepicker(a);
    },
    _setDateDatepicker: function (a, b) {
      if ((a = this._getInst(a))) {
        this._setDate(a, b);
        this._updateDatepicker(a);
        this._updateAlternate(a);
      }
    },
    _getDateDatepicker: function (a, b) {
      (a = this._getInst(a)) && !a.inline && this._setDateFromField(a, b);
      return a ? this._getDate(a) : null;
    },
    _doKeyDown: function (a) {
      var b = d.datepicker._getInst(a.target),
        c = true,
        e = b.dpDiv.is('.ui-datepicker-rtl');
      b._keyEvent = true;
      if (d.datepicker._datepickerShowing)
        switch (a.keyCode) {
          case 9:
            d.datepicker._hideDatepicker();
            c = false;
            break;
          case 13:
            c = d('td.' + d.datepicker._dayOverClass + ':not(.' + d.datepicker._currentClass + ')', b.dpDiv);
            c[0] && d.datepicker._selectDay(a.target, b.selectedMonth, b.selectedYear, c[0]);
            if ((a = d.datepicker._get(b, 'onSelect'))) {
              c = d.datepicker._formatDate(b);
              a.apply(b.input ? b.input[0] : null, [c, b]);
            } else d.datepicker._hideDatepicker();
            return false;
          case 27:
            d.datepicker._hideDatepicker();
            break;
          case 33:
            d.datepicker._adjustDate(
              a.target,
              a.ctrlKey ? -d.datepicker._get(b, 'stepBigMonths') : -d.datepicker._get(b, 'stepMonths'),
              'M',
            );
            break;
          case 34:
            d.datepicker._adjustDate(
              a.target,
              a.ctrlKey ? +d.datepicker._get(b, 'stepBigMonths') : +d.datepicker._get(b, 'stepMonths'),
              'M',
            );
            break;
          case 35:
            if (a.ctrlKey || a.metaKey) d.datepicker._clearDate(a.target);
            c = a.ctrlKey || a.metaKey;
            break;
          case 36:
            if (a.ctrlKey || a.metaKey) d.datepicker._gotoToday(a.target);
            c = a.ctrlKey || a.metaKey;
            break;
          case 37:
            if (a.ctrlKey || a.metaKey) d.datepicker._adjustDate(a.target, e ? +1 : -1, 'D');
            c = a.ctrlKey || a.metaKey;
            if (a.originalEvent.altKey)
              d.datepicker._adjustDate(
                a.target,
                a.ctrlKey ? -d.datepicker._get(b, 'stepBigMonths') : -d.datepicker._get(b, 'stepMonths'),
                'M',
              );
            break;
          case 38:
            if (a.ctrlKey || a.metaKey) d.datepicker._adjustDate(a.target, -7, 'D');
            c = a.ctrlKey || a.metaKey;
            break;
          case 39:
            if (a.ctrlKey || a.metaKey) d.datepicker._adjustDate(a.target, e ? -1 : +1, 'D');
            c = a.ctrlKey || a.metaKey;
            if (a.originalEvent.altKey)
              d.datepicker._adjustDate(
                a.target,
                a.ctrlKey ? +d.datepicker._get(b, 'stepBigMonths') : +d.datepicker._get(b, 'stepMonths'),
                'M',
              );
            break;
          case 40:
            if (a.ctrlKey || a.metaKey) d.datepicker._adjustDate(a.target, +7, 'D');
            c = a.ctrlKey || a.metaKey;
            break;
          default:
            c = false;
        }
      else if (a.keyCode == 36 && a.ctrlKey) d.datepicker._showDatepicker(this);
      else c = false;
      if (c) {
        a.preventDefault();
        a.stopPropagation();
      }
    },
    _doKeyPress: function (a) {
      var b = d.datepicker._getInst(a.target);
      if (d.datepicker._get(b, 'constrainInput')) {
        b = d.datepicker._possibleChars(d.datepicker._get(b, 'dateFormat'));
        var c = String.fromCharCode(a.charCode == C ? a.keyCode : a.charCode);
        return a.ctrlKey || a.metaKey || c < ' ' || !b || b.indexOf(c) > -1;
      }
    },
    _doKeyUp: function (a) {
      a = d.datepicker._getInst(a.target);
      if (a.input.val() != a.lastVal)
        try {
          if (
            d.datepicker.parseDate(
              d.datepicker._get(a, 'dateFormat'),
              a.input ? a.input.val() : null,
              d.datepicker._getFormatConfig(a),
            )
          ) {
            d.datepicker._setDateFromField(a);
            d.datepicker._updateAlternate(a);
            d.datepicker._updateDatepicker(a);
          }
        } catch (b) {
          d.datepicker.log(b);
        }
      return true;
    },
    _showDatepicker: function (a) {
      a = a.target || a;
      if (a.nodeName.toLowerCase() != 'input') a = d('input', a.parentNode)[0];
      if (!(d.datepicker._isDisabledDatepicker(a) || d.datepicker._lastInput == a)) {
        var b = d.datepicker._getInst(a);
        if (d.datepicker._curInst && d.datepicker._curInst != b) {
          d.datepicker._datepickerShowing && d.datepicker._triggerOnClose(d.datepicker._curInst);
          d.datepicker._curInst.dpDiv.stop(true, true);
        }
        var c = d.datepicker._get(b, 'beforeShow');
        c = c ? c.apply(a, [a, b]) : {};
        if (c !== false) {
          H(b.settings, c);
          b.lastVal = null;
          d.datepicker._lastInput = a;
          d.datepicker._setDateFromField(b);
          if (d.datepicker._inDialog) a.value = '';
          if (!d.datepicker._pos) {
            d.datepicker._pos = d.datepicker._findPos(a);
            d.datepicker._pos[1] += a.offsetHeight;
          }
          var e = false;
          d(a)
            .parents()
            .each(function () {
              e |= d(this).css('position') == 'fixed';
              return !e;
            });
          if (e && d.browser.opera) {
            d.datepicker._pos[0] -= document.documentElement.scrollLeft;
            d.datepicker._pos[1] -= document.documentElement.scrollTop;
          }
          c = { left: d.datepicker._pos[0], top: d.datepicker._pos[1] };
          d.datepicker._pos = null;
          b.dpDiv.empty();
          b.dpDiv.css({ position: 'absolute', display: 'block', top: '-1000px' });
          d.datepicker._updateDatepicker(b);
          c = d.datepicker._checkOffset(b, c, e);
          b.dpDiv.css({
            position: d.datepicker._inDialog && d.blockUI ? 'static' : e ? 'fixed' : 'absolute',
            display: 'none',
            left: c.left + 'px',
            top: c.top + 'px',
          });
          if (!b.inline) {
            c = d.datepicker._get(b, 'showAnim');
            var f = d.datepicker._get(b, 'duration'),
              h = function () {
                var i = b.dpDiv.find('iframe.ui-datepicker-cover');
                if (i.length) {
                  var g = d.datepicker._getBorders(b.dpDiv);
                  i.css({ left: -g[0], top: -g[1], width: b.dpDiv.outerWidth(), height: b.dpDiv.outerHeight() });
                }
              };
            b.dpDiv.zIndex(d(a).zIndex() + 1);
            d.datepicker._datepickerShowing = true;
            d.effects && d.effects[c]
              ? b.dpDiv.show(c, d.datepicker._get(b, 'showOptions'), f, h)
              : b.dpDiv[c || 'show'](c ? f : null, h);
            if (!c || !f) h();
            b.input.is(':visible') && !b.input.is(':disabled') && b.input.focus();
            d.datepicker._curInst = b;
          }
        }
      }
    },
    _updateDatepicker: function (a) {
      this.maxRows = 4;
      var b = d.datepicker._getBorders(a.dpDiv);
      J = a;
      a.dpDiv.empty().append(this._generateHTML(a));
      var c = a.dpDiv.find('iframe.ui-datepicker-cover');
      c.length && c.css({ left: -b[0], top: -b[1], width: a.dpDiv.outerWidth(), height: a.dpDiv.outerHeight() });
      a.dpDiv.find('.' + this._dayOverClass + ' a').mouseover();
      b = this._getNumberOfMonths(a);
      c = b[1];
      a.dpDiv.removeClass('ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4').width('');
      c > 1 && a.dpDiv.addClass('ui-datepicker-multi-' + c).css('width', 17 * c + 'em');
      a.dpDiv[(b[0] != 1 || b[1] != 1 ? 'add' : 'remove') + 'Class']('ui-datepicker-multi');
      a.dpDiv[(this._get(a, 'isRTL') ? 'add' : 'remove') + 'Class']('ui-datepicker-rtl');
      a == d.datepicker._curInst &&
        d.datepicker._datepickerShowing &&
        a.input &&
        a.input.is(':visible') &&
        !a.input.is(':disabled') &&
        a.input[0] != document.activeElement &&
        a.input.focus();
      if (a.yearshtml) {
        var e = a.yearshtml;
        setTimeout(function () {
          e === a.yearshtml && a.yearshtml && a.dpDiv.find('select.ui-datepicker-year:first').replaceWith(a.yearshtml);
          e = a.yearshtml = null;
        }, 0);
      }
    },
    _getBorders: function (a) {
      var b = function (c) {
        return { thin: 1, medium: 2, thick: 3 }[c] || c;
      };
      return [parseFloat(b(a.css('border-left-width'))), parseFloat(b(a.css('border-top-width')))];
    },
    _checkOffset: function (a, b, c) {
      var e = a.dpDiv.outerWidth(),
        f = a.dpDiv.outerHeight(),
        h = a.input ? a.input.outerWidth() : 0,
        i = a.input ? a.input.outerHeight() : 0,
        g = document.documentElement.clientWidth + d(document).scrollLeft(),
        j = document.documentElement.clientHeight + d(document).scrollTop();
      b.left -= this._get(a, 'isRTL') ? e - h : 0;
      b.left -= c && b.left == a.input.offset().left ? d(document).scrollLeft() : 0;
      b.top -= c && b.top == a.input.offset().top + i ? d(document).scrollTop() : 0;
      b.left -= Math.min(b.left, b.left + e > g && g > e ? Math.abs(b.left + e - g) : 0);
      b.top -= Math.min(b.top, b.top + f > j && j > f ? Math.abs(f + i) : 0);
      return b;
    },
    _findPos: function (a) {
      for (
        var b = this._get(this._getInst(a), 'isRTL');
        a && (a.type == 'hidden' || a.nodeType != 1 || d.expr.filters.hidden(a));

      )
        a = a[b ? 'previousSibling' : 'nextSibling'];
      a = d(a).offset();
      return [a.left, a.top];
    },
    _triggerOnClose: function (a) {
      var b = this._get(a, 'onClose');
      if (b) b.apply(a.input ? a.input[0] : null, [a.input ? a.input.val() : '', a]);
    },
    _hideDatepicker: function (a) {
      var b = this._curInst;
      if (!(!b || (a && b != d.data(a, 'datepicker'))))
        if (this._datepickerShowing) {
          a = this._get(b, 'showAnim');
          var c = this._get(b, 'duration'),
            e = function () {
              d.datepicker._tidyDialog(b);
              this._curInst = null;
            };
          d.effects && d.effects[a]
            ? b.dpDiv.hide(a, d.datepicker._get(b, 'showOptions'), c, e)
            : b.dpDiv[a == 'slideDown' ? 'slideUp' : a == 'fadeIn' ? 'fadeOut' : 'hide'](a ? c : null, e);
          a || e();
          d.datepicker._triggerOnClose(b);
          this._datepickerShowing = false;
          this._lastInput = null;
          if (this._inDialog) {
            this._dialogInput.css({ position: 'absolute', left: '0', top: '-100px' });
            if (d.blockUI) {
              d.unblockUI();
              d('body').append(this.dpDiv);
            }
          }
          this._inDialog = false;
        }
    },
    _tidyDialog: function (a) {
      a.dpDiv.removeClass(this._dialogClass).unbind('.ui-datepicker-calendar');
    },
    _checkExternalClick: function (a) {
      if (d.datepicker._curInst) {
        a = d(a.target);
        a[0].id != d.datepicker._mainDivId &&
          a.parents('#' + d.datepicker._mainDivId).length == 0 &&
          !a.hasClass(d.datepicker.markerClassName) &&
          !a.hasClass(d.datepicker._triggerClass) &&
          d.datepicker._datepickerShowing &&
          !(d.datepicker._inDialog && d.blockUI) &&
          d.datepicker._hideDatepicker();
      }
    },
    _adjustDate: function (a, b, c) {
      a = d(a);
      var e = this._getInst(a[0]);
      if (!this._isDisabledDatepicker(a[0])) {
        this._adjustInstDate(e, b + (c == 'M' ? this._get(e, 'showCurrentAtPos') : 0), c);
        this._updateDatepicker(e);
      }
    },
    _gotoToday: function (a) {
      a = d(a);
      var b = this._getInst(a[0]);
      if (this._get(b, 'gotoCurrent') && b.currentDay) {
        b.selectedDay = b.currentDay;
        b.drawMonth = b.selectedMonth = b.currentMonth;
        b.drawYear = b.selectedYear = b.currentYear;
      } else {
        var c = new Date();
        b.selectedDay = c.getDate();
        b.drawMonth = b.selectedMonth = c.getMonth();
        b.drawYear = b.selectedYear = c.getFullYear();
      }
      this._notifyChange(b);
      this._adjustDate(a);
    },
    _selectMonthYear: function (a, b, c) {
      a = d(a);
      var e = this._getInst(a[0]);
      e['selected' + (c == 'M' ? 'Month' : 'Year')] = e['draw' + (c == 'M' ? 'Month' : 'Year')] = parseInt(
        b.options[b.selectedIndex].value,
        10,
      );
      this._notifyChange(e);
      this._adjustDate(a);
    },
    _selectDay: function (a, b, c, e) {
      var f = d(a);
      if (!(d(e).hasClass(this._unselectableClass) || this._isDisabledDatepicker(f[0]))) {
        f = this._getInst(f[0]);
        f.selectedDay = f.currentDay = d('a', e).html();
        f.selectedMonth = f.currentMonth = b;
        f.selectedYear = f.currentYear = c;
        this._selectDate(a, this._formatDate(f, f.currentDay, f.currentMonth, f.currentYear));
      }
    },
    _clearDate: function (a) {
      a = d(a);
      this._getInst(a[0]);
      this._selectDate(a, '');
    },
    _selectDate: function (a, b) {
      a = this._getInst(d(a)[0]);
      b = b != null ? b : this._formatDate(a);
      a.input && a.input.val(b);
      this._updateAlternate(a);
      var c = this._get(a, 'onSelect');
      if (c) c.apply(a.input ? a.input[0] : null, [b, a]);
      else a.input && a.input.trigger('change');
      if (a.inline) this._updateDatepicker(a);
      else {
        this._hideDatepicker();
        this._lastInput = a.input[0];
        typeof a.input[0] != 'object' && a.input.focus();
        this._lastInput = null;
      }
    },
    _updateAlternate: function (a) {
      var b = this._get(a, 'altField');
      if (b) {
        var c = this._get(a, 'altFormat') || this._get(a, 'dateFormat'),
          e = this._getDate(a),
          f = this.formatDate(c, e, this._getFormatConfig(a));
        d(b).each(function () {
          d(this).val(f);
        });
      }
    },
    noWeekends: function (a) {
      a = a.getDay();
      return [a > 0 && a < 6, ''];
    },
    iso8601Week: function (a) {
      a = new Date(a.getTime());
      a.setDate(a.getDate() + 4 - (a.getDay() || 7));
      var b = a.getTime();
      a.setMonth(0);
      a.setDate(1);
      return Math.floor(Math.round((b - a) / 864e5) / 7) + 1;
    },
    parseDate: function (a, b, c) {
      if (a == null || b == null) throw 'Invalid arguments';
      b = typeof b == 'object' ? b.toString() : b + '';
      if (b == '') return null;
      var e = (c ? c.shortYearCutoff : null) || this._defaults.shortYearCutoff;
      e = typeof e != 'string' ? e : (new Date().getFullYear() % 100) + parseInt(e, 10);
      for (
        var f = (c ? c.dayNamesShort : null) || this._defaults.dayNamesShort,
          h = (c ? c.dayNames : null) || this._defaults.dayNames,
          i = (c ? c.monthNamesShort : null) || this._defaults.monthNamesShort,
          g = (c ? c.monthNames : null) || this._defaults.monthNames,
          j = (c = -1),
          l = -1,
          u = -1,
          k = false,
          o = function (p) {
            (p = A + 1 < a.length && a.charAt(A + 1) == p) && A++;
            return p;
          },
          m = function (p) {
            var D = o(p);
            p = new RegExp('^\\d{1,' + (p == '@' ? 14 : p == '!' ? 20 : p == 'y' && D ? 4 : p == 'o' ? 3 : 2) + '}');
            p = b.substring(q).match(p);
            if (!p) throw 'Missing number at position ' + q;
            q += p[0].length;
            return parseInt(p[0], 10);
          },
          n = function (p, D, K) {
            p = d
              .map(o(p) ? K : D, function (w, x) {
                return [[x, w]];
              })
              .sort(function (w, x) {
                return -(w[1].length - x[1].length);
              });
            var E = -1;
            d.each(p, function (w, x) {
              w = x[1];
              if (b.substr(q, w.length).toLowerCase() == w.toLowerCase()) {
                E = x[0];
                q += w.length;
                return false;
              }
            });
            if (E != -1) return E + 1;
            else throw 'Unknown name at position ' + q;
          },
          s = function () {
            if (b.charAt(q) != a.charAt(A)) throw 'Unexpected literal at position ' + q;
            q++;
          },
          q = 0,
          A = 0;
        A < a.length;
        A++
      )
        if (k)
          if (a.charAt(A) == "'" && !o("'")) k = false;
          else s();
        else
          switch (a.charAt(A)) {
            case 'd':
              l = m('d');
              break;
            case 'D':
              n('D', f, h);
              break;
            case 'o':
              u = m('o');
              break;
            case 'm':
              j = m('m');
              break;
            case 'M':
              j = n('M', i, g);
              break;
            case 'y':
              c = m('y');
              break;
            case '@':
              var v = new Date(m('@'));
              c = v.getFullYear();
              j = v.getMonth() + 1;
              l = v.getDate();
              break;
            case '!':
              v = new Date((m('!') - this._ticksTo1970) / 1e4);
              c = v.getFullYear();
              j = v.getMonth() + 1;
              l = v.getDate();
              break;
            case "'":
              if (o("'")) s();
              else k = true;
              break;
            default:
              s();
          }
      if (q < b.length) throw 'Extra/unparsed characters found in date: ' + b.substring(q);
      if (c == -1) c = new Date().getFullYear();
      else if (c < 100) c += new Date().getFullYear() - (new Date().getFullYear() % 100) + (c <= e ? 0 : -100);
      if (u > -1) {
        j = 1;
        l = u;
        do {
          e = this._getDaysInMonth(c, j - 1);
          if (l <= e) break;
          j++;
          l -= e;
        } while (1);
      }
      v = this._daylightSavingAdjust(new Date(c, j - 1, l));
      if (v.getFullYear() != c || v.getMonth() + 1 != j || v.getDate() != l) throw 'Invalid date';
      return v;
    },
    ATOM: 'yy-mm-dd',
    COOKIE: 'D, dd M yy',
    ISO_8601: 'yy-mm-dd',
    RFC_822: 'D, d M y',
    RFC_850: 'DD, dd-M-y',
    RFC_1036: 'D, d M y',
    RFC_1123: 'D, d M yy',
    RFC_2822: 'D, d M yy',
    RSS: 'D, d M y',
    TICKS: '!',
    TIMESTAMP: '@',
    W3C: 'yy-mm-dd',
    _ticksTo1970: (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 24 * 60 * 60 * 1e7,
    formatDate: function (a, b, c) {
      if (!b) return '';
      var e = (c ? c.dayNamesShort : null) || this._defaults.dayNamesShort,
        f = (c ? c.dayNames : null) || this._defaults.dayNames,
        h = (c ? c.monthNamesShort : null) || this._defaults.monthNamesShort;
      c = (c ? c.monthNames : null) || this._defaults.monthNames;
      var i = function (o) {
          (o = k + 1 < a.length && a.charAt(k + 1) == o) && k++;
          return o;
        },
        g = function (o, m, n) {
          m = '' + m;
          if (i(o)) for (; m.length < n; ) m = '0' + m;
          return m;
        },
        j = function (o, m, n, s) {
          return i(o) ? s[m] : n[m];
        },
        l = '',
        u = false;
      if (b)
        for (var k = 0; k < a.length; k++)
          if (u)
            if (a.charAt(k) == "'" && !i("'")) u = false;
            else l += a.charAt(k);
          else
            switch (a.charAt(k)) {
              case 'd':
                l += g('d', b.getDate(), 2);
                break;
              case 'D':
                l += j('D', b.getDay(), e, f);
                break;
              case 'o':
                l += g(
                  'o',
                  Math.round(
                    (new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime() -
                      new Date(b.getFullYear(), 0, 0).getTime()) /
                      864e5,
                  ),
                  3,
                );
                break;
              case 'm':
                l += g('m', b.getMonth() + 1, 2);
                break;
              case 'M':
                l += j('M', b.getMonth(), h, c);
                break;
              case 'y':
                l += i('y') ? b.getFullYear() : (b.getYear() % 100 < 10 ? '0' : '') + (b.getYear() % 100);
                break;
              case '@':
                l += b.getTime();
                break;
              case '!':
                l += b.getTime() * 1e4 + this._ticksTo1970;
                break;
              case "'":
                if (i("'")) l += "'";
                else u = true;
                break;
              default:
                l += a.charAt(k);
            }
      return l;
    },
    _possibleChars: function (a) {
      for (
        var b = '',
          c = false,
          e = function (h) {
            (h = f + 1 < a.length && a.charAt(f + 1) == h) && f++;
            return h;
          },
          f = 0;
        f < a.length;
        f++
      )
        if (c)
          if (a.charAt(f) == "'" && !e("'")) c = false;
          else b += a.charAt(f);
        else
          switch (a.charAt(f)) {
            case 'd':
            case 'm':
            case 'y':
            case '@':
              b += '0123456789';
              break;
            case 'D':
            case 'M':
              return null;
            case "'":
              if (e("'")) b += "'";
              else c = true;
              break;
            default:
              b += a.charAt(f);
          }
      return b;
    },
    _get: function (a, b) {
      return a.settings[b] !== C ? a.settings[b] : this._defaults[b];
    },
    _setDateFromField: function (a, b) {
      if (a.input.val() != a.lastVal) {
        var c = this._get(a, 'dateFormat'),
          e = (a.lastVal = a.input ? a.input.val() : null),
          f,
          h;
        f = h = this._getDefaultDate(a);
        var i = this._getFormatConfig(a);
        try {
          f = this.parseDate(c, e, i) || h;
        } catch (g) {
          this.log(g);
          e = b ? '' : e;
        }
        a.selectedDay = f.getDate();
        a.drawMonth = a.selectedMonth = f.getMonth();
        a.drawYear = a.selectedYear = f.getFullYear();
        a.currentDay = e ? f.getDate() : 0;
        a.currentMonth = e ? f.getMonth() : 0;
        a.currentYear = e ? f.getFullYear() : 0;
        this._adjustInstDate(a);
      }
    },
    _getDefaultDate: function (a) {
      return this._restrictMinMax(a, this._determineDate(a, this._get(a, 'defaultDate'), new Date()));
    },
    _determineDate: function (a, b, c) {
      var e = function (h) {
          var i = new Date();
          i.setDate(i.getDate() + h);
          return i;
        },
        f = function (h) {
          try {
            return d.datepicker.parseDate(d.datepicker._get(a, 'dateFormat'), h, d.datepicker._getFormatConfig(a));
          } catch (i) {}
          var g = (h.toLowerCase().match(/^c/) ? d.datepicker._getDate(a) : null) || new Date(),
            j = g.getFullYear(),
            l = g.getMonth();
          g = g.getDate();
          for (var u = /([+-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, k = u.exec(h); k; ) {
            switch (k[2] || 'd') {
              case 'd':
              case 'D':
                g += parseInt(k[1], 10);
                break;
              case 'w':
              case 'W':
                g += parseInt(k[1], 10) * 7;
                break;
              case 'm':
              case 'M':
                l += parseInt(k[1], 10);
                g = Math.min(g, d.datepicker._getDaysInMonth(j, l));
                break;
              case 'y':
              case 'Y':
                j += parseInt(k[1], 10);
                g = Math.min(g, d.datepicker._getDaysInMonth(j, l));
                break;
            }
            k = u.exec(h);
          }
          return new Date(j, l, g);
        };
      if (
        (b =
          (b =
            b == null || b === ''
              ? c
              : typeof b == 'string'
              ? f(b)
              : typeof b == 'number'
              ? isNaN(b)
                ? c
                : e(b)
              : new Date(b.getTime())) && b.toString() == 'Invalid Date'
            ? c
            : b)
      ) {
        b.setHours(0);
        b.setMinutes(0);
        b.setSeconds(0);
        b.setMilliseconds(0);
      }
      return this._daylightSavingAdjust(b);
    },
    _daylightSavingAdjust: function (a) {
      if (!a) return null;
      a.setHours(a.getHours() > 12 ? a.getHours() + 2 : 0);
      return a;
    },
    _setDate: function (a, b, c) {
      var e = !b,
        f = a.selectedMonth,
        h = a.selectedYear;
      b = this._restrictMinMax(a, this._determineDate(a, b, new Date()));
      a.selectedDay = a.currentDay = b.getDate();
      a.drawMonth = a.selectedMonth = a.currentMonth = b.getMonth();
      a.drawYear = a.selectedYear = a.currentYear = b.getFullYear();
      if ((f != a.selectedMonth || h != a.selectedYear) && !c) this._notifyChange(a);
      this._adjustInstDate(a);
      if (a.input) a.input.val(e ? '' : this._formatDate(a));
    },
    _getDate: function (a) {
      return !a.currentYear || (a.input && a.input.val() == '')
        ? null
        : this._daylightSavingAdjust(new Date(a.currentYear, a.currentMonth, a.currentDay));
    },
    _generateHTML: function (a) {
      var b = new Date();
      b = this._daylightSavingAdjust(new Date(b.getFullYear(), b.getMonth(), b.getDate()));
      var c = this._get(a, 'isRTL'),
        e = this._get(a, 'showButtonPanel'),
        f = this._get(a, 'hideIfNoPrevNext'),
        h = this._get(a, 'navigationAsDateFormat'),
        i = this._getNumberOfMonths(a),
        g = this._get(a, 'showCurrentAtPos'),
        j = this._get(a, 'stepMonths'),
        l = i[0] != 1 || i[1] != 1,
        u = this._daylightSavingAdjust(
          !a.currentDay ? new Date(9999, 9, 9) : new Date(a.currentYear, a.currentMonth, a.currentDay),
        ),
        k = this._getMinMaxDate(a, 'min'),
        o = this._getMinMaxDate(a, 'max');
      g = a.drawMonth - g;
      var m = a.drawYear;
      if (g < 0) {
        g += 12;
        m--;
      }
      if (o) {
        var n = this._daylightSavingAdjust(new Date(o.getFullYear(), o.getMonth() - i[0] * i[1] + 1, o.getDate()));
        for (n = k && n < k ? k : n; this._daylightSavingAdjust(new Date(m, g, 1)) > n; ) {
          g--;
          if (g < 0) {
            g = 11;
            m--;
          }
        }
      }
      a.drawMonth = g;
      a.drawYear = m;
      n = this._get(a, 'prevText');
      n = !h ? n : this.formatDate(n, this._daylightSavingAdjust(new Date(m, g - j, 1)), this._getFormatConfig(a));
      n = this._canAdjustMonth(a, -1, m, g)
        ? '<a class="ui-datepicker-prev ui-corner-all" onclick="DP_jQuery_' +
          B +
          ".datepicker._adjustDate('#" +
          a.id +
          "', -" +
          j +
          ', \'M\');" title="' +
          n +
          '"><span class="ui-icon ui-icon-circle-triangle-' +
          (c ? 'e' : 'w') +
          '">' +
          n +
          '</span></a>'
        : f
        ? ''
        : '<a class="ui-datepicker-prev ui-corner-all ui-state-disabled" title="' +
          n +
          '"><span class="ui-icon ui-icon-circle-triangle-' +
          (c ? 'e' : 'w') +
          '">' +
          n +
          '</span></a>';
      var s = this._get(a, 'nextText');
      s = !h ? s : this.formatDate(s, this._daylightSavingAdjust(new Date(m, g + j, 1)), this._getFormatConfig(a));
      f = this._canAdjustMonth(a, +1, m, g)
        ? '<a class="ui-datepicker-next ui-corner-all" onclick="DP_jQuery_' +
          B +
          ".datepicker._adjustDate('#" +
          a.id +
          "', +" +
          j +
          ', \'M\');" title="' +
          s +
          '"><span class="ui-icon ui-icon-circle-triangle-' +
          (c ? 'w' : 'e') +
          '">' +
          s +
          '</span></a>'
        : f
        ? ''
        : '<a class="ui-datepicker-next ui-corner-all ui-state-disabled" title="' +
          s +
          '"><span class="ui-icon ui-icon-circle-triangle-' +
          (c ? 'w' : 'e') +
          '">' +
          s +
          '</span></a>';
      j = this._get(a, 'currentText');
      s = this._get(a, 'gotoCurrent') && a.currentDay ? u : b;
      j = !h ? j : this.formatDate(j, s, this._getFormatConfig(a));
      h = !a.inline
        ? '<button type="button" class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all" onclick="DP_jQuery_' +
          B +
          '.datepicker._hideDatepicker();">' +
          this._get(a, 'closeText') +
          '</button>'
        : '';
      e = e
        ? '<div class="ui-datepicker-buttonpane ui-widget-content">' +
          (c ? h : '') +
          (this._isInRange(a, s)
            ? '<button type="button" class="ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all" onclick="DP_jQuery_' +
              B +
              ".datepicker._gotoToday('#" +
              a.id +
              '\');">' +
              j +
              '</button>'
            : '') +
          (c ? '' : h) +
          '</div>'
        : '';
      h = parseInt(this._get(a, 'firstDay'), 10);
      h = isNaN(h) ? 0 : h;
      j = this._get(a, 'showWeek');
      s = this._get(a, 'dayNames');
      this._get(a, 'dayNamesShort');
      var q = this._get(a, 'dayNamesMin'),
        A = this._get(a, 'monthNames'),
        v = this._get(a, 'monthNamesShort'),
        p = this._get(a, 'beforeShowDay'),
        D = this._get(a, 'showOtherMonths'),
        K = this._get(a, 'selectOtherMonths');
      this._get(a, 'calculateWeek');
      for (var E = this._getDefaultDate(a), w = '', x = 0; x < i[0]; x++) {
        var O = '';
        this.maxRows = 4;
        for (var G = 0; G < i[1]; G++) {
          var P = this._daylightSavingAdjust(new Date(m, g, a.selectedDay)),
            t = ' ui-corner-all',
            y = '';
          if (l) {
            y += '<div class="ui-datepicker-group';
            if (i[1] > 1)
              switch (G) {
                case 0:
                  y += ' ui-datepicker-group-first';
                  t = ' ui-corner-' + (c ? 'right' : 'left');
                  break;
                case i[1] - 1:
                  y += ' ui-datepicker-group-last';
                  t = ' ui-corner-' + (c ? 'left' : 'right');
                  break;
                default:
                  y += ' ui-datepicker-group-middle';
                  t = '';
                  break;
              }
            y += '">';
          }
          y +=
            '<div class="ui-datepicker-header ui-widget-header ui-helper-clearfix' +
            t +
            '">' +
            (/all|left/.test(t) && x == 0 ? (c ? f : n) : '') +
            (/all|right/.test(t) && x == 0 ? (c ? n : f) : '') +
            this._generateMonthYearHeader(a, g, m, k, o, x > 0 || G > 0, A, v) +
            '</div><table class="ui-datepicker-calendar"><thead><tr>';
          var z = j ? '<th class="ui-datepicker-week-col">' + this._get(a, 'weekHeader') + '</th>' : '';
          for (t = 0; t < 7; t++) {
            var r = (t + h) % 7;
            z +=
              '<th' +
              ((t + h + 6) % 7 >= 5 ? ' class="ui-datepicker-week-end"' : '') +
              '><span title="' +
              s[r] +
              '">' +
              q[r] +
              '</span></th>';
          }
          y += z + '</tr></thead><tbody>';
          z = this._getDaysInMonth(m, g);
          if (m == a.selectedYear && g == a.selectedMonth) a.selectedDay = Math.min(a.selectedDay, z);
          t = (this._getFirstDayOfMonth(m, g) - h + 7) % 7;
          z = Math.ceil((t + z) / 7);
          this.maxRows = z = l ? (this.maxRows > z ? this.maxRows : z) : z;
          r = this._daylightSavingAdjust(new Date(m, g, 1 - t));
          for (var Q = 0; Q < z; Q++) {
            y += '<tr>';
            var R = !j ? '' : '<td class="ui-datepicker-week-col">' + this._get(a, 'calculateWeek')(r) + '</td>';
            for (t = 0; t < 7; t++) {
              var I = p ? p.apply(a.input ? a.input[0] : null, [r]) : [true, ''],
                F = r.getMonth() != g,
                L = (F && !K) || !I[0] || (k && r < k) || (o && r > o);
              R +=
                '<td class="' +
                ((t + h + 6) % 7 >= 5 ? ' ui-datepicker-week-end' : '') +
                (F ? ' ui-datepicker-other-month' : '') +
                ((r.getTime() == P.getTime() && g == a.selectedMonth && a._keyEvent) ||
                (E.getTime() == r.getTime() && E.getTime() == P.getTime())
                  ? ' ' + this._dayOverClass
                  : '') +
                (L ? ' ' + this._unselectableClass + ' ui-state-disabled' : '') +
                (F && !D
                  ? ''
                  : ' ' +
                    I[1] +
                    (r.getTime() == u.getTime() ? ' ' + this._currentClass : '') +
                    (r.getTime() == b.getTime() ? ' ui-datepicker-today' : '')) +
                '"' +
                ((!F || D) && I[2] ? ' title="' + I[2] + '"' : '') +
                (L
                  ? ''
                  : ' onclick="DP_jQuery_' +
                    B +
                    ".datepicker._selectDay('#" +
                    a.id +
                    "'," +
                    r.getMonth() +
                    ',' +
                    r.getFullYear() +
                    ', this);return false;"') +
                '>' +
                (F && !D
                  ? '&#xa0;'
                  : L
                  ? '<span class="ui-state-default">' + r.getDate() + '</span>'
                  : '<a class="ui-state-default' +
                    (r.getTime() == b.getTime() ? ' ui-state-highlight' : '') +
                    (r.getTime() == u.getTime() ? ' ui-state-active' : '') +
                    (F ? ' ui-priority-secondary' : '') +
                    '" href="#">' +
                    r.getDate() +
                    '</a>') +
                '</td>';
              r.setDate(r.getDate() + 1);
              r = this._daylightSavingAdjust(r);
            }
            y += R + '</tr>';
          }
          g++;
          if (g > 11) {
            g = 0;
            m++;
          }
          y +=
            '</tbody></table>' +
            (l ? '</div>' + (i[0] > 0 && G == i[1] - 1 ? '<div class="ui-datepicker-row-break"></div>' : '') : '');
          O += y;
        }
        w += O;
      }
      w +=
        e +
        (d.browser.msie && parseInt(d.browser.version, 10) < 7 && !a.inline
          ? '<iframe src="javascript:false;" class="ui-datepicker-cover" frameborder="0"></iframe>'
          : '');
      a._keyEvent = false;
      return w;
    },
    _generateMonthYearHeader: function (a, b, c, e, f, h, i, g) {
      var j = this._get(a, 'changeMonth'),
        l = this._get(a, 'changeYear'),
        u = this._get(a, 'showMonthAfterYear'),
        k = '<div class="ui-datepicker-title">',
        o = '';
      if (h || !j) o += '<span class="ui-datepicker-month">' + i[b] + '</span>';
      else {
        i = e && e.getFullYear() == c;
        var m = f && f.getFullYear() == c;
        o +=
          '<select class="ui-datepicker-month" onchange="DP_jQuery_' +
          B +
          ".datepicker._selectMonthYear('#" +
          a.id +
          "', this, 'M');\" >";
        for (var n = 0; n < 12; n++)
          if ((!i || n >= e.getMonth()) && (!m || n <= f.getMonth()))
            o += '<option value="' + n + '"' + (n == b ? ' selected="selected"' : '') + '>' + g[n] + '</option>';
        o += '</select>';
      }
      u || (k += o + (h || !(j && l) ? '&#xa0;' : ''));
      if (!a.yearshtml) {
        a.yearshtml = '';
        if (h || !l) k += '<span class="ui-datepicker-year">' + c + '</span>';
        else {
          g = this._get(a, 'yearRange').split(':');
          var s = new Date().getFullYear();
          i = function (q) {
            q = q.match(/c[+-].*/)
              ? c + parseInt(q.substring(1), 10)
              : q.match(/[+-].*/)
              ? s + parseInt(q, 10)
              : parseInt(q, 10);
            return isNaN(q) ? s : q;
          };
          b = i(g[0]);
          g = Math.max(b, i(g[1] || ''));
          b = e ? Math.max(b, e.getFullYear()) : b;
          g = f ? Math.min(g, f.getFullYear()) : g;
          for (
            a.yearshtml +=
              '<select class="ui-datepicker-year" onchange="DP_jQuery_' +
              B +
              ".datepicker._selectMonthYear('#" +
              a.id +
              "', this, 'Y');\" >";
            b <= g;
            b++
          )
            a.yearshtml += '<option value="' + b + '"' + (b == c ? ' selected="selected"' : '') + '>' + b + '</option>';
          a.yearshtml += '</select>';
          k += a.yearshtml;
          a.yearshtml = null;
        }
      }
      k += this._get(a, 'yearSuffix');
      if (u) k += (h || !(j && l) ? '&#xa0;' : '') + o;
      k += '</div>';
      return k;
    },
    _adjustInstDate: function (a, b, c) {
      var e = a.drawYear + (c == 'Y' ? b : 0),
        f = a.drawMonth + (c == 'M' ? b : 0);
      b = Math.min(a.selectedDay, this._getDaysInMonth(e, f)) + (c == 'D' ? b : 0);
      e = this._restrictMinMax(a, this._daylightSavingAdjust(new Date(e, f, b)));
      a.selectedDay = e.getDate();
      a.drawMonth = a.selectedMonth = e.getMonth();
      a.drawYear = a.selectedYear = e.getFullYear();
      if (c == 'M' || c == 'Y') this._notifyChange(a);
    },
    _restrictMinMax: function (a, b) {
      var c = this._getMinMaxDate(a, 'min');
      a = this._getMinMaxDate(a, 'max');
      b = c && b < c ? c : b;
      return (b = a && b > a ? a : b);
    },
    _notifyChange: function (a) {
      var b = this._get(a, 'onChangeMonthYear');
      if (b) b.apply(a.input ? a.input[0] : null, [a.selectedYear, a.selectedMonth + 1, a]);
    },
    _getNumberOfMonths: function (a) {
      a = this._get(a, 'numberOfMonths');
      return a == null ? [1, 1] : typeof a == 'number' ? [1, a] : a;
    },
    _getMinMaxDate: function (a, b) {
      return this._determineDate(a, this._get(a, b + 'Date'), null);
    },
    _getDaysInMonth: function (a, b) {
      return 32 - this._daylightSavingAdjust(new Date(a, b, 32)).getDate();
    },
    _getFirstDayOfMonth: function (a, b) {
      return new Date(a, b, 1).getDay();
    },
    _canAdjustMonth: function (a, b, c, e) {
      var f = this._getNumberOfMonths(a);
      c = this._daylightSavingAdjust(new Date(c, e + (b < 0 ? b : f[0] * f[1]), 1));
      b < 0 && c.setDate(this._getDaysInMonth(c.getFullYear(), c.getMonth()));
      return this._isInRange(a, c);
    },
    _isInRange: function (a, b) {
      var c = this._getMinMaxDate(a, 'min');
      a = this._getMinMaxDate(a, 'max');
      return (!c || b.getTime() >= c.getTime()) && (!a || b.getTime() <= a.getTime());
    },
    _getFormatConfig: function (a) {
      var b = this._get(a, 'shortYearCutoff');
      b = typeof b != 'string' ? b : (new Date().getFullYear() % 100) + parseInt(b, 10);
      return {
        shortYearCutoff: b,
        dayNamesShort: this._get(a, 'dayNamesShort'),
        dayNames: this._get(a, 'dayNames'),
        monthNamesShort: this._get(a, 'monthNamesShort'),
        monthNames: this._get(a, 'monthNames'),
      };
    },
    _formatDate: function (a, b, c, e) {
      if (!b) {
        a.currentDay = a.selectedDay;
        a.currentMonth = a.selectedMonth;
        a.currentYear = a.selectedYear;
      }
      b = b
        ? typeof b == 'object'
          ? b
          : this._daylightSavingAdjust(new Date(e, c, b))
        : this._daylightSavingAdjust(new Date(a.currentYear, a.currentMonth, a.currentDay));
      return this.formatDate(this._get(a, 'dateFormat'), b, this._getFormatConfig(a));
    },
  });
  d.fn.datepicker = function (a) {
    if (!this.length) return this;
    if (!d.datepicker.initialized) {
      d(document).mousedown(d.datepicker._checkExternalClick).find('body').append(d.datepicker.dpDiv);
      d.datepicker.initialized = true;
    }
    var b = Array.prototype.slice.call(arguments, 1);
    if (typeof a == 'string' && (a == 'isDisabled' || a == 'getDate' || a == 'widget'))
      return d.datepicker['_' + a + 'Datepicker'].apply(d.datepicker, [this[0]].concat(b));
    if (a == 'option' && arguments.length == 2 && typeof arguments[1] == 'string')
      return d.datepicker['_' + a + 'Datepicker'].apply(d.datepicker, [this[0]].concat(b));
    return this.each(function () {
      typeof a == 'string'
        ? d.datepicker['_' + a + 'Datepicker'].apply(d.datepicker, [this].concat(b))
        : d.datepicker._attachDatepicker(this, a);
    });
  };
  d.datepicker = new M();
  d.datepicker.initialized = false;
  d.datepicker.uuid = new Date().getTime();
  d.datepicker.version = '1.8.16';
  window['DP_jQuery_' + B] = d;
})(jQuery);
/*
 * jQuery UI Effects 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/
 */
jQuery.effects ||
  (function (f, j) {
    function m(c) {
      var a;
      if (c && c.constructor == Array && c.length == 3) return c;
      if ((a = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(c)))
        return [parseInt(a[1], 10), parseInt(a[2], 10), parseInt(a[3], 10)];
      if (
        (a = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(c))
      )
        return [parseFloat(a[1]) * 2.55, parseFloat(a[2]) * 2.55, parseFloat(a[3]) * 2.55];
      if ((a = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(c)))
        return [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)];
      if ((a = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(c)))
        return [parseInt(a[1] + a[1], 16), parseInt(a[2] + a[2], 16), parseInt(a[3] + a[3], 16)];
      if (/rgba\(0, 0, 0, 0\)/.exec(c)) return n.transparent;
      return n[f.trim(c).toLowerCase()];
    }
    function s(c, a) {
      var b;
      do {
        b = f.curCSS(c, a);
        if ((b != '' && b != 'transparent') || f.nodeName(c, 'body')) break;
        a = 'backgroundColor';
      } while ((c = c.parentNode));
      return m(b);
    }
    function o() {
      var c = document.defaultView ? document.defaultView.getComputedStyle(this, null) : this.currentStyle,
        a = {},
        b,
        d;
      if (c && c.length && c[0] && c[c[0]])
        for (var e = c.length; e--; ) {
          b = c[e];
          if (typeof c[b] == 'string') {
            d = b.replace(/\-(\w)/g, function (g, h) {
              return h.toUpperCase();
            });
            a[d] = c[b];
          }
        }
      else for (b in c) if (typeof c[b] === 'string') a[b] = c[b];
      return a;
    }
    function p(c) {
      var a, b;
      for (a in c) {
        b = c[a];
        if (
          b == null ||
          f.isFunction(b) ||
          a in t ||
          /scrollbar/.test(a) ||
          (!/color/i.test(a) && isNaN(parseFloat(b)))
        )
          delete c[a];
      }
      return c;
    }
    function u(c, a) {
      var b = { _: 0 },
        d;
      for (d in a) if (c[d] != a[d]) b[d] = a[d];
      return b;
    }
    function k(c, a, b, d) {
      if (typeof c == 'object') {
        d = a;
        b = null;
        a = c;
        c = a.effect;
      }
      if (f.isFunction(a)) {
        d = a;
        b = null;
        a = {};
      }
      if (typeof a == 'number' || f.fx.speeds[a]) {
        d = b;
        b = a;
        a = {};
      }
      if (f.isFunction(b)) {
        d = b;
        b = null;
      }
      a = a || {};
      b = b || a.duration;
      b = f.fx.off ? 0 : typeof b == 'number' ? b : b in f.fx.speeds ? f.fx.speeds[b] : f.fx.speeds._default;
      d = d || a.complete;
      return [c, a, b, d];
    }
    function l(c) {
      if (!c || typeof c === 'number' || f.fx.speeds[c]) return true;
      if (typeof c === 'string' && !f.effects[c]) return true;
      return false;
    }
    f.effects = {};
    f.each(
      [
        'backgroundColor',
        'borderBottomColor',
        'borderLeftColor',
        'borderRightColor',
        'borderTopColor',
        'borderColor',
        'color',
        'outlineColor',
      ],
      function (c, a) {
        f.fx.step[a] = function (b) {
          if (!b.colorInit) {
            b.start = s(b.elem, a);
            b.end = m(b.end);
            b.colorInit = true;
          }
          b.elem.style[a] =
            'rgb(' +
            Math.max(Math.min(parseInt(b.pos * (b.end[0] - b.start[0]) + b.start[0], 10), 255), 0) +
            ',' +
            Math.max(Math.min(parseInt(b.pos * (b.end[1] - b.start[1]) + b.start[1], 10), 255), 0) +
            ',' +
            Math.max(Math.min(parseInt(b.pos * (b.end[2] - b.start[2]) + b.start[2], 10), 255), 0) +
            ')';
        };
      },
    );
    var n = {
        aqua: [0, 255, 255],
        azure: [240, 255, 255],
        beige: [245, 245, 220],
        black: [0, 0, 0],
        blue: [0, 0, 255],
        brown: [165, 42, 42],
        cyan: [0, 255, 255],
        darkblue: [0, 0, 139],
        darkcyan: [0, 139, 139],
        darkgrey: [169, 169, 169],
        darkgreen: [0, 100, 0],
        darkkhaki: [189, 183, 107],
        darkmagenta: [139, 0, 139],
        darkolivegreen: [85, 107, 47],
        darkorange: [255, 140, 0],
        darkorchid: [153, 50, 204],
        darkred: [139, 0, 0],
        darksalmon: [233, 150, 122],
        darkviolet: [148, 0, 211],
        fuchsia: [255, 0, 255],
        gold: [255, 215, 0],
        green: [0, 128, 0],
        indigo: [75, 0, 130],
        khaki: [240, 230, 140],
        lightblue: [173, 216, 230],
        lightcyan: [224, 255, 255],
        lightgreen: [144, 238, 144],
        lightgrey: [211, 211, 211],
        lightpink: [255, 182, 193],
        lightyellow: [255, 255, 224],
        lime: [0, 255, 0],
        magenta: [255, 0, 255],
        maroon: [128, 0, 0],
        navy: [0, 0, 128],
        olive: [128, 128, 0],
        orange: [255, 165, 0],
        pink: [255, 192, 203],
        purple: [128, 0, 128],
        violet: [128, 0, 128],
        red: [255, 0, 0],
        silver: [192, 192, 192],
        white: [255, 255, 255],
        yellow: [255, 255, 0],
        transparent: [255, 255, 255],
      },
      q = ['add', 'remove', 'toggle'],
      t = {
        border: 1,
        borderBottom: 1,
        borderColor: 1,
        borderLeft: 1,
        borderRight: 1,
        borderTop: 1,
        borderWidth: 1,
        margin: 1,
        padding: 1,
      };
    f.effects.animateClass = function (c, a, b, d) {
      if (f.isFunction(b)) {
        d = b;
        b = null;
      }
      return this.queue(function () {
        var e = f(this),
          g = e.attr('style') || ' ',
          h = p(o.call(this)),
          r,
          v = e.attr('class');
        f.each(q, function (w, i) {
          c[i] && e[i + 'Class'](c[i]);
        });
        r = p(o.call(this));
        e.attr('class', v);
        e.animate(u(h, r), {
          queue: false,
          duration: a,
          easing: b,
          complete: function () {
            f.each(q, function (w, i) {
              c[i] && e[i + 'Class'](c[i]);
            });
            if (typeof e.attr('style') == 'object') {
              e.attr('style').cssText = '';
              e.attr('style').cssText = g;
            } else e.attr('style', g);
            d && d.apply(this, arguments);
            f.dequeue(this);
          },
        });
      });
    };
    f.fn.extend({
      _addClass: f.fn.addClass,
      addClass: function (c, a, b, d) {
        return a ? f.effects.animateClass.apply(this, [{ add: c }, a, b, d]) : this._addClass(c);
      },
      _removeClass: f.fn.removeClass,
      removeClass: function (c, a, b, d) {
        return a ? f.effects.animateClass.apply(this, [{ remove: c }, a, b, d]) : this._removeClass(c);
      },
      _toggleClass: f.fn.toggleClass,
      toggleClass: function (c, a, b, d, e) {
        return typeof a == 'boolean' || a === j
          ? b
            ? f.effects.animateClass.apply(this, [a ? { add: c } : { remove: c }, b, d, e])
            : this._toggleClass(c, a)
          : f.effects.animateClass.apply(this, [{ toggle: c }, a, b, d]);
      },
      switchClass: function (c, a, b, d, e) {
        return f.effects.animateClass.apply(this, [{ add: a, remove: c }, b, d, e]);
      },
    });
    f.extend(f.effects, {
      version: '1.8.16',
      save: function (c, a) {
        for (var b = 0; b < a.length; b++) a[b] !== null && c.data('ec.storage.' + a[b], c[0].style[a[b]]);
      },
      restore: function (c, a) {
        for (var b = 0; b < a.length; b++) a[b] !== null && c.css(a[b], c.data('ec.storage.' + a[b]));
      },
      setMode: function (c, a) {
        if (a == 'toggle') a = c.is(':hidden') ? 'show' : 'hide';
        return a;
      },
      getBaseline: function (c, a) {
        var b;
        switch (c[0]) {
          case 'top':
            b = 0;
            break;
          case 'middle':
            b = 0.5;
            break;
          case 'bottom':
            b = 1;
            break;
          default:
            b = c[0] / a.height;
        }
        switch (c[1]) {
          case 'left':
            c = 0;
            break;
          case 'center':
            c = 0.5;
            break;
          case 'right':
            c = 1;
            break;
          default:
            c = c[1] / a.width;
        }
        return { x: c, y: b };
      },
      createWrapper: function (c) {
        if (c.parent().is('.ui-effects-wrapper')) return c.parent();
        var a = { width: c.outerWidth(true), height: c.outerHeight(true), float: c.css('float') },
          b = f('<div></div>')
            .addClass('ui-effects-wrapper')
            .css({ fontSize: '100%', background: 'transparent', border: 'none', margin: 0, padding: 0 }),
          d = document.activeElement;
        c.wrap(b);
        if (c[0] === d || f.contains(c[0], d)) f(d).focus();
        b = c.parent();
        if (c.css('position') == 'static') {
          b.css({ position: 'relative' });
          c.css({ position: 'relative' });
        } else {
          f.extend(a, { position: c.css('position'), zIndex: c.css('z-index') });
          f.each(['top', 'left', 'bottom', 'right'], function (e, g) {
            a[g] = c.css(g);
            if (isNaN(parseInt(a[g], 10))) a[g] = 'auto';
          });
          c.css({ position: 'relative', top: 0, left: 0, right: 'auto', bottom: 'auto' });
        }
        return b.css(a).show();
      },
      removeWrapper: function (c) {
        var a,
          b = document.activeElement;
        if (c.parent().is('.ui-effects-wrapper')) {
          a = c.parent().replaceWith(c);
          if (c[0] === b || f.contains(c[0], b)) f(b).focus();
          return a;
        }
        return c;
      },
      setTransition: function (c, a, b, d) {
        d = d || {};
        f.each(a, function (e, g) {
          unit = c.cssUnit(g);
          if (unit[0] > 0) d[g] = unit[0] * b + unit[1];
        });
        return d;
      },
    });
    f.fn.extend({
      effect: function (c) {
        var a = k.apply(this, arguments),
          b = { options: a[1], duration: a[2], callback: a[3] };
        a = b.options.mode;
        var d = f.effects[c];
        if (f.fx.off || !d)
          return a
            ? this[a](b.duration, b.callback)
            : this.each(function () {
                b.callback && b.callback.call(this);
              });
        return d.call(this, b);
      },
      _show: f.fn.show,
      show: function (c) {
        if (l(c)) return this._show.apply(this, arguments);
        else {
          var a = k.apply(this, arguments);
          a[1].mode = 'show';
          return this.effect.apply(this, a);
        }
      },
      _hide: f.fn.hide,
      hide: function (c) {
        if (l(c)) return this._hide.apply(this, arguments);
        else {
          var a = k.apply(this, arguments);
          a[1].mode = 'hide';
          return this.effect.apply(this, a);
        }
      },
      __toggle: f.fn.toggle,
      toggle: function (c) {
        if (l(c) || typeof c === 'boolean' || f.isFunction(c)) return this.__toggle.apply(this, arguments);
        else {
          var a = k.apply(this, arguments);
          a[1].mode = 'toggle';
          return this.effect.apply(this, a);
        }
      },
      cssUnit: function (c) {
        var a = this.css(c),
          b = [];
        f.each(['em', 'px', '%', 'pt'], function (d, e) {
          if (a.indexOf(e) > 0) b = [parseFloat(a), e];
        });
        return b;
      },
    });
    f.easing.jswing = f.easing.swing;
    f.extend(f.easing, {
      def: 'easeOutQuad',
      swing: function (c, a, b, d, e) {
        return f.easing[f.easing.def](c, a, b, d, e);
      },
      easeInQuad: function (c, a, b, d, e) {
        return d * (a /= e) * a + b;
      },
      easeOutQuad: function (c, a, b, d, e) {
        return -d * (a /= e) * (a - 2) + b;
      },
      easeInOutQuad: function (c, a, b, d, e) {
        if ((a /= e / 2) < 1) return (d / 2) * a * a + b;
        return (-d / 2) * (--a * (a - 2) - 1) + b;
      },
      easeInCubic: function (c, a, b, d, e) {
        return d * (a /= e) * a * a + b;
      },
      easeOutCubic: function (c, a, b, d, e) {
        return d * ((a = a / e - 1) * a * a + 1) + b;
      },
      easeInOutCubic: function (c, a, b, d, e) {
        if ((a /= e / 2) < 1) return (d / 2) * a * a * a + b;
        return (d / 2) * ((a -= 2) * a * a + 2) + b;
      },
      easeInQuart: function (c, a, b, d, e) {
        return d * (a /= e) * a * a * a + b;
      },
      easeOutQuart: function (c, a, b, d, e) {
        return -d * ((a = a / e - 1) * a * a * a - 1) + b;
      },
      easeInOutQuart: function (c, a, b, d, e) {
        if ((a /= e / 2) < 1) return (d / 2) * a * a * a * a + b;
        return (-d / 2) * ((a -= 2) * a * a * a - 2) + b;
      },
      easeInQuint: function (c, a, b, d, e) {
        return d * (a /= e) * a * a * a * a + b;
      },
      easeOutQuint: function (c, a, b, d, e) {
        return d * ((a = a / e - 1) * a * a * a * a + 1) + b;
      },
      easeInOutQuint: function (c, a, b, d, e) {
        if ((a /= e / 2) < 1) return (d / 2) * a * a * a * a * a + b;
        return (d / 2) * ((a -= 2) * a * a * a * a + 2) + b;
      },
      easeInSine: function (c, a, b, d, e) {
        return -d * Math.cos((a / e) * (Math.PI / 2)) + d + b;
      },
      easeOutSine: function (c, a, b, d, e) {
        return d * Math.sin((a / e) * (Math.PI / 2)) + b;
      },
      easeInOutSine: function (c, a, b, d, e) {
        return (-d / 2) * (Math.cos((Math.PI * a) / e) - 1) + b;
      },
      easeInExpo: function (c, a, b, d, e) {
        return a == 0 ? b : d * Math.pow(2, 10 * (a / e - 1)) + b;
      },
      easeOutExpo: function (c, a, b, d, e) {
        return a == e ? b + d : d * (-Math.pow(2, (-10 * a) / e) + 1) + b;
      },
      easeInOutExpo: function (c, a, b, d, e) {
        if (a == 0) return b;
        if (a == e) return b + d;
        if ((a /= e / 2) < 1) return (d / 2) * Math.pow(2, 10 * (a - 1)) + b;
        return (d / 2) * (-Math.pow(2, -10 * --a) + 2) + b;
      },
      easeInCirc: function (c, a, b, d, e) {
        return -d * (Math.sqrt(1 - (a /= e) * a) - 1) + b;
      },
      easeOutCirc: function (c, a, b, d, e) {
        return d * Math.sqrt(1 - (a = a / e - 1) * a) + b;
      },
      easeInOutCirc: function (c, a, b, d, e) {
        if ((a /= e / 2) < 1) return (-d / 2) * (Math.sqrt(1 - a * a) - 1) + b;
        return (d / 2) * (Math.sqrt(1 - (a -= 2) * a) + 1) + b;
      },
      easeInElastic: function (c, a, b, d, e) {
        c = 1.70158;
        var g = 0,
          h = d;
        if (a == 0) return b;
        if ((a /= e) == 1) return b + d;
        g || (g = e * 0.3);
        if (h < Math.abs(d)) {
          h = d;
          c = g / 4;
        } else c = (g / (2 * Math.PI)) * Math.asin(d / h);
        return -(h * Math.pow(2, 10 * (a -= 1)) * Math.sin(((a * e - c) * 2 * Math.PI) / g)) + b;
      },
      easeOutElastic: function (c, a, b, d, e) {
        c = 1.70158;
        var g = 0,
          h = d;
        if (a == 0) return b;
        if ((a /= e) == 1) return b + d;
        g || (g = e * 0.3);
        if (h < Math.abs(d)) {
          h = d;
          c = g / 4;
        } else c = (g / (2 * Math.PI)) * Math.asin(d / h);
        return h * Math.pow(2, -10 * a) * Math.sin(((a * e - c) * 2 * Math.PI) / g) + d + b;
      },
      easeInOutElastic: function (c, a, b, d, e) {
        c = 1.70158;
        var g = 0,
          h = d;
        if (a == 0) return b;
        if ((a /= e / 2) == 2) return b + d;
        g || (g = e * 0.3 * 1.5);
        if (h < Math.abs(d)) {
          h = d;
          c = g / 4;
        } else c = (g / (2 * Math.PI)) * Math.asin(d / h);
        if (a < 1) return -0.5 * h * Math.pow(2, 10 * (a -= 1)) * Math.sin(((a * e - c) * 2 * Math.PI) / g) + b;
        return h * Math.pow(2, -10 * (a -= 1)) * Math.sin(((a * e - c) * 2 * Math.PI) / g) * 0.5 + d + b;
      },
      easeInBack: function (c, a, b, d, e, g) {
        if (g == j) g = 1.70158;
        return d * (a /= e) * a * ((g + 1) * a - g) + b;
      },
      easeOutBack: function (c, a, b, d, e, g) {
        if (g == j) g = 1.70158;
        return d * ((a = a / e - 1) * a * ((g + 1) * a + g) + 1) + b;
      },
      easeInOutBack: function (c, a, b, d, e, g) {
        if (g == j) g = 1.70158;
        if ((a /= e / 2) < 1) return (d / 2) * a * a * (((g *= 1.525) + 1) * a - g) + b;
        return (d / 2) * ((a -= 2) * a * (((g *= 1.525) + 1) * a + g) + 2) + b;
      },
      easeInBounce: function (c, a, b, d, e) {
        return d - f.easing.easeOutBounce(c, e - a, 0, d, e) + b;
      },
      easeOutBounce: function (c, a, b, d, e) {
        return (a /= e) < 1 / 2.75
          ? d * 7.5625 * a * a + b
          : a < 2 / 2.75
          ? d * (7.5625 * (a -= 1.5 / 2.75) * a + 0.75) + b
          : a < 2.5 / 2.75
          ? d * (7.5625 * (a -= 2.25 / 2.75) * a + 0.9375) + b
          : d * (7.5625 * (a -= 2.625 / 2.75) * a + 0.984375) + b;
      },
      easeInOutBounce: function (c, a, b, d, e) {
        if (a < e / 2) return f.easing.easeInBounce(c, a * 2, 0, d, e) * 0.5 + b;
        return f.easing.easeOutBounce(c, a * 2 - e, 0, d, e) * 0.5 + d * 0.5 + b;
      },
    });
  })(jQuery);
/*
 * jQuery UI Effects Blind 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Blind
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (b) {
  b.effects.blind = function (c) {
    return this.queue(function () {
      var a = b(this),
        g = ['position', 'top', 'bottom', 'left', 'right'],
        f = b.effects.setMode(a, c.options.mode || 'hide'),
        d = c.options.direction || 'vertical';
      b.effects.save(a, g);
      a.show();
      var e = b.effects.createWrapper(a).css({ overflow: 'hidden' }),
        h = d == 'vertical' ? 'height' : 'width';
      d = d == 'vertical' ? e.height() : e.width();
      f == 'show' && e.css(h, 0);
      var i = {};
      i[h] = f == 'show' ? d : 0;
      e.animate(i, c.duration, c.options.easing, function () {
        f == 'hide' && a.hide();
        b.effects.restore(a, g);
        b.effects.removeWrapper(a);
        c.callback && c.callback.apply(a[0], arguments);
        a.dequeue();
      });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Bounce 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Bounce
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (e) {
  e.effects.bounce = function (b) {
    return this.queue(function () {
      var a = e(this),
        l = ['position', 'top', 'bottom', 'left', 'right'],
        h = e.effects.setMode(a, b.options.mode || 'effect'),
        d = b.options.direction || 'up',
        c = b.options.distance || 20,
        m = b.options.times || 5,
        i = b.duration || 250;
      /show|hide/.test(h) && l.push('opacity');
      e.effects.save(a, l);
      a.show();
      e.effects.createWrapper(a);
      var f = d == 'up' || d == 'down' ? 'top' : 'left';
      d = d == 'up' || d == 'left' ? 'pos' : 'neg';
      c = b.options.distance || (f == 'top' ? a.outerHeight({ margin: true }) / 3 : a.outerWidth({ margin: true }) / 3);
      if (h == 'show') a.css('opacity', 0).css(f, d == 'pos' ? -c : c);
      if (h == 'hide') c /= m * 2;
      h != 'hide' && m--;
      if (h == 'show') {
        var g = { opacity: 1 };
        g[f] = (d == 'pos' ? '+=' : '-=') + c;
        a.animate(g, i / 2, b.options.easing);
        c /= 2;
        m--;
      }
      for (g = 0; g < m; g++) {
        var j = {},
          k = {};
        j[f] = (d == 'pos' ? '-=' : '+=') + c;
        k[f] = (d == 'pos' ? '+=' : '-=') + c;
        a.animate(j, i / 2, b.options.easing).animate(k, i / 2, b.options.easing);
        c = h == 'hide' ? c * 2 : c / 2;
      }
      if (h == 'hide') {
        g = { opacity: 0 };
        g[f] = (d == 'pos' ? '-=' : '+=') + c;
        a.animate(g, i / 2, b.options.easing, function () {
          a.hide();
          e.effects.restore(a, l);
          e.effects.removeWrapper(a);
          b.callback && b.callback.apply(this, arguments);
        });
      } else {
        j = {};
        k = {};
        j[f] = (d == 'pos' ? '-=' : '+=') + c;
        k[f] = (d == 'pos' ? '+=' : '-=') + c;
        a.animate(j, i / 2, b.options.easing).animate(k, i / 2, b.options.easing, function () {
          e.effects.restore(a, l);
          e.effects.removeWrapper(a);
          b.callback && b.callback.apply(this, arguments);
        });
      }
      a.queue('fx', function () {
        a.dequeue();
      });
      a.dequeue();
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Clip 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Clip
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (b) {
  b.effects.clip = function (e) {
    return this.queue(function () {
      var a = b(this),
        i = ['position', 'top', 'bottom', 'left', 'right', 'height', 'width'],
        f = b.effects.setMode(a, e.options.mode || 'hide'),
        c = e.options.direction || 'vertical';
      b.effects.save(a, i);
      a.show();
      var d = b.effects.createWrapper(a).css({ overflow: 'hidden' });
      d = a[0].tagName == 'IMG' ? d : a;
      var g = { size: c == 'vertical' ? 'height' : 'width', position: c == 'vertical' ? 'top' : 'left' };
      c = c == 'vertical' ? d.height() : d.width();
      if (f == 'show') {
        d.css(g.size, 0);
        d.css(g.position, c / 2);
      }
      var h = {};
      h[g.size] = f == 'show' ? c : 0;
      h[g.position] = f == 'show' ? 0 : c / 2;
      d.animate(h, {
        queue: false,
        duration: e.duration,
        easing: e.options.easing,
        complete: function () {
          f == 'hide' && a.hide();
          b.effects.restore(a, i);
          b.effects.removeWrapper(a);
          e.callback && e.callback.apply(a[0], arguments);
          a.dequeue();
        },
      });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Drop 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Drop
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (c) {
  c.effects.drop = function (d) {
    return this.queue(function () {
      var a = c(this),
        h = ['position', 'top', 'bottom', 'left', 'right', 'opacity'],
        e = c.effects.setMode(a, d.options.mode || 'hide'),
        b = d.options.direction || 'left';
      c.effects.save(a, h);
      a.show();
      c.effects.createWrapper(a);
      var f = b == 'up' || b == 'down' ? 'top' : 'left';
      b = b == 'up' || b == 'left' ? 'pos' : 'neg';
      var g =
        d.options.distance || (f == 'top' ? a.outerHeight({ margin: true }) / 2 : a.outerWidth({ margin: true }) / 2);
      if (e == 'show') a.css('opacity', 0).css(f, b == 'pos' ? -g : g);
      var i = { opacity: e == 'show' ? 1 : 0 };
      i[f] = (e == 'show' ? (b == 'pos' ? '+=' : '-=') : b == 'pos' ? '-=' : '+=') + g;
      a.animate(i, {
        queue: false,
        duration: d.duration,
        easing: d.options.easing,
        complete: function () {
          e == 'hide' && a.hide();
          c.effects.restore(a, h);
          c.effects.removeWrapper(a);
          d.callback && d.callback.apply(this, arguments);
          a.dequeue();
        },
      });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Explode 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Explode
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (j) {
  j.effects.explode = function (a) {
    return this.queue(function () {
      var c = a.options.pieces ? Math.round(Math.sqrt(a.options.pieces)) : 3,
        d = a.options.pieces ? Math.round(Math.sqrt(a.options.pieces)) : 3;
      a.options.mode = a.options.mode == 'toggle' ? (j(this).is(':visible') ? 'hide' : 'show') : a.options.mode;
      var b = j(this).show().css('visibility', 'hidden'),
        g = b.offset();
      g.top -= parseInt(b.css('marginTop'), 10) || 0;
      g.left -= parseInt(b.css('marginLeft'), 10) || 0;
      for (var h = b.outerWidth(true), i = b.outerHeight(true), e = 0; e < c; e++)
        for (var f = 0; f < d; f++)
          b.clone()
            .appendTo('body')
            .wrap('<div></div>')
            .css({ position: 'absolute', visibility: 'visible', left: -f * (h / d), top: -e * (i / c) })
            .parent()
            .addClass('ui-effects-explode')
            .css({
              position: 'absolute',
              overflow: 'hidden',
              width: h / d,
              height: i / c,
              left: g.left + f * (h / d) + (a.options.mode == 'show' ? (f - Math.floor(d / 2)) * (h / d) : 0),
              top: g.top + e * (i / c) + (a.options.mode == 'show' ? (e - Math.floor(c / 2)) * (i / c) : 0),
              opacity: a.options.mode == 'show' ? 0 : 1,
            })
            .animate(
              {
                left: g.left + f * (h / d) + (a.options.mode == 'show' ? 0 : (f - Math.floor(d / 2)) * (h / d)),
                top: g.top + e * (i / c) + (a.options.mode == 'show' ? 0 : (e - Math.floor(c / 2)) * (i / c)),
                opacity: a.options.mode == 'show' ? 1 : 0,
              },
              a.duration || 500,
            );
      setTimeout(function () {
        a.options.mode == 'show' ? b.css({ visibility: 'visible' }) : b.css({ visibility: 'visible' }).hide();
        a.callback && a.callback.apply(b[0]);
        b.dequeue();
        j('div.ui-effects-explode').remove();
      }, a.duration || 500);
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Fade 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Fade
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (b) {
  b.effects.fade = function (a) {
    return this.queue(function () {
      var c = b(this),
        d = b.effects.setMode(c, a.options.mode || 'hide');
      c.animate(
        { opacity: d },
        {
          queue: false,
          duration: a.duration,
          easing: a.options.easing,
          complete: function () {
            a.callback && a.callback.apply(this, arguments);
            c.dequeue();
          },
        },
      );
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Fold 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Fold
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (c) {
  c.effects.fold = function (a) {
    return this.queue(function () {
      var b = c(this),
        j = ['position', 'top', 'bottom', 'left', 'right'],
        d = c.effects.setMode(b, a.options.mode || 'hide'),
        g = a.options.size || 15,
        h = !!a.options.horizFirst,
        k = a.duration ? a.duration / 2 : c.fx.speeds._default / 2;
      c.effects.save(b, j);
      b.show();
      var e = c.effects.createWrapper(b).css({ overflow: 'hidden' }),
        f = (d == 'show') != h,
        l = f ? ['width', 'height'] : ['height', 'width'];
      f = f ? [e.width(), e.height()] : [e.height(), e.width()];
      var i = /([0-9]+)%/.exec(g);
      if (i) g = (parseInt(i[1], 10) / 100) * f[d == 'hide' ? 0 : 1];
      if (d == 'show') e.css(h ? { height: 0, width: g } : { height: g, width: 0 });
      h = {};
      i = {};
      h[l[0]] = d == 'show' ? f[0] : g;
      i[l[1]] = d == 'show' ? f[1] : 0;
      e.animate(h, k, a.options.easing).animate(i, k, a.options.easing, function () {
        d == 'hide' && b.hide();
        c.effects.restore(b, j);
        c.effects.removeWrapper(b);
        a.callback && a.callback.apply(b[0], arguments);
        b.dequeue();
      });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Highlight 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Highlight
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (b) {
  b.effects.highlight = function (c) {
    return this.queue(function () {
      var a = b(this),
        e = ['backgroundImage', 'backgroundColor', 'opacity'],
        d = b.effects.setMode(a, c.options.mode || 'show'),
        f = { backgroundColor: a.css('backgroundColor') };
      if (d == 'hide') f.opacity = 0;
      b.effects.save(a, e);
      a.show()
        .css({ backgroundImage: 'none', backgroundColor: c.options.color || '#ffff99' })
        .animate(f, {
          queue: false,
          duration: c.duration,
          easing: c.options.easing,
          complete: function () {
            d == 'hide' && a.hide();
            b.effects.restore(a, e);
            d == 'show' && !b.support.opacity && this.style.removeAttribute('filter');
            c.callback && c.callback.apply(this, arguments);
            a.dequeue();
          },
        });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Pulsate 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Pulsate
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (d) {
  d.effects.pulsate = function (a) {
    return this.queue(function () {
      var b = d(this),
        c = d.effects.setMode(b, a.options.mode || 'show');
      times = (a.options.times || 5) * 2 - 1;
      duration = a.duration ? a.duration / 2 : d.fx.speeds._default / 2;
      isVisible = b.is(':visible');
      animateTo = 0;
      if (!isVisible) {
        b.css('opacity', 0).show();
        animateTo = 1;
      }
      if ((c == 'hide' && isVisible) || (c == 'show' && !isVisible)) times--;
      for (c = 0; c < times; c++) {
        b.animate({ opacity: animateTo }, duration, a.options.easing);
        animateTo = (animateTo + 1) % 2;
      }
      b.animate({ opacity: animateTo }, duration, a.options.easing, function () {
        animateTo == 0 && b.hide();
        a.callback && a.callback.apply(this, arguments);
      });
      b.queue('fx', function () {
        b.dequeue();
      }).dequeue();
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Scale 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Scale
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (c) {
  c.effects.puff = function (b) {
    return this.queue(function () {
      var a = c(this),
        e = c.effects.setMode(a, b.options.mode || 'hide'),
        g = parseInt(b.options.percent, 10) || 150,
        h = g / 100,
        i = { height: a.height(), width: a.width() };
      c.extend(b.options, {
        fade: true,
        mode: e,
        percent: e == 'hide' ? g : 100,
        from: e == 'hide' ? i : { height: i.height * h, width: i.width * h },
      });
      a.effect('scale', b.options, b.duration, b.callback);
      a.dequeue();
    });
  };
  c.effects.scale = function (b) {
    return this.queue(function () {
      var a = c(this),
        e = c.extend(true, {}, b.options),
        g = c.effects.setMode(a, b.options.mode || 'effect'),
        h = parseInt(b.options.percent, 10) || (parseInt(b.options.percent, 10) == 0 ? 0 : g == 'hide' ? 0 : 100),
        i = b.options.direction || 'both',
        f = b.options.origin;
      if (g != 'effect') {
        e.origin = f || ['middle', 'center'];
        e.restore = true;
      }
      f = { height: a.height(), width: a.width() };
      a.from = b.options.from || (g == 'show' ? { height: 0, width: 0 } : f);
      h = { y: i != 'horizontal' ? h / 100 : 1, x: i != 'vertical' ? h / 100 : 1 };
      a.to = { height: f.height * h.y, width: f.width * h.x };
      if (b.options.fade) {
        if (g == 'show') {
          a.from.opacity = 0;
          a.to.opacity = 1;
        }
        if (g == 'hide') {
          a.from.opacity = 1;
          a.to.opacity = 0;
        }
      }
      e.from = a.from;
      e.to = a.to;
      e.mode = g;
      a.effect('size', e, b.duration, b.callback);
      a.dequeue();
    });
  };
  c.effects.size = function (b) {
    return this.queue(function () {
      var a = c(this),
        e = ['position', 'top', 'bottom', 'left', 'right', 'width', 'height', 'overflow', 'opacity'],
        g = ['position', 'top', 'bottom', 'left', 'right', 'overflow', 'opacity'],
        h = ['width', 'height', 'overflow'],
        i = ['fontSize'],
        f = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom'],
        k = ['borderLeftWidth', 'borderRightWidth', 'paddingLeft', 'paddingRight'],
        p = c.effects.setMode(a, b.options.mode || 'effect'),
        n = b.options.restore || false,
        m = b.options.scale || 'both',
        l = b.options.origin,
        j = { height: a.height(), width: a.width() };
      a.from = b.options.from || j;
      a.to = b.options.to || j;
      if (l) {
        l = c.effects.getBaseline(l, j);
        a.from.top = (j.height - a.from.height) * l.y;
        a.from.left = (j.width - a.from.width) * l.x;
        a.to.top = (j.height - a.to.height) * l.y;
        a.to.left = (j.width - a.to.width) * l.x;
      }
      var d = {
        from: { y: a.from.height / j.height, x: a.from.width / j.width },
        to: { y: a.to.height / j.height, x: a.to.width / j.width },
      };
      if (m == 'box' || m == 'both') {
        if (d.from.y != d.to.y) {
          e = e.concat(f);
          a.from = c.effects.setTransition(a, f, d.from.y, a.from);
          a.to = c.effects.setTransition(a, f, d.to.y, a.to);
        }
        if (d.from.x != d.to.x) {
          e = e.concat(k);
          a.from = c.effects.setTransition(a, k, d.from.x, a.from);
          a.to = c.effects.setTransition(a, k, d.to.x, a.to);
        }
      }
      if (m == 'content' || m == 'both')
        if (d.from.y != d.to.y) {
          e = e.concat(i);
          a.from = c.effects.setTransition(a, i, d.from.y, a.from);
          a.to = c.effects.setTransition(a, i, d.to.y, a.to);
        }
      c.effects.save(a, n ? e : g);
      a.show();
      c.effects.createWrapper(a);
      a.css('overflow', 'hidden').css(a.from);
      if (m == 'content' || m == 'both') {
        f = f.concat(['marginTop', 'marginBottom']).concat(i);
        k = k.concat(['marginLeft', 'marginRight']);
        h = e.concat(f).concat(k);
        a.find('*[width]').each(function () {
          child = c(this);
          n && c.effects.save(child, h);
          var o = { height: child.height(), width: child.width() };
          child.from = { height: o.height * d.from.y, width: o.width * d.from.x };
          child.to = { height: o.height * d.to.y, width: o.width * d.to.x };
          if (d.from.y != d.to.y) {
            child.from = c.effects.setTransition(child, f, d.from.y, child.from);
            child.to = c.effects.setTransition(child, f, d.to.y, child.to);
          }
          if (d.from.x != d.to.x) {
            child.from = c.effects.setTransition(child, k, d.from.x, child.from);
            child.to = c.effects.setTransition(child, k, d.to.x, child.to);
          }
          child.css(child.from);
          child.animate(child.to, b.duration, b.options.easing, function () {
            n && c.effects.restore(child, h);
          });
        });
      }
      a.animate(a.to, {
        queue: false,
        duration: b.duration,
        easing: b.options.easing,
        complete: function () {
          a.to.opacity === 0 && a.css('opacity', a.from.opacity);
          p == 'hide' && a.hide();
          c.effects.restore(a, n ? e : g);
          c.effects.removeWrapper(a);
          b.callback && b.callback.apply(this, arguments);
          a.dequeue();
        },
      });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Shake 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Shake
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (d) {
  d.effects.shake = function (a) {
    return this.queue(function () {
      var b = d(this),
        j = ['position', 'top', 'bottom', 'left', 'right'];
      d.effects.setMode(b, a.options.mode || 'effect');
      var c = a.options.direction || 'left',
        e = a.options.distance || 20,
        l = a.options.times || 3,
        f = a.duration || a.options.duration || 140;
      d.effects.save(b, j);
      b.show();
      d.effects.createWrapper(b);
      var g = c == 'up' || c == 'down' ? 'top' : 'left',
        h = c == 'up' || c == 'left' ? 'pos' : 'neg';
      c = {};
      var i = {},
        k = {};
      c[g] = (h == 'pos' ? '-=' : '+=') + e;
      i[g] = (h == 'pos' ? '+=' : '-=') + e * 2;
      k[g] = (h == 'pos' ? '-=' : '+=') + e * 2;
      b.animate(c, f, a.options.easing);
      for (e = 1; e < l; e++) b.animate(i, f, a.options.easing).animate(k, f, a.options.easing);
      b.animate(i, f, a.options.easing).animate(c, f / 2, a.options.easing, function () {
        d.effects.restore(b, j);
        d.effects.removeWrapper(b);
        a.callback && a.callback.apply(this, arguments);
      });
      b.queue('fx', function () {
        b.dequeue();
      });
      b.dequeue();
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Slide 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Slide
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (c) {
  c.effects.slide = function (d) {
    return this.queue(function () {
      var a = c(this),
        h = ['position', 'top', 'bottom', 'left', 'right'],
        f = c.effects.setMode(a, d.options.mode || 'show'),
        b = d.options.direction || 'left';
      c.effects.save(a, h);
      a.show();
      c.effects.createWrapper(a).css({ overflow: 'hidden' });
      var g = b == 'up' || b == 'down' ? 'top' : 'left';
      b = b == 'up' || b == 'left' ? 'pos' : 'neg';
      var e = d.options.distance || (g == 'top' ? a.outerHeight({ margin: true }) : a.outerWidth({ margin: true }));
      if (f == 'show') a.css(g, b == 'pos' ? (isNaN(e) ? '-' + e : -e) : e);
      var i = {};
      i[g] = (f == 'show' ? (b == 'pos' ? '+=' : '-=') : b == 'pos' ? '-=' : '+=') + e;
      a.animate(i, {
        queue: false,
        duration: d.duration,
        easing: d.options.easing,
        complete: function () {
          f == 'hide' && a.hide();
          c.effects.restore(a, h);
          c.effects.removeWrapper(a);
          d.callback && d.callback.apply(this, arguments);
          a.dequeue();
        },
      });
    });
  };
})(jQuery);
/*
 * jQuery UI Effects Transfer 1.8.16
 *
 * Copyright 2011, AUTHORS.txt (http://jqueryui.com/about)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * http://docs.jquery.com/UI/Effects/Transfer
 *
 * Depends:
 *	jquery.effects.core.js
 */
(function (e) {
  e.effects.transfer = function (a) {
    return this.queue(function () {
      var b = e(this),
        c = e(a.options.to),
        d = c.offset();
      c = { top: d.top, left: d.left, height: c.innerHeight(), width: c.innerWidth() };
      d = b.offset();
      var f = e('<div class="ui-effects-transfer"></div>')
        .appendTo(document.body)
        .addClass(a.options.className)
        .css({ top: d.top, left: d.left, height: b.innerHeight(), width: b.innerWidth(), position: 'absolute' })
        .animate(c, a.duration, a.options.easing, function () {
          f.remove();
          a.callback && a.callback.apply(b[0], arguments);
          b.dequeue();
        });
    });
  };
})(jQuery);
(function ($) {
  // register namespace
  $.extend(true, window, {
    Slick: {
      CellRangeDecorator: CellRangeDecorator,
    },
  });

  /***
   * Displays an overlay on top of a given cell range.
   *
   * TODO:
   * Currently, it blocks mouse events to DOM nodes behind it.
   * Use FF and WebKit-specific "pointer-events" CSS style, or some kind of event forwarding.
   * Could also construct the borders separately using 4 individual DIVs.
   *
   * @param {Grid} grid
   * @param {Object} options
   */
  function CellRangeDecorator(grid, options) {
    var _elem;
    var _defaults = {
      selectionCssClass: 'slick-range-decorator',
      selectionCss: {
        zIndex: '9999',
        border: '2px dashed red',
      },
    };

    options = $.extend(true, {}, _defaults, options);

    function show(range) {
      if (!_elem) {
        _elem = $('<div></div>', { css: options.selectionCss })
          .addClass(options.selectionCssClass)
          .css('position', 'absolute')
          .appendTo(grid.getCanvasNode());
      }

      var from = grid.getCellNodeBox(range.fromRow, range.fromCell);
      var to = grid.getCellNodeBox(range.toRow, range.toCell);

      _elem.css({
        top: from.top - 1,
        left: from.left - 1,
        height: to.bottom - from.top - 2,
        width: to.right - from.left - 2,
      });

      return _elem;
    }

    function hide() {
      if (_elem) {
        _elem.remove();
        _elem = null;
      }
    }

    $.extend(this, {
      show: show,
      hide: hide,
    });
  }
})(jQuery);

(function ($) {
  // register namespace
  $.extend(true, window, {
    Slick: {
      CellRangeSelector: CellRangeSelector,
    },
  });

  function CellRangeSelector(options) {
    var _grid;
    var _canvas;
    var _dragging;
    var _decorator;
    var _self = this;
    var _handler = new Slick.EventHandler();
    var _defaults = {
      selectionCss: {
        border: '2px dashed blue',
      },
    };

    function init(grid) {
      options = $.extend(true, {}, _defaults, options);
      _decorator = new Slick.CellRangeDecorator(grid, options);
      _grid = grid;
      _canvas = _grid.getCanvasNode();
      _handler
        .subscribe(_grid.onDragInit, handleDragInit)
        .subscribe(_grid.onDragStart, handleDragStart)
        .subscribe(_grid.onDrag, handleDrag)
        .subscribe(_grid.onDragEnd, handleDragEnd);
    }

    function destroy() {
      _handler.unsubscribeAll();
    }

    function handleDragInit(e, dd) {
      // prevent the grid from cancelling drag'n'drop by default
      e.stopImmediatePropagation();
    }

    function handleDragStart(e, dd) {
      var cell = _grid.getCellFromEvent(e);
      if (_self.onBeforeCellRangeSelected.notify(cell) !== false) {
        if (_grid.canCellBeSelected(cell.row, cell.cell)) {
          _dragging = true;
          e.stopImmediatePropagation();
        }
      }
      if (!_dragging) {
        return;
      }

      _grid.focus();

      var start = _grid.getCellFromPoint(dd.startX - $(_canvas).offset().left, dd.startY - $(_canvas).offset().top);

      dd.range = { start: start, end: {} };

      return _decorator.show(new Slick.Range(start.row, start.cell));
    }

    function handleDrag(e, dd) {
      if (!_dragging) {
        return;
      }
      e.stopImmediatePropagation();

      var end = _grid.getCellFromPoint(e.pageX - $(_canvas).offset().left, e.pageY - $(_canvas).offset().top);

      if (!_grid.canCellBeSelected(end.row, end.cell)) {
        return;
      }

      dd.range.end = end;
      _decorator.show(new Slick.Range(dd.range.start.row, dd.range.start.cell, end.row, end.cell));
    }

    function handleDragEnd(e, dd) {
      if (!_dragging) {
        return;
      }

      _dragging = false;
      e.stopImmediatePropagation();

      _decorator.hide();
      _self.onCellRangeSelected.notify({
        range: new Slick.Range(dd.range.start.row, dd.range.start.cell, dd.range.end.row, dd.range.end.cell),
      });
    }

    $.extend(this, {
      init: init,
      destroy: destroy,

      onBeforeCellRangeSelected: new Slick.Event(),
      onCellRangeSelected: new Slick.Event(),
    });
  }
})(jQuery);

(function ($) {
  // register namespace
  $.extend(true, window, {
    Slick: {
      CellSelectionModel: CellSelectionModel,
    },
  });

  function CellSelectionModel(options) {
    var _grid;
    var _canvas;
    var _ranges = [];
    var _self = this;
    var _selector = new Slick.CellRangeSelector({
      selectionCss: {
        border: '2px solid black',
      },
    });
    var _options;
    var _defaults = {
      selectActiveCell: true,
    };

    function init(grid) {
      _options = $.extend(true, {}, _defaults, options);
      _grid = grid;
      _canvas = _grid.getCanvasNode();
      _grid.onActiveCellChanged.subscribe(handleActiveCellChange);
      _grid.onKeyDown.subscribe(handleKeyDown);
      grid.registerPlugin(_selector);
      _selector.onCellRangeSelected.subscribe(handleCellRangeSelected);
      _selector.onBeforeCellRangeSelected.subscribe(handleBeforeCellRangeSelected);
    }

    function destroy() {
      _grid.onActiveCellChanged.unsubscribe(handleActiveCellChange);
      _grid.onKeyDown.unsubscribe(handleKeyDown);
      _selector.onCellRangeSelected.unsubscribe(handleCellRangeSelected);
      _selector.onBeforeCellRangeSelected.unsubscribe(handleBeforeCellRangeSelected);
      _grid.unregisterPlugin(_selector);
    }

    function removeInvalidRanges(ranges) {
      var result = [];

      for (var i = 0; i < ranges.length; i++) {
        var r = ranges[i];
        if (_grid.canCellBeSelected(r.fromRow, r.fromCell) && _grid.canCellBeSelected(r.toRow, r.toCell)) {
          result.push(r);
        }
      }

      return result;
    }

    function setSelectedRanges(ranges) {
      _ranges = removeInvalidRanges(ranges);
      _self.onSelectedRangesChanged.notify(_ranges);
    }

    function getSelectedRanges() {
      return _ranges;
    }

    function handleBeforeCellRangeSelected(e, args) {
      if (_grid.getEditorLock().isActive()) {
        e.stopPropagation();
        return false;
      }
    }

    function handleCellRangeSelected(e, args) {
      setSelectedRanges([args.range]);
    }

    function handleActiveCellChange(e, args) {
      if (_options.selectActiveCell && args.row != null && args.cell != null) {
        setSelectedRanges([new Slick.Range(args.row, args.cell)]);
      }
    }

    function handleKeyDown(e) {
      /***
       * Key codes
       * 37 left
       * 38 up
       * 39 right
       * 40 down
       */
      var ranges, last;
      var active = _grid.getActiveCell();

      if (
        active &&
        e.shiftKey &&
        !e.ctrlKey &&
        !e.altKey &&
        (e.which == 37 || e.which == 39 || e.which == 38 || e.which == 40)
      ) {
        ranges = getSelectedRanges();
        if (!ranges.length) ranges.push(new Slick.Range(active.row, active.cell));

        // keyboard can work with last range only
        last = ranges.pop();

        // can't handle selection out of active cell
        if (!last.contains(active.row, active.cell)) last = new Slick.Range(active.row, active.cell);

        var dRow = last.toRow - last.fromRow,
          dCell = last.toCell - last.fromCell,
          // walking direction
          dirRow = active.row == last.fromRow ? 1 : -1,
          dirCell = active.cell == last.fromCell ? 1 : -1;

        if (e.which == 37) {
          dCell -= dirCell;
        } else if (e.which == 39) {
          dCell += dirCell;
        } else if (e.which == 38) {
          dRow -= dirRow;
        } else if (e.which == 40) {
          dRow += dirRow;
        }

        // define new selection range
        var new_last = new Slick.Range(
          active.row,
          active.cell,
          active.row + dirRow * dRow,
          active.cell + dirCell * dCell,
        );
        if (removeInvalidRanges([new_last]).length) {
          ranges.push(new_last);
          var viewRow = dirRow > 0 ? new_last.toRow : new_last.fromRow;
          var viewCell = dirCell > 0 ? new_last.toCell : new_last.fromCell;
          _grid.scrollRowIntoView(viewRow);
          _grid.scrollCellIntoView(viewRow, viewCell);
        } else ranges.push(last);

        setSelectedRanges(ranges);

        e.preventDefault();
        e.stopPropagation();
      }
    }

    $.extend(this, {
      getSelectedRanges: getSelectedRanges,
      setSelectedRanges: setSelectedRanges,

      init: init,
      destroy: destroy,

      onSelectedRangesChanged: new Slick.Event(),
    });
  }
})(jQuery);

(function ($) {
  // Register namespace
  $.extend(true, window, {
    Slick: {
      AutoTooltips: AutoTooltips,
    },
  });

  /**
   * AutoTooltips plugin to show/hide tooltips when columns are too narrow to fit content.
   * @constructor
   * @param {boolean} [options.enableForCells=true]        - Enable tooltip for grid cells
   * @param {boolean} [options.enableForHeaderCells=false] - Enable tooltip for header cells
   * @param {number}  [options.maxToolTipLength=null]      - The maximum length for a tooltip
   */
  function AutoTooltips(options) {
    var _grid;
    var _self = this;
    var _defaults = {
      enableForCells: true,
      enableForHeaderCells: false,
      maxToolTipLength: null,
    };

    /**
     * Initialize plugin.
     */
    function init(grid) {
      options = $.extend(true, {}, _defaults, options);
      _grid = grid;
      if (options.enableForCells) _grid.onMouseEnter.subscribe(handleMouseEnter);
      if (options.enableForHeaderCells) _grid.onHeaderMouseEnter.subscribe(handleHeaderMouseEnter);
    }

    /**
     * Destroy plugin.
     */
    function destroy() {
      if (options.enableForCells) _grid.onMouseEnter.unsubscribe(handleMouseEnter);
      if (options.enableForHeaderCells) _grid.onHeaderMouseEnter.unsubscribe(handleHeaderMouseEnter);
    }

    /**
     * Handle mouse entering grid cell to add/remove tooltip.
     * @param {jQuery.Event} e - The event
     */
    function handleMouseEnter(e) {
      var cell = _grid.getCellFromEvent(e);
      if (cell) {
        var $node = $(_grid.getCellNode(cell.row, cell.cell));
        var text;
        if ($node.innerWidth() < $node[0].scrollWidth) {
          text = $.trim($node.text());
          if (options.maxToolTipLength && text.length > options.maxToolTipLength) {
            text = text.substr(0, options.maxToolTipLength - 3) + '...';
          }
        } else {
          text = '';
        }
        $node.attr('title', text);
      }
    }

    /**
     * Handle mouse entering header cell to add/remove tooltip.
     * @param {jQuery.Event} e     - The event
     * @param {object} args.column - The column definition
     */
    function handleHeaderMouseEnter(e, args) {
      var column = args.column,
        $node = $(e.target).closest('.slick-header-column');
      if (!column.toolTip) {
        $node.attr('title', $node.innerWidth() < $node[0].scrollWidth ? column.name : '');
      }
    }

    // Public API
    $.extend(this, {
      init: init,
      destroy: destroy,
    });
  }
})(jQuery);
(function ($) {
  // register namespace
  $.extend(true, window, {
    Slick: {
      CellExternalCopyManager: CellExternalCopyManager,
    },
  });

  function CellExternalCopyManager(options) {
    /*
          This manager enables users to copy/paste data from/to an external Spreadsheet application
          such as MS-Excel® or OpenOffice-Spreadsheet.

          Since it is not possible to access directly the clipboard in javascript, the plugin uses
          a trick to do it's job. After detecting the keystroke, we dynamically create a textarea
          where the browser copies/pastes the serialized data.

          options:
            copiedCellStyle : sets the css className used for copied cells. default : "copy-manager"
            dataItemColumnValueExtractor : option to specify a custom column value extractor function

        */
    var _grid;
    var _self = this;
    var _copiedRanges;
    var _options = options || {};
    var _copiedCellStyle = _options.copiedCellStyle || 'copy-manager';

    var keyCodes = {
      C: 67,
      V: 86,
    };

    function init(grid) {
      _grid = grid;
      _grid.onKeyDown.subscribe(handleKeyDown);
    }

    function destroy() {
      _grid.onKeyDown.unsubscribe(handleKeyDown);
    }

    function getDataItemValueForColumn(item, columnDef) {
      if (_options.dataItemColumnValueExtractor) {
        return _options.dataItemColumnValueExtractor(item, columnDef);
      }
      return item[columnDef.field];
    }

    function setDataItemValueForColumn(item, columnDef, value) {
      if (_options.dataItemColumnValueSetter) {
        return _options.dataItemColumnValueSetter(item, columnDef, value);
      }
      return (item[columnDef.field] = value);
    }

    function _createTextBox(innerText) {
      var ta = document.createElement('textarea');
      ta.style.position = 'absolute';
      ta.style.left = '-1000px';
      ta.style.top = '-1000px';
      // yc.park ie bug patch.
      $(ta).val(innerText);
      //ta.innerHTML = innerText;
      document.body.appendChild(ta);
      document.designMode = 'off';
      ta.focus();

      return ta;
    }

    function _decodeTabularData(_grid, ta) {
      var columns = _grid.getColumns();
      var clipText = ta.value;
      var clipRows = clipText.split(String.fromCharCode(10));
      var clippeds = [];

      document.body.removeChild(ta);

      for (var i = 0; i < clipRows.length; i++) {
        clippeds[i] = clipRows[i].split(String.fromCharCode(9));
      }

      var activeCell = _grid.getActiveCell();
      var activeRow = activeCell.row;
      var activeCell = activeCell.cell;
      var desty = activeRow;
      var destx = activeCell;

      for (var y = 0; y < clippeds.length; y++) {
        for (var x = 0; x < clippeds[y].length; x++) {
          var desty = activeRow + y;
          var destx = activeCell + x;

          var nd = _grid.getCellNode(desty, destx);
          var dt = _grid.getDataItem(desty);
          setDataItemValueForColumn(dt, columns[destx], clippeds[y][x]);
          _grid.updateCell(desty, destx);
        }
      }
    }

    function handleKeyDown(e, args) {
      var ranges;
      if (!_grid.getEditorLock().isActive()) {
        if (e.which == $.ui.keyCode.ESCAPE) {
          if (_copiedRanges) {
            e.preventDefault();
            clearCopySelection();
            _self.onCopyCancelled.notify({ ranges: _copiedRanges });
            _copiedRanges = null;
          }
        }

        if (e.which == keyCodes.C && (e.ctrlKey || e.metaKey)) {
          // CTRL + C
          ranges = _grid.getSelectionModel().getSelectedRanges();
          if (ranges.length != 0) {
            _copiedRanges = ranges;
            markCopySelection(ranges);
            _self.onCopyCells.notify({ ranges: ranges });

            var columns = _grid.getColumns();
            var clipTextArr = [];

            for (var rg = 0; rg < ranges.length; rg++) {
              var range = ranges[rg];
              var clipTextRows = [];
              for (var i = range.fromRow; i < range.toRow + 1; i++) {
                var clipTextCells = [];
                var dt = _grid.getDataItem(i);

                for (var j = range.fromCell; j < range.toCell + 1; j++) {
                  clipTextCells.push(getDataItemValueForColumn(dt, columns[j]));
                }
                clipTextRows.push(clipTextCells.join('\t'));
              }
              clipTextArr.push(clipTextRows.join('\n'));
            }
            var clipText = clipTextArr.join('\n');
            var ta = _createTextBox(clipText);
            $(ta).select();

            setTimeout(function () {
              document.body.removeChild(ta);
            }, 100);

            return false;
          }
        }

        if (e.which == keyCodes.V && (e.ctrlKey || e.metaKey)) {
          // CTRL + V
          var ta = _createTextBox('');

          setTimeout(function () {
            _decodeTabularData(_grid, ta);
          }, 100);

          return false;
        }
      }
    }

    function markCopySelection(ranges) {
      var columns = _grid.getColumns();
      var hash = {};
      for (var i = 0; i < ranges.length; i++) {
        for (var j = ranges[i].fromRow; j <= ranges[i].toRow; j++) {
          hash[j] = {};
          for (var k = ranges[i].fromCell; k <= ranges[i].toCell; k++) {
            hash[j][columns[k]._idProperty_] = true;
          }
        }
      }
      _grid.setCellCssStyles(_copiedCellStyle, hash);
    }

    function clearCopySelection() {
      _grid.removeCellCssStyles(_copiedCellStyle);
    }

    $.extend(this, {
      init: init,
      destroy: destroy,
      clearCopySelection: clearCopySelection,

      onCopyCells: new Slick.Event(),
      onCopyCancelled: new Slick.Event(),
      onPasteCells: new Slick.Event(),
    });
  }
})(jQuery);

(function ($) {
  $.extend(true, window, {
    Slick: {
      AutoColumnSize: AutoColumnSize,
    },
  });

  function AutoColumnSize(maxWidth) {
    var grid,
      $container,
      context,
      keyCodes = {
        A: 65,
      };

    function init(_grid) {
      grid = _grid;
      maxWidth = maxWidth || 200;

      $container = $(grid.getContainerNode());
      $container.on('dblclick.autosize', '.slick-resizable-handle', reSizeColumn);
      $container.keydown(handleControlKeys);

      context = document.createElement('canvas').getContext('2d');
    }

    function destroy() {
      $container.off();
    }

    function handleControlKeys(event) {
      if (event.ctrlKey && event.shiftKey && event.keyCode === keyCodes.A) {
        resizeAllColumns();
      }
    }

    function resizeAllColumns() {
      var elHeaders = $container.find('.slick-header-column');
      var allColumns = grid.getColumns();
      elHeaders.each(function (index, el) {
        var columnDef = $(el).data('column');
        var headerWidth = getElementWidth(el);
        var colIndex = grid.getColumnIndex(columnDef._idProperty_);
        var column = allColumns[colIndex];
        var autoSizeWidth = Math.max(headerWidth, getMaxColumnTextWidth(columnDef, colIndex)) + 1;
        autoSizeWidth = Math.min(maxWidth, autoSizeWidth);
        column.width = autoSizeWidth;
      });
      grid.setColumns(allColumns);
      grid.onColumnsResized.notify();
    }

    function reSizeColumn(e) {
      var headerEl = $(e.currentTarget).closest('.slick-header-column');
      var columnDef = headerEl.data('column');

      if (!columnDef || !columnDef.resizable) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      var headerWidth = getElementWidth(headerEl[0]);
      var colIndex = grid.getColumnIndex(columnDef._idProperty_);
      var allColumns = grid.getColumns();
      var column = allColumns[colIndex];

      var autoSizeWidth = Math.max(headerWidth, getMaxColumnTextWidth(columnDef, colIndex)) + 1;

      if (autoSizeWidth !== column.width) {
        column.width = autoSizeWidth;
        grid.setColumns(allColumns);
        grid.onColumnsResized.notify();
      }
    }

    function getMaxColumnTextWidth(columnDef, colIndex) {
      var texts = [];
      var rowEl = createRow(columnDef);
      var data = grid.getData();
      if (Slick.Data && data instanceof Slick.Data.DataView) {
        data = data.getItems();
      }
      for (var i = 0; i < data.length; i++) {
        texts.push(data[i][columnDef.field]);
      }
      var template = getMaxTextTemplate(texts, columnDef, colIndex, data, rowEl);
      var width = getTemplateWidth(rowEl, template);
      deleteRow(rowEl);
      return width;
    }

    function getTemplateWidth(rowEl, template) {
      var cell = $(rowEl.find('.slick-cell'));
      cell.append(template);
      $(cell).find('*').css('position', 'relative');
      return cell.outerWidth() + 1;
    }

    function getMaxTextTemplate(texts, columnDef, colIndex, data, rowEl) {
      var max = 0,
        maxTemplate = null;
      var formatFun = columnDef.formatter;
      $(texts).each(function (index, text) {
        var template;
        if (formatFun) {
          template = $('<span>' + formatFun(index, colIndex, text, columnDef, data[index]) + '</span>');
          text = template.text() || text;
        }
        var length = text ? getElementWidthUsingCanvas(rowEl, text) : 0;
        if (length > max) {
          max = length;
          maxTemplate = template || text;
        }
      });
      return maxTemplate;
    }

    function createRow(columnDef) {
      var rowEl = $('<div class="slick-row"><div class="slick-cell"></div></div>');
      rowEl.find('.slick-cell').css({
        visibility: 'hidden',
        'text-overflow': 'initial',
        'white-space': 'nowrap',
      });
      var gridCanvas = $container.find('.grid-canvas');
      $(gridCanvas).append(rowEl);
      return rowEl;
    }

    function deleteRow(rowEl) {
      $(rowEl).remove();
    }

    function getElementWidth(element) {
      var width,
        clone = element.cloneNode(true);
      clone.style.cssText =
        'position: absolute; visibility: hidden;right: auto;text-overflow: initial;white-space: nowrap;';
      element.parentNode.insertBefore(clone, element);
      width = clone.offsetWidth;
      clone.parentNode.removeChild(clone);
      return width;
    }

    function getElementWidthUsingCanvas(element, text) {
      context.font = element.css('font-size') + ' ' + element.css('font-family');
      var metrics = context.measureText(text);
      return metrics.width;
    }

    return {
      init: init,
      destroy: destroy,
    };
  }
})(jQuery);
